'use strict';

(function () {
    'use strict';

    /**
     * Main module of the clinivid
     */

    angular.module('clinivid', ['uiGmapgoogle-maps',

    // Core
    'app.core',

    // Navigation
    'app.navigation',

    // Toolbar
    'app.toolbar',

    // User Module
    'app.user',

    // Viewer
    'app.viewer',

    // Clinician
    'app.clinician',

    // Enterprise
    'app.enterprise',

    // HCI Admin
    'app.admin']);
})();


'use strict';

(function () {
    'use strict';

    angular.module('clinivid').controller('SimpleDialogController', SimpleDialogController);

    /** @ngInject */
    function SimpleDialogController($mdDialog) {
        var vm = this;

        // Data
        vm.title = 'Message';
        vm.message = "This is a message!";

        // Methods
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.pages.auth.lock', []).config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.pages_auth_lock', {
            url: '/pages/auth/lock',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.pages_auth_lock': {
                    templateUrl: 'app/main/pages/auth/lock/lock.html',
                    controller: 'LockController as $ctrl'
                }
            },
            bodyClass: 'lock'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/lock');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.lock', {
            title: 'Lock Screen',
            state: 'app.pages_auth_lock',
            weight: 7
        });
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.pages.auth.lock').controller('LockController', LockController);

    /** @ngInject */
    function LockController() {
        var vm = this;

        // Data
        vm.form = {
            username: 'Jane Doe'
        };

        // Methods

        //////////
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.viewer', ['ngMaterial']).config(config).run(run);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.viewer', {
            url: '/viewer',
            views: {
                'content@app': {
                    templateUrl: 'app/main/viewer/viewer.html',
                    controller: 'ViewerController as $ctrl'
                }
                /*,
                resolve: {
                    SampleData: function (msApi)
                    {
                        return msApi.resolve('sample@get');
                    }
                }*/
            } }).state('app.viewer.home', {
            url: '/viewer',
            views: {
                'content@app': {
                    templateUrl: 'app/main/viewer/viewer.html',
                    controller: 'ViewerController as $ctrl'
                }
                /*,
                resolve: {
                    SampleData: function (msApi)
                    {
                        return msApi.resolve('sample@get');
                    }
                }*/
            } }).state('app.viewer.cases', {
            url: '/viewer/cases',
            views: {
                'content@app': {
                    templateUrl: 'app/main/viewer/cases.html',
                    controller: 'ViewerController as $ctrl'
                }
                /*,
                resolve: {
                    SampleData: function (msApi)
                    {
                        return msApi.resolve('sample@get');
                    }
                }*/
            } })
        //.state('app.viewer.nonuser', {
        //    url: '/cases/single',
        //    views: {
        //        'content@app': {
        //            templateUrl: 'app/main/viewer/singleView.html',
        //            controller: 'ViewerAnonCtlr as $ctrl'
        //        }
        //    }
        //    /*,
        //    resolve: {
        //        SampleData: function (msApi)
        //        {
        //            return msApi.resolve('sample@get');
        //        }
        //    }*/
        //})
        .state('app.viewer.nonuser', {
            url: '/cases/single',
            views: {
                'content@app': {
                    template: '<viewer-non-user></viewer-non-user>'
                }
                /*,
                resolve: {
                    Org: function (apiResolver, $stateParams)
                    {
                        return apiResolver.resolve('organisations.getById@get', { 'id': $stateParams.id });
                    }
                }
                /*,
                resolve: {
                    AdminData: function (msApi) {
                        return msApi.resolve('sample@get');
                    }
                }*/
            } });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/viewer');

        // Api
        //msApiProvider.register('sample', ['app/data/sample/sample.json']);
    }

    function showMenu(msNavigationService) {
        // Navigation
        /*msNavigationService.saveItem('viewer', {
            title: 'VIEWER INTERFACE',
            group: true,
            weight: 3
        });*/

        msNavigationService.saveItem('viewer_home', {
            title: 'Home',
            icon: 'icon-home',
            state: 'app.viewer.home',
            //group: true,
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'VIEWER.VIEWER_NAV_HOME',
            weight: 3
        });

        /*msNavigationService.saveItem('viewer_people', {
            title: 'People',
            icon: 'icon-human-male-female',
            state: 'app.viewer.people',
            //group: true,
            translate: 'VIEWER.VIEWER_NAV_PEOPLE',
            weight: 3
        });*/

        msNavigationService.saveItem('viewer_cases', {
            title: 'Chats',
            icon: 'icon-folder-multiple-outline',
            state: 'app.viewer.cases',
            //group: true,
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'VIEWER.VIEWER_NAV_CASES',
            weight: 3
        });
    }

    function hideMenu(msNavigationService) {

        //msNavigationService.deleteItem('viewer');
        msNavigationService.deleteItem('viewer_home');
        //msNavigationService.deleteItem('viewer_people');
        msNavigationService.deleteItem('viewer_cases');
    }

    function run($rootScope, userService, msNavigationService) {
        $rootScope.$on('activeRoleChanged', function () {
            //colsole.log("Viewer:" + userService.context.currentRole.interface);
            if (userService.context.currentRole.interface == 'viewer') showMenu(msNavigationService);else hideMenu(msNavigationService);
        });
    };
})();


'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ViewerAnonCtlr = function () {
    function ViewerAnonCtlr($sce, $filter, $scope, $location, $resource, $stateParams, $mdDialog, $mdSidenav, $document, $timeout, $mdMedia, msApi, appContext, userService) {
        _classCallCheck(this, ViewerAnonCtlr);

        //this.$document = $document;
        this.$mdDialog = $mdDialog;
        //this.$mdSidenav = $mdSidenav;
        this.$resource = $resource;
        this.$timeout = $timeout;
        //this.msApi = msApi;
        this.$sce = $sce;
        this.$filter = $filter;
        this.userService = userService;
        this.app = appContext;
        if (!this.app.clinician.cases) {
            this.app.clinician.cases = { results: [] };
        }

        //this.auth = userService.authentication;
        this.context = userService.context;

        this.selectedCase = {};
        this.displayChats = [];
        //this.chats = [{
        //    message   : 'Hi!'//,
        //    //created_by: this.context.user.id
        //}, {
        //    message   : 'No way',
        //    created_by: 6
        //}];

        //this.form = {person: {Role: 'Clinician'}};

        //this.responsiveReadPane = undefined;
        //this.dynamicHeight = false;

        this.scrollPos = 0;
        this.scrollEl = angular.element('#content');

        this.valKey = $location.search().valKey;
        this.inviteToken = $location.search().inviteToken;

        this.msecPerMinute = 1000 * 60;
        this.msecPerHour = this.msecPerMinute * 60;
        this.msecPerDay = this.msecPerHour * 24;

        this.loadForm();
    }

    /**
    * Converts a day number to a string. - TBC - move into shared location
    *
    * @method dayOfWeekAsString
    * @param {Number} dayIndex
    * @return {Number} Returns day as number
    */


    _createClass(ViewerAnonCtlr, [{
        key: 'dayOfWeekAsString',
        value: function dayOfWeekAsString(dayIndex) {
            return ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"][dayIndex];
        }

        /**
        * Gets a temporal relative simplified time string - TBC - move into shared location
        *
        * @param time
        */

    }, {
        key: 'getTimeString',
        value: function getTimeString(time) {
            if (!time) {
                console.log("Time is undefined!");
                return;
            }
            var timeObj = new Date(time);
            var elapsed = Date.now() - timeObj;

            if (elapsed < 20 * this.msecPerHour) {
                return this.$filter('date')(timeObj, "h:mm a");
            } else if (elapsed < 6 * this.msecPerDay) {
                return this.dayOfWeekAsString(timeObj.getDay()) + " " + this.$filter('date')(timeObj, "d/M");
            } else {
                return this.$filter('date')(timeObj, "d MMM yy");
            }
        }
    }, {
        key: 'loadForm',
        value: function loadForm() {
            var _this = this;

            //console.log("this.valKey: " + this.valKey);
            //console.log("this.inviteToken: " + this.inviteToken);
            this.$resource(apiBasePath + 'Cases/NonUser').get({ valKey: this.valKey, inviteToken: this.inviteToken }).$promise.then(function (response) {
                console.log(response);
                _this.initCase(response.payload);

                //this.displayChats = _.map(this.selectedCase.items, (c) => _.assign(c, { class: c.created_by === this.context.user.id ? 'align-left' : 'align-right' }));
                //console.log(this.displayChats);
            }).catch(function (response) {
                console.log(response);
                //this.notificationDialog.show("View Message Failed!", "Sorry, we encountered an error in trying to load the message. " + response);
            });
        }
    }, {
        key: 'prepareChats',
        value: function prepareChats(items) {
            var _this2 = this;

            return _(items).filter(function (c) {
                return c.data && c.type !== 10;
            }).map(function (c) {
                return _.assign(c, { class: c.userId === _this2.selectedCase.creator.id ? 'align-left' : 'align-right' });
            }).value();
        }
    }, {
        key: 'initCase',
        value: function initCase(caseData) {
            this.selectedCase = caseData;
            this.displayChats = [];

            if (!this.selectedCase || !this.selectedCase.items || this.selectedCase.items.length <= 0) {
                console.error("Case is empty!");
                return;
            }

            // get latest video
            this.displayChats = this.prepareChats(this.selectedCase.items);

            this.selectedCase.featuredItem = _.find(this.selectedCase.items, function (i) {
                return i.type === 10;
            });

            //this.showVideo(_.get(vidItem, 'data',  "http://dev1.clinivid.com.au/IMG_3439.mp4"));
            if (this.selectedCase.featuredItem) this.showVideo(this.selectedCase.featuredItem.data);
            //else
            //this.showVideo("http://dev1.clinivid.com.au/IMG_4647.mp4");
        }
    }, {
        key: 'showVideo',
        value: function showVideo(vidUrl) {
            //if (!vidUrl)
            //vidUrl = "http://int.clinivid.com.au/IMG_4647.mp4";
            if (vidUrl) {
                this.vidConfig = {
                    preload: "none",
                    autohide: true,
                    autohideTime: 2000,
                    sources: [{ src: this.$sce.trustAsResourceUrl(vidUrl), type: "video/mp4" }],
                    theme: "/styles/videogular.css"
                };
            }
        }
    }]);

    return ViewerAnonCtlr;
}();

angular.module('app.viewer').component('viewerNonUser', {
    controller: ViewerAnonCtlr,
    templateUrl: 'app/main/viewer/direct/singleView.html'
});


'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Created by arolave on 12/06/2016.
 */
var Poller = function () {
    function Poller($timeout) {
        _classCallCheck(this, Poller);

        this.$timeout = $timeout;
        this.pollCount = 0;
    }

    _createClass(Poller, [{
        key: 'run',
        value: function run(requestFn, pollingTime) {
            var _this = this;

            var delayFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            this.destroyed = false;
            this.pollCount += 1;
            if (!delayFirst) requestFn(this.pollCount);

            this.requestPromise = this.$timeout(function () {
                if (!_this.destroyed) _this.run(requestFn, pollingTime);
            }, pollingTime);
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            this.destroyed = true;
            this.pollCount = 0;
            this.$timeout.cancel(this.requestPromise);
        }
    }]);

    return Poller;
}();

angular.module('clinivid').factory('pollingFactory', function ($timeout) {
    'ngInject';

    return {
        build: function build() {
            return new Poller($timeout);
        }
    };
});


'use strict';

/**
 * Created by arolave on 12/06/2016.
 */
angular.module('clinivid').directive('autoScrollBottom', function ($timeout) {
    'ngInject';

    return {
        restrict: 'A',
        scope: {
            autoScrollBottom: '='
        },
        controller: function controller($scope, $element) {
            $scope.$watchCollection('autoScrollBottom', function (newVal) {
                //console.log(_.size(newVal));
                if ($scope.lastItem !== _.last(newVal)) {
                    $timeout(function () {
                        $element[0].scrollTop = $element[0].scrollHeight;
                    });
                    $scope.lastItem = _.last(newVal);
                }
            });
        }
    };
});


'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Created by arolave on 20/05/2016.
 */
angular.module('clinivid').service('notificationDialog', function ($mdDialog) {
  var NotificationDialog = function () {
    function NotificationDialog() {
      _classCallCheck(this, NotificationDialog);
    }

    _createClass(NotificationDialog, [{
      key: 'show',
      value: function show() {
        var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "title";
        var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'message';

        $mdDialog.show({
          controller: function controller($scope, $mdDialog) {
            $scope.closeDialog = function () {
              $mdDialog.hide();
            };
            $scope.title = title;
            $scope.message = message;
          },
          template: '<md-dialog aria-label="Notification">' + '  <md-dialog-content><h1>{{::title}}</h1><div><h5>{{::message}}</h5></div></md-dialog-content>' + '  <md-dialog-actions>' + '    <md-button ng-click="closeDialog()" class="md-primary">' + '      Ok' + '    </md-button>' + '  </md-dialog-actions>' + '</md-dialog>',
          parent: angular.element('body'),
          clickOutsideToClose: true
        });
      }
    }]);

    return NotificationDialog;
  }();

  return new NotificationDialog();
});


'use strict';

(function () {
    'use strict';

    angular.module('app.clinician', ['ngMaterial', 'ngMessages']).config(config).run(run);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $resourceProvider) {
        // State
        $stateProvider.state('app.clinician', {
            url: '/clinician',
            views: {
                'content@app': {
                    template: '<clinician></clinician>'
                }
                /*,
                resolve: {
                    SampleData: function (msApi)
                    {
                        return msApi.resolve('sample@get');
                    }
                }*/
            } }).state('app.clinician.home', {
            url: '/nomoreneeded',
            views: {
                'content@app': {
                    template: '<clinician-cases></clinician-cases>'
                }
                /*,
                resolve: {
                    SampleData: function (msApi)
                    {
                        return msApi.resolve('sample@get');
                    }
                }*/
            } }).state('app.clinician.welcome', {
            url: '/welcome',
            views: {
                'content@app': {
                    template: '<welcome></welcome>'
                }
                /*,
                resolve: {
                    SampleData: function (msApi)
                    {
                        return msApi.resolve('sample@get');
                    }
                }*/
            } }).state('app.clinician.people', {
            url: '/people',
            views: {
                'content@app': {
                    template: '<clinician-people></clinician-people>'
                }
            }
        }).state('app.clinician.manageOrganisation', {
            url: '/manage-organisation',
            views: {
                'content@app': {
                    template: '<manage-organisation></manage-organisation>'
                }
            }
        }).state('app.clinician.manageUsers', {
            url: '/manage-users',
            views: {
                'content@app': {
                    template: '<manage-users></manage-users>'
                }
            }
        }).state('app.clinician.resendCase', {
            url: '/resend-case',
            views: {
                'content@app': {
                    template: '<resend-case></resend-case>'
                }
            }
        }).state('app.clinician.people.add', {
            url: '/people/add',
            views: {
                'content@app': {
                    template: '<clinician-add-person></clinician-add-person>'
                }
                /*,
                resolve: {
                    SampleData: function (msApi)
                    {
                        return msApi.resolve('sample@get');
                    }
                }*/
            } }).state('app.clinician.people.edit', {
            url: '/people/:contactId/edit',
            views: {
                'content@app': {
                    template: '<clinician-edit-person contact="contact"></clinician-edit-person>'
                }
            }
        }).state('app.clinician.cases', {
            url: '/cases',
            views: {
                'content@app': {
                    template: '<clinician-cases></clinician-cases>'
                }
            },
            params: {
                draftCasePage: null
            }
        }).state('app.clinician.settings', {
            url: '/settings',
            views: {
                'content@app': {
                    template: '<clinician-settings></clinician-settings>'
                }
                /*,
                resolve: {
                    SampleData: function (msApi)
                    {
                        return msApi.resolve('sample@get');
                    }
                }*/
            } })
        // need a url that is module independent
        .state('app.clinician.accept', {
            url: '/accept',
            views: {
                'content@app': {
                    template: '<clinician-accept></clinician-accept>'
                }
                /*,
                resolve: {
                    Org: function (apiResolver, $stateParams)
                    {
                        return apiResolver.resolve('organisations.getById@get', { 'id': $stateParams.id });
                    }
                }
                /*,
                resolve: {
                    AdminData: function (msApi) {
                        return msApi.resolve('sample@get');
                    }
                }*/
            } }).state('app.clinician.mdt', {
            url: '/mdt',
            views: {
                'content@app': {
                    template: '<clinician-mdt></clinician-mdt>'
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/clinician');
        $translatePartialLoaderProvider.addPart('app/main/clinician/cases');
        $translatePartialLoaderProvider.addPart('app/main/clinician/people');

        // Api
        //msApiProvider.register('sample', ['app/data/sample/sample.json']);
        msApiProvider.register('clinicians', [apiBasePath + 'Clinicians']);
        msApiProvider.register('clinician.invite', [apiBasePath + 'Clinicians/Invite']);

        $resourceProvider.defaults.cancellable = true;
    }

    function showMenu(msNavigationService) {
        // Navigation

        //msNavigationService.saveItem('clinician_home', {
        //    title: 'Home',
        //    icon: 'icon-home',
        //    state: 'app.clinician.home',
        //    //group: true,
        //    /*stateParams: {
        //        'param1': 'page'
        //     },*/
        //    translate: 'CLINICIAN.CLINICIAN_NAV_HOME',
        //    weight: 3
        //});

        msNavigationService.saveItem('clinician_cases', {
            title: 'Chats',
            icon: 'icon-folder-multiple-outline',
            state: 'app.clinician.cases',
            //group: true,
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'CLINICIAN.CLINICIAN_NAV_CASES',
            weight: 3
        });

        msNavigationService.saveItem('clinician_people', {
            title: 'Contacts',
            icon: 'icon-account-multiple',
            state: 'app.clinician.people',
            //group: true,
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'CLINICIAN.CLINICIAN_NAV_PEOPLE',
            weight: 3
        });

        //msNavigationService.saveItem('clinician_settings', {
        //    title: 'Cases',
        //    icon: 'icon-folder-multiple-outline',
        //    state: 'app.clinician.settings',
        //    //group: true,
        //    /*stateParams: {
        //        'param1': 'page'
        //     },*/
        //    translate: 'CLINICIAN.CLINICIAN_NAV_SETTINGS',
        //    weight: 3
        //});
    }

    function hideMenu(msNavigationService) {

        //msNavigationService.deleteItem('clinician');
        //msNavigationService.deleteItem('clinician_home');
        msNavigationService.deleteItem('clinician_people');
        msNavigationService.deleteItem('clinician_cases');
        //msNavigationService.deleteItem('clinician_settings');
    }

    function run($rootScope, $state, userService, msNavigationService) {
        $rootScope.$on('activeRoleChanged', function () {
            if (userService.context.currentRole.interface == 'clinician') {
                showMenu(msNavigationService);

                if (window.location.href.split('/').pop().toUpperCase() == 'PEOPLE') {

                    $state.go('app.clinician.people');
                    return;
                }
                if (window.location.href.split('/').pop().toUpperCase() == 'CASES') {

                    $state.go('app.clinician.cases');
                    return;
                }
            } else {
                hideMenu(msNavigationService);
            }
        });
    };
})();


/**
 * Created by Apurba-D
 */
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResendCaseCtrl = function () {
  function ResendCaseCtrl($resource, $http, appContext, userService, api, $analytics, $state, $mdDialog, $scope, $stateParams, $q, $document, $mdSidenav, swangular) {
    'inject';

    _classCallCheck(this, ResendCaseCtrl);

    this.swangular = swangular;
    this.$mdSidenav = $mdSidenav;
    this.$document = $document;
    this.api = api;
    this.$http = $http;
    this.$scope = $scope;
    this.$mdDialog = $mdDialog;
    this.app = appContext;
    this.userService = userService;
    this.context = userService.getContext();
    this.$analytics = $analytics;
    this.$resource = $resource;
    this.$state = $state;
    this.currentRole = this.context.currentRole;
    this.stateParams = $stateParams;

    this.caseId = '';
    this.recipientId = '';

    this.caseIdRequired = 'Case Id is required';
    this.recipientIdRequired = 'Recipient Id is required';
  }

  _createClass(ResendCaseCtrl, [{
    key: 'submit',
    value: function submit() {
      if (!this.caseId) {
        this.showError(this.caseIdRequired);
        return;
      } else if (!this.recipientId) {
        this.showError(this.recipientIdRequired);
        return;
      }

      var _self = this;

      this.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(this.$document.body)
      });

      this.$http({
        url: apiBasePath + '/Cases/ResendCaseNotificationToContact?mid=' + this.context.currentRole.membershipId + '&recipientId=' + this.recipientId + '&caseId=' + this.caseId,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      }).then(function (response) {

        _self.$mdDialog.hide();

        if (response.data.type > 0) {
          _self.resetForm();
          _self.swangular.swal('', 'Case resend', 'success');
        } else {
          _self.swangular.swal({
            type: 'error',
            title: '',
            html: response.data.message
          });
        }
      }).error(function () {
        _self.$mdDialog.hide();
        _self.swangular.swal({
          type: 'error',
          title: '',
          html: 'Failed to resend case.Please contact support.'
        });
      });
    }
  }, {
    key: 'resetForm',
    value: function resetForm() {
      this.caseId = '';
      this.recipientId = '';
    }
  }, {
    key: 'showError',
    value: function showError(errorText) {
      this.swangular.swal({
        type: 'error',
        title: '',
        html: errorText
      });
    }
  }]);

  return ResendCaseCtrl;
}();

angular.module('app.clinician').component('resendCase', {
  controller: ResendCaseCtrl,
  templateUrl: 'app/main/clinician/people/resendCase.html'
});


/**
 * Created by Apurba-D
 */
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ManageUsersCtrl = function () {
  function ManageUsersCtrl($resource, $http, appContext, userService, api, $analytics, $state, $mdDialog, $scope, $stateParams, $q, $document, $mdSidenav, swangular) {
    'inject';

    _classCallCheck(this, ManageUsersCtrl);

    this.swangular = swangular;
    this.$mdSidenav = $mdSidenav;
    this.$document = $document;
    this.api = api;
    this.$http = $http;
    this.$scope = $scope;
    this.$mdDialog = $mdDialog;
    this.app = appContext;
    this.userService = userService;
    this.context = userService.getContext();
    this.$analytics = $analytics;
    this.$resource = $resource;
    this.$state = $state;
    this.currentRole = this.context.currentRole;
    this.stateParams = $stateParams;

    this.firstName = '';
    this.lastName = '';

    this.searchResults = [];
    this.orgContactSearchTerm = '';

    this.searchTerm = '';

    this.selectedUser = {};
    this.selectedUserOrgMap = {};
    this.selectedOrgIdForEdit = '';
    this.allRoles4Edit = [];
    this.selectedOrgName = '';

    this.isOrgOwner = false;
    this.isOfficeAdmin = false;
    this.isCreator = false;
    this.isMDTCoOrdinator = false;
    this.isMDTConference = false;

    this.isOrgOwnerPrevious = false;
    this.isOfficeAdminPrevious = false;
    this.isCreatorPrevious = false;
    this.isMDTCoOrdinatorPrevious = false;
    this.isMDTConferencePrevious = false;

    this.editTitle = '';
    this.editFirstName = '';
    this.editLastName = '';
    this.editMiddleNames = '';
    this.editProfession = '';
    this.editCountryCode = '';
    this.editPhone = '';
    this.editAHPRA = '';
    this.editIsValidAHPRA = '';
    this.editEmail = '';

    this.whichPage = 0; // 0 - deafult page 1- edit page

    this.showOrganisation = false;

    this.firstNameRequired = 'Please enter first name.';
    this.lastNameRequired = 'Please enter last name.';

    this.firstNameRequired = 'First name is required';
    this.lastNameRequired = 'Last name is required';
    this.emailRequired = 'Email is required';
    this.countryCodeRequired = 'Country code required';
    this.phoneRequired = 'Mobile number required';

    this.regexPhoneAU = /^(04|#04|#4)[0-9]{8}$/;
    this.regexPhoneIN = /^(#?)[7-9][0-9]{9}$/;
    this.regexPhonePH = /^(\+?\d{2}?\s?\d{3}\s?\d{3}\s?\d{4})|([0]\d{3}\s?\d{3}\s?\d{4})/;
    this.regexPhoneNZ = /^(((\+?64\s*[-\.]?[3-9]|\(?0[3-9]\)?)\s*[-\.]?\d{3}\s*[-\.]?\d{4})|((\+?64\s*[-\.\(]?2\d{1}[-\.\)]?|\(?02\d{1}\)?)\s*[-\.]?\d{3}\s*[-\.]?\d{3,5})|((\+?64\s*[-\.]?[-\.\(]?800[-\.\)]?|[-\.\(]?0800[-\.\)]?)\s*[-\.]?\d{3}\s*[-\.]?(\d{2}|\d{5})))$/;

    this.regexPhone = '';
    this.regexEmail = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

    this.successMessagePostUserDetailsUpdate = 'User details updated successfully';
    this.successMessagePostRoleUpdate = 'Roles updated successfully.';
  }

  _createClass(ManageUsersCtrl, [{
    key: 'searchByFirstName',
    value: function searchByFirstName() {
      if (!this.firstName) {
        this.showError(this.firstNameRequired);
        return;
      }
      this.search();
    }
  }, {
    key: 'searchByLastName',
    value: function searchByLastName() {
      if (!this.lastName) {
        this.showError(this.lastNameRequired);
        return;
      }
      this.search();
    }
  }, {
    key: 'search',
    value: function search() {

      var _self = this;
      this.searchResults = [];

      this.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(this.$document.body)
      });

      this.$http({
        method: 'GET',
        url: apiBasePath + 'Clinicians/SearchByName?mId=' + this.context.currentRole.membershipId + '&firstname=' + this.firstName + '&lastname=' + this.lastName
      }).then(function (response) {
        _self.$mdDialog.hide();
        if (response.data.type === 0) {
          _self.searchResults = response.data.payload;
        } else {
          _self.swangular.swal({
            type: 'error',
            title: '',
            html: 'Failed to search. Please contact support.'
          });
        }
      });
    }
  }, {
    key: 'viewUser',
    value: function viewUser(orgUser) {
      this.whichPage = 1;
      this.selectedUser = orgUser;

      this.formatData();
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.whichPage = 0;
    }
  }, {
    key: 'editPersonalDetails',
    value: function editPersonalDetails() {

      this.whichPage = 2;

      this.editTitle = this.selectedUser.title;
      this.editFirstName = this.selectedUser.firstname;
      this.editLastName = this.selectedUser.lastname;
      this.editMiddleNames = this.selectedUser.middleNames;
      this.editEmail = this.selectedUser.email;
      this.editProfession = this.selectedUser.profession;
      this.editCountryCode = this.selectedUser.region;
      this.editPhone = this.selectedUser.mobile;
      this.editAHPRA = this.selectedUser.registrationId;
      this.editIsValidAHPRA = true;
    }
  }, {
    key: 'cancelPersonalDetails',
    value: function cancelPersonalDetails() {
      this.whichPage = 1;
    }
  }, {
    key: 'editRoles',
    value: function editRoles(key) {
      this.whichPage = 3;
      this.selectedOrgIdForEdit = key;
      this.selectedOrgName = this.selectedUserOrgMap[this.selectedOrgIdForEdit].orgName;

      this.prePopulateValues();
    }
  }, {
    key: 'cancelEditRole',
    value: function cancelEditRole() {
      this.whichPage = 1;
    }
  }, {
    key: 'showError',
    value: function showError(errorText) {
      this.swangular.swal({
        type: 'error',
        title: '',
        html: errorText
      });
    }
  }, {
    key: 'phoneNumberRegex',
    value: function phoneNumberRegex() {

      var regex;

      if (this.countryCode === 'AU') {
        regex = this.regexPhoneAU;
      }
      // else if (this.countryCode === 'PH'){
      //   regex = this.regexPhonePH;
      // }
      else if (this.countryCode === 'NZ') {
          regex = this.regexPhoneNZ;
        } else if (this.countryCode === 'IN') {
          regex = this.regexPhoneIN;
        }

      return regex;
    }
  }, {
    key: 'savePersonalDetails',
    value: function savePersonalDetails() {

      if (!this.editFirstName) {
        this.showError(this.firstNameRequired);
        return;
      } else if (!this.editLastName) {
        this.showError(this.lastNameRequired);
        return;
      } else if (!this.editEmail) {
        this.showError(this.emailRequired);
        return;
      } else if (!this.editCountryCode) {
        this.showError(this.countryCodeRequired);
        return;
      } else if (!this.editPhone) {
        this.showError(this.phoneRequired);
        return;
      }

      //var regexPhone ;
      if (this.editCountryCode === 'AU') {
        this.regexPhone = this.regexPhoneAU;
      } else if (this.editCountryCode === 'IN') {
        this.regexPhone = this.regexPhoneIN;
      }
      // else if (this.editCountryCode === 'PH') {
      //   this.regexPhone = this.regexPhonePH;
      // }
      else if (this.editCountryCode === 'NZ') {
          this.regexPhone = this.regexPhoneNZ;
        }

      if (this.regexPhone.test(this.editPhone) === false) {
        this.showError('Please enter a valid mobile number.');
        return;
      }

      if (this.regexEmail.test(this.editEmail) === false) {
        this.showError('Please enter a valid e-mail address.');
        return;
      }

      var requestPayload = this.createRequestPayloadProfile();

      var _self = this;

      this.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(this.$document.body)
      });

      var emailExistsInCore = this.$http.get(apiBasePath + 'User/checkEmailOrPhoneExists?email=' + this.editEmail + '&phone=' + encodeURIComponent(this.editPhone));
      var req = {
        method: 'GET',
        url: mdtBaseURL + '/users/checkEmailOrPhoneExists?email=' + this.editEmail + '&phone=' + encodeURIComponent(this.editPhone),
        headers: {
          'Accept': 'application/json',
          'x-clinivid-useremail': this.userService.authentication.userName
        }
      };
      var emailExistsInMdt = this.$http(req);

      // Check if email or mobile has changed
      var hasEmailOrMobileChanged = _self.editEmail !== _self.selectedUser.email || _self.editPhone !== _self.selectedUser.mobile;

      if (hasEmailOrMobileChanged) {
        // Flow with MDT: Duplicate checks → MDT update → Core update
        Promise.all([emailExistsInCore, emailExistsInMdt]).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              coreRes = _ref2[0],
              mdtRes = _ref2[1];

          // Step 1: Check duplicates
          if ((coreRes.data.payload.email || mdtRes.data.payload.email) && _self.editEmail !== _self.selectedUser.email) {
            _self.$mdDialog.hide();
            _self.showError('Failed to update. Email already exists.');
            return Promise.reject({ handled: true });
          }

          if ((coreRes.data.payload.phone || mdtRes.data.payload.phone) && _self.editPhone !== _self.selectedUser.mobile) {
            _self.$mdDialog.hide();
            _self.showError('Failed to update. Mobile Number already exists.');
            return Promise.reject({ handled: true });
          }

          // Step 2: POST/PUT to MDT first
          return _self.updateMdtEmailOrPhone(_self.editEmail, _self.editPhone, _self.selectedUser.email, _self.selectedUser.mobile);
        }).then(function (mdtRes) {
          // Step 3: If MDT fails → show error, abort
          if (mdtRes.data && !mdtRes.data.success) {
            _self.$mdDialog.hide();
            _self.showError(mdtRes.data.message || 'Failed to update MDT.');
            return Promise.reject({ handled: true });
          }

          // Step 4: PUT to Core (only after MDT succeeds)
          return _self.$http({
            url: apiBasePath + 'User/Profile?mId=' + _self.context.currentRole.membershipId,
            method: 'PUT',
            data: requestPayload,
            headers: { 'Content-Type': 'application/json' }
          });
        }).then(function (coreRes) {
          // Step 5 & 6: Handle Core response
          if (coreRes.data.type > 0) {
            // Core succeeded → done
            _self.$mdDialog.hide().then(function () {
              _self.confirmAHPRA();
            });
          } else {
            // Core failed → rollback MDT to old values, then surface Core error
            _self.updateMdtEmailOrPhone(_self.selectedUser.email, _self.selectedUser.mobile, _self.editEmail, _self.editPhone).finally(function () {
              _self.$mdDialog.hide().then(function () {
                _self.showError(coreRes.data.message || 'Failed to update. Changes have been rolled back.');
              });
            });
          }
        }).catch(function (error) {
          if (error && error.handled) {
            return;
          }

          _self.$mdDialog.hide().then(function () {
            var errorMessage = 'An error occurred while updating user details.';
            if (error && error.data && error.data.message) {
              errorMessage = error.data.message;
            }
            _self.showError(errorMessage);
          });
        });
      } else {
        // No email/mobile change: Skip MDT, just update Core directly
        _self.$http({
          url: apiBasePath + 'User/Profile?mId=' + _self.context.currentRole.membershipId,
          method: 'PUT',
          data: requestPayload,
          headers: { 'Content-Type': 'application/json' }
        }).then(function (coreRes) {
          _self.$mdDialog.hide().then(function () {
            if (coreRes.data.type > 0) {
              _self.confirmAHPRA();
            } else {
              _self.showError(coreRes.data.message || 'Failed to update.');
            }
          });
        }).catch(function (error) {
          _self.$mdDialog.hide().then(function () {
            var errorMessage = 'An error occurred while updating user details.';
            if (error && error.data && error.data.message) {
              errorMessage = error.data.message;
            }
            _self.showError(errorMessage);
          });
        });
      }
    }
  }, {
    key: 'updateMdtEmailOrPhone',
    value: function updateMdtEmailOrPhone(newEmail, newPhone, originalEmail, originalMobile) {
      return this.$http({
        url: mdtBaseURL + '/users/updateEmailOrPhone?mId=' + this.context.currentRole.membershipId,
        method: 'PUT',
        data: { email: newEmail, phone: newPhone, originalEmail: originalEmail, originalMobile: originalMobile },
        headers: { 'Content-Type': 'application/json', 'x-clinivid-useremail': this.userService.authentication.userName }
      });
    }
  }, {
    key: 'createRequestPayloadProfile',
    value: function createRequestPayloadProfile() {
      return {
        'userId': this.selectedUser.userId,
        'personId': this.selectedUser.personId,
        'profession': this.editProfession,
        'registrationId': this.editAHPRA,
        'email': this.editEmail,
        'isPractitioner': true,
        'isActive': true,
        'title': this.editTitle,
        'firstname': this.editFirstName,
        'middleNames': this.editMiddleNames,
        'lastname': this.editLastName,
        'mobile': this.editPhone,
        'region': this.editCountryCode,
        'orgAndRoles': this.selectedUser.orgAndRoles,
        'roles': [],
        'isValidAHPRA': true,
        'id': this.selectedUser.userId
      };
    }
  }, {
    key: 'confirmAHPRA',
    value: function confirmAHPRA() {

      var requestPayload = this.createRequestConfirmAHPRA();

      var _self = this;

      this.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(this.$document.body)
      });

      this.$http({
        url: apiBasePath + 'Clinicians/ConfirmAHPRA?mId=' + this.context.currentRole.membershipId,
        method: 'POST',
        data: requestPayload,
        headers: { 'Content-Type': 'application/json' }
      }).then(function (response) {
        _self.$mdDialog.hide().then(function () {
          if (response.data.type > 0) {
            _self.refreshPage(true, _self.successMessagePostUserDetailsUpdate);
          } else {
            _self.showError(response.data.message);
          }
        });
      });
    }
  }, {
    key: 'createRequestConfirmAHPRA',
    value: function createRequestConfirmAHPRA() {
      return {
        'ahpraNumber': this.editAHPRA,
        'isValid': this.editIsValidAHPRA
      };
    }
  }, {
    key: 'saveRoleChanges',
    value: function saveRoleChanges() {
      if (!this.isOrgOwner && !this.isOfficeAdmin && !this.isCreator && !this.isMDTCoOrdinator && !this.isMDTConference) {
        this.showError('Standard Roles Required');
        return;
      }

      if (this.isCreator !== this.isCreatorPrevious || this.isOrgOwner !== this.isOrgOwnerPrevious || this.isOfficeAdmin !== this.isOfficeAdminPrevious) {
        var allRoles = [];

        if (this.isOrgOwner) {
          allRoles.push('OrgOwner');
        }
        if (this.isOfficeAdmin) {
          allRoles.push('OfficeAdmin');
        }
        if (this.isCreator) {
          allRoles.push('Creator');
        }

        if (allRoles.length === 0) {
          if (this.checkIfMDTRolesChanged()) {
            this.restCall2UpdateMDTRoles();
          }
        } else {
          this.restCall2UpdateUserRoles(allRoles);
        }
      } else {
        if (this.checkIfMDTRolesChanged()) {
          this.restCall2UpdateMDTRoles();
        }
      }
    }
  }, {
    key: 'checkIfMDTRolesChanged',
    value: function checkIfMDTRolesChanged() {
      return this.isMDTConference !== this.isMDTConferencePrevious || this.isMDTCoOrdinator !== this.isMDTCoOrdinatorPrevious;
    }
  }, {
    key: 'restCall2UpdateUserRoles',
    value: function restCall2UpdateUserRoles(allRoles) {

      var requestPayload = {
        member: {
          userId: this.selectedUser.userId,
          orgId: this.selectedOrgIdForEdit
        },
        roles: allRoles
      };

      var _self = this;

      this.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(this.$document.body)
      });

      this.$http({
        url: apiBasePath + 'Organisations/UpdateUserRoles?mId=' + this.context.currentRole.membershipId,
        method: 'PUT',
        data: requestPayload,
        headers: { 'Content-Type': 'application/json' }
      }).then(function (response) {
        _self.$mdDialog.hide().then(function () {
          if (response.data.type > 0) {
            if (_self.checkIfMDTRolesChanged()) {
              _self.restCall2UpdateMDTRoles();
            } else {
              _self.refreshPage(true, _self.successMessagePostRoleUpdate);
            }
          } else {
            _self.showError(response.data.message);
          }
        });
      });
    }
  }, {
    key: 'restCall2UpdateMDTRoles',
    value: function restCall2UpdateMDTRoles() {

      var allRoles = [];

      if (this.isMDTCoOrdinator) {
        allRoles.push('MDT-CoOrdinator');
      }
      if (this.isMDTConference) {
        allRoles.push('MDT-Conference');
      }

      if (allRoles.length === 0) {
        this.showError('Must have at-least one MDT roles'); // because backend wont let you remove all MDT roles. So why make a rest call
        return;
      }

      var requestPayload = {
        member: {
          userId: this.selectedUser.userId,
          orgId: this.selectedOrgIdForEdit
        },
        roles: allRoles
      };

      this.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(this.$document.body)
      });

      var _self = this;

      this.$http({
        url: apiBasePath + 'Organisations/UpdateUserMDTRoles?mId=' + this.context.currentRole.membershipId,
        method: 'PUT',
        data: requestPayload,
        headers: { 'Content-Type': 'application/json' }
      }).then(function (response) {
        _self.$mdDialog.hide().then(function () {
          if (response.data.type > 0) {
            _self.refreshPage(true, _self.successMessagePostRoleUpdate);
          } else {
            _self.showError(response.data.message);
          }
        });
      });
    }
  }, {
    key: 'refreshPage',
    value: function refreshPage(showSuccessDialog, successMessage) {

      var _self = this;

      this.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(this.$document.body)
      });

      this.$http({
        method: 'GET',
        url: apiBasePath + 'Clinicians/SearchByName?mId=' + this.context.currentRole.membershipId + '&firstname=' + this.firstName + '&lastname=' + this.lastName
      }).then(function (response) {

        if (response.data.type === 0) {
          _self.$mdDialog.hide().then(function () {
            _self.searchResults = response.data.payload;
            for (var i = 0; i < _self.searchResults.length; i++) {
              if (_self.searchResults[i].userId === _self.selectedUser.userId) {
                _self.selectedUser = _self.searchResults[i];
                break;
              }
            }

            _self.formatData();
            _self.prePopulateValues();

            if (showSuccessDialog) {
              _self.swangular.swal('', successMessage, 'success').then(function () {
                _self.whichPage = 1;
              });
            }
          });
        }
      });
    }
  }, {
    key: 'formatData',
    value: function formatData() {

      this.selectedUserOrgMap = {};

      if (!this.selectedUser || !this.selectedUser.orgAndRoles) {
        return;
      }

      for (var i = 0; i < this.selectedUser.orgAndRoles.length; i++) {
        if (this.selectedUserOrgMap.hasOwnProperty(this.selectedUser.orgAndRoles[i].orgId)) {
          var hasDuplicate = false;
          for (var j = 0; j < this.selectedUserOrgMap[this.selectedUser.orgAndRoles[i].orgId].allRoles.length; j++) {
            if (this.selectedUserOrgMap[this.selectedUser.orgAndRoles[i].orgId].allRoles[j] === this.selectedUser.orgAndRoles[i].role) {
              hasDuplicate = true;
              break;
            }
          }
          if (!hasDuplicate) {
            this.selectedUserOrgMap[this.selectedUser.orgAndRoles[i].orgId].allRoles.push(this.selectedUser.orgAndRoles[i].role);
          }
        } else {
          var rolesArray = [];
          rolesArray.push(this.selectedUser.orgAndRoles[i].role);
          this.selectedUserOrgMap[this.selectedUser.orgAndRoles[i].orgId] = {
            allRoles: rolesArray,
            orgName: this.selectedUser.orgAndRoles[i].orgName
          };
        }
      }

      this.showOrganisation = Object.keys(this.selectedUserOrgMap).length > 0;
    }
  }, {
    key: 'prePopulateValues',
    value: function prePopulateValues() {

      if (!this.selectedUserOrgMap || !this.selectedUserOrgMap[this.selectedOrgIdForEdit] || !this.selectedUserOrgMap[this.selectedOrgIdForEdit].allRoles) {
        return;
      }

      this.allRoles4Edit = this.selectedUserOrgMap[this.selectedOrgIdForEdit].allRoles;

      this.isOrgOwner = this.allRoles4Edit.indexOf('OrgOwner') !== -1;
      this.isOfficeAdmin = this.allRoles4Edit.indexOf('OfficeAdmin') !== -1;
      this.isCreator = this.allRoles4Edit.indexOf('Creator') !== -1;
      this.isMDTCoOrdinator = this.allRoles4Edit.indexOf('MDT-CoOrdinator') !== -1;
      this.isMDTConference = this.allRoles4Edit.indexOf('MDT-Conference') !== -1;

      this.isOrgOwnerPrevious = this.allRoles4Edit.indexOf('OrgOwner') !== -1;
      this.isOfficeAdminPrevious = this.allRoles4Edit.indexOf('OfficeAdmin') !== -1;
      this.isCreatorPrevious = this.allRoles4Edit.indexOf('Creator') !== -1;
      this.isMDTCoOrdinatorPrevious = this.allRoles4Edit.indexOf('MDT-CoOrdinator') !== -1;
      this.isMDTConferencePrevious = this.allRoles4Edit.indexOf('MDT-Conference') !== -1;
    }
  }]);

  return ManageUsersCtrl;
}();

angular.module('app.clinician').component('manageUsers', {
  controller: ManageUsersCtrl,
  templateUrl: 'app/main/clinician/people/manageUsers.html'
});


/**
 * Created by Apurba-D
 */
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ManageOrganisationCtrl = function () {
  function ManageOrganisationCtrl($resource, $http, appContext, userService, api, $analytics, $state, $mdDialog, $scope, $stateParams, $q, $document, $mdSidenav, swangular) {
    'inject';

    _classCallCheck(this, ManageOrganisationCtrl);

    this.swangular = swangular;
    this.$mdSidenav = $mdSidenav;
    this.$document = $document;
    this.api = api;
    this.$http = $http;
    this.$scope = $scope;
    this.$mdDialog = $mdDialog;
    this.app = appContext;
    this.userService = userService;
    this.context = userService.getContext();
    this.$analytics = $analytics;
    this.$resource = $resource;
    this.$state = $state;
    this.currentRole = this.context.currentRole;
    this.stateParams = $stateParams;

    this.name = '';
    this.abn = '';

    this.searchResults = [];
    this.searchTerm = '';
    this.noresults = false;

    this.nameRequired = 'Please enter organisation name.';
    this.abnRequired = 'Please enter ABN.';

    this.whichPage = 0;
    this.selectedOrganisation = {};

    this.editOrgDisplayName = '';
    this.editOrgFormalName = '';
    this.editOrgDescription = '';
    this.editOrgABN = '';
    this.editOrgState = '';
    this.searchMode = '';

    this.editOrganisationSuccess = 'Successfully edited organisation';
    this.orgEditMode = true;

    this.noInvites = false;
    this.allInvites = [];
    this.allContacts = [];
    this.noContacts = false;
    this.selectedContact = {};

    this.inviteNewUser = {
      'defaultRole': null,
      'org': {
        'id': ''
      },
      'person': {
        'middleNames': '',
        "profession": '',
        'email': '',
        'firstName': '',
        'isPractitioner': false,
        'lastName': '',
        'mobile': '',
        'region': 'AU',
        'registrationId': '',
        'staffId': '',
        'title': ''
      },
      'roles': []
    };
    this.firstNameRequired = 'First name is required';
    this.lastNameRequired = 'Last name is required';
    this.emailRequired = 'Email is required';
    this.countryCodeRequired = 'Country code required';
    this.phoneRequired = 'Mobile number required';

    this.regexPhoneAU = /^(04|#04|#4)[0-9]{8}$/;
    this.regexPhoneIN = /^(#?)[7-9][0-9]{9}$/;
    this.regexPhonePH = /^(\+?\d{2}?\s?\d{3}\s?\d{3}\s?\d{4})|([0]\d{3}\s?\d{3}\s?\d{4})/;
    this.regexPhoneNZ = /^(((\+?64\s*[-\.]?[3-9]|\(?0[3-9]\)?)\s*[-\.]?\d{3}\s*[-\.]?\d{4})|((\+?64\s*[-\.\(]?2\d{1}[-\.\)]?|\(?02\d{1}\)?)\s*[-\.]?\d{3}\s*[-\.]?\d{3,5})|((\+?64\s*[-\.]?[-\.\(]?800[-\.\)]?|[-\.\(]?0800[-\.\)]?)\s*[-\.]?\d{3}\s*[-\.]?(\d{2}|\d{5})))$/;
    this.successMessagePostUserDetailsUpdate = 'User details updated successfully';

    this.regexPhone = '';
    this.regexEmail = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

    this.isOrgOwner = false;
    this.isOfficeAdmin = false;
    this.isCreator = false;

    this.addUser = {
      lastName: '',
      firstName: '',
      searchResults: []
    };

    this.isSearchUserOn = false;

    this.selectedAddUser = {};
    this.selectedUserOrgMap = {};

    this.showOrganisation = false;

    this.addUserPayload = {
      'member': {
        'orgId': '',
        'userId': '',
        'staffId': ''
      },

      'roles': []
    };

    this.isOrgOwnerAddUser = false;
    this.isOfficeAdminAddUser = false;
    this.isClinicianAddUser = false;

    this.allMembers = [];
    this.noMembers = false;

    this.allCases = [];
    this.noCases = false;

    this.allAddContacts = [];
    this.noAddContacts = false;

    this.selectedMember = {};
    this.selectedMemberRoles = [];
    this.selectedMemberOrgId = '';

    this.externalContactTitle = '';
    this.externalContactFirstName = '';
    this.externalContactLastName = '';
    this.externalContactMiddleName = '';
    this.externalContactProfession = '';
    this.externalContactIsSpellingCorrect = false;
    this.selectedAddContact = {};

    this.connectUserFirstName = '';
    this.connectUserLastName = '';
    this.connectUserSearchResults = [];
    this.noConnectUserSearchResults = false;

    this.selectedExistingContact = {};
  }

  _createClass(ManageOrganisationCtrl, [{
    key: 'downloadCase',
    value: function downloadCase(userCase) {}
  }, {
    key: 'addUserNext',
    value: function addUserNext() {
      this.whichPage = 11;
    }
  }, {
    key: 'addUserAction',
    value: function addUserAction() {

      if (!this.isClinicianAddUser && !this.isOrgOwnerAddUser && !this.isOfficeAdminAddUser) {
        this.showError('Please select roles');
        return;
      }

      var _self = this;

      var requestPayload = this.createAddUserPayload();

      this.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(this.$document.body)
      });

      this.$http({
        url: apiBasePath + '/Organisations/AddExistingUser?mId=' + this.context.currentRole.membershipId,
        method: 'PUT',
        data: requestPayload,
        headers: { 'Content-Type': 'application/json' }
      }).then(function (response) {
        _self.$mdDialog.hide().then(function () {
          if (response.data.type > 0) {
            _self.whichPage = 2;
            _self.swangular.swal('', 'Successfully Added User', 'success');
          } else {
            _self.showError(response.data.message);
          }
        });
      });
    }
  }, {
    key: 'createAddUserPayload',
    value: function createAddUserPayload() {

      this.addUserPayload.roles = [];
      if (this.isOfficeAdminAddUser) {
        this.addUserPayload.roles.push('OfficeAdmin');
      }
      if (this.isOrgOwnerAddUser) {
        this.addUserPayload.roles.push('OrgOwner');
      }
      if (this.isClinicianAddUser) {
        this.addUserPayload.roles.push('Creator');
      }

      this.addUserPayload.member.orgId = this.selectedOrganisation.id;
      this.addUserPayload.member.userId = this.selectedAddUser.userId;

      return this.addUserPayload;
    }
  }, {
    key: 'searchAddUser',
    value: function searchAddUser() {

      var _self = this;

      this.addUser.searchResults = [];

      this.isSearchUserOn = true;

      this.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(this.$document.body)
      });

      this.$http({
        method: 'GET',
        url: apiBasePath + 'Clinicians/SearchByName?mId=' + this.context.currentRole.membershipId + '&firstname=' + this.addUser.firstName + '&firstname=' + this.addUser.lastName
      }).then(function (response) {
        _self.$mdDialog.hide();
        if (response.data.type === 0) {
          _self.addUser.searchResults = response.data.payload;
        }
      });
    }
  }, {
    key: 'checkPractitioner',
    value: function checkPractitioner() {
      if (this.inviteNewUser.person.isPractitioner) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'showDefaultRoles',
    value: function showDefaultRoles() {
      return this.isOfficeAdmin && this.isOrgOwner || this.isOrgOwner && this.isCreator || this.isCreator && this.isOfficeAdmin;
    }
  }, {
    key: 'searchByName',
    value: function searchByName(showMessage, messageContent) {
      if (!this.name) {
        this.showError(this.nameRequired);
        return;
      }

      this.searchMode = 'NAME';

      var _self = this;
      this.searchResults = [];
      _self.noresults = false;

      this.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(this.$document.body)
      });

      this.$http({
        method: 'GET',
        url: apiBasePath + 'Organisations/SearchByName?mId=' + this.context.currentRole.membershipId + '&nameQuery=' + this.name
      }).then(function (response) {
        _self.$mdDialog.hide();
        if (response.data.type >= 0) {
          _self.searchResults = response.data.payload;
          _self.noresults = false;
          if (showMessage) {
            _self.swangular.swal('', messageContent, 'success');
          }
        } else {
          _self.noresults = true;
        }
      });
    }
  }, {
    key: 'searchByABN',
    value: function searchByABN(showMessage, messageContent) {
      if (!this.abn) {
        this.showError(this.abnRequired);
        return;
      }

      this.searchMode = 'ABN';

      var _self = this;
      this.searchResults = [];
      _self.noresults = true;

      this.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(this.$document.body)
      });

      this.$http({
        method: 'GET',
        url: apiBasePath + 'Organisations/SearchByRegId?mId=' + this.context.currentRole.membershipId + '&registeredId=' + this.abn
      }).then(function (response) {
        _self.$mdDialog.hide();
        if (response.data && response.data.type >= 0 && response.data.payload) {
          _self.searchResults.push(response.data.payload);
          _self.noresults = false;
          if (showMessage) {
            _self.swangular.swal('', messageContent, 'success');
          }
        } else {
          _self.noresults = true;
        }
      });
    }
  }, {
    key: 'showError',
    value: function showError(errorText) {
      this.swangular.swal({
        type: 'error',
        title: '',
        html: errorText
      });
    }
  }, {
    key: 'editOrganisation',
    value: function editOrganisation(orgId) {

      var _self = this;

      this.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(this.$document.body)
      });

      this.$http({
        method: 'GET',
        url: apiBasePath + 'Organisations/GetById?mId=' + this.context.currentRole.membershipId + '&orgId=' + orgId
      }).then(function (response) {
        _self.$mdDialog.hide();
        if (response.data.type >= 0) {
          _self.selectedOrganisation = response.data.payload;
          _self.editOrgDisplayName = _self.selectedOrganisation.displayName;
          _self.editOrgFormalName = _self.selectedOrganisation.formalName;
          _self.editOrgDescription = _self.selectedOrganisation.description;
          _self.editOrgABN = _self.selectedOrganisation.registeredId;
          _self.editOrgState = _self.selectedOrganisation.state;
          _self.whichPage = 1;
          _self.orgEditMode = true;
        } else {
          _self.showError('Failed to fetch organisation details.');
        }
      });
    }
  }, {
    key: 'cancelOrgDisplay',
    value: function cancelOrgDisplay() {
      this.whichPage = 0;
    }
  }, {
    key: 'openOrgMenu',
    value: function openOrgMenu($mdMenu, ev) {
      $mdMenu.open(ev);
    }
  }, {
    key: 'editOrg',
    value: function editOrg() {
      this.orgEditMode = !this.orgEditMode;
      if (!this.orgEditMode) {
        return;
      }

      if (!this.editOrgDisplayName) {
        this.showError('Display Name cannot be empty. Please enter a value.');
        this.editOrgDisplayName = this.selectedOrganisation.displayName;
        return;
      } else if (!this.editOrgFormalName) {
        this.showError('Formal Name cannot be empty. Please enter a value.');
        this.editOrgFormalName = this.selectedOrganisation.formalName;
        return;
      }

      var requestPayload = this.createOrgInfoPayload();

      var _self = this;

      this.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(this.$document.body)
      });

      this.$http({
        url: apiBasePath + 'Organisations?mId=' + this.context.currentRole.membershipId,
        method: 'PUT',
        data: requestPayload,
        headers: { 'Content-Type': 'application/json' }
      }).then(function (response) {
        _self.$mdDialog.hide().then(function () {
          if (response.data.type > 0) {
            _self.refreshPage();
          } else {
            _self.showError(response.data.message);
            _self.editOrgFormalName = _self.selectedOrganisation.formalName;
            _self.editOrgDisplayName = _self.selectedOrganisation.displayName;
          }
        });
      });
    }
  }, {
    key: 'refreshPage',
    value: function refreshPage() {
      if (this.searchMode === 'ABN') {
        this.searchByABN(true, this.editOrganisationSuccess);
      } else if (this.searchMode === 'NAME') {
        this.searchByName(true, this.editOrganisationSuccess);
      }
    }
  }, {
    key: 'createOrgInfoPayload',
    value: function createOrgInfoPayload() {
      return {
        'displayName': this.editOrgDisplayName,
        'formalName': this.editOrgFormalName,
        'description': this.editOrgDescription,
        'registeredId': this.editOrgABN,
        'id': this.selectedOrganisation.id,
        'state': this.editOrgState
      };
    }
  }, {
    key: 'back2OrgInfo',
    value: function back2OrgInfo() {
      this.whichPage = 1;
    }
  }, {
    key: 'openAddUserPage',
    value: function openAddUserPage() {
      this.resetAddUserPage();
      this.whichPage = 2;
    }
  }, {
    key: 'resetAddUserPage',
    value: function resetAddUserPage() {
      this.isSearchUserOn = false;
      this.addUser = {
        lastName: '',
        firstName: '',
        searchResults: []
      };
    }
  }, {
    key: 'openInviteUserPage',
    value: function openInviteUserPage() {
      this.whichPage = 3;
      this.resetNewInvitePage();
    }
  }, {
    key: 'inviteNewUserRequest',
    value: function inviteNewUserRequest() {

      if (!this.inviteNewUser.person.firstName) {
        this.showError(this.firstNameRequired);
        return;
      } else if (!this.inviteNewUser.person.lastName) {
        this.showError(this.lastNameRequired);
        return;
      } else if (!this.inviteNewUser.person.email) {
        this.showError(this.emailRequired);
        return;
      } else if (!this.inviteNewUser.person.region) {
        this.showError(this.countryCodeRequired);
        return;
      } else if (!this.inviteNewUser.person.mobile) {
        this.showError(this.phoneRequired);
        return;
      }

      if (this.inviteNewUser.person.region === 'AU') {
        this.regexPhone = this.regexPhoneAU;
      } else if (this.inviteNewUser.person.region === 'IN') {
        this.regexPhone = this.regexPhoneIN;
      } else if (this.inviteNewUser.person.region === 'NZ') {
        this.regexPhone = this.regexPhoneIN;
      }

      if (this.regexPhone.test(this.inviteNewUser.person.mobile) === false) {
        this.showError('Please enter a valid mobile number.');
        return;
      }

      if (this.regexEmail.test(this.inviteNewUser.person.email) === false) {
        this.showError('Please enter a valid e-mail address.');
        return;
      }

      if (!this.isCreator && !this.isOfficeAdmin && !this.isOrgOwner) {
        this.showError('Roles are required.');
        return;
      }

      if (this.isCreator) {
        this.inviteNewUser.roles.push('Creator');
      }

      if (this.isOfficeAdmin) {
        this.inviteNewUser.roles.push('OfficeAdmin');
      }

      if (this.isOrgOwner) {
        this.inviteNewUser.roles.push('OrgOwner');
      }

      if (this.inviteNewUser.defaultRole) {
        if (!this.inviteNewUser.roles.includes(this.inviteNewUser.defaultRole)) {
          this.inviteNewUser.defaultRole = null;
        }
      }

      this.inviteNewUser.org.id = this.selectedOrganisation.id;

      var _self = this;

      this.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(this.$document.body)
      });

      _self.$http({
        url: apiBasePath + 'Organisations/Users?mId=' + this.context.currentRole.membershipId,
        method: 'POST',
        data: this.inviteNewUser,
        headers: { 'Content-Type': 'application/json' }
      }).then(function (response) {
        _self.$mdDialog.hide();
        if (response.data.type > 0) {
          _self.swalSuccess('', 'Invite has been sent.');
          _self.resetNewInvitePage();
        } else {
          if (response.data.message) {
            _self.swalError('Failed', response.data.message);
          } else {
            _self.swalError('Failed', 'Failed to send invite.Please contact support.');
          }
        }
      }).error(function () {
        _self.$mdDialog.hide();
        _self.swalError('Failed', 'Failed to send invite.Please contact support.');
      });
    }
  }, {
    key: 'resetNewInvitePage',
    value: function resetNewInvitePage() {

      this.inviteNewUser.defaultRole = null;

      this.inviteNewUser.org.id = this.selectedOrganisation.id;

      this.inviteNewUser.person.middleNames = '';
      this.inviteNewUser.person.profession = '';
      this.inviteNewUser.person.email = '';
      this.inviteNewUser.person.firstName = '';
      this.inviteNewUser.person.isPractitioner = false;
      this.inviteNewUser.person.lastName = '';
      this.inviteNewUser.person.mobile = '';
      this.inviteNewUser.person.region = 'AU';
      this.inviteNewUser.person.registrationId = '';
      this.inviteNewUser.person.staffId = '';
      this.inviteNewUser.person.title = '';

      this.inviteNewUser.roles = [];

      this.isOrgOwner = false;
      this.isOfficeAdmin = false;
      this.isCreator = false;

      this.noMembers = false;
    }
  }, {
    key: 'openInviteStatusPage',
    value: function openInviteStatusPage() {
      var _self = this;
      this.allInvites = [];
      this.noInvites = false;

      this.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(this.$document.body)
      });

      this.$http({
        method: 'GET',
        url: apiBasePath + '/Organisations/GetUserInvites?mId=' + this.context.currentRole.membershipId + '&orgId=' + this.selectedOrganisation.id
      }).then(function (response) {
        _self.$mdDialog.hide();
        if (response.data.type === 1) {

          _self.allInvites = response.data.payload;
          _self.whichPage = 4;
          if (_self.allInvites.length === 0) {
            _self.noInvites = true;
          }
        } else {

          _self.swangular.swal({
            type: 'error',
            title: '',
            html: response.data.message
          });
        }
      });
    }
  }, {
    key: 'viewUser',
    value: function viewUser(user) {
      this.selectedAddUser = user;
      this.formatData();
      this.whichPage = 10;
    }
  }, {
    key: 'formatData',
    value: function formatData() {

      this.selectedUserOrgMap = {};

      if (!this.selectedAddUser || !this.selectedAddUser.orgAndRoles) {
        return;
      }

      for (var i = 0; i < this.selectedAddUser.orgAndRoles.length; i++) {
        if (this.selectedUserOrgMap.hasOwnProperty(this.selectedAddUser.orgAndRoles[i].orgId)) {
          var hasDuplicate = false;
          for (var j = 0; j < this.selectedUserOrgMap[this.selectedAddUser.orgAndRoles[i].orgId].allRoles.length; j++) {
            if (this.selectedUserOrgMap[this.selectedAddUser.orgAndRoles[i].orgId].allRoles[j] === this.selectedAddUser.orgAndRoles[i].role) {
              hasDuplicate = true;
              break;
            }
          }
          if (!hasDuplicate) {
            this.selectedUserOrgMap[this.selectedAddUser.orgAndRoles[i].orgId].allRoles.push(this.selectedAddUser.orgAndRoles[i].role);
          }
        } else {
          var rolesArray = [];
          rolesArray.push(this.selectedAddUser.orgAndRoles[i].role);
          this.selectedUserOrgMap[this.selectedAddUser.orgAndRoles[i].orgId] = {
            allRoles: rolesArray,
            orgName: this.selectedAddUser.orgAndRoles[i].orgName
          };
        }
      }

      this.showOrganisation = Object.keys(this.selectedUserOrgMap).length > 0;
    }
  }, {
    key: 'closeAddSelectedUser',
    value: function closeAddSelectedUser() {
      this.whichPage = 2;
    }
  }, {
    key: 'resendInvite',
    value: function resendInvite(inviteID) {
      var _self = this;

      this.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(this.$document.body)
      });

      _self.$http({
        url: apiBasePath + 'Organisations/ResendUserInvite?mId=' + this.context.currentRole.membershipId + '&inviteId=' + inviteID,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      }).then(function () {
        _self.$mdDialog.hide();
        _self.swalSuccess('Invite sent', 'Invite has been resend.');
      }).error(function () {
        _self.$mdDialog.hide();
        _self.swalError('Failed', 'Failed to resend invite.Please contact support.');
      });
    }
  }, {
    key: 'swalError',
    value: function swalError(titleText, textContent) {
      this.swangular.swal({
        type: 'error',
        title: titleText,
        html: textContent
      });
    }
  }, {
    key: 'swalSuccess',
    value: function swalSuccess(title, text) {
      this.swangular.swal(title, text, 'success');
    }
  }, {
    key: 'getCreatedDate',
    value: function getCreatedDate(createDate) {
      var createdTime = createDate + 'Z';
      return moment(createDate).format('MMM D, YYYY, h:mm A');
    }
  }, {
    key: 'openMemberListPage',
    value: function openMemberListPage() {

      var _self = this;
      this.allMembers = [];
      this.noMembers = false;

      this.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(this.$document.body)
      });

      this.$http({
        method: 'GET',
        url: apiBasePath + 'User/GetUsersInOrg?mId=' + this.context.currentRole.membershipId + '&orgId=' + this.selectedOrganisation.id
      }).then(function (response) {
        _self.$mdDialog.hide();
        if (response.data.type > 0) {

          _self.allMembers = response.data.payload;
          _self.whichPage = 5;
          if (!_self.allMembers || _self.allMembers.length === 0) {
            _self.noMembers = true;
          }
        } else {

          _self.swangular.swal({
            type: 'error',
            title: '',
            html: 'Failed to get members. Please contact support.'
          });
        }
      });
    }
  }, {
    key: 'viewMember',
    value: function viewMember(member) {
      this.selectedMember = member;
      this.initializeMember();
      this.whichPage = 12;
    }
  }, {
    key: 'initializeMember',
    value: function initializeMember() {
      this.selectedMemberOrgId = this.selectedOrganisation.id;

      // for(var j =0; j < this.selectedMember.roles.length ; j++){
      //   if(this.selectedMember.roles[j].domain === this.selectedMember.user.email){
      //     this.selectedMemberOrgId = this.selectedMember.roles[j].orgId;
      //   }
      // }

      this.selectedMember.isCreator = false;
      this.selectedMember.isOrgOwner = false;
      this.selectedMember.isOfficeAdmin = false;
      this.selectedMember.isMDTCoOrdinator = false;

      this.selectedMemberRoles = [];

      for (var i = 0; i < this.selectedMember.roles.length; i++) {
        if (this.selectedMember.roles[i].orgId === this.selectedMemberOrgId) {

          if (this.selectedMember.roles[i].name === 'Creator') {
            this.selectedMember.isCreator = true;
            this.selectedMemberRoles.push('Creator');
          } else if (this.selectedMember.roles[i].name === 'OrgOwner') {
            this.selectedMember.isOrgOwner = true;
            this.selectedMemberRoles.push('OrgOwner');
          } else if (this.selectedMember.roles[i].name === 'OfficeAdmin') {
            this.selectedMember.isOfficeAdmin = true;
            this.selectedMemberRoles.push('OfficeAdmin');
          } else if (this.selectedMember.roles[i].name === 'MDT-CoOrdinator') {
            this.selectedMember.isMDTCoOrdinator = true;
            this.selectedMemberRoles.push('MDT-CoOrdinator');
          }
        }
      }
    }
  }, {
    key: 'savePersonalDetails',
    value: function savePersonalDetails() {
      if (!this.selectedMember.editFirstName) {
        this.showError(this.firstNameRequired);
        return;
      } else if (!this.selectedMember.editLastName) {
        this.showError(this.lastNameRequired);
        return;
      } else if (!this.selectedMember.editEmail) {
        this.showError(this.emailRequired);
        return;
      } else if (!this.selectedMember.editCountryCode) {
        this.showError(this.countryCodeRequired);
        return;
      } else if (!this.selectedMember.editPhone) {
        this.showError(this.phoneRequired);
        return;
      }

      //var regexPhone ;
      if (this.selectedMember.editCountryCode === 'AU') {
        this.regexPhone = this.regexPhoneAU;
      } else if (this.selectedMember.editCountryCode === 'IN') {
        this.regexPhone = this.regexPhoneIN;
      }
      // else if (this.selectedMember.editCountryCode === 'PH') {
      //   this.regexPhone = this.regexPhonePH;
      // }
      else if (this.selectedMember.editCountryCode === 'NZ') {
          this.regexPhone = this.regexPhoneNZ;
        }

      if (this.regexPhone.test(this.selectedMember.editPhone) === false) {
        this.showError('Please enter a valid mobile number.');
        return;
      }

      if (this.regexEmail.test(this.selectedMember.editEmail) === false) {
        this.showError('Please enter a valid e-mail address.');
        return;
      }

      var requestPayload = this.createRequestPayloadProfile();

      var _self = this;

      this.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(this.$document.body)
      });

      var emailExistsInCore = this.$http.get(apiBasePath + 'User/checkEmailOrPhoneExists?email=' + this.selectedMember.editEmail + '&phone=' + encodeURIComponent(this.selectedMember.editPhone));
      var req = {
        method: 'GET',
        url: mdtBaseURL + '/users/checkEmailOrPhoneExists?email=' + this.selectedMember.editEmail + '&phone=' + encodeURIComponent(this.selectedMember.editPhone),
        headers: {
          'Accept': 'application/json',
          'x-clinivid-useremail': this.userService.authentication.userName
        }
      };
      var emailExistsInMdt = this.$http(req);

      // Check if email or mobile has changed
      var hasEmailOrMobileChanged = _self.selectedMember.editEmail !== _self.selectedMember.user.email || _self.selectedMember.editPhone !== _self.selectedMember.user.mobile;

      if (hasEmailOrMobileChanged) {
        // Flow with MDT: Duplicate checks → MDT update → Core update
        Promise.all([emailExistsInCore, emailExistsInMdt]).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              coreRes = _ref2[0],
              mdtRes = _ref2[1];

          // Step 1: Check duplicates
          if ((coreRes.data.payload.email || mdtRes.data.payload.email) && _self.selectedMember.editEmail !== _self.selectedMember.user.email) {
            _self.$mdDialog.hide();
            _self.showError('Failed to update. Email already exists.');
            return Promise.reject({ handled: true });
          }

          if ((coreRes.data.payload.phone || mdtRes.data.payload.phone) && _self.selectedMember.editPhone !== _self.selectedMember.user.mobile) {
            _self.$mdDialog.hide();
            _self.showError('Failed to update. Mobile Number already exists.');
            return Promise.reject({ handled: true });
          }

          // Step 2: POST/PUT to MDT first
          return _self.updateMdtEmailOrPhone(_self.selectedMember.editEmail, _self.selectedMember.editPhone, _self.selectedMember.user.email, _self.selectedMember.user.mobile);
        }).then(function (mdtRes) {
          // Step 3: If MDT fails → show error, abort
          if (mdtRes.data && !mdtRes.data.success) {
            _self.$mdDialog.hide();
            _self.showError(mdtRes.data.message || 'Failed to update MDT.');
            return Promise.reject({ handled: true });
          }

          // Step 4: PUT to Core (only after MDT succeeds)
          return _self.$http({
            url: apiBasePath + 'User/Profile?mId=' + _self.context.currentRole.membershipId,
            method: 'PUT',
            data: requestPayload,
            headers: { 'Content-Type': 'application/json' }
          });
        }).then(function (coreRes) {
          // Step 5 & 6: Handle Core response
          if (coreRes.data.type > 0) {
            // Core succeeded → done
            _self.$mdDialog.hide().then(function () {
              _self.whichPage = 1;
              _self.swangular.swal('', _self.successMessagePostUserDetailsUpdate, 'success');
            });
          } else {
            // Core failed → rollback MDT to old values, then surface Core error
            _self.updateMdtEmailOrPhone(_self.selectedMember.user.email, _self.selectedMember.user.mobile, _self.selectedMember.editEmail, _self.selectedMember.editPhone).finally(function () {
              _self.$mdDialog.hide().then(function () {
                _self.showError(coreRes.data.message || 'Failed to update. Changes have been rolled back.');
              });
            });
          }
        }).catch(function (error) {
          if (error && error.handled) {
            return;
          }

          _self.$mdDialog.hide().then(function () {
            var errorMessage = 'An error occurred while updating user details.';
            if (error && error.data && error.data.message) {
              errorMessage = error.data.message;
            }
            _self.showError(errorMessage);
          });
        });
      } else {
        // No email/mobile change: Skip MDT, just update Core directly
        _self.$http({
          url: apiBasePath + 'User/Profile?mId=' + _self.context.currentRole.membershipId,
          method: 'PUT',
          data: requestPayload,
          headers: { 'Content-Type': 'application/json' }
        }).then(function (coreRes) {
          _self.$mdDialog.hide().then(function () {
            if (coreRes.data.type > 0) {
              _self.whichPage = 1;
              _self.swangular.swal('', _self.successMessagePostUserDetailsUpdate, 'success');
            } else {
              _self.showError(coreRes.data.message || 'Failed to update.');
            }
          });
        }).catch(function (error) {
          _self.$mdDialog.hide().then(function () {
            var errorMessage = 'An error occurred while updating user details.';
            if (error && error.data && error.data.message) {
              errorMessage = error.data.message;
            }
            _self.showError(errorMessage);
          });
        });
      }
    }
  }, {
    key: 'updateMdtEmailOrPhone',
    value: function updateMdtEmailOrPhone(newEmail, newPhone, originalEmail, originalMobile) {
      return this.$http({
        url: mdtBaseURL + '/users/updateEmailOrPhone?mId=' + this.context.currentRole.membershipId,
        method: 'PUT',
        data: { email: newEmail, phone: newPhone, originalEmail: originalEmail, originalMobile: originalMobile },
        headers: { 'Content-Type': 'application/json', 'x-clinivid-useremail': this.userService.authentication.userName }
      });
    }
  }, {
    key: 'createRequestPayloadProfile',
    value: function createRequestPayloadProfile() {
      return {
        'personId': this.selectedMember.user.personId,
        'orgId': this.selectedMemberOrgId,
        'email': this.selectedMember.editEmail,
        'isPractitioner': false,
        'isActive': false,
        'title': this.selectedMember.editTitle,
        'firstname': this.selectedMember.editFirstName,
        'middleNames': this.selectedMember.editMiddleNames,
        'lastname': this.selectedMember.editLastName,
        'mobile': this.selectedMember.editPhone,
        'roles': this.selectedMemberRoles,
        'profession': this.selectedMember.editProfession,
        'region': this.selectedMember.editCountryCode,
        'registrationId': '',
        'isValidAHPRA': true
      };
    }
  }, {
    key: 'saveRoleChanges',
    value: function saveRoleChanges() {
      if (!this.selectedMember.isCreatorEdit && !this.selectedMember.isOrgOwnerEdit && !this.selectedMember.isOfficeAdminEdit && !this.selectedMember.isMDTCoOrdinatorEdit) {
        this.showError('Standard Roles Required');
        return;
      }

      if (this.selectedMember.isCreatorEdit !== this.selectedMember.isCreator || this.selectedMember.isOrgOwnerEdit !== this.selectedMember.isOrgOwner || this.selectedMember.isOfficeAdminEdit !== this.selectedMember.isOfficeAdmin) {
        var allRoles = [];

        if (this.selectedMember.isOrgOwnerEdit) {
          allRoles.push('OrgOwner');
        }
        if (this.selectedMember.isOfficeAdminEdit) {
          allRoles.push('OfficeAdmin');
        }
        if (this.selectedMember.isCreatorEdit) {
          allRoles.push('Creator');
        }

        if (allRoles.length === 0) {
          if (this.checkIfMDTRolesChanged()) {
            this.restCall2UpdateMDTRoles();
          }
        } else {
          this.restCall2UpdateUserRoles(allRoles);
        }
      } else {
        if (this.checkIfMDTRolesChanged()) {
          this.restCall2UpdateMDTRoles();
        }
      }
    }
  }, {
    key: 'checkIfMDTRolesChanged',
    value: function checkIfMDTRolesChanged() {
      return this.selectedMember.isMDTCoOrdinatorEdit !== this.selectedMember.isMDTCoOrdinator;
    }
  }, {
    key: 'restCall2UpdateUserRoles',
    value: function restCall2UpdateUserRoles(allRoles) {

      var requestPayload = {
        member: {
          userId: this.selectedMember.user.id,
          orgId: this.selectedMemberOrgId
        },
        roles: allRoles
      };

      var _self = this;

      this.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(this.$document.body)
      });

      this.$http({
        url: apiBasePath + 'Organisations/UpdateUserRoles?mId=' + this.context.currentRole.membershipId,
        method: 'PUT',
        data: requestPayload,
        headers: { 'Content-Type': 'application/json' }
      }).then(function (response) {
        _self.$mdDialog.hide().then(function () {
          if (response.data.type > 0) {
            if (_self.checkIfMDTRolesChanged()) {
              _self.restCall2UpdateMDTRoles();
            } else {
              _self.refreshPageMemberList();
            }
          } else {
            _self.showError(response.data.message);
          }
        });
      });
    }
  }, {
    key: 'restCall2UpdateMDTRoles',
    value: function restCall2UpdateMDTRoles() {

      var allRoles = [];

      if (this.selectedMember.isMDTCoOrdinatorEdit) {
        allRoles.push('MDT-CoOrdinator');
      }
      //if(this.isMDTConference ) {allRoles.push('MDT-Conference');}

      //if(allRoles.length ===0) {
      //this.showError('Must have at-least one MDT roles'); // because backend wont let you remove all MDT roles. So why make a rest call
      //return;
      //}

      var requestPayload = {
        member: {
          userId: this.selectedMember.user.id,
          orgId: this.selectedMemberOrgId
        },
        roles: allRoles
      };

      this.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(this.$document.body)
      });

      var _self = this;

      this.$http({
        url: apiBasePath + 'Organisations/UpdateUserMDTRoles?mId=' + this.context.currentRole.membershipId,
        method: 'PUT',
        data: requestPayload,
        headers: { 'Content-Type': 'application/json' }
      }).then(function (response) {
        _self.$mdDialog.hide().then(function () {
          if (response.data.type > 0) {
            _self.refreshPageMemberList();
          } else {
            _self.showError(response.data.message);
          }
        });
      });
    }
  }, {
    key: 'refreshPageMemberList',
    value: function refreshPageMemberList() {

      this.whichPage = 12;

      var _self = this;
      this.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(this.$document.body)
      });

      this.$http({
        method: 'GET',
        url: apiBasePath + 'User/GetUsersInOrg?mId=' + this.context.currentRole.membershipId + '&orgId=' + this.selectedOrganisation.id
      }).then(function (response) {
        _self.$mdDialog.hide();
        if (response.data.type > 0) {

          _self.allMembers = response.data.payload;

          for (var i = 0; i < _self.allMembers.length; i++) {
            if (_self.selectedMember.user.personId === _self.allMembers[i].user.personId) {
              _self.selectedMember = _self.allMembers[i];
              _self.initializeMember();

              _self.swangular.swal('', 'Roles updated successfully', 'success');
            }
          }
          // _self.whichPage = 5;
          //  if(!_self.allMembers || _self.allMembers.length === 0){
          //    _self.noMembers = true;
          //  }
        }
        //else {

        // _self.swangular.swal({
        //   type: 'error',
        //   title: '',
        //   html: 'Failed to get members. Please contact support.'
        // });
        // }
      });
    }
  }, {
    key: 'closeViewSelectedMember',
    value: function closeViewSelectedMember() {
      this.whichPage = 5;
    }
  }, {
    key: 'editPersonalDetails',
    value: function editPersonalDetails() {

      this.selectedMember.editTitle = this.selectedMember.user.title;
      this.selectedMember.editFirstName = this.selectedMember.user.firstname;
      this.selectedMember.editMiddleNames = this.selectedMember.user.middleNames;
      this.selectedMember.editLastName = this.selectedMember.user.lastname;
      this.selectedMember.editProfession = this.selectedMember.user.profession;
      this.selectedMember.editEmail = this.selectedMember.user.email;
      this.selectedMember.editCountryCode = this.selectedMember.user.region;
      this.selectedMember.editPhone = this.selectedMember.user.mobile;

      this.whichPage = 13;
    }
  }, {
    key: 'editPersonalRoles',
    value: function editPersonalRoles() {
      this.selectedMember.isCreatorEdit = this.selectedMember.isCreator;
      this.selectedMember.isOrgOwnerEdit = this.selectedMember.isOrgOwner;
      this.selectedMember.isOfficeAdminEdit = this.selectedMember.isOfficeAdmin;
      this.selectedMember.isMDTCoOrdinatorEdit = this.selectedMember.isMDTCoOrdinator;
      this.whichPage = 14;
    }
  }, {
    key: 'cancelPersonalEdit',
    value: function cancelPersonalEdit() {
      this.whichPage = 12;
    }
  }, {
    key: 'openCasesPage',
    value: function openCasesPage() {

      var _self = this;
      this.allMembers = [];
      this.noMembers = false;
      this.noCases = false;

      this.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(this.$document.body)
      });

      this.$http({
        method: 'GET',
        url: apiBasePath + 'Organisations/GetCasesForOrgWithRead?mId=' + this.context.currentRole.membershipId + '&orgId=' + this.selectedOrganisation.id
      }).then(function (response) {
        _self.$mdDialog.hide();
        if (response.data.type > 0) {

          _self.allCases = response.data.payload.items;
          _self.whichPage = 6;
          if (!_self.allCases || _self.allCases.length === 0) {
            _self.noCases = true;
          }
        } else {
          _self.swangular.swal({
            type: 'error',
            title: '',
            html: response.data.message
          });
        }
      });
    }
  }, {
    key: 'openAddContactPage',
    value: function openAddContactPage() {

      var _self = this;
      this.allAddContacts = [];
      this.noAddContacts = false;

      this.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(this.$document.body)
      });

      this.$http({
        method: 'GET',
        url: apiBasePath + 'User/GetUsersInOrg?mId=' + this.context.currentRole.membershipId + '&orgId=' + this.selectedOrganisation.id
      }).then(function (response) {
        _self.$mdDialog.hide();
        if (response.data.type > 0) {

          _self.allAddContacts = response.data.payload;
          _self.whichPage = 7;
          if (!_self.allAddContacts || _self.allAddContacts.length === 0) {
            _self.noAddContacts = true;
          }
        } else {

          _self.swangular.swal({
            type: 'error',
            title: '',
            html: response.data.message
          });
        }
      });
    }
  }, {
    key: 'connectToExistingUser',
    value: function connectToExistingUser() {
      this.connectUserFirstName = '';
      this.connectUserLastName = '';
      this.connectUserSearchResults = [];
      this.whichPage = 16;
    }
  }, {
    key: 'cancelExistingContactSearchPage',
    value: function cancelExistingContactSearchPage() {
      this.whichPage = 7;
    }
  }, {
    key: 'search',
    value: function search() {

      var _self = this;
      this.connectUserSearchResults = [];

      this.noConnectUserSearchResults = false;

      if (this.connectUserFirstName === '' && this.connectUserLastName === '') {
        return;
      }

      this.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(this.$document.body)
      });

      this.$http({
        method: 'GET',
        url: apiBasePath + 'Clinicians/SearchByName?mId=' + this.context.currentRole.membershipId + '&firstname=' + this.connectUserFirstName + '&firstname=' + this.connectUserLastName
      }).then(function (response) {
        _self.$mdDialog.hide();
        if (response.data.type === 0) {
          _self.connectUserSearchResults = response.data.payload;
          if (_self.connectUserSearchResults && _self.connectUserSearchResults.length === 0) {
            _self.noConnectUserSearchResults = true;
          }
        } else {
          _self.swangular.swal({
            type: 'error',
            title: '',
            html: 'Failed to search. Please contact support.'
          });
        }
      });
    }
  }, {
    key: 'viewUserConnect',
    value: function viewUserConnect(existingContact) {
      this.selectedExistingContact = existingContact;
      this.whichPage = 17;
    }
  }, {
    key: 'cancelViewExistingMember',
    value: function cancelViewExistingMember() {
      this.whichPage = 16;
    }
  }, {
    key: 'connectToNonUser',
    value: function connectToNonUser(selectedAddContact) {
      this.selectedAddContact = selectedAddContact;
      this.externalContactTitle = '';
      this.externalContactFirstName = '';
      this.externalContactLastName = '';
      this.externalContactMiddleName = '';
      this.externalContactProfession = '';
      this.externalContactIsSpellingCorrect = false;
      this.whichPage = 15;
    }
  }, {
    key: 'addExternalContact',
    value: function addExternalContact() {

      if (!this.externalContactFirstName) {
        this.showError(this.firstNameRequired);
        return;
      } else if (!this.externalContactLastName) {
        this.showError(this.lastNameRequired);
        return;
      }

      var requestPayload = [{
        'title': this.externalContactTitle,
        'id': '',
        'firstname': this.externalContactFirstName,
        'middleNames': this.externalContactMiddleName,
        'lastname': this.externalContactLastName,
        'region': '',
        'mobile': '',
        'profession': this.externalContactProfession
      }];

      this.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(this.$document.body)
      });

      var _self = this;

      this.$http({
        url: apiBasePath + '/Organisations/Contacts/AddNonUser?mId=' + this.context.currentRole.membershipId + '&orgId=' + this.selectedOrganisation.id + '&fromUserId=' + this.selectedAddContact.user.id,
        method: 'POST',
        data: requestPayload,
        headers: { 'Content-Type': 'application/json' }
      }).then(function (response) {
        _self.$mdDialog.hide();
        if (response.data.type > 0) {
          _self.swalSuccess('', 'Contact has been added.');
          _self.whichPage = 7;
        } else {
          _self.showError(response.data.message);
        }
      }).error(function () {
        _self.$mdDialog.hide();
        _self.swalError('Failed', 'Failed to add contact.Please contact support.');
      });
    }
  }, {
    key: 'cancelExternalContact',
    value: function cancelExternalContact() {
      this.whichPage = 7;
    }
  }, {
    key: 'connectExistingUser',
    value: function connectExistingUser() {
      this.whichPage = 16;
    }
  }, {
    key: 'openAllContactsPage',
    value: function openAllContactsPage() {
      var _self = this;
      this.allContacts = [];
      this.noContacts = false;

      this.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(this.$document.body)
      });

      this.$http({
        method: 'GET',
        url: apiBasePath + '/Contact/ListForOrg?mId=' + this.context.currentRole.membershipId + '&orgId=' + this.selectedOrganisation.id + '&page=1&pageSize=20'
      }).then(function (response) {
        _self.$mdDialog.hide();
        if (response.data.type > 0) {

          _self.allContacts = response.data.payload.items;
          _self.whichPage = 8;
          if (_self.allContacts.length === 0) {
            _self.noContacts = true;
          }
        } else {

          _self.swangular.swal({
            type: 'error',
            title: '',
            html: 'Failed to get invites. Please contact support.'
          });
        }
      });
    }
  }, {
    key: 'getDisplayName',
    value: function getDisplayName(user) {
      var result = '';
      if (user.title) {
        result += user.title + ' ';
      }
      if (user.firstname) {
        result += user.firstname + ' ';
      }
      if (user.middleNames) {
        result += user.middleNames + ' ';
      }
      if (user.lastname) {
        result += user.lastname + ' ';
      }
      return result;
    }
  }, {
    key: 'getCaseCreatorName',
    value: function getCaseCreatorName(user) {
      var result = '';
      if (!user) return result;

      if (user.title) {
        result += user.title + ' ';
      }
      if (user.firstName) {
        result += user.firstName + ' ';
      }
      if (user.middleNames) {
        result += user.middleNames + ' ';
      }
      if (user.lastName) {
        result += user.lastName + ' ';
      }
      return result;
    }
  }, {
    key: 'getRecipientNames',
    value: function getRecipientNames(recipients) {
      var allRecipients = [];
      for (var i = 0; i < recipients.length; i++) {
        allRecipients.push(recipients[i].displayName);
      }

      return allRecipients.join(';');
    }
  }, {
    key: 'viewContactDetails',
    value: function viewContactDetails(contact) {
      this.selectedContact = contact;
      this.whichPage = 9;
    }
  }, {
    key: 'back2AllContacts',
    value: function back2AllContacts() {
      this.whichPage = 8;
    }
  }]);

  return ManageOrganisationCtrl;
}();

angular.module('app.clinician').component('manageOrganisation', {
  controller: ManageOrganisationCtrl,
  templateUrl: 'app/main/clinician/people/manageOrganisation.html'
});


'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ClinicianPeopleCtlr = function () {
  function ClinicianPeopleCtlr($scope, $state, $mdDialog, notificationDialog, $resource, $document, appContext, userService, api, $analytics, $q, $mdSidenav, $http, localStorageService, $rootScope, swangular) {
    'inject';

    _classCallCheck(this, ClinicianPeopleCtlr);

    this.localStorageService = localStorageService;
    this.swangular = swangular;
    this.$q = $q;
    this.$http = $http;
    this.$mdSidenav = $mdSidenav;
    this.$state = $state;
    this.$mdDialog = $mdDialog;
    this.$resource = $resource;
    this.api = api;
    this.$document = $document;
    this.$analytics = $analytics;
    this.form = { person: {} };
    this.app = appContext;
    this.currentPage = 'CONTACT_LIST'; //'CONTACT_DETAIL'
    this.$scope = $scope;
    this.context = userService.getContext(); //userService.context;
    this.userService = userService;
    this.loadRequest = false;
    this.errorTxt = 'Sorry, an error has occurred and we cannot continue. Please try again later.';
    this.$rootScope = $rootScope;
    this.$scope.editingGroupNameInProgress = false;

    $scope.isDeleteFail = false;
    $scope.isDeleteGroupFail = false;

    this.newGroupForm = {};

    this.selectedContactToAddToGroup;
    this.searchTextContactAutoComplete;
    this.showAddContactToGroupButton = false;
    this.contactSelectedToAdd = undefined;
    this.showNoContactsInGroup = false;
    $scope.thereAreNoGroups = false;
    this.addContactActive = false;
    this.showSpinnerOnGroupDetailsPage = false; //- This determines wheather to show loader till we figure it out wheather the group has contacts

    /** Contact Chips Code  - START */
    this.chipContacts = [];
    this.chipEditGroup = [];
    this.selectedItemChip = null;
    this.selectedItemChipEdit = null;
    this.searchTextChip = null;
    this.searchTextChipEdit = null;
    /** Contact Chips Code  - END */
    this.newContactForm = {}; // - represents the form object on adding new contacts, holds data that tell if phone number is of a existing clinivid user , phone number entered by user and country code
    this.membershipIdOfActiveTab;
    this.$scope.nextButtonCheckPhoneNumberShow = true; //-show  or hide the next on Add contact page after user click "next" to validate number

    this.isAddContactinProgress = false; // - to indicate when add contact is in process
    this.checkinPhoneNumberInProgres = false; // - indicate whether checking phone number is in progress and show a spinner
    this.doesContactAlreadyexist = false; // - this indicates of contact already exists
    this.isContactNewUser = false; //Activated when contact to add is a new user and we need user to enter details- title,lastname profession etc
    this.doEditUnlinkedContact = false;

    this.editUnlinkedContact = {};

    if (window.location.href.indexOf("clinician/mdt") > -1) {
      window.location = "/mdt";
      return;
    }

    if (!this.app.clinician.people) this.app.clinician.people = {};

    $scope.searchTerm = '';
    $scope.searchWord = '';

    this.searchTerm = $scope.searchTerm;

    if (!this.loadRequest) {
      this.loadPage(1, 20, $scope);
    }
    this.$scope.addContactMode = 'PHONE';
  }

  _createClass(ClinicianPeopleCtlr, [{
    key: 'isDevelopmentMode',
    value: function isDevelopmentMode() {
      if (environment === "dev") return true;else return false;
    }
  }, {
    key: 'closeViewContact',
    value: function closeViewContact() {
      this.$mdSidenav('viewContact').close();
    }
  }, {
    key: 'openViewContact',
    value: function openViewContact(contact) {

      this.doEditUnlinkedContact = false;
      this.showEditUnlinkedContactSection = false;
      var icon = this.$document[0].getElementById('editUnlinkedContactIcon');
      if (icon) icon.style.color = '#92298D';

      var enclosingDiv = this.$document[0].getElementById('editUnlinkedContactEnclosingDiv');
      if (enclosingDiv) enclosingDiv.style.backgroundColor = 'white';

      this.$scope.selectedContact = contact;
      this.$mdSidenav('viewContact').toggle();
    }

    /**  Open Side Nav to allow users to Add a new Contact END **/

  }, {
    key: 'closeViewGroup',
    value: function closeViewGroup() {
      this.$mdSidenav('viewGroup').close();
    }

    /** Called when you click a Group to View Details START **/

  }, {
    key: 'openViewGroup',
    value: function openViewGroup(group) {
      this.$scope.selectedGroup = group;
      this.$scope.searchWord = '';
      this.$scope.editingGroupNameInProgress = false;
      this.$scope.newGroupName = '';

      this.chipEditGroup = [];
      this.selectedItemChipEdit = null;
      this.searchTextChipEdit = null;

      this.selectedContactToAddToGroup = undefined; //- reset the selected Contact in Add Contact Section of Groups sidenav

      this.addContactActive = false; //-This changes the background COLOR of Add Contact Button

      var icon = this.$document[0].getElementById('addGroupIcon');
      if (icon) icon.style.color = '#92298D';

      var enclosingDiv = this.$document[0].getElementById('addGroupEnclosingDiv');
      if (enclosingDiv) enclosingDiv.style.backgroundColor = 'white';

      this.showAddContactSectionForGroup = false;

      this.showEditUnlinkedContactSection = false;

      this.showAddContactToGroupButton = false;

      this.contactSelectedToAdd = undefined;

      this.showNoContactsInGroup = false; //- initially hide the add contact call to action

      this.showSpinnerOnGroupDetailsPage = true; //- Show Spinner till we figure it out whether user has contacts or not

      this.getGroupMembers(group.aliasKey, this.membershipIdOfActiveTab, this.$mdSidenav('viewGroup')); //this.getGroupMembers(group.aliasKey,group.membershipId,this.$mdSidenav('viewGroup'));

      this.$mdSidenav('viewGroup').toggle();
    }

    /** Called when you click a Group to View Details END **/

  }, {
    key: 'closeAddGroup',
    value: function closeAddGroup() {
      this.newGroupForm = {};
      this.$mdSidenav('addGroup').close();
    }

    /** Opens the side-Nav to create Group **/

  }, {
    key: 'openCreateGroupTab',
    value: function openCreateGroupTab() {
      this.newGroupForm = {};
      this.chipContacts = [];
      this.selectedItemChip = null;
      this.searchTextChip = null;
      this.$mdSidenav('addGroup').toggle();
    }
  }, {
    key: 'getProfiles',
    value: function getProfiles() {
      var profiles = [];
      for (var i = 0; i < this.context.roles.length; i++) {
        var role = this.context.roles[i];
        if (role.formattedOrganizationName == 'Personal Account') profiles.push(role);
      }

      return profiles;
    }
  }, {
    key: 'clearGroupSearch',
    value: function clearGroupSearch() {
      this.$scope.searchWord = "";
    }
    /** Fetch All Members of a Group and open the sideNav Start **/

  }, {
    key: 'getGroupMembers',
    value: function getGroupMembers(aliasKey, membershipId) {
      if (!aliasKey) return;
      if (!membershipId) return;

      this.$scope.selectedGroup['groupMembers'] = [];

      var localScope = this.$scope;
      var self = this;

      this.$http({
        method: 'GET',
        url: apiBasePath + 'Contact/GetContactAliasContactList?mId=' + membershipId + '&aliasId=' + aliasKey
      }).then(function successCallback(response) {

        self.showSpinnerOnGroupDetailsPage = false; //- Hide spinner as we now know if  group has contacts

        localScope.selectedGroup['groupMembers'] = response.data.payload;

        if (localScope.selectedGroup['groupMembers'] && localScope.selectedGroup['groupMembers'].length > 0) {
          localScope.selectedGroup['groupMembers'].reverse(); //Reverse groups - they should be shown in LIFO

          var allContacts = localScope.contactMap[membershipId];

          for (var i = 0; i < localScope.selectedGroup['groupMembers'].length; i++) {

            var title = '';
            for (var x = 0; x < allContacts.length; x++) {
              if (allContacts[x].id === localScope.selectedGroup['groupMembers'][i].contactId) {
                title = allContacts[x].title;
              }
            }
            var displayName = '';

            if (title && title.length > 0) {
              displayName += title + ' ';
            }

            if (localScope.selectedGroup['groupMembers'][i].lastName) {
              displayName += localScope.selectedGroup['groupMembers'][i].lastName + ' ';
            }
            if (localScope.selectedGroup['groupMembers'][i].middleNames) {
              displayName += localScope.selectedGroup['groupMembers'][i].middleNames + ' ';
            }
            if (localScope.selectedGroup['groupMembers'][i].firstName) {
              displayName += localScope.selectedGroup['groupMembers'][i].firstName;
            }
            localScope.selectedGroup['groupMembers'][i].displayName = displayName;
          }
        }

        if (localScope.selectedGroup.groupMembers && localScope.selectedGroup.groupMembers.length > 0) self.showNoContactsInGroup = false;else self.showNoContactsInGroup = true;

        self.showSpinnerOnGroupDetailsPage = false; //- Hide spinner as we now know if  group has contacts
      }, function errorCallback() {
        self.showNoContactsInGroup = true;
        self.showSpinnerOnGroupDetailsPage = false; //- Hide spinner as we now know if  group has contacts
      });
    }

    /** Fetch All Members of a Group and open the sideNav End **/

    /** This method is triggered when add contact button is clicked on top right of Group Details Side-Nav START **/

  }, {
    key: 'addContact',
    value: function addContact() {

      this.showNoContactsInGroup = false;

      this.selectedContactToAddToGroup = undefined; //- reset the selected Contact in Add Contact Section of Groups sidenav

      this.showAddContactSectionForGroup = !this.showAddContactSectionForGroup;
      this.addContactActive = !this.addContactActive;

      if (this.addContactActive == true) {
        var icon = this.$document[0].getElementById('addGroupIcon');
        if (icon) icon.style.color = 'white';

        var enclosingDiv = this.$document[0].getElementById('addGroupEnclosingDiv');
        if (enclosingDiv) enclosingDiv.style.backgroundColor = '#92298D';
      } else {
        var icon = this.$document[0].getElementById('addGroupIcon');
        if (icon) icon.style.color = '#92298D';

        var enclosingDiv = this.$document[0].getElementById('addGroupEnclosingDiv');
        if (enclosingDiv) enclosingDiv.style.backgroundColor = 'white';
      }
    }
    /** This method is triggered when add contact button is clicked on top right of Group Details Side-Nav END  **/

  }, {
    key: 'removeGroupMember',
    value: function removeGroupMember(member) {

      var data = {
        AliasKey: this.$scope.selectedGroup.aliasKey,
        ContactList: [member.contactId]
      };

      var contactName = '';

      if (member.lastName) contactName = contactName.concat(member.lastName + ' ');
      if (member.middleNames) contactName = contactName.concat(member.middleNames + ' ');
      if (member.firstName) contactName = contactName.concat(member.firstName);

      var contactIdToRemove = member.contactId;

      var scope = this.$scope;

      var _self = this;

      /** This  is a hack as we CAN-ONLY add contact by membership of  org-owner or admin ,else it must be a personal account **/
      var membershipIdToAddContact = void 0;
      var isMembershipIdSet = false;
      var activeTabRole = void 0;
      for (var i = 0; i < this.context.roles.length; i++) {
        // Logic to determine if its a personal Account
        var role = this.context.roles[i];
        if (role.membershipId === this.membershipIdOfActiveTab) {
          //-Assuming  Add Contact button is showed for  genuine Personal Accounts- i am not putting extra checks
          activeTabRole = role; // Active Tab Role is set here
          if (role.orgDisplayName.toUpperCase().indexOf('PRACTICE OF') >= 0) {
            membershipIdToAddContact = this.membershipIdOfActiveTab;
            isMembershipIdSet = true;
            break;
          }
        }
      }

      //-lets determine the membershipId of the Admin or Org-owner and add by that as backend will error out else
      if (!isMembershipIdSet) {
        for (var _i = 0; _i < this.context.roles.length; _i++) {
          // Logic to determine user has Admin or OrgRole
          var tempRole = this.context.roles[_i];
          if (activeTabRole && activeTabRole.orgId === tempRole.orgId) {
            if (tempRole.name === 'OrgOwner' || tempRole.name === 'OfficeAdmin') {
              membershipIdToAddContact = tempRole.membershipId;
              break;
            }
          }
        }
      }

      this.$http.put(apiBasePath + 'Contact/DeleteContactFromAlias?mId=' + membershipIdToAddContact, data).then(function () {

        for (var i = 0; i < scope.selectedGroup.groupMembers.length; i++) {
          var contactId = scope.selectedGroup.groupMembers[i].contactId;
          if (contactIdToRemove === contactId) {
            scope.selectedGroup.members = scope.selectedGroup.groupMembers.splice(i, 1);
            break;
          }
        }

        if (scope.selectedGroup.groupMembers.length <= 0) {
          _self.showNoContactsInGroup = true;
        } //-Show No contacts banner when there are no contacts

        _self.swangular.swal('Contact removed', 'Contact <strong>' + contactName + '</strong> has been successfully removed from group.', 'success');
      }).error(function () {

        _self.swangular.swal({
          type: 'error',
          title: 'Failed to remove contact',
          html: 'Please contact Support.'
        });
      });
    }
  }, {
    key: 'queryContactSearchGroupAdd',
    value: function queryContactSearchGroupAdd(query) {

      var allEligibleContacts = this.$scope.quickSearchMap[this.membershipIdOfActiveTab]; //this.$scope.quickSearchMap[this.$scope.selectedGroup.membershipId];

      //var formattedOrganizationName = this.context.currentRole.formattedOrganizationName; // As we can add groups members on Active profile

      /** prune Contacts already in group **/
      var prunedContacts = [];

      var existingContacts = this.$scope.selectedGroup['groupMembers'];

      for (var i = 0; i < existingContacts.length; i++) {
        prunedContacts.push(existingContacts[i].contactId);
      }

      var allEligibleContactsModified = [];

      for (var i = 0; i < allEligibleContacts.length; i++) {
        if (prunedContacts.indexOf(allEligibleContacts[i].id) > -1) {
          continue;
        } else {
          // allEligibleContacts[i].formattedOrganizationName= formattedOrganizationName;
          allEligibleContactsModified.push(allEligibleContacts[i]);
        }
      }
      var results = query ? allEligibleContactsModified.filter(this.auxillaryQuerySearch(query)) : allEligibleContactsModified;
      return results;
    }
  }, {
    key: 'auxillaryQuerySearch',
    value: function auxillaryQuerySearch(query) {

      var lowercaseQuery = text.toLowerCase();

      return function filterFn(eligibleContact) {
        return eligibleContact.fullName.toLowerCase().indexOf(lowercaseQuery) !== -1;
      };
    }

    /** This method displays the +Add Contact Button when a valid contact is selected. For Invalid Contact the value of item is undefined and +Add Button remain hidden  START **/

  }, {
    key: 'selectedContactChange',
    value: function selectedContactChange(item) {
      if (item) {
        this.showAddContactToGroupButton = true;
        this.contactSelectedToAdd = item;
        //this.addGroupMember(); - If you want to hide the +Add button as asked by Katja
      } else {
        this.showAddContactToGroupButton = false;
        this.contactSelectedToAdd = undefined;
      }
    }

    /** This method displays the +Add Contact Button when a valid contact is selected. For Invalid Contact the value of item is undefined and +Add Button remain hidden  END  **/

    /** This function add a single contact to a group START */

  }, {
    key: 'addGroupMember',
    value: function addGroupMember() {

      var contacts2AddArray = [];

      var listOfNames2BeAdded = [];

      if (this.chipEditGroup && this.chipEditGroup.length > 0) {
        for (var i = 0; i < this.chipEditGroup.length; i++) {
          contacts2AddArray.push(this.chipEditGroup[i].id);
          listOfNames2BeAdded.push(this.chipEditGroup[i].fullName);
        }
      }

      var data = {
        AliasKey: this.$scope.selectedGroup.aliasKey,
        ContactList: contacts2AddArray
      };

      var contactName = listOfNames2BeAdded.join(', '); //this.contactSelectedToAdd.fullName;

      var successMessage = void 0;
      if (this.chipEditGroup.length > 1) {
        successMessage = 'Contacts <strong>' + contactName + '</strong> has been successfully added to group.';
      } else {
        successMessage = 'Contact <strong>' + contactName + '</strong> has been successfully added to group.';
      }

      var scope = this.$scope;
      var aliasKey = this.$scope.selectedGroup.aliasKey;
      var membershipId = this.$scope.selectedGroup.membershipId;
      var _self = this;

      this.$http.put(apiBasePath + 'Contact/AddContactToAlias?mId=' + this.$scope.selectedGroup.membershipId, data).then(function () {

        scope.showAddContactToGroupButton = false;
        scope.contactSelectedToAdd = undefined;
        _self.chipEditGroup = [];
        _self.addContact(); // Hide the add Contact section once done adding contact

        _self.$http({ //Refresh group and update   - scope.selectedGroup.members to show the new contact
          method: 'GET',
          url: apiBasePath + 'Contact/GetContactAliasContactList?mId=' + membershipId + '&aliasId=' + aliasKey
        }).then(function successCallback(response) {

          scope.selectedGroup['groupMembers'] = response.data.payload; //- to update the groups in sideNav

          for (var i = 0; i < scope.selectedGroup['groupMembers'].length; i++) {
            var displayName = '';
            if (scope.selectedGroup['groupMembers'][i].lastName) {
              displayName += scope.selectedGroup['groupMembers'][i].lastName + ' ';
            }
            if (scope.selectedGroup['groupMembers'][i].middleNames) {
              displayName += scope.selectedGroup['groupMembers'][i].middleNames + ' ';
            }
            if (scope.selectedGroup['groupMembers'][i].firstName) {
              displayName += scope.selectedGroup['groupMembers'][i].firstName;
            }
            scope.selectedGroup['groupMembers'][i].displayName = displayName;
          }
          _self.swangular.swal('Contact Added', successMessage, 'success');
        }, function errorCallback() {

          _self.swangular.swal({
            type: 'error',
            title: 'Failed to add contact',
            html: 'Please contact Support.'
          });
        });
      }).error(function () {

        scope.showAddContactToGroupButton = false;
        scope.contactSelectedToAdd = undefined;
        _self.chipEditGroup = [];

        _self.swangular.swal({
          type: 'error',
          title: 'Failed to add contact',
          html: 'Please contact Support.'
        });
      });

      this.selectedContactToAddToGroup = undefined; //- reset the selected Contact in Add Contact Section of Groups sidenav
      _self.chipEditGroup = [];
    }

    /** This function add a single contact to a group END */

    /** Chip Code Start **/

  }, {
    key: 'transformChip',
    value: function transformChip(chip) {
      // If it is an object, it's already a known chip
      if (angular.isObject(chip)) {
        return chip;
      }
    }
  }, {
    key: 'querySearchChip',
    value: function querySearchChip(query) {

      //var membershipId = this.newGroupForm.membershipId;

      var allEligibleContacts = this.$scope.quickSearchMap[this.membershipIdOfActiveTab]; //this.$scope.quickSearchMap[this.context.currentRole.membershipId]; //this.$scope.allMyContacts;
      //var prunedContacts =[];


      var results = query ? allEligibleContacts.filter(this.createFilterForChip(query)) : allEligibleContacts;
      return results;
    }
  }, {
    key: 'createFilterForChip',
    value: function createFilterForChip(query) {
      var lowercaseQuery = query.toLowerCase();

      return function filterFn(contact) {
        return contact.fullName.toLowerCase().indexOf(lowercaseQuery) !== -1;
      };
    }
  }, {
    key: 'showModalSpinner',
    value: function showModalSpinner(_self) {
      _self.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(document.body)
      });
    }
  }, {
    key: 'createGroup',
    value: function createGroup() {
      //Stop=creating-duplicate-group

      var _self = this;

      if (this.$scope.contactMap['groupContact']) {
        for (var _i2 = 0; _i2 < this.$scope.contactMap['groupContact'].length; _i2++) {
          if (this.$scope.contactMap['groupContact'][_i2].membershipId === this.membershipIdOfActiveTab) {
            this.$scope.contactMap['groupContact'][_i2];
          }
        }
      }

      //if(this.newGroupForm && this.newGroupForm.groupName && this.newGroupForm.membershipId) {
      if (this.newGroupForm && this.newGroupForm.groupName) {
        if (this.$scope.contactMap['groupContact']) {
          for (var _i3 = 0; _i3 < this.$scope.contactMap['groupContact'].length; _i3++) {
            if (this.$scope.contactMap['groupContact'][_i3].membershipId === this.membershipIdOfActiveTab) {
              if (this.$scope.contactMap['groupContact'][_i3].aliasName === this.newGroupForm.groupName) {
                this.swangular.swal({
                  type: 'error',
                  title: 'Duplicate group',
                  html: 'A group with same name already exists.'
                });

                return;
              }
            }
          }
        }

        var contacts2AddArray = [];

        _self.showModalSpinner(_self);

        if (this.chipContacts && this.chipContacts.length > 0) {
          for (var i = 0; i < this.chipContacts.length; i++) {
            contacts2AddArray.push(this.chipContacts[i].id);
          }
        }

        /** This  is a hack as we CAN-ONLY add contact by membership of  org-owner or admin ,else it must be a personal account **/
        var membershipIdToAddContact = void 0;
        var isMembershipIdSet = false;
        var activeTabRole = void 0;
        for (var _i4 = 0; _i4 < this.context.roles.length; _i4++) {
          // Logic to determine if its a personal Account
          var role = this.context.roles[_i4];
          if (role.membershipId === this.membershipIdOfActiveTab) {
            //-Assuming  Add Contact button is showed for  genuine Personal Accounts- i am not putting extra checks
            activeTabRole = role; // Active Tab Role is set here
            if (role.orgDisplayName.toUpperCase().indexOf('PRACTICE OF') >= 0) {
              membershipIdToAddContact = this.membershipIdOfActiveTab;
              isMembershipIdSet = true;
              break;
            }
          }
        }

        //-lets determine the membershipId of the Admin or Org-owner and add by that as backend will error out else
        if (!isMembershipIdSet) {
          for (var _i5 = 0; _i5 < this.context.roles.length; _i5++) {
            // Logic to determine user has Admin or OrgRole
            var tempRole = this.context.roles[_i5];
            if (activeTabRole && activeTabRole.orgId === tempRole.orgId) {
              if (tempRole.name === 'OrgOwner' || tempRole.name === 'OfficeAdmin') {
                membershipIdToAddContact = tempRole.membershipId;
                break;
              }
            }
          }
        }

        var groupName = this.newGroupForm.groupName;
        var addGroupSideNav = this.$mdSidenav('addGroup');

        var scope = this.$scope;
        var membershipId = membershipIdToAddContact; //this.context.currentRole.membershipId;//this.newGroupForm.membershipId;

        var currentRole = this.context.currentRole;

        this.$http({
          url: apiBasePath + 'Contact/CreateAlias?mId=' + membershipId,
          method: "POST",
          data: { aliasName: this.newGroupForm.groupName },
          headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {

          if (response.data.type > 0) {
            var groupContacts = scope.contactMap['groupContact'];

            var newlyAddedGroup = {};
            newlyAddedGroup['aliasKey'] = response.data.payload;
            newlyAddedGroup['aliasName'] = groupName;
            newlyAddedGroup['membershipId'] = _self.membershipIdOfActiveTab;
            newlyAddedGroup.role = currentRole;

            if (groupContacts) groupContacts.unshift(newlyAddedGroup); //- Add the New Group on Top of the list of Group LIFO
            else {
                scope.contactMap['groupContact'] = [];
                scope.contactMap['groupContact'].push(newlyAddedGroup);
              }

            if (scope.contactMap['groupContact'].length > 1) {
              scope.contactMap['groupContact'].sort(function (a, b) {
                return a.aliasName.localeCompare(b.aliasName);
              });
            }

            if (contacts2AddArray && contacts2AddArray.length > 0) {
              var data = {
                AliasKey: response.data.payload,
                ContactList: contacts2AddArray
              };

              _self.$http.put(apiBasePath + 'Contact/AddContactToAlias?mId=' + membershipId, data).then(function (response) {
                _self.$mdDialog.hide();
                addGroupSideNav.close();
                _self.swangular.swal('Group Created', 'Group <strong>' + groupName + '</strong> has been successfully created.', 'success');
              }).error(function () {
                _self.$mdDialog.hide();
                addGroupSideNav.close();
                _self.swangular.swal({
                  type: 'error',
                  title: 'Error Creating Group',
                  html: 'Group <strong>' + groupName + '</strong> has been successfully created. But failed to add Contacts.'
                });
              });
            } else {
              _self.$mdDialog.hide();
              addGroupSideNav.close();
              _self.swangular.swal('Group Created', 'Group <strong>' + groupName + '</strong> has been successfully created.', 'success');
            }
          } else {
            _self.$mdDialog.hide();
            addGroupSideNav.close();
            _self.swangular.swal({
              type: 'error',
              title: 'Error Creating Group',
              html: 'Group <strong>' + groupName + '</strong> has been successfully created. But failed to add Contacts.'
            });
          }
        }).error(function () {
          _self.$mdDialog.hide();
          addGroupSideNav.close();
          _self.swangular.swal({
            type: 'error',
            title: 'Error Creating Group',
            html: 'Group <strong>' + groupName + '</strong> has been successfully created. But failed to add Contacts.'
          });
        });
      }
    }
  }, {
    key: 'showAddContactChipWidget',
    value: function showAddContactChipWidget() {
      if (this.newGroupForm && this.newGroupForm.membershipId) return true;else false;
    }

    /** Chip Code End **/

    /** Create Case for single  Recipient START **/

  }, {
    key: 'createCaseForSingleRecipient',
    value: function createCaseForSingleRecipient(contact) {

      this.$mdSidenav('viewGroup').close();
      this.$state.go('app.user.casecreation', { singleRecipientId: contact.id, membershipIdFromContactsPage: this.membershipIdOfActiveTab });
    }
    /** Create Case for single  Recipient END **/

    /** Create Case from  Group START **/

  }, {
    key: 'createCaseForEntireGroup',
    value: function createCaseForEntireGroup(group) {

      this.$mdSidenav('viewGroup').close();
      this.$state.go('app.user.casecreation', { createCaseWithGroupId: group.aliasKey, membershipIdFromContactsPage: this.membershipIdOfActiveTab });
    }
    /** Create Case from  Group END **/

  }, {
    key: 'howManytabsToShow',
    value: function howManytabsToShow() {
      if (this.context.roles == undefined) return;
      var tabs2Show = [];
      for (var i = 0; i < this.context.roles.length; i++) {
        var role = this.context.roles[i];

        if (role.name !== 'Viewer' && role.title && role.title.toUpperCase() !== 'ENTERPRISE' && role.name !== 'HCI-Admin' && role.name.toLowerCase() !== 'officeadmin') {
          tabs2Show.push(this.context.roles[i]);
        }
        // if(this.context.roles[i].title && this.context.roles[i].title.toUpperCase() === 'ENTERPRISE'){
        // console.log("ORG owner", this.context.roles[i].title);
        // continue;
        // }
        // else {
        //tabs2Show.push(this.context.roles[i]);
        // }
      }

      return tabs2Show;
    }
  }, {
    key: 'loadPage',
    value: function loadPage(page, pageSize, scope) {
      var _this = this;

      pageSize = 100; //Although backend returns 22 setting the maximum no of contacts as 100 to cover all .

      this.loadRequest = true;

      scope.contactMap = {};
      scope.orgMembers = {};
      scope.quickSearchMap = {};
      //scope.allMyContacts = [];

      this.selectedContactsTabIndex = 0;

      if (!this.context || !this.context.currentRole) {
        // this.userService.getUserContext();
        this.$resource(apiBasePath + 'User/Context').get({ username: this.userService.authentication.userName },
        //return this.msApi.request('app.userContext@get', { username: this.authentication.userName },
        // SUCCESS
        function (response) {
          //console.log("Registration Complete.");
          //console.log(response);
          if (response.type > 0) {
            _.assign(_this.userService.context, _.pick(response.payload, ['roles', 'defaultRole', 'user']));

            var filterViewer = [];

            for (var i = 0; i < _this.userService.context.roles.length; i++) {
              if (_this.userService.context.roles[i].name !== 'Viewer') {
                filterViewer.push(_this.userService.context.roles[i]);
              }
            }

            if (_this.userService.context.defaultRole.name === 'Viewer') {
              _this.userService.context.defaultRole = filterViewer[0];
            }

            _this.userService.context.roles = filterViewer;

            _this.$rootScope.$broadcast('userContextChanged');
            // let defaultRole = this.localStorageService.get(`defaultRoles.${this.context.user.id}`);
            // if (!defaultRole) {
            //   defaultRole = {name: this.context.defaultRole.name, domain: this.context.defaultRole.domain}
            // } - commented as this is picking up cached profile

            var defaultRole = {
              name: _this.userService.context.defaultRole.name,
              domain: _this.userService.context.defaultRole.domain
            };

            _this.userService.setActiveRole(defaultRole.name, defaultRole.domain);

            for (var _i6 = 0; _i6 < _this.userService.context.roles.length; _i6++) {
              // - This block of code formats organisation name. It's a IE-11 fix.
              var r = _this.userService.context.roles[_i6];

              if (!r) {
                continue;
              }

              // var isPersonalProfile = r.orgDisplayName.toUpperCase().includes('PRACTICE OF');
              var isPersonalProfile = r.orgDisplayName.toUpperCase().indexOf('PRACTICE OF') >= 0;

              if (isPersonalProfile) {
                r.formattedOrganizationName = 'Personal Account';
                r.customOrganizationName = r.formattedOrganizationName;
              } else {
                r.formattedOrganizationName = r.orgDisplayName;
                if (r.formattedOrganizationName.length > 18) r.customOrganizationName = r.formattedOrganizationName.slice(0, 18).concat('...');else r.customOrganizationName = r.formattedOrganizationName;
              }
            };
          } else {
            return _this.userService.logOut();
          }

          _this.context = _this.userService.context;
          _this.populateContactsPage(page, pageSize, scope);
        },
        // ERROR
        function (response) {
          return _this.userService.logOut();
        });
        // return;
      } else {
        this.populateContactsPage(page, pageSize, scope);
      }
    }
  }, {
    key: 'populateContactsPage',
    value: function populateContactsPage(page, pageSize, scope) {
      var _this2 = this;

      var membershipIdOfActiveTab = this.membershipIdOfActiveTab;
      var allContactPromiseArray = [];

      this.api.contacts.getPaged.get({ // Is this required ? -AD
        mId: this.context.currentRole.membershipId,
        page: page,
        pageSize: pageSize
      }).$promise.then(function (response) {
        if (response.type > 0) {

          _this2.app.clinician.people.results = {
            items: response.payload.items,
            page: page,
            pageSize: pageSize,
            totalItems: response.payload.totalItems
          };
          scope.contactList = _this2.app.clinician.people.results.items;
        } else {

          //this.app.popup("Error", "Sorry, an error has occurred and we cannot continue. Please try again later.", 'Close');
        }
      }).catch(function (response) {

        // this.app.popup("Error", "Sorry, an error has occurred and we cannot continue. Please try again later.", 'Close');
      });

      var validProfiles = this.howManytabsToShow();

      var _loop = function _loop(i) {

        // if(validProfiles[i].title && validProfiles[i].title.toUpperCase() === 'ENTERPRISE')
        // continue; // - this is the Enterprise Profile. We don't show enterprise Profile details

        var currentRole = validProfiles[i];

        var formattedOrganizationName = validProfiles[i].formattedOrganizationName;

        var currentMembershipId = validProfiles[i].membershipId;

        var currentRoleOrgId = validProfiles[i].orgId;

        if (!membershipIdOfActiveTab && currentMembershipId === _this2.context.currentRole.membershipId) // - executed on page load
          _this2.selectedContactsTabIndex = i;

        if (membershipIdOfActiveTab && currentMembershipId === membershipIdOfActiveTab) //executed when user is on a Tab after page load
          _this2.selectedContactsTabIndex = i;

        var orgMembersPromise = _this2.api.contacts.getUsersInOrg.get({
          mId: currentMembershipId,
          orgId: currentRoleOrgId
        }).$promise.then(function (response) {
          if (response.type > 0) {
            if (response.payload) {
              var personIDList = [];
              for (var t = 0; t < response.payload.length; t++) {
                personIDList.push(response.payload[t].user.personId);
              }
              scope.orgMembers[currentMembershipId] = personIDList;
            }
          }
        }).catch();

        var contactPromise = _this2.api.contacts.getPaged.get({
          mId: currentMembershipId,
          page: page,
          pageSize: pageSize
        }).$promise.then(function (response) {
          if (response.type > 0) {

            scope.contactMap[currentMembershipId] = response.payload.items;

            var mapOfNamesToSearch = [];

            for (var i = 0; i < response.payload.items.length; i++) {

              if (response.payload.items[i].personId.toUpperCase() === _this2.context.user.personId.toUpperCase()) {
                response.payload.items[i].isMyContact = true;
              }

              var name = '';

              if (response.payload.items[i].firstname) name = name.concat(response.payload.items[i].firstname + ' ');
              if (response.payload.items[i].lastname) name = name.concat(response.payload.items[i].lastname + ' ');
              if (response.payload.items[i].middleNames) name = name.concat(response.payload.items[i].middleNames + ' ');

              var _searchableObjects = {
                fullName: name,
                id: response.payload.items[i].id,
                formattedOrganizationName: formattedOrganizationName,
                profession: ''
              };

              if (response.payload.items[i].profession && response.payload.items[i].profession.length > 0) _searchableObjects.profession = response.payload.items[i].profession;

              mapOfNamesToSearch.push(_searchableObjects);
              //scope.allMyContacts.push(_searchableObjects);
            }

            scope.quickSearchMap[currentMembershipId] = mapOfNamesToSearch;
          }
        }).catch();

        allContactPromiseArray.push(contactPromise);
        allContactPromiseArray.push(orgMembersPromise);
        //-Rest call for Groups

        var groupContactPromise = _this2.api.contacts.getGroups.get({
          mId: currentMembershipId,
          page: page,
          pageSize: pageSize
        }).$promise.then(function (response) {
          if (response.type > 0) {
            var existingGroup = scope.contactMap['groupContact'];

            //Add membershipId to Groups as Rest API is not sending them.

            var modifiedPayload;

            if (response && response.payload) {
              modifiedPayload = [];
              if (response.payload.length > 1) {
                response.payload.sort(function (a, b) {
                  return b.aliasName.localeCompare(a.aliasName);
                });
              }
              for (var x = 0; x < response.payload.length; x++) {
                response.payload[x].membershipId = currentMembershipId;
                response.payload[x].role = currentRole;
                modifiedPayload.push(response.payload[x]);
              }
            }

            if (existingGroup) {
              //- merge all group contacts into one as there is only one Group Page
              var mergedGroup = existingGroup.concat(modifiedPayload);
              scope.contactMap['groupContact'] = mergedGroup;
            } else {
              //- Load contacts into one key named 'groupContact'
              if (modifiedPayload && modifiedPayload.length > 0) {
                scope.contactMap['groupContact'] = modifiedPayload;
              }
            }
          }
        }).catch();

        allContactPromiseArray.push(groupContactPromise);
      };

      for (var i = 0; i < validProfiles.length; i++) {
        _loop(i);
      }

      if (allContactPromiseArray.length > 0) {
        this.$q.all(allContactPromiseArray).then(function () {

          if (scope.contactMap['groupContact'] && scope.contactMap['groupContact'].length > 0) {
            scope.contactMap['groupContact'].reverse(); //Reverse groups - they should be shown in LIFO

            /*  Code fix to stop displaying duplicate groups Start */
            var groupsUnsorted = scope.contactMap['groupContact'];
            var newArray = [];
            var lookupObject = {};

            for (var i in groupsUnsorted) {
              lookupObject[groupsUnsorted[i]['aliasKey']] = groupsUnsorted[i];
            }
            for (i in lookupObject) {
              newArray.push(lookupObject[i]);
            }
            scope.contactMap['groupContact'] = newArray;
            /*  Code fix to stop displaying duplicate groups End */
            scope.thereAreNoGroups = false;
          }

          if (scope.contactMap) {
            for (var x = 0; x < validProfiles.length; x++) {
              var contactsByProfile = scope.contactMap[validProfiles[x].membershipId];
              var orgMembersByProfile = scope.orgMembers[validProfiles[x].membershipId];

              for (var y = 0; y < contactsByProfile.length; y++) {
                var personIDofInterest = contactsByProfile[y].personId;
                for (var z = 0; z < orgMembersByProfile.length; z++) {
                  if (orgMembersByProfile[z] === personIDofInterest) {
                    contactsByProfile[y].isInternalContact = true;
                    break;
                  }
                }
                //if(!contactsByProfile[y].isExternalContact)  contactsByProfile[y].isExternalContact = false;
              }
            }
          }

          scope.isLoadContactsAndGroupsComplete = true;

          scope.contactMap;
        });
      } else {
        scope.isLoadContactsAndGroupsComplete = true;
        scope.noContacts = true;
        return;
      }
    }
  }, {
    key: 'createCase',
    value: function createCase(contact) {
      this.$state.go('app.user.casecreation', { contactId: contact.id });
    }
  }, {
    key: 'getOrganization',
    value: function getOrganization(contact) {
      if (contact && contact.availability) {
        var organisationId = contact.availability[0].organisationId;
        if (organisationId) {
          for (var i = 0; i < this.context.roles.length; i++) {
            var role = this.context.roles[i];
            if (role.orgId === organisationId) {
              // var isPersonalProfile = role && role.orgDisplayName.toUpperCase().includes('PRACTICE OF');
              var isPersonalProfile = role && role.orgDisplayName.toUpperCase().indexOf('PRACTICE OF') >= 0;
              if (isPersonalProfile) {
                return 'Personal Account';
              } else {
                return role.orgDisplayName;
              }
            }
          }
        }
      }
    }
  }, {
    key: 'isThisMyPersonalAccount',
    value: function isThisMyPersonalAccount(contact) {
      if (contact) {
        var organisationId = contact.availability[0].organisationId;
        if (organisationId) {
          for (var i = 0; i < this.context.roles.length; i++) {
            var role = this.context.roles[i];
            if (role.orgId === organisationId) {
              var localStorage = this.localStorageService.get('authorizationData');
              if (localStorage.userName.toUpperCase() === role.domain.toUpperCase()) return true;
            }
          }
        }
      }
      return false;
    }

    /** Refresh only when user clicks a profile that he does not own to synchronization  **/

  }, {
    key: 'individualProfileTabClicked',
    value: function individualProfileTabClicked(membershipId) {
      this.membershipIdOfActiveTab = membershipId; //This helps to keep track of active profile as we are showing all profiles now and the concept of currentProfile is obsolete

      if (this.membershipIdOfActiveTab && this.$scope.contactMap && this.$scope.contactMap[this.membershipIdOfActiveTab] && this.$scope.contactMap[this.membershipIdOfActiveTab].searchTerm) {
        this.$scope.contactMap[this.membershipIdOfActiveTab].searchTerm = '';
      }

      /** Commenting this in the interest of performance
       for(var i =0 ; i < this.context.roles.length ; i++){
         var role = this.context.roles[i];
         if(role && role.membershipId === membershipId)
            if(role.orgDisplayName.toUpperCase().indexOf('PRACTICE OF') < 0)
                 this.loadPage(1, 20, this.$scope);
       }
       **/
    }
  }, {
    key: 'groupTabClicked',
    value: function groupTabClicked() {
      if (this.$scope.contactMap && this.$scope.contactMap['groupContact'] && this.$scope.contactMap['groupContact'].searchTerm) {
        this.$scope.contactMap['groupContact'].searchTerm = '';
      }
      //this.loadPage(1, 20, this.$scope); - Not required as this is personal and wont require synchronization
    }

    /** API call to delete Single Contact**/

  }, {
    key: 'deleteIndividualContact',
    value: function deleteIndividualContact(contact) {

      if (!contact) return;

      this.$mdSidenav('viewContact').close();

      var appropriateMembershipId = this.userService.getAppropriateMembershipId(this.membershipIdOfActiveTab);

      var contactToDelete = {
        mId: appropriateMembershipId,
        id: contact.id
      };

      var nameOfContactToDelete = "";
      if (contact.title) nameOfContactToDelete = nameOfContactToDelete.concat(contact.title + ' ');
      if (contact.firstname) nameOfContactToDelete = nameOfContactToDelete.concat(contact.firstname + ' ');
      if (contact.middleNames) nameOfContactToDelete = nameOfContactToDelete.concat(contact.middleNames + ' ');
      if (contact.lastname) nameOfContactToDelete = nameOfContactToDelete.concat(contact.lastname + ' ');

      var _self = this;

      _self.swangular.swal({
        title: 'Delete Contact',
        html: 'Do you want to delete <strong>' + nameOfContactToDelete + '</strong> from your contact list ?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        focusConfirm: false
      }).then(function (result) {
        if (result.value) {
          _self.$resource(apiBasePath + 'Contact').delete(contactToDelete).$promise.then(function (response) {
            if (response.type > 0) {
              _self.$analytics.eventTrack('Click', { category: 'Button', label: 'contact-deleted-successfully' });
              _self.$scope.searchTerm = "";

              var currentContactsArray = _self.$scope.contactMap[_self.membershipIdOfActiveTab];

              var prunedContacts = [];
              if (currentContactsArray) {
                for (var i = 0; i < currentContactsArray.length; i++) {
                  if (currentContactsArray[i].id !== contactToDelete.id) {
                    prunedContacts.push(currentContactsArray[i]);
                  }
                }
              }
              _self.$scope.contactMap[_self.membershipIdOfActiveTab] = prunedContacts;

              currentContactsArray = _self.$scope.quickSearchMap[_self.membershipIdOfActiveTab]; //- Clean the search map used by chips

              prunedContacts = [];
              if (currentContactsArray) {
                for (var j = 0; j < currentContactsArray.length; j++) {
                  if (currentContactsArray[j].id !== contactToDelete.id) {
                    prunedContacts.push(currentContactsArray[j]);
                  }
                }
              }
              _self.$scope.quickSearchMap[_self.membershipIdOfActiveTab] = prunedContacts;
            } else {
              //console.log("Failed to delete contact");
              _self.swangular.swal({
                type: 'error',
                title: '',
                html: 'Failed to delete contact.Please contact <a href="mailto:support@clinivid.com.au">Support</a>'
              });
              _self.$analytics.eventTrack('Click', { category: 'Button', label: 'contact-delete-failure' });
            }
          }).catch(function () {
            _self.swangular.swal({
              type: 'error',
              title: '',
              html: 'Failed to delete contact.Please contact <a href="mailto:support@clinivid.com.au">Support</a>'
            });
            _self.$analytics.eventTrack('Click', { category: 'Button', label: 'contact-delete-failure' });
          });
        }
      });
    }

    /**  API call to delete Group **/

  }, {
    key: 'deleteGroup',
    value: function deleteGroup(group) {

      var _self = this;

      /** This  is a hack as we CAN-ONLY add contact by membership of  org-owner or admin ,else it must be a personal account **/
      var membershipIdToDeleteGroup = void 0;
      var isMembershipIdSet = false;
      var activeTabRole = void 0;
      for (var i = 0; i < this.context.roles.length; i++) {
        // Logic to determine if its a personal Account
        var role = this.context.roles[i];
        if (role.membershipId === group.membershipId) {
          //-Assuming  Add Contact button is showed for  genuine Personal Accounts- i am not putting extra checks
          activeTabRole = role; // Active Tab Role is set here
          if (role.orgDisplayName.toUpperCase().indexOf('PRACTICE OF') >= 0) {
            membershipIdToDeleteGroup = group.membershipId;
            isMembershipIdSet = true;
            break;
          }
        }
      }

      //-lets determine the membershipId of the Admin or Org-owner and add by that as backend will error out else
      if (!isMembershipIdSet) {
        for (var _i7 = 0; _i7 < this.context.roles.length; _i7++) {
          // Logic to determine user has Admin or OrgRole
          var tempRole = this.context.roles[_i7];
          if (activeTabRole && activeTabRole.orgId === tempRole.orgId) {
            if (tempRole.name === 'OrgOwner' || tempRole.name === 'OfficeAdmin') {
              membershipIdToDeleteGroup = tempRole.membershipId;
              break;
            }
          }
        }
      }

      var deleteData = {
        mId: membershipIdToDeleteGroup,
        aliasId: group.aliasKey

      };

      var groupId2Remove = group.aliasKey;

      _self.swangular.swal({
        title: 'Delete Group',
        html: 'Do you want to delete the group <strong>' + group.aliasName + '</strong>?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        focusConfirm: false
      }).then(function (result) {
        if (result.value) {

          _self.showModalSpinner(_self);

          _self.$resource(apiBasePath + 'Contact/DeleteAlias').delete(deleteData).$promise.then(function (response) {
            if (response.type > 0) {
              _self.$analytics.eventTrack('Click', { category: 'Button', label: 'group-deleted-successfully' });

              if (_self.$scope.contactMap['groupContact']) {
                _self.$scope.contactMap['groupContact'].searchTerm = ""; //resetting search text

                var prunedGroups = [];
                for (var i = 0; i < _self.$scope.contactMap['groupContact'].length; i++) {
                  if (_self.$scope.contactMap['groupContact'][i].aliasKey !== groupId2Remove) {

                    prunedGroups.push(_self.$scope.contactMap['groupContact'][i]);
                  }
                }

                _self.$scope.contactMap['groupContact'] = prunedGroups;
              }
              _self.$mdSidenav('viewGroup').close();

              _self.$mdDialog.hide();
            } else {
              _self.$mdDialog.hide();
              _self.swangular.swal({
                type: 'error',
                title: '',
                html: 'Failed to delete group.Please contact <a href="mailto:support@clinivid.com.au">Support</a>'
              });

              _self.$analytics.eventTrack('Click', { category: 'Button', label: 'group-delete-failure' });
              _self.isDeleteGroupFail = true;
            }
          }).catch(function () {
            _self.$mdDialog.hide();
            _self.$analytics.eventTrack('Click', { category: 'Button', label: 'group-delete-failure' });
            _self.isDeleteGroupFail = true;
            _self.swangular.swal({
              type: 'error',
              title: '',
              html: 'Failed to delete group.Please contact <a href="mailto:support@clinivid.com.au">Support</a>'
            });
          });
        }
      });
    }

    /**  Show group members sorted */

  }, {
    key: 'getSortedGroupMembers',
    value: function getSortedGroupMembers(selectedGroup) {

      if (selectedGroup.groupMembers && selectedGroup.groupMembers.length > 0) {
        selectedGroup.groupMembers.sort(function (a, b) {
          return a.lastName.localeCompare(b.lastName);
        });
      }
      return selectedGroup.groupMembers;
    }

    /** Add New Contact Code **/

  }, {
    key: 'phoneNumberRegex',
    value: function phoneNumberRegex() {

      var regex = void 0;

      if (this.newContactForm.countryCode === 'AU') {
        regex = '^(04|#04|#4)[0-9]{8}$';
      }
      //  else if (this.newContactForm.countryCode === 'PH'){
      //    regex = '(\+?\d{2}?\s?\d{3}\s?\d{3}\s?\d{4})|([0]\d{3}\s?\d{3}\s?\d{4})';
      //  }
      else if (this.newContactForm.countryCode === 'NZ') {
          regex = '^#?(02|2)[0-9]{7,8}$';
        } else if (this.newContactForm.countryCode === 'IN') {
          regex = '^(#?)[7-9][0-9]{9}$';
        }

      return regex;
    }

    /** This function checks if Phone number OR Email is a existing user of New User **/

  }, {
    key: 'checkPhoneNumber',
    value: function checkPhoneNumber() {
      var _this3 = this;

      var userMode = this.$scope.addContactMode;
      this.$scope.addContactReadOnlyMode = true;
      if (userMode == 'PHONE') {
        this.$scope.nextButtonCheckPhoneNumberShow = false;
        this.checkinPhoneNumberInProgres = true;
        this.isAddContactinProgress = true;

        //- check if contact is ALREADY in your list
        var allContactsNumbers = {};

        var allContacts = this.$scope.contactMap[this.membershipIdOfActiveTab];

        if (allContacts) {
          for (var i = 0; i < allContacts.length; i++) {
            if (allContacts[i].mobile) {

              if (allContacts[i].availability) {
                allContactsNumbers[allContacts[i].mobile] = allContacts[i].availability;
              } else {
                allContactsNumbers[allContacts[i].mobile] = null;
              }
            }
          }
        }

        var allNumbers = Object.keys(allContactsNumbers);
        if (allNumbers) {
          for (var x = 0; x < allNumbers.length; x++) {
            if (allNumbers[x].indexOf(this.newContactForm.phoneNumber) > -1) {
              this.doesContactAlreadyexist = true;
              this.checkinPhoneNumberInProgres = false;
              return;
            }
          }
        }

        var newContactForm = this.newContactForm;
        var _self = this;

        var requestPayload = {
          'email': null,
          'mobile': newContactForm.phoneNumber,
          'region': newContactForm.countryCode
        };

        this.$resource(apiBasePath + 'User/Search?mId=' + this.membershipIdOfActiveTab).get(requestPayload).$promise.then(function (response) {
          _this3.checkinPhoneNumberInProgres = false;

          if (response.type >= 0) {
            if (response.payload.email) delete response.payload.email;
            newContactForm.systemCheckForPhoneNumber = response.payload;
            newContactForm.systemCheckForPhoneNumber.mobile = newContactForm.phoneNumber;
          } else {
            _self.isContactNewUser = true;
          }
        });
      } else if (userMode == 'EMAIL') {
        this.$scope.nextButtonCheckPhoneNumberShow = false;
        this.checkinPhoneNumberInProgres = true;
        this.isAddContactinProgress = true;

        var _newContactForm = this.newContactForm;
        var _self2 = this;

        var emailOfAllYourContacts = [];
        var _allContacts = this.$scope.contactMap[this.membershipIdOfActiveTab];

        if (_allContacts) {
          for (var _i8 = 0; _i8 < _allContacts.length; _i8++) {
            if (_allContacts[_i8].email) {
              emailOfAllYourContacts.push(_allContacts[_i8].email);
            }
          }
        }

        if (emailOfAllYourContacts) /** Check if a mobile number already exists **/
          for (var _x = 0; _x < emailOfAllYourContacts.length; _x++) {
            if (emailOfAllYourContacts[_x] === _newContactForm.email) {
              this.doesContactAlreadyexist = true;
              this.checkinPhoneNumberInProgres = false;
              return;
            }
          }

        var requestPayload = {
          'email': _newContactForm.email
        };

        this.$resource(apiBasePath + 'User/Search?mId=' + this.membershipIdOfActiveTab).get(requestPayload).$promise.then(function (response) {
          _this3.checkinPhoneNumberInProgres = false;

          if (response.type >= 0) {
            if (response.payload.mobile) delete response.payload.mobile;
            _newContactForm.systemCheckForPhoneNumber = response.payload;
            //newContactForm.systemCheckForPhoneNumber.mobile = newContactForm.phoneNumber; ? What to do
          } else {
            _self2.isContactNewUser = true;
          }
        });
      }
    }
  }, {
    key: 'closeAddContact',
    value: function closeAddContact() {
      this.$mdSidenav('addContact').close();
    }

    /**  Open Side Nav to allow users to Add a new Contact START **/

  }, {
    key: 'openAddContact',
    value: function openAddContact() {
      this.cancelContactAdd();
      this.$mdSidenav('addContact').toggle();
    }

    /** Connect with a clinivid user who is not in your list **/

  }, {
    key: 'connectWithClinividUser',
    value: function connectWithClinividUser(contact) {
      if (!contact) return;

      var contactName = this.extractName(contact);

      this.$mdSidenav('addContact').close();
      var _self = this;

      /** This  is a hack as we CAN-ONLY add contact by membership of  org-owner or admin ,else it must be a personal account **/
      var membershipIdToAddContact = void 0;
      var isMembershipIdSet = false;
      var activeTabRole = void 0;
      for (var i = 0; i < this.context.roles.length; i++) {
        // Logic to determine if its a personal Account
        var role = this.context.roles[i];
        if (role.membershipId === this.membershipIdOfActiveTab) {
          //-Assuming  Add Contact button is showed for  genuine Personal Accounts- i am not putting extra checks
          activeTabRole = role; // Active Tab Role is set here
          if (role.orgDisplayName.toUpperCase().indexOf('PRACTICE OF') >= 0) {
            membershipIdToAddContact = this.membershipIdOfActiveTab;
            isMembershipIdSet = true;
            break;
          }
        }
      }

      //-lets determine the membershipId of the Admin or Org-owner and add by that as backend will error out else
      if (!isMembershipIdSet) {
        for (var _i9 = 0; _i9 < this.context.roles.length; _i9++) {
          // Logic to determine user has Admin or OrgRole
          var tempRole = this.context.roles[_i9];
          if (activeTabRole && activeTabRole.orgId === tempRole.orgId) {
            if (tempRole.name === 'OrgOwner' || tempRole.name === 'OfficeAdmin') {
              membershipIdToAddContact = tempRole.membershipId;
              break;
            }
          }
        }
      }

      this.$resource(apiBasePath + 'Contact/Connect?mId=' + membershipIdToAddContact).save(contact).$promise.then(function (response) {
        if (response.type >= 1) {
          _self.loadPage(1, 100, _self.$scope);

          _self.swangular.swal('Contact Added', 'Contact <strong> ' + contactName + '</strong> has been added to your contact list.', 'success');
        } else {
          if (response.type == -23 || response.type == -25) {

            if (response.type == -23 && response.message.toLowerCase().includes('contact already exists')) {
              _self.swangular.swal({
                type: 'info',
                title: 'Contact already exists',
                html: 'This person already exists in your contact list.' + 'You cannot add a contact more than once'
              });
            } else {
              _self.swangular.swal({
                type: 'error',
                title: 'Failed to add contact',
                html: response.message
              });
            }
          } else {
            _self.swangular.swal({
              type: 'error',
              title: 'Failed to add contact',
              html: 'Please contact support'
            });
          }
        }
      });
    }
  }, {
    key: 'cancelContactAdd',
    value: function cancelContactAdd() {
      this.doesContactAlreadyexist = false;
      this.isContactNewUser = false;
      this.checkinPhoneNumberInProgres = false;
      this.isAddContactinProgress = false;
      this.$scope.nextButtonCheckPhoneNumberShow = true;
      this.newContactForm = {};
      this.$scope.addContactMode = 'PHONE';
      this.$document[0].getElementById('addByMobileNumber').checked = true;
      this.$document[0].getElementById('addByEmail').checked = false;
      this.newContactForm.countryCode = 'AU';
    }
  }, {
    key: 'resetAddContactForm',
    value: function resetAddContactForm() {
      this.doesContactAlreadyexist = false;
      this.isContactNewUser = false;
      this.checkinPhoneNumberInProgres = false;
      this.isAddContactinProgress = false;
      this.$scope.nextButtonCheckPhoneNumberShow = true;
      this.newContactForm = {};
      var currentMode = this.$scope.addContactMode;
      if (currentMode === 'PHONE') {
        this.$document[0].getElementById('addByMobileNumber').checked = true;
        this.$document[0].getElementById('addByEmail').checked = false;
      }
      if (currentMode === 'EMAIL') {
        this.$document[0].getElementById('addByMobileNumber').checked = false;
        this.$document[0].getElementById('addByEmail').checked = true;
      }

      this.newContactForm.countryCode = 'AU';
    }

    /** Saves a new Ccntact  that does not exist on Clinivid **/

  }, {
    key: 'saveYourNewClinividContact',
    value: function saveYourNewClinividContact() {

      var _self = this;
      var newContactName = "";

      if (this.newContactForm.title) newContactName = newContactName.concat(this.newContactForm.title + ' ');
      if (this.newContactForm.firstname) newContactName = newContactName.concat(this.newContactForm.firstname + ' ');
      if (this.newContactForm.lastname) newContactName = newContactName.concat(this.newContactForm.lastname);

      var requestPayLoadMobile = {
        title: this.newContactForm.title,
        firstname: this.newContactForm.firstname,
        lastname: this.newContactForm.lastname,
        profession: this.newContactForm.profession,
        mobile: this.newContactForm.phoneNumber,
        region: this.newContactForm.countryCode
      };

      var requestPayLoadEmail = {
        title: this.newContactForm.title,
        firstname: this.newContactForm.firstname,
        lastname: this.newContactForm.lastname,
        profession: this.newContactForm.profession,
        email: this.newContactForm.email
      };

      var requestPayLoad = void 0;
      if (this.$scope.addContactMode == 'PHONE') requestPayLoad = requestPayLoadMobile;else if (this.$scope.addContactMode == 'EMAIL') requestPayLoad = requestPayLoadEmail;

      /** This  is a hack as we CAN-ONLY add contact by membership of  org-owner or admin ,else it must be a personal account **/
      var membershipIdToAddContact = void 0;
      var isMembershipIdSet = false;
      var activeTabRole = void 0;
      for (var i = 0; i < this.context.roles.length; i++) {
        // Logic to determine if its a personal Account
        var role = this.context.roles[i];
        if (role.membershipId === this.membershipIdOfActiveTab) {
          //-Assuming  Add Contact button is showed for  genuine Personal Accounts- i am not putting extra checks
          activeTabRole = role; // Active Tab Role is set here
          if (role.orgDisplayName.toUpperCase().indexOf('PRACTICE OF') >= 0) {
            membershipIdToAddContact = this.membershipIdOfActiveTab;
            isMembershipIdSet = true;
            break;
          }
        }
      }

      //-lets determine the membershipId of the Admin or Org-owner and add by that as backend will error out else
      if (!isMembershipIdSet) {
        for (var _i10 = 0; _i10 < this.context.roles.length; _i10++) {
          // Logic to determine user has Admin or OrgRole
          var tempRole = this.context.roles[_i10];
          if (activeTabRole && activeTabRole.orgId === tempRole.orgId) {
            if (tempRole.name === 'OrgOwner' || tempRole.name === 'OfficeAdmin') {
              membershipIdToAddContact = tempRole.membershipId;
              break;
            }
          }
        }
      }

      this.$resource(apiBasePath + 'Contact?mId=' + membershipIdToAddContact).save(requestPayLoad).$promise.then(function (response) {

        _self.loadPage(1, 100, _self.$scope);
        _self.$mdSidenav('addContact').close();

        if (response.type > 0) {
          _self.swangular.swal('New contact added', "New contact <strong>" + newContactName + "</strong> has been successfully added to your profile", 'success');
        } else {
          _self.swangular.swal({
            type: 'error',
            title: 'Failed to add contact',
            html: "Your current profile doesn't give you the permission to add new contacts"
          });
        }
      }).catch(function () {

        _self.$analytics.eventTrack('Click', { category: 'Button', label: 'save-contact-failure' });

        _self.swangular.swal({
          type: 'error',
          title: 'Failed to add contact',
          html: "Please contact support"
        });
      });
    }

    /** Toggle the Edit Button and display edit section on view Cntact side-Nav **/

  }, {
    key: 'editYourNewClinividContact',
    value: function editYourNewClinividContact(selectedContact) {

      /** Redirect to Profile Page to edit Details  **/
      if (selectedContact && selectedContact.isMyContact) {
        this.$state.go('app.user.profile', { fromContactsPage: true });
      }

      this.editUnlinkedContact = {};
      this.editUnlinkedContact.title = selectedContact.title;
      this.editUnlinkedContact.firstname = selectedContact.firstname;
      this.editUnlinkedContact.lastname = selectedContact.lastname;
      this.editUnlinkedContact.profession = selectedContact.profession;
      this.editUnlinkedContact.mobile = selectedContact.mobile;
      this.editUnlinkedContact.region = selectedContact.region;
      this.editUnlinkedContact.id = selectedContact.id;

      this.toggleEditUnlinkedContact();
    }
  }, {
    key: 'saveChangesInUnlinkedClinividContact',
    value: function saveChangesInUnlinkedClinividContact() {

      var _self = this;

      var newContactName = "";

      if (this.newContactForm.title) newContactName = newContactName.concat(this.newContactForm.title + ' ');
      if (this.newContactForm.firstname) newContactName = newContactName.concat(this.newContactForm.firstname + ' ');
      if (this.newContactForm.lastname) newContactName = newContactName.concat(this.newContactForm.lastname);

      this.$resource(apiBasePath + 'Contact?mId=' + this.membershipIdOfActiveTab, null, { 'update': { method: 'PUT' } }).update(this.editUnlinkedContact).$promise.then(function (response) {

        _self.$mdSidenav('viewContact').close();

        if (response.type > 0) {
          _self.$analytics.eventTrack('Click', { category: 'Button', label: 'update-contact-success' });
          _self.loadPage(1, 100, _self.$scope);

          _self.swangular.swal('Contact details updated', "Contact <strong>" + newContactName + "</strong> has been successfully updated", 'success');
        } else {
          _self.$analytics.eventTrack('Click', { category: 'Button', label: 'update-contact-failure' });
          _self.swangular.swal({
            type: 'error',
            title: 'Contact updated failed',
            html: "Failed to update contact. Please contact support"
          });
        }
      }).catch(function (response) {
        _self.$mdSidenav('viewContact').close();
        _self.swangular.swal({
          type: 'error',
          title: 'Contact updated failed',
          html: "Failed to update contact. Please contact support"
        });

        _self.$analytics.eventTrack('Click', { category: 'Button', label: 'update-contact-failure' });
      });
    }
  }, {
    key: 'toggleEditUnlinkedContact',
    value: function toggleEditUnlinkedContact() {
      this.showEditUnlinkedContactSection = !this.showEditUnlinkedContactSection;

      this.doEditUnlinkedContact = !this.doEditUnlinkedContact;

      if (this.doEditUnlinkedContact == true) {
        var icon = this.$document[0].getElementById('editUnlinkedContactIcon');
        if (icon) icon.style.color = 'white';

        var enclosingDiv = this.$document[0].getElementById('editUnlinkedContactEnclosingDiv');
        if (enclosingDiv) enclosingDiv.style.backgroundColor = '#92298D';
      } else {
        var icon = this.$document[0].getElementById('editUnlinkedContactIcon');
        if (icon) icon.style.color = '#92298D';

        var enclosingDiv = this.$document[0].getElementById('editUnlinkedContactEnclosingDiv');
        if (enclosingDiv) enclosingDiv.style.backgroundColor = 'white';
      }
    }

    /** generic code to extract full name by combining title firstName middlename and last name **/

  }, {
    key: 'extractName',
    value: function extractName(_object) {
      var fullName = '';

      if (_object.title) fullName = fullName.concat(_object.title + ' ');
      if (_object.firstname) fullName = fullName.concat(_object.firstname + ' ');
      if (_object.middleNames) fullName = fullName.concat(_object.middleNames + ' ');
      if (_object.lastname) fullName = fullName.concat(_object.lastname + ' ');

      return fullName;
    }
  }, {
    key: 'isContactAvailable',
    value: function isContactAvailable(contact) {
      if (contact && contact.availability && contact.availability[0]) {
        if (contact.availability[0].status === 1 && contact.isLinked) {
          return true;
        } else return false;
      }
    }
  }, {
    key: 'clearGroupName',
    value: function clearGroupName() {
      this.$scope.newGroupName = '';
    }
  }, {
    key: 'changeGroupName',
    value: function changeGroupName(selectedGroup) {

      var _self = this;
      var existingGroupMembers = selectedGroup.groupMembers;
      var newGroupName = this.$scope.newGroupName;
      var currentRole = this.context.currentRole;

      /**  Check if group Name already exists **/
      if (this.$scope.contactMap['groupContact']) {
        for (var i = 0; i < this.$scope.contactMap['groupContact'].length; i++) {
          if (this.$scope.contactMap['groupContact'][i].membershipId === this.membershipIdOfActiveTab) {
            this.$scope.contactMap['groupContact'][i];
          }
        }
      }

      if (newGroupName) {
        if (this.$scope.contactMap['groupContact']) {
          for (var _i11 = 0; _i11 < this.$scope.contactMap['groupContact'].length; _i11++) {
            if (this.$scope.contactMap['groupContact'][_i11].membershipId === this.membershipIdOfActiveTab) {
              if (this.$scope.contactMap['groupContact'][_i11].aliasName === newGroupName) {
                _self.$mdSidenav('viewGroup').close();
                _self.swangular.swal({
                  type: 'error',
                  title: 'Error Updating Group name',
                  html: 'A group with this name already exists.'
                });
                return;
              }
            }
          }
        }
      }

      /** Hack to find membership-ID  Start **/
      var membershipIdToAddContact = void 0;
      var isMembershipIdSet = false;
      var activeTabRole = void 0;
      for (var _i12 = 0; _i12 < this.context.roles.length; _i12++) {
        // Logic to determine if its a personal Account
        var role = this.context.roles[_i12];
        if (role.membershipId === this.membershipIdOfActiveTab) {
          //-Assuming  Add Contact button is showed for  genuine Personal Accounts- i am not putting extra checks
          activeTabRole = role; // Active Tab Role is set here
          if (role.orgDisplayName.toUpperCase().indexOf('PRACTICE OF') >= 0) {
            membershipIdToAddContact = this.membershipIdOfActiveTab;
            isMembershipIdSet = true;
            break;
          }
        }
      }

      if (!isMembershipIdSet) {
        for (var _i13 = 0; _i13 < this.context.roles.length; _i13++) {
          // Logic to determine user has Admin or OrgRole
          var tempRole = this.context.roles[_i13];
          if (activeTabRole && activeTabRole.orgId === tempRole.orgId) {
            if (tempRole.name === 'OrgOwner' || tempRole.name === 'OfficeAdmin') {
              membershipIdToAddContact = tempRole.membershipId;
              break;
            }
          }
        }
      }
      /** Hack to find membership-ID  End **/

      _self.showModalSpinner(_self);

      this.$http({ // - Rest Call to create a duplicate group with same name
        url: apiBasePath + 'Contact/CreateAlias?mId=' + membershipIdToAddContact,
        method: 'POST',
        data: { aliasName: newGroupName },
        //data: '"' + newGroupName + '"',
        headers: { 'Content-Type': 'application/json' }
      }).then(function (response) {

        if (response.data.type > 0) {
          /** Add Group  to local map  START **/
          var groupContacts = _self.$scope.contactMap['groupContact'];
          var cloneGroupContacts = [];

          for (var z = 0; z < groupContacts.length; z++) {
            if (groupContacts[z].aliasKey !== selectedGroup.aliasKey) {
              cloneGroupContacts.push(groupContacts[z]);
            }
          }

          groupContacts = cloneGroupContacts;

          var newlyAddedGroup = {};
          newlyAddedGroup['aliasKey'] = response.data.payload;
          newlyAddedGroup['aliasName'] = newGroupName;
          newlyAddedGroup['membershipId'] = _self.membershipIdOfActiveTab;
          newlyAddedGroup.role = currentRole;

          if (groupContacts) {
            groupContacts.unshift(newlyAddedGroup); //- Add the New Group on Top of the list of Group LIFO
            _self.$scope.contactMap['groupContact'] = groupContacts;
          } else {
            _self.$scope.contactMap['groupContact'] = [];
            _self.$scope.contactMap['groupContact'].push(newlyAddedGroup);
          }
          /** Add Group  to local map  END **/

          /** Replicate Contacts START **/
          if (existingGroupMembers && existingGroupMembers.length > 0) {
            var contactIdz = [];

            for (var i = 0; i < existingGroupMembers.length; i++) {
              contactIdz.push(existingGroupMembers[i].contactId);
            }

            var data = {
              AliasKey: response.data.payload,
              ContactList: contactIdz
            };

            _self.$http.put(apiBasePath + 'Contact/AddContactToAlias?mId=' + membershipIdToAddContact, data).then(function (response) {

              var deleteData = {
                mId: membershipIdToAddContact,
                aliasId: selectedGroup.aliasKey
              };

              _self.$resource(apiBasePath + 'Contact/DeleteAlias').delete(deleteData).$promise.then(function (response) {
                if (response.type > 0) {
                  _self.$mdDialog.hide();
                  _self.$mdSidenav('viewGroup').close();
                  _self.swangular.swal('Group Updated', 'Group name has been successfully updated.', 'success');
                }
              }).catch(function () {
                _self.$mdDialog.hide();
                _self.$mdSidenav('viewGroup').close();
              });
            }).error(function () {
              _self.$mdDialog.hide();
              _self.$mdSidenav('viewGroup').close();
              _self.swangular.swal({
                type: 'error',
                title: 'Error Updating Group name',
                html: 'Failed to update group name.'
              });
            });
          } else {

            var deleteData = {
              mId: membershipIdToAddContact,
              aliasId: selectedGroup.aliasKey
            };

            _self.$resource(apiBasePath + 'Contact/DeleteAlias').delete(deleteData).$promise.then(function (response) {
              if (response.type > 0) {
                _self.$mdDialog.hide();
                _self.$mdSidenav('viewGroup').close();
                _self.swangular.swal('Group Updated', 'Group name has been successfully updated.', 'success');
              }
            }).catch(function () {
              _self.$mdDialog.hide();
              _self.$mdSidenav('viewGroup').close();
            });
          }
        } else {
          _self.$mdDialog.hide();
          _self.$mdSidenav('viewGroup').close();
          _self.swangular.swal({
            type: 'error',
            title: 'Error Updating Group name',
            html: 'Failed to update group name.'
          });
        }
      }).error(function () {
        _self.$mdDialog.hide();
        _self.$mdSidenav('viewGroup').close();
        _self.swangular.swal({
          type: 'error',
          title: 'Error Updating Group name',
          html: 'Failed to update group name.'
        });
      });
    }
  }, {
    key: 'cancelGroupNameChange',
    value: function cancelGroupNameChange() {
      this.$scope.editingGroupNameInProgress = false;
    }
  }, {
    key: 'editGroupName',
    value: function editGroupName() {
      this.$scope.editingGroupNameInProgress = true;
    }
  }, {
    key: 'isMemberOwnerOfGroup',
    value: function isMemberOwnerOfGroup() {
      if (!this.context.roles) return;

      var activeTabRole = void 0;

      for (var i = 0; i < this.context.roles.length; i++) {
        var role = this.context.roles[i];
        if (role && role.membershipId === this.membershipIdOfActiveTab) {
          activeTabRole = role; // Active Tab Role is set here
          if (role.orgDisplayName.toUpperCase().indexOf('PRACTICE OF') >= 0) {
            var localStorage = this.localStorageService.get('authorizationData');
            if (localStorage.userName.toUpperCase() !== role.domain.toUpperCase()) return false;else return true;
          }
        }
      }
      /** This  is a hack as we CAN-ONLY add contact by membership of  org-owner or admin ,else it must be a personal account **/
      //-lets determine the membershipId of the Admin or Org-owner and add by that as backend will error out else
      for (var _i14 = 0; _i14 < this.context.roles.length; _i14++) {
        // Logic to determine user has Admin or OrgRole
        var tempRole = this.context.roles[_i14];
        if (activeTabRole && activeTabRole.orgId === tempRole.orgId) {
          if (tempRole.name === 'OrgOwner' || tempRole.name === 'OfficeAdmin') {
            return true;
          }
        }
      }
    }
  }, {
    key: 'elligibleToAddContact',
    value: function elligibleToAddContact(currentRole) {
      if (!this.context.roles) return;

      for (var i = 0; i < this.context.roles.length; i++) {
        // Logic to determine if its a personal Account
        var role = this.context.roles[i];
        if (role && role.membershipId === this.membershipIdOfActiveTab && role.orgDisplayName.toUpperCase().indexOf('PRACTICE OF') >= 0) {
          var localStorage = this.localStorageService.get('authorizationData');
          if (localStorage.userName.toUpperCase() !== role.domain.toUpperCase()) return false;else return true;
        }
      }
      var isUserEligibleToAddRoles = false;
      for (var _i15 = 0; _i15 < this.context.roles.length; _i15++) {
        // Logic to determine user has Admin or OrgRole
        var tempRole = this.context.roles[_i15];
        if (currentRole && currentRole.orgId === tempRole.orgId) {
          if (tempRole.name === 'OrgOwner' || tempRole.name === 'OfficeAdmin') {
            isUserEligibleToAddRoles = true;
            break;
          }
        }
      }
      return isUserEligibleToAddRoles;
    }
  }, {
    key: 'ifUserAdmin',
    value: function ifUserAdmin(role) {
      if (!role) return false;
      if (this.context.roles == undefined) return;

      var isUserEligibleToAddRoles = false;
      for (var i = 0; i < this.context.roles.length; i++) {
        var tempRole = this.context.roles[i];
        if (role && role.orgId === tempRole.orgId) {
          if (tempRole.name === 'OrgOwner' || tempRole.name === 'OfficeAdmin') {
            // role.membershipId = tempRole.membershipId;
            isUserEligibleToAddRoles = true;
            break;
          }
        }
      }
      return isUserEligibleToAddRoles;
    }
  }, {
    key: 'toggleAddContact',
    value: function toggleAddContact(mode) {
      if (mode == 'PHONE') {
        this.$scope.addContactMode = 'PHONE';
        this.$document[0].getElementById('addByMobileNumber').checked = true;
        this.$document[0].getElementById('addByEmail').checked = false;
        this.newContactForm.phoneNumber = "";
        this.newContactForm.email = "";
      } else if (mode == 'EMAIL') {
        this.$scope.addContactMode = 'EMAIL';
        this.$document[0].getElementById('addByMobileNumber').checked = false;
        this.$document[0].getElementById('addByEmail').checked = true;
        this.newContactForm.phoneNumber = "";
        this.newContactForm.email = "";
      }
    }
  }, {
    key: 'isThisMe',
    value: function isThisMe(contact) {
      if (contact.personId.toUpperCase() === this.context.user.personId.toUpperCase()) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'getGroupsOfThisProfile',
    value: function getGroupsOfThisProfile(membershipId) {

      var profileGroups = [];
      if (!this.$scope.contactMap['groupContact']) return profileGroups;
      for (var i = 0; i < this.$scope.contactMap['groupContact'].length; i++) {
        if (this.$scope.contactMap['groupContact'][i].membershipId === membershipId) {
          profileGroups.push(this.$scope.contactMap['groupContact'][i]);
        }
      }
      return profileGroups;
    }
  }]);

  return ClinicianPeopleCtlr;
}();

angular.module('app.clinician').component('clinicianPeople', {
  controller: ClinicianPeopleCtlr,
  templateUrl: 'app/main/clinician/people/people.html'
}).component('clinicianMdt', {
  controller: ClinicianPeopleCtlr,
  templateUrl: ''
});


'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ClinicianCaseCtlr = function () {
  function ClinicianCaseCtlr($http, $q, $sce, $scope, $filter, $stateParams, $resource, $mdDialog, $mdSidenav, $document, $timeout, $mdMedia, appContext, userService, pollingFactory, api, $analytics, $state, localStorageService, $window, swangular, moment) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, ClinicianCaseCtlr);

    this.casePollStatus = {
      hasCases: false,
      firstPoll: false
    };

    this.swangular = swangular;

    this.isVideoConferenceScgeduleInProgress = false;
    this.$window = $window;
    this.videoConferenceBaseURL = 'https://care-dev2.teleconnect.me/demo/api/v1/';
    this.totalConnect_api_key = '7a3c4b01f1d04be024d169306a17d944e30ccb';
    this.totalConnect_api_secret = 'f96b5b4467d47f1754626df835c91baa482001fbecb13cd994c00b24066eeef7';

    this.$q = $q;

    $scope.searchModeOn = false;

    $scope.showGallery = true;

    $scope.pdfThumbNailError = function (element) {

      element.src = 'assets/images/pdf-icon.png';
      element.parentNode.style['background-color'] = '#ffffff';
      element.parentNode.style.background = 'none';
      return true;
    };

    $scope.imageThumbnailError = function (element, chat) {
      element.src = chat.data;
      element.parentNode.style['background-color'] = '#ffffff';
      element.parentNode.style.background = 'none';
      return true;
    };

    $scope.imgError = function (element) {
      var siblings = element.parentNode.children;
      element.style.display = 'none';
      var imageNodeName = element.nodeName;

      for (var i = siblings.length; i--;) {

        if (siblings[i].nodeName != imageNodeName) {
          siblings[i].style.display = 'block';
        }
      }
    };

    this.localStorageService = localStorageService;
    this.$scope = $scope;
    this.$scope.selectedCaseTags = [];
    this.$scope.tagSearchText = '';
    this.$scope.allTagsOfCurrentProfile = [];
    this.api = api;
    this.$state = $state;
    this.$document = $document;
    this.$mdDialog = $mdDialog;
    this.$mdSidenav = $mdSidenav;
    this.$resource = $resource;
    this.$http = $http;
    this.$timeout = $timeout;
    this.$sce = $sce;
    this.tabClasses = ['tab-list-view', 'tab-read-view'];
    this.$filter = $filter;
    this.$analytics = $analytics;
    this.searchRecipient;

    this.priority;
    this.caseTitle;
    this.selectCaseResource = null;
    this.pollCaseResource = null;
    this.isCaseSelectCancelled = false;
    this.isCasePollCancelled = false;

    this.moment = moment;

    // this.maxPatientDOB = new Date();
    // this.minPatientDOB = new Date(new Date().setFullYear(new Date().getFullYear() - 119));
    this.currentDate = new Date();
    var d = this.currentDate.getDate();
    var m = this.currentDate.getMonth() + 1; //Month from 0 to 11
    var y = this.currentDate.getFullYear();

    this.maxPatientDOB = '' + (d <= 9 ? '0' + d : d) + '-' + (m <= 9 ? '0' + m : m) + '-' + y;

    this.futureDate = new Date(new Date().setFullYear(new Date().getFullYear() - 119));
    d = this.futureDate.getDate();
    m = this.futureDate.getMonth() + 1; //Month from 0 to 11
    y = this.futureDate.getFullYear();

    this.minPatientDOB = '' + (d <= 9 ? '0' + d : d) + '-' + (m <= 9 ? '0' + m : m) + '-' + y;

    this.minVideoConferenceDate = new Date();
    this.maxVideoConferenceDate = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
    this.videoConferenceDate = new Date();
    this.videoConferenceTime = new Date();
    this.videoConferenceDuration = 60;
    this.videoConferenceMinutesOption = [];
    for (var i = 1; i <= 60; i++) {
      this.videoConferenceMinutesOption.push(i);
    }

    this.app = appContext;
    if (!this.app.clinician.cases) {
      this.app.clinician.cases = { results: [] };
    }

    this.auth = userService.authentication;
    this.userService = userService;
    this.context = userService.getContext();

    this.form = { person: { Role: 'Clinician' } };

    this.activeTabIndex = 0;
    this.pageSize = 10;

    this.checked = [];
    this.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];

    this.responsiveReadPane = undefined;
    this.dynamicHeight = false;
    this.selectedEl = undefined;

    this.scrollPos = 0;
    this.scrollEl = angular.element('#content');
    this.currentPage = 1;
    this.watches($scope, $mdMedia, userService);
    this.pollers($scope, pollingFactory);

    this.userUploadedFileBuffer = [];
    this.caseSearchKeyword;
    this.caseSearchKeyword2;
    this.searchBoxButtonText = 'Go';

    this.$scope.$on('loggedOut', this.clearOldCases());

    this.showMRN = false;

    this.startPage = 1;
    this.endPage = 10;
    this.totalUserCases = 0;

    this.$scope.caseList = [];
    this.casesPerPage = 10;
    this.currentCasesPagination = 1;

    this.profileSpecificContacts = [];

    $scope.showRecipients = false;
    $scope.toggleInstruction = 'details ';
    $scope.toggleRecipients = function () {

      $scope.showRecipients = !$scope.showRecipients;

      if ($scope.showRecipients) {
        $scope.toggleInstruction = 'less ';
      } else {
        $scope.toggleInstruction = 'details ';
      }
    };

    var stepCount = 0;
    $scope.isLeftScrollPossible = false; // initial page 1 is visible so no left scroll possible
    $scope.isRightScrollPossible = true; // initial only right scroll is possible
    $scope.scrollPaginationRight = function () {
      $scope.$broadcast('move.right');
      $scope.isLeftScrollPossible = true; // left scroll possible after right scroll
      stepCount += 1;
      if (stepCount == $scope.maxSteps) $scope.isRightScrollPossible = false; // right scroll not possible after reaching last page
    };
    $scope.scrollPaginationLeft = function () {
      $scope.$broadcast('move.left');
      $scope.isRightScrollPossible = true; // right scroll possible after left scroll
      stepCount -= 1;
      if (stepCount == 0) $scope.isLeftScrollPossible = false; // left scroll not possible after reaching page 1
    };

    // Select Case with latest message after landing on cases page
    $scope.$watch('$ctrl.casePollStatus.hasCases', function (hasCases) {
      // console.log("Got Cases selecting case", $scope.caseList, hasCases);
      if (hasCases) {
        //hasCases is true once cases are succesfully fetched

        // Code to determine number of pages of cases for pagination
        // One page has 10 cases
        $scope.allPages = function () {

          var totalCasePages = Math.ceil(_this.totalUserCases / 10);
          // console.log(this.totalUserCases, totalCasePages);
          $scope.showCasePagination = totalCasePages > 1;
          $scope.isPaginationScrollable = totalCasePages > 8;
          $scope.maxSteps = totalCasePages - 8; // number of time to click on pagination right button to reach last page
          return new Array(totalCasePages); // Hack to generate array for ng-repeat
        };
      }
    });

    this.allGroupsOfActiveProfile = [];
    this.allGroupsOfActiveProfileVsGroupMembersMap = [];
    this.loadProfileGroupsAndAllItsMembers();

    this.patientDOBFormat = 'D-M-YYYY';
  }

  _createClass(ClinicianCaseCtlr, [{
    key: 'shouldShowSearchCaseBanner',
    value: function shouldShowSearchCaseBanner() {

      if (this.$scope.searchModeOn && !this.caseSearchKeyword2) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'shouldShowCaseListing',
    value: function shouldShowCaseListing() {

      if (this.$scope.searchModeOn === false) {
        return true;
      }

      if (this.$scope.searchModeOn) {
        if (this.caseSearchKeyword2) {
          return true;
        } else {
          return false;
        }
      }
    }
  }, {
    key: 'setSearchModeOn',
    value: function setSearchModeOn() {
      this.$scope.searchModeOn = true;
      this.loadPage();
      this.selectedCase = undefined;
    }
  }, {
    key: 'setSearchModeOff',
    value: function setSearchModeOff() {
      this.$scope.searchModeOn = false;
      this.caseSearchKeyword2 = undefined;
      this.selectedCase = undefined;
      this.caseList = [];
      this.loadPage();
    }
  }, {
    key: 'openMoreActionsMobile',
    value: function openMoreActionsMobile() {
      this.$mdSidenav('moreActionsMobile').toggle();
    }
  }, {
    key: 'loadProfileGroupsAndAllItsMembers',
    value: function loadProfileGroupsAndAllItsMembers() {
      //- prefetch all group and its members fo ease to add and remove recipients
      var _self = this;
      return this.api.contacts.getGroups.get({
        mId: this.context.currentRole.membershipId,
        page: 1,
        pageSize: 100
      }).$promise.then(function (response) {
        if (response.type > 0) {
          // Need To get GroupMembers Here
          if (response && response.payload) {
            _self.allGroupsOfActiveProfile = response.payload;
            if (_self.allGroupsOfActiveProfile && _self.allGroupsOfActiveProfile.length > 0) {
              var _loop = function _loop(i) {

                var aliasKey = _self.allGroupsOfActiveProfile[i].aliasKey;

                _self.$http({
                  method: 'GET',
                  url: apiBasePath + 'Contact/GetContactAliasContactList?mId=' + _self.context.currentRole.membershipId + '&aliasId=' + aliasKey
                }).then(function successCallback(response) {
                  response.data.payload;
                  var groupAndItsMembers = {};
                  groupAndItsMembers.aliasKey = aliasKey;
                  groupAndItsMembers.memberContactIds = [];
                  for (var c = 0; c < response.data.payload.length; c++) {
                    groupAndItsMembers.memberContactIds.push(response.data.payload[c].contactId);
                  }
                  _self.allGroupsOfActiveProfileVsGroupMembersMap.push(groupAndItsMembers);
                }, function errorCallback(response) {
                  console.error('Failed to Fetch Group Members');
                });
              };

              for (var i = 0; i < _self.allGroupsOfActiveProfile.length; i++) {
                _loop(i);
              }
            }
          }
        }
      }).catch();
    }
  }, {
    key: 'clearOldCases',
    value: function clearOldCases(event, arg) {
      this.app.clinician.cases.currentPage = undefined;
    }
  }, {
    key: 'doesnotUserHaveCase',
    value: function doesnotUserHaveCase() {
      if (typeof this.app.clinician.cases.currentPage == "undefined") return true;
      if (typeof this.app.clinician.cases.currentPage.items == "undefined") return true;
      return this.app.clinician.cases.currentPage.items.length <= 0;
    }
  }, {
    key: 'pollers',
    value: function pollers($scope, pollingFactory) {
      var _this2 = this,
          _arguments = arguments;

      var listPoller = pollingFactory.build();
      this.casePoller = pollingFactory.build();

      listPoller.run(function () {
        _this2.loadPage.apply(_this2, _arguments);
      }, 25000);

      $scope.$on('$destroy', function () {

        listPoller.destroy();
        _this2.casePoller.destroy();
      });
    }
  }, {
    key: 'watches',
    value: function watches($scope, $mdMedia, userService) {
      var _this3 = this;

      // Watch screen size to activate responsive read pane
      $scope.$watch(function () {
        return $mdMedia('gt-md');
      }, function (current) {
        _this3.responsiveReadPane = !current;
      });

      // Watch screen size to activate dynamic height on tabs
      $scope.$watch(function () {
        return $mdMedia('xs');
      }, function (current) {
        _this3.dynamicHeight = current;
      });
    }
  }, {
    key: 'loadPage',
    value: function loadPage(pollCount) {
      var _this4 = this;

      //if(!this.$window.navigator.onLine) {return;} - Find another way to check if browser is online

      if (!this.context || !this.context.currentRole) {
        return;
      }

      var localCasePollStatus = this.casePollStatus;

      var pageNo = 1;
      var pageSizeCases = 10;

      if (!this || !this.currentCasesPagination) pageNo = 1;else pageNo = this.currentCasesPagination;

      if (!this || !this.casesPerPage) pageSizeCases = 10;else pageSizeCases = this.casesPerPage;

      if (this.$scope.searchModeOn === true) {
        pageSizeCases = 10000;
        pageNo = 1;
      }

      this.$resource(apiBasePath + 'CaseTransfer/GetTransferRequest').get({
        mId: this.context.currentRole.membershipId
      }).$promise.then(function (response) {
        if (response.type > 0) {
          if (response.payload) {

            var casetransfererequests = {};
            for (var k = 0; k < response.payload.length; k++) {
              casetransfererequests[response.payload[k].caseId] = response.payload[k].requestId;
            }
          }
        }
      }).catch(function (response) {});

      this.$http.get(apiBasePath + 'Cases/InBoxWithProc', { params: { mid: this.context.currentRole.membershipId, page: pageNo, pageSize: pageSizeCases }, suppressSpinner: true }).then(function (response) {

        if (_.get(response, 'data.type') > 0) {
          var caseList = response.data.payload;
          caseList.items = _this4.filterOutDraftThatDoesNotBelongToMe(response.data.payload, _this4.context.user.personId);
          _this4.app.clinician.cases.results[_this4.currentPage] = caseList;
          _this4.app.clinician.cases.currentPage = caseList;

          if (caseList && caseList.items) {
            // Logic to determine Unread items of each case.
            var userIdOfCurrentUser = _this4.context.user.personId;
            var totalUnreadMessagesOnCurrentPage = 0;

            var _loop2 = function _loop2() {
              caseData = caseList.items[i];


              for (j = 0; j < _this4.context.roles.length; j++) {
                if (_this4.context.roles[j].orgId === caseData.creator.orgId) caseData.organization = _this4.context.roles[j].formattedOrganizationName;
              }

              latestItemId = caseData.latestItemId;
              totalUnreadMessagesOnCurrentCase = 0;
              totalItemCount = caseData.totalItemCount;

              var caseRecipientList = [];

              if (caseData && caseData.items) {
                for (var _j = 0; _j < caseData.recipients.length; _j++) {
                  if (caseData.recipients[_j].hasOwnProperty('displayName')) caseRecipientList.push(caseData.recipients[_j].displayName);else {
                    var displayName = _this4.getDisplayName(caseData.recipients[_j].title, caseData.recipients[_j].firstname, caseData.recipients[_j].middleNames, caseData.recipients[_j].lastname);
                    caseRecipientList.push(displayName);
                  }
                  if (caseData.recipients[_j].id === userIdOfCurrentUser) {
                    if (latestItemId === caseData.recipients[_j].lastItemReadId) totalUnreadMessagesOnCurrentCase = 0;else {
                      var difference = totalItemCount - caseData.recipients[_j].countItemsRead;
                      totalUnreadMessagesOnCurrentCase = difference;
                      if (difference > 0) {
                        totalUnreadMessagesOnCurrentPage = totalUnreadMessagesOnCurrentPage + 1;
                      }
                    }
                  }
                }
              }
              caseList.items[i].totalUnreadMessages = totalUnreadMessagesOnCurrentCase;
              caseList.items[i].displayableRecipients = caseRecipientList.join('; ');

              var currentCase = caseList.items[i];
              req = {
                method: 'GET',
                url: mdtBaseURL + 'tags/cases/' + currentCase.id,
                headers: {
                  'Accept': 'application/json',
                  'x-clinivid-useremail': _this4.userService.authentication.userName,
                  'app-backend': 'newint'
                }
              };


              _this4.$http(req).then(function (response) {

                if (response && response.data && response.data.success) {
                  if (response.data.payload.length > 0) {
                    currentCase.hasTags = true;
                    var allCurrentCaseTags = [];
                    for (var x = 0; x < response.data.payload.length; x++) {
                      allCurrentCaseTags.push(response.data.payload[x].tag);
                    }
                    currentCase.allCurrentCaseTags = allCurrentCaseTags.join(', ');
                    currentCase.tagCount = response.data.payload.length;
                  }
                }
              }, function (response) {});
            };

            for (var i = 0; i < caseList.items.length; i++) {
              var caseData;
              var j;
              var latestItemId;
              var totalUnreadMessagesOnCurrentCase;
              var totalItemCount;
              var req;

              _loop2();
            }
            _this4.app.clinician.cases.totalUnreadMessagesOnCurrentPage = totalUnreadMessagesOnCurrentPage;
          }
          _this4.$scope.caseList = caseList.items;
          _this4.totalUserCases = caseList.totalItems;

          if (caseList.totalItems === 0) {
            if (localCasePollStatus) {
              localCasePollStatus.hasCases = false;
              localCasePollStatus.firstPoll = true;
            }
          } else {
            if (localCasePollStatus) {
              localCasePollStatus.hasCases = true;
              localCasePollStatus.firstPoll = true;
            }
          }
        } else {

          if (localCasePollStatus) {
            localCasePollStatus.hasCases = false;
            localCasePollStatus.firstPoll = true;
          }
        }

        var preselectedCaseID = _this4.$window.sessionStorage.getItem('mdtcase');
        if (preselectedCaseID) {
          _this4.$window.sessionStorage.removeItem('mdtcase');
          for (var i = 0; i < _this4.$scope.caseList.length; i++) {
            if (_this4.$scope.caseList[i].id === preselectedCaseID) _this4.selectCase(_this4.$scope.caseList[i]);
            break;
          }
        }
      }).catch(function (response) {

        if (localCasePollStatus) {
          localCasePollStatus.hasCases = false;
          localCasePollStatus.firstPoll = true;
        }
      });
    }
  }, {
    key: 'getDisplayName',
    value: function getDisplayName(title, firstname, middleNames, lastname) {
      var result = '';
      if (title) result += title + ' ';
      if (firstname) result += firstname + ' ';
      if (middleNames) result += middleNames + ' ';
      if (lastname) result += lastname + ' ';
      return result;
    }
  }, {
    key: 'filterOutDraftThatDoesNotBelongToMe',
    value: function filterOutDraftThatDoesNotBelongToMe(caseList, personID) {
      if (typeof caseList.items == "undefined") return;
      var result = caseList.items.filter(function (item) {
        return !(item.status === 50 && item.creator.personId !== personID);
      });
      return result;
    }
  }, {
    key: 'enableCasePolling',
    value: function enableCasePolling() {
      var _this5 = this,
          _arguments2 = arguments;

      this.casePoller.run(function () {
        return _this5.pollCase.apply(_this5, _arguments2);
      }, 10000);
    }
  }, {
    key: 'resizeTextBoxForLongText',
    value: function resizeTextBoxForLongText() {
      // invoke this as $ctrl.resizeTextBoxForLongText()
      var el = event.currentTarget;
      setTimeout(function () {
        el.style.cssText = 'height:auto; padding:0';
        el.style.cssText = 'height:' + el.scrollHeight + 'px';
      }, 0);
    }
  }, {
    key: 'sendMessage',
    value: function sendMessage() {
      var _this6 = this;

      if (_.isEmpty(this.newMessage)) {
        return;
      }

      var msg = {
        caseId: this.selectedCase.id,
        userId: this.context.user.id,
        type: 40,
        data: this.newMessage,
        timestamp: new Date()
      };

      this.$resource(apiBasePath + 'Cases/Creator/ItemWithNotify?mid=' + this.context.currentRole.membershipId).save(msg).$promise.then(function (response) {

        if (response.type > 0) {
          _this6.$analytics.eventTrack('Click', { category: 'Button', label: 'add-message-success' });
          if (response.payload) {
            var item = response.payload;
            item.timestamp = item.timestamp + 'NEW-MESSAGE';
            _this6.selectedCase.items.push(item);
            _this6.updateItems([item]);
            //this.selectedCase.recipientsUnread = this.selectedCase.recipients.length - 1;
          }
        }
        // TBC - handle status errors
        else {
            _this6.$analytics.eventTrack('Click', { category: 'Button', label: 'add-message-failure' });
            _this6.app.popup("Error", "Sorry, an error has occurred and we cannot continue. Please try again later.", 'Close');
          }
      }).catch(function (response) {

        _this6.$analytics.eventTrack('Click', { category: 'Button', label: 'add-message-failure' });
        _this6.app.popup("Error", "Sorry, an error has occurred and we cannot continue. Please try again later.", 'Close');
      });

      //var textBox = this.$document[0].getElementById('textBox4TextMessage').style.height='40px';

      this.newMessage = null;
    }
  }, {
    key: 'uploadVideo',
    value: function uploadVideo(file) {
      var reader = new FileReader();
      var _self = this;

      _self.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(document.body)
      });

      reader.addEventListener("load", function () {

        var video = document.createElement('video');
        var time = 1; // Set specific time in second for thumbnail
        var scale = 1; // Scale image

        // Set dimensions of thumbnail
        var thumbnailDimensions = {
          width: 200,
          height: 200
        };
        video.setAttribute('src', reader.result);
        video.addEventListener('loadedmetadata', function () {
          this.currentTime = time; //Set current time of video after metadat loaded
        }, false);

        video.addEventListener('loadeddata', function () {
          var canvas = document.createElement("canvas");
          canvas.width = thumbnailDimensions.width * scale;
          canvas.height = thumbnailDimensions.height * scale;
          canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);

          var thumbnailAsBase64 = canvas.toDataURL('image/jpeg');
          _self.videoThumbnailFile = undefined;

          fetch(thumbnailAsBase64).then(function (res) {
            return res.blob();
          }).then(function (blob) {
            _self.videoThumbnailFile = new File([blob], 'videoThumbNail.jpeg');
          });

          video.setAttribute('currentTime', 0); // Reset video current time
        }, false);

        _self.$mdDialog.hide();

        _self.swangular.swal({
          title: '',
          html: '<video style="width:100%;max-width:400px;" controls><source src="' + reader.result + '" type="video/mp4"></video>',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Upload'
        }).then(function (result) {
          if (result.value) {
            var spinnerLoadingMedia = _self.$document[0].getElementById('uploadindMediaSpinner');
            spinnerLoadingMedia.style = 'text-align: center;margin-bottom:10px;display:block;';

            var beginItemRequestPayload = {
              id: 0,
              caseId: _self.selectedCase.id,
              type: 12,
              data: "",
              timestamp: new Date()
            };
            _self.$analytics.eventTrack('Click', { category: 'Button', label: 'upload-video-initiated-after-preview' });

            _self.$http({
              url: apiBasePath + 'Cases/Creator/BeginItem?mid=' + _self.context.currentRole.membershipId,
              data: beginItemRequestPayload,
              method: 'POST',
              headers: { 'Content-Type': 'application/json' }
            }).then(function (response) {
              if (response.data.type > 0) {
                if (response.data.payload) {

                  var s3URLforImageUpload = response.data.payload.data;
                  var responseID = response.data.payload.id;
                  var previewData = response.data.payload.previewData;

                  _self.$http({
                    url: s3URLforImageUpload,
                    data: file,
                    method: 'PUT',
                    headers: { 'Content-Type': file.type } }).then(function (response) {
                    if (_self.videoThumbnailFile) {
                      _self.$http({
                        url: previewData,
                        data: _self.videoThumbnailFile,
                        headers: { 'Content-Type': 'image/jpeg' },
                        method: 'PUT' }).then(function () {
                        console.log('Thumbnail Upload SUCCESS');
                      }, function (error) {
                        console.log('Thumbnail Upload Failed');
                      });
                    }
                    var endItemRequestPayload = {
                      id: responseID,
                      caseId: _self.selectedCase.id,
                      type: 10,
                      data: s3URLforImageUpload,
                      timestamp: new Date()
                    };
                    _self.$http({
                      url: apiBasePath + 'Cases/Creator/EndItem?mid=' + _self.context.currentRole.membershipId,
                      data: endItemRequestPayload,
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' }
                    }).then(function (response) {
                      spinnerLoadingMedia.style['display'] = 'none';
                      //scope.selectedCase.isFileUploadInProcess = false;
                      if (response.data.type > 0) {
                        var localFile = {};
                        localFile.key = s3URLforImageUpload.split('?')[0];
                        localFile.source = reader.result;
                        _self.userUploadedFileBuffer.push(localFile);

                        var item = response.data.payload;
                        item.timestamp = item.timestamp + 'NEW-MESSAGE';
                        item.userId = _self.context.user.id;
                        _self.selectedCase.items.push(item);
                        _self.updateItems([item]);

                        _self.$analytics.eventTrack('Click', { category: 'Button', label: 'video-uploaded-successfully' });

                        _self.swangular.swal('Video uploaded', 'Your video has been successfully uploaded.', 'success');
                      } else {
                        _self.swangular.swal({
                          type: 'error',
                          title: '',
                          html: 'Sorry, an error has occurred and we cannot continue. Please try again later.'
                        });
                      }
                    }, function (error) {
                      console.log(error);
                      spinnerLoadingMedia.style['display'] = 'none';
                      //scope.selectedCase.isFileUploadInProcess = false;
                      _self.swangular.swal({
                        type: 'error',
                        title: '',
                        html: 'Sorry, an error has occurred and we cannot continue. Please try again later.'
                      });
                    });
                  }, function (error) {
                    console.log(error);
                    spinnerLoadingMedia.style['display'] = 'none';
                    //scope.selectedCase.isFileUploadInProcess = false;
                    _self.swangular.swal({
                      type: 'error',
                      title: '',
                      html: 'Sorry, an error has occurred and we cannot continue. Please try again later.'
                    });
                  });
                }
              } else {
                //spinnerLoadingMedia.style['display'] ='none';
                //scope.selectedCase.isFileUploadInProcess = false;
                _self.swangular.swal({
                  type: 'error',
                  title: '',
                  html: 'Sorry, an error has occurred and we cannot continue. Please try again later.'
                });
              }
            }, function (error) {
              console.log(error);
              spinnerLoadingMedia.style['display'] = 'none';
              //scope.selectedCase.isFileUploadInProcess = false;
              _self.swangular.swal({
                type: 'error',
                title: '',
                html: 'Sorry, an error has occurred and we cannot continue. Please try again later.'
              });
            });
          }
        });
      }, false);

      if (file) {
        reader.readAsDataURL(file);
      }
    }
  }, {
    key: 'uploadPDF',
    value: function uploadPDF(file) {

      var reader = new FileReader();
      var _self = this;

      _self.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(document.body)
      });

      reader.addEventListener("load", function () {

        _self.$mdDialog.hide();

        _self.swangular.swal({
          title: '',
          html: '<object width="1000px" height="500px" type="application/pdf" data="' + reader.result + '" style="margin: auto; max-width: 100%;">',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Upload'
        }).then(function (result) {
          if (result.value) {
            var spinnerLoadingMedia = _self.$document[0].getElementById('uploadindMediaSpinner');
            spinnerLoadingMedia.style = 'text-align: center;margin-bottom:10px;display:block;';

            var beginItemRequestPayload = {
              id: 0,
              caseId: _self.selectedCase.id,
              type: 62,
              data: "",
              timestamp: new Date()
            };
            _self.$analytics.eventTrack('Click', { category: 'Button', label: 'pdf-initiated-after-preview' });

            _self.$http({ url: apiBasePath + 'Cases/Creator/BeginItem?mid=' + _self.context.currentRole.membershipId,
              method: 'POST',
              data: beginItemRequestPayload,
              headers: { 'Content-Type': 'application/json' } }).then(function (response) {
              if (response.data.type > 0) {
                if (response.data.payload) {

                  var s3URLforImageUpload = response.data.payload.data;
                  var responseID = response.data.payload.id;

                  _self.$http({
                    url: s3URLforImageUpload,
                    method: 'PUT',
                    data: file,
                    headers: { 'Content-Type': file.type } }).then(function () {

                    spinnerLoadingMedia.style['display'] = 'none';
                    var endItemRequestPayload = {
                      id: responseID,
                      caseId: _self.selectedCase.id,
                      type: 60,
                      data: s3URLforImageUpload,
                      timestamp: new Date()
                    };

                    _self.$http({
                      url: apiBasePath + 'Cases/Creator/EndItem?mid=' + _self.context.currentRole.membershipId,
                      method: 'POST',
                      data: endItemRequestPayload,
                      headers: { 'Content-Type': 'application/json' }
                    }).then(function (response) {

                      if (response.data.type > 0) {

                        var localFile = {};
                        localFile.key = s3URLforImageUpload.split('?')[0];
                        localFile.source = reader.result;
                        _self.userUploadedFileBuffer.push(localFile);

                        var item = response.payload;
                        item.timestamp = item.timestamp + 'NEW-MESSAGE';
                        item.userId = _self.context.user.id;
                        _self.selectedCase.items.push(item);
                        _self.updateItems([item]);

                        _self.$analytics.eventTrack('Click', { category: 'Button', label: 'pdf-uploaded-successfully' });

                        _self.swangular.swal('PDF uploaded', 'Your PDF has been successfully uploaded', 'success');
                      } else {
                        _self.swangular.swal({
                          type: 'error',
                          title: '',
                          html: 'Sorry, an error has occurred and we cannot continue. Please try again later.'
                        });
                      }
                    }, function (error) {
                      console.log(error);
                      spinnerLoadingMedia.style['display'] = 'none';
                      _self.swangular.swal({
                        type: 'error',
                        title: '',
                        html: 'Sorry, an error has occurred and we cannot continue. Please try again later.'
                      });
                    });
                  }, function (error) {
                    console.log(error);
                    spinnerLoadingMedia.style['display'] = 'none';
                    _self.swangular.swal({
                      type: 'error',
                      title: '',
                      html: 'Sorry, an error has occurred and we cannot continue. Please try again later.'
                    });
                  });
                }
              } else {
                _self.swangular.swal({
                  type: 'error',
                  title: '',
                  html: 'Sorry, an error has occurred and we cannot continue. Please try again later.'
                });
              }
            }, function (error) {
              console.log(error);
              spinnerLoadingMedia.style['display'] = 'none';
              _self.swangular.swal({
                type: 'error',
                title: '',
                html: 'Sorry, an error has occurred and we cannot continue. Please try again later.'
              });
            });
          }
        });
      }, false);

      if (file) {
        reader.readAsDataURL(file);
      }
    }
  }, {
    key: 'parseHTMLLinks',
    value: function parseHTMLLinks(data) {
      var urlRegex = /(https?:\/\/[^\s]+)/g;
      return data.replace(urlRegex, function (url) {
        return '<a href="' + url + '" target="_blank">' + url + '</a>';
      });
    }
  }, {
    key: 'getFileSource',
    value: function getFileSource(url) {

      if (this.userUploadedFileBuffer) for (var i = 0; i < this.userUploadedFileBuffer.length; i++) {
        if (url.indexOf(this.userUploadedFileBuffer[i].key) >= 0) return this.userUploadedFileBuffer[i].source;
      }return url;
    }
  }, {
    key: 'genericFileUpload',
    value: function genericFileUpload(file, errFiles) {
      if (!file) return;

      var fileNameSplit = file.name.split('.');
      var fileExtension = fileNameSplit[fileNameSplit.length - 1];

      if (!(fileExtension === 'mp4' || fileExtension === 'jpeg' || fileExtension === 'png' || fileExtension === 'gif' || fileExtension === 'pdf' || fileExtension === 'jpg' || fileExtension === 'mov')) {

        this.swangular.swal({
          type: 'error',
          title: 'Unsupported file type',
          html: fileExtension + ' format is not supported!'
        });

        return;
      }

      if (file.type === 'application/pdf') {
        this.uploadPDF(file);
      } else if (file.type.split('/')[0] === 'video') {
        this.uploadVideo(file);
      } else if (file.type.split('/')[0] === 'image') {
        this.uploadImage(file);
      }
      /**  - Handling upcoming features  - upload mp3 , doc and docX
      else if (file.type  === 'audio/mp3'){
        this.uploadAudio(file);
        return;
      }
      else if (file.type === 'application/msword'){
        this.uploadDoc(file);
        return;
      }
      else if (file.type === 'application/x-iwork-pages-sffpages'){ -- support for docx Files
        this.uploadDocx(file);
        return;
      }
      **/
    }
  }, {
    key: 'uploadImage',
    value: function uploadImage(file) {
      var reader = new FileReader();
      var _self = this;

      reader.addEventListener("load", function () {
        _self.swangular.swal({
          title: '',
          html: '<img src=' + reader.result + '>',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Upload'
        }).then(function (result) {
          if (result.value) {
            var spinnerLoadingMedia = _self.$document[0].getElementById('uploadindMediaSpinner');
            spinnerLoadingMedia.style = 'text-align: center;margin-bottom:10px;display:block;';

            var beginItemRequestPayload = {
              id: 0,
              caseId: _self.selectedCase.id,
              type: 32,
              data: "",
              timestamp: new Date()
            };
            _self.$analytics.eventTrack('Click', { category: 'Button', label: 'upload-image-initiated-after-preview' });

            _self.$resource(apiBasePath + 'Cases/Creator/BeginItem?mid=' + _self.context.currentRole.membershipId).save(beginItemRequestPayload).$promise.then(function (response) {
              if (response.type > 0) {
                if (response.payload) {
                  var s3URLforImageUpload = response.payload.data;
                  var responseID = response.payload.id;

                  _self.$http({
                    url: s3URLforImageUpload,
                    data: file,
                    method: 'PUT',
                    headers: { 'Content-Type': file.type } }).then(function () {

                    spinnerLoadingMedia.style['display'] = 'none';

                    var endItemRequestPayload = {
                      id: responseID,
                      caseId: _self.selectedCase.id,
                      type: 30,
                      data: s3URLforImageUpload,
                      timestamp: new Date()
                    };

                    _self.$http({
                      url: apiBasePath + 'Cases/Creator/EndItem?mid=' + _self.context.currentRole.membershipId,
                      data: endItemRequestPayload,
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' }
                    }).then(function (response) {
                      if (response.data.type > 0) {
                        var localFile = {};
                        localFile.key = s3URLforImageUpload.split('?')[0];
                        localFile.source = reader.result;
                        _self.userUploadedFileBuffer.push(localFile);

                        var item = response.data.payload;
                        item.timestamp = item.timestamp + 'NEW-MESSAGE';
                        item.userId = _self.context.user.id;
                        _self.selectedCase.items.push(item);
                        _self.updateItems([item]);

                        _self.$analytics.eventTrack('Click', { category: 'Button', label: 'image-uploaded-successfully' });

                        _self.swangular.swal('Image uploaded', 'Your Image has been successfully uploaded', 'success');
                      } else {
                        _self.swangular.swal({
                          type: 'error',
                          title: '',
                          html: 'Sorry, an error has occurred and we cannot continue. Please try again later.'
                        });
                      }
                    }, function (error) {
                      console.log(error);
                      spinnerLoadingMedia.style['display'] = 'none';
                      _self.swangular.swal({
                        type: 'error',
                        title: '',
                        html: 'Sorry, an error has occurred and we cannot continue. Please try again later.'
                      });
                    });
                  }, function (error) {
                    console.log(error);
                    spinnerLoadingMedia.style['display'] = 'none';
                    _self.swangular.swal({
                      type: 'error',
                      title: '',
                      html: 'Sorry, an error has occurred and we cannot continue. Please try again later.'
                    });
                  });
                }
              } else {
                _self.swangular.swal({
                  type: 'error',
                  title: '',
                  html: 'Sorry, an error has occurred and we cannot continue. Please try again later.'
                });
              }
            }, function (error) {
              console.log(error);
              spinnerLoadingMedia.style['display'] = 'none';
              _self.swangular.swal({
                type: 'error',
                title: '',
                html: 'Sorry, an error has occurred and we cannot continue. Please try again later.'
              });
            });
          }
        });
      }, false);

      if (file) {
        reader.readAsDataURL(file);
      }
    }
  }, {
    key: 'selectCase',
    value: function selectCase(caseData) {
      var _this7 = this;

      this.closeAllSidenavs();

      if (caseData && this.selectedCase && this.selectedCase.id === caseData.id) {
        // If the same case is selected again don't do anything
        return;
      }

      if (this.selectCaseResource) {
        // If select case Call is taking long time
        // Cancel Pending request in case a different case is selected
        this.selectCaseResource.$cancelRequest();
        this.isCaseSelectCancelled = true;
      }

      // Not sure why this is here
      var spinnerLoadingMedia = this.$document[0].getElementById('uploadindMediaSpinner');
      if (spinnerLoadingMedia) spinnerLoadingMedia.style['display'] = 'none';

      this.showMRN = false;
      this.selectedCase = undefined;
      this.newMessage = undefined;

      // hide recipient details on case select
      this.$scope.toggleInstruction = 'details ';
      this.$scope.showRecipients = false;

      this.$analytics.eventTrack('Click', { category: 'Button', label: 'user-clicked-case' });

      if (this.selectedEl) {
        this.selectedEl.classList.remove('selected');
      }

      if (caseData && caseData.id) {
        this.$scope.moreMessageCounter = 1;

        // Spinning loader in list-view2.html shows before complete display
        // in read-view2.html
        this.$scope.$broadcast('show.loader');
        this.$scope.isCaseLoaded = false;
        this.selectedCase = { 'id': caseData.id };

        var textBox = this.$document[0].getElementById('textBox4TextMessage');
        // if(textBox)   textBox.style.height='40px';

        // Changed syntax for cancelling pending request functionality
        this.selectCaseResource = this.$resource(apiBasePath + 'CasesWithAvailability').get({
          mId: this.context.currentRole.membershipId,
          build: 135,
          caseId: caseData.id
        });

        this.selectCaseResource.$promise.then(function (response) {

          if (_this7.pollCaseResource) {
            // If select case Call is taking long time
            // Cancel Pending request in case a different case is selected
            _this7.pollCaseResource.$cancelRequest();
            _this7.isCasePollCancelled = true;
          }

          _this7.$scope.$broadcast('hide.loader'); // Hide loader on case load
          _this7.$scope.isCaseLoaded = true;

          _this7.$analytics.eventTrack('Click', { category: 'Button', label: 'user-viewed-case-success' });
          if (response.type > 0) {
            _this7.casePoller.destroy();

            _this7.selectedCase = response.payload;
            _this7.initCase();
            _this7.priority = _this7.selectedCase.priority;
            _this7.caseTitle = _this7.selectedCase.title;

            // update read indicators
            for (var j = 0; j < caseData.recipients.length; j++) {
              var recipient = caseData.recipients[j];

              if (recipient.id == _this7.context.user.personId) {
                _this7.app.clinician.cases.countOfNew -= caseData.items.length - recipient.countItemsRead;
              }
            }
            caseData.countOfNewItems = 0;

            // Remove unread messages badge on selectCase()
            for (var j = 0; j < caseData.recipients.length; j++) {
              var recipient = caseData.recipients[j];
              //console.log("Recipient Id: " + recipient.id + "  context.user.personId: " + this.context.user.personId);
              if (recipient.id === _this7.context.user.personId) {
                recipient.countItemsRead = caseData.items.length;
              }
            }

            if (response && response.payload && response.payload.items) {
              _this7.$scope.galery = [];
              for (var i = 0; i < response.payload.items.length; i++) {
                var itemType = response.payload.items[i].type;
                if (itemType === 30 || itemType === 10 || itemType === 60) {
                  var media = {};
                  media.id = response.payload.items[i].id;
                  media.type = itemType;
                  media.previewData = response.payload.items[i].previewData;
                  media.data = response.payload.items[i].data;
                  _this7.$scope.galery.push(media);
                }
              }

              _this7.$scope.showGallery = true;
            }
          } else {
            _this7.selectedCase = undefined;
            _this7.$analytics.eventTrack('Click', { category: 'Button', label: 'user-viewed-case-error' });
            //this.app.popup("Error", "Sorry, an error has occured and we cannot continue. Please try again later.", 'Close');
            _this7.swangular.swal({
              type: 'error',
              title: '',
              html: 'Sorry, an error has occurred and we cannot continue.Please contact <a href="mailto:support@clinivid.com.au">Support</a>'
            });
          }

          _this7.isCaseSelectCancelled = false;
        }).catch(function () {
          _this7.selectedCase = undefined;
          if (_this7.isCaseSelectCancelled) {} else {
            _this7.$analytics.eventTrack('Click', { category: 'Button', label: 'user-viewed-case-error' });
            //this.app.popup("Error", "Sorry, an error has occured and we cannot continue. Please try again later.", 'Close');
            _this7.swangular.swal({
              type: 'error',
              title: '',
              html: 'Sorry, an error has occurred and we cannot continue.Please contact <a href="mailto:support@clinivid.com.au">Support</a>'
            });
          }
        });
      }

      this.$timeout(function () {
        // If responsive read pane is
        // active, navigate to it
        if (angular.isDefined(_this7.responsiveReadPane) && _this7.responsiveReadPane) {
          _this7.activeTabIndex = 1;
        }

        // Store the current scrollPos
        _this7.scrollPos = _this7.scrollEl.scrollTop();

        // Scroll to the top
        _this7.scrollEl.scrollTop(0);
      });
    }
  }, {
    key: 'focusMediaSourceInGalery',
    value: function focusMediaSourceInGalery(mediaId) {
      var media = this.$document[0].getElementById(mediaId);
      if (media) media.focus();
    }
  }, {
    key: 'archive',
    value: function archive(event) {
      var _this8 = this;

      if (!this.checked || this.checked.length == 0) {
        this.app.popup("Archiving", "To archive cases, please select the cases to archive by checking the checkbox next to each item.", 'Ok');
        return;
      }

      var itemsToArchive = [];
      for (var i = 0; i < this.checked.length; i++) {
        //console.log("Adding: " + this.checked[i].id);
        itemsToArchive.push(this.checked[i].id);
      }

      this.$resource(apiBasePath + 'Cases/Archive?mid=' + this.context.currentRole.membershipId, null, { 'update': { method: 'PUT' }
      }).update(itemsToArchive).$promise.then(function (response) {
        //console.log(response);
        if (response.type > 0) {
          //get id
          //console.log(response);
          //if(response.payload){
          _this8.app.popup("Archived", "Items have been successfully archived", 'Ok');
          //}
          _this8.loadPage();
        }
        // TBC - handle status errors
        else {

            _this8.app.popup("Error", "Sorry, an error has occured and archiving did not complete. Please try again later.", 'Close');
          }
      }).catch(function () {

        _this8.app.popup("Error", "Sorry, an error has occured and we cannot continue. Please try again later.", 'Close');
      });

      this.newMessage = null;
    }

    /**
     * Close read pane
     */

  }, {
    key: 'closeReadPane',
    value: function closeReadPane() {
      var _this9 = this;

      if (angular.isDefined(this.responsiveReadPane) && this.responsiveReadPane) {

        this.selectedCase = null;
        this.casePoller.destroy();
        this.activeTabIndex = 0;
        this.vidConfig = null;

        this.$timeout(function () {
          _this9.scrollEl.scrollTop(_this9.scrollPos);
        }, 650);
      }
    }
  }, {
    key: 'showMoreMessages',
    value: function showMoreMessages() {
      this.$scope.moreMessageCounter += 1;
    }
  }, {
    key: 'prepareChats',
    value: function prepareChats(items) {
      if (items.length === 1 && items[0].id === 0) {
        return [];
      }

      var filteredMessages = [];

      for (var i = 0; i < items.length; i++) {
        if (items[i].type === 40 && items[i].data) {
          items[i].data = items[i].data.replace(/(?:\r\n|\r|\n)/g, '<br>');
          items[i].data = this.parseHTMLLinks(items[i].data);
        }
        if (items[i].userId === this.context.user.id) items[i].doesMessageBelongToMe = true;else {
          items[i].doesMessageBelongToMe = false;

          // for(var j=0; j < this.selectedCase.recipients ; j++){  - Need to correct this logic
          //   if(this.selectedCase.recipients[j].id ===  items[i].personId){
          //     items[i].chatOwner= this.selectedCase.recipients[j].displayName;
          //     break;
          //   }
          // }
        }

        // if((items[i].type === 30 || items[i].type === 10 || items[i].type === 60)){
        //   if(items[i].previewData && items[i].previewData.length >0 && !items[i].hasThumbNail) {
        //     this.$http.get(items[i].previewData, { cache: true}).then( function(result) {
        //         items[i].hasThumbNail = true;
        //       },
        //         function failure(result){
        //           items[i].hasThumbNail = false;
        //         }
        //       );
        //
        //
        //     items[i].hasThumbNail = true;
        //     var xmlHttp = new XMLHttpRequest();
        //     xmlHttp.open( "GET", items[i].previewData, false ); // false for synchronous request
        //     xmlHttp.send( null );
        //
        //     if (xmlHttp.status === 200) {
        //       items[i].hasThumbNail = true;
        //     }
        //     else {
        //       items[i].hasThumbNail = false;
        //     }
        //     console.log('There IS Preview Data:'+items[i].previewData);
        //   }
        //   else{
        //     console.log('There NO Preview Data:'+items[i].previewData);
        //   }
        // }


        if (this.validMessage(items[i])) filteredMessages.push(items[i]);
        // this.$http.get(items[i].data, { cache: true}).success( function(result) {
        //   console.log('get Call made succesfully');
        // });
      }

      var truncatedMessages = [];
      for (var _i = filteredMessages.length - 1; _i >= 0; _i--) {
        truncatedMessages.push(filteredMessages[_i]);
      }

      var filteredMessagesPlusLoadMore = [];
      var counter = 1;
      for (var _i2 = 0; _i2 < truncatedMessages.length; _i2++) {
        truncatedMessages[_i2].currentLoadMore = counter;
        filteredMessagesPlusLoadMore.push(truncatedMessages[_i2]);
        if ((_i2 + 1) % 10 === 0) {
          counter++;
          var difference = filteredMessages.length - 10 * (counter - 1);
          if (difference <= 0) continue;
          var loadMore = {};
          loadMore.type = 4;
          loadMore.currentLoadMore = counter - 1;
          loadMore.loadMoreMessage = '+' + difference + ' more messages';
          filteredMessagesPlusLoadMore.push(loadMore);
        }
      }

      var reversedFilteredMessagesWithLoadMore = [];
      for (var _i3 = filteredMessagesPlusLoadMore.length - 1; _i3 >= 0; _i3--) {
        reversedFilteredMessagesWithLoadMore.push(filteredMessagesPlusLoadMore[_i3]);
      }

      // const result = _(items) This is not required any more !
      //   .filter((c) => c.data )
      //   .map((c) => _.assign(c, {class: c.userId === this.context.user.id ? 'align-right' : 'align-left'}))
      //   .value();

      // return result ? result : [];

      return reversedFilteredMessagesWithLoadMore; //filteredMessages;
    }
  }, {
    key: 'getCurrentUserID',
    value: function getCurrentUserID() {
      return this.context.user.id;
    }
  }, {
    key: 'removeNewLines',
    value: function removeNewLines(chatData) {
      return chatData = chatData.replace(/(?:\r\n|\r|\n)/g, '<br />');
    }
  }, {
    key: 'initCase',
    value: function initCase() {
      if (!_.size(_.get(this.selectedCase, 'items'))) {

        return;
      }

      // get latest video
      this.displayChats = this.prepareChats(this.selectedCase.items);

      //this.selectedCase.featuredItem = _.find(this.selectedCase.items, (i) => i.type === 10);
      var vidItem = _.find(this.selectedCase.items, function (i) {
        return i.type === 10;
      });
      //this.setVidConfig(vidItem); commented because of defect-2565
      //this.showVideo(_.get(vidItem, 'data',  "http://dev1.clinivid.com.au/IMG_3439.mp4"));
      //if(this.selectedCase.featuredItem)
      //    this.showVideo(this.selectedCase.featuredItem.data);
      //else {
      //    console.log("Showing demo video");
      //    this.showVideo("http://dev1.clinivid.com.au/IMG_4647.mp4");
      //}

      // start polling
      this.enableCasePolling();
    }

    /* setVidConfig(vidItem) {
         var  vidUrl = _.get(vidItem, 'data');
         //if(!vidUrl)
             //vidUrl = "http://int.clinivid.com.au/IMG_4647.mp4";
         if (vidUrl){
              this.vidConfig = {
                 autohide: true,
                 autohideTime: 2000,
                 preload: "none",
                 sources: [
                     { src: this.$sce.trustAsResourceUrl(vidUrl), type: "video/mp4" }
                 ],
                 theme: "/styles/videogular.css"
             };
         }
         else
             this.vidConfig = null;
     }*/

  }, {
    key: 'setVidConfig',
    value: function setVidConfig(url) {

      if (this.userUploadedFileBuffer) for (var i = 0; i < this.userUploadedFileBuffer.length; i++) {
        if (url.indexOf(this.userUploadedFileBuffer[i].key) >= 0) return this.userUploadedFileBuffer[i].source;
      }return this.$sce.trustAsResourceUrl(url);
    }
  }, {
    key: 'isDevelopmentMode',
    value: function isDevelopmentMode() {
      if (environment === "dev") return true;else return false;
    }
  }, {
    key: 'getUnread',
    value: function getUnread() {
      var recipientDisplayNames = [];
      if (this.selectedCase) this.selectedCase.recipients.forEach(function (individualRecipient) {
        if (individualRecipient.countItemsRead === 0) recipientDisplayNames.push(individualRecipient.displayName);
      });

      if (recipientDisplayNames.length > 0) recipientDisplayNames = recipientDisplayNames.slice(1);
      return recipientDisplayNames.join('; ');
    }
  }, {
    key: 'getRead',
    value: function getRead() {
      var recipientDisplayNames = [];
      if (this.selectedCase) this.selectedCase.recipients.forEach(function (individualRecipient) {
        if (individualRecipient.countItemsRead >= 0) recipientDisplayNames.push(individualRecipient.displayName);
      });

      if (recipientDisplayNames.length > 0) recipientDisplayNames = recipientDisplayNames.slice(1);
      return recipientDisplayNames.join('; ');
    }
  }, {
    key: 'getRecipients',
    value: function getRecipients() {
      var recipientDisplayNames = [];
      if (this.selectedCase) this.selectedCase.recipients.forEach(function (individualRecipient) {
        recipientDisplayNames.push(individualRecipient.displayName);
      });
      if (recipientDisplayNames.length > 0) recipientDisplayNames = recipientDisplayNames.slice(1);
      return recipientDisplayNames.join('; ');
    }
  }, {
    key: 'getNumberofRecipients',
    value: function getNumberofRecipients() {
      if (this.selectedCase && typeof this.selectedCase.recipients !== 'undefined') {
        return 'Recipients (' + this.selectedCase.recipients.length + ')';
      }
    }
  }, {
    key: 'patientHasRefNo',
    value: function patientHasRefNo() {
      if (this.selectedCase && this.selectedCase.patient) {
        return this.selectedCase.patient.ref;
      } else return false;
    }
  }, {
    key: 'patientHasDOB',
    value: function patientHasDOB() {
      if (this.selectedCase && this.selectedCase.patient) {
        return this.selectedCase.patient.dob;
      } else return false;
    }
  }, {
    key: 'toggleRightMobile',
    value: function toggleRightMobile() {
      this.$mdSidenav('moreActionsMobile').close();
      this.toggleRight(this);
    }
  }, {
    key: 'toggleRight',
    value: function toggleRight(self) {
      //Open side-nav to allow to remove or add recipients

      var _self = void 0;
      if (self) _self = self;else _self = this;

      _self.profileSpecificContacts = [];

      _self.recipientsLoaded = true;

      _self.$resource(apiBasePath + 'Contact/PageWithAvailability2').get({
        mId: _self.context.currentRole.membershipId,
        page: 1,
        pageSize: 100
      }).$promise.then(function (response) {

        if (response.type > 0) {
          _self.profileSpecificContacts = response.payload.items;

          for (var i = 0; i < _self.selectedCase.recipients.length; i++) {
            for (var j = 0; j < _self.profileSpecificContacts.length; j++) {
              if (_self.profileSpecificContacts[j].personId == _self.selectedCase.recipients[i].id) {
                _self.profileSpecificContacts[j].selected = true;
              }
            }
          }

          _self.api.contacts.getGroups.get({
            mId: _self.context.currentRole.membershipId,
            page: 1,
            pageSize: 100
          }).$promise.then(function (response) {

            _self.recipientsLoaded = false;

            if (response.type > 0) {
              for (var k = 0; k < response.payload.length; k++) {
                var group = {};
                group.isGroup = true;
                group.aliasKey = response.payload[k].aliasKey;
                group.name = response.payload[k].aliasName;
                group.members = []; //- add group members here

                for (var c = 0; c < _self.allGroupsOfActiveProfileVsGroupMembersMap.length; c++) {
                  if (_self.allGroupsOfActiveProfileVsGroupMembersMap[c].aliasKey === group.aliasKey) {
                    var members = _self.allGroupsOfActiveProfileVsGroupMembersMap[c].memberContactIds;
                    for (var a = 0; a < members.length; a++) {
                      for (var b = 0; b < _self.profileSpecificContacts.length; b++) {
                        if (_self.profileSpecificContacts[b].id === members[a]) {
                          var memberDetail = '';
                          if (_self.profileSpecificContacts[b].title) memberDetail = memberDetail.concat(_self.profileSpecificContacts[b].title + ' ');
                          if (_self.profileSpecificContacts[b].lastname) memberDetail = memberDetail.concat(_self.profileSpecificContacts[b].lastname + ' ');
                          if (_self.profileSpecificContacts[b].firstname) memberDetail = memberDetail.concat(_self.profileSpecificContacts[b].firstname + ' ');
                          if (_self.profileSpecificContacts[b].profession) memberDetail = memberDetail.concat(' - ' + _self.profileSpecificContacts[b].profession);

                          group.members.push(memberDetail);
                        }
                      }
                    }
                  }
                }

                _self.profileSpecificContacts.push(group);
              }
            } else {
              console.error('Failed to Load Groups for:' + currentMembershipId);
            }
          }).catch(function () {
            _self.recipientsLoaded = false;
          });
        } else {
          _self.profileSpecificContacts = [];
        }
      }).catch(function () {
        _self.recipientsLoaded = false;
      });

      _self.$mdSidenav('right').toggle();
    }
  }, {
    key: 'showGroupMembers',
    value: function showGroupMembers(groupName) {
      var showLink = this.$document[0].getElementById(groupName + '-show');
      var hideLink = this.$document[0].getElementById(groupName + '-hide');
      var memberDetails = this.$document[0].getElementById(groupName + '-member-details');
      if (showLink) showLink.style.display = "none";
      if (hideLink) hideLink.style.display = "block";
      if (memberDetails) memberDetails.style.display = "block";
    }
  }, {
    key: 'toggleGallery',
    value: function toggleGallery() {
      this.$scope.showGallery = !this.$scope.showGallery; //this.$document[0].getElementById("overlay").style.display = "block";
    }
  }, {
    key: 'closeCaseGallery',
    value: function closeCaseGallery() {
      this.$document[0].getElementById("overlay").style.display = "none";
    }
  }, {
    key: 'hideGroupMembers',
    value: function hideGroupMembers(groupName) {
      var showLink = this.$document[0].getElementById(groupName + '-show');
      var hideLink = this.$document[0].getElementById(groupName + '-hide');
      var memberDetails = this.$document[0].getElementById(groupName + '-member-details');
      if (showLink) showLink.style.display = "block";
      if (hideLink) hideLink.style.display = "none";
      if (memberDetails) memberDetails.style.display = "none";
    }
  }, {
    key: 'getPatients',
    value: function getPatients() {
      var _this10 = this;

      this.patientDOBsearch = undefined;

      this.patientSearchOn = true;
      this.$resource(apiBasePath + 'Patient/SearchByName').get({
        mId: this.context.currentRole.membershipId,
        searchterm: this.searchPatientKeyWord
      }).$promise.then(function (response) {
        _this10.patientSearchOn = false;
        if (response.type > 0) {
          _this10.patients = response.payload;
          _this10.showNoPatienFoundText = false;
        } else {
          _this10.showNoPatienFoundText = true;
          _this10.patients = [];
        }
      }).catch(function () {
        _this10.patientSearchOn = false;
        _this10.showNoPatienFoundText = true;
      });
    }
  }, {
    key: 'getPatientFilterCondition',
    value: function getPatientFilterCondition() {
      var searchWord;

      if (this.patientDOBsearch) {
        var dobDate = new Date(this.patientDOBsearch);

        var fullYear = dobDate.getFullYear();
        var month = Number(dobDate.getMonth()) + 1;
        var day = dobDate.getDate();
        searchWord = fullYear + '-' + month + '-' + day;
      } else searchWord = this.patientDOBsearch;

      return searchWord;
    }

    /*
    searchInCase(){
     if(!this.caseSearchKeyword) return;
      if(this.searchBoxButtonText === 'Cancel'){ // Change search button text and clean search when user presses Cancel
       this.caseSearchKeyword='';
       this.caseSearchKeyword2='';
      // this.searchBoxButtonText ='Go';
       return;
     }
      this.caseSearchKeyword2 = this.caseSearchKeyword;
     //this.searchBoxButtonText ='Cancel';
      }
    */

  }, {
    key: 'getOrganization',
    value: function getOrganization(contact) {

      if (contact && contact.availability && this.context && this.context.roles) {
        var organisationId = contact.availability[0].organisationId;
        if (organisationId) {
          for (var i = 0; i < this.context.roles.length; i++) {
            var role = this.context.roles[i];
            if (role.orgId === organisationId) {
              // var isPersonalProfile = role && role.orgDisplayName.toUpperCase().includes('PRACTICE OF');
              var isPersonalProfile = role && role.orgDisplayName.toUpperCase().indexOf('PRACTICE OF') >= 0;
              // var isPersonalProfile = role && role.orgDisplayName.toUpperCase().includes('PRACTICE OF');
              if (isPersonalProfile) {
                return 'Personal Account';
              } else {
                return role.orgDisplayName;
              }
            }
          }
        }
      }
    }
  }, {
    key: 'getRequestorOrganization',
    value: function getRequestorOrganization(organisationId) {
      if (organisationId) {
        var organizationName = void 0;
        for (var i = 0; i < this.context.roles.length; i++) {
          var role = this.context.roles[i];
          if (role.orgId === organisationId) {
            var isPersonalProfile = role && role.orgDisplayName.toUpperCase().indexOf('PRACTICE OF') >= 0;

            if (isPersonalProfile) {
              organizationName = 'Personal Account';
              break;
            } else {
              organizationName = role.orgDisplayName;
              break;
            }
          }
        }
        if (organizationName) {
          return organizationName;
        } else {
          return 'Personal Account';
        }
      }
    }
  }, {
    key: 'closeSideNavPanel',
    value: function closeSideNavPanel() {
      this.$mdSidenav('right').close();
    }
  }, {
    key: 'closeAllSidenavs',
    value: function closeAllSidenavs() {
      this.$mdSidenav('right').close();
      this.$mdSidenav('patient').close();
      //  this.$mdSidenav('createVideoConferenceSettings').close();
      this.$mdSidenav('moreActionsMobile').close();
      this.$mdSidenav('transferOwnership').close();
      this.closeCaseTags();
    }
  }, {
    key: 'closeCaseTransferSideNav',
    value: function closeCaseTransferSideNav() {
      this.$mdSidenav('transferOwnership').close();
    }
  }, {
    key: 'addAndRemoveRecipients',
    value: function addAndRemoveRecipients() {
      this.$mdSidenav('right').close();

      var existingRecipientsId = [];

      var addedRecipients = [];
      var displayNamesOfAddedRecipients = [];
      var displaynamesOfAddedRecipientsPopup = [];

      var removedRecipients = [];
      var displaynamesOfRemovedRecipients = [];
      var displaynamesOfRemovedRecipientsPopup = [];

      var contactIdOfAddedRecipients = [];

      for (var x = 0; x < this.profileSpecificContacts.length; x++) {
        if (this.profileSpecificContacts[x].isGroup) continue;
        if (this.profileSpecificContacts[x].selected) {
          addedRecipients.push(this.profileSpecificContacts[x]);
          contactIdOfAddedRecipients.push(this.profileSpecificContacts[x].id);
        } else {
          removedRecipients.push(this.profileSpecificContacts[x].personId);
        }
      }

      for (var _x = 0; _x < this.profileSpecificContacts.length; _x++) {
        if (this.profileSpecificContacts[_x].isGroup && this.profileSpecificContacts[_x].selected) {
          for (var j = 0; j < this.allGroupsOfActiveProfileVsGroupMembersMap.length; j++) {
            if (this.profileSpecificContacts[_x].aliasKey === this.allGroupsOfActiveProfileVsGroupMembersMap[j].aliasKey) {
              var members = this.allGroupsOfActiveProfileVsGroupMembersMap[j].memberContactIds;
              for (var k = 0; k < members.length; k++) {
                for (var l = 0; l < this.profileSpecificContacts.length; l++) {
                  if (members[k] === this.profileSpecificContacts[l].id) {
                    if (contactIdOfAddedRecipients.indexOf(this.profileSpecificContacts[l].id) <= -1) {
                      addedRecipients.push(this.profileSpecificContacts[l]);
                    }
                  }
                }
              }
            }
          }
        }
      }

      var tempRecipients = [];

      for (var z = 0; z < this.selectedCase.recipients.length; z++) {
        existingRecipientsId.push(this.selectedCase.recipients[z].id);
      }

      for (var y = 0; y < addedRecipients.length; y++) {
        //Logic to create a list of recipients after ADDING the  SELECTED recipients
        if (existingRecipientsId.indexOf(addedRecipients[y].personId) > -1) {
          //No need to add if recipient is already there !
        } else {
          // - Logic to create a recipient for adding to the case
          var newRecipientAdded = this.translateContact(addedRecipients[y]);

          tempRecipients.push(newRecipientAdded);
          var displayName = "";
          if (addedRecipients[y].title) displayName = displayName + addedRecipients[y].title;
          if (addedRecipients[y].lastname) displayName = displayName.trim() + " " + addedRecipients[y].lastname;
          if (addedRecipients[y].firstname) displayName = displayName.trim() + ", " + addedRecipients[y].firstname;

          displayNamesOfAddedRecipients.push(displayName);
          displaynamesOfAddedRecipientsPopup.push('<li>' + displayName + '</li>');
        }
      }

      for (var _x2 = 0; _x2 < this.selectedCase.recipients.length; _x2++) {
        //Logic to create a list of recipients after REMOVING the DE-SELECTED recipients
        if (removedRecipients.indexOf(this.selectedCase.recipients[_x2].id) > -1) {
          // This recipient is removed by user
          displaynamesOfRemovedRecipients.push(this.selectedCase.recipients[_x2].displayName);
          displaynamesOfRemovedRecipientsPopup.push('<li>' + this.selectedCase.recipients[_x2].displayName + '</li>');
        } else tempRecipients.push(this.selectedCase.recipients[_x2]); // This recipient is retained by user
      }

      //this.selectedCase.recipients = tempRecipients;
      this.cloneSelectedCase = JSON.parse(JSON.stringify(this.selectedCase));
      this.cloneSelectedCase.recipients = tempRecipients;

      var alertString = '';
      if (displaynamesOfRemovedRecipientsPopup.length > 0) alertString = 'You are removing the below participants. These participants won\'t be able to see any discussion for this chat: <br><ul> ' + displaynamesOfRemovedRecipientsPopup.join('') + '</ul>';

      if (displaynamesOfAddedRecipientsPopup.length > 0) alertString = alertString + '<br>You are adding the below participants. Make sure you have patient\'s consent. These participants will see discussion from beginning of this chat: <br><ul> ' + displaynamesOfAddedRecipientsPopup.join('') + '</ul>';

      if (alertString.trim() === '') return;

      var _self = this;

      _self.swangular.swal({
        title: 'Change recipients',
        html: alertString,
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        focusConfirm: false
      }).then(function (result) {
        if (result.value) {
          _self.addRemoveRecipientRestCalls(_self, displaynamesOfRemovedRecipients, displayNamesOfAddedRecipients);
        }
      });
    }
  }, {
    key: 'translateContact',
    value: function translateContact(contact) {
      var recipient = {};

      recipient.displayName = "";

      if (contact.title) recipient.displayName += contact.title + " ";

      recipient.displayName += contact.lastname + ", " + contact.firstname;
      if (contact.middlenames) recipient.displayName += " " + contact.middlenames;

      //console.log(contact);
      recipient.id = contact.personId;
      if (contact.mobile) recipient.address = contact.mobile;else recipient.address = contact.email;

      // find best ref available
      if (contact.registrationId) recipient.displayRef = contact.registrationId;else if (contact.positionTitle) recipient.displayRef = contact.positionTitle;else if (contact.profession) recipient.displayRef = contact.profession;else if (contact.staffId) recipient.displayRef = contact.staffId;else if (contact.mobile) recipient.displayRef = contact.mobile;else recipient.displayRef = contact.email;

      return recipient;
    }
  }, {
    key: 'addRemoveRecipientRestCalls',
    value: function addRemoveRecipientRestCalls(_self, displaynamesOfRemovedRecipients, displayNamesOfAddedRecipients) {

      var caseOwner = _self.cloneSelectedCase.creator.personId;

      var reOrderedRecipientsList = [];

      for (var i = 0; i < _self.cloneSelectedCase.recipients.length; i++) {
        if (_self.cloneSelectedCase.recipients[i].id === caseOwner) {
          reOrderedRecipientsList.push(_self.cloneSelectedCase.recipients[i]);
          break;
        }
      }

      for (var _i4 = 0; _i4 < _self.cloneSelectedCase.recipients.length; _i4++) {
        if (_self.cloneSelectedCase.recipients[_i4].id !== caseOwner) {
          reOrderedRecipientsList.push(_self.cloneSelectedCase.recipients[_i4]);
        }
      }

      _self.cloneSelectedCase.recipients = reOrderedRecipientsList;

      _self.$resource(apiBasePath + 'Cases/UpdateCaseRecipients?mid=' + _self.context.currentRole.membershipId).save(_self.cloneSelectedCase, function (response) {
        if (response.type > 0) {

          _self.swangular.swal('Change recipients', 'Completed', 'success');

          _self.selectedCase = JSON.parse(JSON.stringify(_self.cloneSelectedCase));

          for (var _i5 = 0; _i5 < displaynamesOfRemovedRecipients.length; _i5++) {
            // - Logic to send message for removed recipients
            var recipientRemovedMessageItem = { // - Logic to send message for removed recipients
              caseId: _self.selectedCase.id,
              userId: _self.context.user.id,
              type: 90,
              data: displaynamesOfRemovedRecipients[_i5] + " has been removed from discussion.",
              timestamp: new Date()
            };

            _self.$resource(apiBasePath + 'Cases/Creator/ItemWithNotify?mid=' + _self.context.currentRole.membershipId).save(recipientRemovedMessageItem).$promise.then(function (response) {

              if (response.type > 0) {

                var item = response.payload;
                item.timestamp = item.timestamp + 'NEW-MESSAGE';
                _self.selectedCase.items.push(item);
                _self.updateItems([item]);
              }
            }).catch(function () {
              _self.swangular.swal({
                type: 'error',
                title: '',
                html: 'Failed to change recipients.Please contact <a href="mailto:support@clinivid.com.au">Support</a>'
              });
            });
          } // - End of for loop

          for (var _i6 = 0; _i6 < displayNamesOfAddedRecipients.length; _i6++) {
            // - Logic to send message for added recipients
            var recipientAddMessageItem = {
              caseId: _self.selectedCase.id,
              userId: _self.context.user.id,
              type: 90,
              data: displayNamesOfAddedRecipients[_i6] + " has been added to the discussion.",
              timestamp: new Date()
            };

            _self.$resource(apiBasePath + 'Cases/Creator/ItemWithNotify?mid=' + _self.context.currentRole.membershipId).save(recipientAddMessageItem).$promise.then(function (response) {

              if (response.type > 0) {

                if (response.payload) {
                  var item = response.payload;
                  item.timestamp = item.timestamp + 'NEW-MESSAGE';
                  _self.selectedCase.items.push(item);
                  _self.updateItems([item]);
                }
              }
            }).catch(function () {
              _self.swangular.swal({
                type: 'error',
                title: '',
                html: 'Failed to change recipients.Please contact <a href="mailto:support@clinivid.com.au">Support</a>'
              });
            });
          } // - End of for loop
        } else {
          _self.swangular.swal({
            type: 'error',
            title: '',
            html: 'Failed to modify recipients. Please contact <a href="mailto:support@clinivid.com.au">Support</a>'
          });
        }
      }, function () {
        _self.swangular.swal({
          type: 'error',
          title: '',
          html: 'Failed to change recipients.Please contact <a href="mailto:support@clinivid.com.au">Support</a>'
        });
      });
    }
  }, {
    key: 'openMobileArchive',
    value: function openMobileArchive() {
      this.$mdSidenav('moreActionsMobile').close();
      this.archiveThisCase(this);
    }
  }, {
    key: 'changeOwnership',
    value: function changeOwnership(transferRequest) {
      this.$mdSidenav('transferOwnership').close();

      var _self = this;
      var selectedCaseOrgId = this.selectedCase.creator.orgId;

      var caseCreatedWithMembershipId = void 0;
      for (var j = 0; j < this.context.roles.length; j++) {
        if (_self.context.roles[j].orgId === selectedCaseOrgId) caseCreatedWithMembershipId = _self.context.roles[j].membershipId;
      }

      if (!caseCreatedWithMembershipId) {
        caseCreatedWithMembershipId = _self.context.currentRole.membershipId;
      }

      var transferTo = '';
      if (transferRequest.title) transferTo += transferRequest.title + ' ';

      if (transferRequest.lastName) transferTo += transferRequest.lastName + ' ';

      if (transferRequest.firstName) transferTo += transferRequest.firstName;

      _self.swangular.swal({
        title: 'Transfer ownership',
        html: 'You are transferring your ownership to <b>' + transferTo + '</b>. All privileges will be shifted. Are you sure you would like to continue?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Accept',
        cancelButtonText: 'Reject',
        focusConfirm: false
      }).then(function (result) {
        if (result.value) {
          var transferPayload = {
            caseId: transferRequest.caseId,
            requestId: transferRequest.requestId
          };
          _self.$resource(apiBasePath + 'CaseTransfer/Accept?mid=' + caseCreatedWithMembershipId).save(transferPayload).$promise.then(function (response) {
            _self.selectedCase.isFileUploadInProcess = false;
            if (response.type > 0) {
              var changeOwnershipMessage = {
                caseId: _self.selectedCase.id,
                userId: _self.context.user.id,
                type: 90,
                data: "Transferred chat ownership to  - " + transferTo,
                timestamp: new Date()
              };

              _self.$resource(apiBasePath + 'Cases/Creator/ItemWithNotify?mid=' + _self.context.currentRole.membershipId).save(changeOwnershipMessage).$promise.then(function (response) {
                _self.selectedCase.isFileUploadInProcess = false;
                if (response.type > 0) {

                  var item = response.payload;
                  item.timestamp = item.timestamp + 'NEW-MESSAGE';
                  _self.selectedCase.items.push(item);
                  _self.updateItems([item]);
                }
              }).catch(function () {
                _self.selectedCase.isFileUploadInProcess = false;
              });
            } else {
              _self.swangular.swal({
                type: 'error',
                title: '',
                html: 'Failed to transfer ownership.Please contact support'
              });
            }
          }).catch(function () {
            _self.selectedCase.isFileUploadInProcess = false;
            _self.swangular.swal({
              type: 'error',
              title: '',
              html: 'Failed to transfer ownership.Please contact support'
            });
          });
        } else {
          // Reject case ownership request
          var _transferPayload = {
            caseId: transferRequest.caseId,
            requestId: transferRequest.requestId
          };
          _self.$resource(apiBasePath + 'CaseTransfer/Reject?mid=' + caseCreatedWithMembershipId).save(_transferPayload).$promise.then(function (response) {
            _self.selectedCase.isFileUploadInProcess = false;
            if (response.type > 0) {
              var changeOwnershipMessage = {
                caseId: _self.selectedCase.id,
                userId: _self.context.user.id,
                type: 90,
                data: "Chat ownership denied to  - " + transferTo,
                timestamp: new Date()
              };

              _self.$resource(apiBasePath + 'Cases/Creator/ItemWithNotify?mid=' + _self.context.currentRole.membershipId).save(changeOwnershipMessage).$promise.then(function (response) {
                _self.selectedCase.isFileUploadInProcess = false;
                if (response.type > 0) {

                  var item = response.payload;
                  item.timestamp = item.timestamp + 'NEW-MESSAGE';
                  _self.selectedCase.items.push(item);
                  _self.updateItems([item]);
                }
              }).catch(function () {
                _self.selectedCase.isFileUploadInProcess = false;
              });
            }
          }).catch(function () {
            _self.selectedCase.isFileUploadInProcess = false;
          });
        }
      });
    }
  }, {
    key: 'exitCase',
    value: function exitCase() {
      var _self = this;
      _self.swangular.swal({
        title: 'Exit this chat',
        text: "",
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, exit!'
      }).then(function (result) {
        if (result.value) {
          _self.$resource(apiBasePath + 'Cases/LeaveCase?mId=' + _self.context.currentRole.membershipId + "&caseId=" + _self.selectedCase.id).save().$promise.then(function (response) {
            if (response.type > 0) {
              _self.loadPage();
              _self.selectedCase = undefined;
              _self.swangular.swal("Success", "You have successfully exited from this chat.", 'success');
            }
          });
        }
      });
    }
  }, {
    key: 'requestCaseOwnership',
    value: function requestCaseOwnership() {

      var _self = this;
      _self.$mdSidenav('moreActionsMobile').close();
      var transferTo = this.userService.getUserDisplayName();

      this.swangular.swal({
        title: 'Request ownership',
        html: 'You are requesting ownership for this chat. Are you sure you would like to continue?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        focusConfirm: false
      }).then(function (result) {
        if (result.value) {

          _self.$resource(apiBasePath + 'CaseTransfer/CreateRequest').get({
            mId: _self.context.currentRole.membershipId,
            caseId: _self.selectedCase.id
          }).$promise.then(function (response) {

            if (response.type > 0) {
              /**  Notify a request has been made for ownership start **/

              var changeOwnershipMessage = {
                caseId: _self.selectedCase.id,
                userId: _self.context.user.id,
                type: 90,
                data: "Chat ownership transfer requested by  - " + transferTo,
                timestamp: new Date()
              };

              _self.$resource(apiBasePath + 'Cases/Creator/ItemWithNotify?mid=' + _self.context.currentRole.membershipId).save(changeOwnershipMessage).$promise.then(function (response) {
                _self.selectedCase.isFileUploadInProcess = false;
                if (response.type > 0) {

                  var item = response.payload;
                  item.timestamp = item.timestamp + 'NEW-MESSAGE';
                  _self.selectedCase.items.push(item);
                  _self.updateItems([item]);
                }
              }).catch(function () {
                _self.selectedCase.isFileUploadInProcess = false;
              });

              /**  Notify a request has been made for ownership end **/
            }
          }).catch();
        }
      });
    }
  }, {
    key: 'archiveThisCase',
    value: function archiveThisCase(self) {

      var _self = void 0;
      if (self) _self = self;else _self = this;

      _self.swangular.swal({
        title: 'Archive this chat',
        text: "This action will close the case. You will no longer have access to it in Clinivid. If Clinivid is linked with your Electronic Medical Records, the chat will be saved to the patient's record.",
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, archive!'
      }).then(function (result) {
        if (result.value) {
          _self.deleteCaseOnConfirm(_self);
        }
      });
    }
  }, {
    key: 'deleteCaseOnConfirm',
    value: function deleteCaseOnConfirm(localScope) {
      var _this11 = this;

      var caseId2beDeleted = [];
      caseId2beDeleted.push(localScope.selectedCase.id);

      localScope.$resource(apiBasePath + 'Cases/Archive?mid=' + localScope.context.currentRole.membershipId, null, {
        'update': { method: 'PUT' }
      }).update(caseId2beDeleted).$promise.then(function (response) {
        if (response.type > 0) {

          var indexToRemove = -1;

          for (var n = 0; n < localScope.$scope.caseList.length; n++) {
            if (localScope.$scope.caseList[n].id === localScope.selectedCase.id) {
              indexToRemove = n;
              break;
            }
          }

          localScope.$scope.caseList.splice(indexToRemove, 1); // Need to remove the case from right hand side
          // console.log("Deleting Cases", localScope.$scope.caseList.length, this.currentCasesPagination);
          if (localScope.$scope.caseList.length == 0 && _this11.currentCasesPagination > 1) {
            if (_this11.currentCasesPagination > 1) {
              // console.log("Going to previous page", this.currentCasesPagination - 1);
              _this11.goToCasePage(_this11.currentCasesPagination - 1);
            } else {
              // console.log("Going to next page", this.currentCasesPagination + 1);
              _this11.goToCasePage(_this11.currentCasesPagination + 1);
            }
          }

          localScope.showMRN = false;

          localScope.selectedCase = undefined;
          localScope.totalUserCases = localScope.totalUserCases - 1;

          localScope.swangular.swal('Archived!', 'Your case has been archived.', 'success');
        }
      }).catch();
    }
  }, {
    key: 'getTotalAttachements',
    value: function getTotalAttachements() {
      if (this.selectedCase) {
        var attachementCount = 0;
        if (this.selectedCase.items) {
          for (var i = 0; i < this.selectedCase.items.length; i++) {
            var type = this.selectedCase.items[i].type;
            if (type && (type === 10 || type === 60 || type === 62 || type === 30 || type === 32)) attachementCount++;
          }
        }
        return attachementCount;
      } else return 0;
    }
  }, {
    key: 'getRecipientsFromCase',
    value: function getRecipientsFromCase(currentCase) {
      var recipientDisplayNames = [];
      currentCase.recipients.forEach(function (individualRecipient) {
        recipientDisplayNames.push(individualRecipient.displayName);
      });
      if (recipientDisplayNames.length > 0) recipientDisplayNames = recipientDisplayNames.slice(1);
      var recipientsFromCase = recipientDisplayNames.join();
      if (recipientsFromCase) return 'Clinician: ' + recipientDisplayNames.join('; ');else return '';
    }
  }, {
    key: 'validMessage',
    value: function validMessage(chat) {
      if (chat && (chat.type === 60 || chat.type === 40 || chat.type === 10 || chat.type === 30 || chat.type === 90) && !(!chat.data || 0 === chat.length)) return true;else return false;
    }
  }, {
    key: 'doesMessageBelongToMe',
    value: function doesMessageBelongToMe(chat, currentUserID) {
      if (currentUserID === chat.userId) return true;else false;
    }
  }, {
    key: 'filteredMessages',
    value: function filteredMessages() {
      var filteredMessages = [];

      if (this.displayChats) for (var i = 0; i < this.displayChats.length; i++) {
        if (this.validMessage(this.displayChats[i])) filteredMessages.push(this.displayChats[i]);
      }

      return filteredMessages;
    }
  }, {
    key: 'openVideoInPopup',
    value: function openVideoInPopup(userFilesrc) {

      /*
      var localDialog = this.$mdDialog;
       this.$mdDialog.show({
        template: '<md-dialog class="fullscreen-dialog">'+
         '<md-toolbar>'+
          '<div class="md-toolbar-tools">'+
            '<h2>Preview Video</h2>'+
            '<span flex></span>'+
            '<md-button class="md-icon-button" ng-click="close();">'+
              '<md-icon md-font-icon="icon-close-circle-outline" aria-label="Close dialog"></md-icon>'+
            '</md-button>'+
          '</div>'+
        '</md-toolbar>'+
        '<md-dialog-content class="video-content">'+
          '<video controls  name="media" ng-src="'+userFilesrc+'" controlsList="nodownload" oncontextmenu="return false;"'+
          'width="640px" height="360px"/>'+
        '</md-dialog-content>'+
        '</md-dialog>',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        fullscreen: true,
        ok: 'Close',
        scope: angular.extend(this.$scope.$new(), {close: function() {localDialog.cancel();}})
      }).then((response) => {
        // console.log("Ok", response);
      }, (response) => {
        // console.log("Cancel", response);
      });
      */

      this.swangular.swal({
        title: '',
        html: '<video style="width:100%;max-width:400px;" controls controlsList="nodownload"><source src="' + userFilesrc + '"></video>'
      });
    }
  }, {
    key: 'closePreview',
    value: function closePreview() {
      this.$mdDialog.close();
    }
  }, {
    key: 'openPDFInPopup',
    value: function openPDFInPopup(chatdata) {
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", chatdata, false); // false for synchronous request
      xmlHttp.send(null);
      var localDialog = this.$mdDialog;

      var pdfURL = chatdata + '#toolbar=0';

      /*
      this.$mdDialog.show({
        template: '<md-dialog>'+
        '<md-toolbar>'+
        '<div class="md-toolbar-tools">'+
        '<h2>Preview PDF</h2>'+
        '<span flex></span>'+
        '<md-button class="md-icon-button" ng-click="close();">'+
        '<md-icon md-font-icon="icon-close-circle-outline" aria-label="Close dialog"></md-icon>'+
        '</md-button>'+
        '</div>'+
        '</md-toolbar>'+
        // '<md-dialog-content>'+
        '<object width="1000" height="500" type="application/pdf" data="'+pdfURL+'" style="margin: auto; max-width: 100%;">'+
        // '</md-dialog-content>'+
        '</md-dialog>',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: true,
        ok: 'Close',
        scope: angular.extend(this.$scope.$new(), { close: function() {localDialog.cancel();} })
       });
       */

      this.swangular.swal({
        title: '',
        html: '<object width="1000px" height="500px" type="application/pdf" data="' + pdfURL + '" style="margin: auto; max-width: 100%;">'
      });
    }
  }, {
    key: 'updateItems',
    value: function updateItems(newItems) {
      this.displayChats = _.orderBy(_.uniqBy(this.displayChats.concat(this.prepareChats(newItems)), 'id'), ['timestamp'], ['asc']);

      var vidItem = _.find(newItems, function (i) {
        return i.type === 10;
      });

      if (vidItem && this.vidConfig) {

        this.vidConfig.sources[0] = { src: this.$sce.trustAsResourceUrl(vidItem.data), type: "video/mp4" };
      }
      // if(newItems && newItems.length > 0)
      //     console.log(newItems);
    }
  }, {
    key: 'updateItemsLocal',
    value: function updateItemsLocal(newItems, displayChats, prepareChatsLocal) {

      displayChats = _.orderBy(_.uniqBy(displayChats.concat(prepareChatsLocal(newItems)), 'id'), ['timestamp'], ['asc']);
    }
  }, {
    key: 'pollCase',
    value: function pollCase() {
      var _this12 = this;

      if (this.pollCaseResource) {
        // If select case Call is taking long time
        // Cancel Pending request in case a different case is selected
        this.pollCaseResource.$cancelRequest();
        this.isCasePollCancelled = true;
      }
      if (!this.selectedCase) return; // -Added Undefined check to stop errors

      var latestItemId = _.get(_.last(this.selectedCase.items), 'id', 0);

      this.pollCaseResource = this.$resource(apiBasePath + 'CasesWithAvailability').get({
        mId: this.context.currentRole.membershipId,
        build: 135,
        caseId: this.selectedCase.id
      });

      this.pollCaseResource.$promise.then(function (response) {

        // this.$analytics.eventTrack('Click', {  category: 'Button', label: 'user-viewed-case-success' });
        if (response.type > 0) {

          _this12.selectedCase = response.payload;
          if (!_.size(_.get(response.payload, 'items'))) {

            return;
          }

          // get latest video
          _this12.displayChats = _this12.prepareChats(response.payload.items);

          //Added code to update Gallery when new media is uploaded
          var tempGalery = [];
          for (var i = 0; i < response.payload.items.length; i++) {
            var itemType = response.payload.items[i].type;
            if (itemType === 30 || itemType === 10 || itemType === 60) {
              var media = {};
              media.id = response.payload.items[i].id;
              media.type = itemType;
              media.previewData = response.payload.items[i].previewData;
              media.data = response.payload.items[i].data;
              tempGalery.push(media);
            }
          }
          _this12.$scope.galery = tempGalery;

          var vidItem = _.find(response.payload.items, function (i) {
            return i.type === 10;
          });

          // console.log("Successfully updates from selected Case", response.payload);
        }
      }).catch(function (response) {
        // This code will fail silently
        // this.$analytics.eventTrack('Click', {  category: 'Button', label: 'user-viewed-case-error' });
        // this.app.popup("Error", "Sorry, an error has occured and we cannot continue. Please try again later.", 'Close');
      });
    }

    /**
    * Toggle checked status of the mail
    *
    * @param mail
    * @param event
    */

  }, {
    key: 'toggleCheck',
    value: function toggleCheck(caseData, event) {
      if (event) {
        event.stopPropagation();
      }

      var idx = this.checked.indexOf(caseData);

      if (idx > -1) {
        this.checked.splice(idx, 1);
      } else {
        this.checked.push(caseData);
      }
    }

    /**
    * Return checked status of the mail
    *
    * @param mail
    * @returns {boolean}
    */

  }, {
    key: 'isChecked',
    value: function isChecked(caseData) {
      return this.checked.indexOf(caseData) > -1;
    }

    /**
    * Open compose dialog
    *
    * @param ev
    */

  }, {
    key: 'composeDialog',
    value: function composeDialog(ev) {
      var newCase = {};
      this.$mdDialog.show({
        locals: {
          newCase: newCase
        },
        controller: 'ComposeDialogController',
        templateUrl: 'app/main/clinician/cases/dialogs/compose/compose-dialog.html',
        parent: angular.element(this.$document.body),
        //targetEvent: ev,
        clickOutsideToClose: false
      });
    }
  }, {
    key: 'getFractionRead',
    value: function getFractionRead(caseData) {
      var totalRecipients = caseData.recipients.length;
      var totalPeopleRead = 0;

      var lastItemID = caseData.latestItemId;

      for (var i = 0; i < caseData.recipients.length; i++) {
        if (caseData.recipients[i].lastItemReadId === lastItemID) totalPeopleRead++;
      }

      return totalPeopleRead + '/' + totalRecipients;
    }
  }, {
    key: 'getReadRecipientsName',
    value: function getReadRecipientsName(caseData) {
      if (caseData && caseData.recipients) {

        var lastItemID = caseData.latestItemId;
        var recipientDisplayNames = [];
        var isOwner = false;

        var _self = this;

        if (this.context.user && this.context.user.personId) {
          var currentuserId = this.context.user.personId;
          caseData.recipients.forEach(function (individualRecipient) {
            if (individualRecipient.lastItemReadId === lastItemID) {
              if (currentuserId === individualRecipient.id) {
                isOwner = true;
              } else {
                if (individualRecipient.hasOwnProperty('displayName')) {
                  recipientDisplayNames.push(individualRecipient.displayName);
                } else {
                  var displayName = _self.getDisplayName(individualRecipient.title, individualRecipient.firstname, individualRecipient.middleNames, individualRecipient.lastname);
                  recipientDisplayNames.push(displayName);
                }
              }
            }
          });

          if (isOwner) {
            recipientDisplayNames.push('You');
          }
          // if (recipientDisplayNames.length > 0) recipientDisplayNames = recipientDisplayNames.slice(1);
          return recipientDisplayNames.join('; ');
        }
      } else return "";
    }
  }, {
    key: 'getUnReadRecipientsName',
    value: function getUnReadRecipientsName(caseData) {

      if (caseData && caseData.recipients && this.context.user) {
        var lastItemID = caseData.latestItemId;
        var recipientDisplayNames = [];
        var isOwner = false;
        var currentuserId = this.context.user.personId;

        var _self = this;

        caseData.recipients.forEach(function (individualRecipient) {
          if (individualRecipient.lastItemReadId !== lastItemID) {
            if (currentuserId === individualRecipient.id) {
              isOwner = true;
            } else {
              if (individualRecipient.hasOwnProperty('displayName')) {
                recipientDisplayNames.push(individualRecipient.displayName);
              } else {
                var displayName = _self.getDisplayName(individualRecipient.title, individualRecipient.firstname, individualRecipient.middleNames, individualRecipient.lastname);
                recipientDisplayNames.push(displayName);
              }
            }
          }
        });

        if (isOwner) {
          recipientDisplayNames.push('You');
        } // To add at last
        //if (recipientDisplayNames.length > 0) recipientDisplayNames = recipientDisplayNames.slice(1);
        return recipientDisplayNames.join('; ');
      } else return "";
    }
  }, {
    key: 'howManyMessagesAreUnread',
    value: function howManyMessagesAreUnread(caseData) {
      var userIdOfCurrentUser = this.context.user.personId;
      var totalUnreadMessagesOnCurrentCase = 0;
      var totalItemCount = caseData.totalItemCount;

      if (caseData && caseData.items) {
        for (var j = 0; j < caseData.recipients.length; j++) {
          if (caseData.recipients[j].id === userIdOfCurrentUser) totalUnreadMessagesOnCurrentCase = totalItemCount - caseData.recipients[j].countItemsRead;
        }
      }
      return totalUnreadMessagesOnCurrentCase;
    }
  }, {
    key: 'getReadRecipients',
    value: function getReadRecipients(caseData) {
      var lastItemID = caseData.latestItemId;

      var readRecipients = [];

      for (var i = 0; i < caseData.recipients.length; i++) {
        if (caseData.recipients[i].lastItemReadId === lastItemID) readRecipients.push(caseData.recipients[i]);
      }
    }
  }, {
    key: 'calculateTimeSinceLastRead',
    value: function calculateTimeSinceLastRead(caseData) {
      if (caseData && caseData.updated) {
        var lastUpdateDate = new Date(caseData.updated + 'Z'); //.toLocaleString("en-AU", {timeZone: "Australia/Sydney"});

        var currentDate = new Date(); //.toLocaleString("en-AU", {timeZone: "Australia/Sydney"});

        var delta = Math.abs(currentDate.getTime() - lastUpdateDate.getTime());

        var seconds = Math.floor(delta / 1000);
        var minutes = Math.floor(seconds / 60);
        var hours = Math.floor(minutes / 60);
        var days = Math.floor(hours / 24);

        if (minutes === 0) return '1m';else if (hours === 0) return minutes + 'm';else if (days === 0) return hours + 'h';

        var monthsConst = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        return lastUpdateDate.getDate() + ' ' + monthsConst[lastUpdateDate.getMonth()];
      }
      return 'na';
    }
  }, {
    key: 'getRecipientNotification',
    value: function getRecipientNotification(chatData) {

      if (chatData) return chatData.replace("discussion", "the discussion");else return chatData;
    }
  }, {
    key: 'showReferenceNumber',
    value: function showReferenceNumber() {
      this.showMRN = true;
    }
  }, {
    key: 'handleDraftCase',
    value: function handleDraftCase(caseData) {
      this.$state.go('app.user.casecreation', { draftCase: caseData, casePage: this.currentCasesPagination });
    }
  }, {
    key: 'goToNextCaseList',
    value: function goToNextCaseList() {
      this.startPage = this.startPage + this.casesPerPage;
      this.endPage = this.endPage + this.casesPerPage;
      this.currentCasesPagination = this.currentCasesPagination + 1;
      this.loadPage();
      this.selectCase(null);
    }
  }, {
    key: 'goToPreviousCaseList',
    value: function goToPreviousCaseList() {
      this.startPage = this.startPage - this.casesPerPage;
      this.endPage = this.endPage - this.casesPerPage;
      this.currentCasesPagination = this.currentCasesPagination - 1;
      this.loadPage();
      this.selectCase(null);
    }
  }, {
    key: 'goToCasePage',
    value: function goToCasePage(page) {
      // console.log("going to page", page);
      this.selectCase(null);
      this.currentCasesPagination = page;
      this.loadPage();
    }
  }, {
    key: 'showPrevious',
    value: function showPrevious() {
      if (this.startPage > this.casesPerPage) return true;else false;
    }
  }, {
    key: 'showNext',
    value: function showNext() {
      if (this.endPage < this.totalUserCases) return true;else false;
    }
  }, {
    key: 'getLastMessageCount',
    value: function getLastMessageCount() {
      if (this.totalUserCases > this.endPage) return this.endPage;else return this.totalUserCases;
    }

    /**
    * Toggle sidenav
    *
    * @param sidenavId
    */

  }, {
    key: 'toggleSidenav',
    value: function toggleSidenav(sidenavId) {
      this.$mdSidenav(sidenavId).toggle();
    }
  }, {
    key: 'getTimeAndDateOfChat',
    value: function getTimeAndDateOfChat(date) {
      if (date.indexOf('NEW-MESSAGE') !== -1) {
        return this.app.getTimeAndDateOfChat(new Date().toString());
      }
      var local = new Date(date + 'Z');
      return this.app.getTimeAndDateOfChat(local.toString());
    }
  }, {
    key: 'getLatestMessageTimestamp',
    value: function getLatestMessageTimestamp(caseData) {

      // return null if no messages in case
      if (caseData.items == undefined || caseData.items.length == 0) {
        return null;
      } else {

        var latestCaseMessage = caseData.items.reduce(function (latestMessage, currentMessage) {

          var latestMessageTimestamp = new Date(latestMessage.timestamp);
          var currentMessageTimestamp = new Date(currentMessage.timestamp);
          return latestMessageTimestamp > currentMessageTimestamp ? latestMessage : currentMessage;
        });

        return new Date(latestCaseMessage.timestamp);
      }
    }
  }, {
    key: 'togglePatientEdit',
    value: function togglePatientEdit() {

      this.patient = this.selectedCase.patient;
      if (this.patient.dob) {
        this.patient.dob = this.moment(this.patient.dob, 'DD MMM YYYY').format('D-M-YYYY');
      }
      this.patientDOBsearch = undefined;
      this.patients = [];
      this.showNoPatienFoundText = false;
      this.searchPatientKeyWord = "";

      if (this.editPatientButtonText === "Search Patient") {
        this.editPatientButtonText = "+ Create/Edit patient";
      } else {
        this.editPatientButtonText = "Search Patient";
      }

      if (this.editPatientMode === "createNew") {
        this.editPatientMode = "searchExisting";
      } else {
        this.editPatientMode = "createNew";
      }
    }
  }, {
    key: 'openEditPatient',
    value: function openEditPatient() {
      this.$mdSidenav('moreActionsMobile').close();
      this.$mdSidenav('patient').toggle();
      this.editPatientButtonText = "+ Create/Edit patient";
      this.editPatientMode = "searchExisting";
      this.patientDOBsearch = undefined;
      this.patients = [];
      this.showNoPatienFoundText = false;
      this.searchPatientKeyWord = "";
    }
  }, {
    key: 'closePatientPanel',
    value: function closePatientPanel() {
      this.$mdSidenav('patient').close();
    }
  }, {
    key: 'changePatientThroughSearch',
    value: function changePatientThroughSearch(patient) {
      // Edit patient obtained through search

      this.selectedCase.isFileUploadInProcess = true;
      this.$mdSidenav('patient').close();

      var cloneSelectedCase = JSON.parse(JSON.stringify(this.selectedCase));
      cloneSelectedCase.patient = patient;
      cloneSelectedCase.patient.firstName = cloneSelectedCase.patient.firstname;
      cloneSelectedCase.patient.lastName = cloneSelectedCase.patient.lastname;
      delete cloneSelectedCase.patient.firstname;
      delete cloneSelectedCase.patient.lastname;

      var localResource = this.$resource;
      var localCaseId = this.selectedCase.id;
      var localUserId = this.context.user.id;
      var localMembershipId = this.context.currentRole.membershipId;
      var localScope = this;
      var modifierName = this.context.user.firstname + ' ' + this.context.user.lastname;

      this.$resource(apiBasePath + 'Cases/UpdateCaseRecipients?mid=' + this.context.currentRole.membershipId).save(cloneSelectedCase, function (response) {
        var _this13 = this;

        if (response.type > 0) {

          localScope.selectedCase = JSON.parse(JSON.stringify(cloneSelectedCase));

          if (response.payload && response.payload.patient) {
            localScope.selectedCase.patient = response.payload.patient;
            for (var l = 0; l < localScope.$scope.caseList.length; l++) {
              console.log('Looping');
              if (localScope.selectedCase.id === localScope.$scope.caseList[l].id) {
                console.log('selected case id match');
                localScope.$scope.caseList[l].patient = response.payload.patient;
              }
            }
          }

          // - Logic to send message after  removing patient
          var patientRemovedMessageItem = {
            caseId: localCaseId,
            userId: localUserId,
            type: 90,
            data: "Patient information Updated by - " + modifierName,
            timestamp: new Date()
          };

          localResource(apiBasePath + 'Cases/Creator/ItemWithNotify?mid=' + localMembershipId).save(patientRemovedMessageItem).$promise.then(function (response) {
            _this13.selectedCase.isFileUploadInProcess = false;
            if (response.type > 0) {

              var item = response.payload;
              item.timestamp = item.timestamp + 'NEW-MESSAGE';
              localScope.selectedCase.items.push(item);
              localScope.updateItems([item]);
            }
          }).catch(function () {
            _this13.selectedCase.isFileUploadInProcess = false;
          });
        }
      }, function () {
        this.selectedCase.isFileUploadInProcess = false;
      });
    }
  }, {
    key: 'validatePatientDOB',
    value: function validatePatientDOB(patientForm) {

      var startDate = this.moment(this.minPatientDOB, this.patientDOBFormat);
      var endDate = this.moment(this.maxPatientDOB, this.patientDOBFormat);
      if (this.patient.dob) {
        if (!this.moment(this.patient.dob, this.patientDOBFormat, true).isValid()) {
          patientForm.patientDOB.$setValidity('errorPatientDOBInvalidFormat', false);
          patientForm.patientDOB.$setValidity('invalidDateRange', true);
          return;
        } else if (!this.moment(this.patient.dob, this.patientDOBFormat).isBetween(startDate, endDate)) {
          patientForm.patientDOB.$setValidity('invalidDateRange', false);
          patientForm.patientDOB.$setValidity('errorPatientDOBInvalidFormat', true);
          return;
        }
        // else {
        //   patientForm.patientDOB.$setValidity('invalidDateRange', true);
        //   patientForm.patientDOB.$setValidity('errorPatientDOBInvalidFormat', true);
        // }
      }
      patientForm.patientDOB.$setValidity('invalidDateRange', true);
      patientForm.patientDOB.$setValidity('errorPatientDOBInvalidFormat', true);
    }
  }, {
    key: 'addNewPatientProfile',
    value: function addNewPatientProfile() {
      if (this.patient.dob) {
        this.patient.dob = this.moment(this.patient.dob, this.patientDOBFormat).format('M-D-YYYY');
      }

      this.selectedCase.isFileUploadInProcess = true;
      this.$mdSidenav('patient').close();

      var cloneSelectedCase = JSON.parse(JSON.stringify(this.selectedCase));
      cloneSelectedCase.patient = this.patient;

      delete cloneSelectedCase.patient.firstname;
      delete cloneSelectedCase.patient.lastname;

      var localResource = this.$resource;
      var localCaseId = this.selectedCase.id;
      var localUserId = this.context.user.id;
      var localMembershipId = this.context.currentRole.membershipId;
      var localScope = this;

      var modifierName = this.context.user.firstname + ' ' + this.context.user.lastname;

      this.$resource(apiBasePath + 'Cases/UpdateCaseRecipients?mid=' + this.context.currentRole.membershipId).save(cloneSelectedCase, function (response) {
        var _this14 = this;

        if (response.type > 0) {

          localScope.selectedCase = JSON.parse(JSON.stringify(cloneSelectedCase));

          if (response.payload && response.payload.patient) {
            localScope.selectedCase.patient = response.payload.patient;
            for (var l = 0; l < localScope.$scope.caseList.length; l++) {
              console.log('Looping');
              if (localScope.selectedCase.id === localScope.$scope.caseList[l].id) {
                console.log('selected case id match');
                localScope.$scope.caseList[l].patient = response.payload.patient;
              }
            }
          }

          // - Logic to send message after  removing patient
          var patientRemovedMessageItem = {
            caseId: localCaseId,
            userId: localUserId,
            type: 90,
            data: "Patient information Updated by - " + modifierName,
            timestamp: new Date()
          };

          localResource(apiBasePath + 'Cases/Creator/ItemWithNotify?mid=' + localMembershipId).save(patientRemovedMessageItem).$promise.then(function (response) {

            _this14.selectedCase.isFileUploadInProcess = false;

            if (response.type > 0) {

              var item = response.payload;
              item.timestamp = item.timestamp + 'NEW-MESSAGE';
              localScope.selectedCase.items.push(item);
              localScope.updateItems([item]);
              localScope.loadPage();
            }
          }).catch(function () {
            _this14.selectedCase.isFileUploadInProcess = false;
          });
        }
      }, function () {
        this.selectedCase.isFileUploadInProcess = false;
      });
    }
  }, {
    key: 'updateCasePriority',
    value: function updateCasePriority() {
      if (this.priority === this.selectedCase.priority) return;

      this.selectedCase.isFileUploadInProcess = true;

      var cloneSelectedCase = JSON.parse(JSON.stringify(this.selectedCase));

      cloneSelectedCase.priority = this.priority;

      var localResource = this.$resource;
      var localCaseId = this.selectedCase.id;
      var localUserId = this.context.user.id;
      var localMembershipId = this.context.currentRole.membershipId;
      var localScope = this;

      var modifierName = this.context.user.firstname + ' ' + this.context.user.lastname;

      this.$resource(apiBasePath + 'Cases/UpdateCaseRecipients?mid=' + this.context.currentRole.membershipId).save(cloneSelectedCase, function (response) {
        var _this15 = this;

        if (response.type > 0) {

          localScope.selectedCase = JSON.parse(JSON.stringify(cloneSelectedCase));

          // - Logic to send message after  removing patient
          var patientRemovedMessageItem = {
            caseId: localCaseId,
            userId: localUserId,
            type: 90,
            data: "Priority of Chat Updated by - " + modifierName,
            timestamp: new Date()
          };

          localResource(apiBasePath + 'Cases/Creator/ItemWithNotify?mid=' + localMembershipId).save(patientRemovedMessageItem).$promise.then(function (response) {

            _this15.selectedCase.isFileUploadInProcess = false;
            if (response.type > 0) {

              var item = response.payload;
              item.timestamp = item.timestamp + 'NEW-MESSAGE';
              localScope.selectedCase.items.push(item);
              localScope.updateItems([item]);
              localScope.loadPage();
            }
          }).catch(function () {
            _this15.selectedCase.isFileUploadInProcess = false;
          });
        }
      }, function () {
        this.selectedCase.isFileUploadInProcess = false;
      });
    }
  }, {
    key: 'checkThumbnailExists',
    value: function checkThumbnailExists(chat) {

      //
      // return  this.$http.get(chat.previewData, { cache: true}).then( function(result) {
      //     return chat.previewData;
      // },
      //   function failure(result){
      //     return chat.data;
      //   }
      // );

      // var xmlHttp = new XMLHttpRequest();
      // xmlHttp.open( "GET", chat.previewData, false ); // false for synchronous request
      // xmlHttp.send( null );
      //
      // if (xmlHttp.status === 200) {
      //   return chat.previewData;
      // }
      // else {
      //   return chat.data;
      // }
    }
  }, {
    key: 'queryTagSearch',
    value: function queryTagSearch(query) {
      var allTagsOfCurrentProfile = [];

      for (var i = 0; i < this.$scope.allTagsOfCurrentProfile.length; i++) {
        allTagsOfCurrentProfile.push(this.$scope.allTagsOfCurrentProfile[i].tag);
      }

      var unique_array_of_Tags = [];
      for (var _i7 = 0; _i7 < allTagsOfCurrentProfile.length; _i7++) {
        if (unique_array_of_Tags.indexOf(allTagsOfCurrentProfile[_i7]) == -1) {
          unique_array_of_Tags.push(allTagsOfCurrentProfile[_i7]);
        }
      }

      var removedAlreadyPresentTags4mSuggestion = [];

      for (var _i8 = 0; _i8 < unique_array_of_Tags.length; _i8++) {
        var isTagAlreadyPresent = false;
        for (var j = 0; j < this.$scope.selectedCaseTags.length; j++) {
          if (this.$scope.selectedCaseTags[j].tag === unique_array_of_Tags[_i8]) {
            isTagAlreadyPresent = true;
            break;
          }
        }
        if (!isTagAlreadyPresent) {
          removedAlreadyPresentTags4mSuggestion.push(unique_array_of_Tags[_i8]);
        }
      }

      var results = query ? removedAlreadyPresentTags4mSuggestion.filter(this.createFilterForTag(query)) : removedAlreadyPresentTags4mSuggestion;
      return results;
    }
  }, {
    key: 'createFilterForTag',
    value: function createFilterForTag(query) {
      var lowercaseQuery = query.toLowerCase();

      return function filterFn(tag) {
        return tag.toLowerCase().indexOf(lowercaseQuery) >= 0;
      };
    }
  }, {
    key: 'updateCaseTitle',
    value: function updateCaseTitle() {
      if (this.caseTitle === this.selectedCase.title) return;

      var cloneSelectedCase = JSON.parse(JSON.stringify(this.selectedCase));

      cloneSelectedCase.title = this.caseTitle;

      var localResource = this.$resource;
      var localCaseId = this.selectedCase.id;
      var localUserId = this.context.user.id;
      var localMembershipId = this.context.currentRole.membershipId;
      var localScope = this;

      var modifierName = this.context.user.firstname + ' ' + this.context.user.lastname;

      this.$resource(apiBasePath + 'Cases/UpdateCaseRecipients?mid=' + this.context.currentRole.membershipId).save(cloneSelectedCase, function (response) {
        if (response.type > 0) {

          localScope.selectedCase = JSON.parse(JSON.stringify(cloneSelectedCase));

          // - Logic to send message after  removing patient
          var patientRemovedMessageItem = {
            caseId: localCaseId,
            userId: localUserId,
            type: 90,
            data: "Chat Title has been updated by - " + modifierName,
            timestamp: new Date()
          };

          localResource(apiBasePath + 'Cases/Creator/ItemWithNotify?mid=' + localMembershipId).save(patientRemovedMessageItem).$promise.then(function (response) {

            if (response.type > 0) {

              var item = response.payload;
              item.timestamp = item.timestamp + 'NEW-MESSAGE';
              localScope.selectedCase.items.push(item);
              localScope.updateItems([item]);
            }
          }).catch();
        }
      }, function () {});
    }
  }, {
    key: 'showCaseList',
    value: function showCaseList() {
      this.selectedCase = null;
    }

    // createVideoConference(){
    //   this.resetConferenceOptions();
    //   this.$mdSidenav('createVideoConferenceSettings').toggle();
    // }

  }, {
    key: 'addTagOnEnter',
    value: function addTagOnEnter(keyEvent) {

      if (keyEvent.which === 13) {
        var autoChild = this.$document[0].getElementById('autoCompleteTag').firstElementChild;
        var el = angular.element(autoChild);
        el.scope().$mdAutocompleteCtrl.hidden = true;
        this.addTagToCase(this);
      }
    }
  }, {
    key: 'showTags',
    value: function showTags(self) {

      var _self = void 0;
      if (self) _self = self;else _self = this;

      _self.$scope.loadingTagsInProgress = true;
      _self.$scope.tagSearchText = '';

      _self.$mdSidenav('allCaseTags').toggle();

      var req = {
        method: 'GET',
        url: mdtBaseURL + 'tags/cases/' + this.selectedCase.id,
        headers: {
          'Accept': 'application/json',
          'x-clinivid-useremail': _self.userService.authentication.userName,
          'app-backend': 'newint'
        }
      };

      var getAllOrganizationTags = {
        method: 'GET',
        url: mdtBaseURL + 'tags/orgs/' + _self.selectedCase.creator.orgId,
        headers: {
          'Accept': 'application/json',
          'x-clinivid-useremail': _self.userService.authentication.userName,
          'app-backend': 'newint'
        }
      };

      this.$http(req).then(function (response) {

        if (response && response.data && response.data.success) {
          _self.$scope.selectedCaseTags = response.data.payload;
        }
        _self.$scope.loadingTagsInProgress = false;
      }, function () {
        _self.$scope.loadingTagsInProgress = false;
      });

      this.$http(getAllOrganizationTags).then(function (response) {
        if (response && response.data && response.data.success) {
          _self.$scope.allTagsOfCurrentProfile = response.data.payload;
        }
        _self.$scope.loadingTagsInProgress = false;
      }, function () {
        _self.$scope.loadingTagsInProgress = false;
      });
    }
  }, {
    key: 'isTagDuplicate',
    value: function isTagDuplicate() {

      for (var i = 0; i < this.$scope.selectedCaseTags.length; i++) {
        if (this.$scope.selectedCaseTags[i].tag === this.$scope.tagSearchText) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: 'addTagToCase',
    value: function addTagToCase(_self) {

      if (!_self) {
        _self = this;
      }

      if (_self.$scope.tagSearchText.trim().length === 0) return;
      if (this.isTagDuplicate()) return; //Not adding duplicate Tags


      var req = {
        method: 'POST',
        url: mdtBaseURL + 'tags',
        headers: {
          'Accept': 'application/json',
          'x-clinivid-useremail': _self.userService.authentication.userName
        },
        data: {
          "userId": _self.context.user.personId,
          "orgId": _self.selectedCase.creator.orgId,
          "caseId": _self.selectedCase.id,
          "tag": _self.$scope.tagSearchText
        }
      };

      _self.$http(req).then(function (response) {

        if (response && response.data && response.data.success) {
          var newTag = {
            "tag": _self.$scope.tagSearchText,
            "tagId": response.data.payload.tagId,
            "caseId": _self.selectedCase.id,
            "orgId": _self.context.currentRole.orgId
          };
          _self.$scope.selectedCaseTags.unshift(newTag);
          _self.$scope.tagSearchText = "";
          var autoChild = _self.$document[0].getElementById('autoCompleteTag').firstElementChild;
          var el = angular.element(autoChild);
          el.scope().$mdAutocompleteCtrl.hidden = true;
          _self.$document[0].getElementById('scripted').focus();
        }
      }, function () {});
    }
  }, {
    key: 'deleteTagFromModel',
    value: function deleteTagFromModel(tag) {
      var prunedTags = [];

      for (var i = 0; i < this.$scope.selectedCaseTags.length; i++) {
        if (this.$scope.selectedCaseTags[i].tagId === tag.tagId) {
          continue;
        } else {
          prunedTags.push(this.$scope.selectedCaseTags[i]);
        }
      }

      this.$scope.selectedCaseTags = prunedTags;
    }
  }, {
    key: 'deleteTag',
    value: function deleteTag(tag) {

      var _self = this;

      this.deleteTagFromModel(tag);

      var req = {
        method: 'DELETE',
        url: mdtBaseURL + 'tags/' + tag.tagId,
        headers: {
          'Accept': 'application/json',
          'x-clinivid-useremail': _self.userService.authentication.userName,
          'app-backend': 'newint'
        },
        data: {
          "userId": _self.context.user.personId,
          "orgId": _self.context.currentRole.orgId,
          "caseId": _self.selectedCase.id,
          "tag": tag.tag
        }
      };

      this.$http(req).then(function (response) {}, function (response) {});
    }
  }, {
    key: 'toggleAddContact',
    value: function toggleAddContact(mode) {
      if (mode == 'NOW') {
        this.resetConferenceOptions();
      } else if (mode == 'LATER') {
        this.$scope.videoConferenceMode = 'LATER';
        this.$document[0].getElementById('scheduleNow').checked = false;
        this.$document[0].getElementById('scheduleLater').checked = true;
        this.videoConferenceDate = new Date();
        this.videoConferenceTime = new Date();
        this.videoConferenceDuration = 60;
      }
    }

    // closeVideoConferenceSettings() {
    //   this.$mdSidenav('createVideoConferenceSettings').close();
    // }

  }, {
    key: 'closeCaseTags',
    value: function closeCaseTags() {
      this.$mdSidenav('allCaseTags').close();
      this.$scope.tagSearchText = '';
    }
  }, {
    key: 'openTagMobile',
    value: function openTagMobile() {
      this.$mdSidenav('moreActionsMobile').close();
      this.showTags(this);
    }
  }, {
    key: 'closeMoreActions',
    value: function closeMoreActions() {
      this.$mdSidenav('moreActionsMobile').close();
    }
  }, {
    key: 'resetConferenceOptions',
    value: function resetConferenceOptions() {
      this.$scope.videoConferenceMode = 'NOW';
      this.$document[0].getElementById('scheduleNow').checked = true;
      this.$document[0].getElementById('scheduleLater').checked = false;
      this.videoConferenceDate = new Date();
      this.videoConferenceTime = new Date();
      this.videoConferenceDuration = 60;
    }

    // createMeeting(now){
    //
    //     this.$mdSidenav('createVideoConferenceSettings').close();
    //
    //     this.$mdDialog.show({
    //       template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
    //       parent: angular.element(document.body)
    //     });
    //
    //     this.now = now;
    //     this.generateTokenFromTotalConnect(this);
    // }

  }, {
    key: 'getDateTimeDuration',
    value: function getDateTimeDuration(_self) {
      if (_self.now) {
        //Set Video Conference now !
        _self.videoConferenceDate = new Date();
        _self.videoConferenceTime = new Date();
        _self.videoConferenceDuration = 60;
      }

      var month = _self.videoConferenceDate.getMonth() + 1;
      var day = _self.videoConferenceDate.getDate();
      var year = _self.videoConferenceDate.getFullYear();

      var meetingDate = day + '/' + month + '/' + year;

      var hour = _self.videoConferenceTime.getHours();
      var minutes = _self.videoConferenceTime.getMinutes();
      var h = hour % 12 || 12;
      var ampm = hour < 12 || hour === 24 ? "AM" : "PM";

      var meetingTime = h + ':' + minutes + ' ' + ampm;

      this.meetingTime = meetingTime;
      this.meetingDate = meetingDate;

      var dateTimeDurationConfig = {
        'Date': meetingDate,
        'Time': meetingTime,
        'Duration': _self.videoConferenceDuration
      };

      return dateTimeDurationConfig;
    }
  }, {
    key: 'generateTokenFromTotalConnect',
    value: function generateTokenFromTotalConnect(_self) {
      var userID = 'clinivid_' + _self.context.user.id + '@teleconnect.me';
      var totalConnectData = 'grant_type=tenant_credentials&username=' + userID + '&api_key=' + _self.totalConnect_api_key + '&api_secret=' + _self.totalConnect_api_secret;

      _self.$http.post(_self.videoConferenceBaseURL + 'auth/token', totalConnectData, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        _self.localStorageService.set('keyTrustToken', response.data.access_token);
        _self.setupMeeting(_self);
      }).catch(function (err, status) {
        _self.$mdDialog.hide();
        _self.swangular.swal({
          type: 'error',
          title: '',
          html: 'Failed to create video conference.Please contact support'
        });
      });
    }
  }, {
    key: 'setupMeeting',
    value: function setupMeeting(_self) {
      var keyTrustToken = _self.localStorageService.get('keyTrustToken');
      var dateTimeDurationConfig = _self.getDateTimeDuration(_self);
      _self.dateTimeDurationConfig = dateTimeDurationConfig;

      var httpHeaders = void 0;

      if (_self.now) {
        httpHeaders = { //should not sent Content-Type if meeting is mow
          'Accept': 'application/json',
          'TC-API-Access-Token': keyTrustToken
        };
      } else {
        httpHeaders = {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json',
          'TC-API-Access-Token': keyTrustToken
        };
      }

      var meetingDetails = 'date=' + dateTimeDurationConfig['Date'] + '&time=' + dateTimeDurationConfig['Time'] + '&duration=' + dateTimeDurationConfig['Duration'];
      _self.$http.post(_self.videoConferenceBaseURL + 'vc', meetingDetails, {
        headers: httpHeaders
      }).then(function (response) {
        _self.videoConferenceLink = response.data.joinlink;
        _self.vcid = response.data.vcid;
        _self.addParticipantsToVideoChat(_self);
      }).catch(function (err, status) {
        _self.$mdDialog.hide();

        _self.swangular.swal({
          type: 'error',
          title: '',
          html: 'Failed to create video conference.Please contact support'
        });
      });
    }
  }, {
    key: 'addParticipantsToVideoChat',
    value: function addParticipantsToVideoChat(_self) {

      _self.recipientsEmail = [];

      this.$resource(apiBasePath + 'Contact/PageWithAvailability2').get({
        mId: _self.context.currentRole.membershipId,
        page: 1,
        pageSize: 100
      }).$promise.then(function (response) {
        if (response.type > 0) {
          var profileSpecificContacts = response.payload.items;

          for (var i = 0; i < _self.selectedCase.recipients.length; i++) {
            for (var j = 0; j < profileSpecificContacts.length; j++) {
              if (profileSpecificContacts[j].personId == _self.selectedCase.recipients[i].id && profileSpecificContacts[j].personId !== _self.context.user.id) {
                if (profileSpecificContacts[j].email && profileSpecificContacts[j].email.trim().length) _self.recipientsEmail.push(profileSpecificContacts[j].email);
              }
            }
          }

          _self.participantLinks = [];

          if (_self.recipientsEmail && _self.recipientsEmail.length > 0) {
            var inviteParticipantsArray = [];

            var _loop3 = function _loop3(_i9) {

              var inviteDetails = 'vcid=' + _self.vcid + '&email=' + _self.recipientsEmail[_i9];

              // Generate Invite for other people in the case

              var inviteIndividualparticipant = _self.$http.post(_self.videoConferenceBaseURL + 'vc/' + _self.vcid + '/participant/add', inviteDetails, {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Accept': 'application/json',
                  'TC-API-Access-Token': _self.localStorageService.get('keyTrustToken')
                }
              }).then(function (response) {

                var participantLinkDetail = {
                  email: _self.recipientsEmail[_i9],
                  participantLink: response.data.joinlink
                };

                _self.participantLinks.push(participantLinkDetail);
              }).catch(function (err, status) {

                _self.$mdDialog.hide();

                _self.swangular.swal({
                  type: 'error',
                  title: '',
                  html: 'Failed to create video conference.Please contact support'
                });
              });

              inviteParticipantsArray.push(inviteIndividualparticipant);
            };

            for (var _i9 = 0; _i9 < _self.recipientsEmail.length; _i9++) {
              _loop3(_i9);
            }

            if (inviteParticipantsArray.length > 0) {
              _self.$q.all(inviteParticipantsArray).then(function () {

                if (_self.videoConferenceLink) {
                  _self.addMeetingDetailsToChat(_self);
                }
              });
            } else return;
          }
        }
      }).catch(function () {});
    }
  }, {
    key: 'isThisAVideoMeeting',
    value: function isThisAVideoMeeting(data) {
      try {
        JSON.parse(data);
      } catch (e) {
        return false;
      }
      return true;
    }
  }, {
    key: 'transferCase',
    value: function transferCase() {
      var _self = this;
      // User might be the owner of the case but we need to find out which membership ID this case he created.

      var caseCreatedWithMembershipId = void 0;
      _self.$mdSidenav('moreActionsMobile').close();

      var creatorOrgId = _self.selectedCase.creator.orgId;
      var caseId = _self.selectedCase.id;

      for (var j = 0; j < this.context.roles.length; j++) {
        if (this.context.roles[j].orgId === creatorOrgId) caseCreatedWithMembershipId = this.context.roles[j].membershipId;
      }

      if (!caseCreatedWithMembershipId) {
        return;
      }

      _self.$scope.pendingCaseTransfers = [];

      _self.$resource(apiBasePath + 'CaseTransfer/GetTransferRequest').get({
        mId: caseCreatedWithMembershipId
      }).$promise.then(function (response) {
        if (response.type > 0) {
          if (response.payload && response.payload.length > 0) {
            for (var i = 0; i < response.payload.length; i++) {
              if (response.payload[i].caseId === caseId) {
                _self.$scope.pendingCaseTransfers.push(response.payload[i]);
              }
            }

            if (_self.$scope.pendingCaseTransfers.length > 0) {
              _self.$scope.changeOwnerRequestSearch = '';
              _self.$mdSidenav('transferOwnership').toggle();
            } else {
              _self.swangular.swal({
                type: 'info',
                title: '',
                html: 'There is no pending ownership requests for this chat.'
              });
            }
          } else {
            _self.swangular.swal({
              type: 'info',
              title: '',
              html: 'There is no pending ownership requests for this chat.'
            });
          }
        }
      }).catch();
    }

    /*
    openVideoConferenceInSeperateTab(data){
      try {
        let videoConferenceDetails = JSON.parse(data);
        let videoLink ;
         if (this.selectedCase.creator.personId === this.context.user.personId){ // You are the owner hence send the moderator Link
          videoLink=videoConferenceDetails.videoLink;
        }
        else {
           for(let i = 0 ; i < videoConferenceDetails.ParticipantLink.length; i++){
               if(videoConferenceDetails.ParticipantLink[i].email === this.userService.authentication.userName){
                 videoLink= videoConferenceDetails.ParticipantLink[i].participantLink;
               }
           }
        }
        if(videoLink && this.isHyperLink(videoLink)) {
          let win=this.$window.open(videoLink, '_blank');
          win.focus();
        }
       } catch (e) {
        return;
      }
    }
    */

  }, {
    key: 'isHyperLink',
    value: function isHyperLink(testString) {
      var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
      if (regex.test(testString)) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'getVideoConferenceDisplayMessage',
    value: function getVideoConferenceDisplayMessage(data) {
      var result = "Scheduled video conference";

      try {
        var videoConferenceDetails = JSON.parse(data);

        if (videoConferenceDetails && (videoConferenceDetails.Date || videoConferenceDetails.Time || videoConferenceDetails.Duration)) {
          if (videoConferenceDetails.Date) result += ' on ' + videoConferenceDetails.Date;
          if (videoConferenceDetails.Time) result += ' at ' + videoConferenceDetails.Time;
          if (videoConferenceDetails.Duration) result += ' for ' + videoConferenceDetails.Duration + ' minutes';
        } else {
          result += ' now';
        }
      } catch (e) {
        return;
      }

      return result;
    }
  }, {
    key: 'addMeetingDetailsToChat',
    value: function addMeetingDetailsToChat(_self) {
      var _this16 = this;

      var videoConferenceDetails = void 0;
      if (_self.now) {
        videoConferenceDetails = {
          'videoLink': _self.videoConferenceLink,
          'ParticipantLink': _self.participantLinks
        };
      } else {
        videoConferenceDetails = {
          'videoLink': _self.videoConferenceLink,
          'Date': _self.dateTimeDurationConfig.Date,
          'Time': _self.dateTimeDurationConfig.Time,
          'Duration': _self.dateTimeDurationConfig.Duration,
          'ParticipantLink': _self.participantLinks
        };
      }

      var videoMeetingDetails = {
        caseId: _self.selectedCase.id,
        userId: _self.context.user.id,
        type: 90,
        data: JSON.stringify(videoConferenceDetails),
        timestamp: new Date()
      };

      _self.$resource(apiBasePath + 'Cases/Creator/ItemWithNotify?mid=' + _self.context.currentRole.membershipId).save(videoMeetingDetails).$promise.then(function (response) {

        _this16.selectedCase.isFileUploadInProcess = false;
        if (response.type > 0) {
          var item = response.payload;
          item.timestamp = item.timestamp + 'NEW-MESSAGE';
          _self.selectedCase.items.push(item);
          _self.updateItems([item]);
          _self.loadPage();
          _self.$mdDialog.hide();
          if (_self.now) {
            var win = _this16.$window.open(_self.videoConferenceLink, '_blank');
            win.focus();
          }
        }
      }).catch(function () {
        _self.$mdDialog.hide();
        _self.selectedCase.isFileUploadInProcess = false;
        _self.swangular.swal({
          type: 'error',
          title: '',
          html: 'Failed to create video conference.Please contact support'
        });
      });
    }
  }, {
    key: 'mobileCheck',
    value: function mobileCheck() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }

    /**
     * Get timezone for Australian state
     * @param {string} state - Australian state code (e.g., 'NSW', 'VIC')
     * @returns {string} IANA timezone string, defaults to 'Australia/Sydney'
     */

  }, {
    key: '_getTimezoneForState',
    value: function _getTimezoneForState(state) {
      // Australian state to timezone mapping
      var STATE_TIMEZONE_MAP = {
        'NSW': 'Australia/Sydney',
        'VIC': 'Australia/Melbourne',
        'QLD': 'Australia/Brisbane',
        'SA': 'Australia/Adelaide',
        'WA': 'Australia/Perth',
        'TAS': 'Australia/Hobart',
        'NT': 'Australia/Darwin',
        'ACT': 'Australia/Sydney'
      };
      return STATE_TIMEZONE_MAP[state] || 'Australia/Sydney';
    }
  }, {
    key: 'downloadCaseInPDF',
    value: function downloadCaseInPDF() {
      var _this17 = this;

      this.$mdSidenav('moreActionsMobile').close();

      this.swangular.swal('Downloading chat', 'Chat download has been initiated.This may take a while.', 'success');

      var caseTitle = this.selectedCase.title;
      if (!caseTitle) caseTitle = 'Untitled Chat';
      var patientName = this.userService.getLongName(this.selectedCase.patient);
      if (!patientName) patientName = 'Undisclosed';
      var caseMediaPrepend = patientName + '_' + caseTitle + '_';

      // Fetch organisation state before generating PDF
      var organisationState = null;
      var organisationTimezone = 'Australia/Sydney'; // Default timezone
      var orgId = this.selectedCase.creator.orgId;

      this.$http.get(apiBasePathNoAuth + '/organisations/getstate?orgId=' + orgId).then(function (response) {
        if (response.data && response.data.success) {
          organisationState = response.data.payload.state;
          organisationTimezone = _this17._getTimezoneForState(organisationState);
        }
      }).catch(function (error) {
        console.error('Failed to fetch organisation state:', error);
      }).finally(function () {
        // Continue with PDF generation regardless of API success/failure
        _this17._generatePDF(caseTitle, patientName, caseMediaPrepend, organisationTimezone);
      });
    }

    /**
     * Internal method to generate PDF after fetching organisation state
     * @param {string} caseTitle - The case title
     * @param {string} patientName - The patient name
     * @param {string} caseMediaPrepend - Prefix for media files
     * @param {string} organisationTimezone - IANA timezone string (e.g., 'Australia/Sydney')
     */

  }, {
    key: '_generatePDF',
    value: function _generatePDF(caseTitle, patientName, caseMediaPrepend, organisationTimezone) {
      var _this18 = this;

      var doc = new jsPDF();

      var makeName = function makeName(creator) {
        if (!creator) {
          return "undisclosed";
        }
        if (creator.title && creator.firstname && creator.lastname) {
          return creator.title + ' ' + creator.lastname + ', ' + creator.firstname;
        } else if (!creator.title && creator.firstname && creator.lastname) {
          return creator.lastname + ', ' + creator.firstname;
        } else if (creator.title && !creator.firstname && creator.lastname) {
          return creator.title + ' ' + creator.lastname;
        } else if (creator.title && creator.firstname && !creator.lastname) {
          return creator.title + ' ' + creator.firstname;
        } else {
          return "undisclosed";
        }
      };

      var makeDOB = function makeDOB(patient) {
        if (!patient || !patient.dob) return "";

        return " - " + patient.dob;
      };

      var _self = this;
      var makeDate = function makeDate(isoString, fallbackTime) {
        // Remove 'NEW-MESSAGE' flag if present
        if (isoString && typeof isoString === 'string' && isoString.indexOf('NEW-MESSAGE') !== -1) {
          isoString = isoString.replace('NEW-MESSAGE', '');
        }

        // If timestamp is empty/undefined after stripping, use fallback time field for new items
        if (!isoString || isoString === 'undefined') {
          isoString = fallbackTime;
        }

        if (!isoString) return '';

        // Parse as UTC using moment.utc(), then convert to Date for timezone formatting
        var caseTime = _self.moment.utc(isoString).toDate();

        return caseTime.toLocaleString('en-AU', {
          timeZone: organisationTimezone,
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          hour12: true
        });
      };

      if (!Promise.prototype.finally) {
        Promise.prototype.finally = Promise.prototype.finally || {
          finally: function _finally(fn) {
            var onFinally = function onFinally(cb) {
              return Promise.resolve(fn()).then(cb);
            };
            return this.then(function (result) {
              return onFinally(function () {
                return result;
              });
            }, function (reason) {
              return onFinally(function () {
                throw reason;
              });
            });
          }
        }.finally;
      }

      var makeBase64Thumbnail = function makeBase64Thumbnail(url) {
        // url += "&time="+(new Date()).getTime(); // this line of code made magic.

        var xhr = new XMLHttpRequest();

        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();

        return new Promise(function (resolve, reject) {
          xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
              // callback(reader.result);
              var data = {
                'url': url,
                'data': reader.result
              };
              resolve(data);
            };
            reader.readAsDataURL(xhr.response);
          };
        });
      };

      function checkFailed(then) {
        return function (responses) {
          var someFailed = responses.some(function (response) {
            return response.error;
          });

          if (someFailed) {
            throw responses;
          }

          return then(responses);
        };
      }

      function arrayBufferToBase64(buffer) {
        var binary = '';
        var bytes = [].slice.call(new Uint8Array(buffer));

        bytes.forEach(function (b) {
          return binary += String.fromCharCode(b);
        });

        return window.btoa(binary);
      };

      function senderName(name) {
        return name + " |";
      }

      var maxLeft = 15;
      var textLeft = 24;

      var maxRight = doc.internal.pageSize.getWidth() - maxLeft;

      var textCenter = doc.internal.pageSize.getWidth() / 2;

      var maxHeight = doc.internal.pageSize.getHeight() - 15;

      var startHeight = 25;
      var spaceHeight = 6;
      var spaceWidth = 3;

      var maxFontSize = 30;
      var mediumFontSize = 20;
      var normalFontSize = 16;
      var smallFontSize = 12;
      var smallestFontSize = 11;

      var discussionHeightFactor = void 0,
          discussionStartHeightFactor = void 0;

      function mediaToPDF(thumbnails, messages, recipients) {
        var discussionHeightFactor = discussionStartHeightFactor + 1.5;

        itemLoop: for (var m = 0; m < messages.length; m++) {

          var item = messages[m];

          var itemSender = void 0;

          for (var j = 0; j < recipients.length; j++) {
            var recipient = recipients[j];
            if (item.personId == recipient.id) itemSender = recipient;
          }

          doc.setFontStyle('bold');
          doc.setFontSize(smallestFontSize);

          doc.text(senderName(itemSender.displayName), textLeft, startHeight + discussionHeightFactor * spaceHeight, {
            'align': 'left'
          });

          doc.setFontStyle('normal');
          var _spaceForDetail = doc.getTextWidth(senderName(itemSender.displayName)) + spaceWidth;
          doc.text(makeDate(item.timestamp, item.time), textLeft + _spaceForDetail, startHeight + discussionHeightFactor * spaceHeight, {
            'align': 'left'
          });

          doc.setFontSize(smallFontSize);

          var deltaHeight = void 0;

          switch (item.type) {
            case 32:
              break;
            case 30:
              {
                // get promise for  base64 thumbnail
                var imageThumbnail = void 0;

                imageThumbnailLoop: for (var k = 0; k < thumbnails.length; k++) {
                  var thumbnail = thumbnails[k];

                  if (item.previewData == thumbnail.url) {
                    // if(item.data == thumbnail.url) {
                    imageThumbnail = thumbnail;
                    break imageThumbnailLoop;
                  }
                }
                // let thumbnail = await makeBase64Thumbnail(item.previewData);

                discussionHeightFactor += 1;
                doc.text('[Image]', textLeft, startHeight + discussionHeightFactor * spaceHeight, {
                  'align': 'left'
                });

                // put thumbnail
                try {
                  doc.addImage(imageThumbnail.data, 'JPEG', textLeft, startHeight + (discussionHeightFactor + 0.5) * spaceHeight, 80, 60);
                  discussionHeightFactor += 11;
                } catch (err) {

                  doc.setTextColor('#FFFFFF');

                  doc.text('Thumbnail not available', textLeft, startHeight + (discussionHeightFactor + 1) * spaceHeight, {
                    'align': 'left'
                  });

                  doc.setTextColor('#000000');

                  discussionHeightFactor += 2;
                }
                // update discussionHeightFactor

                discussionHeightFactor = (discussionHeightFactor * spaceHeight + 9) / spaceHeight + 0.4;

                // conitnue loop
                if ((discussionHeightFactor + 3) * spaceHeight + startHeight >= maxHeight && m < messages.length - 1) {
                  discussionHeightFactor = 1;
                  doc.addPage();
                }

                continue itemLoop;
              }
            case 62:
              break;
            case 12:
              break;
            case 10:
              {
                // let thumbnail = await makeBase64Thumbnail(item.previewData);

                var videoThumbnail = void 0;
                videoThumbnailLoop: for (var _k = 0; _k < thumbnails.length; _k++) {
                  var _thumbnail = thumbnails[_k];
                  if (item.previewData == _thumbnail.url) {
                    videoThumbnail = _thumbnail;
                    break videoThumbnailLoop;
                  }
                }

                discussionHeightFactor += 1;
                doc.text('[Video]', textLeft, startHeight + discussionHeightFactor * spaceHeight, {
                  'align': 'left'
                });

                // put thumbnail
                // doc.addImage(videoThumbnail.data, 'JPEG', textLeft, startHeight + ((discussionHeightFactor + 0.5 )*spaceHeight), 90, 60);
                try {
                  doc.addImage(videoThumbnail.data, 'JPEG', textLeft, startHeight + (discussionHeightFactor + 0.5) * spaceHeight, 90, 60);
                  // doc.addImage(imageThumbnail.data, 'JPEG', textLeft, startHeight + ((discussionHeightFactor + 0.5 )*spaceHeight), 80, 60);
                  discussionHeightFactor += 11;
                } catch (err) {
                  doc.setTextColor('#FFFFFF');

                  doc.text('Thumbnail not available', textLeft, startHeight + (discussionHeightFactor + 1) * spaceHeight, {
                    'align': 'left'
                  });

                  doc.setTextColor('#000000');

                  discussionHeightFactor += 1;
                }

                // discussionHeightFactor +=11
                discussionHeightFactor = (discussionHeightFactor * spaceHeight + 9) / spaceHeight + 0.4;

                if ((discussionHeightFactor + 3) * spaceHeight + startHeight >= maxHeight && m < messages.length - 1) {
                  discussionHeightFactor = 1;
                  doc.addPage();
                }

                continue itemLoop;
              }
            case 60:
              {
                // get promise for  base64 thumbnail
                // let thumbnail = await makeBase64Thumbnail(item.previewData);
                var pdfThumbnail = void 0;
                pdfThumbnailLoop: for (var _k2 = 0; _k2 < thumbnails.length; _k2++) {
                  var _thumbnail2 = thumbnails[_k2];
                  if (item.previewData == _thumbnail2.url) {
                    pdfThumbnail = _thumbnail2;
                    break pdfThumbnailLoop;
                  }
                }

                discussionHeightFactor += 1;
                doc.text('[PDF]', textLeft, startHeight + discussionHeightFactor * spaceHeight, {
                  'align': 'left'
                });

                // put thumbnail
                // doc.addImage(pdfThumbnail.data, 'JPEG', textLeft, startHeight + ((discussionHeightFactor + 0.5 )*spaceHeight), 60, 60);
                // update discussionHeightFactor
                try {
                  // doc.addImage(imageThumbnail.data, 'JPEG', textLeft, startHeight + ((discussionHeightFactor + 0.5 )*spaceHeight), 80, 60);
                  doc.addImage(pdfThumbnail.data, 'JPEG', textLeft, startHeight + (discussionHeightFactor + 0.5) * spaceHeight, 60, 60);
                  discussionHeightFactor += 11;
                } catch (err) {
                  doc.setTextColor('#FFFFFF');

                  doc.text('Thumbnail not available', textLeft, startHeight + (discussionHeightFactor + 1) * spaceHeight, {
                    'align': 'left'
                  });

                  doc.setTextColor('#000000');

                  discussionHeightFactor += 1;
                }

                // discussionHeightFactor +=11
                discussionHeightFactor = (discussionHeightFactor * spaceHeight + 9) / spaceHeight + 0.4;

                // conitnue loop
                if ((discussionHeightFactor + 3) * spaceHeight + startHeight >= maxHeight && m < messages.length - 1) {
                  discussionHeightFactor = 1;
                  doc.addPage();
                }

                continue itemLoop;
              }
            default:
              {
                if (item.data) {
                  var lineHeight = 4.33;
                  var textMessage = item.data.replace(/<br\s*\/?>/gi, '\n');
                  var allLines = doc.splitTextToSize(textMessage, maxRight - 30);
                  var totalLines = allLines.length;
                  var _deltaHeight = totalLines * lineHeight;

                  // console.log("HEIGHT FACTOR", discussionHeightFactor, deltaHeight);
                  doc.text(allLines, textLeft, startHeight + (discussionHeightFactor + 1) * spaceHeight, {
                    'align': 'left'
                  });

                  // discussionHeightFactor = (((discussionHeightFactor + 1)*spaceHeight) + deltaHeight)/spaceHeight;
                  discussionHeightFactor = ((discussionHeightFactor + 1.2) * spaceHeight + _deltaHeight + 1) / spaceHeight + 0.4;
                  if ((discussionHeightFactor + 3) * spaceHeight + startHeight >= maxHeight && m < messages.length - 1) {
                    discussionHeightFactor = 1;
                    doc.addPage();
                  }
                }

                continue itemLoop;
              }
          }
        }
      }

      // All Promise Request mediaFiles to base64
      // Download Case items
      if (this.selectedCase.items && this.selectedCase.items.length > 0) {

        var allMediaPromises = []; // promise for all s3 media items
        var allThumbnails = []; // promise for all s3 media items

        mediaLoop: for (var i = 0; i < this.selectedCase.items.length; i++) {
          // loop over case messages for all s3 media urls

          var item = this.selectedCase.items[i];
          if (!item.previewData) {
            // if only text message
            continue mediaLoop;
          } else {
            // if media message

            // console.log("THUMBNAIL", item.previewData);
            // if(item.type==30){
            //   allMediaPromises.push(makeBase64Thumbnail(item.data));
            // }
            allMediaPromises.push(makeBase64Thumbnail(item.previewData));
            allThumbnails.push(item);
          }
        }

        // Hack so on promise.all() doesn't throw error on if one of the promises fails
        var allMediaPromisesResolved = allMediaPromises.map(function (promise) {
          return promise.catch(function (error) {
            return { error: error };
          });
        });

        if (window.fetch) {
          Promise.all(allThumbnails.map(function (u) {
            return fetch(u.previewData, {

              'cache': 'reload'

            });
          })).then(function (responses) {
            return Promise.all(responses.map(function (res) {
              // response.arrayBuffer().then((buffer) => {
              return res.arrayBuffer().then(function (buffer) {
                // var base64Flag = 'data:image/jpeg;base64,';
                // var base64Flag = 'base64,';
                var imageStr = arrayBufferToBase64(buffer);
                var messageId = void 0,
                    messageType = void 0,
                    messageUrl = void 0;
                for (var _i10 = 0; _i10 < allThumbnails.length; _i10++) {
                  var message = allThumbnails[_i10];
                  if (message.previewData == res.url) {
                    messageId = message.id;
                    messageType = message.type;
                    messageUrl = message.previewData;
                  }
                }
                // document.querySelector('img').src = base64Flag + imageStr;
                // return base64Flag + imageStr;
                // return imageStr;
                return {
                  'data': imageStr,
                  'id': messageId,
                  'type': messageType,
                  'url': messageUrl
                };
              });
              // return res.blob();
            }));
          }).then(function (allMedia) {

            mediaToPDF(allMedia, _this18.selectedCase.items, _this18.selectedCase.recipients);
          }).finally(function (data) {
            var zip = new JSZip();

            var makeZipFileName = function makeZipFileName(downloadCase) {
              var patientName = makeName(downloadCase.patient);
              var caseName = downloadCase.title || "Untitled";
              if (patientName.toUpperCase() == 'UNDISCLOSED') {
                return caseName + ".zip";
              } else {
                return patientName + "-" + caseName + ".zip";
              }
            };
            // let zipFileName = "Clinivid-"+ (this.selectedCase.title || "Untitled") + ".zip"
            var zipFileName = makeZipFileName(_this18.selectedCase);
            zip.file((_this18.selectedCase.title || "Untitled") + ".pdf", doc.output('arraybuffer'));

            var hyperMedias = [];
            var count = 0;

            for (var _i11 = 0; _i11 < _this18.selectedCase.items.length; _i11++) {

              var _item = _this18.selectedCase.items[_i11];

              if (_item.type === 10 || _item.type === 30 || _item.type === 60) {
                // hyperMedias.push(item.data);
                hyperMedias.push(_item);
                // allHyperMediaPromisesResolved.push(makeBase64MediaFiles(item.data, item.id, item.type));
              }
            }

            if (hyperMedias.length == 0) {

              var downloaderName = _this18.context.user.firstname + ' ' + _this18.context.user.lastname;

              var caseDownloadNotification = {
                caseId: _this18.selectedCase.id,
                userId: _this18.context.user.id,
                type: 90,
                data: 'Chat has been downloaded by - ' + downloaderName,
                timestamp: new Date()
              };

              _this18.$resource(apiBasePath + 'Cases/Creator/ItemWithNotify?mid=' + _this18.context.currentRole.membershipId).save(caseDownloadNotification).$promise.then(function (response) {

                _this18.selectedCase.isFileUploadInProcess = false;
                if (response.type > 0) {
                  var _item2 = response.payload;
                  _item2.timestamp = _item2.timestamp + 'NEW-MESSAGE';
                  _this18.selectedCase.items.push(_item2);
                  _this18.updateItems([_item2]);
                  _this18.loadPage();
                }
              }).catch();

              zip.generateAsync({ type: 'blob' }).then(function (content) {
                saveAs(content, zipFileName);
              });
            } else {

              Promise.all(hyperMedias.map(function (u) {
                return fetch(u.data, {

                  'cache': 'reload'

                });
              })).then(function (responses) {
                return Promise.all(responses.map(function (res) {
                  return res.arrayBuffer().then(function (buffer) {
                    var imageStr = arrayBufferToBase64(buffer);
                    var messageId = void 0,
                        messageType = void 0;
                    for (var _i12 = 0; _i12 < hyperMedias.length; _i12++) {
                      var message = hyperMedias[_i12];
                      if (message.data == res.url) {
                        messageId = message.id;
                        messageType = message.type;
                      }
                    }
                    return {
                      'data': imageStr,
                      'id': messageId,
                      'type': messageType
                    };
                  });
                }));
              }).then(function (allMedia) {

                allMedia.forEach(function (media) {
                  var fileName = "media/" + caseMediaPrepend + media.id;
                  if (media.type === 10) {
                    fileName += ".mp4";
                  } else if (media.type === 30) {
                    fileName += ".jpg";
                  } else if (media.type === 60) {
                    fileName += ".pdf";
                  }

                  zip.file(fileName, media.data, { base64: true });
                });
                // zip.file(fileName, texts[0]);
              }).finally(function (data) {
                var downloaderName = _this18.context.user.firstname + ' ' + _this18.context.user.lastname;

                var caseDownloadNotification = {
                  caseId: _this18.selectedCase.id,
                  userId: _this18.context.user.id,
                  type: 90,
                  data: 'Chat has been downloaded by - ' + downloaderName,
                  timestamp: new Date()
                };

                _this18.$resource(apiBasePath + 'Cases/Creator/ItemWithNotify?mid=' + _this18.context.currentRole.membershipId).save(caseDownloadNotification).$promise.then(function (response) {

                  _this18.selectedCase.isFileUploadInProcess = false;
                  if (response.type > 0) {
                    var _item3 = response.payload;
                    _item3.timestamp = _item3.timestamp + 'NEW-MESSAGE';
                    _this18.selectedCase.items.push(_item3);
                    _this18.updateItems([_item3]);
                    _this18.loadPage();
                  }
                }).catch();

                zip.generateAsync({ type: 'blob' }).then(function (content) {
                  saveAs(content, zipFileName);
                });
              });
            }
          });
        } else {

          Promise.all(allMediaPromisesResolved).then(checkFailed(function () {
            for (var _len = arguments.length, mediaResponses = Array(_len), _key = 0; _key < _len; _key++) {
              mediaResponses[_key] = arguments[_key];
            }

            if (_this18.selectedCase.items && _this18.selectedCase.items.length > 0) {

              var thumbnailFiles = [];
              for (var _i13 = 0; _i13 < _this18.selectedCase.items.length; _i13++) {

                var item = _this18.selectedCase.items[_i13];
                if (mediaResponses[0] && mediaResponses[0].length) {
                  mediaFilesLoop: for (var k = 0; k < mediaResponses[0].length; k++) {

                    var mediaFile = mediaResponses[0][k];
                    if (item.previewData == mediaFile.url) {
                      // if(item.data==mediaFile.url) {
                      thumbnailFiles.push(mediaFile);
                      break mediaFilesLoop;
                    }
                  }
                }
              }

              mediaToPDF(thumbnailFiles, _this18.selectedCase.items, _this18.selectedCase.recipients);
            }
          })).catch(function () {
            for (var _len2 = arguments.length, mediaResponses = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              mediaResponses[_key2] = arguments[_key2];
            }

            var thumbnailFiles = [];
            for (var _i14 = 0; _i14 < _this18.selectedCase.items.length; _i14++) {

              var item = _this18.selectedCase.items[_i14];
              if (mediaResponses[0] && mediaResponses[0].length) {
                mediaFilesLoop: for (var k = 0; k < mediaResponses[0].length; k++) {

                  var mediaFile = mediaResponses[0][k];
                  if (item.previewData == mediaFile.url) {
                    // if(item.data==mediaFile.url) {
                    thumbnailFiles.push(mediaFile);
                    break mediaFilesLoop;
                  }
                }
              }
            }

            mediaToPDF(thumbnailFiles, _this18.selectedCase.items, _this18.selectedCase.recipients);
          }).finally(function () {

            var zip = new JSZip();

            var zipFileName = "Clinivid-" + (_this18.selectedCase.title || "Untitled") + ".zip";
            zip.file((_this18.selectedCase.title || "Untitled") + ".pdf", doc.output('arraybuffer'));

            var makeBase64MediaFiles = function makeBase64MediaFiles(imgUrl, id, type) {

              var xhr = new XMLHttpRequest();

              xhr.open('GET', imgUrl);
              xhr.responseType = 'blob';
              xhr.send();

              return new Promise(function (resolve, reject) {

                xhr.onload = function () {
                  // console.log("READING");
                  var reader = new FileReader();
                  reader.onloadend = function () {

                    var mediaData = reader.result.replace(/^data:(image|video|application)\/(xml|png|jpg|jpeg|pdf|mp4);base64,/, "");
                    var data = {
                      'url': imgUrl,
                      // 'data': reader.result,
                      'data': mediaData,
                      // 'data': xhr.response,
                      'id': id,
                      'type': type
                    };
                    resolve(data);
                  };
                  reader.readAsDataURL(xhr.response);
                };
              });
            };

            var hyperMedias = [];
            var count = 0;
            var allHyperMediaPromisesResolved = [];

            for (var _i15 = 0; _i15 < _this18.selectedCase.items.length; _i15++) {

              var _item4 = _this18.selectedCase.items[_i15];

              if (_item4.type === 10 || _item4.type === 30 || _item4.type === 60) {
                // hyperMedias.push(item.data);
                hyperMedias.push(_item4);
                allHyperMediaPromisesResolved.push(makeBase64MediaFiles(_item4.data, _item4.id, _item4.type));
              }
            }

            // doc.save();

            if (hyperMedias.length == 0) {

              var downloaderName = _this18.context.user.firstname + ' ' + _this18.context.user.lastname;

              var caseDownloadNotification = {
                caseId: _this18.selectedCase.id,
                userId: _this18.context.user.id,
                type: 90,
                data: 'Chat has been downloaded by - ' + downloaderName,
                timestamp: new Date()
              };

              _this18.$resource(apiBasePath + 'Cases/Creator/ItemWithNotify?mid=' + _this18.context.currentRole.membershipId).save(caseDownloadNotification).$promise.then(function (response) {

                _this18.selectedCase.isFileUploadInProcess = false;
                if (response.type > 0) {
                  var _item5 = response.payload;
                  _item5.timestamp = _item5.timestamp + 'NEW-MESSAGE';
                  _this18.selectedCase.items.push(_item5);
                  _this18.updateItems([_item5]);
                  _this18.loadPage();
                }
              }).catch();

              zip.generateAsync({ type: 'blob' }).then(function (content) {
                saveAs(content, zipFileName);
              });
            } else {

              Promise.all(allHyperMediaPromisesResolved).then(checkFailed(function () {
                for (var _len3 = arguments.length, mediaResponses = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                  mediaResponses[_key3] = arguments[_key3];
                }

                // let fileName = "media/"+item.id;

                for (var _i16 = 0; _i16 < mediaResponses[0].length; _i16++) {
                  var _item6 = mediaResponses[0][_i16];

                  var fileName = "media/" + _item6.id;
                  if (_item6.type === 10) {
                    fileName += ".mp4";
                  } else if (_item6.type === 30) {
                    fileName += ".jpg";
                  } else if (_item6.type === 60) {
                    fileName += ".pdf";
                  } else {
                    continue;
                  }
                  console.log("ZIP FILE Media", _item6);
                  // zip.file(fileName, item.data);
                  zip.file(fileName, _item6.data, { 'base64': true });
                }
              })).catch(function () {
                for (var _len4 = arguments.length, mediaResponses = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                  mediaResponses[_key4] = arguments[_key4];
                }

                // let fileName = "media/"+item.id;
                for (var _i17 = 0; _i17 < mediaResponses.length; _i17++) {
                  var _item7 = mediaResponses[_i17];
                  var fileName = "media/" + _item7.id;
                  if (_item7.type === 10) {
                    fileName += ".mp4";
                  } else if (_item7.type === 30) {
                    fileName += ".jpg";
                  } else if (_item7.type === 60) {
                    fileName += ".pdf";
                  }

                  // zip.file(fileName, item.data);
                  zip.file(fileName, _item7.data, { 'base64': true });
                  // zip.file(fileName, item.data, {'binary': true});
                }
                // let fileName = "media/"+item.id;
              }).finally(function (data) {
                var downloaderName = _this18.context.user.firstname + ' ' + _this18.context.user.lastname;

                var caseDownloadNotification = {
                  caseId: _this18.selectedCase.id,
                  userId: _this18.context.user.id,
                  type: 90,
                  data: 'Chat has been downloaded by - ' + downloaderName,
                  timestamp: new Date()
                };

                _this18.$resource(apiBasePath + 'Cases/Creator/ItemWithNotify?mid=' + _this18.context.currentRole.membershipId).save(caseDownloadNotification).$promise.then(function (response) {

                  _this18.selectedCase.isFileUploadInProcess = false;
                  if (response.type > 0) {
                    var _item8 = response.payload;
                    _item8.timestamp = _item8.timestamp + 'NEW-MESSAGE';
                    _this18.selectedCase.items.push(_item8);
                    _this18.updateItems([_item8]);
                    _this18.loadPage();
                  }
                }).catch();

                zip.generateAsync({ type: 'blob' }).then(function (content) {
                  saveAs(content, zipFileName);
                });
              });
            }
          });
        }
      }

      doc.setFontSize(maxFontSize);
      doc.setTextColor('#b91d5c');
      doc.text(this.selectedCase.title || 'Untitled Chat', textCenter, startHeight, {
        'align': 'center'
      });
      doc.setTextColor('#000000');

      doc.line(maxLeft, startHeight + spaceHeight, maxRight, startHeight + spaceHeight);

      doc.setFontSize(smallFontSize);

      doc.text('Last updated:', textLeft, startHeight + 3 * spaceHeight, {
        'align': 'left'
      });

      doc.setTextColor('#b91d5c');
      doc.setFontStyle('bold');

      var spaceForDetail = doc.getTextWidth('Last updated:') + spaceWidth;
      doc.text(makeDate(this.selectedCase.updated, null), textLeft + spaceForDetail, startHeight + 3 * spaceHeight, {
        'align': 'left'
      });

      doc.setTextColor('#000000');
      doc.setFontStyle('normal');

      doc.text('Creator:', textLeft, startHeight + 4.5 * spaceHeight, {
        'align': 'left'
      });

      doc.setTextColor('#b91d5c');
      doc.setFontStyle('bold');

      spaceForDetail = doc.getTextWidth('Creator:') + spaceWidth;
      doc.text(makeName(this.selectedCase.creator), textLeft + spaceForDetail, startHeight + 4.5 * spaceHeight, {
        'align': 'left'
      });

      doc.setTextColor('#000000');
      doc.setFontStyle('normal');

      doc.text('Patient:', textLeft, startHeight + 6 * spaceHeight, {
        'align': 'left'
      });

      doc.setTextColor('#b91d5c');
      doc.setFontStyle('bold');

      spaceForDetail = doc.getTextWidth('Patient:') + spaceWidth;
      doc.text(makeName(this.selectedCase.patient) + makeDOB(this.selectedCase.patient), textLeft + spaceForDetail, startHeight + 6 * spaceHeight, {
        'align': 'left'
      });

      doc.setTextColor('#000000');
      doc.setFontStyle('normal');

      doc.text('Participants:', textLeft, startHeight + 8 * spaceHeight, {
        'align': 'left'
      });

      doc.setFontSize(smallestFontSize);

      var participantStartHeightFactor = 9;
      var participantHeightFactor = void 0;

      if (this.selectedCase.recipients.length >= 0) {
        for (var _i18 = 0; _i18 < this.selectedCase.recipients.length; _i18++) {

          participantHeightFactor = participantStartHeightFactor + _i18;
          var participant = this.selectedCase.recipients[_i18];
          doc.text(participant.displayName, textLeft, startHeight + participantHeightFactor * spaceHeight, {
            'align': 'left'
          });
        }
      }

      // TODO: dynamic message display
      // TODO: customise type of message text, image, pdf, vide    doc.setFontSize(normalFontSize);
      doc.setTextColor('#b91d5c');
      doc.setFontSize(smallFontSize);

      discussionStartHeightFactor = participantHeightFactor + 2;
      doc.text('Discussion items:', textLeft, startHeight + discussionStartHeightFactor * spaceHeight, {
        'align': 'left'
      });

      doc.setTextColor('#000000');
    }
  }, {
    key: 'openCaseMenu',
    value: function openCaseMenu($mdMenu, ev) {
      $mdMenu.open(ev);
    }
  }]);

  return ClinicianCaseCtlr;
}();

angular.module('app.clinician').component('clinicianCases', {
  controller: ClinicianCaseCtlr,
  templateUrl: 'app/main/clinician/cases/cases.html'
}).directive('paginationScroll', function ($rootScope) {
  // provide scrolling on button click if more than 8 pages
  var stepSize = 41; // width of page button
  var currentStep = 0; // initial no scroll
  return {
    restrict: 'C',
    // require: 'ngModel',
    link: function link(scope, element, attrs, ctrl) {
      scope.$watch('$parent.maxSteps', function (steps) {
        if (steps > 0) {
          // HACK if more than 8 pages style from 'center' to 'flex-start'
          element[0].style['justify-content'] = 'flex-start';
        }
      });

      // console.log("pagination scroll", element, scope);
      scope.$on('move.right', function () {
        // console.log("moving right");
        if (currentStep < scope.$parent.maxSteps) currentStep += 1; // Can't scroll right beyond available pages
        element.animate({ 'scrollLeft': currentStep * stepSize }, 100);
      });
      scope.$on('move.left', function () {
        // console.log("moving right");
        if (currentStep > 0) currentStep -= 1; // Can't scroll less than available
        element.animate({ 'scrollLeft': currentStep * stepSize }, 100);
      });
    }
  };
}).directive('caseViewOverlay', function () {
  return {
    restrict: 'C',
    link: function link(scope, element, attrs, ctrl) {
      scope.$on('show.loader', function () {
        element[0].style['display'] = 'block';
      });
      scope.$on('hide.loader', function () {
        element[0].style['display'] = 'none';
      });
    }
  };
}).directive('disableContextMenu', function () {
  return {
    restrict: 'C',
    scope: {},
    link: function link(scope, element, attrs, ctrl) {
      element.on("contextmenu", function (e) {

        e.preventDefault();
      }, false);
    }
  };
});


'use strict';

(function () {
    'use strict';

    angular.module('app.admin', ['ngMaterial', 'ngMessages']).config(config).run(run);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.admin', {
            url: '/admin',
            views: {
                'content@app': {
                    template: '<admin></admin>'
                }
                /*,
                resolve: {
                    AdminData: function (msApi)
                    {
                        return msApi.resolve('admin@get');
                    }
                }*/
            } }).state('app.admin.home', {
            url: '/home',
            views: {
                'content@app': {
                    template: '<admin></admin>'
                }
                /*,
                resolve: {
                    AdminData: function (msApi) {
                        return msApi.resolve('sample@get');
                    }
                }*/
            } }).state('app.admin.org', {
            url: '/org',
            views: {
                'content@app': {
                    template: '<org></org>'
                }
                /*,
                resolve: {
                    AdminData: function (msApi) {
                        return msApi.resolve('sample@get');
                    }
                }*/
            } }).state('app.admin.org.view', {
            url: '/view?id',
            views: {
                'content@app': {
                    template: '<org-view></org-view>'
                }
                /*,
                resolve: {
                    AdminData: function (msApi) {
                        return msApi.resolve('sample@get');
                    }
                }*/
            } }).state('app.admin.org.add', {
            url: '/add',
            views: {
                'content@app': {
                    template: '<org-add></org-add>'
                }
                /*,
                resolve: {
                    AdminData: function (msApi) {
                        return msApi.resolve('sample@get');
                    }
                }*/
            } }).state('app.admin.org.edit', {
            url: '/edit?id',
            views: {
                'content@app': {
                    template: '<org-edit></org-edit>'
                }
                /*,
                resolve: {
                    Org: function (apiResolver, $stateParams)
                    {
                        return apiResolver.resolve('organisations.getById@get', { 'id': $stateParams.id });
                    }
                }
                /*,
                resolve: {
                    AdminData: function (msApi) {
                        return msApi.resolve('sample@get');
                    }
                }*/
            } }).state('app.admin.people', {
            url: '/people',
            views: {
                'content@app': {
                    template: '<people></people>'
                }
                /*,
                resolve: {
                    AdminData: function (msApi) {
                        return msApi.resolve('sample@get');
                    }
                }*/
            } }).state('app.admin.people.view', {
            url: '/view?id',
            views: {
                'content@app': {
                    template: '<person-view></person-view>'
                }
                /*,
                resolve: {
                    AdminData: function (msApi) {
                        return msApi.resolve('sample@get');
                    }
                }*/
            } }).state('app.admin.people.add', {
            url: '/add',
            views: {
                'content@app': {
                    template: '<person-add></person-add>'
                }
                /*,
                resolve: {
                    AdminData: function (msApi) {
                        return msApi.resolve('sample@get');
                    }
                }*/
            } }).state('app.admin.people.edit', {
            url: '/edit?id',
            views: {
                'content@app': {
                    template: '<person-edit></person-edit>'
                }
                /*,
                resolve: {
                    Org: function (apiResolver, $stateParams)
                    {
                        return apiResolver.resolve('organisations.getById@get', { 'id': $stateParams.id });
                    }
                }
                /*,
                resolve: {
                    AdminData: function (msApi) {
                        return msApi.resolve('sample@get');
                    }
                }*/
            } }).state('app.admin.clinician', {
            url: '/clinician',
            views: {
                'content@app': {
                    template: '<admin></admin>'
                }
                /*,
                resolve: {
                    AdminData: function (msApi) {
                        return msApi.resolve('sample@get');
                    }
                }*/
            } }).state('app.admin.clinician.add', {
            url: '/add',
            views: {
                'content@app': {
                    template: '<clinician-admin></clinician-admin>'
                }
                /*,
                resolve: {
                    Org: function (apiResolver, $stateParams)
                    {
                        return apiResolver.resolve('organisations.getById@get', { 'id': $stateParams.id });
                    }
                }
                /*,
                resolve: {
                    AdminData: function (msApi) {
                        return msApi.resolve('sample@get');
                    }
                }*/
            } }).state('app.admin.cases', {
            url: '/cases',
            views: {
                'content@app': {
                    template: '<cases></cases>'
                }
                /*,
                resolve: {
                    AdminData: function (msApi) {
                        return msApi.resolve('sample@get');
                    }
                }*/
            } });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/admin');
    }

    function showMenu(msNavigationService) {
        // Navigation
        /*msNavigationService.saveItem('admin', {
            title: 'ADMIN INTERFACE',
            group: true,
            weight: 3,
            state: 'app.admin'
        });*/

        msNavigationService.saveItem('admin_home', {
            title: 'Home',
            icon: 'icon-home',
            state: 'app.admin.home',
            //group: true,
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'ADMIN.ADMIN_NAV_HOME',
            weight: 3
        });

        msNavigationService.saveItem('admin_organisations', {
            title: 'Organisations',
            icon: 'icon-hospital-building',
            state: 'app.admin.org',
            //group: true,
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'ADMIN.ADMIN_NAV_ORG',
            weight: 3
        });

        msNavigationService.saveItem('admin_people', {
            title: 'People',
            icon: 'icon-human-male-female',
            state: 'app.admin.people',
            //group: true,
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'ADMIN.ADMIN_NAV_PEOPLE',
            weight: 3
        });

        msNavigationService.saveItem('admin_cases', {
            title: 'Chats',
            icon: 'icon-folder-multiple-outline',
            state: 'app.admin.cases',
            //group: true,
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'ADMIN.ADMIN_NAV_CASES',
            weight: 3
        });
    }

    function hideMenu(msNavigationService) {
        //msNavigationService.deleteItem('admin');
        msNavigationService.deleteItem('admin_home');
        msNavigationService.deleteItem('admin_organisations');
        msNavigationService.deleteItem('admin_people');
        msNavigationService.deleteItem('admin_cases');
    }

    function run($rootScope, $state, userService, msNavigationService) {
        $rootScope.$on('activeRoleChanged', function () {
            if (userService.context.currentRole.interface == 'admin') {
                showMenu(msNavigationService);
                $state.go('app.clinician.manageOrganisation');
            } else {
                hideMenu(msNavigationService);
            }
        });
    };
})();


'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrganisationCtlr = function () {
    function OrganisationCtlr($state, $resource, $stateParams, notificationDialog, $mdSidenav, api, appContext, userService) {
        'ngInject';

        var _this = this;

        _classCallCheck(this, OrganisationCtlr);

        this.$state = $state;
        this.$resource = $resource;
        this.notificationDialog = notificationDialog;
        this.$mdSidenav = $mdSidenav;
        this.api = api;
        this.userService = userService;

        //TODO restore this.org: Views and master copy should be held under this.org and considered immutable. this.form should be used for mutation and be a copy. isDirty checks will work this way if needed
        // this.org = {};
        this.app = appContext;
        this.context = userService.context;

        this.form = { org: {}, person: { isClinician: false } };

        // Data
        var orgId = $stateParams.id;
        if (orgId) {
            this.api.organisations.getById.get({ 'id': orgId }).$promise.then(function (response) {
                return _this.form.org = response;
            });
        }

        // this.watches($scope);
    }

    // watches($scope) {
    //   $scope.$watch(
    //     'vm.org',
    //     () => this.form = angular.copy(this.org),
    //     true
    //   );
    // }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */


    _createClass(OrganisationCtlr, [{
        key: 'toggleSidenav',
        value: function toggleSidenav(sidenavId) {
            this.$mdSidenav(sidenavId).toggle();
        }
    }, {
        key: 'scopeToOrg',
        value: function scopeToOrg() {
            if (this.form.org) this.userService.setCurrentOrg(this.form.org);
        }

        /**
         * Search
         *
         * @param search variable
         */

    }, {
        key: 'search',
        value: function search(varName) {
            var _this2 = this;

            var handleSuccess = function handleSuccess(isToggleSidenav) {
                return function (response) {
                    // console.log(response);
                    if (_.size(response.payload) === 0) {
                        _this2.app.popup("Nothing Found", 'No record was found with a name like: ' + _this2.form.org.nameQuery, 'Ok');
                    } else if (_.size(response.payload) === 1) {
                        _this2.$state.go('app.admin.org.view', { id: response.payload[0].id });
                    } else if (_.size(response.payload) > 1) {
                        _this2.results = angular.copy(response.payload);
                        _this2.toggleSidenav('sidenav');
                    }
                };
            };

            if (varName == 'name') {
                this.api.organisations.searchByName.get({ mId: this.context.currentRole.membershipId, nameQuery: this.form.org.nameQuery }).$promise.then(handleSuccess(true)).catch(function (response) {
                    if (response.status == 404) _this2.app.popup("Nothing Found", 'No record was found with a name like: ' + _this2.form.org.nameQuery, 'Ok');
                });
            } else if (varName == 'registeredId') {
                this.api.organisations.searchByRegId.get({ mId: this.context.currentRole.membershipId, registeredId: this.form.org.registeredId }).$promise.then(handleSuccess(false)).catch(function (response) {
                    if (response.status == 404) _this2.app.popup("Nothing Found", 'No record was found with ABN: ' + _this2.form.org.registeredId, 'Ok');
                });
            } else console.log("Error: unrecognised search type!");
        }

        /**
         * Submit stepper form
         *
         * @param ev
         */

    }, {
        key: 'submitStepper',
        value: function submitStepper(ev) {
            var _this3 = this;

            // You can do an API call here to send the form to your server
            this.$resource(apiBasePath + 'Organisations?mId=' + this.context.currentRole.membershipId).save(this.form).$promise.then(function (response) {
                console.log(response);
                if (response.type > 0) {
                    _this3.notificationDialog.show(response.payload.org.displayName + " Added", response.payload.org.displayName + " has been successfully added.");
                    _this3.$state.go('app.admin.org');
                } else if (response.type == 0) {
                    _this3.notificationDialog.show("Add Organisation Unsuccessful!", "Organisation could not be added because it already exists in the system." + response.message);
                } else _this3.notificationDialog.show("Add Organisation Unsuccessful!", "Sorry, we encountered an error in trying to add the organisation. " + response.message);
            }).catch(function (response) {
                _this3.notificationDialog.show("An error occurred", "Sorry, we encountered an error. Please try again later. " + response);
            });
        }

        /**
         * Submit edit form
         *
         * @param ev
         */

    }, {
        key: 'submitEdit',
        value: function submitEdit() {
            var _this4 = this;

            // You can do an API call here to send the form to your server

            this.api.organisations.edit.update(this.form.org).$promise.then(function (response) {
                _this4.$state.go('app.admin.org.view', { id: response.id });
            }).catch(function (response) {
                _this4.notificationDialog.show("Edit Organisation Unsuccessful!", "Sorry, we encountered an error in trying to update the organisation. " + response);
            });
        }
    }]);

    return OrganisationCtlr;
}();

angular.module('app.admin').component('cases', {
    controller: OrganisationCtlr,
    templateUrl: 'app/main/admin/cases/cases.html'
}).component('org', {
    controller: OrganisationCtlr,
    templateUrl: 'app/main/admin/organisations/org.html'
}).component('orgView', {
    controller: OrganisationCtlr,
    templateUrl: 'app/main/admin/organisations/org-view.html'
}).component('orgAdd', {
    controller: OrganisationCtlr,
    templateUrl: 'app/main/admin/organisations/org-add.html'
}).component('orgEdit', {
    controller: OrganisationCtlr,
    templateUrl: 'app/main/admin/organisations/org-edit.html'
});


'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ClinicianAdminCtlr = function () {
    function ClinicianAdminCtlr($state, $stateParams, notificationDialog, $mdSidenav, msApi, userService) {
        'ngInject';

        var _this = this;

        _classCallCheck(this, ClinicianAdminCtlr);

        this.$state = $state;
        this.$mdSidenav = $mdSidenav;
        this.msApi = msApi;
        this.notificationDialog = notificationDialog;

        this.userContext = userService.context;
        this.form = { person: { role: 'Clinician' } };

        var clinicianId = $stateParams.id;
        if (clinicianId) {
            msApi.organisations.getById.get({ 'id': orgId }).$promise.then(function (response) {
                return _this.org = response;
            });
        }
    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */


    _createClass(ClinicianAdminCtlr, [{
        key: 'toggleSidenav',
        value: function toggleSidenav(sidenavId) {
            this.$mdSidenav(sidenavId).toggle();
        }

        /**
         * Search
         *
         * @param search variable
         */

    }, {
        key: 'search',
        value: function search(varName) {
            var _this2 = this;

            var handleSuccess = function handleSuccess(response) {
                if (response.length == 1) {
                    _this2.$state.go('app.admin.org.view', { id: response[0].id });
                } else if (response.length > 1) {
                    _this2.org.results = angular.copy(response);
                }
            };

            var handleError = function handleError(queryName, queryValue) {
                return function (response) {
                    if (response.status == 404) {
                        _this2.notificationDialog.show("Nothing Found", 'No record was found with a ' + queryName + ' like: ' + queryValue);
                    }
                };
            };

            if (varName == 'name') {
                //console.log(vm.org.name);
                api.organisations.searchByName.query(this.org).$promise.then(handleSuccess).catch(handleError('Display Name', this.org.name));
            } else if (varName == 'registeredId') {
                //console.error(this.org.registeredId);
                api.organisations.searchByRegId.query(this.org).$promise.then(handleSuccess).catch(handleError('ABN', this.org.registeredId));
            } else console.log("Error: unrecognised search type!");
        }

        /**
         * Submit stepper form
         *
         * @param ev
         */

    }, {
        key: 'submitStepper',
        value: function submitStepper(ev) {
            var _this3 = this;

            this.form.person.OrgId = this.userContext.currentOrg.id;

            // You can do an API call here to send the form to your server
            this.msApi.request('clinicians@save', this.form.person).then(function (response) {
                _this3.notificationDialog.show(response.firstname + ' Added', response.firstname + ' has been successfully added.');
                _this3.$state.go('app.admin.people');
            }).catch(function (response) {
                _this3.notificationDialog.show("Add Clinician Unsuccessful!", "Sorry, we encountered an error in trying to add the clinician. " + response);
            });
        }

        /**
         * Submit stepper form
         *
         * @param ev
         */

    }, {
        key: 'submitEdit',
        value: function submitEdit() {
            var _this4 = this;

            api.organisations.edit.update(this.org).$promise.then(function (response) {
                _this4.$state.go('app.admin.org.view', { id: response.id });
                _this4.org = {};
            }).catch(function (response) {
                _this4.notificationDialog.show('Edit Organisation Unsuccessful!', "Sorry, we encountered an error in trying to add the organisation. " + response);
            });
        }

        /**
         * Send form
         */

    }, {
        key: 'sendForm',
        value: function sendForm(ev) {
            this.notificationDialog.show("The Title", "The message");
        }
    }]);

    return ClinicianAdminCtlr;
}();

angular.module('app.admin').component('clinicianAdmin', {
    controller: ClinicianAdminCtlr,
    templateUrl: 'app/main/admin/clinicians/clinician-add.html'
});


'use strict';

(function () {
    'use strict';

    angular.module('app.core', ["com.2fdevs.videogular", "com.2fdevs.videogular.plugins.buffering", "com.2fdevs.videogular.plugins.controls", "com.2fdevs.videogular.plugins.overlayplay", "com.2fdevs.videogular.plugins.poster", 'ngAnimate', 'ngAria', 'ngCookies', 'ngMessages', 'ngResource', 'ngSanitize', 'ngMaterial', 'pascalprecht.translate', 'ui.router', 'ngFileUpload', 'luegg.directives', 'mdPickers', 'angular-thumbnails', 'ngPassword', 'vcRecaptcha', 'angular-google-analytics', 'angulartics', 'angulartics.google.analytics', 'swangular', 'angularMoment']);
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.core').controller('MsWidgetController', MsWidgetController).directive('msWidget', msWidgetDirective).directive('msWidgetFront', msWidgetFrontDirective).directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element) {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip() {
            if (!isFlippable()) {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable() {
            return angular.isDefined($scope.flippable) && $scope.flippable === true;
        }
    }

    /** @ngInject */
    function msWidgetDirective() {
        return {
            restrict: 'E',
            scope: {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile: function compile(tElement) {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn) {
                    // Custom transclusion
                    transcludeFn(function (clone) {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective() {
        return {
            restrict: 'E',
            require: '^msWidget',
            transclude: true,
            compile: function compile(tElement) {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn) {
                    // Custom transclusion
                    transcludeFn(function (clone) {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective() {
        return {
            restrict: 'E',
            require: '^msWidget',
            transclude: true,
            compile: function compile(tElement) {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn) {
                    // Custom transclusion
                    transcludeFn(function (clone) {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.core').controller('MsTimelineController', MsTimelineController).directive('msTimeline', msTimelineDirective).directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController() {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl) {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl() {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective() {
        return {
            scope: {
                loadMore: '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile: function compile(tElement) {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl) {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element('#content');
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll() {
                        if (scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top) {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                            // Success
                            function () {
                                // Hide the loader
                                loadMoreEl.removeClass('show');

                                // Register the onScroll event again
                                registerOnScroll();
                            },

                            // Error
                            function () {
                                // Remove the loader completely
                                loadMoreEl.remove();
                            });
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll() {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll() {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function () {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q) {
        return {
            scope: true,
            require: '^msTimeline',
            compile: function compile(tElement) {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl) {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init() {
                        // Check if the timeline item has ms-card
                        if (iElement.find('ms-card')) {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args) {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function () {
                                    $timeout(function () {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        } else {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function () {
                                $timeout(function () {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(function () {
                        return itemLoaded && itemInViewport;
                    }, function (current, old) {
                        if (angular.equals(current, old)) {
                            return;
                        }

                        if (current) {
                            iElement.removeClass('hidden').addClass('animate');

                            // Unbind itemReadyWatcher
                            itemReadyWatcher();
                        }
                    }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element) {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if (imgEl.length > 0) {
                            imgEl.on('load', function () {
                                deferred.resolve('Image is loaded');
                            });
                        } else {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility() {
                        if (scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold) {
                            $timeout(function () {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.core').controller('MsStepperController', MsStepperController).directive('msStepper', msStepperDirective).directive('msStepperStep', msStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout) {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form) {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form) {
            var step = {
                element: element,
                scope: scope,
                form: form,
                stepNumber: scope.step || vm.steps.length + 1,
                stepTitle: scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b) {
                return a.stepNumber - b.stepNumber;
            });
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps() {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm() {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function () {
                // Reset all the steps
                for (var x = 0; x < vm.steps.length; x++) {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            // Hide all steps
            for (var i = 0; i < vm.steps.length; i++) {
                vm.steps[i].element.hide();
            }

            // Show the current step
            vm.steps[vm.currentStepNumber - 1].element.show();
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber) {
            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep() {
            vm.setCurrentStep(vm.currentStepNumber - 1);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep() {
            vm.setCurrentStep(vm.currentStepNumber + 1);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep() {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep() {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep() {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep() {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return null;
            }

            var disabled = false;

            for (var i = 1; i < stepNumber; i++) {
                if (!isStepValid(i)) {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return null;
            }

            // If the step is optional, always return true
            if (isStepOptional(stepNumber)) {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber) {
            return !(stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid() {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msStepperDirective() {
        return {
            restrict: 'A',
            require: ['form', 'msStepper'],
            priority: 1001,
            controller: 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude: true,
            templateUrl: 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile: function compile(tElement) {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls) {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msStepperStepDirective() {
        return {
            restrict: 'E',
            require: ['form', '^msStepper'],
            priority: 1000,
            scope: {
                step: '=?',
                stepTitle: '=?',
                optionalStep: '=?'
            },
            compile: function compile(tElement) {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls) {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.core').directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate) {
        return {
            restrict: 'E',
            link: function link(scope, iElement) {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function () {
                    $animate.leave(iElement).then(function () {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.core').directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective() {
        return {
            restrict: 'A',
            require: '^mdSidenav',
            link: function link(scope, iElement, iAttrs, MdSidenavCtrl) {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function () {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current) {
                    if (angular.isUndefined(current)) {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.core').directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function msSearchBarDirective($document) {
        return {
            restrict: 'E',
            scope: true,
            templateUrl: 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile: function compile(tElement) {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement) {
                    var expanderEl, collapserEl;

                    // Initialize
                    init();

                    function init() {
                        expanderEl = iElement.find('#ms-search-bar-expander');
                        collapserEl = iElement.find('#ms-search-bar-collapser');

                        expanderEl.on('click', expand);
                        collapserEl.on('click', collapse);
                    }

                    /**
                     * Expand
                     */
                    function expand() {
                        iElement.addClass('expanded');

                        // Esc key event
                        $document.on('keyup', escKeyEvent);
                    }

                    /**
                     * Collapse
                     */
                    function collapse() {
                        iElement.removeClass('expanded');
                    }

                    /**
                     * Escape key event
                     *
                     * @param e
                     */
                    function escKeyEvent(e) {
                        if (e.keyCode === 27) {
                            collapse();
                            $document.off('keyup', escKeyEvent);
                        }
                    }
                };
            }
        };
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.core').provider('msScrollConfig', msScrollConfigProvider).directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider() {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed: 1,
            wheelPropagation: false,
            swipePropagation: true,
            minScrollbarLength: null,
            maxScrollbarLength: null,
            useBothWheelAxes: false,
            useKeyboard: true,
            suppressScrollX: false,
            suppressScrollY: false,
            scrollXMarginOffset: 0,
            scrollYMarginOffset: 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration) {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function () {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig() {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, clinividConfig) {
        return {
            restrict: 'AE',
            compile: function compile(tElement) {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if (clinividConfig.getConfig('disableCustomScrollbars')) {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if (clinividConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile()) {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs) {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if (iAttrs.msScroll) {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function () {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function () {
                        return iElement.prop('scrollHeight');
                    }, function (current, old) {
                        if (angular.isUndefined(current) || angular.equals(current, old)) {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function () {
                        return iElement.prop('scrollWidth');
                    }, function (current, old) {
                        if (angular.isUndefined(current) || angular.equals(current, old)) {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar() {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function () {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.core').directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective() {
        return {
            restrict: 'A',
            link: function link(scope, iElement) {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.core').directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective() {
        return {
            restrict: 'A',
            scope: {
                msRandomClass: '='
            },
            link: function link(scope, iElement) {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * scope.msRandomClass.length)];
                iElement.addClass(randomClass);
            }
        };
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.core').provider('msNavigationService', msNavigationServiceProvider).controller('MsNavigationController', MsNavigationController)
    // Vertical
    .directive('msNavigation', msNavigationDirective).controller('MsNavigationNodeController', MsNavigationNodeController).directive('msNavigationNode', msNavigationNodeDirective).directive('msNavigationItem', msNavigationItemDirective)
    //Horizontal
    .directive('msNavigationHorizontal', msNavigationHorizontalDirective).controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController).directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective).directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider() {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item) {
            if (!angular.isString(path)) {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for (var i = 0; i < parent.length; i++) {
                if (parent[i]._id === id) {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if (updateItem) {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else {
                    // Create an empty children array in the item
                    item.children = [];

                    // Add the default weight if not provided or if it's not a number
                    if (angular.isUndefined(item.weight) || !angular.isNumber(item.weight)) {
                        item.weight = 1;
                    }

                    // Add the item id
                    item._id = id;

                    // Add the item path
                    item._path = path;

                    // Add proper ui-sref
                    item.uisref = _getUiSref(item);

                    // Push the item into the array
                    parent.push(item);
                }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path) {
            if (!angular.isString(path)) {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for (var p = 0; p < parts.length; p++) {
                var id = parts[p];

                for (var i = 0; i < item.length; i++) {
                    if (item[i]._id === id) {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if (item[i]._path === path) {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent) {
            // If parent not provided, sort the root items
            if (!parent) {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for (var i = 0; i < parent.length; i++) {
                var children = parent[i].children;

                if (children.length > 1) {
                    children.sort(_byWeight);
                }

                if (children.length > 0) {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts) {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if (parts.length === 1) {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for (var i = 0; i < parts.length; i++) {
                var _id = parts[i],
                    createParent = true;

                for (var p = 0; p < parent.length; p++) {
                    if (parent[p]._id === _id) {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if (createParent) {
                    var item = {
                        _id: _id,
                        _path: parts.join('.'),
                        title: _id,
                        weight: 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y) {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item) {
            var uisref = '';

            if (angular.isDefined(item.state)) {
                uisref = item.state;

                if (angular.isDefined(item.stateParams) && angular.isObject(item.stateParams)) {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function () {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem: saveItem,
                deleteItem: deleteItem,
                sort: sortByWeight,
                clearNavigation: clearNavigation,
                setActiveItem: setActiveItem,
                getActiveItem: getActiveItem,
                getNavigationObject: getNavigationObject,
                setNavigationScope: setNavigationScope,
                setFolded: setFolded,
                getFolded: getFolded,
                setFoldedOpen: setFoldedOpen,
                getFoldedOpen: getFoldedOpen,
                toggleFolded: toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation() {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if (navigationScope) {
                    navigationScope.vm.navigation = [];
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope) {
                activeItem = {
                    node: node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem() {
                return activeItem;
            }

            /**
             * Return navigation object
             *
             * @param root
             * @returns {Array}
             */
            function getNavigationObject(root) {
                if (root) {
                    for (var i = 0; i < navigation.length; i++) {
                        if (navigation[i]._id === root) {
                            return [navigation[i]];
                        }
                    }
                }

                return navigation;
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope) {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status) {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded() {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status) {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen() {
                return foldedOpen;
            }

            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded() {
                navigationScope.toggleFolded();
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService) {
        var vm = this;

        // Data
        if ($scope.root) {
            vm.navigation = msNavigationService.getNavigationObject($scope.root);
        } else {
            vm.navigation = msNavigationService.getNavigationObject();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService) {
        return {
            restrict: 'E',
            scope: {
                folded: '=',
                root: '@'
            },
            controller: 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude: true,
            compile: function compile(tElement) {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement) {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init() {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if (msNavigationService.getFolded() === null) {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if (msNavigationService.getFolded()) {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function () {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function () {
                        return sidenav.isLockedOpen();
                    }, function (current, old) {
                        if (angular.isUndefined(current) || angular.equals(current, old)) {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if (folded) {
                            if (current) {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            } else {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if (activeItem) {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old) {
                        if (angular.isUndefined(current) || angular.equals(current, old)) {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded) {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if (folded) {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        } else {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if (activeItem) {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander() {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function () {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser() {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser() {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event) {
                        if (event) {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if (activeItem) {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event) {
                        if (event) {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function () {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function () {
                        // Close the sidenav
                        sidenav.close();

                        // If navigation is folded open, close it
                        if (msNavigationService.getFolded()) {
                            onFoldCollapserHover();
                        }
                    });

                    // Cleanup
                    scope.$on('$destroy', function () {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService) {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if (!vm.hasChildren || vm.group) {
                vm.collapsable = false;
            } else {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if (!vm.collapsable) {
                vm.collapsed = false;
            } else {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function () {
                // Expand if the current scope is collapsable and is collapsed
                if (vm.collapsable && vm.collapsed) {
                    $scope.$evalAsync(function () {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path) {
                if (vm.collapsed || !vm.collapsable) {
                    return;
                }

                // If there is no path defined, collapse
                if (angular.isUndefined(path)) {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else {
                        var givenPathParts = path.split('.'),
                            activePathParts = [];

                        var activeItem = msNavigationService.getActiveItem();
                        if (activeItem) {
                            activePathParts = activeItem.node._path.split('.');
                        }

                        // Test for given path
                        if (givenPathParts.indexOf(vm.node._id) > -1) {
                            return;
                        }

                        // Test for active path
                        if (activePathParts.indexOf(vm.node._id) > -1) {
                            return;
                        }

                        vm.collapse();
                    }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function () {
                if (vm.node.state === $state.current.name) {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed() {
            if (vm.collapsed) {
                vm.expand();
            } else {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse() {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function () {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl, {
                    'display': 'block',
                    'height': height + 'px'
                }, {
                    'height': '0px'
                }, vm.animateHeightClass).then(function () {
                    // Clear the inline styles after animation done
                    collapseEl.css({
                        'display': '',
                        'height': ''
                    });

                    // Clear collapsing class from the node
                    vm.element.removeClass('collapsing');
                });

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand() {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position': 'absolute',
                'visibility': 'hidden',
                'display': 'block',
                'height': 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position': '',
                'visibility': '',
                'display': '',
                'height': ''
            });

            $scope.$evalAsync(function () {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl, {
                    'display': 'block',
                    'height': '0px'
                }, {
                    'height': height + 'px'
                }, vm.animateHeightClass).then(function () {
                    // Clear the inline styles after animation done
                    expandEl.css({
                        'height': ''
                    });

                    // Clear expanding class from the node
                    vm.element.removeClass('expanding');
                });

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass() {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden() {
            if (angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden)) {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective() {
        return {
            restrict: 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller: 'MsNavigationNodeController as vm',
            compile: function compile(tElement) {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if (MsNavigationNodeCtrl.group) {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective() {
        return {
            restrict: 'A',
            require: '^msNavigationNode',
            compile: function compile(tElement) {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
                    // If the item is collapsable...
                    if (MsNavigationNodeCtrl.collapsable) {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function () {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService) {
        return {
            restrict: 'E',
            scope: {
                root: '@'
            },
            controller: 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude: true,
            compile: function compile(tElement) {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope) {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService) {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function () {
                // Mark as active if has children
                if (vm.hasChildren) {
                    $scope.$evalAsync(function () {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function () {
                if (!vm.hasChildren) {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if (activeItem) {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if (activePathParts.indexOf(vm.node._id) > -1) {
                    $scope.$evalAsync(function () {
                        vm.isActive = true;
                    });
                } else {
                    $scope.$evalAsync(function () {
                        vm.isActive = false;
                    });
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function () {
                if (vm.node.state === $state.current.name) {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states everything except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass() {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective() {
        return {
            restrict: 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller: 'MsNavigationHorizontalNodeController as vm',
            compile: function compile(tElement) {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if (MsNavigationHorizontalNodeCtrl.group) {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia) {
        return {
            restrict: 'A',
            require: '^msNavigationHorizontalNode',
            compile: function compile(tElement) {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
                    iElement.on('click', onClick);

                    function onClick() {
                        if (!MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md')) {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function () {
                        iElement.off('click');
                    });
                };
            }
        };
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.core').factory('msNavFoldService', msNavFoldService).directive('msNavIsFolded', msNavIsFoldedDirective).controller('MsNavController', MsNavController).directive('msNav', msNavDirective).directive('msNavTitle', msNavTitleDirective).directive('msNavButton', msNavButtonDirective).directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService() {
        var foldable = {};

        var service = {
            setFoldable: setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold: toggleFold,
            openFolded: openFolded,
            closeFolded: closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element) {
            foldable = {
                'scope': scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen() {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold() {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded() {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded() {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService) {
        return {
            restrict: 'A',
            link: function link(scope, iElement, iAttrs) {
                var isFolded = iAttrs.msNavIsFolded === 'true',
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if (isFolded) {
                    fold();
                } else {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen() {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold() {
                    isFolded = !isFolded;

                    if (isFolded) {
                        fold();
                    } else {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold() {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event) {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event) {
                    if (angular.isDefined(event)) {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event) {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event) {
                    if (angular.isDefined(event)) {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event) {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold() {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function () {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }

    /** @ngInject */
    function MsNavController() {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled() {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable() {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable() {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope) {
            toggleItems.push({
                'element': element,
                'scope': scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems() {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope) {
            lockedItems.push({
                'element': element,
                'scope': scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems() {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService) {
        return {
            restrict: 'E',
            scope: {},
            controller: 'MsNavController',
            compile: function compile(tElement) {
                tElement.addClass('ms-nav');

                return function postLink(scope) {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function () {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation) {
                            navigation.close();

                            if (msNavFoldService.isNavFoldedOpen()) {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function () {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective() {
        return {
            restrict: 'A',
            compile: function compile(tElement) {
                tElement.addClass('ms-nav-title');

                return function postLink() {};
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective() {
        return {
            restrict: 'AE',
            compile: function compile(tElement) {
                tElement.addClass('ms-nav-button');

                return function postLink() {};
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state) {
        return {
            restrict: 'A',
            require: '^msNav',
            scope: true,
            compile: function compile(tElement, tAttrs) {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if (angular.isUndefined(tAttrs.collapsed)) {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl) {
                    var classes = {
                        expanded: 'expanded',
                        expandAnimation: 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link) {
                        var state = angular.element(link).attr('ui-sref');

                        if (angular.isUndefined(state)) {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle() {
                        // If navigation is disabled, do nothing...
                        if (MsNavCtrl.isDisabled()) {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if (isCollapsed()) {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function () {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        } else {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function () {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function () {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem) {
                            if (angular.equals(lockedItem.scope, scope)) {
                                locked = true;
                            }
                        });

                        if (locked) {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function () {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function () {
                        // Collapse and then...
                        collapse().then(function () {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function () {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state) {
                            if (currentState === state) {
                                shouldExpand = true;
                            }
                        });

                        if (shouldExpand) {
                            expand();
                        } else {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function () {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed() {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded() {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand() {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if (isExpanded()) {
                            // Reject the deferred object
                            deferred.reject({ 'error': true });

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position': 'absolute',
                            'visibility': 'hidden',
                            'display': 'block',
                            'height': 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position': '',
                            'visibility': '',
                            'display': '',
                            'height': ''
                        });

                        // Animate the height
                        scope.$evalAsync(function () {
                            $animate.animate(elementToExpand, {
                                'display': 'block',
                                'height': '0px'
                            }, {
                                'height': height + 'px'
                            }, classes.expandAnimation).then(function () {
                                // Add expanded class
                                elementToExpand.addClass(classes.expanded);

                                // Clear the inline styles after animation done
                                elementToExpand.css({ 'height': '' });

                                // Resolve the deferred object
                                deferred.resolve({ 'success': true });
                            });
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse() {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if (isCollapsed()) {
                            // Reject the deferred object
                            deferred.reject({ 'error': true });

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function () {
                            $animate.animate(elementToCollapse, {
                                'height': height + 'px'
                            }, {
                                'height': '0px'
                            }, classes.collapseAnimation).then(function () {
                                // Remove expanded class
                                elementToCollapse.removeClass(classes.expanded);

                                // Clear the inline styles after animation done
                                elementToCollapse.css({
                                    'display': '',
                                    'height': ''
                                });

                                // Resolve the deferred object
                                deferred.resolve({ 'success': true });
                            });
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.core').directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPicker($mdMenu, $mdColorPalette, clinividGenerator) {
        return {
            require: 'ngModel',
            restrict: 'E',
            scope: {
                ngModel: '=',
                msModelType: '@?'
            },
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link: function link($scope, element, attrs, ngModel) {
                // Material Color Palette
                $scope.palettes = $mdColorPalette;
                $scope.selectedPalette = false;
                $scope.selectedHues = false;

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                $scope.msModelType = $scope.msModelType || 'class';

                /**
                 * Initialize / Watch model changes
                 */
                $scope.$watch('ngModel', setSelectedColor);

                /**
                 * Activate Hue Selection
                 * @param palette
                 * @param hues
                 */
                $scope.activateHueSelection = function (palette, hues) {
                    $scope.selectedPalette = palette;
                    $scope.selectedHues = hues;
                };

                /**
                 * Select Color
                 * @type {selectColor}
                 */
                $scope.selectColor = function (palette, hue) {
                    // Update Selected Color
                    updateSelectedColor(palette, hue);

                    // Update Model Value
                    updateModel();

                    // Hide The picker
                    $mdMenu.hide();
                };

                $scope.removeColor = function () {

                    $scope.selectedColor = {
                        palette: '',
                        hue: '',
                        class: ''
                    };

                    $scope.activateHueSelection(false, false);

                    updateModel();
                };

                /**
                 * Set SelectedColor by model type
                 */
                function setSelectedColor() {
                    if (!ngModel.$viewValue || ngModel.$viewValue === '') {
                        return;
                    }

                    var palette, hue;

                    // If ModelType Class
                    if ($scope.msModelType === 'class') {
                        var color = ngModel.$viewValue.split('-');
                        if (color.length >= 5) {
                            palette = color[1] + '-' + color[2];
                            hue = color[3];
                        } else {
                            palette = color[1];
                            hue = color[2];
                        }
                    }
                    // If ModelType Object
                    else if ($scope.msModelType === 'obj') {
                            palette = ngModel.$viewValue.palette;
                            hue = ngModel.$viewValue.hue || 500;
                        }

                    // Update Selected Color
                    updateSelectedColor(palette, hue);
                }

                /**
                 * Update Selected Color
                 * @param palette
                 * @param hue
                 */
                function updateSelectedColor(palette, hue) {
                    $scope.selectedColor = {
                        palette: palette,
                        hue: hue,
                        class: 'md-' + palette + '-' + hue + '-bg',
                        bgColorValue: clinividGenerator.rgba($scope.palettes[palette][hue].value),
                        fgColorValue: clinividGenerator.rgba($scope.palettes[palette][hue].contrast)
                    };

                    // If Model object not Equals the selectedColor update it
                    // it can be happen when the model only have pallete and hue values
                    if ($scope.msModelType === 'obj' && !angular.equals($scope.selectedColor, ngModel.$viewValue)) {
                        // Update Model Value
                        updateModel();
                    }

                    $scope.activateHueSelection(palette, $scope.palettes[palette]);
                }

                /**
                 * Update Model Value by model type
                 */
                function updateModel() {
                    if ($scope.msModelType === 'class') {
                        ngModel.$setViewValue($scope.selectedColor.class);
                    } else if ($scope.msModelType === 'obj') {
                        ngModel.$setViewValue($scope.selectedColor);
                    }
                }
            }
        };
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.core').controller('MsFormWizardController', MsFormWizardController).directive('msFormWizard', msFormWizardDirective).directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController() {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form) {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep() {
            if (isFirstStep()) {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep() {
            if (isLastStep()) {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep() {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep() {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps() {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep() {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep() {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid() {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid() {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete() {
            for (var x = 0; x < vm.forms.length; x++) {
                if (vm.forms[x].$invalid) {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm() {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for (var x = 0; x < vm.forms.length; x++) {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective() {
        return {
            restrict: 'E',
            scope: true,
            controller: 'MsFormWizardController as msWizard',
            compile: function compile(tElement) {
                tElement.addClass('ms-form-wizard');

                return function postLink() {};
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective() {
        return {
            restrict: 'A',
            require: ['form', '^msFormWizard'],
            compile: function compile(tElement) {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls) {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.core').provider('msDatepickerFixConfig', msDatepickerFixConfigProvider).directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider() {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function formatter(val) {
                if (!val) {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser: function parser(val) {
                if (!val) {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration) {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function () {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig) {
        return {
            require: 'ngModel',
            link: function link(scope, elem, attrs, ngModel) {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.core').directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective() {
        return {
            restrict: 'E',
            scope: {
                templatePath: '=template',
                card: '=ngModel',
                vm: '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile: function compile(tElement) {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement) {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded() {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();


'use strict';

(function () {
    'use strict';

    /** @ngInject */

    function config($httpProvider, $translatePartialLoaderProvider, $stateProvider, msApiProvider, localStorageServiceProvider) {
        // localStorageServiceProvider.
        localStorageServiceProvider.setStorageType('sessionStorage');

        $httpProvider.interceptors.push('showLoading');
        $httpProvider.interceptors.push('logHttpErrors');
        $httpProvider.interceptors.push('authInterceptor');

        // State
        $stateProvider.state('app.user', {
            url: '/user',
            views: {
                'content@app': {
                    templateUrl: 'app/user/user.html',
                    controller: 'UserController as $ctrl'
                }
                /*,
                resolve: {
                    AdminData: function (msApi)
                    {
                        return msApi.resolve('admin@get');
                    }
                }*/
            } }).state('app.user.login', {
            url: '/login',
            views: {
                'content@app': {
                    template: '<login></login>'
                }
            },
            bodyClass: 'login'
        }).state('app.user.suspendedUser', {
            url: '/suspendedUser',
            views: {
                'content@app': {
                    template: '<suspended-user></suspended-user>'
                }
            },
            bodyClass: 'suspendedUser'
        }).state('app.user.completeUserProfile', {
            url: '/completeUserProfile',
            views: {
                'content@app': {
                    template: '<complete-user-profile></complete-user-profile>'
                }
            },
            bodyClass: 'suspendedUser',
            params: {
                contextPayload: null
            }
        }).state('app.user.casecreation', {
            url: '/casecreation/:contactId',
            views: {
                'content@app': {
                    template: '<casecreation></casecreation>'
                }
            },
            bodyClass: 'login',
            params: {
                draftCase: null,
                contactId: null,
                casePage: null,
                allContacts: null,
                createCaseWithGroupId: null,
                singleRecipientId: null,
                membershipIdFromContactsPage: null
            }
        }).state('app.user.createorganisation', {
            url: '/createorganisation',
            views: {
                'content@app': {
                    template: '<createorganisation></createorganisation>'
                }
            },
            bodyClass: 'login'
        }).state('app.user.profile', {
            url: '/profile',
            views: {
                'content@app': {
                    template: '<profile></profile>'
                }
            },
            bodyClass: 'login',
            params: {
                fromContactsPage: null
            }
        });

        $stateProvider.state('app.user.register', {
            url: '/register',
            views: {
                'content@app': {
                    template: '<register></register>'
                }
            },
            bodyClass: 'register',
            params: {
                inviteKey: null
            }
        });

        $stateProvider.state('app.user.forgot-password', {
            url: '/forgot-password',
            views: {
                'content@app': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.user.forgot-password': {
                    template: '<forgot-password></forgot-password>'
                }
            },
            bodyClass: 'forgot-password'
        });

        $stateProvider.state('app.user.resetPwd', {
            url: '/reset-password',
            views: {
                'content@app': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.user.resetPwd': {
                    template: '<reset-password></reset-password>'
                }
            },
            bodyClass: 'reset-password'
        });

        $stateProvider.state('app.user.changePwd', {
            url: '/change-password',
            views: {
                'content@app': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.user.changePwd': {
                    template: '<reset-password></reset-password>'
                }
            },
            bodyClass: 'reset-password'
        });

        $stateProvider.state('app.user.logout', {
            url: '/logout',
            views: {
                'content@app': {
                    template: '<logout-user></logout-user>'
                }
            },
            bodyClass: 'logout-user'
        });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/user');
        $translatePartialLoaderProvider.addPart('app/user/auth');

        // Api
        //msApiProvider.register('app.auth@save', ['http://localhost:26264/api/token']);
        //msApiProvider.register('app.login@post', [apiBasePath + 'Account/Login']);
        msApiProvider.register('app.login', [apiBasePath + 'Account/Login']);
        msApiProvider.register('app.logout', [apiBasePath + 'Account/Logout']);
        msApiProvider.register('app.register', [apiBasePath + 'Account/Register']);
        msApiProvider.register('app.setNewUserDetails', [apiBasePath + 'User/SetNewUserDetails']);
        msApiProvider.register('app.setSecurityQuestions', [apiBasePath + 'User/setSecurityQuestions']);
        msApiProvider.register('app.forgot-password', [apiBasePathNoAuth + 'Account/ForgotPassword']);
        msApiProvider.register('app.reset-password', [apiBasePathNoAuth + 'Account/ResetPassword']);
        msApiProvider.register('app.userContext', [apiBasePath + 'User/Context']);
    }

    function authInterceptor($injector, $q, localStorageService) {
        return {
            request: function request(config) {
                config.headers = config.headers || {};

                var authData = localStorageService.get('authorizationData');

                if (config && config.url && config.url.startsWith('https://care-dev2.teleconnect.me/demo/api/v1/')) {
                    return config;
                }

                var isS3call = config.url.startsWith('https://s3');
                //Added this piece as upload to s3 was failing if Authorization Header is added
                if (isS3call && config.method === 'PUT') {
                    if (config.data.type.split('/')[0] === 'image') config.headers = { "Content-Type": 'image/jpeg' }; //Special case as for png this will fail
                    if (config.data.type.split('/')[0] === 'video') config.headers = { "Content-Type": 'video/mp4' }; //Special case as for png this will fail
                    return config;
                }

                if (authData) {
                    config.headers.Authorization = 'Bearer ' + authData.token;
                }

                return config;
            },
            responseError: function responseError(rejection) {
                var retryRequest = function retryRequest(config) {
                    var http = $injector.get('$http');
                    return http(config);
                };

                if (rejection.status === 401) {
                    var userService = $injector.get('userService');

                    var authData = localStorageService.get('authorizationData');

                    if (_.get(authData, 'useRefreshTokens')) {
                        return userService.refreshToken().then(function () {
                            return retryRequest(rejection.config);
                        });
                    }

                    userService.logOut();
                }
                if (rejection.status === 400 && rejection.config.method === 'POST' && rejection.config.url.includes('/Cases/ResendCaseNotificationToContact?mid')) {
                    return $q.resolve(rejection);
                }
                return $q.reject(rejection);
            }
        };
    }

    function showLoading($q, $rootScope, $timeout) {
        return {
            request: function request(config) {
                if (!config.suppressSpinner) $rootScope.apiLoadingProgress = false;

                return config;
            },
            response: function response(_response) {
                $timeout(function () {
                    return $rootScope.apiLoadingProgress = false;
                });
                return _response;
            },
            responseError: function responseError(response) {
                $timeout(function () {
                    return $rootScope.apiLoadingProgress = false;
                });
                return $q.reject(response);
            }
        };
    }

    function logHttpErrors($q) {
        return {
            responseError: function responseError(rejection) {
                //console.error(`HTTP ${rejection.status}: ${JSON.stringify(rejection.data)}`)
                return $q.reject(rejection);
            }
        };
    }

    angular.module('app.user', ['LocalStorageModule']).config(config).factory('authInterceptor', ['$injector', '$q', 'localStorageService', authInterceptor]).factory('logHttpErrors', ['$q', logHttpErrors]).factory('showLoading', ['$q', '$rootScope', '$timeout', showLoading]);
})();


'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SuspendedUserController = function SuspendedUserController() {
  _classCallCheck(this, SuspendedUserController);
};

angular.module('app.user').component('suspendedUser', {
  controller: SuspendedUserController,
  templateUrl: 'app/user/auth/SuspendedUser.html'
});


'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResetPasswordController = function () {
    function ResetPasswordController($location, appContext, userService) {
        _classCallCheck(this, ResetPasswordController);

        this.app = appContext;
        this.userService = userService;
        this.key = $location.search().key;
        this.form = {};
    }

    _createClass(ResetPasswordController, [{
        key: 'resetPwd',
        value: function resetPwd() {
            var _this = this;

            if (!this.form.password || !this.key) {
                return;
            }

            this.userService.resetPwd(this.form.password, this.key).then(function (response) {

                if (response.type >= 1) {
                    _this.app.popup('Success', 'Your password has been changed.', 'Ok', 'app.user.login');
                } else if (response.type === -18) {
                    _this.app.popup('Expired', response.message, 'Ok', 'app.user.forgot-password');
                } else {
                    _this.app.popup('Failed', 'Sorry, the request has failed. Please try again another time.', 'Ok');
                }
            }).catch();
        }
    }]);

    return ResetPasswordController;
}();

angular.module('app.user').component('resetPassword', {
    controller: ResetPasswordController,
    templateUrl: 'app/user/auth/reset-password.html'
});


'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RegisterController = function () {
	function RegisterController($scope, $state, appContext, userService, $stateParams, $analytics, $mdSidenav, $location, $window, swangular, $mdDialog, $http, localStorageService, mfaFactory, mfaInputHelper, $timeout) {
		'inject';

		_classCallCheck(this, RegisterController);

		this.$timeout = $timeout;
		if ($location.search().hasOwnProperty('quickreply')) {
			this.showCallToAction = true;
		} else {
			this.showCallToAction = false;
		}
		this.$window = $window;
		this.swangular = swangular;
		this.$mdDialog = $mdDialog;
		this.app = appContext;
		this.userService = userService;
		this.$stateParams = $stateParams;
		this.context = userService.context;
		this.form = { person: {} };
		this.inviteKey = $stateParams.inviteKey;
		this.$analytics = $analytics;
		this.$mdSidenav = $mdSidenav;
		this.showRegistrationDetailsStep = false;
		this.currentPage = 'CHECK_AHPRA';
		this.patientRegistrationForm = {};
		this.currentStep = 1;
		this.$http = $http;
		this.localStorageService = localStorageService;
		this.mfaFactory = mfaFactory;
		this.mfaInputHelper = mfaInputHelper;
		this.registrationRegularExpression = '[A-Z]{3}[0-9]{7,10}';
		this.registrationMaxLength = 13;
		this.registrationInvalidMessage = 'Must be 3 Capital letters followed by 7 to 10 digits';

		// MFA state
		this.showMFAScreen = false;
		this.mfaSessionId = null;
		this.maskedMobile = '';
		this.mfaCode = ['', '', '', '', '', ''];
		this.mfaError = '';
		this.resendCount = 0;
		this.mfaTestMode = false;
	}

	_createClass(RegisterController, [{
		key: 'openMenu',
		value: function openMenu($mdOpenMenu, ev) {
			$mdOpenMenu(ev);
		}
	}, {
		key: 'openRightMenu',
		value: function openRightMenu() {
			this.$window.location.href = terms;
			//this.$mdSidenav('termsAndConditions').toggle();
		}
	}, {
		key: 'openPrivacyMenu',
		value: function openPrivacyMenu() {
			this.$window.location.href = privacyPolicy;
			//this.$mdSidenav('privacy').toggle();
		}
	}, {
		key: 'closeSideNavPanelTermsAndConditions',
		value: function closeSideNavPanelTermsAndConditions() {
			this.$mdSidenav('termsAndConditions').close();
		}
	}, {
		key: 'closeSideNavPanelPrivacy',
		value: function closeSideNavPanelPrivacy() {
			this.$mdSidenav('privacy').close();
		}
	}, {
		key: 'takeToRegistrationPage',
		value: function takeToRegistrationPage() {
			this.currentPage = 'USER_REGISTRATION';
		}
	}, {
		key: 'takeToNoAHRPAPage',
		value: function takeToNoAHRPAPage() {
			this.currentPage = 'NO_AHPRA';
		}
	}, {
		key: 'openAHRPAPage',
		value: function openAHRPAPage() {
			var _this = this;

			// this.$window.open('http://www.ahpra.gov.au/Registration/Registers-of-Practitioners.aspx', '_blank');

			this.swangular.swal({
				title: '',
				text: 'You are leaving Clinivid to go to an external website. Do you wish to continue?',
				type: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				cancelButtonText: 'No, go back',
				confirmButtonText: 'Yes, take me there'
			}).then(function (result) {
				if (result.value) {
					_this.$window.open('http://www.ahpra.gov.au/Registration/Registers-of-Practitioners.aspx', '_blank');
				}
			});
		}
	}, {
		key: 'phoneNumberRegex',
		value: function phoneNumberRegex() {

			var regex = void 0;

			if (this.patientRegistrationForm.countryCode === 'AU') {
				regex = '^(04|#04|#4)[0-9]{8}$';
			}
			// else if (this.patientRegistrationForm.countryCode === 'PH'){
			//   regex = '(\+?\d{2}?\s?\d{3}\s?\d{3}\s?\d{4})|([0]\d{3}\s?\d{3}\s?\d{4})';
			// }
			else if (this.patientRegistrationForm.countryCode === 'NZ') {
					regex = '^(((\+?64\s*[-\.]?[3-9]|\(?0[3-9]\)?)\s*[-\.]?\d{3}\s*[-\.]?\d{4})|((\+?64\s*[-\.\(]?2\d{1}[-\.\)]?|\(?02\d{1}\)?)\s*[-\.]?\d{3}\s*[-\.]?\d{3,5})|((\+?64\s*[-\.]?[-\.\(]?800[-\.\)]?|[-\.\(]?0800[-\.\)]?)\s*[-\.]?\d{3}\s*[-\.]?(\d{2}|\d{5})))$';
				} else if (this.patientRegistrationForm.countryCode === 'IN') {
					regex = '^(#?)[7-9][0-9]{9}$';
				}

			return regex;
		}
	}, {
		key: 'appendRegistrationPrefix',
		value: function appendRegistrationPrefix() {

			if (this.patientRegistrationForm.profession === 'Sonographer') {
				this.registrationRegularExpression = '[0-9]{4}';
				this.registrationInvalidMessage = 'Must be 4 digits';
			} else {
				this.registrationRegularExpression = '[A-Z]{3}[0-9]{7,10}';
				this.registrationInvalidMessage = 'Must be 3 Capital letters followed by 7 to 10 digits';
			}

			if (this.currentStep === 1) this.currentStep = 2; // Move to next step after user chooses Profession
		}
	}, {
		key: 'getButtonText',
		value: function getButtonText() {
			if (this.currentStep !== 3) {
				return 'Next';
			} else {
				return 'Next';
			}
		}
	}, {
		key: 'initiateMFA',
		value: function initiateMFA() {
			var _this2 = this;

			var spinner = this.$mdDialog;
			var form = this.patientRegistrationForm;

			var errorMessages = {
				email_already_registered: 'The Email Id: <b>' + form.email + '</b> is already taken.',
				mobile_already_registered: 'Submission Failed: The Mobile No: <b>' + form.phoneNumber + '</b> is already registered by another user. Please check your number or contact <a href="mailto:support@clinivid.com.au">support.</a>',
				registration_id_already_exists: 'This registration number is already in use.'
			};

			spinner.show({
				template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
				parent: angular.element(document.body)
			});

			this.mfaFactory.sendRegisterCode(form).then(function (response) {
				spinner.hide();
				if (response.data.success) {
					_this2.mfaSessionId = response.data.sessionId;
					_this2.maskedMobile = response.data.maskedMobile;
					_this2.mfaCode = ['', '', '', '', '', ''];
					_this2.mfaError = '';
					_this2.mfaTestMode = !!response.data.mfaTestMode;
					_this2.showMFAScreen = true;
					if (_this2.showMFAScreen) {
						//focus on input element
						_this2.mfaInputHelper.focusElement('mfa-digit-0', 500, 200);
					}
				} else {
					_this2.swangular.swal({
						type: 'error',
						title: 'Registration Failed',
						html: 'Please check your information and try again.'
					});
				}
			}).catch(function (err) {
				spinner.hide();

				_this2.swangular.swal({
					type: 'error',
					title: 'Registration Failed',
					html: errorMessages[err.data && err.data.error] || 'Please contact <a href="mailto:support@clinivid.com.au">support.</a>'
				});
			});
		}
	}, {
		key: 'onCodeDigitInput',
		value: function onCodeDigitInput(index, event) {
			//focus on button
			this.mfaInputHelper.focusMfaButton(index, event, 'signup_btn');
			this.mfaInputHelper.onCodeDigitInput(this.mfaCode, index, event);
		}
	}, {
		key: 'onCodeKeydown',
		value: function onCodeKeydown(index, event) {
			//focus on button
			this.mfaInputHelper.focusMfaButton(index, event, 'signup_btn');
			this.mfaInputHelper.onCodeKeydown(this.mfaCode, index, event);
		}
	}, {
		key: 'resendCode',
		value: function resendCode() {
			var _this3 = this;

			if (this.resendCount >= 3) return;

			this.mfaFactory.resendCode(this.mfaSessionId).then(function (response) {
				if (response.data.success) {
					_this3.resendCount++;
					_this3.mfaError = '';
					_this3.mfaCode = ['', '', '', '', '', ''];
					var first = document.getElementById('mfa-digit-0');
					if (first) first.focus();
				} else {
					_this3.mfaError = 'Please click on the Go back button to verify the mobile number you have entered or contact support using the link below.';
				}
			}).catch(function () {
				_this3.mfaError = 'Failed to resend code. Please try again.';
			});
		}
	}, {
		key: 'cancelMFA',
		value: function cancelMFA() {
			this.showMFAScreen = false;
			this.mfaSessionId = null;
			this.mfaCode = ['', '', '', '', '', ''];
			this.mfaError = '';
			this.resendCount = 0;
		}

		/**  New User Registration Process */

	}, {
		key: 'registerUser',
		value: function registerUser() {
			var _this4 = this;

			if (this.currentStep === 1) {
				this.currentStep = 2;return;
			}
			if (this.currentStep === 2) {
				this.currentStep = 3;return;
			}

			var userService = this.userService;
			var patientRegistrationForm = this.patientRegistrationForm;
			var inviteKey = this.inviteKey;
			var analytics = this.$analytics;
			var swangular = this.swangular;
			var formEmail = this.patientRegistrationForm.email;
			var duplicateEmail = 'The Email Id: <b>' + formEmail + '</b> is already taken.';
			var regionCode = this.patientRegistrationForm.countryCode;
			var spinner = this.$mdDialog;
			var formPhoneNumber = this.patientRegistrationForm.phoneNumber;
			var duplicateMobileNumber = 'Submission Failed: The Mobile No: <b>' + formPhoneNumber + '</b> is already registered by another user. Please check your number or contact <a href="mailto:support@clinivid.com.au">support.</a>';

			// MFA Error: handle invalid/expired code 
			var errorMessages = {
				invalid_session: 'The 6 digits number you have entered is either not correct or has expired',
				session_expired: 'The 6 digits number you have entered is either not correct or has expired',
				already_verified: 'Your account is already verified.',
				invalid_code: 'The 6 digits number you have entered is either not correct or has expired'
			};

			spinner.show({
				template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
				parent: angular.element(document.body)
			});

			// Get MFA Code
			var mfaCode = this.mfaCode.join('');

			userService.register(patientRegistrationForm.email, patientRegistrationForm.password, this.mfaSessionId, mfaCode).then(function (response) {

				if (response.type > 0) {

					var payloadID = response.payload;
					var data = 'grant_type=password&username=' + patientRegistrationForm.email + '&password=' + patientRegistrationForm.password;

					userService.loginMobile(data).then(function (response) {
						var authData = {
							token: response.data.access_token,
							userName: response.data.userName,
							userId: response.data.userId,
							refreshToken: response.data.refresh_token,
							useRefreshTokens: true
						};

						_this4.localStorageService.set('authorizationData', authData);
						userService.saveNewUserDetails2(payloadID, patientRegistrationForm.title, patientRegistrationForm.firstName, patientRegistrationForm.middleName, patientRegistrationForm.lastName, patientRegistrationForm.email, patientRegistrationForm.phoneNumber, patientRegistrationForm.registerNumber, patientRegistrationForm.profession, inviteKey, regionCode).then(function (response) {
							spinner.hide();

							if (response.type >= 1) {

								analytics.eventTrack('Click', { category: 'Button', label: 'user-registered' });

								_this4.userService.authentication.isAuth = true;
								_this4.userService.authentication.userName = authData.userName;
								_this4.userService.authentication.userId = authData.userId;
								_this4.userService.$rootScope.$broadcast('loggedIn');
								//this.userService.login(patientRegistrationForm.email, patientRegistrationForm.password, analytics);
							} else if (response.type == 0) {
								analytics.eventTrack('Click', { category: 'Button', label: 'user-registration-failed-number-taken' });

								swangular.swal({
									type: 'error',
									title: 'Number Taken',
									html: duplicateMobileNumber
								});
							} else {
								analytics.eventTrack('Click', { category: 'Button', label: 'user-registration-failed-system-error' });

								swangular.swal({
									type: 'error',
									title: 'Account creation failed',
									html: 'Please contact <a href="mailto:support@clinivid.com.au">support.</a>'
								});
							}
						}).catch(function () {
							spinner.hide();
							analytics.eventTrack('Click', { category: 'Button', label: 'user-registration-failed-system-error' });
						});

						// this.authentication.isAuth = true;
						// this.authentication.userName = userName;
						// this.authentication.userId = authData.userId;

						// this.$rootScope.$broadcast('loggedIn');
						//
						// analytics.eventTrack('Click', {  category: 'Button', label: 'user-login-success' });
						//
						// return response;
					}).catch(function (err, status) {
						//if(_self){
						// _self.$scope.isLoginInProcess = false;
						spinner.hide();
						swangular.swal({
							type: 'error',
							title: 'Registration failed',
							html: 'Please contact support.'
						});
						//}

						// analytics.eventTrack('Click', {  category: 'Button', label: 'user-login-failure' });
						// this.loginError= err.data.error_description;
						// this.logOut(true, 'app.user.login');
						// this.$q.reject(err);
					});
				} else if (response.type === 0) {

					spinner.hide();

					swangular.swal({
						type: 'error',
						title: 'Account Already Exists',
						html: duplicateEmail
					});
				} else {
					// TBC - errors such as existing user etc should be managed

					swangular.swal({
						type: 'error',
						title: 'Registration Failed',
						html: errorMessages[response.error] || 'Please contact <a href="mailto:support@clinivid.com.au">support.</a>'
					});

					spinner.hide();
				}
			}).catch(function () {
				spinner.hide();

				swangular.swal({
					type: 'error',
					title: 'Account creation failed',
					html: 'Please contact <a href="mailto:support@clinivid.com.au">support.</a>'
				});
			});
		}
	}]);

	return RegisterController;
}();

angular.module('app.user').component('welcome', {
	controller: RegisterController,
	templateUrl: 'app/main/clinician/welcome.html'
}).component('register', {
	controller: RegisterController,
	templateUrl: 'app/user/auth/register2.html'
});


'use strict';

/**
 * mfaInputHelper
 *
 * Shared UI helper for the 6-digit MFA code input fields.
 * Used by LoginController and RegisterController.
 *
 */

function mfaInputHelper($timeout) {
    return {
        onCodeDigitInput: function onCodeDigitInput(mfaCode, index, event) {
            var value = event.target.value;
            if (!/^\d$/.test(value)) {
                mfaCode[index] = '';
                event.target.value = '';
                return;
            }
            mfaCode[index] = value;

            // Auto-advance to next field
            if (index < 5) {
                var next = document.getElementById('mfa-digit-' + (index + 1));
                if (next) next.focus();
            }
        },
        onCodeKeydown: function onCodeKeydown(mfaCode, index, event) {
            if (event.key === 'Backspace' && !mfaCode[index] && index > 0) {
                var prev = document.getElementById('mfa-digit-' + (index - 1));
                if (prev) prev.focus();
            }
        },
        focusElement: function focusElement(elementId) {
            var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var reFocusDelay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;


            $timeout(function () {
                var element = document.getElementById(elementId);
                if (element) {
                    element.focus();

                    if (reFocusDelay !== null) {
                        $timeout(function () {
                            element.focus();
                        }, reFocusDelay);
                    }
                }
            }, delay);
        },
        focusMfaButton: function focusMfaButton(index, event, button) {
            var mfaButton = document.getElementById(button);
            if (index === 5 && event.target.value !== '') {
                $timeout(function () {
                    if (mfaButton) {
                        mfaButton.focus();
                    }
                }, 0);
            }
        }
    };
}

mfaInputHelper.$inject = ['$timeout'];
angular.module('app.user').factory('mfaInputHelper', mfaInputHelper);


'use strict';

/**
 * mfaFactory
 *
 * Common factory that wraps MFA-related API calls.
 * Keeps HTTP logic out of controllers; state management remains in the controller.
 */

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MfaFactory = function () {
	function MfaFactory($http) {
		_classCallCheck(this, MfaFactory);

		this.$http = $http;
	}

	/**
  * Sends the initial MFA code for registration.
  *
  * @param {object} formData - { phoneNumber, countryCode, email, registerNumber }
  * @returns {Promise} Resolves with the HTTP response
  */


	_createClass(MfaFactory, [{
		key: 'sendRegisterCode',
		value: function sendRegisterCode(formData) {
			return this.$http.post(apiBasePathNoAuth + '/mfa/send-register-code', {
				mobile: formData.phoneNumber,
				region: formData.countryCode,
				email: formData.email,
				registrationId: formData.registerNumber
			});
		}

		/**
   * Resends the MFA code for an existing session.
   *
   * @param {string} sessionId - The current MFA session ID
   * @returns {Promise} Resolves with the HTTP response
   */

	}, {
		key: 'resendCode',
		value: function resendCode(sessionId) {
			return this.$http.post(apiBasePathNoAuth + '/mfa/resend-code', {
				sessionId: sessionId
			});
		}

		/**
   * Sends MFA code via email when SMS resends are exhausted.
   *
   * @param {string} sessionId - The MFA session ID
   * @returns {Promise} Resolves with the HTTP response
   */

	}, {
		key: 'sendCodeEmail',
		value: function sendCodeEmail(sessionId) {
			return this.$http.post(apiBasePathNoAuth + '/mfa/send-code-email', {
				sessionId: sessionId
			});
		}
	}]);

	return MfaFactory;
}();

angular.module('app.user').factory('mfaFactory', ['$http', function ($http) {
	return new MfaFactory($http);
}]);


'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LogoutUserController = function LogoutUserController($location, appContext, userService) {
    _classCallCheck(this, LogoutUserController);

    setTimeout(function () {
        userService.logOut();
    }, 100);
};

angular.module('app.user').component('logoutUser', {
    controller: LogoutUserController,
    templateUrl: 'app/user/auth/logout-user.html'
});


'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LoginController = function () {
  function LoginController($location, userService, $analytics, $scope, localStorageService, $mdSidenav, $document, swangular, $window, mfaFactory, mfaInputHelper, $timeout) {
    'inject';

    _classCallCheck(this, LoginController);

    this.userService = userService;
    this.$timeout = $timeout;
    localStorageService.clearAll();

    this.form = { email: $location.search().u };
    this.$analytics = $analytics;
    this.$scope = $scope;
    this.$mdSidenav = $mdSidenav;
    this.$document = $document;
    this.swangular = swangular;
    this.navigator = $window.navigator;
    this.$window = $window;
    this.$location = $location;
    this.mfaFactory = mfaFactory;
    this.mfaInputHelper = mfaInputHelper;

    // MFA state
    this.mfaVisible = false;
    this.mfaSessionId = null;
    this.maskedMobile = '';
    this.maskedEmail = '';
    this.mfaCode = ['', '', '', '', '', ''];
    this.mfaError = '';
    this.remainingResends = null;
    this.emailCodeSent = false;
    this.mfaSuccess = '';
    this.mfaTestMode = false;
    // keep a reference to the email used during login so we can pass it to
    // checkAccountStatus after successful MFA verify
    this._loginEmail = '';
  }

  _createClass(LoginController, [{
    key: 'login',
    value: function login() {
      var _this = this;

      // if(!this.navigator.onLine){
      //   this.swangular.swal({
      //     title: '',
      //
      //     html: '<img src="data:image/png;base64,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" style="width:40px;height:40px;"><br><br>Please check your internet connection.'
      //   });
      //   return;
      // }
      this.userService.loginError = undefined;
      var email = '';
      if (this.form.email) {
        email = this.form.email.toLowerCase().trim();
      }
      this._loginEmail = email;
      this.userService.login(email, this.form.password, this.$analytics, this).catch(function () {
        _this.$scope.isLoginInProcess = false;
      });
    }

    /**
     * Called by userService.login() when the API returns mfaRequired:true.
     * @param {object} data - The login response payload
     */

  }, {
    key: 'showMFAScreen',
    value: function showMFAScreen(data) {
      this.mfaSessionId = data.sessionId;
      this.maskedMobile = data.maskedMobile;
      this.maskedEmail = data.maskedEmail;
      this.mfaCode = ['', '', '', '', '', ''];
      this.mfaError = '';
      this.mfaSuccess = '';
      this.remainingResends = null;
      this.emailCodeSent = false;
      this.mfaTestMode = !!data.mfaTestMode;
      this.mfaVisible = true;
      if (this.mfaVisible) {
        //focus on input element
        this.mfaInputHelper.focusElement('mfa-digit-0');
      }
    }
  }, {
    key: 'onCodeDigitInput',
    value: function onCodeDigitInput(index, event) {
      //focus on confirm_button
      this.mfaInputHelper.focusMfaButton(index, event, 'confirm_btn');
      this.mfaInputHelper.onCodeDigitInput(this.mfaCode, index, event);
    }
  }, {
    key: 'onCodeKeydown',
    value: function onCodeKeydown(index, event) {
      //focus on confirm-button
      this.mfaInputHelper.focusMfaButton(index, event, 'confirm_btn');
      this.mfaInputHelper.onCodeKeydown(this.mfaCode, index, event);
    }

    /**
     * Submit the 6-digit MFA code to complete login.
     */

  }, {
    key: 'verifyMFA',
    value: function verifyMFA() {
      var _this2 = this;

      var code = this.mfaCode.join('');
      this.mfaError = '';

      this.userService.loginVerify(this.mfaSessionId, code).then(function (response) {
        if (response.data && response.data.access_token) {
          _this2.userService.completeLoginWithToken(response.data, _this2.$analytics, _this2._loginEmail, _this2);
        } else {
          _this2.mfaError = 'The 6 digits code you have entered is either not correct or has expired';
        }
      }).catch(function (err) {
        var errorMessages = {
          invalid_session: 'The 6 digits code you have entered is either not correct or has expired',
          session_expired: 'The 6 digits code you have entered is either not correct or has expired',
          invalid_code: 'The 6 digits code you have entered is either not correct or has expired'
        };
        var errorKey = err.data && err.data.error;
        _this2.mfaError = errorMessages[errorKey] || 'Verification failed. Please try again.';
      });
    }

    /**
     * Resend the SMS code.
     * API returns remainingResends; when it reaches 0 the "Send via email"
     * link becomes visible instead.
     */

  }, {
    key: 'resendCode',
    value: function resendCode() {
      var _this3 = this;

      this.mfaFactory.resendCode(this.mfaSessionId).then(function (response) {
        if (response.data.success) {
          _this3.remainingResends = response.data.remainingResends;
          _this3.mfaError = '';
          _this3.mfaSuccess = 'We have sent a text message with the new code.';
          _this3.mfaCode = ['', '', '', '', '', ''];
          var first = document.getElementById('mfa-digit-0');
          if (first) first.focus();
        } else {
          _this3.mfaError = response.data.error || 'Failed to resend the code. Please try again.';
        }
      }).catch(function (error) {
        _this3.mfaError = error.data.error || 'Failed to resend the code. Please try again.';
      });
    }

    /**
     * Send the MFA code via email (shown when SMS resends are exhausted).
     * API returns remainingResends; when it reaches 0 email attempts are also
     * exhausted and no further options are shown.
     */

  }, {
    key: 'sendCodeByEmail',
    value: function sendCodeByEmail() {
      var _this4 = this;

      this.emailCodeSent = false;
      this.mfaError = '';
      this.mfaSuccess = '';
      this.mfaFactory.sendCodeEmail(this.mfaSessionId).then(function (response) {
        if (response.data.success) {
          _this4.emailCodeSent = true;
          _this4.remainingResends = response.data.remainingResends;
          _this4.mfaError = '';
          _this4.mfaCode = ['', '', '', '', '', ''];
          var first = document.getElementById('mfa-digit-0');
          if (first) first.focus();
        } else {
          _this4.mfaError = 'Failed to send the code via email. Please try again.';
        }
      }).catch(function (error) {
        _this4.mfaError = error.data.error || 'Failed to send the code via email. Please try again.';
      });
    }

    /**
     * Go back to the login form and reset MFA state.
     */

  }, {
    key: 'cancelMFA',
    value: function cancelMFA() {
      this.mfaVisible = false;
      this.mfaSessionId = null;
      this.mfaCode = ['', '', '', '', '', ''];
      this.mfaError = '';
      this.mfaSuccess = '';
      this.remainingResends = null;
      this.emailCodeSent = false;
    }
  }, {
    key: 'togglePassword',
    value: function togglePassword() {
      var userpassword = this.$document[0].getElementById('userpassword');
      if (userpassword.type === 'password') {
        userpassword.type = 'text';
      } else {
        userpassword.type = 'password';
      }
    }
  }, {
    key: 'showTerms',
    value: function showTerms() {
      this.$window.location.href = terms;
      //this.$mdSidenav('termsAndConditions').toggle();
    }
  }, {
    key: 'showPrivacy',
    value: function showPrivacy() {
      this.$window.location.href = privacyPolicy;
      //this.$mdSidenav('privacy').toggle();
    }
  }, {
    key: 'closeSideNavPanelTermsAndConditions',
    value: function closeSideNavPanelTermsAndConditions() {
      this.$mdSidenav('termsAndConditions').close();
    }
  }, {
    key: 'closeSideNavPanelPrivacy',
    value: function closeSideNavPanelPrivacy() {
      this.$mdSidenav('privacy').close();
    }
  }]);

  return LoginController;
}();

angular.module('app.user').component('login', {
  controller: LoginController,
  templateUrl: 'app/user/auth/login.html'
});


'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ForgotPasswordController = function () {
  function ForgotPasswordController(appContext, userService, $analytics, swangular, $state) {
    _classCallCheck(this, ForgotPasswordController);

    this.app = appContext;
    this.userService = userService;
    this.emailAddress = "";
    this.$analytics = $analytics;
    this.backendError = false;
    this.swangular = swangular;
    this.$state = $state;
  }

  _createClass(ForgotPasswordController, [{
    key: 'forgotPassword',
    value: function forgotPassword() {
      var _this = this;

      this.backendError = false;
      var _self = this;
      this.userService.forgotPassword(this.emailAddress).then(function (response) {
        _this.$analytics.eventTrack('Click', { category: 'Button', label: 'emailed-link-to-reset-password-success' });
        if (response.type >= 1) {
          _self.swangular.swal('Request sent', 'We have sent a password reset link to your email address. Please check your email and follow instructions to reset your password.', 'success');

          _self.$state.go('app.user.login');
          // this.app.popup("Request sent", "We have sent a password reset link to your email address. Please check your email and follow instructions to reset your password."
          //   , 'Ok', 'app.user.login');
        } else {
          _this.backendError = true;
          _this.$analytics.eventTrack('Click', { category: 'Button', label: 'emailed-link-to-reset-password-failure' });
          //this.app.popup("Failed", "Sorry, the request has failed. Please try again another time.", 'Ok');
          _self.swangular.swal({
            type: 'error',
            title: 'Failed',
            html: 'Sorry, the request has failed. Please try again another time.'
          });
        }
      }).catch(function () {
        this.backendError = true;
        this.$analytics.eventTrack('Click', { category: 'Button', label: 'emailed-link-to-reset-password-failure' });
      });
    }
  }]);

  return ForgotPasswordController;
}();

angular.module('app.user').component('forgotPassword', {
  controller: ForgotPasswordController,
  templateUrl: 'app/user/auth/forgot-password.html'
});


'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CompleteUserProfile = function () {
  function CompleteUserProfile($stateParams, swangular, $http, userService, $rootScope, $state, $resource, $mdDialog, $window) {
    _classCallCheck(this, CompleteUserProfile);

    this.$stateParams = $stateParams;

    this.profession = '';
    this.countryCode = '';
    this.phoneNumber = '';
    this.title = '';
    this.lastName = '';
    this.firstName = '';
    this.middleName = '';
    this.id = '';
    this.registerNumber = '';

    this.swangular = swangular;
    this.$http = $http;
    this.userService = userService;
    this.$rootScope = $rootScope;
    this.context = undefined;
    this.$state = $state;
    this.$resource = $resource;
    this.$mdDialog = $mdDialog;
    this.$window = $window;

    if (this.$stateParams && this.$stateParams.contextPayload) {
      this.id = this.$stateParams.contextPayload.user.id;
      this.context = this.$stateParams.contextPayload;
    }

    this.registrationRegularExpression = '[A-Z]{3}[0-9]{7,10}';
    this.registrationInvalidMessage = "Must be 3 Capital letters followed by 7 to 10 digits";
  }

  _createClass(CompleteUserProfile, [{
    key: 'phoneNumberRegex',
    value: function phoneNumberRegex() {

      var regex;

      if (this.countryCode === 'AU') {
        regex = '^(04|#04)[0-9]{8}$';
      }
      // else if (this.countryCode === 'PH'){
      //   regex = '(\+?\d{2}?\s?\d{3}\s?\d{3}\s?\d{4})|([0]\d{3}\s?\d{3}\s?\d{4})';
      // }
      else if (this.countryCode === 'NZ') {
          regex = '^(((\+?64\s*[-\.]?[3-9]|\(?0[3-9]\)?)\s*[-\.]?\d{3}\s*[-\.]?\d{4})|((\+?64\s*[-\.\(]?2\d{1}[-\.\)]?|\(?02\d{1}\)?)\s*[-\.]?\d{3}\s*[-\.]?\d{3,5})|((\+?64\s*[-\.]?[-\.\(]?800[-\.\)]?|[-\.\(]?0800[-\.\)]?)\s*[-\.]?\d{3}\s*[-\.]?(\d{2}|\d{5})))$';
        } else if (this.countryCode === 'IN') {
          regex = '^(#?)[7-9][0-9]{9}$';
        }

      return regex;
    }
  }, {
    key: 'openAHRPAPage',
    value: function openAHRPAPage() {
      this.$window.open('http://www.ahpra.gov.au/Registration/Registers-of-Practitioners.aspx', '_blank');
    }
  }, {
    key: 'registerUser',
    value: function registerUser() {
      var _this = this;

      var _self = this;

      var url = apiBasePath + 'User/RegisterNewUserDetails';

      var duplicateMobileNumber = 'Submission Failed: The Mobile No: <b>' + this.phoneNumber + '</b> is already registered by another user. Please check your number or contact <a href="mailto:support@clinivid.com.au">support.</a>';

      var details = {
        Id: this.id,
        Title: this.title,
        Firstname: this.firstName,
        MiddleNames: this.middleName,
        Lastname: this.lastName,
        Mobile: this.phoneNumber,
        Profession: this.profession,
        Region: this.countryCode,
        RegistrationId: this.registerNumber
      };

      _self.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(document.body)
      });

      _self.$http.post(url, details).then(function (response) {
        if (response.data.type === 2) {

          _self.$resource(apiBasePath + 'User/Context').get({ username: _self.userService.authentication.userName }, function (response) {

            _self.$mdDialog.hide();

            if (response.type > 0) {

              if (response.payload && response.payload.statusCode === 30) {
                _this.authentication.isAuth = false;
                _this.$state.go('app.user.suspendedUser');
                return;
              }
              _.assign(_self.userService.context, _.pick(response.payload, ['roles', 'defaultRole', 'user']));

              _self.userService.initializeApp();
              _self.userService.authentication.isAuth = true;
              _self.$state.go('app.clinician.cases');
            } else {
              _self.userService.logOut();
            }
          }, function (response) {
            _self.$mdDialog.hide();
            _self.userService.logOut();
          });
        } else if (response.data.type === 0) {
          _self.$mdDialog.hide();
          _self.swangular.swal({
            type: 'error',
            title: 'Number Taken',
            html: duplicateMobileNumber
          });
        } else {
          _self.$mdDialog.hide();
          _self.swangular.swal({
            type: 'error',
            title: 'Failed to update profile',
            html: 'Please contact <a href="mailto:support@clinivid.com.au">support.</a>'
          });
        }
      }).catch(function (response) {
        _self.$mdDialog.hide();
        _self.swangular.swal({
          type: 'error',
          title: 'Failed to update profile',
          html: 'Please contact <a href="mailto:support@clinivid.com.au">support.</a>'
        });
      });
    }
  }]);

  return CompleteUserProfile;
}();

angular.module('app.user').component('completeUserProfile', {
  controller: CompleteUserProfile,
  templateUrl: 'app/user/auth/completeUserProfile.html'
});


'use strict';

(function () {
    'use strict';

    angular.module('app.core')
    //.provider('msNavigationService', msNavigationServiceProvider)
    .controller('HciNavigationController', HciNavigationController)
    // Vertical
    //.directive('msNavigation', msNavigationDirective)
    //.controller('MsNavigationNodeController', MsNavigationNodeController)
    //.directive('msNavigationNode', msNavigationNodeDirective)
    //.directive('msNavigationItem', msNavigationItemDirective)
    //Horizontal

    //.controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
    //.directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
    //.directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective)
    .directive('hciNavigationHorizontal', hciNavigationHorizontalDirective);

    /** @ngInject */
    function HciNavigationController($log, $scope, msNavigationService, userService) {
        var vm = this;
        vm.userContext = userService.context;
        vm.auth = userService.authentication;
        vm.true = true;
        // Data
        if ($scope.root) {
            vm.navigation = msNavigationService.getNavigationObject($scope.root);
            //vm.navinterfaces = msNavigationService.getNavigationObject($scope.root);
        } else {
            vm.navigation = msNavigationService.getNavigationObject();
            //vm.navinterfaces = msNavigationService.getNavigationObject();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /*$rootScope.$on('activeRoleChanged', function () {
            for (var i = 0; i < vm.navinterfaces.length; i++) {
                var navinterface = vm.navinterfaces[i];
                if (navinterface._id == userService.context.currentRole.interface)
                    vm.navigation = navinterface.children;
            }
            console.log("Nav updated!");
            console.log(vm.navinterfaces);
        });*/

        /**
         * Initialize
         */
        function init() {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function hciNavigationHorizontalDirective(msNavigationService) {
        return {
            restrict: 'E',
            scope: {
                root: '@'
            },
            controller: 'HciNavigationController as $ctrl',
            templateUrl: 'app/navigation/hci-navigation/templates/horizontal.html',
            transclude: true,
            compile: function compile(tElement) {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope) {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.viewer').controller('ViewerController', ViewerController);

    /** @ngInject */
    function ViewerController() {
        var vm = this;

        // Data
        //vm.helloText = ViewerData.data.helloText;

        // Methods

        //////////
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.enterprise', []).config(config).run(run);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.enterprise', {
            url: '/enterprise',
            views: {
                'content@app': {
                    templateUrl: 'app/main/enterprise/enterprise.html',
                    controller: 'EnterpriseController as $ctrl'
                }
                /*,
                resolve: {
                    SampleData: function (msApi)
                    {
                        return msApi.resolve('sample@get');
                    }
                }*/
            } }).state('app.enterprise.home', {
            url: '/home',
            views: {
                'content@app': {
                    templateUrl: 'app/main/enterprise/enterprise.html',
                    controller: 'EnterpriseController as $ctrl'
                }
                /*,
                resolve: {
                    SampleData: function (msApi)
                    {
                        return msApi.resolve('sample@get');
                    }
                }*/
            } }).state('app.enterprise.details', {
            url: '/details',
            views: {
                'content@app': {
                    templateUrl: 'app/main/enterprise/details.html',
                    controller: 'EnterpriseController as $ctrl'
                }
                /*,
                resolve: {
                    SampleData: function (msApi)
                    {
                        return msApi.resolve('sample@get');
                    }
                }*/
            } }).state('app.enterprise.people', {
            url: '/people',
            views: {
                'content@app': {
                    templateUrl: 'app/main/enterprise/people.html',
                    controller: 'EnterpriseController as $ctrl'
                }
                /*,
                resolve: {
                    SampleData: function (msApi)
                    {
                        return msApi.resolve('sample@get');
                    }
                }*/
            } }).state('app.enterprise.cases', {
            url: '/cases',
            views: {
                'content@app': {
                    templateUrl: 'app/main/enterprise/cases.html',
                    controller: 'EnterpriseController as $ctrl'
                }
                /*,
                resolve: {
                    SampleData: function (msApi)
                    {
                        return msApi.resolve('sample@get');
                    }
                }*/
            } })
        // need a url that is module independent
        .state('app.enterprise.accept', {
            url: '/accept',
            views: {
                'content@app': {
                    template: '<enterprise-accept></enterprise-accept>',
                    controller: 'EnterpriseController as $ctrl'
                }
                /*,
                resolve: {
                    Org: function (apiResolver, $stateParams)
                    {
                        return apiResolver.resolve('organisations.getById@get', { 'id': $stateParams.id });
                    }
                }
                /*,
                resolve: {
                    AdminData: function (msApi) {
                        return msApi.resolve('sample@get');
                    }
                }*/
            } });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/enterprise');

        // Api
        //msApiProvider.register('sample', ['app/data/sample/sample.json']);

    }

    function showMenu(msNavigationService) {
        // Navigation
        /*msNavigationService.saveItem('enterprise', {
            title: 'ENTERPRISE INTERFACE',
            group: true,
            weight: 3
        });
         msNavigationService.saveItem('enterprise.view', {
            title: 'Enterprise',
            icon: 'icon-tile-four',
            state: 'app.enterprise',
            translate: 'ENTERPRISE.ENTERPRISE_NAV',
            weight: 1
        });*/

        msNavigationService.saveItem('enterprise_home', {
            title: 'Home',
            icon: 'icon-home',
            state: 'app.enterprise.home',
            //group: true,
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'ENTERPRISE.ENTERPRISE_NAV_HOME',
            weight: 3
        });

        msNavigationService.saveItem('enterprise_organisations', {
            title: 'Organisations',
            icon: 'icon-hospital-building',
            state: 'app.enterprise.details',
            //group: true,
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'ENTERPRISE.ENTERPRISE_NAV_ORG',
            weight: 3
        });

        msNavigationService.saveItem('enterprise_people', {
            title: 'People',
            icon: 'icon-human-male-female',
            state: 'app.enterprise.people',
            //group: true,
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'ENTERPRISE.ENTERPRISE_NAV_PEOPLE',
            weight: 3
        });

        msNavigationService.saveItem('enterprise_cases', {
            title: 'Chats',
            icon: 'icon-folder-multiple-outline',
            state: 'app.enterprise.cases',
            //group: true,
            /*stateParams: {
                'param1': 'page'
             },*/
            translate: 'ENTERPRISE.ENTERPRISE_NAV_CASES',
            weight: 3
        });
    }

    function hideMenu(msNavigationService) {

        //msNavigationService.deleteItem('enterprise');
        msNavigationService.deleteItem('enterprise_home');
        msNavigationService.deleteItem('enterprise_organisations');
        msNavigationService.deleteItem('enterprise_people');
        msNavigationService.deleteItem('enterprise_cases');
    }

    function run($rootScope, userService, msNavigationService) {
        $rootScope.$on('activeRoleChanged', function () {

            if (userService.context.currentRole.interface == 'enterprise') showMenu(msNavigationService);else hideMenu(msNavigationService);
        });
    };
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.enterprise').controller('EnterpriseController', EnterpriseController);

    /** @ngInject */
    function EnterpriseController() {
        var vm = this;

        // Data
        //vm.helloText = EnterpriseData.data.helloText;

        // Methods

        //////////
    }
})();


'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EnterpriseAnonCtlr = function () {
    function EnterpriseAnonCtlr($state, $location, notificationDialog, $mdSidenav, api, appContext, userService) {
        'inject';

        _classCallCheck(this, EnterpriseAnonCtlr);

        this.$state = $state;
        this.notificationDialog = notificationDialog;
        this.$mdSidenav = $mdSidenav;
        this.api = api;
        this.userService = userService;

        this.app = appContext;

        this.form = { person: {} };

        if (userService.authentication.isAuth) userService.logOut();

        var acceptKey = $location.search().key;
        if (!acceptKey) $state.go('/');else this.loadForm(acceptKey);
    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */


    _createClass(EnterpriseAnonCtlr, [{
        key: 'toggleSidenav',
        value: function toggleSidenav(sidenavId) {
            this.$mdSidenav(sidenavId).toggle();
        }

        /**
         * Submit stepper form
         *
         * @param ev
         */

    }, {
        key: 'loadForm',
        value: function loadForm(acceptKey) {
            var _this = this;

            this.api.organisations.invite.get({ key: acceptKey }).$promise.then(function (response) {
                _this.form.person = response.payload;
                if (_this.form.person.isPractitioner) _this.form.person.role = "Clinician";else _this.form.person.role = "System Owner";
                _this.form.person.key = acceptKey;
                _this.form.person.lockEmail = true;
                _this.form.person.isPractitionerLocked = true;
            }).catch(function (response) {
                _this.notificationDialog.show("Invitation Failed!", "Sorry, we encountered an error in trying to load the invite. " + response);
            });
        }

        /**
         * Submit stepper form
         *
         * @param ev
         */

    }, {
        key: 'submitStepper',
        value: function submitStepper(ev) {
            var _this2 = this;

            // You can do an API call here to send the form to your server
            this.api.organisations.invite.save(this.form.person).$promise.then(function (response) {
                if (response.type > 0) {
                    _this2.app.popup("Welcome " + _this2.form.person.firstname, "Welcome " + _this2.form.person.firstname + ", you're account is now ready to use.", 'Ok');
                    return _this2.userService.login(_this2.form.person.email, _this2.form.person.password);
                } else _this2.app.popup("Error", response.message, 'Close');
            }).catch(function (response) {
                _this2.app.popup("Error", response.message, 'Close');
            });
        }
    }]);

    return EnterpriseAnonCtlr;
}();

angular.module('app.enterprise').component('enterpriseAccept', {
    templateUrl: 'app/main/enterprise/enterprise-accept.html',
    controller: EnterpriseAnonCtlr
});


'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Created by arolave on 26/05/2016.
 */
var ContactsController = function () {
    function ContactsController($scope) {
        'inject';

        var _this = this;

        _classCallCheck(this, ContactsController);

        $scope.$watchGroup(['$ctrl.currentPage', '$ctrl.totalItems'], function () {
            return _this.setLastShownIndex();
        });
    }

    _createClass(ContactsController, [{
        key: 'setLastShownIndex',
        value: function setLastShownIndex() {
            var calcPageMinMax = function calcPageMinMax(min, max, maxSize) {
                if (max - min + 1 === maxSize) return [min, max];

                var newMin = min > 1 ? min - 1 : min;
                var newMax = max < maxSize ? max + 1 : max;
                return calcPageMinMax(newMin, newMax, maxSize);
            };

            if (this.currentPage == null) return;

            var endOfPage = this.currentPage * this.pageSize;
            this.skipRows = endOfPage - this.pageSize;
            this.lastShownIndex = endOfPage > this.totalItems ? this.totalItems : endOfPage;
            this.currentPage = Math.ceil((this.skipRows + 1) / this.pageSize);
            var maxPages = Math.ceil(this.totalItems / this.pageSize);

            var _calcPageMinMax = calcPageMinMax(this.currentPage, this.currentPage, maxPages),
                _calcPageMinMax2 = _slicedToArray(_calcPageMinMax, 2),
                minIndex = _calcPageMinMax2[0],
                maxIndex = _calcPageMinMax2[1];

            this.pageLinks = _.range(minIndex, maxIndex + 1);
        }
    }, {
        key: 'gotoPage',
        value: function gotoPage(page) {
            console.log('contacts.gotoPage(' + page + ')');
            this.loadPage({ page: page, pageSize: this.pageSize });
        }
    }]);

    return ContactsController;
}();

angular.module('clinivid').component('contacts', {
    controller: ContactsController,
    templateUrl: 'app/main/contacts/contacts.html',
    bindings: {
        items: '<',
        totalItems: '<',
        currentPage: '<',
        pageSize: '<',
        showActions: '<',
        createCase: '&',
        loadPage: '&',
        editContact: '&',
        deleteContactWithConfirm: '&',
        selectContact: '&',
        searchTerm: '<'
    }
});


'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ClinicianCtlr = function () {
    function ClinicianCtlr($state, $stateParams, notificationDialog, $mdSidenav, msApi, userService) {
        'inject';

        var _this = this;

        _classCallCheck(this, ClinicianCtlr);

        this.$state = $state;
        this.notificationDialog = notificationDialog;
        this.$mdSidenav = $mdSidenav;
        this.msApi = msApi;

        this.userContext = userService.context;
        this.form = { person: { Role: 'Clinician' } };

        // Data
        var clinicianId = $stateParams.id;
        if (clinicianId) {
            //TODO rename org to clinician
            msApi.organisations.getById.get({ 'id': orgId }.$promise.then(function (response) {
                return _this.org = angular.copy(response);
            }));
        }
    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */


    _createClass(ClinicianCtlr, [{
        key: 'toggleSidenav',
        value: function toggleSidenav(sidenavId) {
            this.$mdSidenav(sidenavId).toggle();
        }

        /**
         * Search
         *
         * @param search variable
         */

    }, {
        key: 'search',
        value: function search(varName) {}
        //TODO


        /**
         * Submit stepper form
         *
         * @param ev
         */

    }, {
        key: 'submitStepper',
        value: function submitStepper(ev) {
            var _this2 = this;

            this.form.person.OrgId = this.userContext.currentOrg.id;

            // You can do an API call here to send the form to your server
            // You can do an API call here to send the form to your server
            this.msApi.request('clinicians@save', this.form.person).then(function (response) {
                _this2.notificationDialog.show(response.firstname + ' Added', response.firstname + ' has been successfully added.');
                $state.go('app.admin.people');
            }).catch(function (response) {
                console.error(response);
                _this2.notificationDialog.show("Add Clinician Unsuccessful!", "Sorry, we encountered an error in trying to add the clinician. " + response);
            });
        }

        /**
         * Submit stepper form
         *
         * @param ev
         */

    }, {
        key: 'submitEdit',
        value: function submitEdit() {}
        //TODO


        /**
         * Send form
         */

    }, {
        key: 'sendForm',
        value: function sendForm(ev) {
            //TODO
        }
    }]);

    return ClinicianCtlr;
}();

angular.module('app.clinician').component('clinician', {
    controller: ClinicianCtlr,
    templateUrl: 'app/main/clinician/clinician.html'
}).component('clinicianSettings', {
    controller: ClinicianCtlr,
    templateUrl: 'app/main/clinician/settings.html'
});


'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ClinicianAnonCtlr = function () {
    function ClinicianAnonCtlr($state, $location, notificationDialog, $mdSidenav, api, msApi, appContext, userService) {
        'inject';

        _classCallCheck(this, ClinicianAnonCtlr);

        this.$state = $state;
        this.notificationDialog = notificationDialog;
        this.$mdSidenav = $mdSidenav;
        this.msApi = msApi;
        this.api = api;
        this.userService = userService;

        this.app = appContext;

        this.form = { person: {} };

        // ***** This is an Anonomous Controller *****//
        if (userService.authentication.isAuth) userService.logOut();

        // Data
        var acceptKey = $location.search().key;
        if (!acceptKey) $state.go('/');else this.loadForm(acceptKey);
    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */


    _createClass(ClinicianAnonCtlr, [{
        key: 'toggleSidenav',
        value: function toggleSidenav(sidenavId) {
            this.$mdSidenav(sidenavId).toggle();
        }

        /**
         * Submit stepper form
         *
         * @param ev
         */

    }, {
        key: 'loadForm',
        value: function loadForm(acceptKey) {
            var _this = this;

            var data = { key: acceptKey };
            this.msApi.request('clinician.invite@get', data).then(function (response) {
                console.log(response);
                _this.form.person = response;
                _this.form.person.key = acceptKey;
                _this.form.person.lockEmail = true;
                _this.form.person.role = "Clinician";
                //String(this.form.mobile);
            }).catch(function (response) {
                _this.notificationDialog.show("Invitation Failed!", "Sorry, we encountered an error in trying to load the invite. " + response);
            });
        }

        /**
         * Submit stepper form
         *
         * @param ev
         */

    }, {
        key: 'submitStepper',
        value: function submitStepper(ev) {
            var _this2 = this;

            // You can do an API call here to send the form to your server
            this.api.clinicians.invite.save(this.form.person).$promise.then(function (response) {
                //console.log(response);
                if (response.type > 0) {
                    _this2.app.popup("Welcome " + _this2.form.person.firstname, "Welcome " + _this2.form.person.firstname + ", you're account is now ready to use.", 'Ok');
                    return _this2.userService.login(_this2.form.person.email, _this2.form.person.password);
                } else _this2.app.popup("Error", response.message, 'Close');
            }).catch(function (response) {
                _this2.app.popup("Error", response.message, 'Close');
            });
        }
    }]);

    return ClinicianAnonCtlr;
}();

angular.module('app.clinician').component('clinicianAccept', {
    controller: ClinicianAnonCtlr,
    templateUrl: 'app/main/clinician/clinician-accept.html'
});


'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AdminController = function AdminController() {
    _classCallCheck(this, AdminController);

    this.page = {};
};

angular.module('app.admin').component('admin', {
    controller: AdminController,
    templateUrl: 'app/main/admin/admin.html'
});


'use strict';

(function () {
    'use strict';

    angular.module('app.core').provider('clinividTheming', clinividThemingProvider);

    /** @ngInject */
    function clinividThemingProvider() {
        // Inject Cookies Service
        var $cookies;

        angular.injector(['ngCookies']).invoke(['$cookies', function (_$cookies) {
            $cookies = _$cookies;
        }]);

        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        var registeredPalettes, registeredThemes;

        // Methods
        this.setRegisteredPalettes = setRegisteredPalettes;
        this.setRegisteredThemes = setRegisteredThemes;

        //////////

        /**
         * Set registered palettes
         *
         * @param _registeredPalettes
         */
        function setRegisteredPalettes(_registeredPalettes) {
            registeredPalettes = _registeredPalettes;
        }

        /**
         * Set registered themes
         *
         * @param _registeredThemes
         */
        function setRegisteredThemes(_registeredThemes) {
            registeredThemes = _registeredThemes;
        }

        /**
         * Service
         */
        this.$get = function () {
            var service = {
                getRegisteredPalettes: getRegisteredPalettes,
                getRegisteredThemes: getRegisteredThemes,
                setActiveTheme: setActiveTheme,
                setThemesList: setThemesList,
                themes: {
                    list: {},
                    active: {
                        'name': '',
                        'theme': {}
                    }
                }
            };

            return service;

            //////////

            /**
             * Get registered palettes
             *
             * @returns {*}
             */
            function getRegisteredPalettes() {
                return registeredPalettes;
            }

            /**
             * Get registered themes
             *
             * @returns {*}
             */
            function getRegisteredThemes() {
                return registeredThemes;
            }

            /**
             * Set active theme
             *
             * @param themeName
             */
            function setActiveTheme(themeName) {
                // If theme does not exist, fallback to the default theme
                if (angular.isUndefined(service.themes.list[themeName])) {
                    // If there is no theme called "default"...
                    if (angular.isUndefined(service.themes.list.default)) {
                        $log.error('You must have at least one theme named "default"');
                        return;
                    }

                    $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                    // Otherwise set theme to default theme
                    service.themes.active.name = 'default';
                    service.themes.active.theme = service.themes.list.default;
                    $cookies.put('selectedTheme', service.themes.active.name);

                    return;
                }

                service.themes.active.name = themeName;
                service.themes.active.theme = service.themes.list[themeName];
                $cookies.put('selectedTheme', themeName);
            }

            /**
             * Set available themes list
             *
             * @param themeList
             */
            function setThemesList(themeList) {
                service.themes.list = themeList;
            }
        };
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.core').config(config);

    /** @ngInject */
    function config($mdThemingProvider, clinividPalettes, clinividThemes, clinividThemingProvider) {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke(['$cookies', function (_$cookies) {
            $cookies = _$cookies;
        }]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if (customTheme) {
            clinividThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(clinividPalettes, function (palette) {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(clinividThemes, function (theme, themeName) {
            $mdThemingProvider.theme(themeName).primaryPalette(theme.primary.name, theme.primary.hues).accentPalette(theme.accent.name, theme.accent.hues).warnPalette(theme.warn.name, theme.warn.hues).backgroundPalette(theme.background.name, theme.background.hues);
        });

        // Store generated PALETTES and THEMES objects from $mdThemingProvider
        // in our custom provider, so we can inject them into other areas
        clinividThemingProvider.setRegisteredPalettes($mdThemingProvider._PALETTES);
        clinividThemingProvider.setRegisteredThemes($mdThemingProvider._THEMES);
    }
})();


'use strict';

(function () {
    'use strict';

    var clinividThemes = {
        'default': {
            primary: {
                name: 'clinivid-purple',
                hues: {
                    'default': '500',
                    'hue-1': '600',
                    'hue-2': '700',
                    'hue-3': 'A700'
                }
            },
            accent: {
                name: 'clinivid-pale-purple',
                hues: {
                    'default': '500',
                    'hue-1': '600',
                    'hue-2': '700',
                    'hue-3': 'A700'
                }
            },
            warn: { name: 'red' },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1': '100',
                    'hue-2': '50',
                    'hue-3': '300'
                }
            }
        }
    };

    angular.module('app.core').constant('clinividThemes', clinividThemes);
})();


'use strict';

(function () {
    'use strict';

    var clinividPalettes = [{
        name: 'clinivid-purple',
        options: {
            '50': '#F3E5F5',
            '100': '#E1BEE7',
            '200': '#CE93D8',
            '300': '#BA68C8',
            '400': '#AB47BC',
            '500': '#9C27B0',
            '600': '#8E24AA',
            '700': '#7B1FA2',
            '800': '#6A1B9A',
            '900': '#4A148C',
            'A100': '#EA80FC',
            'A200': '#E040FB',
            'A400': '#D500F9',
            'A700': '#AA00FF',
            'contrastDefaultColor': 'light',
            'contrastDarkColors': '50 100 200 A100',
            'contrastStrongLightColors': '300 400'
        }
    }, {
        name: 'clinivid-pale-purple',
        options: {
            '50': '#92298c',
            '100': '#92298c',
            '200': '#92298c',
            '300': '#92298c',
            '400': '#92298c',
            '500': '#92298c',
            '600': '#92298c',
            '700': '#92298c',
            '800': '#92298c',
            '900': '#92298c',
            'A100': '#92298c',
            'A200': '#92298c',
            'A400': '#92298c',
            'A700': '#92298c',

            'contrastDefaultColor': 'light',
            'contrastDarkColors': '50 100 200 A100',
            'contrastStrongLightColors': '300 400'
        }
    }];

    angular.module('app.core').constant('clinividPalettes', clinividPalettes);
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.core').factory('clinividGenerator', clinividGeneratorService);

    /** @ngInject */
    function clinividGeneratorService($cookies, $log, clinividTheming) {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba: rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate() {
            var registeredThemes = clinividTheming.getRegisteredThemes();
            var registeredPalettes = clinividTheming.getRegisteredPalettes();

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme) {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName) {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name': colorType.name,
                        'levels': {
                            'default': {
                                'color': rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1': {
                                'color': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2': {
                                'color': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3': {
                                'color': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName) {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName) {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName) {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName) {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes) {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme) {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName) {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            clinividTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if (selectedTheme) {
                clinividTheming.setActiveTheme(selectedTheme);
            } else {
                clinividTheming.setActiveTheme('default');
            }
        }

        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars) {
            var cssTemplate = '[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched) {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel) {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if (color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255) {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if (contrastLevel) {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if (color.length === 3) {
                return 'rgb(' + color.join(',') + ')';
            } else if (color.length === 4) {
                return 'rgba(' + color.join(',') + ')';
            } else {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel) {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if (color[0] === 255 && color[1] === 255 && color[2] === 255) {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if (color[0] === 0 && color[1] === 0, color[2] === 0) {
                    color[3] = contrastLevels.black[contrastLevel];
                }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.core').controller('MsThemeOptionsController', MsThemeOptionsController).directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, clinividTheming) {
        var vm = this;

        // Data
        vm.themes = clinividTheming.themes;
        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName) {
            // Set active theme
            clinividTheming.setActiveTheme(themeName);
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode() {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', vm.layoutMode === 'boxed');
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle() {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions() {
        return {
            restrict: 'E',
            scope: {
                panelOpen: '=?'
            },
            controller: 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile: function compile(tElement) {
                tElement.addClass('ms-theme-options');

                return function postLink(scope, iElement) {
                    var bodyEl = angular.element('body'),
                        backdropEl = angular.element('<div class="ms-theme-options-backdrop"></div>');

                    // Panel open status
                    scope.panelOpen = scope.panelOpen || false;

                    /**
                     * Toggle options panel
                     */
                    function toggleOptionsPanel() {
                        if (scope.panelOpen) {
                            closeOptionsPanel();
                        } else {
                            openOptionsPanel();
                        }
                    }

                    function openOptionsPanel() {
                        // Set panelOpen status
                        scope.panelOpen = true;

                        // Add open class
                        iElement.addClass('open');

                        // Append the backdrop
                        bodyEl.append(backdropEl);

                        // Register the event
                        backdropEl.on('click touch', closeOptionsPanel);
                    }

                    /**
                     * Close options panel
                     */
                    function closeOptionsPanel() {
                        // Set panelOpen status
                        scope.panelOpen = false;

                        // Remove open class
                        iElement.removeClass('open');

                        // De-register the event
                        backdropEl.off('click touch', closeOptionsPanel);

                        // Remove the backdrop
                        backdropEl.remove();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsPanel = toggleOptionsPanel;
                };
            }
        };
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.core').factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window) {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists: exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile: isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser() {
            // If we already tested, do not test again
            if (browserInfo) {
                return browserInfo;
            }

            var browserData = [{
                string: $window.navigator.userAgent,
                subString: 'Edge',
                versionSearch: 'Edge',
                identity: 'Edge'
            }, {
                string: $window.navigator.userAgent,
                subString: 'Chrome',
                identity: 'Chrome'
            }, {
                string: $window.navigator.userAgent,
                subString: 'OmniWeb',
                versionSearch: 'OmniWeb/',
                identity: 'OmniWeb'
            }, {
                string: $window.navigator.vendor,
                subString: 'Apple',
                versionSearch: 'Version',
                identity: 'Safari'
            }, {
                prop: $window.opera,
                identity: 'Opera'
            }, {
                string: $window.navigator.vendor,
                subString: 'iCab',
                identity: 'iCab'
            }, {
                string: $window.navigator.vendor,
                subString: 'KDE',
                identity: 'Konqueror'
            }, {
                string: $window.navigator.userAgent,
                subString: 'Firefox',
                identity: 'Firefox'
            }, {
                string: $window.navigator.vendor,
                subString: 'Camino',
                identity: 'Camino'
            }, {
                string: $window.navigator.userAgent,
                subString: 'Netscape',
                identity: 'Netscape'
            }, {
                string: $window.navigator.userAgent,
                subString: 'MSIE',
                identity: 'Explorer',
                versionSearch: 'MSIE'
            }, {
                string: $window.navigator.userAgent,
                subString: 'Trident/7',
                identity: 'Explorer',
                versionSearch: 'rv'
            }, {
                string: $window.navigator.userAgent,
                subString: 'Gecko',
                identity: 'Mozilla',
                versionSearch: 'rv'
            }, {
                string: $window.navigator.userAgent,
                subString: 'Mozilla',
                identity: 'Netscape',
                versionSearch: 'Mozilla'
            }];

            var osData = [{
                string: $window.navigator.platform,
                subString: 'Win',
                identity: 'Windows'
            }, {
                string: $window.navigator.platform,
                subString: 'Mac',
                identity: 'Mac'
            }, {
                string: $window.navigator.platform,
                subString: 'Linux',
                identity: 'Linux'
            }, {
                string: $window.navigator.platform,
                subString: 'iPhone',
                identity: 'iPhone'
            }, {
                string: $window.navigator.platform,
                subString: 'iPod',
                identity: 'iPod'
            }, {
                string: $window.navigator.platform,
                subString: 'iPad',
                identity: 'iPad'
            }, {
                string: $window.navigator.platform,
                subString: 'Android',
                identity: 'Android'
            }];

            var versionSearchString = '';

            function searchString(data) {
                for (var i = 0; i < data.length; i++) {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if (dataString) {
                        if (dataString.indexOf(data[i].subString) !== -1) {
                            return data[i].identity;
                        }
                    } else if (dataProp) {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString) {
                var index = dataString.indexOf(versionSearchString);

                if (index === -1) {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os: os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator() {
            var S4 = function S4() {
                return ((1 + Math.random()) * 0x10000 || 0).toString(16).substring(1);
            };
            return S4() + S4() + S4() + S4() + S4() + S4();
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile() {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array) {
            if (array.indexOf(item) === -1) {
                array.push(item);
            } else {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.core').provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider() {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject required services
        var $log = angular.injector(['ng']).get('$log'),
            $resource = angular.injector(['ngResource']).get('$resource');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url) {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl() {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject() {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource) {
            if (!angular.isString(key)) {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if (!angular.isArray(resource)) {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Prepare the resource object
            var resourceObj = {
                url: baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions: resource[2] || [],
                options: resource[3] || {}
            };

            // Assign the resource
            api[key] = $resource(resourceObj.url, resourceObj.paramDefaults, resourceObj.actions, resourceObj.options);
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($q, $log) {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register: register,
                resolve: resolve,
                request: request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters) {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if (!resource || !method) {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if (!apiObject) {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                } else {
                    apiObject[method](params,

                    // Success
                    function (response) {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response) {
                        deferred.reject(response);
                    });
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error) {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if (!resource || !method) {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if (!apiObject) {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                } else {
                    apiObject[method](params,

                    // SUCCESS
                    function (response) {
                        // Resolve the promise
                        deferred.resolve(response);

                        // Call the success function if there is one
                        if (angular.isDefined(success) && angular.isFunction(success)) {
                            success(response);
                        }
                    },

                    // ERROR
                    function (response) {
                        // Reject the promise
                        deferred.reject(response);

                        // Call the error function if there is one
                        if (angular.isDefined(error) && angular.isFunction(error)) {
                            error(response);
                        }
                    });
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.core').factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api) {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters) {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if (!resource || !method) {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if (!apiObject) {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            } else {
                apiObject[method](params,

                // Success
                function (response) {
                    deferred.resolve(response);
                },

                // Error
                function (response) {
                    deferred.reject(response);
                });
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource) {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for (var l = 0; l < resourceParts.length; l++) {
                if (angular.isUndefined(apiObject[resourceParts[l]])) {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if (!apiObject) {
                return false;
            }

            return apiObject;
        }
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.core').directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'EA',
            compile: function compile(tElement, tAttrs) {
                var code;
                //No attribute? code is the content
                if (!tAttrs.code) {
                    code = tElement.html();
                    tElement.empty();
                }

                return function (scope, iElement, iAttrs) {
                    if (iAttrs.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(iAttrs.code);
                    }
                    var shouldInterpolate = scope.$eval(iAttrs.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }

                            var contentParent = angular.element('<pre><code class="highlight" ng-non-bindable></code></pre>');

                            iElement.append(contentParent);

                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {
                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);

                        lines = lines.map(function (line) {
                            return line.replace(startingWhitespaceRegex, '').replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(iAttrs.language || iAttrs.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value.replace(/=<span class="hljs-value">""<\/span>/gi, '').replace('<head>', '').replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.core').filter('filterByTags', filterByTags).filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags() {
        return function (items, tags) {
            if (items.length === 0 || tags.length === 0) {
                return items;
            }

            var filtered = [];

            items.forEach(function (item) {
                var match = tags.every(function (tag) {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag) {
                        if (itemTag.name === tag.name) {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if (match) {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags() {
        return function (itemTags, tags) {
            if (itemTags.length === 0 || tags.length === 0) {
                return;
            }

            if (itemTags.length < tags.length) {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag) {
                var tagExists = false;

                itemTags.forEach(function (itemTag) {
                    if (itemTag.name === tag.name) {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if (match) {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.core').filter('toTrusted', toTrustedFilter).filter('htmlToPlaintext', htmlToPlainTextFilter).filter('nospace', nospaceFilter).filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce) {
        return function (value) {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter() {
        return function (text) {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter() {
        return function (value) {
            return !value ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter() {
        return function (doc) {
            if (!doc) {
                return;
            }
            if (doc.type === 'directive') {
                return doc.name.replace(/([A-Z])/g, function ($1) {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.core').provider('clinividConfig', clinividConfigProvider);

    /** @ngInject */
    function clinividConfigProvider() {
        // Default configuration
        var clinividConfiguration = {
            'disableCustomScrollbars': false,
            'disableMdInkRippleOnMobile': true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration) {
            clinividConfiguration = angular.extend({}, clinividConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function () {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName) {
                if (angular.isUndefined(clinividConfiguration[configName])) {
                    return false;
                }

                return clinividConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue) {
                clinividConfiguration[configName] = configValue;
            }
        };
    }
})();


/**
 * Created by arolave on 26/06/2016.
 */
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProfileController = function () {
  function ProfileController($resource, appContext, userService, api, $analytics, $rootScope, $http, $mdDialog, $q, swangular, localStorageService, $stateParams, $state, $scope, $document, $filter) {
    'inject';

    var _this = this;

    _classCallCheck(this, ProfileController);

    this.app = appContext;
    this.swangular = swangular;
    this.$q = $q;
    this.api = api;
    this.$state = $state;
    this.localStorageService = localStorageService;
    this.userName = userService.authentication.userName;
    this.context = userService.context;
    this.$analytics = $analytics;
    this.$resource = $resource;
    this.$filter = $filter;
    this.$rootScope = $rootScope;
    this.userService = userService;
    this.$http = $http;
    this.originalProfileData;
    this.$mdDialog = $mdDialog;
    this.unavailableTime = undefined;
    this.unavailableDate = undefined;
    this.minUnavailableDate = new Date();
    this.maxUnavailableDate = new Date(new Date().setMonth(new Date().getMonth() + 1));
    this.profileEditable = true;
    this.showLockedFields = false;
    this.lockedFieldTextInfo;
    this.$scope = $scope;
    this.createOrganizationForm = {};
    this.orgSearchTerm = '';
    this.planPrice = 12;
    this.planFeature = 'Meetings - $12/month';
    this.planTargets = 'Small Practice';
    this.$stateParams = $stateParams;
    this.planType = 'MDT'; // - possible values MESSAGING MDT

    this.$document = $document;
    this.$scope.saveProfileInProcess = false;
    this.selectedOrgID = undefined;
    this.selectedMembershipID = undefined;
    this.selectedOrgDisplayName = '';
    this.selectedOrgFormalName = '';

    this.selectedOrgDisplayNameOriginal = '';
    this.selectedOrgFormalNameOriginal = '';

    this.showDeletePage = 1;
    this.reason2Delete = "";
    this.password = "";
    this.password2Deactivate = "";
    this.password2Delete = "";
    this.reason2Deactivate = "";

    this.profilePageMode = 1;

    if (this.$stateParams.fromContactsPage) {
      this.profileEditable = false;
    }

    this.orgInfo = [];
    this.inviteStatus = [];
    this.allCases = [];
    this.caseSearchTerm = '';
    this.allCasesSelected = false;
    this.inviteSearchTerm = '';
    this.newInvite = {};
    this.newNotification = {};
    this.searchUser = {};
    this.clinividUserFound = false;
    this.clinividUserIDFromSearch = '';
    this.orgUsers = [];
    this.orgUserSearchTerm = '';
    this.orgContacts = [];
    this.orgContactSearchTerm = '';
    this.contactEdited = {};
    this.rawContact = {};
    this.editInvitee = {};
    this.selectedInvitee = {};
    this.addContactMode = 'phoneMode';
    this.addContact = {};
    this.isContactNewUser = false;
    this.isContactExistingUser = false;
    this.existingUserPayload = {};
    this.newUserPayload = {};
    this.chipContacts = [];
    this.allMembers = [];
    this.allExternalContacts = [];
    this.searchTextChip = null;
    this.selectedItemChip = null;

    this.allOrganisationPage = 'ALL-ORGANISATION';
    this.noOrganisationPage = 'NO-ORGANISATION';
    this.organisationInfoPage = 'ORGANISATION-INFO';
    this.addMemberPage = 'ADD-MEMBER';
    this.inviteMemberPage = 'INVITE-MEMBER';
    this.inviteStatusPage = 'INVITE-STATUS';
    this.manageMembersPage = 'MANAGE-MEMBERS';
    this.manageMembersEditPage = 'MANAGE-MEMBERS-EDIT';
    this.manageContactsPage = 'MANAGE-CONTACTS';
    this.activityStatusPage = 'ACTIVITY-STATUS';
    this.manageCasesPage = 'MANAGE-CASES';
    this.manageContactsAddPage = 'MANAGE-CONTACTS-ADD';
    this.manageContactsEditpage = 'MANAGE-CONTACTS-EDIT';
    this.notificationsPage = 'NOTIFICATIONS';
    this.activityStatusDetails = 'ACTIVITY-STATUS-DETAILS';

    this.selectedCaseMessageDetails = [];

    this.organizationPage = this.noOrganisationPage;

    if (!this.context || !this.context.currentRole) {
      this.$resource(apiBasePath + 'User/Context').get({ username: userService.authentication.userName },
      //return this.msApi.request('app.userContext@get', { username: this.authentication.userName },
      // SUCCESS
      function (response) {

        if (response.type > 0) {
          _.assign(userService.context, _.pick(response.payload, ['roles', 'defaultRole', 'user']));

          var filterViewer = [];

          for (var i = 0; i < userService.context.roles.length; i++) {
            if (userService.context.roles[i].name !== 'Viewer' && userService.context.roles[i].name !== 'HCI-Admin') {
              filterViewer.push(userService.context.roles[i]);
            }
          }

          if (userService.context.defaultRole.name === 'Viewer') {
            userService.context.defaultRole = filterViewer[0];
          }

          userService.context.roles = filterViewer;

          _this.$rootScope.$broadcast('userContextChanged');
          // let defaultRole = this.localStorageService.get(`defaultRoles.${this.context.user.id}`);
          // if (!defaultRole) {
          //   defaultRole = {name: this.context.defaultRole.name, domain: this.context.defaultRole.domain}
          // } - commented as this is picking up cached profile

          var defaultRole = {
            name: userService.context.defaultRole.name,
            domain: userService.context.defaultRole.domain
          };

          userService.setActiveRole(defaultRole.name, defaultRole.domain);

          for (var _i = 0; _i < userService.context.roles.length; _i++) {
            // - This block of code formats organisation name. It's a IE-11 fix.
            var r = userService.context.roles[_i];

            if (!r) {
              continue;
            }

            // var isPersonalProfile = r.orgDisplayName.toUpperCase().includes('PRACTICE OF');
            var isPersonalProfile = r.orgDisplayName.toUpperCase().indexOf('PRACTICE OF') >= 0;

            if (isPersonalProfile) {
              r.formattedOrganizationName = 'Personal Account';
              r.customOrganizationName = r.formattedOrganizationName;
            } else {
              r.formattedOrganizationName = r.orgDisplayName;
              if (r.formattedOrganizationName.length > 18) r.customOrganizationName = r.formattedOrganizationName.slice(0, 18).concat('...');else r.customOrganizationName = r.formattedOrganizationName;
            }
          };
        } else {

          return userService.logOut();
        }

        _this.context = userService.context;
        _this.getUserProfile();
        _this.getUserOrganization();
        _this.getUserDisplayName();
      },
      // ERROR
      function (response) {

        return userService.logOut();
      });
    } else {
      this.getUserProfile();
      this.getUserOrganization();
      this.getUserDisplayName();
    }

    this.availabilityMap = {};
  }

  _createClass(ProfileController, [{
    key: 'loadAvailability',
    value: function loadAvailability() {
      var _this2 = this;

      var _self = this;
      var allAvailability = [];

      var _loop = function _loop(i) {
        if (_self.context.roles[i].name !== 'Viewer' && _self.context.roles[i].name !== 'OrgAdmin' && _self.context.roles[i].name !== 'OrgOwner') {
          var promise = _this2.$http({
            url: apiBasePath + 'User/GetCurrentAvailabilitySetting?mId=' + _self.context.roles[i].membershipId,
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
          }).then(function (response) {

            if (response.data.type > 0) {
              var currentAvailability = response.data.payload.currentAvailability;
              var status = void 0;
              if (currentAvailability === 1) {
                status = 'Available';
              } else if (currentAvailability === 2) {
                status = 'Unavailable';
              } else if (currentAvailability === 50) {
                status = 'Not to be Disturbed';
              } else if (currentAvailability === 20) {
                status = 'Unavailable';
              }

              _self.availabilityMap[_self.context.roles[i].membershipId] = {
                'availability': currentAvailability,
                'status': status
              };
            }
          });

          allAvailability.push(promise);
        } // - End of IF loop
      };

      for (var i = 0; i < _self.context.roles.length; i++) {
        _loop(i);
      } // - End of for loop

      if (allAvailability.length > 0) {
        _self.$q.all(allAvailability).then(function () {
          // _self.showAllProfiles = true;
          _self.profilePageMode = 2;
          _self.$mdDialog.hide();
        });
      }
    }
  }, {
    key: 'getStatus',
    value: function getStatus(membershipId) {
      if (this.availabilityMap[membershipId]) {
        var status = this.availabilityMap[membershipId].status;
        return status;
      }
      return 'Unavailable';
    }
  }, {
    key: 'showOrganizationalDetails',
    value: function showOrganizationalDetails(selectedOrgID, selectedMembershipID) {

      this.showModalSpinner(this);

      var _self = this;
      _self.selectedOrgID = selectedOrgID;
      _self.selectedMembershipID = selectedMembershipID;

      this.$resource(apiBasePath + 'Organisations/GetById').get({
        mId: selectedMembershipID,
        orgId: selectedOrgID

      }).$promise.then(function (response) {
        if (response && response.type > 0) {
          if (response['payload']) {
            _self.selectedOrgDisplayName = response['payload'].displayName;
            _self.selectedOrgFormalName = response['payload'].formalName;
            _self.selectedOrgDisplayNameOriginal = response['payload'].displayName;
            _self.selectedOrgFormalNameOriginal = response['payload'].formalName;
            _self.organizationPage = _self.organisationInfoPage;
          }
          _self.$mdDialog.hide();
        }
      }).catch(function () {
        _self.$mdDialog.hide();
      });
    }
  }, {
    key: 'cancelOrganizationDisplay',
    value: function cancelOrganizationDisplay() {
      this.organizationPage = this.allOrganisationPage;
      this.selectedOrgID = undefined;
    }
  }, {
    key: 'saveOrganizationInfoChanges',
    value: function saveOrganizationInfoChanges() {
      var _self = this;

      var requestPayload = {
        displayName: _self.selectedOrgDisplayName,
        formalName: _self.selectedOrgFormalName,
        id: _self.selectedOrgID
      };

      _self.$http({
        url: apiBasePath + 'Organisations?mId=' + _self.selectedMembershipID,
        method: 'PUT',
        data: requestPayload,
        headers: { 'Content-Type': 'application/json' }
      }).then(function (response) {
        _self.$mdDialog.hide();
        if (response.data.type > 0) {
          _self.swalSuccess(_self, 'Organization updated', 'Your organization has been updated successfully.');
          _self.selectedOrgDisplayNameOriginal = _self.selectedOrgDisplayName;
          _self.selectedOrgFormalNameOriginal = _self.selectedOrgFormalName;
        } else {
          _self.swalError(_self, 'Failed', response.data.message);
          _self.selectedOrgDisplayName = _self.selectedOrgDisplayNameOriginal;
          _self.selectedOrgFormalName = _self.selectedOrgFormalNameOriginal;
        }
      });
    }
  }, {
    key: 'openOrgMenu',
    value: function openOrgMenu($mdMenu, ev) {
      $mdMenu.open(ev);
    }
  }, {
    key: 'openAddMemberPage',
    value: function openAddMemberPage() {
      this.organizationPage = this.addMemberPage;
      this.searchUser = {};
      this.clinividUserFound = false;
    }
  }, {
    key: 'cancelAddMemberPage',
    value: function cancelAddMemberPage() {
      this.organizationPage = this.organisationInfoPage;
    }
  }, {
    key: 'openInviteMemberPage',
    value: function openInviteMemberPage() {
      this.newInvite = {};
      this.newInvite.isPractitioner = false;
      this.organizationPage = this.inviteMemberPage;
    }
  }, {
    key: 'cancelInviteMemberPage',
    value: function cancelInviteMemberPage() {
      this.organizationPage = this.organisationInfoPage;
    }
  }, {
    key: 'openInviteStatusPage',
    value: function openInviteStatusPage() {
      var _self = this;
      _self.showModalSpinner(_self);
      _self.inviteSearchTerm = '';
      _self.inviteStatus = [];

      _self.$resource(apiBasePath + 'Organisations/GetUserInvites').get({
        mId: _self.selectedMembershipID,
        orgId: _self.selectedOrgID

      }).$promise.then(function (response) {
        _self.$mdDialog.hide();
        if (response && response.type > 0) {
          if (response['payload'] && response['payload'].length > 0) {

            for (var i = 0; i < response['payload'].length; i++) {
              var invite = {};
              invite['userName'] = _self.getDisplayName(response['payload'][i]['user']['title'], response['payload'][i]['user']['firstname'], response['payload'][i]['user']['middleNames'], response['payload'][i]['user']['lastname']);

              invite['statusCode'] = response['payload'][i]['statusCode'];

              if (response['payload'][i]['statusCode'] === 70) {
                invite['statusText'] = 'ACCEPTED';
              }

              if (response['payload'][i]['statusCode'] === 55) {
                invite['statusText'] = 'OPEN';
              }

              // var createdTime = response['payload'][i]['created']+'Z';
              var createdTime = response['payload'][i]['created'];
              invite['rawDate'] = createdTime;
              var createdTimeDisplay = moment(createdTime).format('MMM D, YYYY, h:mm A');
              invite['createdDate'] = createdTimeDisplay;

              invite['inviteId'] = response['payload'][i]['inviteId'];

              _self.inviteStatus.push(invite);
            }

            if (_self.inviteStatus && _self.inviteStatus.length > 0) {
              _self.inviteStatus.sort(function (a, b) {
                return new Date(b.rawDate) - new Date(a.rawDate);
              });
            }
            _self.organizationPage = _self.inviteStatusPage;
          }
        }
      }).catch(function () {
        _self.$mdDialog.hide();
      });
    }
  }, {
    key: 'cancelInviteSearch',
    value: function cancelInviteSearch() {
      this.inviteSearchTerm = '';
    }
  }, {
    key: 'cancelSearchCase',
    value: function cancelSearchCase() {
      this.caseSearchTerm = '';
    }
  }, {
    key: 'openManageMembersPage',
    value: function openManageMembersPage() {
      var _self = this;
      _self.orgUsers = [];
      _self.orgUserSearchTerm = '';

      _self.showModalSpinner(_self);

      this.$http({
        url: apiBasePath + 'User/GetUsersInOrg?mId=' + _self.selectedMembershipID + '&orgId=' + _self.selectedOrgID,
        method: 'GET'
      }).then(function (response) {
        if (response && response.data && response.data.type > 0) {
          if (response.data['payload']) {

            for (var i = 0; i < response.data['payload'].length; i++) {
              if (response.data['payload'][i]['user']['personId'] !== _self.context.user.personId) {
                var orgMember = {};
                orgMember.userName = _self.getDisplayName(response.data['payload'][i]['user']['title'], response.data['payload'][i]['user']['firstname'], response.data['payload'][i]['user']['middleNames'], response.data['payload'][i]['user']['lastname']);
                orgMember.id = response.data['payload'][i]['user'].id;
                orgMember.email = response.data['payload'][i]['user']['email'] ? response.data['payload'][i]['user']['email'] : 'NA';
                orgMember.mobile = response.data['payload'][i]['user']['mobile'] ? response.data['payload'][i]['user']['mobile'] : 'NA';
                orgMember.title = response.data['payload'][i]['user']['title'];
                orgMember.firstname = response.data['payload'][i]['user']['firstname'];
                orgMember.middleNames = response.data['payload'][i]['user']['middleNames'];
                orgMember.lastname = response.data['payload'][i]['user']['lastname'];

                for (var c = 0; c < response.data['payload'][i]['roles'].length; c++) {
                  if (response.data['payload'][i]['roles'][c]['orgId'] === _self.selectedOrgID) {
                    if (response.data['payload'][i]['roles'][c]['name'] === 'OrgOwner') {
                      orgMember.isOrgOwner = true;
                    }
                    if (response.data['payload'][i]['roles'][c]['name'] === 'Creator') {
                      orgMember.isClinician = true;
                    }
                    if (response.data['payload'][i]['roles'][c]['name'] === 'MDT-CoOrdinator') {
                      orgMember.isMDTCoOrdinator = true;
                    }
                    if (response.data['payload'][i]['roles'][c]['name'] === 'MDT-Conference') {
                      orgMember.isMDTConference = true;
                    }
                  }
                }
                _self.orgUsers.push(orgMember);
              }
            }

            _self.organizationPage = _self.manageMembersPage;
          }
          _self.$mdDialog.hide();
        }
      }, function (error) {
        console.log(error);
        _self.$mdDialog.hide();
        _self.swalError(_self, 'Failed', 'Failed to fetch members for this organisation.Please contact support.');
      });
      // .catch(function () {
      //   _self.$mdDialog.hide();
      // });
    }
  }, {
    key: 'cancelOrgUserSearch',
    value: function cancelOrgUserSearch() {
      this.orgUserSearchTerm = '';
    }
  }, {
    key: 'cancelContactSearch',
    value: function cancelContactSearch() {
      this.orgContactSearchTerm = '';
    }
  }, {
    key: 'editMember',
    value: function editMember(orgUser) {
      this.selectedInvitee = orgUser;
      this.editInvitee.title = orgUser.title;
      this.editInvitee.firstname = orgUser.firstname;
      this.editInvitee.middleNames = orgUser.middleNames;
      this.editInvitee.lastname = orgUser.lastname;
      this.editInvitee.email = orgUser.email;
      this.editInvitee.mobile = orgUser.mobile;
      this.editInvitee.isOrgOwner = orgUser.isOrgOwner ? orgUser.isOrgOwner : false;
      this.editInvitee.isOrgOwnerOriginal = this.editInvitee.isOrgOwner;
      this.editInvitee.isClinician = orgUser.isClinician ? orgUser.isClinician : false;
      this.editInvitee.isClinicianOriginal = this.editInvitee.isClinician;
      this.editInvitee.isMDTCoOrdinator = orgUser.isMDTCoOrdinator ? orgUser.isMDTCoOrdinator : false;
      this.editInvitee.isMDTCoOrdinatorOriginal = this.editInvitee.isMDTCoOrdinator;
      this.editInvitee.isMDTConference = orgUser.isMDTConference ? orgUser.isMDTConference : false;
      this.editInvitee.isMDTConferenceOriginal = this.editInvitee.isMDTConference;
      this.organizationPage = this.manageMembersEditPage;
    }
  }, {
    key: 'updateInvitee',
    value: function updateInvitee() {
      var _self = this;
      var roles = [];

      if (!this.editInvitee.isOrgOwner && !this.editInvitee.isClinician) {
        _self.swalError(_self, '', 'User must be either a OrgOwner or Clinician');
        return;
      }

      if (!this.editInvitee.isClinician) {
        _self.swalError(_self, '', 'User must be a Clinician');
        return;
      }

      if (this.editInvitee.isOrgOwner !== this.editInvitee.isOrgOwnerOriginal || this.editInvitee.isClinicianOriginal !== this.editInvitee.isClinician) {

        if (this.editInvitee.isOrgOwner === true) {
          roles.push('OrgOwner');
        }

        if (this.editInvitee.isClinician === true) {
          roles.push('Creator');
        }

        var requestPayloadStandardRole = {
          'member': {
            userId: _self.selectedInvitee.id,
            orgId: _self.selectedOrgID
          },
          'roles': roles
        };

        _self.showModalSpinner(_self);

        _self.$http({
          url: apiBasePath + '/Organisations/UpdateUserRoles?mId=' + _self.selectedMembershipID,
          method: 'PUT',
          data: requestPayloadStandardRole,
          headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {

          _self.$mdDialog.hide();

          if (response.data.success === false) {
            _self.swalError(_self, '', 'Failed to update roles.Please contact <a href="mailto:support@clinivid.com.au">Support</a>');
          } else {
            _self.$mdDialog.hide();
            _self.openManageMembersPage();
            _self.swalSuccess(_self, '', 'Roles updated successfully');
          }
        }, function () {
          _self.$mdDialog.hide();
          _self.swalError(_self, '', 'Failed to update roles.Please contact <a href="mailto:support@clinivid.com.au">Support</a>');
        });
      } else {
        _self.openManageMembersPage();
      }
    }
  }, {
    key: 'cancelEditMemberPage',
    value: function cancelEditMemberPage() {
      this.organizationPage = this.manageMembersPage;
    }
  }, {
    key: 'deleteMember',
    value: function deleteMember(orgUser) {
      var _self = this;
      var requestPayload = {
        'member': {
          userId: orgUser.id,
          orgId: _self.selectedOrgID
        }
      };
      _self.swangular.swal({
        title: 'Delete member',
        html: 'Do you want to delete <strong>' + orgUser.userName + '</strong> ?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        focusConfirm: false
      }).then(function (result) {
        if (result.value) {
          _self.$http({
            url: apiBasePath + '/Organisations/RemoveUser?mId=' + _self.selectedMembershipID,
            method: 'DELETE',
            data: requestPayload,
            headers: { 'Content-Type': 'application/json' }
          }).then(function (response) {
            if (response.data.type > 0) {
              _self.openManageMembersPage();
              _self.swalSuccess(_self, '', '<strong>' + orgUser.userName + '</strong> deleted successfully');
            } else {
              _self.swalError(_self, '', 'Failed to delete member.Please contact <a href="mailto:support@clinivid.com.au">Support</a>');
            }
          }).catch(function () {
            _self.swalError(_self, '', 'Failed to delete member.Please contact <a href="mailto:support@clinivid.com.au">Support</a>');
          });
        }
      });
    }
  }, {
    key: 'deleteContact',
    value: function deleteContact(contactId, displayName) {
      var _self = this;

      var contactToDelete = {
        mId: _self.selectedMembershipID,
        id: contactId
      };
      _self.swangular.swal({
        title: 'Delete Contact',
        html: 'Do you want to delete <strong>' + displayName + '</strong> from your contact list ?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        focusConfirm: false
      }).then(function (result) {
        if (result.value) {
          _self.$resource(apiBasePath + 'Contact').delete(contactToDelete).$promise.then(function (response) {
            if (response.type > 0) {
              _self.orgContactSearchTerm = '';
              var prunedContacts = [];
              if (_self.orgContacts) {
                for (var i = 0; i < _self.orgContacts.length; i++) {
                  if (_self.orgContacts[i].id !== contactId) {
                    prunedContacts.push(_self.orgContacts[i]);
                  }
                }
                _self.orgContacts = prunedContacts;
              }
              _self.swalSuccess(_self, '', 'Contact deleted successfully');
            } else {
              _self.swalError(_self, '', 'Failed to delete contact.Please contact <a href="mailto:support@clinivid.com.au">Support</a>');
            }
          }).catch(function () {
            _self.swalError(_self, '', 'Failed to delete contact.Please contact <a href="mailto:support@clinivid.com.au">Support</a>');
          });
        }
      });
    }
  }, {
    key: 'editContact',
    value: function editContact(userInfo) {
      this.rawContact = userInfo;
      this.organizationPage = this.manageContactsEditpage;
      this.contactEdited = {};
      this.contactEdited.title = this.rawContact.title;
      this.contactEdited.firstname = this.rawContact.firstname ? this.rawContact.firstname : 'NA';
      this.contactEdited.middleNames = this.rawContact.middleNames ? this.rawContact.middleNames : 'NA';
      this.contactEdited.lastname = this.rawContact.lastname ? this.rawContact.lastname : 'NA';
      this.contactEdited.profession = this.rawContact.profession ? this.rawContact.profession : 'NA';
      this.contactEdited.registrationId = this.rawContact.registrationId ? this.rawContact.registrationId : 'NA';
      this.contactEdited.mobile = this.rawContact.mobile;
      this.contactEdited.region = this.rawContact.region;
      this.contactEdited.email = this.rawContact.email ? this.rawContact.email : 'NA';
    }
  }, {
    key: 'cancelEditContact',
    value: function cancelEditContact() {
      this.organizationPage = this.manageContactsPage;
    }
  }, {
    key: 'openAddContact',
    value: function openAddContact() {
      this.addContactMode = 'phoneMode';
      this.isContactNewUser = false;
      this.isContactExistingUser = false;
      this.existingUserPayload = {};
      this.newUserPayload = {};
      this.addContact = {};
      this.organizationPage = this.manageContactsAddPage;
    }
  }, {
    key: 'cancelAddContact',
    value: function cancelAddContact() {
      this.organizationPage = this.manageContactsPage;
    }
  }, {
    key: 'addContactNext',
    value: function addContactNext() {
      var _self = this;
      _self.isContactNewUser = false;
      _self.isContactExistingUser = false;
      _self.existingUserPayload = {};
      _self.newUserPayload = {};

      if (_self.addContactMode === 'phoneMode') {
        if (!_self.addContact.region) {
          _self.swalError(_self, 'Error', 'Country code is required.');
          return;
        }
        if (!_self.addContact.phone) {
          _self.swalError(_self, 'Error', 'Mobile number is required.');
          return;
        }

        var regexPhone;

        if (_self.addContact['region'] === 'AU') {
          regexPhone = /^(04|#04|#4)[0-9]{8}$/;
        } else if (_self.addContact['region'] === 'IN') {
          regexPhone = /^(#?)[7-9][0-9]{9}$/;
        } else if (_self.addContact['region'] === 'NZ') {
          regexPhone = /^#?(02|2)[0-9]{7,8}$/;
        }
        if (regexPhone.test(_self.addContact['phone']) === false) {
          _self.swalError(_self, 'Error', 'Please enter a valid mobile number.');
          return;
        }

        for (var t = 0; t < _self.orgContacts.length; t++) {
          if (_self.orgContacts[t].mobile === _self.addContact['phone']) {
            _self.swalError(_self, 'Error', 'Contact already exists with this number.');
            return;
          }
        }

        var requestPayloadPhone = {
          'email': null,
          'mobile': _self.addContact['phone'],
          'region': _self.addContact['region']
        };
        _self.showModalSpinner(_self);
        _self.$resource(apiBasePath + 'User/Profile?mId=' + _self.selectedMembershipID).get(requestPayloadPhone).$promise.then(function (response) {
          _self.$mdDialog.hide();
          if (response.type >= 0) {
            _self.isContactExistingUser = true;
            _self.existingUserPayload = response.payload;
          } else {
            _self.isContactNewUser = true;
          }
        }, function (error) {
          console.log(error);
          _self.$mdDialog.hide();
          _self.swalError(_self, 'Failed to add contact', 'Please contact <a href="mailto:support@clinivid.com.au">Support</a>');
        });
      }

      if (_self.addContactMode === 'emailMode') {
        if (!_self.addContact.email) {
          _self.swalError(_self, 'Error', 'Email is required.');
          return;
        }

        var regexEmail = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        if (regexEmail.test(_self.addContact['email']) === false) {
          _self.swalError(_self, 'Error', 'Please enter a valid e-mail address.');
          return;
        }
        for (var t = 0; t < _self.orgContacts.length; t++) {
          if (_self.orgContacts[t].email === _self.addContact['email']) {
            _self.swalError(_self, 'Error', 'Contact already exists with this email.');
            return;
          }
        }

        var requestPayloadEmail = {
          'email': _self.addContact['email']
        };
        _self.showModalSpinner(_self);
        _self.$resource(apiBasePath + 'User/Profile?mId=' + _self.selectedMembershipID).get(requestPayloadEmail).$promise.then(function (response) {
          _self.$mdDialog.hide();
          if (response.type >= 0) {
            _self.isContactExistingUser = true;
            _self.existingUserPayload = response.payload;
          } else {
            _self.isContactNewUser = true;
          }
        }, function (error) {
          console.log(error);
          _self.$mdDialog.hide();
          _self.swalError(_self, 'Failed to add contact', 'Please contact <a href="mailto:support@clinivid.com.au">Support</a>');
        });
      }
    }
  }, {
    key: 'connectWithContact',
    value: function connectWithContact() {
      var _self = this;
      _self.showModalSpinner(_self);

      _self.$http({
        url: apiBasePath + 'Contact/Connect?mId=' + _self.selectedMembershipID,
        method: 'POST',
        data: _self.existingUserPayload,
        headers: { 'Content-Type': 'application/json' }
      }).then(function (response) {
        _self.$mdDialog.hide();
        if (response.data.type >= 1) {
          _self.openManageContactsPage();
          _self.swangular.swal('Contact Added', 'Contact has been added successfully.', 'success');
        } else {
          if (response.data.type === -23 || response.data.type === -25) {

            if (response.data.type === -23 && response.data.message.toLowerCase().includes('contact already exists')) {
              _self.swangular.swal({
                type: 'info',
                title: 'Contact already exists',
                html: 'This person already exists in your contact list.' + 'You cannot add a contact more than once'
              });
            } else {
              _self.swalError(_self, 'Failed to add contact', 'This person has not yet accepted an invitation to become part of this organisation.' + ' Please resend the invite.' + ' Please contact <a href="mailto:support@clinivid.com.au">Support</a>');
            }
          } else {
            _self.swalError(_self, 'Failed to add contact', 'Please contact <a href="mailto:support@clinivid.com.au">Support</a>');
          }
        }
      }, function (error) {
        console.log(error);
        _self.$mdDialog.hide();
        _self.swalError(_self, 'Failed to add contact.Please contact support.');
      });
    }
  }, {
    key: 'addNewUser',
    value: function addNewUser() {
      var _self = this;

      if (!_self.newUserPayload.lastname) {
        _self.swalError(_self, 'Error', 'Last name is required.');
        return;
      }

      var requestPayLoad = {};

      if (_self.addContactMode === 'phoneMode') {
        requestPayLoad = {
          title: _self.newUserPayload.title,
          firstname: _self.newUserPayload.firstname,
          lastname: _self.newUserPayload.lastname,
          profession: _self.newUserPayload.profession,
          mobile: _self.addContact['phone'],
          region: _self.addContact['region']
        };
      } else if (_self.addContactMode === 'emailMode') {
        requestPayLoad = {
          title: _self.newUserPayload.title,
          firstname: _self.newUserPayload.firstname,
          lastname: _self.newUserPayload.lastname,
          profession: _self.newUserPayload.profession,
          email: _self.addContact['email']
        };
      }
      _self.showModalSpinner(_self);
      _self.$http({
        url: apiBasePath + 'Contact?mId=' + _self.selectedMembershipID,
        data: requestPayLoad,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      }).then(function (response) {
        _self.$mdDialog.hide();
        if (response.data.type > 0) {
          _self.openManageContactsPage();
          _self.swangular.swal('New contact added', 'Contact has been successfully added to your organization', 'success');
        } else {
          _self.swalError(_self, 'Failed to add contact', 'Please contact <a href="mailto:support@clinivid.com.au">Support</a>');
        }
      }, function (error) {
        _self.$mdDialog.hide();
        _self.swalError(_self, 'Failed to add contact', 'Please contact <a href="mailto:support@clinivid.com.au">Support</a>');
      });
    }
  }, {
    key: 'updateContact',
    value: function updateContact() {
      var _self = this;
      var changeInData = false;
      if (_self.contactEdited.title && _self.rawContact.title !== _self.contactEdited.title) {
        _self.rawContact.title = _self.contactEdited.title;changeInData = true;
      }
      if (_self.rawContact.firstname !== _self.contactEdited.firstname && _self.contactEdited.firstname !== 'NA') {
        _self.rawContact.firstname = _self.contactEdited.firstname;changeInData = true;
      }
      if (_self.rawContact.middleNames !== _self.contactEdited.middleNames && _self.contactEdited.middleNames !== 'NA') {
        _self.rawContact.middleNames = _self.contactEdited.middleNames;changeInData = true;
      }
      if (_self.rawContact.lastname !== _self.contactEdited.lastname && _self.contactEdited.lastname !== 'NA') {
        _self.rawContact.lastname = _self.contactEdited.lastname;changeInData = true;
      }
      if (_self.rawContact.registrationId !== _self.contactEdited.registrationId && _self.contactEdited.registrationId !== 'NA') {
        _self.rawContact.registrationId = _self.contactEdited.registrationId;
        var regexRegistration = '';

        if (_self.contactEdited['profession'] === 'Sonographer' && _self.contactEdited['registrationId']) {
          regexRegistration = /[0-9]{4}/;
          if (regexRegistration.test(_self.contactEdited['registrationId']) === false) {
            _self.swalError(_self, 'Error', 'Registration number must be 4 digits.');
            return;
          }
        } else if (_self.contactEdited['registrationId']) {
          regexRegistration = /[A-Z]{3}[0-9]{7,10}/;
          if (regexRegistration.test(_self.contactEdited['registrationId']) === false) {
            _self.swalError(_self, 'Error', 'Registration number must be 3 Capital letters followed by 7 to 10 digits.');
            return;
          }
        }
        changeInData = true;
      }
      if (_self.rawContact.email !== _self.contactEdited.email && _self.contactEdited.email !== 'NA') {
        _self.rawContact.email = _self.contactEdited.email;
        var regexEmail = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        if (regexEmail.test(_self.contactEdited['email']) === false) {
          _self.swalError(_self, 'Error', 'Please enter a valid e-mail address.');
          return;
        }
        changeInData = true;
      }
      if (_self.rawContact.mobile !== _self.contactEdited.mobile && _self.contactEdited.mobile !== 'NA') {
        _self.rawContact.mobile = _self.contactEdited.mobile;
        var regexPhone;

        if (_self.contactEdited['region'] === 'AU') {
          regexPhone = /^(04|#04|#4)[0-9]{8}$/;
        } else if (_self.contactEdited['region'] === 'IN') {
          regexPhone = /^(#?)[7-9][0-9]{9}$/;
        }
        if (regexPhone && regexPhone.test(_self.contactEdited['mobile']) === false) {
          _self.swalError(_self, 'Error', 'Please enter a valid mobile number.');
          return;
        }
        changeInData = true;
      }
      if (_self.contactEdited.profession && _self.rawContact.profession !== _self.contactEdited.profession) {
        _self.rawContact.profession = _self.contactEdited.profession;changeInData = true;
      }
      if (_self.contactEdited.region && _self.rawContact.region !== _self.contactEdited.region) {
        _self.rawContact.region = _self.contactEdited.region;changeInData = true;
      }

      if (changeInData) {
        _self.showModalSpinner(_self);
        _self.$resource(apiBasePath + 'Contact?mId=' + _self.selectedMembershipID, null, { 'update': { method: 'PUT' } }).update(_self.rawContact).$promise.then(function (response) {
          _self.$mdDialog.hide();
          if (response.type > 0) {
            _self.openManageContactsPage();
            _self.swalSuccess(_self, '', 'Contact updated successfully');
          } else {
            _self.swalError(_self, '', 'Failed to update contact.Please contact <a href="mailto:support@clinivid.com.au">Support</a>');
          }
        }).catch(function () {
          _self.$mdDialog.hide();
          _self.swalError(_self, '', 'Failed to update contact.Please contact <a href="mailto:support@clinivid.com.au">Support</a>');
        });
      } else {
        _self.organizationPage = _self.manageContactsPage;
      }
    }
  }, {
    key: 'openCases',
    value: function openCases() {
      var _self = this;
      _self.allCases = [];
      _self.caseSearchTerm = '';
      _self.allCasesSelected = false;

      _self.showModalSpinner(_self);

      _self.$http({
        url: apiBasePath + 'Organisations/GetCasesForOrgWithRead?mid=' + _self.selectedMembershipID + '&orgId=' + _self.selectedOrgID,
        method: 'GET'
      }).then(function (response) {

        _self.$mdDialog.hide();

        _self.allCases = [];

        if (response && response.data && response.data.type > 0) {
          if (response.data['payload']) {

            _self.allCases = response.data['payload'].items ? response.data['payload'].items : [];

            _self.allCases.sort(function (a, b) {
              return new Date(b.updated) - new Date(a.updated);
            });

            for (var i = 0; i < _self.allCases.length; i++) {

              if (!_self.allCases[i].title) _self.allCases[i].title = 'Untitled Chat';

              _self.allCases[i].selected = false;

              var senderName = '';
              var senderUserId = '';
              if (_self.allCases[i].creator) {
                senderUserId = _self.allCases[i].creator.userId;
              }

              if (_self.allCases[i].creator) {
                if (_self.allCases[i].creator.title) senderName = senderName.concat(_self.allCases[i].creator.title + ' ');
                if (_self.allCases[i].creator.firstName) senderName = senderName.concat(_self.allCases[i].creator.firstName + ', ');
                if (_self.allCases[i].creator.middleNames) senderName = senderName.concat(_self.allCases[i].creator.middleNames + ' ');
                if (_self.allCases[i].creator.lastName) senderName = senderName.concat(_self.allCases[i].creator.lastName);
              }

              _self.allCases[i].senderName = senderName;

              var patientName = '';
              if (_self.allCases[i].patient) {
                if (_self.allCases[i].patient.title) {
                  patientName = patientName.concat(_self.allCases[i].patient.title + ' ');
                }
                if (_self.allCases[i].patient.firstName) {
                  patientName = patientName.concat(_self.allCases[i].patient.firstName + ' ');
                }
                if (_self.allCases[i].patient.middleNames) {
                  patientName = patientName.concat(_self.allCases[i].patient.middleNames + ' ');
                }
                if (_self.allCases[i].patient.lastName) {
                  patientName = patientName.concat(_self.allCases[i].patient.lastName);
                }
              }

              _self.allCases[i].patientName = patientName;

              var recipientsNames = [];
              if (_self.allCases[i].recipients) {
                for (var x = 0; x < _self.allCases[i].recipients.length; x++) {
                  if (senderUserId === _self.allCases[i].recipients[x].userId) {
                    continue;
                  }
                  recipientsNames.push(_self.allCases[i].recipients[x].displayName);
                }
              }

              _self.allCases[i].recipientsNames = recipientsNames.join('; ');

              _self.allCases[i].lastUpdated = moment(_self.allCases[i].updated).format('MMM D, YYYY, h:mm A');
            }

            _self.organizationPage = _self.manageCasesPage;
          }
        } else {
          if (response.data && response.data.message) {
            _self.swalError(_self, 'Failed', response.data.message);
          }
        }
      }, function () {
        _self.swalError(_self, 'Failed', 'Failed to fetch cases for this organisation. Please contact support.');
      });
    }
  }, {
    key: 'selectDeselectAllCases',
    value: function selectDeselectAllCases() {
      for (var i = 0; i < this.allCases.length; i++) {
        this.allCases[i].selected = !this.allCasesSelected;
      }
    }
  }, {
    key: 'batchDownload',
    value: function batchDownload() {
      var _self = this;

      this.swangular.swal('Downloading chat', 'Chat download has been initiated.', 'success');

      // Fetch organisation timezone once for all cases in batch
      var organisationTimezone = 'Australia/Sydney'; // Default timezone

      if (this.selectedOrgID) {
        this.$http.get(apiBasePathNoAuth + '/organisations/getstate?orgId=' + this.selectedOrgID).then(function (response) {
          if (response.data && response.data.success) {
            var organisationState = response.data.payload.state;
            organisationTimezone = _self._getTimezoneForState(organisationState);
          }
        }).catch(function (error) {
          console.error('Failed to fetch organisation state:', error);
        }).finally(function () {
          // Download all selected cases with the fetched timezone
          _self._downloadSelectedCases(organisationTimezone);
        });
      } else {
        // No selectedOrgID available - proceed with default timezone
        console.error('selectedOrgID not available for batch download, using default timezone');
        this._downloadSelectedCases(organisationTimezone);
      }
    }
  }, {
    key: '_downloadSelectedCases',
    value: function _downloadSelectedCases(organisationTimezone) {
      for (var i = 0; i < this.allCases.length; i++) {
        if (this.allCases[i].selected) {
          this.fetchCase(this.allCases[i].id, false, organisationTimezone);
        }
      }
    }
  }, {
    key: 'showDownloadAll',
    value: function showDownloadAll() {
      var visibleCases = this.$filter('filter')(this.allCases, this.caseSearchTerm);

      if (!visibleCases) return false;

      for (var x = 0; x < visibleCases.length; x++) {
        if (visibleCases[x].selected) return true;
      }

      return false;
    }
  }, {
    key: 'fetchCase',
    value: function fetchCase(caseID, showMessage, organisationTimezone) {

      var _self = this;

      if (showMessage) _self.showModalSpinner(_self);

      _self.$http({
        url: apiBasePath + 'CasesWithAvailability?mid=' + _self.selectedMembershipID + '&caseId=' + caseID + '&build=135',
        method: 'GET'
      }).then(function (response) {
        if (showMessage) _self.$mdDialog.hide();
        if (response && response.data && response.data.type > 0) {
          _self.downloadCaseInPDF(response.data.payload, showMessage, organisationTimezone);
        } else {
          if (showMessage) _self.swalError(_self, 'Failed', 'Failed to fetch cases. Please contact support.');
        }
      }, function () {
        if (showMessage) {
          _self.$mdDialog.hide();
          _self.swalError(_self, 'Failed', 'Failed to fetch cases. Please contact support.');
        }
      });
    }
  }, {
    key: 'downloadCaseInPDF',
    value: function downloadCaseInPDF(userCase, showMessage, organisationTimezone) {

      if (showMessage) this.swangular.swal('Downloading chat', 'Chat download has been initiated.This may take a while.', 'success');

      var caseTitle = userCase.title;
      if (!caseTitle) caseTitle = 'Untitled Chat';
      var patientName = this.userService.getLongName(userCase.patient);
      if (!patientName) patientName = 'Undisclosed';
      var caseMediaPrepend = patientName + '_' + caseTitle + '_';

      // Use provided timezone or default to Australia/Sydney
      if (!organisationTimezone) {
        organisationTimezone = 'Australia/Sydney';
      }

      this._generatePDFContent(userCase, caseTitle, patientName, caseMediaPrepend, organisationTimezone, showMessage);
    }
  }, {
    key: '_generatePDFContent',
    value: function _generatePDFContent(userCase, caseTitle, patientName, caseMediaPrepend, organisationTimezone, showMessage) {
      var _this3 = this;

      var _self = this;

      var doc = new jsPDF();

      var makeName = function makeName(creator) {
        if (creator.title && creator.firstname && creator.lastname) {
          return creator.title + ' ' + creator.lastname + ', ' + creator.firstname;
        } else if (!creator.title && creator.firstname && creator.lastname) {
          return creator.lastname + ', ' + creator.firstname;
        } else if (creator.title && !creator.firstname && creator.lastname) {
          return creator.title + ' ' + creator.lastname;
        } else if (creator.title && creator.firstname && !creator.lastname) {
          return creator.title + ' ' + creator.firstname;
        } else {
          return "undisclosed";
        }
      };

      var makeDOB = function makeDOB(patient) {
        if (!patient || !patient.dob) return "";

        return " - " + patient.dob;
      };

      var makeDate = function makeDate(isoString, fallbackTime) {
        // Remove 'NEW-MESSAGE' flag if present
        if (isoString && typeof isoString === 'string' && isoString.indexOf('NEW-MESSAGE') !== -1) {
          isoString = isoString.replace('NEW-MESSAGE', '');
        }

        // If timestamp is empty/undefined after stripping, use fallback time field
        if (!isoString || isoString === 'undefined') {
          isoString = fallbackTime;
        }

        if (!isoString) return '';

        var caseTime = new Date(isoString);

        return caseTime.toLocaleString('en-AU', {
          timeZone: organisationTimezone,
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          hour12: true
        });
      };

      if (!Promise.prototype.finally) {
        Promise.prototype.finally = Promise.prototype.finally || {
          finally: function _finally(fn) {
            var onFinally = function onFinally(cb) {
              return Promise.resolve(fn()).then(cb);
            };
            return this.then(function (result) {
              return onFinally(function () {
                return result;
              });
            }, function (reason) {
              return onFinally(function () {
                throw reason;
              });
            });
          }
        }.finally;
      }

      var makeBase64Thumbnail = function makeBase64Thumbnail(url) {
        // url += "&time="+(new Date()).getTime(); // this line of code made magic.

        var xhr = new XMLHttpRequest();

        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();

        return new Promise(function (resolve, reject) {
          xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
              // callback(reader.result);
              var data = {
                'url': url,
                'data': reader.result
              };
              resolve(data);
            };
            reader.readAsDataURL(xhr.response);
          };
        });
      };

      function checkFailed(then) {
        return function (responses) {
          var someFailed = responses.some(function (response) {
            return response.error;
          });

          if (someFailed) {
            throw responses;
          }

          return then(responses);
        };
      }

      function arrayBufferToBase64(buffer) {
        var binary = '';
        var bytes = [].slice.call(new Uint8Array(buffer));

        bytes.forEach(function (b) {
          return binary += String.fromCharCode(b);
        });

        return window.btoa(binary);
      };

      function senderName(name) {
        return name + " |";
      }

      var maxLeft = 15;
      var textLeft = 24;

      var maxRight = doc.internal.pageSize.getWidth() - maxLeft;

      var textCenter = doc.internal.pageSize.getWidth() / 2;

      var maxHeight = doc.internal.pageSize.getHeight() - 15;

      var startHeight = 25;
      var spaceHeight = 6;
      var spaceWidth = 3;

      var maxFontSize = 30;
      var mediumFontSize = 20;
      var normalFontSize = 16;
      var smallFontSize = 12;
      var smallestFontSize = 11;

      var discussionHeightFactor = void 0,
          discussionStartHeightFactor = void 0;

      function mediaToPDF(thumbnails, messages, recipients) {
        var discussionHeightFactor = discussionStartHeightFactor + 1.5;

        itemLoop: for (var m = 0; m < messages.length; m++) {

          var item = messages[m];

          var itemSender = void 0;

          for (var j = 0; j < recipients.length; j++) {
            var recipient = recipients[j];
            if (item.personId == recipient.id) itemSender = recipient;
          }

          doc.setFontStyle('bold');
          doc.setFontSize(smallestFontSize);

          doc.text(senderName(itemSender.displayName), textLeft, startHeight + discussionHeightFactor * spaceHeight, {
            'align': 'left'
          });

          doc.setFontStyle('normal');
          var _spaceForDetail = doc.getTextWidth(senderName(itemSender.displayName)) + spaceWidth;
          doc.text(makeDate(item.timestamp, item.time), textLeft + _spaceForDetail, startHeight + discussionHeightFactor * spaceHeight, {
            'align': 'left'
          });

          doc.setFontSize(smallFontSize);

          var deltaHeight = void 0;

          switch (item.type) {
            case 32:
              break;
            case 30:
              {
                // get promise for  base64 thumbnail
                var imageThumbnail = void 0;

                imageThumbnailLoop: for (var k = 0; k < thumbnails.length; k++) {
                  var thumbnail = thumbnails[k];

                  if (item.previewData == thumbnail.url) {
                    // if(item.data == thumbnail.url) {
                    imageThumbnail = thumbnail;
                    break imageThumbnailLoop;
                  }
                }
                // let thumbnail = await makeBase64Thumbnail(item.previewData);

                discussionHeightFactor += 1;
                doc.text('[Image]', textLeft, startHeight + discussionHeightFactor * spaceHeight, {
                  'align': 'left'
                });

                // put thumbnail
                try {
                  doc.addImage(imageThumbnail.data, 'JPEG', textLeft, startHeight + (discussionHeightFactor + 0.5) * spaceHeight, 80, 60);
                  discussionHeightFactor += 11;
                } catch (err) {

                  doc.setTextColor('#FFFFFF');

                  doc.text('Thumbnail not available', textLeft, startHeight + (discussionHeightFactor + 1) * spaceHeight, {
                    'align': 'left'
                  });

                  doc.setTextColor('#000000');

                  discussionHeightFactor += 2;
                }
                // update discussionHeightFactor

                discussionHeightFactor = (discussionHeightFactor * spaceHeight + 9) / spaceHeight + 0.4;

                // conitnue loop
                if ((discussionHeightFactor + 3) * spaceHeight + startHeight >= maxHeight && m < messages.length - 1) {
                  discussionHeightFactor = 1;
                  doc.addPage();
                }

                continue itemLoop;
              }
            case 62:
              break;
            case 12:
              break;
            case 10:
              {
                // let thumbnail = await makeBase64Thumbnail(item.previewData);

                var videoThumbnail = void 0;
                videoThumbnailLoop: for (var _k = 0; _k < thumbnails.length; _k++) {
                  var _thumbnail = thumbnails[_k];
                  if (item.previewData == _thumbnail.url) {
                    videoThumbnail = _thumbnail;
                    break videoThumbnailLoop;
                  }
                }

                discussionHeightFactor += 1;
                doc.text('[Video]', textLeft, startHeight + discussionHeightFactor * spaceHeight, {
                  'align': 'left'
                });

                // put thumbnail
                // doc.addImage(videoThumbnail.data, 'JPEG', textLeft, startHeight + ((discussionHeightFactor + 0.5 )*spaceHeight), 90, 60);
                try {
                  doc.addImage(videoThumbnail.data, 'JPEG', textLeft, startHeight + (discussionHeightFactor + 0.5) * spaceHeight, 90, 60);
                  // doc.addImage(imageThumbnail.data, 'JPEG', textLeft, startHeight + ((discussionHeightFactor + 0.5 )*spaceHeight), 80, 60);
                  discussionHeightFactor += 11;
                } catch (err) {
                  doc.setTextColor('#FFFFFF');

                  doc.text('Thumbnail not available', textLeft, startHeight + (discussionHeightFactor + 1) * spaceHeight, {
                    'align': 'left'
                  });

                  doc.setTextColor('#000000');

                  discussionHeightFactor += 1;
                }

                // discussionHeightFactor +=11
                discussionHeightFactor = (discussionHeightFactor * spaceHeight + 9) / spaceHeight + 0.4;

                if ((discussionHeightFactor + 3) * spaceHeight + startHeight >= maxHeight && m < messages.length - 1) {
                  discussionHeightFactor = 1;
                  doc.addPage();
                }

                continue itemLoop;
              }
            case 60:
              {
                // get promise for  base64 thumbnail
                // let thumbnail = await makeBase64Thumbnail(item.previewData);
                var pdfThumbnail = void 0;
                pdfThumbnailLoop: for (var _k2 = 0; _k2 < thumbnails.length; _k2++) {
                  var _thumbnail2 = thumbnails[_k2];
                  if (item.previewData == _thumbnail2.url) {
                    pdfThumbnail = _thumbnail2;
                    break pdfThumbnailLoop;
                  }
                }

                discussionHeightFactor += 1;
                doc.text('[PDF]', textLeft, startHeight + discussionHeightFactor * spaceHeight, {
                  'align': 'left'
                });

                // put thumbnail
                // doc.addImage(pdfThumbnail.data, 'JPEG', textLeft, startHeight + ((discussionHeightFactor + 0.5 )*spaceHeight), 60, 60);
                // update discussionHeightFactor
                try {
                  // doc.addImage(imageThumbnail.data, 'JPEG', textLeft, startHeight + ((discussionHeightFactor + 0.5 )*spaceHeight), 80, 60);
                  doc.addImage(pdfThumbnail.data, 'JPEG', textLeft, startHeight + (discussionHeightFactor + 0.5) * spaceHeight, 60, 60);
                  discussionHeightFactor += 11;
                } catch (err) {
                  doc.setTextColor('#FFFFFF');

                  doc.text('Thumbnail not available', textLeft, startHeight + (discussionHeightFactor + 1) * spaceHeight, {
                    'align': 'left'
                  });

                  doc.setTextColor('#000000');

                  discussionHeightFactor += 1;
                }

                // discussionHeightFactor +=11
                discussionHeightFactor = (discussionHeightFactor * spaceHeight + 9) / spaceHeight + 0.4;

                // conitnue loop
                if ((discussionHeightFactor + 3) * spaceHeight + startHeight >= maxHeight && m < messages.length - 1) {
                  discussionHeightFactor = 1;
                  doc.addPage();
                }

                continue itemLoop;
              }
            default:
              {
                if (item.data) {
                  var lineHeight = 4.33;
                  var textMessage = item.data.replace(/<br\s*\/?>/gi, '\n');
                  var allLines = doc.splitTextToSize(textMessage, maxRight - 30);
                  var totalLines = allLines.length;
                  var _deltaHeight = totalLines * lineHeight;

                  // console.log("HEIGHT FACTOR", discussionHeightFactor, deltaHeight);
                  doc.text(allLines, textLeft, startHeight + (discussionHeightFactor + 1) * spaceHeight, {
                    'align': 'left'
                  });

                  // discussionHeightFactor = (((discussionHeightFactor + 1)*spaceHeight) + deltaHeight)/spaceHeight;
                  discussionHeightFactor = ((discussionHeightFactor + 1.2) * spaceHeight + _deltaHeight + 1) / spaceHeight + 0.4;
                  if ((discussionHeightFactor + 3) * spaceHeight + startHeight >= maxHeight && m < messages.length - 1) {
                    discussionHeightFactor = 1;
                    doc.addPage();
                  }
                }

                continue itemLoop;
              }
          }
        }
      }

      // All Promise Request mediaFiles to base64
      // Download Case items
      if (userCase.items && userCase.items.length > 0) {

        var allMediaPromises = []; // promise for all s3 media items
        var allThumbnails = []; // promise for all s3 media items

        mediaLoop: for (var i = 0; i < userCase.items.length; i++) {
          // loop over case messages for all s3 media urls

          var item = userCase.items[i];
          if (!item.previewData) {
            // if only text message
            continue mediaLoop;
          } else {
            // if media message

            // console.log("THUMBNAIL", item.previewData);
            // if(item.type==30){
            //   allMediaPromises.push(makeBase64Thumbnail(item.data));
            // }
            allMediaPromises.push(makeBase64Thumbnail(item.previewData));
            allThumbnails.push(item);
          }
        }

        // Hack so on promise.all() doesn't throw error on if one of the promises fails
        var allMediaPromisesResolved = allMediaPromises.map(function (promise) {
          return promise.catch(function (error) {
            return { error: error };
          });
        });

        if (window.fetch) {
          Promise.all(allThumbnails.map(function (u) {
            return fetch(u.previewData, {

              'cache': 'reload'

            });
          })).then(function (responses) {
            return Promise.all(responses.map(function (res) {
              // response.arrayBuffer().then((buffer) => {
              return res.arrayBuffer().then(function (buffer) {
                // var base64Flag = 'data:image/jpeg;base64,';
                // var base64Flag = 'base64,';
                var imageStr = arrayBufferToBase64(buffer);
                var messageId = void 0,
                    messageType = void 0,
                    messageUrl = void 0;
                for (var _i2 = 0; _i2 < allThumbnails.length; _i2++) {
                  var message = allThumbnails[_i2];
                  if (message.previewData == res.url) {
                    messageId = message.id;
                    messageType = message.type;
                    messageUrl = message.previewData;
                  }
                }
                // document.querySelector('img').src = base64Flag + imageStr;
                // return base64Flag + imageStr;
                // return imageStr;
                return {
                  'data': imageStr,
                  'id': messageId,
                  'type': messageType,
                  'url': messageUrl
                };
              });
              // return res.blob();
            }));
          }).then(function (allMedia) {

            mediaToPDF(allMedia, userCase.items, userCase.recipients);
          }).finally(function (data) {
            var zip = new JSZip();

            var makeZipFileName = function makeZipFileName(downloadCase) {
              var patientName = makeName(downloadCase.patient);
              var caseName = downloadCase.title || "Untitled";
              if (patientName.toUpperCase() == 'UNDISCLOSED') {
                return caseName + ".zip";
              } else {
                return patientName + "-" + caseName + ".zip";
              }
            };

            var zipFileName = makeZipFileName(userCase);
            zip.file((userCase.title || "Untitled") + ".pdf", doc.output('arraybuffer'));

            var hyperMedias = [];
            var count = 0;

            for (var _i3 = 0; _i3 < userCase.items.length; _i3++) {

              var _item = userCase.items[_i3];

              if (_item.type === 10 || _item.type === 30 || _item.type === 60) {
                // hyperMedias.push(item.data);
                hyperMedias.push(_item);
                // allHyperMediaPromisesResolved.push(makeBase64MediaFiles(item.data, item.id, item.type));
              }
            }

            if (hyperMedias.length == 0) {

              var downloaderName = _this3.context.user.firstname + ' ' + _this3.context.user.lastname;

              var caseDownloadNotification = {
                caseId: userCase.id,
                userId: _this3.context.user.id,
                type: 90,
                data: 'Chat has been downloaded by - ' + downloaderName,
                timestamp: new Date()
              };

              _this3.$resource(apiBasePath + 'Cases/Creator/ItemWithNotify?mid=' + _this3.context.currentRole.membershipId).save(caseDownloadNotification).$promise.then(function (response) {

                userCase.isFileUploadInProcess = false;
                if (response.type > 0) {
                  var _item2 = response.payload;
                  _item2.timestamp = _item2.timestamp + 'NEW-MESSAGE';
                  userCase.items.push(_item2);
                  _this3.updateItems([_item2]);
                  _this3.loadPage();
                }
              }).catch();

              zip.generateAsync({ type: 'blob' }).then(function (content) {
                saveAs(content, zipFileName);
              });
            } else {

              Promise.all(hyperMedias.map(function (u) {
                return fetch(u.data, {

                  'cache': 'reload'

                });
              })).then(function (responses) {
                return Promise.all(responses.map(function (res) {
                  return res.arrayBuffer().then(function (buffer) {
                    var imageStr = arrayBufferToBase64(buffer);
                    var messageId = void 0,
                        messageType = void 0;
                    for (var _i4 = 0; _i4 < hyperMedias.length; _i4++) {
                      var message = hyperMedias[_i4];
                      if (message.data == res.url) {
                        messageId = message.id;
                        messageType = message.type;
                      }
                    }
                    return {
                      'data': imageStr,
                      'id': messageId,
                      'type': messageType
                    };
                  });
                }));
              }).then(function (allMedia) {

                allMedia.forEach(function (media) {
                  var fileName = "media/" + caseMediaPrepend + media.id;
                  if (media.type === 10) {
                    fileName += ".mp4";
                  } else if (media.type === 30) {
                    fileName += ".jpg";
                  } else if (media.type === 60) {
                    fileName += ".pdf";
                  }

                  zip.file(fileName, media.data, { base64: true });
                });
                // zip.file(fileName, texts[0]);
              }).finally(function (data) {
                var downloaderName = _this3.context.user.firstname + ' ' + _this3.context.user.lastname;

                var caseDownloadNotification = {
                  caseId: userCase.id,
                  userId: _this3.context.user.id,
                  type: 90,
                  data: 'Chat has been downloaded by - ' + downloaderName,
                  timestamp: new Date()
                };

                _this3.$resource(apiBasePath + 'Cases/Creator/ItemWithNotify?mid=' + _this3.context.currentRole.membershipId).save(caseDownloadNotification).$promise.then(function (response) {

                  userCase.isFileUploadInProcess = false;
                  if (response.type > 0) {
                    var _item3 = response.payload;
                    _item3.timestamp = _item3.timestamp + 'NEW-MESSAGE';
                    userCase.items.push(_item3);
                    _this3.updateItems([_item3]);
                    _this3.loadPage();
                  }
                }).catch();

                zip.generateAsync({ type: 'blob' }).then(function (content) {
                  saveAs(content, zipFileName);
                });
              });
            }
          });
        } else {

          Promise.all(allMediaPromisesResolved).then(checkFailed(function () {
            for (var _len = arguments.length, mediaResponses = Array(_len), _key = 0; _key < _len; _key++) {
              mediaResponses[_key] = arguments[_key];
            }

            if (userCase.items && userCase.items.length > 0) {

              var thumbnailFiles = [];
              for (var _i5 = 0; _i5 < userCase.items.length; _i5++) {

                var item = userCase.items[_i5];
                if (mediaResponses[0] && mediaResponses[0].length) {
                  mediaFilesLoop: for (var k = 0; k < mediaResponses[0].length; k++) {

                    var mediaFile = mediaResponses[0][k];
                    if (item.previewData == mediaFile.url) {
                      // if(item.data==mediaFile.url) {
                      thumbnailFiles.push(mediaFile);
                      break mediaFilesLoop;
                    }
                  }
                }
              }

              mediaToPDF(thumbnailFiles, userCase.items, userCase.recipients);
            }
          })).catch(function () {
            for (var _len2 = arguments.length, mediaResponses = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              mediaResponses[_key2] = arguments[_key2];
            }

            var thumbnailFiles = [];
            for (var _i6 = 0; _i6 < userCase.items.length; _i6++) {

              var item = userCase.items[_i6];
              if (mediaResponses[0] && mediaResponses[0].length) {
                mediaFilesLoop: for (var k = 0; k < mediaResponses[0].length; k++) {

                  var mediaFile = mediaResponses[0][k];
                  if (item.previewData == mediaFile.url) {
                    // if(item.data==mediaFile.url) {
                    thumbnailFiles.push(mediaFile);
                    break mediaFilesLoop;
                  }
                }
              }
            }

            mediaToPDF(thumbnailFiles, userCase.items, userCase.recipients);
          }).finally(function () {

            var zip = new JSZip();

            var zipFileName = "Clinivid-" + (userCase.title || "Untitled") + ".zip";
            zip.file((userCase.title || "Untitled") + ".pdf", doc.output('arraybuffer'));

            var makeBase64MediaFiles = function makeBase64MediaFiles(imgUrl, id, type) {

              var xhr = new XMLHttpRequest();

              xhr.open('GET', imgUrl);
              xhr.responseType = 'blob';
              xhr.send();

              return new Promise(function (resolve, reject) {

                xhr.onload = function () {
                  // console.log("READING");
                  var reader = new FileReader();
                  reader.onloadend = function () {

                    var mediaData = reader.result.replace(/^data:(image|video|application)\/(xml|png|jpg|jpeg|pdf|mp4);base64,/, "");
                    var data = {
                      'url': imgUrl,
                      // 'data': reader.result,
                      'data': mediaData,
                      // 'data': xhr.response,
                      'id': id,
                      'type': type
                    };
                    resolve(data);
                  };
                  reader.readAsDataURL(xhr.response);
                };
              });
            };

            var hyperMedias = [];
            var count = 0;
            var allHyperMediaPromisesResolved = [];

            for (var _i7 = 0; _i7 < userCase.items.length; _i7++) {

              var _item4 = userCase.items[_i7];

              if (_item4.type === 10 || _item4.type === 30 || _item4.type === 60) {
                // hyperMedias.push(item.data);
                hyperMedias.push(_item4);
                allHyperMediaPromisesResolved.push(makeBase64MediaFiles(_item4.data, _item4.id, _item4.type));
              }
            }

            // doc.save();

            if (hyperMedias.length == 0) {

              var downloaderName = _this3.context.user.firstname + ' ' + _this3.context.user.lastname;

              var caseDownloadNotification = {
                caseId: userCase.id,
                userId: _this3.context.user.id,
                type: 90,
                data: 'Chat has been downloaded by - ' + downloaderName,
                timestamp: new Date()
              };

              _this3.$resource(apiBasePath + 'Cases/Creator/ItemWithNotify?mid=' + _this3.context.currentRole.membershipId).save(caseDownloadNotification).$promise.then(function (response) {

                userCase.isFileUploadInProcess = false;
                if (response.type > 0) {
                  var _item5 = response.payload;
                  _item5.timestamp = _item5.timestamp + 'NEW-MESSAGE';
                  userCase.items.push(_item5);
                  _this3.updateItems([_item5]);
                  _this3.loadPage();
                }
              }).catch();

              zip.generateAsync({ type: 'blob' }).then(function (content) {
                saveAs(content, zipFileName);
              });
            } else {

              Promise.all(allHyperMediaPromisesResolved).then(checkFailed(function () {
                for (var _len3 = arguments.length, mediaResponses = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                  mediaResponses[_key3] = arguments[_key3];
                }

                // let fileName = "media/"+item.id;

                for (var _i8 = 0; _i8 < mediaResponses[0].length; _i8++) {
                  var _item6 = mediaResponses[0][_i8];

                  var fileName = "media/" + _item6.id;
                  if (_item6.type === 10) {
                    fileName += ".mp4";
                  } else if (_item6.type === 30) {
                    fileName += ".jpg";
                  } else if (_item6.type === 60) {
                    fileName += ".pdf";
                  } else {
                    continue;
                  }
                  console.log("ZIP FILE Media", _item6);
                  // zip.file(fileName, item.data);
                  zip.file(fileName, _item6.data, { 'base64': true });
                }
              })).catch(function () {
                for (var _len4 = arguments.length, mediaResponses = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                  mediaResponses[_key4] = arguments[_key4];
                }

                // let fileName = "media/"+item.id;
                for (var _i9 = 0; _i9 < mediaResponses.length; _i9++) {
                  var _item7 = mediaResponses[_i9];
                  var fileName = "media/" + _item7.id;
                  if (_item7.type === 10) {
                    fileName += ".mp4";
                  } else if (_item7.type === 30) {
                    fileName += ".jpg";
                  } else if (_item7.type === 60) {
                    fileName += ".pdf";
                  }

                  // zip.file(fileName, item.data);
                  zip.file(fileName, _item7.data, { 'base64': true });
                  // zip.file(fileName, item.data, {'binary': true});
                }
                // let fileName = "media/"+item.id;
              }).finally(function (data) {
                var downloaderName = _this3.context.user.firstname + ' ' + _this3.context.user.lastname;

                var caseDownloadNotification = {
                  caseId: userCase.id,
                  userId: _this3.context.user.id,
                  type: 90,
                  data: 'Chat has been downloaded by - ' + downloaderName,
                  timestamp: new Date()
                };

                _this3.$resource(apiBasePath + 'Cases/Creator/ItemWithNotify?mid=' + _this3.context.currentRole.membershipId).save(caseDownloadNotification).$promise.then(function (response) {

                  userCase.isFileUploadInProcess = false;
                  if (response.type > 0) {
                    var _item8 = response.payload;
                    _item8.timestamp = _item8.timestamp + 'NEW-MESSAGE';
                    userCase.items.push(_item8);
                    _this3.updateItems([_item8]);
                    _this3.loadPage();
                  }
                }).catch();

                zip.generateAsync({ type: 'blob' }).then(function (content) {
                  saveAs(content, zipFileName);
                });
              });
            }
          });
        }
      }

      doc.setFontSize(maxFontSize);
      doc.setTextColor('#b91d5c');
      doc.text(userCase.title || 'Untitled Chat', textCenter, startHeight, {
        'align': 'center'
      });
      doc.setTextColor('#000000');

      doc.line(maxLeft, startHeight + spaceHeight, maxRight, startHeight + spaceHeight);

      doc.setFontSize(smallFontSize);

      doc.text('Last updated:', textLeft, startHeight + 3 * spaceHeight, {
        'align': 'left'
      });

      doc.setTextColor('#b91d5c');
      doc.setFontStyle('bold');

      var spaceForDetail = doc.getTextWidth('Last updated:') + spaceWidth;
      doc.text(makeDate(userCase.updated, null), textLeft + spaceForDetail, startHeight + 3 * spaceHeight, {
        'align': 'left'
      });

      doc.setTextColor('#000000');
      doc.setFontStyle('normal');

      doc.text('Creator:', textLeft, startHeight + 4.5 * spaceHeight, {
        'align': 'left'
      });

      doc.setTextColor('#b91d5c');
      doc.setFontStyle('bold');

      spaceForDetail = doc.getTextWidth('Creator:') + spaceWidth;
      doc.text(makeName(userCase.creator), textLeft + spaceForDetail, startHeight + 4.5 * spaceHeight, {
        'align': 'left'
      });

      doc.setTextColor('#000000');
      doc.setFontStyle('normal');

      doc.text('Patient:', textLeft, startHeight + 6 * spaceHeight, {
        'align': 'left'
      });

      doc.setTextColor('#b91d5c');
      doc.setFontStyle('bold');

      spaceForDetail = doc.getTextWidth('Patient:') + spaceWidth;
      doc.text(makeName(userCase.patient) + makeDOB(userCase.patient), textLeft + spaceForDetail, startHeight + 6 * spaceHeight, {
        'align': 'left'
      });

      doc.setTextColor('#000000');
      doc.setFontStyle('normal');

      doc.text('Participants:', textLeft, startHeight + 8 * spaceHeight, {
        'align': 'left'
      });

      doc.setFontSize(smallestFontSize);

      var participantStartHeightFactor = 9;
      var participantHeightFactor = void 0;

      if (userCase.recipients.length >= 0) {
        for (var _i10 = 0; _i10 < userCase.recipients.length; _i10++) {

          participantHeightFactor = participantStartHeightFactor + _i10;
          var participant = userCase.recipients[_i10];
          doc.text(participant.displayName, textLeft, startHeight + participantHeightFactor * spaceHeight, {
            'align': 'left'
          });
        }
      }

      // TODO: dynamic message display
      // TODO: customise type of message text, image, pdf, vide    doc.setFontSize(normalFontSize);
      doc.setTextColor('#b91d5c');
      doc.setFontSize(smallFontSize);

      discussionStartHeightFactor = participantHeightFactor + 2;
      doc.text('Discussion items:', textLeft, startHeight + discussionStartHeightFactor * spaceHeight, {
        'align': 'left'
      });

      doc.setTextColor('#000000');
    }
  }, {
    key: 'openNotificationsPage',
    value: function openNotificationsPage() {
      var _self = this;
      _self.chipContacts = [];
      _self.newNotification = {};
      _self.$scope.quickSearchMap = {};
      _self.allExternalContacts = [];
      _self.allMembers = [];
      _self.showModalSpinner(_self);
      var page = 1;
      var pageSize = 100;

      var currentMembershipId = _self.context.currentRole.membershipId;
      var formattedOrganizationName = _self.context.currentRole.formattedOrganizationName;

      _self.api.contacts.getPaged.get({
        mId: currentMembershipId,
        page: page,
        pageSize: pageSize
      }).$promise.then(function (response) {
        if (response.type > 0) {

          var mapOfNamesToSearch = [];

          for (var i = 0; i < response.payload.items.length; i++) {

            var name = '';

            if (response.payload.items[i].firstname) name = name.concat(response.payload.items[i].firstname + ' ');
            if (response.payload.items[i].middleNames) name = name.concat(response.payload.items[i].middleNames + ' ');
            if (response.payload.items[i].lastname) name = name.concat(response.payload.items[i].lastname);

            var _searchableObjects = {
              fullName: name,
              id: response.payload.items[i].id,
              personId: response.payload.items[i].personId,
              formattedOrganizationName: formattedOrganizationName,
              profession: ''
            };

            if (response.payload.items[i].profession && response.payload.items[i].profession.length > 0) _searchableObjects.profession = response.payload.items[i].profession;

            mapOfNamesToSearch.push(_searchableObjects);
          }

          _self.$scope.quickSearchMap[currentMembershipId] = mapOfNamesToSearch;
        }
        _self.fetchOrgMembers(_self);
      }, function (error) {
        _self.$mdDialog.hide();
        _self.swalError(_self, 'Failed', 'Failed to fetch contacts for this organisation.Please contact support.');
      });
    }
  }, {
    key: 'fetchOrgMembers',
    value: function fetchOrgMembers(_self) {

      _self.$http({
        url: apiBasePath + 'User/GetUsersInOrg?mId=' + _self.context.currentRole.membershipId + '&orgId=' + _self.context.currentRole.orgId,
        method: 'GET'
      }).then(function (response) {
        if (response && response.data && response.data.type > 0) {
          if (response.data['payload']) {

            for (var i = 0; i < response.data['payload'].length; i++) {
              if (response.data['payload'][i]['user']['personId'] !== _self.context.user.personId) {
                _self.allMembers.push(response.data['payload'][i]['user']['personId']);
              }
            }

            var all = _self.$scope.quickSearchMap[_self.context.currentRole.membershipId];
            for (var x = 0; x < all.length; x++) {
              if (all[x].personId == _self.context.user.personId) continue;
              if (_self.allMembers.includes(all[x].personId)) continue;

              _self.allExternalContacts.push(all[x].personId);
            }

            if (_self.allMembers.length > 0 && _self.$scope.quickSearchMap[_self.context.currentRole.membershipId] != null) {
              var allMembersChip = {
                fullName: 'All Members',
                id: 'ALL_MEMBERS',
                personId: 'ALL_MEMBERS',
                formattedOrganizationName: _self.context.currentRole.formattedOrganizationName,
                profession: ''
              };
              _self.$scope.quickSearchMap[_self.context.currentRole.membershipId].push(allMembersChip);
            }

            if (_self.allExternalContacts.length > 0 && _self.$scope.quickSearchMap[_self.context.currentRole.membershipId] != null) {
              var allExternalContactsChip = {
                fullName: 'All Contacts',
                id: 'ALL_CONTACTS',
                personId: 'ALL_CONTACTS',
                formattedOrganizationName: _self.context.currentRole.formattedOrganizationName,
                profession: ''
              };
              _self.$scope.quickSearchMap[_self.context.currentRole.membershipId].push(allExternalContactsChip);
            }

            _self.$mdDialog.hide();
            _self.organizationPage = _self.notificationsPage;
          }
        }
      }, function (error) {
        _self.$mdDialog.hide();
        _self.swalError(_self, 'Failed', 'Failed to fetch contacts for this organisation.Please contact support.');
      });
    }
  }, {
    key: 'transformChip',
    value: function transformChip(chip) {
      // If it is an object, it's already a known chip
      if (angular.isObject(chip)) {
        return chip;
      }
    }
  }, {
    key: 'querySearchChip',
    value: function querySearchChip(query) {

      var activeMembershipId = this.context.currentRole.membershipId;
      var allEligibleContacts = this.$scope.quickSearchMap[activeMembershipId];
      var results = query ? allEligibleContacts.filter(this.createFilterForChip(query)) : allEligibleContacts;
      return results;
    }
  }, {
    key: 'createFilterForChip',
    value: function createFilterForChip(query) {
      var lowercaseQuery = query.toLowerCase();

      return function filterFn(contact) {
        return contact.fullName.toLowerCase().indexOf(lowercaseQuery) >= 0;
      };
    }
  }, {
    key: 'openManageContactsPage',
    value: function openManageContactsPage() {
      var _self = this;
      _self.orgContacts = [];
      _self.orgContactSearchTerm = '';

      _self.showModalSpinner(_self);

      _self.$http({
        url: apiBasePath + 'Contact/PageWithAvailability2?mId=' + _self.selectedMembershipID + '&page=1&pageSize=100',
        method: 'GET'
      }).then(function (response) {
        if (response && response.data && response.data.type > 0) {
          if (response.data['payload']) {
            _self.orgContacts = response.data['payload']['items'];
            for (var i = 0; i < response.data['payload']['items'].length; i++) {

              var userName = _self.getDisplayName(response.data['payload']['items'][i]['title'], response.data['payload']['items'][i]['firstname'], response.data['payload']['items'][i]['middleNames'], response.data['payload']['items'][i]['lastname']);
              response.data['payload']['items'][i]['userName'] = userName;
            }
            _self.organizationPage = _self.manageContactsPage;
          }
          _self.$mdDialog.hide();
        }
      }, function (error) {
        console.log(error);
        _self.$mdDialog.hide();
        _self.swalError(_self, 'Failed', 'Failed to fetch contacts for this organisation.Please contact support.');
      });
      // .catch(function () {
      //   _self.$mdDialog.hide();
      // });
    }
  }, {
    key: 'resendInvite',
    value: function resendInvite(inviteID) {
      var _self = this;

      _self.showModalSpinner(_self);

      _self.$http({
        url: apiBasePath + '/Organisations/ResendUserInvite?mId=' + _self.selectedMembershipID + '&inviteId=' + inviteID,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      }).then(function () {
        _self.$mdDialog.hide();
        _self.swalSuccess(_self, 'Invite sent', 'An invite has been resend.');
      }).catch(function () {
        _self.$mdDialog.hide();
        _self.swalError(_self, 'Failed', 'Failed to resend invite.Please contact support.');
      });
    }
  }, {
    key: 'sendNotification',
    value: function sendNotification() {

      var _self = this;

      var allRecipients = [];

      if (_self.chipContacts == null || _self.chipContacts != null && _self.chipContacts.length == 0) {
        _self.swalError(_self, 'No recipient', 'Please select recipients.');
        return;
      }

      _self.showModalSpinner(_self);

      for (var i = 0; i < _self.chipContacts.length; i++) {
        if (_self.chipContacts[i].personId == 'ALL_MEMBERS') {
          allRecipients.push.apply(allRecipients, _self.allMembers);
          continue;
        }
        if (_self.chipContacts[i].personId == 'ALL_CONTACTS') {
          allRecipients.push.apply(allRecipients, _self.allExternalContacts);
          continue;
        }
        allRecipients.push(_self.chipContacts[i].personId);
      }

      var uniqueRecipients = [];

      // Loop through array values
      for (i = 0; i < allRecipients.length; i++) {
        if (uniqueRecipients.indexOf(allRecipients[i]) === -1) {
          uniqueRecipients.push(allRecipients[i]);
        }
      }

      var failedMessage = 'Failed to send notification.Please contact support.';

      var req = {
        method: 'POST',
        url: mdtBaseURL + 'admin/orgs/' + _self.selectedOrgID + '/surveys',
        headers: {
          'Accept': 'application/json',
          'x-clinivid-useremail': _self.userService.authentication.userName
        },
        data: {
          "subject": _self.newNotification.subject,
          "text": _self.newNotification.content,
          "isTemplate": true,
          "recipientIds": uniqueRecipients
        }
      };

      _self.$http(req).then(function (response) {

        if (response && response.data && response.data.success) {

          _self.$mdDialog.hide();
          _self.swalSuccess(_self, 'Notification sent', 'Notification sent successfully.');
          _self.newNotification.subject = '';
          _self.newNotification.content = '';
          _self.chipContacts = [];
        } else {
          _self.$mdDialog.hide();
          _self.swalError(_self, 'Failed', failedMessage);
        }
      }, function () {
        _self.$mdDialog.hide();
        _self.swalError(_self, 'Failed', failedMessage);
      });
    }
  }, {
    key: 'searchUsers',
    value: function searchUsers() {
      var _self = this;
      _self.clinividUserFound = false;

      if (_self.searchUser) {
        if (!_self.searchUser['region']) {
          _self.swalError(_self, 'Error', 'Please choose country code.');
          return;
        }
        if (!_self.searchUser['phone']) {
          _self.swalError(_self, 'Error', 'Please enter mobile number.');
          return;
        }

        var regexPhone;

        if (_self.searchUser['region'] === 'AU') {
          regexPhone = /^(04|#04|#4)[0-9]{8}$/;
        } else if (_self.searchUser['region'] === 'IN') {
          regexPhone = /^(#?)[7-9][0-9]{9}$/;
        } else if (_self.searchUser['region'] === 'NZ') {
          regexPhone = /^#?(02|2)[0-9]{7,8}$/;
        }
        if (regexPhone.test(_self.searchUser['phone']) === false) {
          _self.swalError(_self, 'Error', 'Please enter a valid mobile number.');
          return;
        }
      } else {
        return;
      }

      _self.showModalSpinner(_self);

      _self.$resource(apiBasePath + 'User/Profile').get({
        mId: _self.selectedMembershipID,
        mobile: _self.searchUser['phone'],
        region: _self.searchUser['region']

      }).$promise.then(function (response) {
        _self.$mdDialog.hide();
        if (response && response['payload']) {
          _self.clinividUserIDFromSearch = response['payload']['id'];
          _self.clinividUserFound = true;
          _self.searchUser.title = response['payload']['title'] ? response['payload']['title'] : 'NA';
          _self.searchUser.lastName = response['payload']['lastname'] ? response['payload']['lastname'] : 'NA';
          _self.searchUser.firstName = response['payload']['firstname'] ? response['payload']['firstname'] : 'NA';
          _self.searchUser.profession = response['payload']['profession'] ? response['payload']['profession'] : 'NA';
          _self.searchUser.registrationNo = response['payload']['registrationId'] ? response['payload']['registrationId'] : 'NA';
        } else {
          _self.swalError(_self, 'Error', 'This phone number does not exist.Please fill our form to invite.');
        }
      }).catch();
    }
  }, {
    key: 'addUser',
    value: function addUser() {

      var _self = this;
      var roles = [];
      if (_self.searchUser.assignRoleOwner) {
        roles.push('OrgOwner');
      }
      if (_self.searchUser.assignRoleClinician) {
        roles.push('Creator');
      }

      if (roles.length === 0) {
        _self.swalError(_self, 'Error', 'Please choose roles for the user.');
        return;
      }

      var requestPayload = {
        'member': {
          'userId': _self.clinividUserIDFromSearch,
          'orgId': _self.selectedOrgID,
          'staffId': _self.searchUser.staffID ? _self.searchUser.staffID : ''
        },
        'roles': roles
      };

      _self.$resource(apiBasePath + 'Organisations/AddExistingUser?mId=' + _self.selectedMembershipID, null, { 'update': { method: 'PUT' } }).update(requestPayload).$promise.then(function (response) {

        if (response.type > 0) {
          _self.searchUser = {};
          _self.clinividUserFound = false;
          _self.swalSuccess(_self, 'Success', 'User added successfully.');
        } else {
          _self.swalError(_self, 'Error', response.message);
        }
      });
    }
  }, {
    key: 'sendInvite',
    value: function sendInvite() {
      var _self = this;

      if (_self.newInvite) {
        // - do validation to check if First Name , Last Name , Email , Phone and Role is there . Only these are mandatory

        if (!_self.newInvite['firstName']) {
          _self.swalError(_self, 'Error', 'First name is required.');
          return;
        }
        if (!_self.newInvite['lastName']) {
          _self.swalError(_self, 'Error', 'Last name is required.');
          return;
        }
        if (!_self.newInvite['email']) {
          _self.swalError(_self, 'Error', 'Email name is required.');
          return;
        }

        var regexEmail = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        if (regexEmail.test(_self.newInvite['email']) === false) {
          _self.swalError(_self, 'Error', 'Please enter a valid e-mail address.');
          return;
        }

        if (!_self.newInvite['region']) {
          _self.swalError(_self, 'Error', 'Please choose country code.');
          return;
        }
        if (!_self.newInvite['phone']) {
          _self.swalError(_self, 'Error', 'Please enter mobile number.');
          return;
        }

        var regexPhone;

        if (_self.newInvite['region'] === 'AU') {
          regexPhone = /^(04|#04|#4)[0-9]{8}$/;
        } else if (_self.newInvite['region'] === 'IN') {
          regexPhone = /^(#?)[7-9][0-9]{9}$/;
        } else if (_self.newInvite['region'] === 'NZ') {
          regexPhone = /^#?(02|2)[0-9]{7,8}$/;
        }
        if (regexPhone.test(_self.newInvite['phone']) === false) {
          _self.swalError(_self, 'Error', 'Please enter a valid mobile number.');
          return;
        }

        if (_self.newInvite['isPractitioner']) {
          var regexRegistration = '';

          if (_self.newInvite['profession'] === 'Sonographer' && _self.newInvite['registrationNo']) {
            regexRegistration = /[0-9]{4}/;
            if (regexRegistration.test(_self.newInvite['registrationNo']) === false) {
              _self.swalError(_self, 'Error', 'Registration number must be 4 digits.');
              return;
            }
          } else if (_self.newInvite['registrationNo']) {
            regexRegistration = /[A-Z]{3}[0-9]{7,10}/;
            if (regexRegistration.test(_self.newInvite['registrationNo']) === false) {
              _self.swalError(_self, 'Error', 'Registration number must be 3 Capital letters followed by 7 to 10 digits.');
              return;
            }
          }
        }

        if (!_self.newInvite['assignRoleOwner'] && !_self.newInvite['assignRoleClinician']) {
          _self.swalError(_self, 'Error', 'Please select a role to assign.');
          return;
        }
      }

      _self.showModalSpinner(_self);

      var roles = [];
      if (_self.newInvite['assignRoleOwner']) {
        roles.push('OrgOwner');
      }
      if (_self.newInvite['assignRoleClinician']) {
        roles.push('Creator');
      }

      var invitePayload = {
        'defaultRole': _self.newInvite['defaultRole'] && roles.length === 2 ? _self.newInvite.defaultRole : null,
        'org': {
          'id': _self.selectedOrgID
        },
        'person': {
          'middleNames': _self.newInvite['middleName'] ? _self.newInvite['middleName'] : '',
          'profession': _self.newInvite['profession'] ? _self.newInvite['profession'] : '',
          'email': _self.newInvite['email'],
          'firstName': _self.newInvite['firstName'],
          'isPractitioner': this.newInvite['isPractitioner'],
          'lastName': _self.newInvite['lastName'],
          'mobile': _self.newInvite['phone'],
          'region': _self.newInvite['region'],
          'registrationId': _self.newInvite['registrationNo'] ? _self.newInvite['registrationNo'] : '',
          'staffId': _self.newInvite['staffID'] ? _self.newInvite['staffID'] : '',
          'title': _self.newInvite['title'] ? _self.newInvite['title'] : ''
        },
        'roles': roles
      };

      _self.$http({
        url: apiBasePath + '/Organisations/Users?mId=' + _self.selectedMembershipID,
        method: 'POST',
        data: invitePayload,
        headers: { 'Content-Type': 'application/json' }
      }).then(function (response) {
        _self.$mdDialog.hide();
        if (response.data.type > 0) {
          _self.newInvite = {};
          _self.swalSuccess(_self, 'Invite sent', 'An invite has been sent successfully.');
        } else {
          _self.swalError(_self, 'Failed', response.data.message);
        }
      }).catch(function () {
        _self.$mdDialog.hide();
        _self.swalError(_self, 'Failed', 'Failed to send invite.Please contact support.');
      });
    }
  }, {
    key: 'isPractitioner',
    value: function isPractitioner() {
      if (this.newInvite && this.newInvite.isPractitioner) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'cancelInviteStatusPage',
    value: function cancelInviteStatusPage() {
      this.organizationPage = this.organisationInfoPage;
    }
  }, {
    key: 'cancelOpenCase',
    value: function cancelOpenCase() {
      this.organizationPage = this.organisationInfoPage;
    }
  }, {
    key: 'resetDefaultRole',
    value: function resetDefaultRole() {
      if (this.newInvite['assignRoleOwner'] && this.newInvite['assignRoleClinician']) {
        this.newInvite['defaultRole'] = '';
      }
    }
  }, {
    key: 'openActivityStatusPage',
    value: function openActivityStatusPage() {

      var _self = this;
      _self.allCases = [];
      _self.caseSearchTerm = '';
      _self.allCasesSelected = false;

      _self.showModalSpinner(_self);

      _self.$http({
        url: apiBasePath + 'Organisations/GetCasesForOrgWithRead?mid=' + _self.selectedMembershipID + '&orgId=' + _self.selectedOrgID,
        method: 'GET'
      }).then(function (response) {

        _self.$mdDialog.hide();

        _self.allCases = [];

        if (response && response.data && response.data.type > 0) {
          if (response.data['payload']) {

            _self.allCases = response.data['payload'].items ? response.data['payload'].items : [];

            _self.allCases.sort(function (a, b) {
              return new Date(b.updated) - new Date(a.updated);
            });

            for (var i = 0; i < _self.allCases.length; i++) {

              if (!_self.allCases[i].title) _self.allCases[i].title = 'Untitled Chat';

              _self.allCases[i].selected = false;

              var senderName = '';
              var senderUserId = _self.allCases[i].creator.userId;

              if (_self.allCases[i].creator.title) senderName = senderName.concat(_self.allCases[i].creator.title + ' ');
              if (_self.allCases[i].creator.firstName) senderName = senderName.concat(_self.allCases[i].creator.firstName + ', ');
              if (_self.allCases[i].creator.middleNames) senderName = senderName.concat(_self.allCases[i].creator.middleNames + ' ');
              if (_self.allCases[i].creator.lastName) senderName = senderName.concat(_self.allCases[i].creator.lastName);

              _self.allCases[i].senderName = senderName;

              var patientName = '';
              if (_self.allCases[i].patient) {
                if (_self.allCases[i].patient.title) patientName = patientName.concat(_self.allCases[i].patient.title + ' ');
                if (_self.allCases[i].patient.firstName) patientName = patientName.concat(_self.allCases[i].patient.firstName + ' ');
                if (_self.allCases[i].patient.middleNames) patientName = patientName.concat(_self.allCases[i].patient.middleNames + ' ');
                if (_self.allCases[i].patient.lastName) patientName = patientName.concat(_self.allCases[i].patient.lastName);

                if (_self.allCases[i].patient.dob) patientName = patientName.concat("; DOB:" + _self.allCases[i].patient.dob);
                if (_self.allCases[i].patient.ref) patientName = patientName.concat("; REF:" + _self.allCases[i].patient.ref);
              }

              _self.allCases[i].patientName = patientName;

              var casePriority = 'NORMAL';
              if (_self.allCases[i].priority === 50) casePriority = 'URGENT';
              if (_self.allCases[i].priority === 40) casePriority = 'HIGH';

              _self.allCases[i].casePriority = casePriority;

              var recipientsNames = [];
              var totalItemCountMax = 0;
              for (var x = 0; x < _self.allCases[i].recipients.length; x++) {

                if (_self.allCases[i].recipients[x] && _self.allCases[i].recipients[x].itemLog && _self.allCases[i].recipients[x].itemLog.length > totalItemCountMax) {
                  totalItemCountMax = _self.allCases[i].recipients[x].itemLog.length;
                }

                if (senderUserId === _self.allCases[i].recipients[x].userId) continue;
                recipientsNames.push(_self.allCases[i].recipients[x].displayName);
              }

              _self.allCases[i].totalItemCount = totalItemCountMax;
              _self.allCases[i].recipientsNames = recipientsNames.join("; ");

              _self.allCases[i].lastUpdated = moment(_self.allCases[i].updated).format('MMM D, YYYY, h:mm A');
            }

            _self.organizationPage = _self.activityStatusPage;
          }
        } else {
          if (response.data && response.data.message) {
            _self.swalError(_self, 'Failed', response.data.message);
          }
        }
      }, function () {
        _self.$mdDialog.hide();
        _self.swalError(_self, 'Failed', 'Failed to fetch cases for this organisation. Please contact support.');
      });
    }
  }, {
    key: 'openActivityCaseDetails',
    value: function openActivityCaseDetails(userCase) {

      if (!userCase) this.showNoItemMessage();else if (!userCase.recipients) this.showNoItemMessage();else {

        this.selectedCaseMessageDetails = {};
        var recipientsAndNames = {};

        for (var j = 0; j < userCase.recipients.length; j++) {
          recipientsAndNames[userCase.recipients[j].userId] = userCase.recipients[j].displayName;
        }

        var messages = {};

        for (var x = 0; x < userCase.recipients.length; x++) {

          if (userCase.recipients[x].itemLog) {

            for (var i = 0; i < userCase.recipients[x].itemLog.length; i++) {

              var caseItemId = userCase.recipients[x].itemLog[i].caseItemId;

              if (messages.hasOwnProperty(caseItemId)) {
                var message = messages[caseItemId];
                message['readTimes'][userCase.recipients[x].userId] = userCase.recipients[x].itemLog[i].readTime;
              } else {
                var readTimesObj = {};
                readTimesObj[userCase.recipients[x].userId] = userCase.recipients[x].itemLog[i].readTime;

                messages[caseItemId] = {
                  caseItemId: caseItemId,
                  caseItemTypeDesc: userCase.recipients[x].itemLog[i].caseItemTypeDesc,
                  creatorUserId: userCase.recipients[x].itemLog[i].creatorUserId,
                  readTimes: readTimesObj
                };
              }
            }
          }
        }

        if (Object.keys(messages).length === 0) this.showNoItemMessage();else {

          for (var k in messages) {
            messages[k].displayCaseItem = messages[k].caseItemId + " - " + messages[k].caseItemTypeDesc;
            if (recipientsAndNames[messages[k].creatorUserId]) {

              messages[k].displaySender = "SENDER: " + recipientsAndNames[messages[k].creatorUserId];
              var senderTime = messages[k].readTimes[messages[k].creatorUserId];

              if (senderTime) {
                messages[k].displaySender = messages[k].displaySender + " " + moment(senderTime).format('MMM D, YYYY, h:mm A');
              }
            }

            var recipients = [];
            for (var m in messages[k].readTimes) {
              if (m === messages[k].creatorUserId) continue;
              recipients.push(recipientsAndNames[m] + " : " + moment(messages[k].readTimes[m]).format('MMM D, YYYY, h:mm A'));
            }

            messages[k].displayRecipients = recipients.join(" ; ");
          }

          this.selectedCaseMessageDetails = Object.values(messages);
          this.organizationPage = this.activityStatusDetails;
        }
      }
    }
  }, {
    key: 'showNoItemMessage',
    value: function showNoItemMessage() {
      this.swangular.swal({
        type: 'info',
        title: '',
        html: 'There are no case items.'
      });
    }
  }, {
    key: 'cancelActivityStatusDetailsPage',
    value: function cancelActivityStatusDetailsPage() {
      this.organizationPage = this.activityStatusPage;
    }
  }, {
    key: 'cancelActivityStatusPage',
    value: function cancelActivityStatusPage() {
      this.organizationPage = this.organisationInfoPage;
    }
  }, {
    key: 'setSearchModeOff',
    value: function setSearchModeOff() {
      this.orgSearchTerm = '';
    }
  }, {
    key: 'getUserOrganization',
    value: function getUserOrganization() {
      for (var x = 0; x < this.context.roles.length; x++) {
        if (this.context.roles[x].name === 'OrgOwner') {

          var displayableOrganization = {};
          displayableOrganization['orgName'] = this.context.roles[x].formattedOrganizationName;
          displayableOrganization['membershipId'] = this.context.roles[x].membershipId;
          displayableOrganization['orgId'] = this.context.roles[x].orgId;
          this.orgInfo.push(displayableOrganization);
        }
      }

      if (this.orgInfo.length <= 0) {
        this.organizationPage = this.noOrganisationPage;
      } else if (this.orgInfo.length > 0) {
        this.organizationPage = this.allOrganisationPage;
      }
    }
  }, {
    key: 'getUserProfile',
    value: function getUserProfile() {
      var _this4 = this;

      var _self = this;

      _self.showModalSpinner(_self);

      this.$resource(apiBasePath + 'User/Profile').get({ 'mId': this.context.currentRole.membershipId, 'userId': this.context.user.id }).$promise.then(function (response) {
        _self.$mdDialog.hide();
        if (response.type >= 0) {

          _this4.form = { person: response.payload };

          _self.originalProfileData = JSON.parse(JSON.stringify(_this4.form.person));

          _this4.days = [];
          for (var i = 1; i <= 31; i++) {
            _this4.days.push(i);
          }
          _this4.hours = [];
          for (var i = 1; i <= 24; i++) {
            _this4.hours.push(i);
          }
          _this4.minutes = [];
          for (var i = 1; i <= 60; i++) {
            _this4.minutes.push(i);
          }

          _this4.availabilityMode = 'available';

          // this.showAllProfiles = false;
          _this4.profilePageMode = 1;

          _this4.filterProfiles = function (role) {
            return role.name !== 'Viewer' && role.title && role.title.toUpperCase() !== 'ENTERPRISE' && role.name !== 'HCI-Admin' && role.name.toLowerCase() !== 'officeadmin';
          };

          _this4.selectedRole = _this4.context.currentRole;

          // }, 1000)
        } else {
          _this4.app.popup("Error", "Sorry, an error has occurred and we cannot continue. Please try again later.", 'Close');
        }
      });
    }
  }, {
    key: 'hasProfileDataChanged',
    value: function hasProfileDataChanged() {
      if (this.form && this.form.person) {
        if (this.originalProfileData.title != this.form.person.title) {
          return true;
        }
        if (this.originalProfileData.firstname != this.form.person.firstname) {
          return true;
        }
        if (this.originalProfileData.middleNames != this.form.person.middleNames) {
          return true;
        }
        if (this.originalProfileData.registrationId != this.form.person.registrationId && this.form.person.registrationId.match(/[A-Z]{3}[0-9]{7,10}/)) {
          return true;
        }
        if (this.originalProfileData.profession != this.form.person.profession) {
          return true;
        }
        return false;
      } else {
        return false;
      }
    }
  }, {
    key: 'getOrgDisplayName',
    value: function getOrgDisplayName(role) {
      // var isPersonalProfile = role && role.orgDisplayName.toUpperCase().includes('PRACTICE OF');
      var isPersonalProfile = role && role.orgDisplayName.toUpperCase().indexOf('PRACTICE OF') >= 0;
      if (isPersonalProfile) {
        return 'Personal Account';
      } else {
        return role.orgDisplayName;
      }
    }
  }, {
    key: 'save',
    value: function save() {
      var _this5 = this;

      if (!this.hasProfileDataChanged()) {
        return;
      }
      var _self = this;

      _self.$scope.saveProfileInProcess = true;

      this.$resource(apiBasePath + 'User/Profile?mId=' + this.context.currentRole.membershipId, null, { 'update': { method: 'PUT' } }).update(this.form.person).$promise.then(function (response) {
        _self.$scope.saveProfileInProcess = false;
        if (response.type > 0) {

          _this5.profileEditable = true;
          // TBC - invalidate context to ensure the updates propagate across client
          _this5.$analytics.eventTrack('Click', { category: 'Button', label: 'profile-edited-successfully' });

          var userContext = _self.localStorageService.get('userContext');
          if (userContext && userContext.user) {
            userContext.user.firstname = _this5.form.person.firstname;
          };

          _self.localStorageService.set('userContext', userContext);

          _self.swangular.swal('Updated Profile', 'Your profile has been updated successfully.', 'success');

          if (_self.$stateParams.fromContactsPage) {
            //Redirect back to Contacts Page as you have come from there
            _self.$state.go('app.clinician.people');
          }
        } else {
          _this5.$analytics.eventTrack('Click', { category: 'Button', label: 'profile-edited-failure' });
          _this5.swangular.swal({
            type: 'error',
            title: '',
            html: 'Sorry, an error has occurred and we cannot continue. You can request changes by contacting <a href="mailto:support@clinivid.com.au">Support</a>'
          });
        }
      });
    }
  }, {
    key: 'showModalSpinner',
    value: function showModalSpinner(_self) {
      _self.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(document.body)
      });
    }
  }, {
    key: 'saveAvailabilityChanges',
    value: function saveAvailabilityChanges() {
      var _self = this;

      if (_self.availabilityMode === 'available') {
        _self.showModalSpinner(_self);

        var userAvailable = {
          'availability': 1
        };

        _self.$http({
          url: apiBasePath + 'User/SetDefaultAvailableSetting?mId=' + _self.context.currentRole.membershipId,
          method: 'POST',
          data: userAvailable,
          headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {

          if (response.data.type > 0) {
            var requestPayload = [{
              'label': 'Monday',
              'startInMinutes': 480,
              'endInMinutes': 1020
            }, {
              'label': 'Tuesday',
              'startInMinutes': 480,
              'endInMinutes': 1020
            }, {
              'label': 'Wednesday',
              'startInMinutes': 480,
              'endInMinutes': 1020
            }, {
              'label': 'Thursday',
              'startInMinutes': 480,
              'endInMinutes': 1020
            }, {
              'label': 'Friday',
              'startInMinutes': 480,
              'endInMinutes': 1020
            }, {
              'label': 'Saturday',
              'startInMinutes': 480,
              'endInMinutes': 1020
            }, {
              'label': 'Sunday',
              'startInMinutes': 480,
              'endInMinutes': 1020
            }];

            _self.$http({
              url: apiBasePath + 'User/SetAvailabilityTimeTable?mId=' + _self.context.currentRole.membershipId + '&userId=' + _self.context.user.id,
              method: 'PUT',
              data: requestPayload,
              headers: { 'Content-Type': 'application/json' }
            }).then(function (response) {
              _self.$mdDialog.hide();
              if (response.data.type > 0) {
                _self.swalSuccess(_self, 'Availability updated', 'Your availability has been updated successfully.');
              } else {
                _self.swalError(_self, 'Failed', 'Failed to updated availability.Please contact support.');
              }
            });
          } else {
            _self.$mdDialog.hide();
            _self.swalError(_self, 'Failed', 'Failed to updated availability.Please contact support.');
          }
        });
      } else if (this.availabilityMode === 'unavailableUntil') {

        if (!_self.unavailableTime) {
          _self.swalError(_self, 'Error', 'Please pick a time.');
          return;
        }
        if (!_self.unavailableDate) {
          _self.swalError(_self, 'Error', 'Please pick a date.');
          return;
        }

        var userUnavailableTime = _self.unavailableTime;
        var userUnavailableDate = _self.unavailableDate;
        var browserUnavailableTime = new Date(userUnavailableDate.getFullYear(), userUnavailableDate.getMonth(), userUnavailableDate.getDate(), userUnavailableTime.getHours(), userUnavailableTime.getMinutes());

        if (browserUnavailableTime.getTime() < new Date().getTime()) {
          _self.swalError(_self, 'Error', 'Availability time must be beyond current date.');
          return;
        }

        var availability = {
          'availability': 2,
          'endDate': browserUnavailableTime.toISOString()
        };

        _self.showModalSpinner(_self);
        this.$http({
          url: apiBasePath + '/User/SetAvailability?mId=' + _self.context.currentRole.membershipId,
          method: 'POST',
          data: availability,
          headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
          _self.$mdDialog.hide();
          if (response.data.type > 0) {
            _self.unavailableTime = undefined;
            _self.unavailableDate = undefined;
            _self.swalSuccess(_self, 'Availability updated', 'Your availability has been updated successfully.');
          } else {
            _self.swalError(_self, 'Failed', 'Failed to updated availability.Please contact support.');
          }
        });
      } else if (this.availabilityMode === 'unavailableDuration') {

        if (!_self.day && !_self.hour && !_self.minute) {
          _self.swalError(_self, 'Error', 'Please choose days , hours or minutes');
          return;
        }

        var currentDate = new Date();
        var unavilableTimeSinceEpoch = void 0;

        if (_self.day) {
          unavilableTimeSinceEpoch = currentDate.getTime() + _self.day * 24 * 60 * 60 * 1000;
        }

        if (_self.hour) {
          unavilableTimeSinceEpoch = currentDate.getTime() + _self.hour * 60 * 60 * 1000;
        }

        if (_self.minute) {
          unavilableTimeSinceEpoch = currentDate.getTime() + _self.minute * 60 * 60 * 60 * 1000;
        }

        var unavilableTimeRequest = new Date(unavilableTimeSinceEpoch).toISOString();

        var _availability = {
          'availability': 2,
          'endDate': unavilableTimeRequest
        };

        _self.showModalSpinner(_self);
        this.$http({
          url: apiBasePath + '/User/SetAvailability?mId=' + _self.context.currentRole.membershipId,
          method: 'POST',
          data: _availability,
          headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
          _self.$mdDialog.hide();
          if (response.data.type > 0) {
            _self.day = undefined;
            _self.hour = undefined;
            _self.minute = undefined;
            _self.swalSuccess(_self, 'Availability updated', 'Your availability has been updated successfully.');
          } else {
            _self.swalError(_self, 'Failed', 'Failed to updated availability.Please contact support.');
          }
        });
      }
    }
  }, {
    key: 'clearAvailability',
    value: function clearAvailability() {
      this.day = undefined;
      this.hour = undefined;
      this.minute = undefined;
      this.unavailableDate = undefined;
      this.unavailableTime = undefined;
      //this.showAllProfiles = false;
      this.profilePageMode = 1;
      this.availabilityMode = 'available';
    }
  }, {
    key: 'editProfile',
    value: function editProfile() {
      this.profileEditable = !this.profileEditable;
    }
  }, {
    key: 'showProfilePage',
    value: function showProfilePage() {
      this.showModalSpinner(this);
      this.loadAvailability();
      //this.showAllProfiles = true;
      this.profilePageMode = 2;
    }
  }, {
    key: 'closeProfilePage',
    value: function closeProfilePage() {
      //this.showAllProfiles = false;
      this.profilePageMode = 1;
    }
  }, {
    key: 'changeProfile',
    value: function changeProfile(role, $index) {
      // this.selectedRoleIndex = $index;
      this.selectedRole = role;
    }
  }, {
    key: 'hideUserNotificationForLockedFields',
    value: function hideUserNotificationForLockedFields() {
      this.showLockedFields = false;
    }
  }, {
    key: 'getUserDisplayName',
    value: function getUserDisplayName() {
      var result = '';

      var user = this.context.user;

      if (user.title) result += user.title + ' ';
      if (user.firstname) result += user.firstname + ' ';
      if (user.middleNames) result += user.middleNames + ' ';
      if (user.lastname) result += user.lastname + ' ';

      return result;
    }
  }, {
    key: 'getDisplayName',
    value: function getDisplayName(title, firstname, middleNames, lastname) {
      var result = '';
      if (title) result += title + ' ';
      if (firstname) result += firstname + ' ';
      if (middleNames) result += middleNames + ' ';
      if (lastname) result += lastname + ' ';
      return result;
    }
  }, {
    key: 'showUserNotificationForLockedFieldsLastName',
    value: function showUserNotificationForLockedFieldsLastName() {
      this.swangular.swal({
        type: 'info',
        title: '',
        html: 'Last name is view only. You can request changes by contacting <a href="mailto:support@clinivid.com.au">Support</a>'
      });
    }
  }, {
    key: 'showUserNotificationForLockedFieldsEmail',
    value: function showUserNotificationForLockedFieldsEmail() {
      this.swangular.swal({
        type: 'info',
        title: '',
        html: 'Email is view only. You can request changes by contacting <a href="mailto:support@clinivid.com.au">Support</a>'
      });
    }
  }, {
    key: 'showUserNotificationForLockedFieldsMobile',
    value: function showUserNotificationForLockedFieldsMobile() {
      this.swangular.swal({
        type: 'info',
        title: '',
        html: 'Mobile number is view only. You can request changes by contacting <a href="mailto:support@clinivid.com.au">Support</a>'
      });
    }
  }, {
    key: 'swalError',
    value: function swalError(_self, titleText, textContent) {
      _self.swangular.swal({
        type: 'error',
        title: titleText,
        html: textContent
      });
    }
  }, {
    key: 'swalSuccess',
    value: function swalSuccess(_self, title, text) {
      _self.swangular.swal(title, text, 'success');
    }
  }, {
    key: 'deleteAccountDisclaimer',
    value: function deleteAccountDisclaimer() {

      var _self = this;

      this.swangular.swal({
        title: 'Delete your Clinivid Account',
        html: 'You\'re requesting to delete ' + this.userService.getUserDisplayName() + '. Once the request is received the account will be deleted permanently and you will no longer be able to access your MDT meetings and chats',
        type: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        focusConfirm: false
      }).then(function (result) {
        if (result.value) {
          _self.showDeletePage = 2;
        }
      });
    }
  }, {
    key: 'deleteAccount',
    value: function deleteAccount() {
      var _this6 = this;

      if (this.reason2Delete === null || this.reason2Delete.trim() === "") {
        this.swangular.swal({
          type: 'error',
          title: 'Error deleting account',
          html: 'Please enter reason.'
        });
        return;
      }

      if (this.password2Delete === null || this.password2Delete.trim() === "") {
        this.swangular.swal({
          type: 'error',
          title: 'Error deleting account',
          html: 'Please enter password.'
        });
        return;
      }

      if (this.localStorageService.get('password') !== this.password2Delete) {
        this.swangular.swal({
          type: 'error',
          title: 'Error deleting account',
          html: 'Please enter correct password.'
        });
        return;
      }

      var req = {
        method: 'POST',
        url: mdtBaseURL + '/extras/accountdel',
        headers: {
          'Accept': 'application/json',
          'x-clinivid-useremail': this.userService.authentication.userName
        },
        data: {
          'status': 'deletion',
          'reason': this.reason2Delete
        }
      };

      var userService = this.userService;

      this.$http(req).then(function (resp) {
        if (resp && resp.data && resp.data.success) {
          userService.logOut();
        }
      }).catch(function (error) {
        _this6.swangular.swal({
          type: 'error',
          title: 'Error deleting account',
          html: 'Please contact support.'
        });
      });
    }
  }, {
    key: 'deactivateAccount',
    value: function deactivateAccount() {
      var _this7 = this;

      if (this.reason2Deactivate === null || this.reason2Deactivate.trim() === "") {
        this.swangular.swal({
          type: 'error',
          title: 'Error deactivating account',
          html: 'Please enter reason.'
        });
        return;
      }

      if (this.password2Deactivate === null || this.password2Deactivate.trim() === "") {
        this.swangular.swal({
          type: 'error',
          title: 'Error deactivating account',
          html: 'Please enter password.'
        });
        return;
      }

      if (this.localStorageService.get('password') !== this.password2Deactivate) {
        this.swangular.swal({
          type: 'error',
          title: 'Error deactivating account',
          html: 'Please enter correct password.'
        });
        return;
      }

      var req = {
        method: 'POST',
        url: mdtBaseURL + '/extras/accountdel',
        headers: {
          'Accept': 'application/json',
          'x-clinivid-useremail': this.userService.authentication.userName
        },
        data: {
          'status': 'deactivation',
          'reason': this.reason2Deactivate
        }
      };

      var userService = this.userService;

      this.$http(req).then(function (resp) {
        if (resp && resp.data && resp.data.success) {
          userService.logOut();
        }
      }).catch(function (error) {
        _this7.swangular.swal({
          type: 'error',
          title: 'Error deactivating account',
          html: 'Please contact support.'
        });
      });
    }
  }, {
    key: 'go2DeletePage',
    value: function go2DeletePage() {
      this.showDeletePage = 1;
      this.reason2Delete = '';
      this.reason2Deactivate = '';
      this.password2Deactivate = '';
      this.password2Delete = '';
    }
  }, {
    key: 'openDeleteAccountPage',
    value: function openDeleteAccountPage() {
      this.showDeletePage = 3;
    }
  }, {
    key: 'openDeletePage',
    value: function openDeletePage() {
      this.profilePageMode = 3;
    }
  }, {
    key: 'openProfilePage',
    value: function openProfilePage() {
      this.profilePageMode = 1;
    }
  }, {
    key: 'saveProfileChange',
    value: function saveProfileChange(role) {
      var _this8 = this;

      if (this.selectedRole.statusCode < 50) return;
      //this.context.currentRole = this.selectedRole; //- This will change things only on UI
      // this.showAllProfiles = false;
      this.profilePageMode = 1;

      //-Make Rest call here to make this Persistent across Device
      var nextRole = {
        Username: this.userName,
        Mid: this.selectedRole.membershipId
      };

      this.$resource(apiBasePath + 'User/SetDefaultRole', null, { 'update': { method: 'PUT' }
      }).update(nextRole).$promise.then(function (response) {

        if (response.type > 0) {
          _this8.context.currentRole = _this8.selectedRole;
          _this8.userService.setContextInSession(_this8.context);

          var notificationText = 'You have changed your profile to ' + _this8.context.currentRole.formattedOrganizationName;
          _this8.swangular.swal('Profile changed', notificationText, 'success');
        } else {
          _this8.swangular.swal({
            type: 'error',
            title: 'Error changing Profile',
            html: 'Unable to change your profile now. Please try again later.'
          });
        }
      }).catch(function (response) {
        _this8.swangular.swal({
          type: 'error',
          title: 'Error Changing Profile',
          html: 'Unable to change your profile now. Please try again later.'
        });
      });
    }

    /**
     * Get timezone for Australian state
     * @param {string} state - Australian state code (e.g., 'NSW', 'VIC')
     * @returns {string} IANA timezone string, defaults to 'Australia/Sydney'
     */

  }, {
    key: '_getTimezoneForState',
    value: function _getTimezoneForState(state) {
      var STATE_TIMEZONE_MAP = {
        'NSW': 'Australia/Sydney',
        'VIC': 'Australia/Melbourne',
        'QLD': 'Australia/Brisbane',
        'SA': 'Australia/Adelaide',
        'WA': 'Australia/Perth',
        'TAS': 'Australia/Hobart',
        'NT': 'Australia/Darwin',
        'ACT': 'Australia/Sydney'
      };
      return STATE_TIMEZONE_MAP[state] || 'Australia/Sydney';
    }
  }]);

  return ProfileController;
}();

angular.module('app.user').component('profile', {
  controller: ProfileController,
  templateUrl: 'app/user/profile.html'
});


'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Created by arolave on 21/05/2016.
 */

var UserFactory = function () {
  function UserFactory($http, $location, $q, localStorageService, msApi, $rootScope, $state, $resource) {
    'inject';

    var _this2 = this;

    _classCallCheck(this, UserFactory);

    this.$http = $http;
    this.$location = $location;
    this.localStorageService = localStorageService;
    this.msApi = msApi;
    this.$rootScope = $rootScope;
    this.$state = $state;
    this.$resource = $resource;
    this.$q = $q;
    this.CLIENT_ID = 'clinivid.com.au';

    this.context = {};
    this.authentication = {
      isAuth: false,
      userName: "",
      userId: "",
      superUser: false
    };
    this.useRefreshTokens = true;

    $rootScope.$on('loggedIn', function () {
      _this2.getUserContext();
    });

    this.context.titles = ["Dr", "Mr", "Mrs", "Ms", "Miss", "Master", "Mx"];

    this.loginError;
  }

  _createClass(UserFactory, [{
    key: 'register',
    value: function register(email, password, sessionId, code) {
      var _this3 = this;

      this.logOut(false);

      var registration = {
        Email: email,
        Password: password,
        sessionId: sessionId,
        code: code
      };

      // Couldn't get msApi service to construct the required request format so reverting to basic approach
      return this.$http.post(apiBasePathNoAuth + '/User/Register', registration).then(function (response) {
        _this3.authentication.userId = response.data.payload;
        return response.data;
      });
    }
  }, {
    key: 'saveNewUserDetails',
    value: function saveNewUserDetails(id, title, firstname, middlenames, lastname, email, mobile, regId, profession, inviteKey) {

      var mob = null;
      var region = $("#mobile_number_registration").intlTelInput("getSelectedCountryData").iso2;
      region = region.toUpperCase();

      if (mobile) mob = mobile.replace(/[^#0-9]/g, '');

      var rawPhoneNumber = $("#mobile_number_registration").val();

      if (rawPhoneNumber.startsWith("#")) mob = rawPhoneNumber;

      var details = {
        Id: id,
        Title: title,
        Firstname: firstname,
        MiddleNames: middlenames,
        Lastname: lastname,
        Email: email,
        Mobile: mob,
        RegistrationId: regId,
        Profession: profession,
        Region: region
      };

      var query = apiBasePath + 'User/RegisterNewUserDetails';

      if (inviteKey) query += '?inviteKey=' + inviteKey;

      return this.$http.post(query, details).then(function (response) {

        return response.data;
      });
    }
  }, {
    key: 'saveNewUserDetails2',
    value: function saveNewUserDetails2(id, title, firstname, middlenames, lastname, email, mobile, regId, profession, inviteKey, regionCode) {

      if (mobile.indexOf('#04') === 0 && regionCode === 'AU') {
        // Need To Do this for Test Numbers in Australia
        mobile = '#' + mobile.substring(2);
      }

      if (!title) {
        title = '';
      }

      var details = {
        Id: id,
        Title: title,
        Firstname: firstname,
        MiddleNames: middlenames,
        Lastname: lastname,
        Email: email,
        Mobile: mobile,
        RegistrationId: regId,
        Profession: profession,
        Region: regionCode
      };

      var query = apiBasePath + 'User/RegisterNewUserDetails';

      if (inviteKey) query += '?inviteKey=' + inviteKey;

      return this.$http.post(query, details).then(function (response) {

        return response.data;
      });
    }
  }, {
    key: 'setSecurityQuestions',
    value: function setSecurityQuestions(id, q1, a1, q2, a2) {

      var data = {
        Id: id,
        Q1: q1,
        A1: a1,
        Q2: q2,
        A2: a2
      };

      return this.$http.post(apiBasePath + 'User/setSecurityQuestions', data).then(function (response) {

        return response.data;
      });
    }
  }, {
    key: 'login',
    value: function login(userName, password, analytics, _self) {
      var _this4 = this;

      var data = { username: userName, password: password };

      if (_self) _self.$scope.isLoginInProcess = true;
      return this.$http.post(apiBasePathNoAuth + '/user/login', data).then(function (response) {

        if (!response.data.success) {
          var message = "Please check your username and password.";
          if (response.data.error_description) {
            message = response.data.error_description;
          }
          _this4.postLoginFailure(new Error('fail'), _self, analytics, 'user-login-failure', message, _this4, 'error', 'Login failed');
        } else if (response.data.mfaRequired) {
          // MFA required — hand off to the login controller to show the MFA screen
          if (_self) {
            _self.$scope.isLoginInProcess = false;
            _self.showMFAScreen(response.data);
          }
        } else {
          var authData = {
            token: response.data.access_token,
            userName: response.data.userName,
            userId: response.data.userId,
            refreshToken: response.data.refresh_token,
            useRefreshTokens: true
          };

          _this4.localStorageService.set('authorizationData', authData);
          _this4.localStorageService.set('password', password);

          _this4.checkAccountStatus(response, analytics, userName, _this4, _self, authData);
        }
      }).catch(function (err) {

        var message = "Please check your username and password.";
        if (err.data && err.data.error_description) {
          message = err.data.error_description;
        }
        _this4.postLoginFailure(err, _self, analytics, 'user-login-failure', message, _this4, 'error', 'Login failed');
      });
    }

    /**
     * Authenticates a user during registration workflow using /noauth/user/login-mobile.
     * This endpoint is separate from the standard /user/login to avoid the MFA flow.
     *
     * @param {string} data - URL-encoded form data (grant_type, username, password)
     * @returns {Promise} Resolves with the HTTP response containing auth token
     */

  }, {
    key: 'loginMobile',
    value: function loginMobile(data) {
      return this.$http.post(apiBasePathNoAuth + '/user/login-mobile', data, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      });
    }

    /**
     * Verifies the MFA code for login and returns the auth token response.
     *
     * @param {string} sessionId - The MFA session ID from login response
     * @param {string} code - The 6-digit code entered by the user
     * @returns {Promise} Resolves with the HTTP response containing auth token
     */

  }, {
    key: 'loginVerify',
    value: function loginVerify(sessionId, code) {
      return this.$http.post(apiBasePathNoAuth + '/user/login-verify', {
        sessionId: sessionId,
        code: code
      });
    }

    /**
     * Completes login after MFA code verification.
     * Expects the loginVerify response to contain a standard auth token.
     */

  }, {
    key: 'completeLoginWithToken',
    value: function completeLoginWithToken(responseData, analytics, userName, _self) {
      var authData = {
        token: responseData.access_token,
        userName: responseData.userName,
        userId: responseData.userId,
        refreshToken: responseData.refresh_token,
        useRefreshTokens: true
      };

      this.localStorageService.set('authorizationData', authData);

      // Wrap response in the shape checkAccountStatus expects
      var prepareResponse = { data: responseData };
      this.checkAccountStatus(prepareResponse, analytics, userName, this, _self, authData);
    }
  }, {
    key: 'postLoginFailure',
    value: function postLoginFailure(err, _self, analytics, analyticsMessage, popUpMessage, _this, icon, popupTitle) {
      if (_self) {
        _self.$scope.isLoginInProcess = false;
        if (!icon) {
          _self.swangular.swal({
            imageUrl: 'assets/images/no-ahpra.png',
            imageWidth: 50,
            imageHeight: 50,
            type: '',
            title: popupTitle,
            html: popUpMessage
          });
        } else {
          _self.swangular.swal({
            type: icon,
            title: popupTitle,
            html: popUpMessage
          });
        }
      }
      analytics.eventTrack('Click', { category: 'Button', label: analyticsMessage });
      _this.loginError = popUpMessage;
      _this.logOut(true, 'app.user.login');
      _this.$q.reject(err);
    }
  }, {
    key: 'checkAccountStatus',
    value: function checkAccountStatus(response, analytics, userName, _this, _self, authData) {

      var req = {
        method: 'GET',
        url: mdtBaseURL + '/extras/accountstatus',
        headers: {
          'Accept': 'application/json',
          'x-clinivid-useremail': userName
        }
      };

      var reqAccountDelete = {
        method: 'POST',
        url: mdtBaseURL + '/extras/accountdel',
        headers: {
          'Accept': 'application/json',
          'x-clinivid-useremail': userName
        },
        data: {
          'status': 'active',
          'reason': ''
        }
      };

      _this.$http(req).then(function (resp) {
        if (resp && resp.data && resp.data.success) {

          if ('ACTIVE' === resp.data.payload.status.toUpperCase()) {
            _this.redirectSuccessfulLogin(resp, analytics, userName, _self, authData, _this);
          } else if ('DELETION' === resp.data.payload.status.toUpperCase()) {
            _this.postLoginFailure(new Error(), _self, analytics, 'user-login-failure', 'Your account has been deleted.<br><a href=\"mailto:support@clinivid.com.au\">Contact support.</a>', _this, null, 'Account deleted');
          } else if ('DEACTIVATION' === resp.data.payload.status.toUpperCase()) {
            _this.$http(reqAccountDelete).then(function (respAccountDelete) {
              if (respAccountDelete && respAccountDelete.data && respAccountDelete.data.success) {
                _this.redirectSuccessfulLogin(resp, analytics, userName, _self, authData, _this);
              } else {
                _this.postLoginFailure(new Error(), _self, analytics, 'user-login-failure', 'Failed to check account status.\nPlease contact support.', _this, 'error', 'Login failed');
              }
            }).catch(function (err) {
              _this.postLoginFailure(new Error(), _self, analytics, 'user-login-failure', 'Failed to check account status.\nPlease contact support.', _this, 'error', 'Login failed');
            });
          }
        }
      }).catch(function (error) {
        _this.postLoginFailure(new Error(), _self, analytics, 'user-login-failure', 'Failed to check account status.\nPlease contact support.', _this, 'error', 'Login failed');
      });
    }
  }, {
    key: 'redirectSuccessfulLogin',
    value: function redirectSuccessfulLogin(response, analytics, userName, _self, authData, _this) {

      _this.authentication.isAuth = true;
      _this.authentication.userName = userName;
      _this.authentication.userId = authData.userId;
      _this.$rootScope.$broadcast('loggedIn');

      analytics.eventTrack('Click', { category: 'Button', label: 'user-login-success' });
    }
  }, {
    key: 'isDevelopmentMode',
    value: function isDevelopmentMode() {
      if (environment === "dev") return true;else return false;
    }

    /*
     Logs out.
     Param 1 [isRedirecting]: bool - indicating if any redirect should happen at all. default is true
     Param 2 [redirect]: string - name of target state for redirect after logout is complete
     */

  }, {
    key: 'logOut',
    value: function logOut() {
      var _this5 = this;

      var isRedirecting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var redirect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'app.welcome';


      this.localStorageService.remove('authorizationData');
      this.localStorageService.remove('userContext');
      this.localStorageService.clearAll();

      this.authentication.isAuth = false;
      this.authentication.userName = "";
      this.authentication.userId = "";
      _.forEach(['user', 'roles', 'defaultRole', 'currentOrg', 'currentRole'], function (k) {
        return delete _this5.context[k];
      });

      this.$rootScope.$broadcast('loggedOut');

      if (isRedirecting) this.$state.go(redirect);
    }
  }, {
    key: 'refreshToken',
    value: function refreshToken() {
      var _this6 = this;

      var authData = this.localStorageService.get('authorizationData');

      if (_.get(authData, 'useRefreshTokens')) {
        var queryParams = 'grant_type=refresh_token&refresh_token=' + authData.refreshToken + '&client_id=' + this.CLIENT_ID;

        this.localStorageService.remove('authorizationData');

        return this.$http.post(apiBasePathNoAuth + '/user/login', queryParams, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
          var responseData = response.data;
          _this6.localStorageService.set('authorizationData', {
            token: responseData.access_token,
            userName: responseData.userName,
            userId: responseData.userId,
            refreshToken: responseData.refresh_token,
            useRefreshTokens: true
          });

          return responseData;
        }).catch(function (response) {
          _this6.logOut();
          return response;
        });
      }
    }
  }, {
    key: 'forgotPassword',
    value: function forgotPassword(email) {
      return this.$http.get(apiBasePathNoAuth + 'User/ForgotPassword?email=' + email).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'resetPwd',
    value: function resetPwd(password, key) {
      var data = {
        Key: key,
        Value: password
      };
      return this.$http.post(apiBasePathNoAuth + 'User/ResetPassword', data).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'fillAuthData',
    value: function fillAuthData() {

      var authData = this.localStorageService.get('authorizationData');
      if (authData) {
        this.authentication.isAuth = true;
        this.authentication.userName = authData.userName;
        this.authentication.userId = authData.userId;
      }
    }
  }, {
    key: 'setContextInSession',
    value: function setContextInSession(context) {
      this.localStorageService.set('userContext', context);
    }
  }, {
    key: 'getContext',
    value: function getContext() {
      var cachedContext = this.localStorageService.get('userContext');
      return cachedContext;
    }
  }, {
    key: 'getAppropriateMembershipId',
    value: function getAppropriateMembershipId(membershipIdOfActiveTab) {
      /** This  is a hack as we CAN-ONLY add contact by membership of  org-owner or admin ,else it must be a personal account **/
      var appropriateMembershipId = void 0;
      var isMembershipIdSet = false;
      var activeTabRole = void 0;
      for (var i = 0; i < this.context.roles.length; i++) {
        // Logic to determine if its a personal Account
        var role = this.context.roles[i];
        if (role.membershipId === membershipIdOfActiveTab) {
          //-Assuming  Add Contact button is showed for  genuine Personal Accounts- i am not putting extra checks
          activeTabRole = role; // Active Tab Role is set here
          if (role.orgDisplayName.toUpperCase().indexOf('PRACTICE OF') >= 0) {
            appropriateMembershipId = membershipIdOfActiveTab;
            isMembershipIdSet = true;
            break;
          }
        }
      }

      //-lets determine the membershipId of the Admin or Org-owner and add by that as backend will error out else
      if (!isMembershipIdSet) {
        for (var _i = 0; _i < this.context.roles.length; _i++) {
          // Logic to determine user has Admin or OrgRole
          var tempRole = this.context.roles[_i];
          if (activeTabRole && activeTabRole.orgId === tempRole.orgId) {
            if (tempRole.name === 'OrgOwner' || tempRole.name === 'OfficeAdmin') {
              appropriateMembershipId = tempRole.membershipId;
              break;
            }
          }
        }
      }

      return appropriateMembershipId;
    }
  }, {
    key: 'getUserName',
    value: function getUserName() {
      return this.getContext().user.firstname + " " + this.getContext().user.lastname;
    }
  }, {
    key: 'getUserDisplayName',
    value: function getUserDisplayName() {
      var result = '';

      var user = this.getContext().user;

      if (user.title) result += user.title + ' ';
      if (user.lastname) result += user.lastname + ' ';
      // if(user.middleNames) result += user.middleNames+' ';
      if (user.firstname) result += user.firstname + ' ';

      return result;
    }
  }, {
    key: 'checkSuperAdmin',
    value: function checkSuperAdmin() {
      var userContext = this.localStorageService.get('userContext');

      if (userContext.hasOwnProperty('currentRole') && userContext.currentRole.hasOwnProperty('name') && userContext.currentRole.name.toUpperCase() === 'HCI-ADMIN') {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'getUserProfile',
    value: function getUserProfile() {
      return this.getContext().currentRole.customOrganizationName;
    }
  }, {
    key: 'getUserContext',
    value: function getUserContext() {
      var _this7 = this;

      return this.$resource(apiBasePath + 'User/Context').get({ username: this.authentication.userName },
      //return this.msApi.request('app.userContext@get', { username: this.authentication.userName },
      // SUCCESS
      function (response) {

        if (response.type > 0) {

          if (response.payload && response.payload.statusCode === 30) {
            _this7.authentication.isAuth = false;
            _this7.$state.go('app.user.suspendedUser');
            return;
          }

          _.assign(_this7.context, _.pick(response.payload, ['roles', 'defaultRole', 'user']));

          if (response.code === 25) {
            _this7.authentication.isAuth = false;
            _this7.$state.go('app.user.completeUserProfile', { contextPayload: _this7.context });
            return;
          }

          _this7.initializeApp();
        } else {
          return _this7.logOut();
        }
      },
      // ERROR
      function (response) {

        return _this7.logOut();
      });
    }
  }, {
    key: 'initializeApp',
    value: function initializeApp() {
      var filterViewer = [];

      for (var i = 0; i < this.context.roles.length; i++) {
        if (this.context.roles[i].domain && this.context.roles[i].name !== 'Viewer') {
          filterViewer.push(this.context.roles[i]);
        }
      }

      if (this.context.defaultRole.name === 'Viewer') {
        this.context.defaultRole = filterViewer[0];
      }

      this.context.roles = filterViewer;

      this.$rootScope.$broadcast('userContextChanged');

      var defaultRole = {
        name: this.context.defaultRole.name,
        domain: this.context.defaultRole.domain
      };

      this.setActiveRole(defaultRole.name, defaultRole.domain);

      for (var _i2 = 0; _i2 < this.context.roles.length; _i2++) {
        // - This block of code formats organisation name. It's a IE-11 fix.
        var _r = this.context.roles[_i2];

        if (!_r) {
          continue;
        }

        // var isPersonalProfile = r.orgDisplayName.toUpperCase().includes('PRACTICE OF');
        var isPersonalProfile = _r.orgDisplayName.toUpperCase().indexOf('PRACTICE OF') >= 0;

        if (isPersonalProfile) {
          _r.formattedOrganizationName = 'Personal Account';
          _r.customOrganizationName = _r.formattedOrganizationName;
        } else {
          _r.formattedOrganizationName = _r.orgDisplayName;
          if (_r.formattedOrganizationName.length > 18) _r.customOrganizationName = _r.formattedOrganizationName.slice(0, 18).concat('...');else _r.customOrganizationName = _r.formattedOrganizationName;
        }
      }

      if (this.context && this.context.currentRole && (this.context.currentRole.name.toLowerCase() === 'officeadmin' || this.context.currentRole.name.toLowerCase() === 'orgowner' || this.context.currentRole.name.toLowerCase() === 'orgadmin' || this.context.currentRole.name.toLowerCase() === 'mdt-coordinator')) {
        var domain = this.context.currentRole.domain;
        for (var _i3 = 0; _i3 < this.context.roles.length; _i3++) {
          var r = this.context.roles[_i3];
          if (r && r.domain === domain && r.name.toLowerCase() !== 'orgowner' && r.name.toLowerCase() !== 'orgadmin' && r.name.toLowerCase() !== 'mdt-coordinator' && r.name.toLowerCase() !== 'officeadmin') {
            //switch currentRole to something which is not owner , admin or mdt-coOrdinator
            this.context.currentRole = r;
          }
        }
      }

      this.setContextInSession(this.context);
    }
  }, {
    key: 'setCurrentOrg',
    value: function setCurrentOrg(organisation) {
      this.context.currentOrg = organisation;
    }

    // Get Instance ID token. Initially this makes a network call, once retrieved
    // subsequent calls to getToken will return from cache.

  }, {
    key: 'generateRegisterToken',
    value: function generateRegisterToken(_self) {

      messaging.getToken().then(function (currentToken) {
        if (currentToken) {
          _self.sendTokenToServer(currentToken, _self);
        } else {
          // Show permission request.
          _self.setTokenSentToServer(false);
        }
      }).catch(function (err) {});
    }
  }, {
    key: 'sendTokenToServer',
    value: function sendTokenToServer(currentToken, _self) {
      if (!_self.isTokenSentToServer()) {

        var userId = _self.context.user.id;

        var payLoad = {};
        payLoad["identifier"] = userId;
        payLoad["userId"] = userId;
        payLoad["os"] = 7;
        payLoad["model"] = "BROWSER";
        payLoad["pushToken"] = currentToken;

        _self.$resource(apiBasePath + 'Device/Register?mId=' + _self.context.currentRole.membershipId, null, { 'update': { method: 'PUT' } }).update(payLoad).$promise.then(function (response) {
          if (response.type > 0) {

            _self.setTokenSentToServer(true);
          }
        });
      }
    }
  }, {
    key: 'isTokenSentToServer',
    value: function isTokenSentToServer() {
      return window.localStorage.getItem('sentToServer') === '1';
    }
  }, {
    key: 'setTokenSentToServer',
    value: function setTokenSentToServer(sent) {
      window.localStorage.setItem('sentToServer', sent ? '1' : '0');
    }
  }, {
    key: 'setActiveRole',
    value: function setActiveRole(roleName, domain) {
      for (var i = 0; i < this.context.roles.length; i++) {
        var role = this.context.roles[i];
        if (role.name == roleName && role.domain == domain) {
          this.localStorageService.set('defaultRoles.' + this.context.user.id, { name: roleName, domain: domain });
          this.context.currentRole = role;

          if (role.domain !== this.authentication.userName) {
            this.setCurrentOrg({
              id: role.orgId,
              displayName: role.domain
            });
          }

          if (this.$state.includes('app.user.login')) {
            this.$state.go('app.clinician.cases');
          }
          if (this.$state.includes('app.user.register')) {
            this.$state.go('app.clinician.cases');
          }

          this.$rootScope.$broadcast('activeRoleChanged');
          break;
        }
      }
    }
  }, {
    key: 'getLongNamePatient',
    value: function getLongNamePatient(person) {
      var name = '';
      if (!person) {
        return name;
      }

      if (person.lastName) {
        if (person.title) {
          name += person.title + ' ';
        }
        name += person.lastName;
      } else if (person.lastname) {
        if (person.title) {
          name += person.title + ' ';
        }
        name += person.lastname;
      }

      if (person.firstName) {
        if (name !== '') {
          name += ', ';
        }

        name += person.firstName;
      } else if (person.firstname) {
        if (name !== '') {
          name += ', ';
        }

        name += person.firstname;
      }

      if (person.middleNames) {
        name += ' ' + person.middleNames;
      } else if (person.middlenames) {
        name += ' ' + person.middlenames;
      }

      return name;
    }
  }, {
    key: 'getLongName',
    value: function getLongName(person) {
      var name = "";
      if (!person) return name;

      if (person.lastname) {
        if (person.title) {
          name += person.title + " ";
        }
        name += person.lastname;
      }

      if (person.firstname) {
        if (name != "") name += ", ";

        name += person.firstname;
      }

      if (person.middlenames) name += " " + person.middlenames;

      return name;
    }
  }, {
    key: 'getAbbrevName',
    value: function getAbbrevName(person) {
      var name = "";
      if (person) {
        if (person.title && person.LastName) name = person.title + " " + person.lastName;

        if (name && person.firstName) name += ", ";

        if (person.firstName) name += person.firstName.charAt(0) + ".";
      }
      return name;
    }
  }, {
    key: 'getShortName',
    value: function getShortName(person) {
      if (person.firstname) return person.firstname;

      var name = "";
      if (person.title && person.lastname) name = person.title + " " + person.lastname;

      return name;
    }
  }]);

  return UserFactory;
}();

angular.module('app.user').factory('userService', ['$http', '$location', '$q', 'localStorageService', 'msApi', '$rootScope', '$state', '$resource', function ($http, $location, $q, localStorageService, msApi, $rootScope, $state, $resource) {
  return new UserFactory($http, $location, $q, localStorageService, msApi, $rootScope, $state, $resource);
}]);


/**
 * Created by Apurba-D
 */
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CreateOrganizationController = function () {
  function CreateOrganizationController($resource, $http, appContext, userService, api, $analytics, $state, $mdDialog, $scope, $stateParams, $q, $document, $mdSidenav, swangular) {
    'inject';

    _classCallCheck(this, CreateOrganizationController);

    this.swangular = swangular;
    this.$mdSidenav = $mdSidenav;
    this.$document = $document;
    this.api = api;
    this.$http = $http;
    this.$scope = $scope;
    this.$mdDialog = $mdDialog;
    this.app = appContext;
    this.userService = userService;
    this.context = userService.getContext();
    this.$analytics = $analytics;
    this.$resource = $resource;
    this.$state = $state;
    this.currentRole = this.context.currentRole;
    this.stateParams = $stateParams;

    this.displayName = '';
    this.formalName = '';
    this.description = '';
    this.abn = '';

    this.title = '';
    this.firstName = '';
    this.middleName = '';
    this.lastName = '';

    this.isOfficeAdmin = false;
    this.isClinician = false;
    this.email = '';
    this.countryCode = '';
    this.phone = '';
    this.state = '';

    this.staffID = '';
    this.isPractitioner = false;
    this.profession = '';
    this.registrationNo = '';

    this.displayNameRequired = 'Display name is required';
    this.formalNameRequired = 'Formal name is required';
    this.firstNameRequired = 'First name is required';
    this.lastNameRequired = 'Last name is required';
    this.emailRequired = 'Email is required';
    this.countryCodeRequired = 'Country code required';
    this.phoneRequired = 'Mobile number required';

    this.regexPhoneAU = /^(04|#04|#4)[0-9]{8}$/;
    this.regexPhoneIN = /^(#?)[7-9][0-9]{9}$/;

    this.regexPhone = '';
    this.regexEmail = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
  }

  _createClass(CreateOrganizationController, [{
    key: 'createOrganization',
    value: function createOrganization() {

      if (!this.displayName) {
        this.showError(this.displayNameRequired);
        return;
      } else if (!this.formalName) {
        this.showError(this.formalNameRequired);
        return;
      } else if (!this.firstName) {
        this.showError(this.firstNameRequired);
        return;
      } else if (!this.lastName) {
        this.showError(this.lastNameRequired);
        return;
      } else if (!this.email) {
        this.showError(this.emailRequired);
        return;
      } else if (!this.countryCode) {
        this.showError(this.countryCodeRequired);
        return;
      } else if (!this.phone) {
        this.showError(this.phoneRequired);
        return;
      }

      //var regexPhone ;
      if (this.countryCode === 'AU') {
        this.regexPhone = this.regexPhoneAU;
      } else if (this.countryCode === 'IN') {
        this.regexPhone = this.regexPhoneIN;
      }
      if (this.regexPhone.test(this.phone) === false) {
        this.showError('Please enter a valid mobile number.');
        return;
      }

      if (this.regexEmail.test(this.email) === false) {
        this.showError('Please enter a valid e-mail address.');
        return;
      }

      var _self = this;

      var payload = this.createPayload();

      this.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(this.$document.body)
      });

      this.$http({
        url: apiBasePath + '/Organisations?mId=' + this.context.currentRole.membershipId,
        method: 'POST',
        data: payload,
        headers: { 'Content-Type': 'application/json' }
      }).then(function (response) {

        _self.$mdDialog.hide();

        if (response.data.type > 0) {
          _self.resetForm();
          _self.swangular.swal('', 'Organization created', 'success');
        } else {
          _self.swangular.swal({
            type: 'error',
            title: '',
            html: response.data.message
          });
        }
      }).error(function () {
        _self.$mdDialog.hide();
        _self.swangular.swal({
          type: 'error',
          title: '',
          html: 'Failed to create organisation.Please contact support.'
        });
      });
    }
  }, {
    key: 'createPayload',
    value: function createPayload() {
      var payload = {};

      var org = {};
      org.description = this.description;
      org.displayName = this.displayName;
      org.formalName = this.formalName;
      org.registeredId = this.abn;
      org.state = this.state;

      var supportedRegions = [];
      supportedRegions.push('AU');

      org.supportedRegions = supportedRegions;

      payload.org = org;

      var person = {};

      person.middleNames = this.middleName;
      person.email = this.email;
      person.firstName = this.firstName;
      person.isPractitioner = this.isPractitioner;
      person.lastName = this.lastName;
      person.mobile = this.phone;
      person.region = this.countryCode;
      person.staffId = this.staffID;
      person.title = this.title;

      if (this.isPractitioner) {
        person.registrationId = this.registrationNo;
        person.profession = this.profession;
      } else {
        person.registrationId = '';
        person.profession = '';
      }

      payload.person = person;

      var roles = [];

      roles.push('OrgOwner');

      if (this.isOfficeAdmin) {
        roles.push('OfficeAdmin');
      }

      if (this.isClinician) {
        roles.push('Creator');
      }

      payload.roles = roles;

      return payload;
    }
  }, {
    key: 'resetForm',
    value: function resetForm() {
      this.displayName = '';
      this.formalName = '';
      this.description = '';
      this.abn = '';

      this.title = '';
      this.firstName = '';
      this.middleName = '';
      this.lastName = '';

      this.isOfficeAdmin = false;
      this.isClinician = false;
      this.email = '';
      this.countryCode = '';
      this.phone = '';
      this.state = '';

      this.staffID = '';
      this.isPractitioner = false;
      this.profession = '';
      this.registrationNo = '';
    }
  }, {
    key: 'showError',
    value: function showError(errorText) {
      this.swangular.swal({
        type: 'error',
        title: '',
        html: errorText
      });
    }
  }, {
    key: 'checkPractitioner',
    value: function checkPractitioner() {
      if (this.isPractitioner) {
        return true;
      } else {
        return false;
      }
    }
  }]);

  return CreateOrganizationController;
}();

angular.module('app.user').component('createorganisation', {
  controller: CreateOrganizationController,
  templateUrl: 'app/user/createorganisation.html'
});


'use strict';

(function () {
    'use strict';

    angular.module('app.user').controller('UserController', UserController);

    /** @ngInject */
    function UserController() {}
})();


/**
 * Created by Apurba-D
 */
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CaseCreationController = function () {
  function CaseCreationController($resource, $http, appContext, userService, api, $analytics, $state, $mdDialog, $scope, $stateParams, $q, $document, $mdSidenav, swangular, moment) {
    'inject';

    var _this = this;

    _classCallCheck(this, CaseCreationController);

    this.swangular = swangular;
    this.$mdSidenav = $mdSidenav;
    this.$document = $document;
    this.api = api;
    this.$http = $http;
    this.$scope = $scope;
    this.$mdDialog = $mdDialog;
    this.app = appContext;
    this.userService = userService;
    this.context = userService.getContext();
    this.sendersDisplayName = this.context.user.title + ' ' + this.context.user.firstname + ' ' + this.context.user.lastname;
    this.$analytics = $analytics;
    this.$resource = $resource;
    this.currentPage = 'CASE_CREATE';
    this.$state = $state;
    this.profile = {};
    this.currentRole = this.context.currentRole;
    this.stateParams = $stateParams;

    this.roleObj = null;

    if (this.stateParams.membershipIdFromContactsPage) {
      for (var i = 0; i < this.context.roles.length; i++) {
        if (this.context.roles[i].membershipId === this.stateParams.membershipIdFromContactsPage) {
          this.roleObj = this.context.roles[i];
          break;
        }
      }
    }

    if (!this.roleObj) {
      this.roleObj = this.context.currentRole;
    }

    this.allRoles = this.context.roles;
    this.defaultRole = this.context.defaultRole;
    this.$q = $q;
    this.userName = userService.authentication.userName;

    this.searchIcon = '/assets/icons/search-icon.svg';
    this.closeIcon = '/assets/icons/if_icon-close-circled_211650.svg';
    this.patientSearchIcon = this.searchIcon;

    $scope.isLoadContactsAndGroupsComplete = false; //- Will become true only after all contacts are loaded for the active profile

    /** Load All Contacts First **/

    this.loadAllContacts();

    this.filterProfile = function (role) {
      return role.name !== 'Viewer' && role.title && role.title.toUpperCase() !== 'ENTERPRISE' && role.name !== 'HCI-Admin' && role.name.toLowerCase() !== 'officeadmin';
    };

    this.profileSpecificContacts = [];
    //if (this.currentRole) this.getContacts($scope);
    $scope.userProfileContacts = this.profileSpecificContacts;

    $scope.getOrganization = function (contact) {
      return _this.getOrganization(contact);
    };

    this.searchRecipient;

    this.profileSwapInitiatedFromRecipientsPage = false;

    this.patients = [];

    this.$scope.searchPatientKeyWord = "";
    this.patientDOBsearch;

    this.profileSwapInitiatedFromPatientSearch = false;

    this.isPatientSelected = false;
    this.moment = moment;

    // this.maxPatientDOB = new Date();
    // this.minPatientDOB = new Date(new Date().setFullYear(new Date().getFullYear() - 119));
    this.currentDate = new Date();
    var d = this.currentDate.getDate();
    var m = this.currentDate.getMonth() + 1; //Month from 0 to 11
    var y = this.currentDate.getFullYear();

    this.maxPatientDOB = '' + (d <= 9 ? '0' + d : d) + '-' + (m <= 9 ? '0' + m : m) + '-' + y;

    this.futureDate = new Date(new Date().setFullYear(new Date().getFullYear() - 119));
    d = this.futureDate.getDate();
    m = this.futureDate.getMonth() + 1; //Month from 0 to 11
    y = this.futureDate.getFullYear();

    this.minPatientDOB = '' + (d <= 9 ? '0' + d : d) + '-' + (m <= 9 ? '0' + m : m) + '-' + y;

    this.patient = {};
    this.isPatientProfileNew = false;

    this.messageRecipients = [];

    this.$scope.userFileUploads = [];

    this.totalFileUploaded = 0;

    this.newCase = {};

    this.caseTextMessage;

    this.isThereOldTextMessage = false;
    this.oldDraftPayload = undefined;

    this.casePriority = 20; //DefaultValue

    this.caseTitle;

    this.draftCase;

    this.isDraft = false;

    if (this.stateParams.draftCase) {

      this.$resource(apiBasePath + 'Cases/NewItems').get({
        mId: this.context.currentRole.membershipId,
        caseId: this.stateParams.draftCase.id,
        latestItemId: 0

      }).$promise.then(function (response) {
        if (response && response.type > 0) {
          _this.previousDraftData = response.payload;
          _this.draftDownloadableItems = _this.filterDownloadableItems(_this.previousDraftData);
          var draftPayload = response.payload[0];

          if (draftPayload && draftPayload.type === 40) {
            _this.caseTextMessage = draftPayload.data;
            _this.isThereOldTextMessage = true;
            _this.oldDraftPayload = draftPayload;
          }
        }
      }).catch(function (response) {
        console.error('An error Occurred while Fetching Text Items from Draft');
      });

      this.caseTitle = this.stateParams.draftCase.title;
      this.casePriority = this.stateParams.draftCase.priority;
      if (this.stateParams.draftCase.patient) {
        this.patient = this.stateParams.draftCase.patient;
        this.isPatientSelected = true;
        var previousPatientName = this.getPatientFullName();
        if (previousPatientName && previousPatientName.length > 0) {
          this.$scope.searchPatientKeyWord = previousPatientName;
          this.patientSearchIcon = this.closeIcon;
        }
      }
      if (this.stateParams.draftCase.items) {
        for (var i = 0; i < this.stateParams.draftCase.items.length; i++) {
          if (this.stateParams.draftCase.items[i].type === 40) {
            // removing this condition && this.stateParams.draftCase.items[i].data
            this.caseTextMessage = this.stateParams.draftCase.items[i].data;
          }
        }
      }

      this.draftCase = this.stateParams.draftCase;
      this.isDraft = true;

      if (this.stateParams.casePage) {
        this.draftCasePage = this.stateParams.casePage;
      }
      // this.draftCasePage = this.stateParams.draftCase.casePage;
    }

    this.patientSearchOn = false;
    this.showNoPatienFoundText = false;

    this.selectedRole = this.context.currentRole;

    $scope.goToAddContact = function () {

      _this.messageRecipients = _this.makeRecipients();
      // console.log("add case new recipient", this.messageRecipients);
      _this.currentPage = 'CONTACT_ADD';
      $scope.$broadcast('start.add.new.people', 'CONTEXT_CASE', _this.messageRecipients);
    };

    /** Chip variables Recipient START **/

    this.selectedItemChip = null;
    this.searchTextChip = null;
    this.chipContacts = [];

    /** Chip variables Recipient END **/

    /** File type constants start **/

    this.fileTypes = {
      VIDEO: "Video",
      IMAGE: "Image",
      PDF: "PDF",
      TEXT: "Text"
    };

    this.fileTypeMap = {
      10: this.fileTypes.VIDEO,
      12: this.fileTypes.VIDEO,
      50: this.fileTypes.VIDEO,
      30: this.fileTypes.IMAGE,
      32: this.fileTypes.IMAGE,
      60: this.fileTypes.PDF,
      62: this.fileTypes.PDF,
      40: this.fileTypes.TEXT,
      42: this.fileTypes.TEXT
    };

    this.getItemType = function (type) {
      return this.fileTypeMap[type] || null;
    };

    this.isVideoType = function (itemType) {
      return this.getItemType(itemType) === this.fileTypes.VIDEO;
    };

    this.isImageType = function (itemType) {
      return this.getItemType(itemType) === this.fileTypes.IMAGE;
    };

    this.isPdfType = function (itemType) {
      return this.getItemType(itemType) === this.fileTypes.PDF;
    };
    /** File type constants end **/

    this.patientSugestionClicked = function (patientIndex) {
      var dropdowns = this.$document[0].getElementsByClassName("autocomplete-items");
      var i;
      for (i = 0; i < dropdowns.length; i++) {
        var openDropdown = dropdowns[i];
        openDropdown.remove();
      }

      if (patientIndex >= 0) {
        //patientIndex is negative when user clicks to view all.
        var patientFullName = this.patients[patientIndex].title + " " + this.patients[patientIndex].firstname + " " + this.patients[patientIndex].lastname;
        this.$document[0].getElementById('patientSearchBox').value = patientFullName;

        //-set patient to be picked up while case creation
        this.patient.title = this.patients[patientIndex].title;
        this.patient.firstname = this.patients[patientIndex].firstname;
        this.patient.lastname = this.patients[patientIndex].lastname;
        this.patient.dob = this.patients[patientIndex].dob;
        this.patient.ref = this.patients[patientIndex].ref;
      }
      if (patientIndex === -1) {
        this.openAllSearchedPatientsSideNav();
      }
    };

    this.filterPatient;

    this.availabilityMap = {};

    this.patientDOBFormat = 'D-M-YYYY';
  }

  _createClass(CaseCreationController, [{
    key: 'setPatient',
    value: function setPatient(selectedPatient) {

      this.patient.title = selectedPatient.title;
      this.patient.firstname = selectedPatient.firstname;
      this.patient.lastname = selectedPatient.lastname;
      this.patient.dob = selectedPatient.dob;
      this.patient.ref = selectedPatient.ref;

      var patientFullName = this.patient.title + " " + this.patient.firstname + " " + this.patient.lastname;

      this.$document[0].getElementById('patientSearchBox').value = patientFullName;
      this.patientSearchIcon = this.closeIcon;

      this.closeAllSearchedPatientsSideNav();
    }
  }, {
    key: 'openAllSearchedPatientsSideNav',
    value: function openAllSearchedPatientsSideNav() {
      this.filterPatient = '';

      this.$mdSidenav('showAllSearchedPatients').toggle();
    }
  }, {
    key: 'closeAllSearchedPatientsSideNav',
    value: function closeAllSearchedPatientsSideNav() {
      this.$mdSidenav('showAllSearchedPatients').close();
    }
  }, {
    key: 'validatePatientDOB',
    value: function validatePatientDOB(patientForm) {

      var startDate = this.moment(this.minPatientDOB, this.patientDOBFormat);
      var endDate = this.moment(this.maxPatientDOB, this.patientDOBFormat);
      if (this.patient.dob) {
        if (!this.moment(this.patient.dob, this.patientDOBFormat, true).isValid()) {
          patientForm.patientDOB.$setValidity('errorPatientDOBInvalidFormat', false);
          patientForm.patientDOB.$setValidity('invalidDateRange', true);
          return;
        } else if (!this.moment(this.patient.dob, this.patientDOBFormat).isBetween(startDate, endDate)) {
          patientForm.patientDOB.$setValidity('invalidDateRange', false);
          patientForm.patientDOB.$setValidity('errorPatientDOBInvalidFormat', true);
          return;
        }
        // else {
        //   patientForm.patientDOB.$setValidity('invalidDateRange', true);
        //   patientForm.patientDOB.$setValidity('errorPatientDOBInvalidFormat', true);
        // }
      }
      patientForm.patientDOB.$setValidity('invalidDateRange', true);
      patientForm.patientDOB.$setValidity('errorPatientDOBInvalidFormat', true);
    }

    /** Button Click on Create Patient **/

  }, {
    key: 'createPatient',
    value: function createPatient() {

      if (this.patient.dob) {
        this.patient.dob = this.moment(this.patient.dob, this.patientDOBFormat).format('M-D-YYYY');
      }

      this.removeSearchResults();
      var patientFullName = '';
      if (this.patient.title) {
        patientFullName = patientFullName.concat(this.patient.title + ' ');
      }
      if (this.patient.firstName) {
        patientFullName = patientFullName.concat(this.patient.firstName + ' ');
      }
      if (this.patient.lastName) {
        patientFullName = patientFullName.concat(this.patient.lastName + ' ');
      }

      this.$document[0].getElementById('patientSearchBox').value = patientFullName;
      this.$scope.searchPatientKeyWord = patientFullName;
      this.patientSearchIcon = this.closeIcon;

      this.closeSideNavToAddANewPatient();
    }

    /** Open Side Nav to Create a New Patient **/

  }, {
    key: 'openSideNavToAddANewPatient',
    value: function openSideNavToAddANewPatient() {
      this.patient = {};
      this.removeSearchResults();

      if (this.$scope.patientForm) {
        this.$scope.patientForm.$setPristine();
        this.$scope.patientForm.$setUntouched();
      }

      this.$mdSidenav('addNewPatient').toggle();
    }
  }, {
    key: 'closeSideNavToAddANewPatient',
    value: function closeSideNavToAddANewPatient() {
      this.$mdSidenav('addNewPatient').close();
    }

    /** patient Search Functionality  **/

  }, {
    key: 'toggleSearch',
    value: function toggleSearch() {
      var _this2 = this;

      if (!this.$scope.searchPatientKeyWord) return;
      if (this.$scope.searchPatientKeyWord && this.$scope.searchPatientKeyWord.trim().length === 0) return;

      var _self = this;
      if (this.patientSearchIcon === this.searchIcon) {
        //- this means user is trying to search


        this.$mdDialog.show({
          template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
          parent: angular.element(document.body)
        });

        this.$resource(apiBasePath + 'Patient/SearchByName').get({
          mId: this.roleObj.membershipId,
          searchterm: this.$scope.searchPatientKeyWord
        }).$promise.then(function (response) {
          _this2.patientSearchOn = false;
          if (response.type > 0) {
            _self.patients = response.payload;

            var totalSearchResults = 0;

            if (_self.patients) totalSearchResults = _self.patients.length;else totalSearchResults = 0; // No matching patients found.
            _self.displaySearchResults(_self, totalSearchResults);
          } else {

            _self.patients = [];
            _self.displaySearchResults(_self, 0);
          }

          _self.patientSearchIcon = _this2.closeIcon; //Change icon as search is +ive
          _self.$mdDialog.hide(); // - close the loader
        }).catch(function (response) {
          _self.$mdDialog.hide(); // - close the loader
          _self.displaySearchResults(_self, -1);
        });
      } else {
        // this is means use is cancelling the patient selection
        _self.$scope.searchPatientKeyWord = "";
        _self.removeSearchResults();
        _self.patientSearchIcon = this.searchIcon;
      }
    }

    /** This closed the search patient sugestion  **/

  }, {
    key: 'removeSearchResults',
    value: function removeSearchResults() {
      var dropdowns = this.$document[0].getElementsByClassName("autocomplete-items");

      if (dropdowns) {
        for (var i = 0; i < dropdowns.length; i++) {
          var openDropdown = dropdowns[i];
          openDropdown.remove();
        }
        //-reset patient search and set the search icon
        if (dropdowns.length > 0) {
          this.patientSearchIcon = this.searchIcon;
          this.$document[0].getElementById('patientSearchBox').value = '';
        }
      }
    }
  }, {
    key: 'displaySearchResults',
    value: function displaySearchResults(_self, totalSearchResults) {
      var defaultNoResultStr = '<strong> No results found for:' + _self.$scope.searchPatientKeyWord + '.<br>Please try again</strong>';
      var searchText = totalSearchResults > 0 ? '<strong> Total ' + totalSearchResults + ' matches found </strong>' : defaultNoResultStr;

      if (totalSearchResults === -1) {
        searchText = defaultNoResultStr;
      }

      var searchBox = _self.$document[0].getElementById('patientSearchBox');
      var a = document.createElement("DIV");
      a.setAttribute("id", 'patient-' + "autocomplete-list");
      a.setAttribute("class", "autocomplete-items");
      searchBox.parentNode.appendChild(a);
      var b = document.createElement("DIV");
      b.innerHTML = searchText;
      a.appendChild(b);

      if (_self.patients) {
        for (var i = 0; i < _self.patients.length; i++) {
          if (i === 3) break; //-show only 3 results

          var c = document.createElement("DIV");
          c.innerHTML = "<aside  class='caseCreatorLabel' style='padding-top:0px;padding-left:10px;' onclick='feedControllerThePatient( " + i + ")'>" + _self.patients[i].title + " " + _self.patients[i].firstname + " " + _self.patients[i].lastname + "<br>" + "<span class='clinicianJobTitle' style='font-style: normal;'>D.O.B:" + " " + _self.patients[i].dob + " |  MRN: " + _self.patients[i].ref + "</span>" + "<br> </aside>";
          a.appendChild(c);
        }

        if (_self.patients.length > 3) {
          var more = document.createElement("DIV");
          more.innerHTML = "<strong onclick='feedControllerThePatient(" + -1 + ")' style='color: #0899ff;'> Click to view all </strong>";
          a.appendChild(more);
        }
      }
    }

    /** Chip Code Recipient START **/

  }, {
    key: 'transformChip',
    value: function transformChip(chip) {
      // If it is an object, it's already a known chip
      if (angular.isObject(chip)) {
        return chip;
      }

      //We can Write Code here to create a new chip
    }
  }, {
    key: 'querySearchChip',
    value: function querySearchChip(query) {

      var activeMembershipId = this.context.currentRole.membershipId;

      var allEligibleContacts = this.$scope.quickSearchMap[activeMembershipId];

      var results = query ? allEligibleContacts.filter(this.createFilterForChip(query)) : allEligibleContacts;
      return results;
    }
  }, {
    key: 'getCurrentRoleDisplay',
    value: function getCurrentRoleDisplay() {
      return this.context.currentRole.title + ', ' + this.getOrgDisplayName(this.context.currentRole);
    }
  }, {
    key: 'createFilterForChip',
    value: function createFilterForChip(query) {
      var lowercaseQuery = query.toLowerCase();

      return function filterFn(contact) {
        return contact.fullName.toLowerCase().indexOf(lowercaseQuery) >= 0;
      };
    }
  }, {
    key: 'getStatus',
    value: function getStatus(membershipId) {
      var status = this.availabilityMap[membershipId].status;
      return status;
    }

    /** Load All Your contacts.Disintegrate groups into constituent contacts **/

  }, {
    key: 'loadAllContacts',
    value: function loadAllContacts() {
      var _this3 = this;

      this.isLoadContactsAndGroupsComplete = false;
      this.$scope.contactMap = {};
      this.$scope.quickSearchMap = {};
      this.$scope.quickSearchMapGroup = {};
      var allContactPromiseArray = [];
      var _self = this;
      var page = 1;
      var pageSize = 100;

      var profileContactPromise = this.api.contacts.getAllContactsWithAvailability.get({
        mId: _self.roleObj.membershipId,
        page: 1,
        pageSize: 100
      }).$promise.then(function (response) {
        if (response.type > 0) {
          _this3.profileSpecificContacts = response.payload.items;
          _self.$scope.userProfileContacts = _this3.profileSpecificContacts;
        }
      }).catch(function (response) {
        console.error('An error Occurred while Fetching contacts');
      });

      allContactPromiseArray.push(profileContactPromise);

      var _loop = function _loop(i) {

        var currentMembershipId = _this3.context.roles[i].membershipId;
        var formattedOrganizationName = _this3.context.roles[i].formattedOrganizationName;

        var contactPromise = _this3.api.contacts.getPaged.get({
          mId: currentMembershipId,
          page: page,
          pageSize: pageSize
        }).$promise.then(function (response) {
          if (response.type > 0) {
            _self.$scope.contactMap[currentMembershipId] = response.payload.items;

            var mapOfNamesToSearch = [];

            for (var i = 0; i < response.payload.items.length; i++) {

              var name = '';

              if (response.payload.items[i].firstname) name = name.concat(response.payload.items[i].firstname + ' ');
              if (response.payload.items[i].middleNames) name = name.concat(response.payload.items[i].middleNames + ' ');
              if (response.payload.items[i].lastname) name = name.concat(response.payload.items[i].lastname);

              var _searchableObjects = {
                fullName: name,
                id: response.payload.items[i].id,
                formattedOrganizationName: formattedOrganizationName,
                profession: ''
              };

              if (response.payload.items[i].profession && response.payload.items[i].profession.length > 0) _searchableObjects.profession = response.payload.items[i].profession;

              mapOfNamesToSearch.push(_searchableObjects);
            }

            _self.$scope.quickSearchMap[currentMembershipId] = mapOfNamesToSearch;
          } else {
            console.error('Failed to Load Contact for:' + currentMembershipId);
          }
        }).catch(function (response) {
          console.error('Failed to Load Contact for specific Profile:');
        });

        allContactPromiseArray.push(contactPromise);

        //-Rest call for Groups

        var groupContactPromise = _this3.api.contacts.getGroups.get({
          mId: currentMembershipId,
          page: page,
          pageSize: pageSize
        }).$promise.then(function (response) {
          if (response.type > 0) {
            var existingGroup = _self.$scope.contactMap['groupContact'];

            //Add membershipId to Groups as Rest API is not sending them.

            var modifiedPayload;

            if (response && response.payload) {
              modifiedPayload = [];
              for (var x = 0; x < response.payload.length; x++) {
                //response.payload[x].membershipId = currentMembershipId;
                modifiedPayload.push(response.payload[x]);
              }

              _self.$scope.quickSearchMapGroup[currentMembershipId] = modifiedPayload;
            }
          } else {
            console.error('Failed to Load Groups for:' + currentMembershipId);
          }
        }).catch(function (response) {
          console.error('Failed to Get Group Contact');
        });

        allContactPromiseArray.push(groupContactPromise);

        if (_self.context.roles[i].name !== 'Viewer' && _self.context.roles[i].name !== 'OrgAdmin' && _self.context.roles[i].name !== 'OrgOwner') {
          var promise = _this3.$http({
            url: apiBasePath + 'User/GetCurrentAvailabilitySetting?mId=' + _self.context.roles[i].membershipId,
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
          }).then(function (response) {

            if (response.data.type > 0) {
              var currentAvailability = response.data.payload.currentAvailability;
              var status = void 0;
              if (currentAvailability === 1) {
                status = 'Available';
              } else if (currentAvailability === 2) {
                status = 'Unavailable';
              } else if (currentAvailability === 50) {
                status = 'Not to be Disturbed';
              } else if (currentAvailability === 20) {
                status = 'Unavailable';
              }

              _self.availabilityMap[_self.context.roles[i].membershipId] = {
                'availability': currentAvailability,
                'status': status
              };
            }
          });

          allContactPromiseArray.push(promise);
        }
      };

      for (var i = 0; i < this.context.roles.length; i++) {
        _loop(i);
      } //- End of for loop

      if (allContactPromiseArray.length > 0) {
        this.$q.all(allContactPromiseArray).then(function () {

          _self.$scope.isLoadContactsAndGroupsComplete = true; //-signal that all group members has been loaded


          for (var i = 0; i < _self.context.roles.length; i++) {
            //- Add the group Names to array of individual contacts.

            var _formattedOrganizationName = _self.context.roles[i].formattedOrganizationName;

            var groupProfiles = _self.$scope.quickSearchMapGroup[_self.context.roles[i].membershipId];
            if (groupProfiles && groupProfiles.length > 0) {

              for (var z = 0; z < groupProfiles.length; z++) {
                var _searchableGroupObj = {
                  fullName: groupProfiles[z].aliasName,
                  id: groupProfiles[z].aliasKey,
                  isGroup: true,
                  formattedOrganizationName: _formattedOrganizationName,
                  profession: ''
                };

                _self.$scope.quickSearchMap[_self.context.roles[i].membershipId].push(_searchableGroupObj);
              } //- End of for loop for group array
            }
          } //- End of for loop for profiles.

          if (_self.stateParams) {
            var redirectedGroupId = _self.stateParams.createCaseWithGroupId;

            var allCurrentProfileGroups = _self.$scope.quickSearchMap[_self.roleObj.membershipId];

            if (redirectedGroupId) {
              for (var g = 0; g < allCurrentProfileGroups.length; g++) {
                if (allCurrentProfileGroups[g].id === redirectedGroupId) {
                  _self.chipContacts.push(allCurrentProfileGroups[g]);
                  break; //- as only group can be redirected
                }
              }
            }

            var redirectSingleRecipientId = _self.stateParams.singleRecipientId;

            if (redirectSingleRecipientId) {
              for (var g = 0; g < allCurrentProfileGroups.length; g++) {
                if (allCurrentProfileGroups[g].id === redirectSingleRecipientId) {
                  _self.chipContacts.push(allCurrentProfileGroups[g]);
                  break; //- as only one contact can be redirected. No need to further loop
                }
              }
            }

            if (_self.stateParams.draftCase) {
              // Logic to pre-populate recipients from draft case
              var draftRecipients = _self.stateParams.draftCase.recipients;
              if (draftRecipients && draftRecipients.length > 0) {

                var draftProfileArray = [];

                for (var h = 0; h < draftRecipients.length; h++) {
                  for (var g = 0; g < _self.profileSpecificContacts.length; g++) {
                    if (_self.profileSpecificContacts[g].personId === draftRecipients[h].id) {
                      draftProfileArray.push(_self.profileSpecificContacts[g]);
                      break;
                    }
                  }
                }

                for (var i = 0; i < draftProfileArray.length; i++) {
                  for (var j = 0; j < allCurrentProfileGroups.length; j++) {
                    if (allCurrentProfileGroups[j].id === draftProfileArray[i].id) {
                      _self.chipContacts.push(allCurrentProfileGroups[j]);
                      break;
                    }
                  }
                }
              }
            }
          }
        });
      } else return;
    }

    /** Chip Code Recipient END **/

  }, {
    key: 'getOrgDisplayName',
    value: function getOrgDisplayName(role) {
      var isPersonalProfile = role && role.orgDisplayName.toUpperCase().includes('PRACTICE OF');
      if (isPersonalProfile) {
        return 'Personal Account';
      } else {
        return role.orgDisplayName;
      }
    }
  }, {
    key: 'openProfiles',
    value: function openProfiles() {
      this.currentPage = 'CHANGE_PROFILE';
    }
  }, {
    key: 'saveProfileChange',
    value: function saveProfileChange() {
      var _this4 = this;

      if (this.selectedRole.statusCode < 50) return;

      this.showAllProfiles = false;

      var _self = this;

      var nextRole = {
        Username: this.userName,
        Mid: this.selectedRole.membershipId
      };
      var selectedRoleLocal = this.selectedRole;

      this.$resource(apiBasePath + 'User/SetDefaultRole', null, { 'update': { method: 'PUT' }
      }).update(nextRole).$promise.then(function (response) {

        if (response.type > 0) {
          _self.context.currentRole = selectedRoleLocal; //- This will change Profile in UI display
          _self.closeProfilePage();
          _self.userService.setContextInSession(_self.context);

          var notificationText = 'You have changed your profile to ' + _this4.context.currentRole.formattedOrganizationName;
          _self.swangular.swal('Profile changed', notificationText, 'success');

          _self.$scope.userProfileContacts = [];
          _self.loadAllContacts();
          _self.selectedItemChip = null;
          _self.searchTextChip = null;
          _self.chipContacts = [];
          _self.removeSearchResults(); //- close patient search sugestions
          _self.patientSearchIcon = _this4.searchIcon; // - change icon to search glass
          _self.$document[0].getElementById('patientSearchBox').value = ''; //- clear the value to patient text field
          _self.patient = {}; //clear patient Object
        } else {
          _this4.closeProfilePage();
          _this4.swangular.swal({
            type: 'error',
            title: 'Error Changing Profile',
            html: 'Unable to change your profile now. Please try again later.'
          });
        }
      }).catch(function (response) {

        _this4.closeProfilePage();
        _this4.swangular.swal({
          type: 'error',
          title: 'Error Changing Profile',
          html: 'Unable to change your profile now. Please try again later.'
        });
      });

      this.$scope.searchPatientKeyWord = "";
      this.patientDOBsearch = undefined;
      this.patients = [];
      this.showNoPatienFoundText = false;
    }
  }, {
    key: 'closeProfilePage',
    value: function closeProfilePage() {
      if (this.profileSwapInitiatedFromRecipientsPage) this.currentPage = 'ADD_RECIPIENTS';else if (this.profileSwapInitiatedFromPatientSearch) this.currentPage = 'SEARCH_AND_SELECT_PATIENTS';else this.currentPage = 'CASE_CREATE';

      //this.selectedRoleIndex = -1;
      this.profileSwapInitiatedFromRecipientsPage = false;
      this.profileSwapInitiatedFromPatientSearch = false;
    }
  }, {
    key: 'goBackToCreateCase',
    value: function goBackToCreateCase() {
      this.searchRecipient = "";
      this.currentPage = 'CASE_CREATE';
    }
  }, {
    key: 'deleteCase',
    value: function deleteCase(casePage) {

      var title = void 0,
          content = void 0;

      if (this.isDraft) {
        title = 'Delete Draft';
        content = 'Are you sure you want to delete this Draft and all its media?';
      } else {
        title = 'Delete Case';
        content = 'Are you sure you want to delete this Case and all its media?';
      }

      var _self = this;
      _self.swangular.swal({
        title: title,
        text: content,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'
      }).then(function (result) {
        if (result.value) {
          if (!_self.draftCase) {
            //Since there is no draft , nothing to delete hence redirect to case listing
            //_self.$state.go('app.clinician.cases'); 4202

            if (_self.stateParams.membershipIdFromContactsPage) {
              _self.$state.go('app.clinician.people');
            } else _self.$state.go('app.clinician.cases', { draftCasePage: casePage });
          } else {
            var caseId2beDeleted = [];
            caseId2beDeleted.push(_self.draftCase.id);
            _self.$resource(apiBasePath + 'Cases/Archive?mid=' + _self.context.currentRole.membershipId, null, {
              'update': { method: 'PUT' }
            }).update(caseId2beDeleted).$promise.then(function (response) {
              if (response.type > 0) {
                if (_self.stateParams.membershipIdFromContactsPage) {
                  _self.$state.go('app.clinician.people');
                } else _self.$state.go('app.clinician.cases', { draftCasePage: casePage });
              } else {
                // console.error('Error Occurred While Deleting Draft:' + response);
              }
            }).catch(function (response) {
              //console.error('Error Occurred While Deleting Draft:' + response);
            });
          }
        }
      });
    }
  }, {
    key: 'sendCase',
    value: function sendCase() {
      this.$state.go('app.clinician.cases');
    }
  }, {
    key: 'skipPatientCreation',
    value: function skipPatientCreation() {
      this.currentPage = 'CASE_CREATE';
    }
  }, {
    key: 'changeProfile',
    value: function changeProfile(role, $index) {
      // this.selectedRoleIndex = $index;
      // this.currentRole = role;
      this.selectedRole = role;
    }
  }, {
    key: 'openAddNewPatient',
    value: function openAddNewPatient() {
      this.currentPage = 'ADD_PATIENTS';
    }
  }, {
    key: 'getPatientFullName',
    value: function getPatientFullName() {
      return this.userService.getLongName(this.patient);
    }
  }, {
    key: 'getPatientDOB',
    value: function getPatientDOB() {
      var patientDateOfBirth = this.app.getDateString(this.patient.dob);
      if (patientDateOfBirth) return "D.O.B: " + this.app.getDateString(this.patient.dob);
      return "";
    }
  }, {
    key: 'getFileSize',
    value: function getFileSize(size) {
      var units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      var i = 0;
      while (size >= 1024) {
        size /= 1024;
        ++i;
      }
      return size.toFixed(1) + ' ' + units[i];
    }
  }, {
    key: 'getFileType',
    value: function getFileType(file) {
      return file.type.split('/')[1].toUpperCase() + " file";
    }
  }, {
    key: 'getTotalFilesAdded',
    value: function getTotalFilesAdded() {
      if (this.$scope.userFileUploads) {
        if (this.$scope.userFileUploads.length === 1) {
          return "1 file Added";
        } else {
          return this.$scope.userFileUploads.length + " files Added";
        }
      }
    }
  }, {
    key: 'deleteUpload',
    value: function deleteUpload(fileToBedeleted) {
      var indexToBeDeleted = this.$scope.userFileUploads.indexOf(fileToBedeleted);
      this.$scope.userFileUploads.splice(indexToBeDeleted, 1);
      //this.$scope.$apply();
    }
  }, {
    key: 'getImageURLFromBlob',
    value: function getImageURLFromBlob(blob) {
      return URL.createObjectURL(blob);
    }
  }, {
    key: 'uploadFileToCase',
    value: function uploadFileToCase(file, errFiles) {
      var _this5 = this;

      if (!file) return;

      var reader = new FileReader();
      var dialogMD = this.$mdDialog;
      var userFileUploads = this.$scope.userFileUploads;
      var $scope = this.$scope;
      var totalFileUploaded = this.totalFileUploaded;

      this.removeSearchResults();

      reader.addEventListener("load", function () {
        //Add code what to do after file is read

        var fileType = file.type;

        if (fileType && fileType.split('/')[0] === 'image') {

          _this5.swangular.swal({
            title: '',
            html: '<img src=' + reader.result + '>',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Upload'
          }).then(function (result) {
            if (result.value) {
              var fileObj = {};
              fileObj.type = 'image';
              fileObj.file = file;
              fileObj.src = reader.result;
              fileObj.index = totalFileUploaded;
              totalFileUploaded++; // Not working and not used
              userFileUploads.push(fileObj);
            }
          });
          /*
          var confirm = dialogMD.confirm()
            .title('Preview Image')
            .htmlContent('<img src=' + reader.result + '>')
            .ok('Upload')
            .cancel('Cancel');
           dialogMD.show(confirm).then(function () {
               var fileObj = {};
              fileObj.type = 'image';
              fileObj.file = file;
              fileObj.src = reader.result;
              fileObj.index = totalFileUploaded;
              totalFileUploaded++; // Not working and not used
              userFileUploads.push(fileObj);
              // console.log("Image uploaded", userFileUploads, totalFileUploaded);
               // commented out because of the $digest already in progress error
              // $scope.$apply(); // - to explicitly refresh upload box in UI
             },
            function () {
               dialogMD.hide();
            });
          */
        } else if (fileType) {
          var fileObj = {};
          if (fileType.split('/')[0] === 'video') {
            _this5.swangular.swal({
              title: '',
              html: '<video style="width:100%;max-width:400px;" controls><source src="' + reader.result + '"></video>',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Upload'
            }).then(function (result) {
              if (result.value) {
                fileObj.type = 'video';
                fileObj.src = reader.result;
                fileObj.file = file;
                fileObj.index = totalFileUploaded;
                totalFileUploaded++;
                userFileUploads.push(fileObj);
                $scope.$apply();
              }
            });
          } else if (fileType === 'application/pdf') {

            _this5.swangular.swal({
              title: '',
              html: '<object width="1000px" height="500px" type="application/pdf" data="' + reader.result + '" style="margin: auto; max-width: 100%;">',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Upload'
            }).then(function (result) {
              if (result.value) {
                fileObj.type = 'pdf';
                fileObj.src = reader.result;
                fileObj.file = file;
                fileObj.index = totalFileUploaded;
                totalFileUploaded++;
                userFileUploads.push(fileObj);
                $scope.$apply(); // - to explicitly refresh upload box in UI
              }
            });
          }
        }

        $scope.$apply(); // - to explicitly refresh upload box in UI
      }, false);

      if (file) {
        reader.readAsDataURL(file);
      }
    }
  }, {
    key: 'cleanOldItems',
    value: function cleanOldItems(callbackObject) {
      /* this is redundant now, Draft Items are comming from /Case/NewItems Call
        for (var i = 0; i < callbackObject.previousDraft.items.length; i++) {
           if (callbackObject.previousDraft.items[i].type === 40) {// Text is type 40
             callbackObject.localResource(apiBasePath + 'Cases/Item/Delete?mid=' + callbackObject.membershipId).save(
              callbackObject.previousDraft.items[i],
              function (response) { // Success
                if (response.type > 0) {
                  //console.log('Item deleted Successfully from Draft');
                }
                else {
                  console.error('Error Occurred While deleting Case Item');
                }
              },
              function (response) { //Failure
                console.error('Error Occurred While deleting Case Item');
              }
            );
          }
        }
      */
      var deleteAllStaleMessages = [];
      if (callbackObject.previousDraftData) {
        for (var k = 0; k < callbackObject.previousDraftData.length; k++) {
          if (callbackObject.previousDraftData[k].type === 40) {
            // Text is type 40
            var deleteIndividualStaleMessage = callbackObject.localResource(apiBasePath + 'Cases/Item/Delete?mid=' + callbackObject.membershipId).save(callbackObject.previousDraftData[k], function (response) {
              // Success
              if (response.type > 0) {} else {
                console.error('Error Occurred While deleting Case Item');
              }
            }, function (response) {
              console.error('Error Occurred While deleting Case Item');
            });
            deleteAllStaleMessages.push(deleteIndividualStaleMessage);
          }
        }
      }

      if (deleteAllStaleMessages.length > 0) {
        this.$q.all(deleteAllStaleMessages).then(function () {
          callbackObject.saveExistingDraftAgain(callbackObject);
        });
      }
    }
  }, {
    key: 'saveExistingDraftAgain',
    value: function saveExistingDraftAgain(callbackObject) {
      // - detect change in case title
      if (callbackObject.caseTitle !== callbackObject.previousDraft.title) callbackObject.previousDraft.title = callbackObject.caseTitle;

      // - detect change in case priority
      if (callbackObject.previousDraft.priority && callbackObject.previousDraft.priority !== callbackObject.casePriority) callbackObject.previousDraft.priority = callbackObject.casePriority;

      // - detect if patient has been removed
      if (callbackObject.previousDraft.patient) if (Object.keys(callbackObject.patient).length === 0) delete callbackObject.previousDraft.patient;

      // -  detect if patient has been changed
      if (callbackObject.patient) callbackObject.previousDraft.patient = callbackObject.patient;

      callbackObject.previousDraft.recipients = callbackObject.newCase.recipients; // - do we need to fine tune recipients comparison to deeper level ?
      callbackObject.previousDraft.items = callbackObject.newCase.items;

      // console.log("API call with updated previousDraft", callbackObject.previousDraft);

      callbackObject.localResource(apiBasePath + 'Cases/SaveDraft?mid=' + callbackObject.membershipId).save(callbackObject.previousDraft, function (response) {
        //- success while saving draft
        if (response.type > 0) {
          callbackObject.payload = response.payload;

          if (callbackObject.sendCase) callbackObject.createCase(callbackObject);else {
            callbackObject.$mdDialog.hide();

            callbackObject.beginItem(callbackObject);

            callbackObject.localState.go('app.clinician.cases');
            //callbackObject.appContext.popup("Storing Draft", "This draft will be kept so you can edit and send it later. Please note that any attachments will only be saved on this device.", 'Ok');
          }
        }
      }, function (response) {
        // - error while saving draft
        callbackObject.appContext.popup("Error", "Sorry, an error has occurred and we cannot continue. Please try again later.", 'Close');
        return;
      });
    }
  }, {
    key: 'beginItem',
    value: function beginItem(callbackObject) {
      /* - This method makes Begin item call and uploads file to s3 by put call */

      //callbackObject.localNewCase = callbackObject.createMediaPaceHolder(callbackObject.localUploadedFiles, callbackObject.payload);

      if (callbackObject.localUploadedFiles) {
        var _loop2 = function () {
          var localFile = callbackObject.localUploadedFiles[i];
          {
            placeHolder = callbackObject.getAppropriatePlaceHolder(localFile, callbackObject.payload.id);

            callbackObject.http({
              headers: { 'Content-Type': 'application/json' },
              url: apiBasePath + 'Cases/Creator/BeginItem?mid=' + callbackObject.membershipId,
              data: placeHolder,
              method: 'POST'
            }).then(function (response) {
              if (response.data.type > 0) {
                callbackObject.singleS3Upload(callbackObject, localFile, response.data.payload);
              } else {
                callbackObject.appContext.popup("Error", "Sorry, an error has occurred and we cannot continue. Please try again later.", 'Close');
              }
            }, function (error) {
              callbackObject.appContext.popup("Error", "Sorry, an error has occurred and we cannot continue. Please try again later.", 'Close');
            });
          }
        };

        for (var i = 0; i < callbackObject.localUploadedFiles.length; i++) {
          var placeHolder;

          _loop2();
        }
      }
    }
  }, {
    key: 'createCase',
    value: function createCase(callbackObject) {
      /* This is the case when user modifies a draft and sends it */

      // console.log("Files and payload for case creation", callbackObject.localUploadedFiles, callbackObject.payload);
      callbackObject.localNewCase = callbackObject.createMediaPaceHolder(callbackObject.localUploadedFiles, callbackObject.payload);

      callbackObject.localResource(apiBasePath + 'Cases/Send?mid=' + callbackObject.membershipId).save(callbackObject.payload, function (response) {
        // Success
        if (response.type > 0) {
          // callbackObject.goToCasesListing(callbackObject);
          callbackObject.sendCasePayloadItems = response.payload.items;
          callbackObject.uploadMedia2s3(callbackObject);
        } else {
          callbackObject.$mdDialog.hide();
          callbackObject.swangular.swal({
            type: 'error',
            title: '',
            html: response.message
          });
          callbackObject.goToCasesListingFromDraft(callbackObject);
          // callbackObject.appContext.popup("Error", "Sorry, an error has occurred and we cannot continue. Please try again later.", 'Close');
          // return;
        }
      },
      // Error
      function (response) {
        callbackObject.$mdDialog.hide();
        callbackObject.swangular.swal({
          type: 'error',
          title: '',
          html: 'There is a system error. Please try again later or contact your administrator.'
        });
        // callbackObject.appContext.popup("Error", "Sorry, an error has occurred and we cannot continue. Please try again later.", 'Close');
        // return;
      });
    }
  }, {
    key: 'createMediaPaceHolder',
    value: function createMediaPaceHolder(localUploadedFiles, localNewCase) {
      if (localUploadedFiles && localUploadedFiles.length > 0) {
        for (var i = 0; i < localUploadedFiles.length; i++) {
          if (localUploadedFiles[i].type === 'image') {
            var imagePlaceHolder = {
              width: 1920,
              height: 1080,
              id: 0,
              caseId: localNewCase.id,
              type: 32,
              data: "",
              timestamp: new Date()

            };
            localNewCase.items.push(imagePlaceHolder);
          } else if (localUploadedFiles[i].type === 'video') {

            var videoPlaceHolder = {
              id: 0,
              caseId: localNewCase.id,
              type: 12,
              data: "",
              timestamp: new Date()
            };
            localNewCase.items.push(videoPlaceHolder);
          } else if (localUploadedFiles[i].type === 'pdf') {

            var pdfPlaceHolder = {
              id: 0,
              caseId: localNewCase.id,
              type: 62,
              data: "",
              timestamp: new Date()
            };
            localNewCase.items.push(pdfPlaceHolder);
          }
        }
      }

      return localNewCase;
    }
  }, {
    key: 'getAppropriatePlaceHolder',
    value: function getAppropriatePlaceHolder(localUploadedFile, caseId) {
      if (localUploadedFile.type === 'image') {
        var imagePlaceHolder = {
          width: 1920,
          height: 1080,
          id: 0,
          caseId: caseId,
          type: 32,
          data: "",
          timestamp: new Date()

        };
        return imagePlaceHolder;
      } else if (localUploadedFile.type === 'video') {

        var videoPlaceHolder = {
          id: 0,
          caseId: caseId,
          type: 12,
          data: "",
          timestamp: new Date()
        };
        return videoPlaceHolder;
      } else if (localUploadedFile.type === 'pdf') {

        var pdfPlaceHolder = {
          id: 0,
          caseId: caseId,
          type: 62,
          data: "",
          timestamp: new Date()
        };
        return pdfPlaceHolder;
      }
    }
  }, {
    key: 'uploadMedia2s3',
    value: function uploadMedia2s3(callbackObject) {
      // - Uploads attachments if any to s3 and redirects to case listing page. Redirects none-the less.

      if (callbackObject.sendCasePayloadItems) for (var i = 0; i < callbackObject.sendCasePayloadItems.length; i++) {
        if (callbackObject.sendCasePayloadItems[i].type === 32) {
          // console.log("Image payload to localFiles", callbackObject.sendCasePayloadItems[i]);
          for (var j = 0; j < callbackObject.localUploadedFiles.length; j++) {
            if (!callbackObject.localUploadedFiles[j].s3URL && callbackObject.localUploadedFiles[j].type === 'image') {
              // console.log("local upload file", callbackObject.localUploadedFiles[j]);
              callbackObject.localUploadedFiles[j].s3URL = callbackObject.sendCasePayloadItems[i].data;
              break;
            }
          }
        }

        if (callbackObject.sendCasePayloadItems[i].type === 12) {
          for (var j = 0; j < callbackObject.localUploadedFiles.length; j++) {
            if (!callbackObject.localUploadedFiles[j].s3URL && callbackObject.localUploadedFiles[j].type === 'video') {
              callbackObject.localUploadedFiles[j].s3URL = callbackObject.sendCasePayloadItems[i].data;
              callbackObject.localUploadedFiles[j].previewData = callbackObject.sendCasePayloadItems[i].previewData; // Required only for video as image and PDF thumbnail is generated by AWS
              break;
            }
          }
        }
        if (callbackObject.sendCasePayloadItems[i].type === 62) {
          for (var j = 0; j < callbackObject.localUploadedFiles.length; j++) {
            if (!callbackObject.localUploadedFiles[j].s3URL && callbackObject.localUploadedFiles[j].type === 'pdf') {
              callbackObject.localUploadedFiles[j].s3URL = callbackObject.sendCasePayloadItems[i].data;
              break;
            }
          }
        }
      }

      var defer = callbackObject.$q.defer(); // Can use this to notify user that some files failed to upload - future

      var putAllMedia = [];

      var _loop3 = function _loop3(_i) {
        if (callbackObject.localUploadedFiles[_i].type === 'video') customType = 10;else if (callbackObject.localUploadedFiles[_i].type === 'image') customType = 30;else if (callbackObject.localUploadedFiles[_i].type === 'pdf') customType = 60;
        //var currentFile = localUploadedFiles[i];

        // console.log("Uploading file to s3", callbackObject.localUploadedFiles[i].s3URL, callbackObject.localUploadedFiles[i].file, callbackObject.localUploadedFiles[i].file.type);
        putSingleMedia = callbackObject.http({
          url: callbackObject.localUploadedFiles[_i].s3URL,
          method: 'PUT',
          data: callbackObject.localUploadedFiles[_i].file,
          headers: { 'Content-Type': callbackObject.localUploadedFiles[_i].file.type }
        }).then(function (response) {
          // Ideally should make end item call here - but seems not required !

          if (callbackObject.localUploadedFiles[_i].type === 'video' && callbackObject.localUploadedFiles[_i].videoThumbnailFile) {
            callbackObject.http({
              url: callbackObject.localUploadedFiles[_i].previewData,
              data: callbackObject.localUploadedFiles[_i].videoThumbnailFile,
              method: 'PUT',
              headers: { 'Content-Type': 'image/jpeg' }
            }).then(function (response) {
              console.log('Thumbnail Uploaded successfully');
            }, function (error) {
              console.log(error);
            });
          } //- End of put request to Upload ThumbNail
        }, function (error) {
          console.log(error);
        });


        putAllMedia.push(putSingleMedia);
      };

      for (var _i = 0; _i < callbackObject.localUploadedFiles.length; _i++) {
        var customType;
        var putSingleMedia;

        _loop3(_i);
      }

      if (putAllMedia && putAllMedia.length > 0) {
        callbackObject.$q.all(putAllMedia).then(function () {
          callbackObject.goToCasesListing(callbackObject);
        });
      } else callbackObject.goToCasesListing(callbackObject);
    }
  }, {
    key: 'singleS3Upload',
    value: function singleS3Upload(callbackObject, localUploadedFile, beginItemResponsePayload) {
      var s3URL = beginItemResponsePayload.data;
      callbackObject.http({
        url: s3URL,
        data: localUploadedFile.file,
        headers: { 'Content-Type': localUploadedFile.file.type },
        method: 'PUT'
      }).then(function (response) {
        callbackObject.singleEndItem(callbackObject, beginItemResponsePayload);
      }, function (error) {
        console.log(error);
        callbackObject.appContext.popup("Error", "Sorry, an error has occurred and we cannot continue. Please try again later.", 'Close');
      });
    }
  }, {
    key: 'singleEndItem',
    value: function singleEndItem(callbackObject, beginItemResponsePayload) {

      var customType = beginItemResponsePayload.type - 2;

      var endItemRequestPayload = {
        id: beginItemResponsePayload.id,
        caseId: beginItemResponsePayload.caseId,
        type: customType,
        data: beginItemResponsePayload.data, // - the s3 URL
        timestamp: new Date()
      };

      callbackObject.http({
        url: apiBasePath + 'Cases/Creator/EndItem?mid=' + callbackObject.membershipId,
        method: 'POST',
        data: endItemRequestPayload,
        headers: { 'Content-Type': 'application/json' }
      }).then(function (response) {
        if (response.data.type <= 0) {
          callbackObject.swangular.swal({
            type: 'error',
            title: '',
            html: 'Sorry, an error has occurred and we cannot continue. Please try again later.'
          });
        }
      }, function (error) {
        callbackObject.swangular.swal({
          type: 'error',
          title: '',
          html: 'Sorry, an error has occurred and we cannot continue. Please try again later.'
        });
      });
    }
  }, {
    key: 'goToCasesListing',
    value: function goToCasesListing(callbackObject) {
      if (callbackObject.appContext.clinician.cases == undefined) callbackObject.appContext.clinician.cases = {};
      callbackObject.appContext.clinician.cases.results = [];

      callbackObject.$mdDialog.hide();

      callbackObject.$analytics.eventTrack('Click', { category: 'Button', label: 'new-case-created' });

      callbackObject.swangular.swal('', 'Your new chat has been created and sent.', 'success');

      //callbackObject.appContext.popup("New Case Sent", "Your new case has been created and sent.", 'Ok');
      callbackObject.localState.go('app.clinician.cases');
    }
  }, {
    key: 'goToCasesListingFromDraft',
    value: function goToCasesListingFromDraft(callbackObject) {
      if (callbackObject.appContext.clinician.cases == undefined) {
        callbackObject.appContext.clinician.cases = {};
      }

      callbackObject.appContext.clinician.cases.results = [];

      callbackObject.$mdDialog.hide();

      callbackObject.$analytics.eventTrack('Click', { category: 'Button', label: 'new-case-created' });
      callbackObject.localState.go('app.clinician.cases');
    }
  }, {
    key: 'notifyDraftHasBeenSaved',
    value: function notifyDraftHasBeenSaved(callbackObject) {

      callbackObject.swangular.swal('', 'This draft will be kept so you can edit and send it later.', 'success');

      callbackObject.localState.go('app.clinician.cases');
      //callbackObject.appContext.popup("Storing Draft", "This draft will be kept so you can edit and send it later. Please note that any attachments will only be saved on this device.", 'Ok');
    }
  }, {
    key: 'sendCaseAfterPersistingDraft',
    value: function sendCaseAfterPersistingDraft(callbackObject) {

      callbackObject.localNewCase = callbackObject.createMediaPaceHolder(callbackObject.localUploadedFiles, callbackObject.payload);

      //Remove empty recipients here !

      var _recipients = [];

      for (var i = 0; i < callbackObject.localNewCase.recipients.length; i++) {
        if (callbackObject.localNewCase.recipients[i].id !== "00000000-0000-0000-0000-000000000000") {
          _recipients.push(callbackObject.localNewCase.recipients[i]);
        }
      }

      callbackObject.localNewCase.recipients = _recipients;

      callbackObject.localResource(apiBasePath + 'Cases/Send?mid=' + callbackObject.membershipId).save(callbackObject.localNewCase, function (response) {
        // Success
        if (response.type > 0) {
          callbackObject.sendCasePayloadItems = response.payload.items;
          callbackObject.uploadMedia2s3(callbackObject);
        } else {
          callbackObject.$mdDialog.hide();
          callbackObject.swangular.swal({
            type: 'error',
            title: '',
            html: response.message
          });
          callbackObject.goToCasesListingFromDraft(callbackObject);
          // callbackObject.appContext.popup("Error", "Sorry, an error has occurred and we cannot continue. Please try again later.", 'Close');
          // return;
        }
      }, function (response) {
        // Error
        callbackObject.$mdDialog.hide();
        callbackObject.swangular.swal({
          type: 'error',
          title: '',
          html: 'There is a system error. Please try again later or contact your administrator.'
        });
        //callbackObject.appContext.popup("Error", "Sorry, an error has occurred and we cannot continue. Please try again later.", 'Close');
        // return;
      });
    }
  }, {
    key: 'checkIfPatientIsEmpty',
    value: function checkIfPatientIsEmpty(patient) {
      return !_.isEmpty(patient) && (!_.isUndefined(patient.firstname) || !_.isUndefined(patient.lastname) || !_.isUndefined(patient.ref) || !_.isUndefined(patient.dob) || !_.isUndefined(patient.title));
    }
  }, {
    key: 'convertChipToContact',
    value: function convertChipToContact(sendCase) {

      var allUserSelectedRecipientChips = this.chipContacts;
      var activeMembershipId = this.context.currentRole.membershipId;

      var _self = this;
      var allRecipients = [];

      if (allUserSelectedRecipientChips && allUserSelectedRecipientChips.length > 0) {

        var allGroupChipPromise = [];

        for (var x = 0; x < allUserSelectedRecipientChips.length; x++) {
          if (allUserSelectedRecipientChips[x].isGroup) {
            // -When your chip is a group

            var individualChipPromise = _self.$http({
              method: 'GET',
              url: apiBasePath + 'Contact/GetContactAliasContactList?mId=' + activeMembershipId + '&aliasId=' + allUserSelectedRecipientChips[x].id
            }).then(function successCallback(response) {
              var groupMembers = response.data.payload;

              for (var j = 0; j < groupMembers.length; j++) {
                allRecipients.push(groupMembers[j].contactId);
              }
            }, function errorCallback(response) {
              console.log('Error Occurred While Getting group Members');
            });

            allGroupChipPromise.push(individualChipPromise);
          } else {
            //--When your chip is a contact.  Map this to the actual Recipient.
            allRecipients.push(allUserSelectedRecipientChips[x].id);
          }
        }
        if (allGroupChipPromise && allGroupChipPromise.length > 0) {
          // - throttle the call till all group members are fetched
          this.$q.all(allGroupChipPromise).then(function () {
            //translate group members to what end -point can understand
            if (allRecipients && allRecipients.length) {
              for (var i = 0; i < allRecipients.length; i++) {
                for (var j = 0; j < _self.profileSpecificContacts.length; j++) {
                  if (_self.profileSpecificContacts[j].id === allRecipients[i]) {
                    _self.messageRecipients.push(_self.profileSpecificContacts[j]);
                    break;
                  }
                }
              }
            }
            _self.messageRecipients;
            _self.saveDraft(sendCase);
          });
        } else {
          // - this is the case when user has selected no Groups only individual contacts
          //translate group members to what end -point can understand
          if (allRecipients && allRecipients.length) {
            for (var i = 0; i < allRecipients.length; i++) {
              for (var j = 0; j < _self.$scope.contactMap[activeMembershipId].length; j++) {
                if (_self.$scope.contactMap[activeMembershipId][j].id === allRecipients[i]) {
                  _self.messageRecipients.push(_self.$scope.contactMap[activeMembershipId][j]);
                  break;
                }
              }
            }
          }
          _self.messageRecipients;
          _self.saveDraft(sendCase);
        }
      } else {
        //- this is the case when user has selected no Chip contact. Its a case send to self
        this.saveDraft(sendCase);
      }
    }
  }, {
    key: 'saveDraft',
    value: function saveDraft(sendCase) {

      // - get all members of Group here . do a q.all

      this.newCase.items = [];
      var item;
      if (this.isThereOldTextMessage) {
        item = this.oldDraftPayload;
        item.data = this.caseTextMessage;
      } else {
        item = {
          Type: 40, // text
          Data: this.caseTextMessage
        };
      }

      this.newCase.items.push(item);

      this.newCase.Patient = this.patient;
      this.newCase.priority = this.casePriority;

      this.newCase.recipients = [];

      var case2Self = false;

      if (this.messageRecipients.length === 0) {
        var self = {
          id: this.context.user.personId
        };
        this.newCase.recipients.push(self);

        case2Self = true;
      } else {

        for (var i = 0; i < this.messageRecipients.length; i++) {
          this.newCase.recipients.push(this.getRecipient(this.messageRecipients[i]));
        }
      }

      this.newCase.title = this.caseTitle;

      var callbackObject = {
        localResource: this.$resource,
        membershipId: this.context.currentRole.membershipId,
        appContext: this.app,
        localState: this.$state,
        http: this.$http,
        $q: this.$q,
        sendCaseAfterPersistingDraft: this.sendCaseAfterPersistingDraft,
        createMediaPaceHolder: this.createMediaPaceHolder,
        localUploadedFiles: this.$scope.userFileUploads,
        uploadMedia2s3: this.uploadMedia2s3,
        beginItem: this.beginItem,
        sendCase: sendCase,
        saveDraftAgain: this.saveDraftAgain,
        newCase: this.newCase,
        draftCase: this.draftCase,
        goToCasesListing: this.goToCasesListing,
        goToCasesListingFromDraft: this.goToCasesListingFromDraft,
        notifyDraftHasBeenSaved: this.notifyDraftHasBeenSaved,
        saveDraftOnly: this.saveDraftOnly,
        cleanOldItems: this.cleanOldItems,
        previousDraft: this.draftCase,
        saveExistingDraftAgain: this.saveExistingDraftAgain,
        caseTitle: this.caseTitle,
        casePriority: this.casePriority,
        patient: this.patient,
        createCase: this.createCase,
        $mdDialog: this.$mdDialog,
        singleS3Upload: this.singleS3Upload,
        singleEndItem: this.singleEndItem,
        getAppropriatePlaceHolder: this.getAppropriatePlaceHolder,
        swangular: this.swangular,
        $analytics: this.$analytics,
        previousDraftData: this.previousDraftData
      };

      var singular = "Are you sure you want to share patient data with this person?";
      var plural = "Are you sure you want to share patient data with these persons?";
      var consentContent;
      var title;

      if (case2Self) {
        consentContent = 'Do you want to send this case to yourself?';
        title = 'No Recipients';
      } else {
        consentContent = this.newCase.recipients.length > 1 ? plural : singular;
        title = 'Share patient data';
      }

      if (sendCase) // - if this is a request to save draft only no need to prompt user
        {

          var _self = this;
          _self.swangular.swal({
            title: title,
            text: consentContent,
            type: 'info',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
          }).then(function (result) {
            if (result.value) {
              _self.coreLogic(callbackObject);
            }
          });
        } else this.coreLogic(callbackObject);
    }
  }, {
    key: 'coreLogic',
    value: function coreLogic(callbackObject) {
      var _loop4 = function _loop4(i) {
        if (callbackObject.localUploadedFiles[i].type === 'video') {
          video = document.createElement('video');
          time = 1; // Set specific time in second for thumbnail

          scale = 1; // Scale image

          thumbnailDimensions = {
            width: 200,
            height: 200
          };

          video.setAttribute('src', callbackObject.localUploadedFiles[i].src);
          video.addEventListener('loadedmetadata', function () {
            this.currentTime = time; //Set current time of video after metadat loaded
          }, false);

          video.addEventListener('loadeddata', function () {
            var canvas = document.createElement("canvas");
            canvas.width = thumbnailDimensions.width * scale;
            canvas.height = thumbnailDimensions.height * scale;
            canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);

            var thumbnailAsBase64 = canvas.toDataURL('image/jpeg');
            callbackObject.localUploadedFiles[i].videoThumbnailFile = undefined;

            fetch(thumbnailAsBase64).then(function (res) {
              return res.blob();
            }).then(function (blob) {
              callbackObject.localUploadedFiles[i].videoThumbnailFile = new File([blob], 'videoThumbNail.jpeg');
            });

            video.setAttribute('currentTime', 0); // Reset video current time
          }, false);
        }
      };

      //-Logic to create thumbnail. This will run in background and you will get a thumbnail later

      for (var i = 0; i < callbackObject.localUploadedFiles.length; i++) {
        var video;
        var time;
        var scale;
        var thumbnailDimensions;

        _loop4(i);
      }
      //-Logic to create thumbnail - END

      callbackObject.$mdDialog.show({
        template: "<md-dialog class='stickyDialog'><div id='makeCenter' class='centerLoader'><md-progress-circular md-mode='indeterminate'></md-progress-circular></div></md-dialog>",
        parent: angular.element(document.body)
      });

      if (!callbackObject.draftCase) {
        // - This is the case when user saves a message as a draft for the first time
        callbackObject.saveDraftOnly(callbackObject);
      } else {
        // - This is the case when user modifies a draft
        //callbackObject.cleanOldItems(callbackObject); - commented for defect resolution
        callbackObject.saveExistingDraftAgain(callbackObject);
      }
    }
  }, {
    key: 'saveDraftOnly',
    value: function saveDraftOnly(callbackObject) {
      callbackObject.localResource(apiBasePath + 'Cases/Draft?mid=' + callbackObject.membershipId).save(callbackObject.newCase, function (response) {
        // Success
        if (response.type > 0) {
          callbackObject.payload = response.payload;
          callbackObject.saveDraftAgain(callbackObject);
        } else {
          callbackObject.$mdDialog.hide();
        }
      }, function (response) {
        callbackObject.$mdDialog.hide();
        callbackObject.appContext.popup("Error", "Sorry, an error has occurred and we cannot continue. Please try again later.", 'Close');
        return;
      });
    }
  }, {
    key: 'saveDraftAgain',
    value: function saveDraftAgain(callbackObject) {

      callbackObject.localResource(apiBasePath + 'Cases/SaveDraft?mid=' + callbackObject.membershipId).save(callbackObject.payload, function (response) {
        if (response.type > 0) {

          if (callbackObject.sendCase) {
            callbackObject.payload = response.payload;
            callbackObject.sendCaseAfterPersistingDraft(callbackObject);
          } else {
            // This is the case where its a Draft and you want to redirect it to the case listing page
            callbackObject.$mdDialog.hide();
            callbackObject.beginItem(callbackObject);

            callbackObject.notifyDraftHasBeenSaved(callbackObject);
            //  callbackObject.uploadMedia2s3(callbackObject);

            // if(callbackObject.localUploadedFiles && callbackObject.localUploadedFiles.length >0)
            //  callbackObject.beginItem(callbackObject);
            // else {
            //   callbackObject.notifyDraftHasBeenSaved(callbackObject);
            // }
          }
        }
      }, function (response) {
        callbackObject.$mdDialog.hide();
        callbackObject.appContext.popup("Error", "Sorry, an error has occurred and we cannot continue. Please try again later.", 'Close');
        return;
      });
    }
  }, {
    key: 'isCaseEligible2Send',
    value: function isCaseEligible2Send() {
      // Check for text message
      if (this.caseTextMessage && this.caseTextMessage.trim().length > 0) {
        return true;
      }

      // Check for file uploads
      if (this.$scope.userFileUploads && this.$scope.userFileUploads.length > 0) {
        return true;
      }

      // Check for draft items
      if (this.draftDownloadableItems && this.draftDownloadableItems.length > 0) {
        return true;
      }

      return false;
    }
  }, {
    key: 'openPDFInPopup',
    value: function openPDFInPopup(userFilesrc) {
      this.$mdDialog.show({

        template: "<object width='1000' height='500' type='application/pdf' data='" + userFilesrc + "' style='margin: auto; max-width: 100%;'>",
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        fullscreen: true,
        ok: 'Close'
      });
    }
  }, {
    key: 'openVideoInPopup',
    value: function openVideoInPopup(userFilesrc) {
      this.swangular.swal({
        title: '',
        html: '<video style="width:100%;max-width:400px;" controls controlsList="nodownload"><source src="' + userFilesrc + '" type="video/mp4"></video>'
      });
    }
  }, {
    key: 'getOrganization',
    value: function getOrganization(contact) {

      // console.log(this.context.roles);
      if (contact && contact.availability && this.context && this.context.roles) {
        var organisationId = contact.availability[0].organisationId;
        if (organisationId) {
          for (var i = 0; i < this.context.roles.length; i++) {
            var role = this.context.roles[i];
            // console.log("Recipient organisations", this.context.roles);
            if (role.orgId === organisationId) {

              var isPersonalProfile = role && role.orgDisplayName.toUpperCase().includes('PRACTICE OF');
              if (isPersonalProfile) {
                return 'Personal Account';
              } else {
                return role.orgDisplayName;
              }
              //return role.orgDisplayName;
            }
          }
        }
      }
    }
  }, {
    key: 'getRecipient',
    value: function getRecipient(contact) {
      var recipient = {};

      recipient.displayName = "";

      if (contact.title) recipient.displayName += contact.title + " ";

      recipient.displayName += contact.lastname + ", " + contact.firstname;
      if (contact.middlenames) recipient.displayName += " " + contact.middlenames;

      //console.log(contact);
      recipient.id = contact.personId;
      if (contact.mobile) recipient.address = contact.mobile;else recipient.address = contact.email;

      // find best ref available
      if (contact.registrationId) recipient.displayRef = contact.registrationId;else if (contact.positionTitle) recipient.displayRef = contact.positionTitle;else if (contact.profession) recipient.displayRef = contact.profession;else if (contact.staffId) recipient.displayRef = contact.staffId;else if (contact.mobile) recipient.displayRef = contact.mobile;else recipient.displayRef = contact.email;

      return recipient;
    }
  }, {
    key: 'makeRecipients',
    value: function makeRecipients() {
      var selectedContacts = [];

      for (var i = 0; i < this.profileSpecificContacts.length; i++) {
        if (this.profileSpecificContacts && this.profileSpecificContacts[i].selected) selectedContacts.push(this.profileSpecificContacts[i]);
      }

      return selectedContacts;
    }
  }, {
    key: 'openVideoInPopup',
    value: function openVideoInPopup(userFilesrc) {
      this.swangular.swal({
        title: '',
        html: '<video style="width:100%;max-width:400px;" controls controlsList="nodownload"><source src="' + userFilesrc + '"></video>'
      });
    }
  }, {
    key: 'openPDFInPopup',
    value: function openPDFInPopup(chatdata) {
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", chatdata, false); // false for synchronous request
      xmlHttp.send(null);
      var localDialog = this.$mdDialog;

      var pdfURL = chatdata + '#toolbar=0';

      this.swangular.swal({
        title: '',
        html: '<object width="1000px" height="500px" type="application/pdf" data="' + pdfURL + '" style="margin: auto; max-width: 100%;">'
      });
    }
  }, {
    key: 'deleteDraftCaseItem',
    value: function deleteDraftCaseItem(item) {
      var _this6 = this;

      this.swangular.swal({
        title: 'Delete Case Item',
        html: 'Do you want to delete this case item?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        focusConfirm: false
      }).then(function (result) {
        if (result.value) {
          var deleteResource = _this6.$resource(apiBasePath + 'items/:caseId/:id', {}, {
            delete: {
              method: 'DELETE'
            }
          });

          deleteResource.delete({ caseId: item.caseId, id: item.id }).$promise.then(function (response) {
            if (response && response.type > 0) {
              _this6.swangular.swal('Case Item Deleted', 'The case item has been successfully deleted.', 'success');
              _this6.$analytics.eventTrack('Click', { category: 'Button', label: 'case-item-delete-success' });

              _this6.draftDownloadableItems = _this6.draftDownloadableItems.filter(function (i) {
                return i.id !== item.id;
              });
            } else {
              _this6.swangular.swal({
                type: 'error',
                title: '',
                html: 'Failed to delete case item. Please contact <a href="mailto:support@clinivid.com.au">Support</a>'
              });
              _this6.$analytics.eventTrack('Click', { category: 'Button', label: 'case-item-delete-failure' });
            }
          }).catch(function (error) {
            _this6.swangular.swal({
              type: 'error',
              title: '',
              html: 'Failed to delete case item. Please contact <a href="mailto:support@clinivid.com.au">Support</a>'
            });
            _this6.$analytics.eventTrack('Click', { category: 'Button', label: 'case-item-delete-failure' });
          });
        }
      });
    }
  }, {
    key: 'filterDownloadableItems',
    value: function filterDownloadableItems(draftItems) {
      var _this7 = this;

      var allowedTypes = [this.fileTypes.VIDEO, this.fileTypes.IMAGE, this.fileTypes.PDF];

      return draftItems.filter(function (obj) {
        return allowedTypes.includes(_this7.getItemType(obj.type));
      });
    }
  }]);

  return CaseCreationController;
}();

angular.module('app.user').component('casecreation', {
  controller: CaseCreationController,
  templateUrl: 'app/user/casecreation.html'
});


'use strict';

(function () {
    'use strict';

    angular.module('app.toolbar', []).config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider) {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.toolbar').controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $mdSidenav, $translate, $mdToast, userService, appContext, $mdDialog, $document, $location, $scope, $state, $http, localStorageService, $window) {
        var vm = this;
        this.$location = $location;
        vm.app = appContext;
        this.$appContext = appContext;
        this.$mdDialog = $mdDialog;
        this.$document = $document;

        // Data
        $rootScope.global = {
            search: ''
        };

        $scope.currentPage = 'cases';

        $scope.goToPage = function (page) {

            if (page == 'app.clinician.mdt') {
                window.location = "/mdt";
            } else {
                $state.go(page);
            }
        };

        $scope.profileClick = function () {
            $scope.currentPage = '';
        };

        $scope.openNewCase = function () {
            $scope.currentPage = '';
        };

        $scope.openCreateNewOrganization = function () {
            $scope.currentPage = '';
        };

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [{
            'title': 'Viewer',
            'icon': 'icon-play-circle-outline',
            'color': '#4CAF50'
        }, {
            'title': 'Enterprise',
            'icon': 'icon-hospital-building',
            'color': '#FFC107'
        }, {
            'title': 'Admin',
            'icon': 'icon-headset',
            'color': '#F44336'
        }];
        vm.languages = {
            en: {
                'title': 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code': 'en',
                'flag': 'us'
                /*,es: {
                    'title'      : 'Spanish',
                    'translation': 'TOOLBAR.SPANISH',
                    'code'       : 'es',
                    'flag'       : 'es'
                }
                ,tr: {
                    'title'      : 'Turkish',
                    'translation': 'TOOLBAR.TURKISH',
                    'code'       : 'tr',
                    'flag'       : 'tr'
                }*/
            } };

        vm.auth = userService.authentication;

        vm.context = userService.context;
        vm.interfaceMenuData = {};

        // Methods
        vm.$window = $window;
        vm.isAndroidDevice = $window.navigator.userAgent.toLowerCase().indexOf('android') > -1 && $window.navigator.userAgent.toLowerCase().indexOf('mobile') > -1;
        vm.isIOSDevice = /iPad|iPhone|iPod|iPad Simulator|iPhone Simulator|iPod Simulator/.test($window.navigator.userAgent) && !$window.MSStream && $window.navigator.userAgent.toLowerCase().indexOf('mobile') > -1;
        vm.showLoginButton = showLoginButton;
        vm.isIncompleteProfile = isIncompleteProfile;
        vm.toggleSidenav = toggleSidenav;
        vm.getCustomizedOrganizationName = getCustomizedOrganizationName;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.composeDialog = composeDialog;
        vm.checkMenu = checkMenu;
        vm.highlightPropertNavMenu = highlightPropertNavMenu;
        vm.getUnreadMessageCount = getUnreadMessageCount;
        vm.checkRegistrationPage = checkRegistrationPage;
        vm.isAdmin = isAdmin;

        this.userService = userService;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }

        $rootScope.$on('userContextChanged', function () {
            vm.context = userService.context;
            updateInterfaceMenu();
            //console.log(userService.context);
            //console.log(vm.auth);
        });

        $rootScope.$on('activeRoleChanged', function () {
            updateInterfaceMenu();
        });

        function updateInterfaceMenu() {
            vm.interfaceMenuData = {};
            for (var i = 0; i < vm.context.roles.length; i++) {
                var role = vm.context.roles[i];
                setInterfaceMenu(role);
            }

            if (vm.context.currentRole) setInterfaceMenu(vm.context.currentRole);else {
                vm.context.currentRole = vm.context.defaultRole;
                setInterfaceMenu(vm.context.currentRole);
            }
            //setSelectedInterfaceMenu(vm.context.currentRole.name + "@" + vm.context.currentRole.domain);
            //console.log(vm.interfaceMenuData);
        }

        function setInterfaceMenu(role) {

            switch (role.name) {
                case "HCI-Admin":
                    role.interface = 'admin';
                    role.title = 'HCI Admin';
                    role.icon = 'icon-headset';
                    role.color = '#F44336';
                    break;
                case "HCI-Support":
                    role.interface = 'admin';
                    role.title = 'HCI Support';
                    role.icon = 'icon-headset';
                    role.color = '#F44336';
                    break;
                case "HCI-Sales":
                    role.interface = 'admin';
                    role.title = 'HCI Sales';
                    role.icon = 'icon-headset';
                    role.color = '#F44336';
                    break;
                case "OrgOwner":
                    role.interface = 'enterprise';
                    role.title = 'Enterprise';
                    role.icon = 'icon-hospital-building';
                    role.color = '#FFC107';
                    break;
                case "OfficeAdmin":
                    role.interface = 'enterprise';
                    role.title = 'Office Admin';
                    role.icon = 'icon-hospital-building';
                    role.color = '#FFC107';
                    break;
                case "Creator":
                    role.interface = 'clinician';
                    role.title = 'Clinician';
                    role.icon = 'icon-message-video';
                    role.color = '#92298c';
                    break;
                case "Viewer":
                    role.interface = 'viewer';
                    role.title = 'Viewer';
                    role.icon = 'icon-play-circle-outline';
                    role.color = '#4CAF50';
                    break;
            }

            /* Menu Item States
            - Active/Selected
            - Enabled >= 50
            - Disabled >= 20
            - Hidden else
            */

            // a user may be a member of multiple organisations so we must check the name and the domain
            if (role.statusCode >= 50) {
                if (vm.context.currentRole && vm.context.currentRole.name == role.name && vm.context.currentRole.domain == role.domain) {
                    role.menuState = 'active';
                } else role.menuState = 'enabled';
            } else if (role.statusCode >= 20) role.menuState = 'disabled';else role.menuState = 'hidden';

            vm.interfaceMenuData[role.name + "@" + role.domain] = role;
        }

        vm.selectInterface = function (roleName, domain) {
            var role = vm.interfaceMenuData[roleName + "@" + domain];
            if (role.statusCode < 50) return;

            userService.setActiveRole(roleName, domain);
        };

        function showLoginButton() {
            if ($window.location.pathname === '/') {
                return true;
            } else if ($window.location.pathname === '/user/register') {
                return true;
            } else {
                return false;
            }
        }

        function isIncompleteProfile() {
            if ($window.location.pathname === '/user/completeUserProfile') {
                return true;
            }
        }

        function getCustomizedOrganizationName(role) {

            if (!role) {
                return '';
            }

            var customOrganizationName = '';

            var isPersonalProfile = role.orgDisplayName.toUpperCase().includes('PRACTICE OF');
            if (isPersonalProfile) {
                customOrganizationName = 'Personal Account';
            } else {
                customOrganizationName = role.orgDisplayName;
            }

            if (customOrganizationName.length > 18) {
                return customOrganizationName.slice(0, 18).concat('...');
            } else {
                return customOrganizationName;
            };
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status) {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout() {
            // Do logout here..
            userService.logOut();
        }

        function isAdmin() {
            for (var i = 0; i < vm.context.roles.length; i++) {
                if (vm.context.roles[i].name === 'OrgOwner' || vm.context.roles[i].name === 'OrgAdmin') {
                    return true;
                }
            }
            return false;
        }

        function checkMenu() {
            if (this.$location.path() === '/user/casecreation/') return false;else return true;
        }
        function highlightPropertNavMenu() {
            if (this.$location.path() === '/clinician/cases') return 'cases';else if (this.$location.path() === '/clinician/people') return 'contacts';else if (this.$location.path() === '/clinician/mdt') return 'mdt';else if (this.$location.path() == '/clinician/manage-organisation') return 'manageOrganisation';else if (this.$location.path() == '/clinician/manage-users') return 'manageUsers';else if (this.$location.path() == '/clinician/resend-case') return 'resendCase';else return '';
        }

        function getUnreadMessageCount() {
            if (vm.$appContext.clinician.cases)
                //return vm.$appContext.clinician.cases.totalUnreadMessagesOnCurrentPage;
                {
                    var userIdOfCurrentUser = this.context.user.personId;
                    var totalUnreadMessagesOnCurrentPage = 0;
                    var caseList = vm.$appContext.clinician.cases.currentPage;

                    if (typeof caseList !== 'undefined' && typeof caseList.items !== 'undefined') {
                        for (var i = 0; i < caseList.items.length; i++) {
                            var caseData = caseList.items[i];
                            var latestItemId = caseData.latestItemId;

                            var totalItemCount = caseData.totalItemCount;

                            if (caseData && caseData.items) {
                                for (var j = 0; j < caseData.recipients.length; j++) {
                                    if (caseData.recipients[j].id === userIdOfCurrentUser) {
                                        if (latestItemId === caseData.recipients[j].lastItemReadId) ;else {
                                            var difference = totalItemCount - caseData.recipients[j].countItemsRead;

                                            if (difference > 0) {
                                                totalUnreadMessagesOnCurrentPage = totalUnreadMessagesOnCurrentPage + 1;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    return totalUnreadMessagesOnCurrentPage;
                }
        }

        function checkRegistrationPage() {
            if (this.$location.path() === '/user/register') return false;else return true;
        }

        function composeDialog(ev) {
            var newCase = {};
            this.$mdDialog.show({
                locals: {
                    newCase: newCase
                },
                controller: 'ComposeDialogController',
                templateUrl: 'app/main/clinician/cases/dialogs/compose/compose-dialog.html',
                parent: angular.element(this.$document.body),
                //targetEvent: ev,
                clickOutsideToClose: false
            });
        }

        /**
         * Change Language
         */
        function changeLanguage(lang) {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if (lang.code !== 'en') {
                var message = 'Clinivid supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position: 'top right',
                    parent: '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.navigation', []).config(config);

    /** @ngInject */
    function config() {}
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.navigation').controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($rootScope, $scope, $state, userService) {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        vm.auth = userService.authentication;
        vm.context = userService.context;

        $rootScope.$on('userContextChanged', function () {
            vm.context = userService.context;

            // redirect to home page of the default role
            //vm.navToRoleHome(vm.context.defaultRole);

            //console.log(userService.context);
            //console.log(vm.auth);
        });

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded() {
            vm.folded = !vm.folded;
        }

        vm.navToRoleHome = function (role) {

            if (role) vm.context.currentRole = role;

            switch (vm.context.currentRole.name) {
                case "HCI-Admin":
                    //console.log("Going to user default: HCI-Admin");
                    $state.go('app.admin.home');
                    break;
                case "HCI-Support":
                    $state.go('app.admin.support');
                    break;
                case "HCI-Sales":
                    $state.go('app.admin.sales');
                    break;
                case "OrgOwner":
                    $state.go('app.enterprise.home');
                    break;
                case "OfficeAdmin":
                    $state.go('app.enterprise.home');
                    break;
                case "Creator":
                    $state.go('app.creator.home');
                    break;
                case "Viewer":
                    $state.go('app.viewer.home');
                    break;
                default:
                    $state.go('app.welcome'); // fail-safer
            }
        };

        //vm.goHome = function () {
        //    $state.go('app.welcome');
        //}

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function () {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('clinivid').controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope) //, uiGmapGoogleMapApi, uiGmapIsReady)
    {
        //uiGmapIsReady.promise(1).then(function (instances) {
        //    instances.forEach(function (inst) {
        //        var map = inst.map;
        //        var uuid = map.uiGmap_id;
        //        var mapInstanceNumber = inst.instance; // Starts at 1.

        //        //var center = maps.LatLng(-33.880450, 151.200368); // Fishburners

        //        //var map = new google.maps.Map(mapElement, mapOptions);
        //        //console.log("second");

        //        var marker = $scope.GoogleMaps.Marker({
        //            id:uuid,
        //            position: $scope.mapOptions.center,
        //            map: map,
        //            title: 'Clinivid',
        //            icon: '/assets/favicon/favicon-32x32.png'
        //        });

        //        $scope.mapIsReady = true;
        //    });
        //});

        $scope.mapOptions = {

            zoom: 15, // How zoomed in you want the map to start at (always required)
            scrollwheel: false, //set to true to enable mouse scrolling while inside the map area

            // The latitude and longitude to center the map (always required)
            //center: {
            //    latitude: parseFloat(-33.880450),
            //    longitude: parseFloat(151.200368)
            //}, // Fishburners
            //markers: [
            //    {
            //        location: {
            //            latitude: -33.880450,
            //            longitude: 151.200368
            //        },
            //        title: 'Health Care Innovate',
            //        icon: '/assets/favicon/favicon-32x32.png'
            //    }
            //],
            // How you would like to style the map. 
            // This is where you would paste any style found on Snazzy Maps.
            styles: [{
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [{
                    "color": "#d3d3d3"
                }]
            }, {
                "featureType": "transit",
                "stylers": [{
                    "color": "#808080"
                }, {
                    "visibility": "off"
                }]
            }, {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [{
                    "visibility": "on"
                }, {
                    "color": "#b3b3b3"
                }]
            }, {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [{
                    "color": "#ffffff"
                }]
            }, {
                "featureType": "road.local",
                "elementType": "geometry.fill",
                "stylers": [{
                    "visibility": "on"
                }, {
                    "color": "#ffffff"
                }, {
                    "weight": 1.8
                }]
            }, {
                "featureType": "road.local",
                "elementType": "geometry.stroke",
                "stylers": [{
                    "color": "#d7d7d7"
                }]
            }, {
                "featureType": "poi",
                "elementType": "geometry.fill",
                "stylers": [{
                    "visibility": "on"
                }, {
                    "color": "#ebebeb"
                }]
            }, {
                "featureType": "administrative",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#a7a7a7"
                }]
            }, {
                "featureType": "road.arterial",
                "elementType": "geometry.fill",
                "stylers": [{
                    "color": "#ffffff"
                }]
            }, {
                "featureType": "road.arterial",
                "elementType": "geometry.fill",
                "stylers": [{
                    "color": "#ffffff"
                }]
            }, {
                "featureType": "landscape",
                "elementType": "geometry.fill",
                "stylers": [{
                    "visibility": "on"
                }, {
                    "color": "#efefef"
                }]
            }, {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#696969"
                }]
            }, {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "visibility": "on"
                }, {
                    "color": "#737373"
                }]
            }, {
                "featureType": "poi",
                "elementType": "labels.icon",
                "stylers": [{
                    "visibility": "off"
                }]
            }, {
                "featureType": "poi",
                "elementType": "labels",
                "stylers": [{
                    "visibility": "off"
                }]
            }, {
                "featureType": "road.arterial",
                "elementType": "geometry.stroke",
                "stylers": [{
                    "color": "#d6d6d6"
                }]
            }, {
                "featureType": "road",
                "elementType": "labels.icon",
                "stylers": [{
                    "visibility": "off"
                }]
            }, {
                "featureType": "poi",
                "elementType": "geometry.fill",
                "stylers": [{
                    "color": "#dadada"
                }]
            }]
        };
        $scope.markerLocation = {
            latitude: parseFloat(-33.880450),
            longitude: parseFloat(151.200368)
        };
        $scope.mapCenter = {
            latitude: parseFloat(-33.880450),
            longitude: parseFloat(151.200368)
        };
        $scope.marker = {
            id: 'Office',
            title: 'Health Care Innovate',
            icon: '/assets/favicon/favicon-32x32.png'
        };

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event) {
            if (event.targetScope.$id === $scope.$id) {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.core').run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, clinividGenerator, clinividConfig) {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        clinividGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if (clinividConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile()) {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if (msUtils.isMobile()) {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if (browserInfo) {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.core').config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, $translateProvider, clinividConfigProvider) {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // clinivid theme configurations
        clinividConfigProvider.config({
            'disableCustomScrollbars': false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile': true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('clinivid').run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, userService) {
        //$(window).bind(
        //  'touchmove',
        //   function (e) {
        //       e.preventDefault();
        //   }
        //);

        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function () {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function () {
            $timeout(function () {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        userService.fillAuthData();
        if (userService.authentication.isAuth) userService.getUserContext();

        // Cleanup
        $rootScope.$on('$destroy', function () {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('clinivid').config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        /*var $cookies;
         angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);
         // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';
         var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };*/
        // END - Layout Style Switcher

        // State definitions
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'main@': {
                    //templateUrl: layouts[layoutStyle].main,
                    templateUrl: 'app/core/layouts/horizontal-navigation.html',
                    controller: 'MainController as vm'
                },
                'toolbar@app': {
                    //templateUrl: layouts[layoutStyle].toolbar,
                    templateUrl: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                    controller: 'ToolbarController as $ctrl'
                },
                'navigation@app': {
                    //templateUrl: layouts[layoutStyle].navigation,
                    templateUrl: 'app/navigation/layouts/horizontal-navigation/navigation.html',
                    controller: 'NavigationController as $ctrl' /*,
                                                                'quickPanel@app': {
                                                                   templateUrl: 'app/quick-panel/quick-panel.html',
                                                                   controller : 'QuickPanelController as $ctrl'
                                                                }*/
                } }
        }).state('app.welcome', {
            url: '/',
            views: {
                'content@app': {
                    templateUrl: 'app/main/welcome.html',
                    controller: 'MainController as $ctrl'
                }
                /*,
                resolve: {
                    AdminData: function (msApi)
                    {
                        return msApi.resolve('admin@get');
                    }
                }*/
            } }).state('app.support', {
            url: '/support',
            views: {
                'content@app': {
                    templateUrl: 'app/main/support.html',
                    controller: 'MainController as $ctrl'
                }
                /*,
                resolve: {
                    AdminData: function (msApi)
                    {
                        return msApi.resolve('admin@get');
                    }
                }*/
            } }).state('app.about', {
            url: '/about',
            views: {
                'content@app': {
                    templateUrl: 'app/main/content/about.html',
                    controller: 'MainController as $ctrl'
                }
            }
        }).state('app.pricing', {
            url: '/pricing',
            views: {
                'content@app': {
                    templateUrl: 'app/main/content/pricing.html',
                    controller: 'MainController as $ctrl'
                }
            }
        }).state('app.faqs', {
            url: '/faqs',
            views: {
                'content@app': {
                    templateUrl: 'app/main/content/FAQs.html',
                    controller: 'MainController as $ctrl'
                }
            }
        })
        //     .state('app.privacy', {
        //         url: '/privacy',
        //         views: {
        //             'content@app': {
        //                 templateUrl: 'app/main/content/privacy.html',
        //                 controller: 'MainController as $ctrl'
        //             }
        //         }
        //     })
        // .state('app.terms', {
        //     url: '/terms',
        //     views: {
        //         'content@app': {
        //             templateUrl: 'app/main/content/terms.html',
        //             controller: 'MainController as $ctrl'
        //         }
        //     }
        // })
        ;
    }
})();


'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IndexController = function () {
  function IndexController(clinividTheming, userService, $window) {
    'inject';

    _classCallCheck(this, IndexController);

    this.auth = userService.authentication;
    this.context = userService.context;

    this.themes = clinividTheming.themes;

    this.navigator = $window.navigator;
    var ua = this.navigator.userAgent;

    this.isOldBrowser = false;
    this.browserUpdateNotificationText = '';
    this.notificationForIEandEdge = 'This browser is not supported, please switch to Safari , Chrome or FireFox.';

    //Detect IE Browser .
    var msie = ua.indexOf('MSIE ');
    var trident = ua.indexOf('Trident/');
    var edge = ua.indexOf('Edge/');
    if (msie && msie > 0) {
      // IE 10 or older => return version number
      //return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
      this.isOldBrowser = true;
      this.browserUpdateNotificationText = this.notificationForIEandEdge;
    } else if (!this.isOldBrowser && trident && trident > 0) {
      // IE 11 => return version number
      //var rv = ua.indexOf('rv:');
      //return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
      this.isOldBrowser = true;
      this.browserUpdateNotificationText = this.notificationForIEandEdge;
    } else if (!this.isOldBrowser && edge && edge > 0) {
      // Edge (IE 12+) => return version number
      /* show notification for all verions of EDGE
      var version =  parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
      if(version <= 13){this.isOldBrowser = true;}
      */
      this.isOldBrowser = true;
      this.browserUpdateNotificationText = this.notificationForIEandEdge;
    } else if (!this.isOldBrowser) {
      // - logic to detect version and browser type for chrome/safari/firefox
      ua = this.navigator.userAgent;

      var tem,
          M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];

      if ((tem = ua.match(/version\/(\d+)/i)) != null) {
        M.splice(1, 1, tem[1]);
      }

      var browserName = M[0];
      var browserVersion = parseInt(M[1], 10);

      if (browserName === 'Safari' && browserVersion < 11) {
        this.isOldBrowser = true;
      } else if (browserName === 'Firefox' && browserVersion < 45) {
        this.isOldBrowser = true;
      } else if (browserName === 'Chrome' && browserVersion < 48) {
        this.isOldBrowser = true;
      }

      this.browserUpdateNotificationText = 'You are using an outdated browser. Please upgrade your browser to improve your experience.';
    }
  }

  _createClass(IndexController, [{
    key: 'showLowerVersionBrowserWarning',
    value: function showLowerVersionBrowserWarning() {
      return this.isOldBrowser;
    }
  }]);

  return IndexController;
}();

angular.module('clinivid').controller('IndexController', IndexController);


'use strict';

(function () {
    'use strict';

    angular.module('clinivid').factory('appContext', appContextService);

    /** @ngInject */
    function appContextService($filter, $state, $mdDialog, userService) {

        var msecPerMinute = 1000 * 60;
        var msecPerHour = msecPerMinute * 60;
        var msecPerDay = msecPerHour * 24;

        // Put your custom configurations here
        var context = {};

        // app data root for each interface
        context.viewer = {};
        context.clinician = {};
        context.hci = {};

        context.states = ["NSW", "VIC", "QLD", "SA", "WA", "NT", "TAS"];

        /**
        * Converts a day number to a string.
        *
        * @method dayOfWeekAsString
        * @param {Number} dayIndex
        * @return {Number} Returns day as number
        */
        function dayOfWeekAsString(dayIndex) {
            return ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"][dayIndex];
        }

        context.popup = function (title, message, buttonText, redirect) {

            $mdDialog.show({
                locals: {
                    title: title,
                    message: message,
                    buttonText: buttonText
                },
                controller: ['$scope', 'title', 'message', 'buttonText', function ($scope, title, message, buttonText) {
                    $scope.title = title;
                    $scope.message = message;
                    $scope.buttonText = buttonText;
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    };
                }],
                template: '<md-dialog aria-label="Notification">' + '  <md-dialog-content><h1>{{title}}</h1><div><pre>{{message}}</pre></div></md-dialog-content>' + '  <md-dialog-actions>' + '    <md-button ng-click="closeDialog()" class="md-primary">' + buttonText + '    </md-button>' + '  </md-dialog-actions>' + '</md-dialog>',
                parent: angular.element('body'),
                clickOutsideToClose: true
            });

            if (redirect) {
                $state.go(redirect);
            }
        };

        /**
        * Gets a temporal relative simplified time string
        *
        * @param time
        */
        context.getTimeString = function (time) {

            if (!time) {

                return;
            }
            var timeObj = new Date(time);
            var elapsed = Date.now() - timeObj;

            if (elapsed < 20 * msecPerHour) {
                return $filter('date')(timeObj, "h:mm a");
            } else if (elapsed < 6 * msecPerDay) {
                return dayOfWeekAsString(timeObj.getDay()) + " " + $filter('date')(timeObj, "d/M");
            } else {
                return $filter('date')(timeObj, "d MMM yy");
            }
        };

        context.getTimeAndDateOfChat = function (time) {
            var timeObj = new Date(time);
            var timeAndDateOfChat = $filter('date')(timeObj, "h:mm a") + " " + dayOfWeekAsStringModified(timeObj.getDay()) + " " + $filter('date')(timeObj, "d/M");
            return timeAndDateOfChat;
        };

        function dayOfWeekAsStringModified(dayIndex) {
            return ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][dayIndex];
        }

        context.getNameOfMessageOwner = function (selectedCase, chat, currentUserID) {
            if (selectedCase) {
                var recipientName = '';
                if (currentUserID === chat.userId) return 'You';
                selectedCase.recipients.forEach(function (individualRecipient) {
                    if (individualRecipient.id === chat.personId) {
                        recipientName = individualRecipient.displayName;
                    }
                });

                return recipientName;
            }
        };

        context.getDateString = function (date) {
            if (!date) {
                //console.log("Time is undefined!");
                return;
            }
            return $filter('date')(date, "dd/MM/yyyy");
        };

        context.genCaseTitle = function (caseData) {
            if (!caseData) return;

            /* Priorities:
            * 1. Explicity title
            * 2. Ref + shortname
            * 3. DoB + Short name
            * 4. Long name
            * 5. Fallback
            */
            var title = "";

            if (caseData.title) return caseData.title;else if (caseData.patient) {
                // console.log(caseData.patient); - 2 verbose
                if (caseData.patient.ref) title = caseData.patient.ref + userService.getAbbrevName(caseData.patient);
                if (caseData.patient.dob) title = userService.getAbbrevName(caseData.patient) + "  DOB: " + caseData.patient.dob;else title = userService.getLongName(caseData.patient);

                if (title) title = "RE Patient: " + title;
            }
            if (!title) title = "Untitled Chat";

            return title;
        };

        return context;
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('clinivid');
})();


'use strict';

(function () {
    'use strict';

    angular.module('clinivid').config(config);

    /** @ngInject */
    function config(uiGmapGoogleMapApiProvider, AnalyticsProvider, $qProvider) {
        $qProvider.errorOnUnhandledRejections(false);
        // Put your custom configurations here
        uiGmapGoogleMapApiProvider.configure({
            key: 'AIzaSyC2bRGx2HTGH5hEu5MHpeqgHWFSlopdT-8'
            //v: '3.20'//defaults to latest 3.X anyhow
            //libraries: 'weather,geometry,visualization'
        });

        var environmentSpecificAnalyticsID = googleAnalyticsTrackingID;
        AnalyticsProvider.setAccount(environmentSpecificAnalyticsID);
        // AnalyticsProvider.setDomainName('none');
        AnalyticsProvider.setDomainName('app.clinivid.com.au');
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('clinivid').factory('api', apiService);

    /** @ngInject */
    function apiService($resource) {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        //apiBasePath  = 'http://localhost:26264/api/';

        api.addresses = {
            getById: $resource(apiBasePath + 'Addresses/:id', { id: '@id' }),
            getByParentId: $resource(apiBasePath + 'Addresses/ofParent/:id', { id: '@id' })
        };

        api.caseInvites = {
            getById: $resource(apiBasePath + 'CaseInvites/:id', { id: '@id' }),
            getByParentId: $resource(apiBasePath + 'CaseInvites/ofParent/:id', { id: '@id' })
        };

        api.caseItems = {
            getById: $resource(apiBasePath + 'CaseItems/:id', { id: '@id' }),
            getByParentId: $resource(apiBasePath + 'CaseItems/ofParent/:id', { id: '@id' })
        };

        api.cases = {
            add: $resource(apiBasePath + 'Cases/:id', { id: '@id' }),
            getById: $resource(apiBasePath + 'Cases/:id', { id: '@id' }),
            getByParentId: $resource(apiBasePath + 'Cases/ofParent/:id', { id: '@id' })
        };

        api.configItems = {
            getById: $resource(apiBasePath + 'configItems/:id', { id: '@id' }),
            getByParentId: $resource(apiBasePath + 'configItems/ofParent/:id', { id: '@id' })
        };

        api.contacts = {
            getAllContactsWithAvailability: $resource(apiBasePath + 'Contact/PageWithAvailability2'), //$resource(apiBasePath + 'Contact/AllContactsWithAvailability'),
            getPaged: $resource(apiBasePath + 'Contact/PageWithAvailability2'), //$resource(apiBasePath + 'Contact/Page'),
            getGroups: $resource(apiBasePath + 'Contact/GetContactAlias'), //New API to Get all Groups
            getGroupMembers: $resource(apiBasePath + 'Contact/GetContactAliasContactList'), //New API to Get all members in a  Group
            getById: $resource(apiBasePath + 'Contact'),
            getUsersInOrg: $resource(apiBasePath + 'User/GetUsersInOrg'),
            getByParentId: $resource(apiBasePath + 'Contacts/ofParent/:id', { id: '@id' })
        };
        //api.contacts.getContacts = new Promise(
        //    function(resolve, reject) {
        //        $resource(apiBasePath + 'Contact/Page')
        //                resolve(thisPromiseCount);

        //    }
        //);

        api.links = {
            getById: $resource(apiBasePath + 'Links/:id', { id: '@id' }),
            getByParentId: $resource(apiBasePath + 'Links/ofParent/:id', { id: '@id' })
        };

        api.members = {
            getById: $resource(apiBasePath + 'Members/:id', { id: '@id' }),
            getByParentId: $resource(apiBasePath + 'Members/ofParent/:id', { id: '@id' })
        };

        api.organisations = {
            add: $resource(apiBasePath + 'Organisations'),
            getById: $resource(apiBasePath + 'Organisations/:id', { id: '@id' }),
            getByParentId: $resource(apiBasePath + 'Organisations/ofParent/:id', { id: '@id' }),
            searchByName: $resource(apiBasePath + 'Organisations/SearchByName'),
            searchByRegId: $resource(apiBasePath + 'Organisations/SearchByRegId'),
            edit: $resource(apiBasePath + 'Organisations/:id', { id: '@id' }, { 'update': { method: 'PUT' } }),
            invite: $resource(apiBasePath + 'Organisations/Invite')
        };

        api.patients = {
            getById: $resource(apiBasePath + 'Patients/:id', { id: '@id' }),
            getByParentId: $resource(apiBasePath + 'Patients/ofParent/:id', { id: '@id' })
        };

        api.people = {

            getById: $resource(apiBasePath + 'People/:id', { id: '@id' }, {
                update: { method: 'PUT' }
            }),
            searchByName: $resource(apiBasePath + 'People/Invite'),
            connect: $resource(apiBasePath + 'People/Connect?mId=:mid', { mId: '@mid' }),
            getByEmailOrMobile: $resource(apiBasePath + 'People'),
            getByParentId: $resource(apiBasePath + 'People/ofParent/:id', { id: '@id' }),
            addRecipient: $resource(apiBasePath + 'People/Recipient')
        };

        api.clinicians = {
            invite: $resource(apiBasePath + 'Clinicians/Invite'),
            getById: $resource(apiBasePath + 'Clinicians/:id', { id: '@id' }),
            getByParentId: $resource(apiBasePath + 'Clinicians/ofParent/:id', { id: '@id' }),
            searchByName: $resource(apiBasePath + 'Clinicians/SearchByName'),
            confirmAHPRA: $resource(apiBasePath + 'Clinicians/ConfirmAHPRA')
        };

        api.premises = {
            getById: $resource(apiBasePath + 'Premises/:id', { id: '@id' }),
            getByParentId: $resource(apiBasePath + 'Premises/ofParent/:id', { id: '@id' })
        };

        api.settings = {
            getById: $resource(apiBasePath + 'Settings/:id', { id: '@id' }),
            getByParentId: $resource(apiBasePath + 'Settings/ofParent/:id', { id: '@id' })
        };

        api.users = {
            getById: $resource(apiBasePath + 'User/Profile'),
            getByParentId: $resource(apiBasePath + 'Users/ofParent/:id', { id: '@id' })
        };

        api.systemEvents = {
            getById: $resource(apiBasePath + 'SystemEvents/:id', { id: '@id' }),
            getByParentId: $resource(apiBasePath + 'SystemEvents/ofParent/:id', { id: '@id' })
        };

        return api;
    }
})();


'use strict';

(function () {
    'use strict';

    angular.module('app.pages.auth.forgot-password', []).config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.pages_auth_forgot-password', {
            url: '/pages/auth/forgot-password',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as $ctrl'
                },
                'content@app.pages_auth_forgot-password': {
                    template: '<forgot-password></forgot-password>'
                }
            },
            bodyClass: 'forgot-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/forgot-password');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.forgot-password', {
            title: 'Forgot Password',
            state: 'app.pages_auth_forgot-password',
            weight: 5
        });
    }
})();


angular.module("clinivid").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/support.html","<md-whiteframe class=\"md-whiteframe-7dp m-50\" flex-sm=\"45\" flex-gt-sm=\"35\" flex-gt-md=\"25\" layout \nlayout-align=\"center center\"><md-content flex layout-padding><h1>This is the support page</h1><h2>TBC</h2></md-content>\n</md-whiteframe>");
$templateCache.put("app/main/welcome.html","<div id=\"landing\" class=\"page-layout\"><section class=\"hero-fullscreen background_solid\" layout=\"row\" \nlayout-align=\"end end\"><div class=\"container align-center\" id=\"main_content\" layout=\"column\" layout-align=\"end end\">\n<div layout=\"row\" layout-align=\"end center\"><div layout=\"column\" layout-align=\"center end\"><h2 class=\"slogan\">\nCommunicator for Clinicians</h2><h5 class=\"features-title subtitle\">\nShare patient information with other clinicians securely anytime from anywhere.</h5></div></div></div></section></div>");
$templateCache.put("app/user/casecreation.html","<div id=\"forms\" class=\"page-layout simple tabbed off-white-bg\" style=\"background-color: #f8f8f8\"><div class=\"content\" \nflex><div flex-xs=\"\" flex-gt-xs=\"100\" layout=\"column\" style=\"background-color: #f8f8f8\" layout-align=\"center center\">\n<div ng-show=\"!isLoadContactsAndGroupsComplete\"><div layout=\"row\" layout-align=\"center\" style=\"padding-top: 112px\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div class=\"sorryNoARPHA\" \nstyle=\"padding-top: 40px;font-size:20px;padding-bottom:180px\">Please wait while we load your contacts</div></div>\n<md-card style=\"background-color: #ffffff\" \nng-show=\"$ctrl.currentPage === \'CASE_CREATE\' && isLoadContactsAndGroupsComplete\"><md-card-actions layout=\"row\" \nlayout-align=\"start center\" ng-click=\"$ctrl.removeSearchResults()\"><md-card-icon-actions><span \nclass=\"createCaseHeader\">New Chat</span></md-card-icon-actions><md-button class=\"createpageHeaderButtons\" \nng-click=\"$ctrl.convertChipToContact(false)\" ng-disabled=\"!$ctrl.isCaseEligible2Send()\">Save Draft</md-button>\n</md-card-actions><md-divider></md-divider><md-card-content style=\"background-color: #f4f4f4\" \nng-click=\"$ctrl.removeSearchResults()\"><div style=\"display: flex;flex: 1\" ng-click=\"$ctrl.removeSearchResults()\"><aside\n class=\"caseCreateLabels\">Sending as</aside><aside class=\"caseCreatorLabel\" style=\"padding-top:16px\">\n{{$ctrl.sendersDisplayName}}<br><span class=\"clinicianJobTitle\">{{$ctrl.getCurrentRoleDisplay()}} <span \nclass=\"changeProfileButton\" ng-click=\"$ctrl.openProfiles()\" ng-show=\"!$ctrl.stateParams.membershipIdFromContactsPage\" \nstyle=\"cursor:pointer\">Change</span></span></aside></div><div style=\"display: flex;flex: 1;margin-top: 20px\" \nng-click=\"$ctrl.removeSearchResults()\"><aside class=\"caseCreateLabels\">Send to</aside><md-chips \nng-model=\"$ctrl.chipContacts\" md-transform-chip=\"$ctrl.transformChip($chip)\" md-require-match=\"true\" \nstyle=\"width:450px\"><md-autocomplete md-selected-item=\"$ctrl.selectedItemChip\" md-no-cache=\"true\" \nmd-require-match=\"true\" md-search-text=\"$ctrl.searchTextChip\" \nmd-items=\"item in $ctrl.querySearchChip($ctrl.searchTextChip)\" md-item-text=\"item.fullName\" \nplaceholder=\"Enter name...\" md-menu-class=\"autocomplete-custom-template\" md-menu-container-class=\"custom-container\" \nmd-min-length=\"0\" style=\"width:400px\"><md-item-template><span class=\"item-title\"><span>{{item.fullName}} </span></span>\n<span class=\"profession\"><span>{{item.profession}}</span> </span><span class=\"item-metadata\"><span>\n{{item.formattedOrganizationName}}</span></span></md-item-template><md-not-found>No matches found.</md-not-found>\n</md-autocomplete><md-chip-template><span><strong style=\"font-size: 15px;font-weight: bold\">{{$chip.fullName}}</strong>\n</span></md-chip-template><button md-chip-remove=\"\" style=\"margin-right: 9px;margin-top: 7px\">&times;</button>\n</md-chips></div><div style=\"display: flex;flex: 1;margin-top: 20px\"><aside class=\"caseCreateLabels\">Patient</aside>\n<div style=\"display:flex;position: relative\" id=\"patientSearchDiv\"><input type=\"text\" placeholder=\"Search patient...\" \nng-model=\"searchPatientKeyWord\" id=\"patientSearchBox\" \nstyle=\"border-top: solid 1px #eaeaea;border-left: solid 1px #eaeaea;border-bottom: solid 1px #eaeaea;border-top-left-radius: 14px;border-bottom-left-radius: 14px;margin-left: -10px;;width: 225px;height: 30px;background-color: #ffffff;font-family: Roboto;font-size: 16px;font-weight: normal;font-style: normal;font-stretch: normal;line-height: normal;letter-spacing: 0.3px;text-align: left;text-transform: none !important;margin-top: 8px;padding: 10px\" \nng-disabled=\"$ctrl.patientSearchIcon === $ctrl.closeIcon\"><div \nstyle=\"margin-top: 8px;width: 25px;;background-color: #ffffff;height: 30px;border-top: solid 1px #eaeaea;border-right: solid 1px #eaeaea;border-bottom: solid 1px #eaeaea;border-top-right-radius: 14px;border-bottom-right-radius: 14px\">\n<img src=\"{{$ctrl.patientSearchIcon}}\" style=\"margin-top: 4px;padding-right: 4px;width: 22px;height: 22px\" \nng-click=\"$ctrl.toggleSearch()\"></div><button aria-label=\"Create New patient\" \nstyle=\"margin-left: 14px;margin-top: 8px;font-size: 19px;border-radius: 50%;width: 30px;height: 30px;background-color: rgba(255, 255, 255, 0.9);box-shadow: inset 0 -1px 1px 0 rgba(149, 149, 149, 0.5)\" \nng-click=\"$ctrl.openSideNavToAddANewPatient()\"><span style=\"color: #0899ff\">+</span></button></div></div>\n</md-card-content><md-card-content><div style=\"display: flex;flex: 1\" ng-click=\"$ctrl.removeSearchResults()\">\n<md-input-container md-no-float class=\"md-block\" style=\"width:70%\"><input type=\"text\" placeholder=\"Untitled Chat\" \nclass=\"caseTitle\" ng-model=\"$ctrl.caseTitle\"></md-input-container><md-select name=\"priority\" \nng-model=\"$ctrl.casePriority\" class=\"casePriorityCombo\" style=\"margin: 10px 0 26px 18px\"><md-option value=\"20\" \nng-selected=\"$ctrl.casePriority === 20\"><span class=\"casePriorityNormal\"></span><span style=\"padding-left: 10px\">\nPriority - None</span></md-option><md-option value=\"40\" ng-selected=\"$ctrl.casePriority === 40\"><span \nclass=\"casePriorityHigh\"></span><span style=\"padding-left: 10px\">Priority - High</span></md-option><md-option \nvalue=\"50\" ng-selected=\"$ctrl.casePriority === 50\"><span class=\"casePriorityUrgent\"></span><span \nstyle=\"padding-left: 10px\">Priority - Urgent</span></md-option></md-select></div><div layout-align=\"center center\" \nstyle=\"border-radius: 4px; box-shadow: inset 0 1px 3px 0 rgba(184, 184, 184, 0.5);border-bottom:none\" \nng-click=\"$ctrl.removeSearchResults()\"><textarea class=\"caseMessageTextBox\" type=\"text\" \nstyle=\"width:100%;border-bottom:none\" ng-model=\"$ctrl.caseTextMessage\" \nplaceholder=\"Add an optional introductory message\">\n              </textarea></div><div layout-align=\"center center\" \nstyle=\"border: solid 1px #eaeaea;border-top:none;height:48px;border-bottom-left-radius: 4px;border-bottom-right-radius: 4px\" \nng-click=\"$ctrl.removeSearchResults()\"><div style=\"width: 100%\"><div style=\"float: left;position: relative\"><md-button \nclass=\"md-fab\" aria-label=\"Attach Media\" ngf-select=\"$ctrl.uploadFileToCase($file, $invalidFiles)\" \naccept=\"application/pdf,image/*,video/mp4,video/quicktime\" \nstyle=\"width: 3.6rem;height: 2.6rem;background-color: white\"><md-icon md-font-icon=\"icon-paperclip\" \nstyle=\"color:#92298D;cursor:pointer;font-size: 26px\"></md-icon></md-button></div><div \nstyle=\"float: left;position: relative;padding-top: 15px\"><span class=\"fileSize\" style=\"font-size: 12px\">Add media\n</span></div></div></div><br><div layout-align=\"center center\" class=\"caseUploadPanel\" scroll-glue-right \nstyle=\"height:auto\" ng-if=\"$ctrl.draftDownloadableItems.length > 0\"><div layout=\"column\" layout-align=\"center center\">\n<div class=\"flex-container-caseimages\" style=\"align-items: flex-end\"><div \nng-repeat=\"item in $ctrl.draftDownloadableItems\" style=\"background-color: white\"><section layout=\"row\" \nlayout-align=\"end end\"><md-icon md-font-icon=\"icon-close-circle\" ng-click=\"$ctrl.deleteDraftCaseItem(item)\" \nstyle=\"color: #000000;cursor:pointer\"></md-icon><a href=\"{{item.downloadableUrl}}\"><md-icon \nmd-font-icon=\"icon-download\" style=\"color:#92298C;margin-right: 7px;margin-bottom: 4px\"></md-icon></a></section><a \nhref=\"{{item.data}}\" data-lightbox=\"{{item.id}}\"><img ng-src=\"{{item.data}}\" style=\"max-height:70px;max-width:100px\" \nclass=\"userCaseThumbnailStyle\" ng-if=\"$ctrl.isImageType(item.type)\"> </a><a href=\"#\" \nng-click=\"$ctrl.openPDFInPopup(item.data)\"><thumbnail file-type=\"pdf\" source=\"{{item.data}}\" max-height=\"70\" \nmax-width=\"100\" ng-if=\"$ctrl.isPdfType(item.type)\" class=\"userCaseThumbnailStyle\"></thumbnail></a><a href=\"#\" \nng-click=\"$ctrl.openVideoInPopup(item.data)\"><thumbnail file-type=\"video\" source=\"{{item.data}}\" max-height=\"70\" \nmax-width=\"100\" ng-if=\"$ctrl.isVideoType(item.type)\" class=\"userCaseThumbnailStyle\"></thumbnail></a><br><span \nclass=\"fileType\" ng-if=\"item.data.includes(\'mp4\')\">Video File</span> <span class=\"fileType\" \nng-if=\"item.data.includes(\'pdf\')\">PDF File</span> <span class=\"fileType\" ng-if=\"item.data.includes(\'jpg\')\">Image File\n</span></div></div></div></div><div layout-align=\"center center\" class=\"caseUploadPanel\" scroll-glue-right \nstyle=\"height:auto\" ng-hide=\"userFileUploads.length === 0\"><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"flex-container-caseimages\" style=\"align-items: flex-end\"><div ng-repeat=\"userFile in  userFileUploads\" \nstyle=\"background-color: white\"><section layout=\"row\" layout-align=\"end end\"><md-icon md-font-icon=\"icon-close-circle\" \nng-click=\"$ctrl.deleteUpload(userFile)\" style=\"color: #000000;cursor:pointer\"></md-icon></section><img \nng-src=\"{{userFile.src}}\" style=\"max-height:70px;max-width:100px\" class=\"userCaseThumbnailStyle\" \nng-if=\"userFile.type === \'image\'\"><thumbnail file-type=\"pdf\" source=\"{{userFile.src}}\" max-height=\"70\" max-width=\"100\" \nng-if=\"userFile.type === \'pdf\'\" class=\"userCaseThumbnailStyle\"></thumbnail><thumbnail file-type=\"video\" \nsource=\"{{userFile.src}}\" max-height=\"70\" max-width=\"100\" ng-if=\"userFile.type === \'video\'\" \nclass=\"userCaseThumbnailStyle\"></thumbnail><br><span class=\"fileType\">{{$ctrl.getFileType(userFile.file)}}</span><br>\n<span class=\"fileSize\">{{$ctrl.getFileSize(userFile.file.size)}}</span></div></div></div></div></md-card-content>\n<md-divider></md-divider><md-card-actions layout=\"row\" layout-align=\"start center\" \nng-click=\"$ctrl.removeSearchResults()\"><md-card-icon-actions><span class=\"createpageHeaderButtons\" \nng-click=\"$ctrl.deleteCase($ctrl.draftCasePage)\" style=\"cursor:pointer\"><md-icon md-font-icon=\"icon-trash\" \nstyle=\"color:#92298C\"></md-icon>Delete Chat</span></md-card-icon-actions><md-button class=\"md-raised md-accent\" \naria-label=\"Send\" type=\"submit\" style=\"text-transform: none !important;border-radius: 5px\" \nng-click=\"$ctrl.convertChipToContact(true)\" ng-disabled=\"!$ctrl.isCaseEligible2Send()\">Send Chat</md-button>\n</md-card-actions></md-card><md-card style=\"background-color: #ffffff\" \nng-show=\"$ctrl.currentPage === \'CHANGE_PROFILE\'\"><md-card-actions layout=\"row\" layout-align=\"start center\">\n<md-card-icon-actions><span class=\"createCaseHeader\">&nbsp</span></md-card-icon-actions><div \nclass=\"createpageHeaderButtons\" ng-click=\"$ctrl.saveProfileChange()\" style=\"cursor:pointer\">Save</div><div \nclass=\"divider-vertical\"></div><div class=\"createpageHeaderButtons\" ng-click=\"$ctrl.closeProfilePage()\" \nstyle=\"cursor:pointer\">Cancel</div></md-card-actions><md-divider></md-divider><md-card-title><md-card-title-text><span \nclass=\"selectRecipientsHeader\">Choose profile</span><br><div><img src=\"assets/images/info.png\" \nstyle=\"margin-right: 5px\">You can choose a different profile you’re registered as to show as the creator of the chat.\n</div></md-card-title-text></md-card-title><md-card class=\"profileCard\" \nstyle=\"border-radius:8px;width:auto;height:auto\" ng-repeat=\"role in $ctrl.allRoles | filter: $ctrl.filterProfile\" \nng-class=\"{\'ie-selected-profile\' : role.membershipId == $ctrl.selectedRole.membershipId}\" \nng-click=\"$ctrl.changeProfile(role,$index)\" \nng-style=\"role.membershipId == $ctrl.selectedRole.membershipId && { \'background\' :\'#f8f8f8\' ,\'border\': \'solid 2px #99288d\',\'box-shadow\': \'0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)\'} || $index != $ctrl.selectedRoleIndex && { \'background\' :\'#ffffff\'}\">\n<md-card-actions layout=\"row\" layout-align=\"end\" ng-show=\"role.membershipId == $ctrl.selectedRole.membershipId\"><span \nclass=\"selectedProfile\" style=\"text-align: right\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" \naria-label=\"Selected Profile\" style=\"color:#92298C\"></md-icon></span></md-card-actions><div><aside \nclass=\"caseCreatorLabel\">{{$ctrl.context.user.title}} {{$ctrl.context.user.firstname}} {{$ctrl.context.user.lastname}}\n<br><span class=\"clinicianJobTitle\">{{role.title}}</span><br><span \nstyle=\"font-family: Roboto;font-size: 12px;font-weight: normal;font-stretch: normal;line-height: normal;letter-spacing: 0.1px;text-align: left;color: #494949\">\n<span ng-show=\"$ctrl.getStatus(role.membershipId) === \'Available\'\" \nstyle=\"height: 10px; width: 10px;background-color: #01d099;border-radius: 50%;display: inline-block;box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);margin-left: -12px\">\n</span> <span ng-show=\"$ctrl.getStatus(role.membershipId) === \'Unavailable\'\" \nstyle=\"height: 10px; width: 10px;background-color: #808080;border-radius: 50%;display: inline-block;box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);margin-left: -12px\">\n</span> {{$ctrl.getStatus(role.membershipId)}}</span><br><span class=\"organizationName\" style=\"color: #0899ff\">\n{{role.formattedOrganizationName}}</span><br></aside></div><br><br></md-card></md-card><md-sidenav \nclass=\"md-sidenav-right ie-width-fix\" md-component-id=\"addNewPatient\" style=\"background-color: #ffffff\"><div \nstyle=\"display: flex; flex-flow: column; height: 100%\"><div><md-toolbar layout=\"row\"><div class=\"md-toolbar-tools\" \nstyle=\"background-color:#92298C\"><md-button class=\"md-icon-button\" aria-label=\"Close Side Panel\" \nng-click=\"$ctrl.closeSideNavToAddANewPatient()\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#FFFFFF\"></md-icon></md-button></div></md-toolbar></div><div \nstyle=\"min-height: 0; flex: 1; overflow: auto\"><div style=\"margin-left:24px;margin-right:24px\"><div \nclass=\"registerAccountHeader\" style=\"margin-top:30px\">Create a new patient profile</div><div \nstyle=\"margin-top:10px;text-align: justify;margin-bottom:20px\"><span class=\"selectRecipientsBody\">\nEnter details to help identify the patient. Make sure you have the patient’s consent to share these details, otherwise \n<span class=\"changeProfileButton\" style=\"cursor:pointer\" ng-click=\"$ctrl.closeSideNavToAddANewPatient()\">\nskip this step.</span></span></div><md-card style=\"background-color: #ffffff\"><form name=\"patientForm\" novalidate \nautocomplete=\"off\"><div style=\"padding-left:17px\"><md-input-container class=\"flex md-default-theme\"><label \nfor=\"select_55\" class=\"md-placeholder\">Title</label><md-select ng-model=\"$ctrl.patient.title\" \nclass=\"ng-pristine ng-valid md-default-theme ng-empty ng-touched\" tabindex=\"0\" aria-disabled=\"false\" role=\"listbox\" \naria-expanded=\"false\" aria-multiselectable=\"false\" id=\"select_55\" aria-owns=\"select_container_56\" aria-invalid=\"false\" \naria-label=\"Title\"><md-option value=\"Dr\">Dr</md-option><md-option value=\"Mr\">Mr</md-option><md-option value=\"Mrs\">Mrs\n</md-option><md-option value=\"Ms\">Ms</md-option><md-option value=\"Miss\">Miss</md-option><md-option value=\"Master\">\nMaster</md-option><md-option value=\"Prof\">Prof</md-option><md-option value=\"A/Prof\">A/Prof</md-option><md-option \nvalue=\"Other\">Other</md-option></md-select></md-input-container></div><div layout=\"column\" \nstyle=\"padding-right:17px;padding-left:17px\"><md-input-container class=\"flex md-default-theme\"><input type=\"text\" \nname=\"firstname\" ng-model=\"$ctrl.patient.firstName\" ng-maxlength=\"50\" placeholder=\"First Name\" required><div \nclass=\"validation-messages\" ng-messages=\"patientForm.firstName\"><div ng-message=\"required\">First name is required!\n</div></div></md-input-container><md-input-container class=\"flex md-default-theme\"><input type=\"text\" name=\"lastname\" \nng-model=\"$ctrl.patient.lastName\" ng-maxlength=\"50\" placeholder=\"Last Name\" required><div class=\"validation-messages\" \nng-messages=\"patientForm.lastName\"><div ng-message=\"required\">Last name is required!</div></div></md-input-container>\n<md-input-container class=\"flex md-default-theme\"><input type=\"text\" name=\"patientDOB\" ng-model=\"$ctrl.patient.dob\" \nplaceholder=\"Patient D.O.B.\" style=\"width: 325px\" maxlength=\"10\" ng-change=\"$ctrl.validatePatientDOB(patientForm)\"><div\n ng-messages=\"patientForm.patientDOB.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"errorPatientDOBInvalidFormat\">Please enter DOB in DD-MM-YYYY format.</div><div \nng-message=\"invalidDateRange\">\nDate of Birth should be within 120 years of current year and must not exceed current date.</div></div>\n</md-input-container><md-input-container class=\"flex md-default-theme\"><input type=\"text\" name=\"referenceNo\" \nng-model=\"$ctrl.patient.ref\" placeholder=\"My Ref. No.\" ng-maxlength=\"100\" style=\"width: 325px\"><div \nng-messages=\"patientForm.referenceNo.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"maxlength\"><span>\nToo many characters.</span></div></div></md-input-container></div><div class=\"case-button\" layout=\"row\" \nlayout-align=\"center\" style=\"margin-bottom:25px\"><md-button class=\"md-accent md-raised md-hue-1 createCaseButton\" \nng-disabled=\"patientForm.$invalid\" ng-click=\"$ctrl.createPatient()\">Create</md-button></div></form></md-card></div>\n</div></div></md-sidenav></div><md-sidenav class=\"md-sidenav-right ie-width-fix\" \nmd-component-id=\"showAllSearchedPatients\" style=\"background-color: #ffffff\"><div \nstyle=\"display: flex; flex-flow: column; height: 100%\"><div><md-toolbar layout=\"row\"><div class=\"md-toolbar-tools\" \nstyle=\"background-color:#92298C\"><md-button class=\"md-icon-button\" aria-label=\"Close Side Panel\" \nng-click=\"$ctrl.closeAllSearchedPatientsSideNav()\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#FFFFFF\"></md-icon></md-button></div></md-toolbar></div><div \nstyle=\"min-height: 0; flex: 1; overflow: auto\"><md-content style=\"background-color: #ffffff\"><md-card \nstyle=\"background-color: #ffffff;box-shadow: 0px 0px\"><md-card-title><md-card-title-text><input type=\"text\" \nng-model=\"$ctrl.filterPatient\" name=\"search\" placeholder=\"Filter patient\" \nstyle=\"height: 40px;width: 385px;box-sizing: border-box;border: 1px solid #eaeaea;border-radius: 14px;font-family: Roboto;font-size: 16px;font-weight: normal;font-style: normal;font-stretch: normal;line-height: normal;letter-spacing: 0.3px;background-color: white;background-image: url(\'assets/images/search.png\');background-position: right;background-repeat: no-repeat;padding: 12px 20px 12px 16px;background-position: 350px 12px\">\n</md-card-title-text></md-card-title><div ng-repeat=\"patient in $ctrl.patients | filter: $ctrl.filterPatient\">\n<md-card-title><div style=\"display: flex;flex: 1\"><aside><div class=\"container\"><div class=\"round\"><input \ntype=\"checkbox\" id=\"{{$index}}\" ng-click=\"$ctrl.setPatient(patient)\"><label for=\"{{$index}}\"></label></div></div>\n</aside><aside class=\"caseCreatorLabel\" style=\"padding-top:0px;padding-left:23px\">\n{{patient.title}} {{patient.firstname}}, {{patient.lastname}}<br><span class=\"clinicianOrganization\" \nstyle=\"color: #0899ff\">DOB: {{patient.dob}} | MRN: {{patient.ref}}</span></aside></div></md-card-title><md-divider \nng-hide=\"$last\"></md-divider></div></md-card></md-content></div></div></md-sidenav></div></div><style>\nmd-autocomplete-wrap > input[type=\"search\"] {\n    padding: 0px 5px !important;\n  }\n  md-autocomplete#custom-template {\n    width: 200px;\n  }\n  .autocomplete-custom-template li {\n    border-bottom: 1px solid #ccc;\n    height: auto;\n    padding-top: 8px;\n    padding-bottom: 8px;\n    white-space: normal;\n  }\n  .autocomplete-custom-template li:last-child {\n    border-bottom-width: 0;\n  }\n  .autocomplete-custom-template .item-title {\n    font-family: Roboto;\n    font-size: 16px;\n    font-weight: bold;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: 0.3px;\n    text-align: left;\n    color: #494949;\n    display: block;\n  }\n  .autocomplete-custom-template .item-metadata {\n    color: #0899ff;\n    font-size: 13px;\n    font-weight: 500;\n    display: block;\n    line-height: 2;\n  }\n  .autocomplete-custom-template .profession {\n    font-family: Roboto;\n    font-size: 12px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: 2;\n    letter-spacing: 0.1px;\n    text-align: left;\n    color: #494949;\n    display: block;\n  }\n\n  .autocomplete {\n    /*the container must be positioned relative:*/\n    position: relative;\n    display: inline-block;\n  }\n  .autocomplete-items {\n    text-align: center;\n    width: 231px;\n    position: absolute;\n    border: 1px solid #d4d4d4;\n    border-bottom: none;\n    border-top: none;\n    z-index: 99;\n    /*position the autocomplete items to be the same width as the container:*/\n    top: 100%;\n    left: 0;\n    right: 0;\n  }\n\n  .autocomplete-items div {\n    padding: 10px;\n    cursor: pointer;\n    background-color: #fff;\n    border-bottom: 1px solid #d4d4d4;\n  }\n\n  .autocomplete-items div:hover {\n    /*when hovering an item:*/\n    background-color: #e9e9e9;\n  }\n\n  .autocomplete-active {\n    /*when navigating through the items using the arrow keys:*/\n    background-color: DodgerBlue !important;\n    color: #ffffff;\n  }\n  md-sidenav,\n  md-sidenav.md-locked-open,\n  md-sidenav.md-closed.md-locked-open-add-active custom-sidenav {\n    min-width: 0px !important;\n    width: auto !important;\n    max-width: none !important;\n  }\n  @-moz-document url-prefix() {\n    #conversation {\n      max-height: 332px;\n    }\n  }\n\n\n    video[name=videoThumbnail]::-webkit-media-controls {\n      display: none;\n    }\n</style><script>\nfunction feedControllerThePatient(patient){\n    var scope = angular.element(document.getElementById(\'patientSearchDiv\')).scope();\n    scope.$ctrl.patientSugestionClicked(patient);\n  }\n</script>");
$templateCache.put("app/user/createorganisation.html","<div id=\"forms\" class=\"page-layout simple tabbed off-white-bg\"><div class=\"content\" flex><div layout=\"row\" \nlayout-align=\"space-around\" class=\"whiteframedemoDirectiveInterpolation\" style=\"padding:24px\"><div class=\"padded\" \nmd-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px\"><div layout=\"column\" \nstyle=\"margin-top: 30px\"><div layout=\"row\" style=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px;margin:auto\">\nCreate and Add an Organisation</div><div layout=\"row\" \nstyle=\"font-size: 12px;font-family: Roboto;font-style: italic;text-align: center;padding-left: 15px;padding-right: 15px\">\nUse this form to add a new organisation to Clinivid such as an enterprise. You must select or enter a user who will have full ownership of the organisation. If you enter a new user, the system will issue an invitation to that user via email to complete their account registration. The organisation will not be active until the owning user account is fully registered.\n</div><div layout=\"row\" style=\"height: 30px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto;margin-top: 30px\"><h1\n \nstyle=\"font-size: 11px;font-weight: bold;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;width: 104px;margin-top: -7px;margin-left: 43px;padding-left: 10px;background: white\">\nORGANISATION</h1></div><div layout=\"row\" style=\"width:90%;margin:auto\"><div layout=\"column\" \nstyle=\"width:100%;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nDisplay name<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.displayName\" placeholder=\"Display name\"></md-input-container></div><div layout=\"column\" \nstyle=\"width:100%;margin-left:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nFormal name<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.formalName\" placeholder=\"Formal name\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"width:90%;margin:auto;margin-top: 20px\"><div layout=\"column\" style=\"width:100%;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nDescription</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0;margin-top: 7px\">\n<input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.description\" placeholder=\"Description\"></md-input-container></div><div layout=\"column\" \nstyle=\"width:100%;margin-left:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nABN</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0;margin-top: 7px\"><input \ntype=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.abn\" placeholder=\"ABN\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"height: 30px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto;margin-top: 50px\"><h1 \nstyle=\"font-size: 11px;font-weight: bold;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;width: 56px;margin-top: -7px;margin-left: 43px;padding-left: 10px;background: white\">\nOWNER</h1></div><div layout=\"row\" style=\"width:90%;margin:auto\"><div layout=\"column\" \nstyle=\"width:100%;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nTitle</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0;margin-top: 7px\">\n<md-select type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.title\" placeholder=\"Title\"><md-option value=\"Dr\">Dr</md-option><md-option value=\"Mr\">Mr</md-option>\n<md-option value=\"Mrs\">Mrs</md-option><md-option value=\"Ms\">Ms</md-option><md-option value=\"Miss\">Miss</md-option>\n<md-option value=\"Master\">Master</md-option><md-option value=\"Prof\">Prof</md-option><md-option value=\"A/Prof\">A/Prof\n</md-option><md-option value=\"Other\">Other</md-option></md-select></md-input-container></div><div layout=\"column\" \nstyle=\"width:100%;margin-left:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nFirst name<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.firstName\" placeholder=\"First name\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"width:90%;margin:auto;margin-top: 20px\"><div layout=\"column\" style=\"width:100%;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nMiddle name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0;margin-top: 7px\">\n<input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.middleName\" placeholder=\"Middle name\"></md-input-container></div><div layout=\"column\" \nstyle=\"width:100%;margin-left:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nLast name<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0;margin-top: 0px\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.lastName\" placeholder=\"Last name\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"width:90%;margin:auto;margin-top: 20px\"><div layout=\"column\" style=\"width:50%;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nState<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container class=\"md-block\" \nmd-no-float style=\"margin-top:0;margin-bottom: 0\"><md-select type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.state\" placeholder=\"Select State\"><md-option value=\"NSW\">New South Wales (NSW)</md-option><md-option \nvalue=\"VIC\">Victoria (VIC)</md-option><md-option value=\"QLD\">Queensland (QLD)</md-option><md-option value=\"SA\">\nSouth Australia (SA)</md-option><md-option value=\"WA\">Western Australia (WA)</md-option><md-option value=\"TAS\">\nTasmania (TAS)</md-option><md-option value=\"NT\">Northern Territory (NT)</md-option><md-option value=\"ACT\">\nAustralian Capital Territory (ACT)</md-option></md-select></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;width:90%\"><div layout=\"column\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;padding-bottom: 10px;padding-top:20px\">\nRoles</h1><div style=\"display: flex;flex: 1\"><aside><div class=\"container\"><div class=\"round\"><input id=\"roleOrgOwner\" \nvalue=\"true\" type=\"checkbox\" checked=\"true\" ng-disabled=\"true\"><label for=\"roleOrgOwner\" \nstyle=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8;background-color: grey\"></label></div></div>\n</aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nOrganisation owner</aside></div></div></div><div layout=\"row\" style=\"margin:auto;width:90%\"><div \nstyle=\"display: flex;flex: 1;margin-top: 20px\"><aside><div class=\"container\"><div class=\"round\"><input \nid=\"roleOfficeAdmin\" value=\"true\" type=\"checkbox\" ng-model=\"$ctrl.isOfficeAdmin\" ng-click=\"$ctrl.resetDefaultRole()\">\n<label for=\"roleOfficeAdmin\" style=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8\"></label></div>\n</div></aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nOffice Admin</aside></div></div><div layout=\"row\" style=\"margin:auto;width:90%\"><div \nstyle=\"display: flex;flex: 1;margin-top: 20px\"><aside><div class=\"container\"><div class=\"round\"><input \nid=\"roleClinician\" value=\"true\" type=\"checkbox\" ng-model=\"$ctrl.isClinician\" ng-click=\"$ctrl.resetDefaultRole()\"><label\n for=\"roleClinician\" style=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8\"></label></div></div>\n</aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nClinician</aside></div></div><div layout=\"row\" \nstyle=\"height: 30px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto;margin-top: 46px\"><h1 \nstyle=\"font-size: 11px;font-weight: bold;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;width: 70px;margin-top: -7px;margin-left: 43px;padding-left: 10px;background: white\">\nCONTACT</h1></div><div layout=\"row\" style=\"margin:auto;width:90%\"><div layout=\"column\" \nstyle=\"width:50%;margin-left:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nEmail<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container class=\"md-block\" \nmd-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.email\" placeholder=\"Email\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"width:90%;margin:auto;margin-top:20px\"><div layout=\"column\" style=\"width:18%;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;margin-left: 10px\">\nCountry code<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><md-select \nclass=\"ng-pristine ng-valid md-default-theme ng-empty ng-touched\" tabindex=\"0\" aria-disabled=\"false\" role=\"listbox\" \naria-expanded=\"false\" aria-multiselectable=\"false\" placeholder=\"Country Code\" ng-model=\"$ctrl.countryCode\" \naria-owns=\"select_container_56\" aria-invalid=\"false\" aria-label=\"Select country code\"><md-option value=\"AU\" \nselected=\"true\">+61 AUS</md-option><md-option value=\"NZ\">+64 NZ</md-option><md-option value=\"IN\">+91 IND</md-option>\n</md-select></md-input-container></div><div layout=\"column\" style=\"width:28%;margin-left:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nMobile number<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0;padding-top:4px\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.phone\" placeholder=\"Mobile number\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"height: 30px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto;margin-top: 50px\"><h1 \nstyle=\"font-size: 11px;font-weight: bold;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;width: 88px;margin-top: -7px;margin-left: 43px;padding-left: 10px;background: white\">\nPROFESSION</h1></div><div layout=\"row\" style=\"width:90%;margin:auto\"><div layout=\"column\" \nstyle=\"width:50%;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nStaff ID</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.staffID\" placeholder=\"Staff ID\"></md-input-container></div></div><md-radio-group \nng-model=\"$ctrl.isPractitioner\" style=\"margin: auto;width:90%;margin-top:26px\"><span \nstyle=\"font-size: 11px;font-weight: normal;letter-spacing: normal;color: #333333;padding-left: 2px\">\nRegistered Practitioner</span><div \nstyle=\"display: flex;align-items: center;font-size: 14px;margin-top: 10px;width:90%;margin-bottom: 0px\">\n<md-radio-button ng-value=\"true\" class=\"md-primary\" style=\"margin-bottom: 0;font-size: 12px\">Yes</md-radio-button>\n<md-radio-button ng-value=\"false\" class=\"md-primary\" style=\"margin-bottom: 0;margin-left: 30px;font-size: 12px\">No\n</md-radio-button></div></md-radio-group><div layout=\"row\" style=\"width:90%;margin:auto;margin-top:20px\"><div \nlayout=\"column\" style=\"width:50%;margin-right:10px\" ng-if=\"$ctrl.checkPractitioner()\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nProfession</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><md-select \ntype=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.profession\" placeholder=\"Profession\"><md-option \nvalue=\"Aboriginal and Torres Strait Islander Health Practitioner\">Aboriginal and Torres Strait Islander<br>\nHealth Practitioner</md-option><md-option value=\"Chinese Medicine Practitioner\">Chinese Medicine Practitioner\n</md-option><md-option value=\"Chiropractor\">Chiropractor</md-option><md-option value=\"Dental Practitioner\">\nDental Practitioner</md-option><md-option value=\"Medical Practitioner\">Medical Practitioner</md-option><md-option \nvalue=\"Medical Radiation Practitioner\">Medical Radiation Practitioner</md-option><md-option value=\"Midwife\">Midwife\n</md-option><md-option value=\"Nurse\">Nurse</md-option><md-option value=\"Occupational Therapist\">Occupational Therapist\n</md-option><md-option value=\"Optometrist\">Optometrist</md-option><md-option value=\"Osteopath\">Osteopath</md-option>\n<md-option value=\"Paramedic\">Paramedic</md-option><md-option value=\"Pathologist\">Pathologist</md-option><md-option \nvalue=\"Pharmacist\">Pharmacist</md-option><md-option value=\"Physiotherapist\">Physiotherapist</md-option><md-option \nvalue=\"Podiatrist\">Podiatrist</md-option><md-option value=\"Psychologist\">Psychologist</md-option><md-option \nvalue=\"Sonographer\">Sonographer</md-option><md-option value=\"Other\">Other</md-option></md-select></md-input-container>\n</div></div><div layout=\"row\" style=\"width:90%;margin:auto;margin-top:20px;padding-bottom: 40px\" \nng-if=\"$ctrl.checkPractitioner()\"><div layout=\"column\" style=\"width:50%;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nRegistration No.</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.registrationNo\" placeholder=\"Registration Number\"></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"center center\" style=\"margin-bottom: 30px\"><md-button type=\"submit\" \nng-click=\"$ctrl.createOrganization()\" class=\"md-raised md-accent submit-button\" \nstyle=\"border-radius:5px;width:115px;height:40px;font-size: 16px;;text-transform: none !important\">SUBMIT</md-button>\n</div></div></div></div></div></div>");
$templateCache.put("app/user/profile.html","<style>\ntable{\n    width:100%;\n    table-layout: fixed;\n\n  }\n  table tr:hover {\n    background: #f4f4f4;\n  }\n  table tr:hover td {\n    color: #555;\n  }\n  .tbl-header{\n    background-color: rgba(255,255,255,0.3);\n  }\n  .tbl-content{\n    height:300px;\n    overflow-x:auto;\n    margin-top: 0px;\n    border: 1px solid rgba(255,255,255,0.3);\n  }\n  th{\n    padding: 20px 15px;\n    text-align: left;\n    font-weight: 500;\n    font-size: 12px;\n    color: #ffffff;\n    text-transform: uppercase;\n    background: #92298D;\n  }\n  td{\n    padding: 15px;\n    text-align: left;\n    vertical-align:middle;\n    font-weight: 300;\n    font-size: 12px;\n    color: #000;\n    border-bottom: solid 1px rgba(255,255,255,0.1);\n  }\n\n  /* for custom scrollbar for webkit browser*/\n\n  ::-webkit-scrollbar {\n    width: 6px;\n  }\n  ::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);\n  }\n  ::-webkit-scrollbar-thumb {\n    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);\n  }\n\n  md-input-container {\n    padding: 2px;\n  }\n\n  md-radio-button.md-default-theme .md-off, md-radio-button .md-off {\n    border: solid 1px #b8b8b8;\n  }\n\n  md-radio-button.md-default-theme:not([disabled]).md-primary .md-on, md-radio-button:not([disabled]).md-primary .md-on, md-radio-button.md-default-theme:not([disabled]) .md-primary .md-on, md-radio-button:not([disabled]) .md-primary .md-on, md-radio-group.md-default-theme:not([disabled]).md-primary .md-on, md-radio-group:not([disabled]).md-primary .md-on, md-radio-group.md-default-theme:not([disabled]) .md-primary .md-on, md-radio-group:not([disabled]) .md-primary .md-on {\n    background-color: #149eff;\n  }\n\n  md-radio-button.md-default-theme:not([disabled]).md-primary.md-checked .md-off, md-radio-button:not([disabled]).md-primary.md-checked .md-off, md-radio-button.md-default-theme:not([disabled]) .md-primary.md-checked .md-off, md-radio-button:not([disabled]) .md-primary.md-checked .md-off, md-radio-button.md-default-theme:not([disabled]).md-primary .md-checked .md-off, md-radio-button:not([disabled]).md-primary .md-checked .md-off, md-radio-button.md-default-theme:not([disabled]) .md-primary .md-checked .md-off, md-radio-button:not([disabled]) .md-primary .md-checked .md-off, md-radio-group.md-default-theme:not([disabled]).md-primary.md-checked .md-off, md-radio-group:not([disabled]).md-primary.md-checked .md-off, md-radio-group.md-default-theme:not([disabled]) .md-primary.md-checked .md-off, md-radio-group:not([disabled]) .md-primary.md-checked .md-off, md-radio-group.md-default-theme:not([disabled]).md-primary .md-checked .md-off, md-radio-group:not([disabled]).md-primary .md-checked .md-off, md-radio-group.md-default-theme:not([disabled]) .md-primary .md-checked .md-off, md-radio-group:not([disabled]) .md-primary .md-checked .md-off {\n    border-color: #149eff;\n  }\n\n  md-select-menu.md-default-theme md-content md-option[selected], md-select-menu md-content md-option[selected] {\n    color: rgba(8, 153, 255, 0.5);\n  }\n\n  md-select.md-default-theme .md-select-value, md-select .md-select-value {\n    border-bottom: 2px solid rgba(8, 153, 255, 0.5);\n  }\n  md-select.md-default-theme:not([dosabled]):focus .md-select-value,.md-select:not([dosabled]):focus .md-select-value{\n    border-bottom-color: rgba(8, 153, 255, 0.5);\n  }\n\n  input:-webkit-autofill,\n  input:-webkit-autofill:hover,\n  input:-webkit-autofill:focus,\n  input:-webkit-autofill:active  {\n    -webkit-box-shadow: 0 0 0 30px white inset !important;\n  }\n\n  md-select.md-default-theme .md-select-icon, md-select .md-select-icon {\n    color: #149eff;\n  }\n\n  md-autocomplete-wrap > input[type=\"search\"] {\n    padding: 0px 5px !important;\n  }\n  md-autocomplete#custom-template {\n    width: 200px;\n  }\n  .autocomplete-custom-template li {\n    border-bottom: 1px solid #ccc;\n    height: auto;\n    padding-top: 8px;\n    padding-bottom: 8px;\n    white-space: normal;\n  }\n  .autocomplete-custom-template li:last-child {\n    border-bottom-width: 0;\n  }\n  .autocomplete-custom-template .item-title {\n    font-family: Roboto;\n    font-size: 16px;\n    font-weight: bold;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: 0.3px;\n    text-align: left;\n    color: #494949;\n    display: block;\n  }\n  .autocomplete-custom-template .item-metadata {\n    color: #0899ff;\n    font-size: 13px;\n    font-weight: 500;\n    display: block;\n    line-height: 2;\n  }\n  .autocomplete-custom-template .profession {\n    font-family: Roboto;\n    font-size: 12px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: 2;\n    letter-spacing: 0.1px;\n    text-align: left;\n    color: #494949;\n    display: block;\n  }\n</style><div id=\"forms\" class=\"page-layout simple tabbed off-white-bg\"><div class=\"content\" flex><md-tabs \nmd-dynamic-height><md-tab label=\"Your Profile\" md-on-deselect=\"$ctrl.clearAvailability()\"><div class=\"content\" \nlayout=\"column\" ng-show=\"$ctrl.profilePageMode==1\"><md-card-actions layout=\"row\" layout-align=\"end end\">\n<md-card-icon-actions ng-show=\"!selectedContact.isLinked\" ng-if=\"!$ctrl.userService.checkSuperAdmin()\"><div \nlayout=\"column\" layout-align=\"center center\" ng-click=\"$ctrl.openDeletePage()\" style=\"cursor:pointer\"><div \nclass=\"action-icon-circular-div\" style=\"background-color:#92298C\"><md-icon md-font-icon=\"icon-trash\" class=\"icon\" \nstyle=\"color: #FFFFFF;padding-left: 6px;padding-top: 4px\"></md-icon><md-tooltip class=\"hide-xs\"><span>\nDelete your account</span></md-tooltip></div></div></md-card-icon-actions><md-card-icon-actions \nng-show=\"!selectedContact.isLinked\" id=\"editInLinkedContact\" style=\"margin-left: 22px\"><div layout=\"column\" \nlayout-align=\"center center\" ng-click=\"$ctrl.editProfile()\" style=\"cursor:pointer\"><div \nclass=\"action-icon-circular-div\" style=\"background-color:#92298C\"><md-icon md-font-icon=\"icon-pencil\" class=\"icon\" \nstyle=\"color: #FFFFFF;padding-left: 6px;padding-top: 4px\" id=\"editUnlinkedContactIcon\"></md-icon><md-tooltip \nclass=\"hide-xs\"><span>Edit your profile</span></md-tooltip></div></div></md-card-icon-actions><md-card-icon-actions \nng-show=\"$ctrl.context.roles.length > 1\" style=\"margin-left: 22px\" ng-if=\"!$ctrl.userService.checkSuperAdmin()\"><div \nlayout=\"column\" layout-align=\"center center\" ng-click=\"$ctrl.showProfilePage()\" style=\"cursor:pointer\"><div \nclass=\"action-icon-circular-div\" style=\"background-color:#92298C\"><md-icon md-font-icon=\"icon-account-switch\" \nclass=\"icon\" style=\"color: #FFFFFF;padding-left: 6px;padding-top: 6px\"></md-icon><md-tooltip class=\"hide-xs\"><span>\nSwitch your profile</span></md-tooltip></div></div></md-card-icon-actions></md-card-actions><div layout=\"column\" \nlayout-align=\"center center\" style=\"margin-top:19px\"><md-icon md-font-icon=\"icon-account-outline\" class=\"icon\" \nstyle=\"color:#92298C\"></md-icon><span style=\"color: #92298C\"><strong \nng-bind=\"$ctrl.context.currentRole.formattedOrganizationName\"><span \nng-show=\"$ctrl.context.currentRole.formattedOrganizationName\">-</span> {{$ctrl.context.currentRole.name | uppercase}}\n<md-tooltip>Your Current Profile</md-tooltip></strong></span><span ng-show=\"$ctrl.showLockedFields\"><md-card \nstyle=\"background-color: #FFFFA5;border-radius: 7px\"><md-card-actions layout=\"row\" layout-align=\"end end\"><span \nclass=\"closebtn\" ng-click=\"$ctrl.hideUserNotificationForLockedFields()\" \nstyle=\"margin-left: 5px;font-size:17px;cursor:pointer\" aria-hidden=\"false\">×</span></md-card-actions><md-list-item><img\n ng-src=\"/assets/images/info.png\" style=\"margin-top: -1px\"> <span \nstyle=\"margin-left: 8px;font-family: Roboto;font-size: 14px;font-weight: normal;font-style: normal;font-stretch: normal;line-height: normal;letter-spacing: 0.3px;text-align: left;color: #030303\">\n{{$ctrl.lockedFieldTextInfo}} is view only. You can request changes by contacting <a \nhref=\"mailto:support@clinivid.com.au\" class=\"md-default-theme\" style=\"font-weight: bold\">Support&nbsp<md-icon \nmd-font-icon=\"icon-email\" class=\"icon\" style=\"color:#92298C;margin-bottom: 2px\"></md-icon></a>.</span></md-list-item>\n</md-card></span></div><form name=\"editForm\" class=\"md-inline-form\" novalidate><div layout=\"column\" layout-gt-xs=\"row\" \nflex=\"100\"><div class=\"formFieldBox\" layout=\"column\" flex=\"\"><md-input-container \nclass=\"md-default-theme min-height-70\" style=\"margin-left: 34px;margin-right: 34px\"><label>Title</label><input \ntype=\"text\" name=\"title\" ng-model=\"$ctrl.form.person.title\" ng-maxlength=\"50\" ng-disabled=\"$ctrl.profileEditable\">\n</md-input-container><md-input-container style=\"margin-left: 34px\"><label>Lastname</label><input type=\"text\" \nname=\"lastname\" ng-model=\"$ctrl.form.person.lastname\" ng-maxlength=\"50\" disabled=\"disabled\"><md-icon \nmd-font-icon=\"icon-lock\" style=\"color: #92298D\" ng-click=\"$ctrl.showUserNotificationForLockedFieldsLastName()\">\n</md-icon></md-input-container><md-input-container style=\"margin-left: 34px;margin-right: 34px\"><label>Firstname\n</label><input type=\"text\" name=\"firstname\" ng-model=\"$ctrl.form.person.firstname\" ng-maxlength=\"50\" \nng-disabled=\"$ctrl.profileEditable\"></md-input-container><md-input-container \nstyle=\"margin-left: 34px;margin-right: 34px\"><label>Middle Names</label><input type=\"text\" name=\"middlenames\" \nng-model=\"$ctrl.form.person.middleNames\" ng-maxlength=\"100\" ng-disabled=\"$ctrl.profileEditable\"></md-input-container>\n</div><div class=\"formFieldBox\" layout=\"column\" flex><md-input-container><label>Mobile No.</label><md-icon \nmd-font-icon=\"icon-cellphone\" style=\"color: #92298C\"><md-tooltip>{{$ctrl.form.person.mobile}}</md-tooltip></md-icon>\n<input type=\"text\" name=\"mobile\" ng-model=\"$ctrl.form.person.mobile\" ng-maxlength=\"16\" ng-minlength=\"10\" \ndisabled=\"disabled\"><md-icon md-font-icon=\"icon-lock\" style=\"color: #92298C\" \nng-click=\"$ctrl.showUserNotificationForLockedFieldsMobile()\"></md-icon></md-input-container><md-input-container><label>\nEmail</label><md-icon md-font-icon=\"icon-email\" style=\"color: #92298C\"><md-tooltip>{{$ctrl.form.person.email}}\n</md-tooltip></md-icon><input type=\"email\" name=\"email\" ng-model=\"$ctrl.form.person.email\" disabled=\"disabled\"><md-icon\n md-font-icon=\"icon-lock\" style=\"color: #92298C\" ng-click=\"$ctrl.showUserNotificationForLockedFieldsEmail()\"></md-icon>\n</md-input-container><md-input-container style=\"margin-left: 34px;margin-right: 34px\"><label>Registration No.</label>\n<input type=\"text\" name=\"registrationId\" ng-model=\"$ctrl.form.person.registrationId\" pattern=\"[A-Z]{3}[0-9]{7,10}\" \nng-disabled=\"$ctrl.profileEditable\"><div class=\"validation-messages\" ng-messages=\"editForm.registrationId.$error\" \nrole=\"alert\"><div ng-message=\"pattern\"><span>Must be 3 Capital letters followed by 7 to 10 digits</span></div></div>\n</md-input-container><md-input-container style=\"margin-left: 34px;margin-right: 34px\"><md-select name=\"profession\" \nng-model=\"$ctrl.form.person.profession\" placeholder=\"Select Your Profession\" ng-disabled=\"$ctrl.profileEditable\">\n<md-option name=\"profession\" value=\"Aboriginal and Torres Strait Islander Health Practitioner\">\nAboriginal and Torres Strait Islander Health Practitioner</md-option><md-option name=\"profession\" \nvalue=\"Chinese Medicine Practitioner\">Chinese Medicine Practitioner</md-option><md-option name=\"profession\" \nvalue=\"Chiropractor\">Chiropractor</md-option><md-option name=\"profession\" value=\"Dental Practitioner\">\nDental Practitioner</md-option><md-option name=\"profession\" value=\"Medical Practitioner\">Medical Practitioner\n</md-option><md-option name=\"profession\" value=\"Medical Radiation Practitioner\">Medical Radiation Practitioner\n</md-option><md-option name=\"profession\" value=\"Midwife\">Midwife</md-option><md-option name=\"profession\" value=\"Nurse\">\nNurse</md-option><md-option name=\"profession\" value=\"Occupational Therapist\">Occupational Therapist</md-option>\n<md-option name=\"profession\" value=\"Optometrist\">Optometrist</md-option><md-option name=\"profession\" value=\"Osteopath\">\nOsteopath</md-option><md-option name=\"profession\" value=\"Paramedic\">Paramedic</md-option><md-option name=\"profession\" \nvalue=\"Pathologist\">Pathologist</md-option><md-option name=\"profession\" value=\"Pharmacist\">Pharmacist</md-option>\n<md-option name=\"profession\" value=\"Physiotherapist\">Physiotherapist</md-option><md-option name=\"profession\" \nvalue=\"Podiatrist\">Podiatrist</md-option><md-option name=\"profession\" value=\"Psychologist\">Psychologist</md-option>\n<md-option name=\"profession\" value=\"Sonographer\">Sonographer</md-option><md-option name=\"profession\" value=\"Other\">\nOther</md-option></md-select></md-input-container></div></div><div layout=\"column\" layout-align=\"center center\" \nng-show=\"!saveProfileInProcess\"><md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.save()\" \nstyle=\"border-radius: 6px;text-transform: none !important;font-family: Roboto\" ng-disabled=\"$ctrl.profileEditable\">Save\n</md-button></div><div class=\"loadingLoginDiv\" ng-show=\"saveProfileInProcess\" \nstyle=\"border-radius:6px;width:115px;height:40px\"><div class=\"spinner\"></div></div></form></div><div \nng-show=\"$ctrl.profilePageMode==2\"><div id=\"forms\" class=\"page-layout simple tabbed off-white-bg\" \nstyle=\"background-color: #f5f5f5\"><div class=\"content\" flex><div flex-xs=\"\" flex-gt-xs=\"100\" layout=\"column\" \nstyle=\"background-color: #f5f5f5\" layout-align=\"center center\"><md-card \nstyle=\"background-color: #f5f5f5;box-shadow:none\"><md-card-actions layout=\"row\" layout-align=\"start center\">\n<md-card-icon-actions><span class=\"createCaseHeader\" style=\"padding-left: 4px;padding-right:14px\">Change Profile</span>\n</md-card-icon-actions><div class=\"createpageHeaderButtons\" ng-click=\"$ctrl.saveProfileChange()\" \nstyle=\"cursor:pointer\">Save</div><div class=\"divider-vertical\"></div><div class=\"createpageHeaderButtons\" \nng-click=\"$ctrl.closeProfilePage()\" style=\"cursor:pointer;padding-right:6px\">Cancel</div></md-card-actions><md-card \nclass=\"profileCard\" style=\"border-radius:8px;height:auto;width:auto\" \nng-repeat=\"role in $ctrl.context.roles | filter: $ctrl.filterProfiles\" ng-click=\"$ctrl.changeProfile(role,$index)\" \nng-class=\"{\'ie-selected-profile\' : role.membershipId == $ctrl.selectedRole.membershipId}\" \nng-style=\"role.membershipId == $ctrl.selectedRole.membershipId && { \'background\' :\'#f8f8f8\' ,\'border\': \'solid 2px #99288d\',\'box-shadow\': \'0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)\'} || $index != $ctrl.selectedRoleIndex && { \'background\' :\'#ffffff\'}\">\n<md-card-actions layout=\"row\" layout-align=\"end\"><span class=\"selectedProfile\" style=\"text-align: right\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" aria-label=\"Selected Profile\" style=\"color:#92298C\" \nng-show=\"role.membershipId == $ctrl.selectedRole.membershipId\"></md-icon></span></md-card-actions><div><aside \nclass=\"caseCreatorLabel\" style=\"margin-right: 10px\">\n{{$ctrl.context.user.title}} {{$ctrl.context.user.firstname}} {{$ctrl.context.user.lastname}}<br><span \nclass=\"clinicianJobTitle\">{{role.title}}</span><br><span \nstyle=\"font-family: Roboto;font-size: 12px;font-weight: normal;font-stretch: normal;line-height: normal;letter-spacing: 0.1px;text-align: left;color: #494949\">\n<span ng-show=\"$ctrl.getStatus(role.membershipId) === \'Available\'\" \nstyle=\"height: 10px; width: 10px;background-color: #01d099;border-radius: 50%;display: inline-block;box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);margin-left: -12px\">\n</span> <span ng-show=\"$ctrl.getStatus(role.membershipId) === \'Unavailable\'\" \nstyle=\"height: 10px; width: 10px;background-color: #808080;border-radius: 50%;display: inline-block;box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);margin-left: -12px\">\n</span> {{$ctrl.getStatus(role.membershipId)}}</span><br><span class=\"organizationName\">\n{{role.formattedOrganizationName}}</span></aside></div><br><br></md-card></md-card></div></div></div></div><div \nng-show=\"$ctrl.profilePageMode==3\"><div layout=\"row\" layout-align=\"space-around\" \nclass=\"whiteframedemoDirectiveInterpolation\" ng-show=\"$ctrl.showDeletePage === 1\"><div class=\"padded\" md-whiteframe \nflex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.openProfilePage()\"></md-icon></div></div><div layout=\"column\" \nstyle=\"margin-top: 30px;width:100%\"><div layout=\"row\" \nstyle=\"font-size: 26px; font-weight: bold;letter-spacing: 0.4px;font-family: Roboto;margin-top:30px;margin:auto\">\nDeactivate your account</div><div layout=\"row\" \nstyle=\"font-size: 26px; font-weight: bold;letter-spacing: 0.4px;font-family: Roboto;margin-top:30px;margin:auto\">\ninstead of deleting?</div><div layout=\"row\" style=\"margin:auto;padding-top: 20px\"><div layout=\"column\" \nstyle=\"width:80px;margin-right:0px\"><img src=\"/assets/images/hiddeneye.png\" style=\"padding-top: 10px\"></div><div \nlayout=\"column\" style=\"width:220px;margin-left:0px\"><h1 \nstyle=\"font-size: 17px;font-weight: 500;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:26px\">\nDe-activating your account is temporary</h1><h1 \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:10px\">\nYour MDT meetings, Chats will be hidden until you enable it by logging back in.</h1></div></div><div layout=\"row\" \nstyle=\"margin:auto;padding-top: 40px\"><div layout=\"column\" style=\"width:80px;margin-right:0px\"><img \nsrc=\"/assets/images/error96.png\" style=\"width:65px;height:72px;padding-left: 11px;padding-top: 22px\"></div><div \nlayout=\"column\" style=\"width:220px;margin-left:0px\"><h1 \nstyle=\"font-size: 17px;font-weight: 500;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:26px\">\nDeleting your account is permanent</h1><h1 \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:10px\">\nYour MDT meetings, Chats will be permanently deleted.</h1></div></div><div layout=\"row\" layout-align=\"center center\" \nstyle=\"margin-bottom: 10px;margin-top: 30px\"><md-button type=\"submit\" ng-click=\"$ctrl.openDeleteAccountPage()\" \nclass=\"md-raised md-accent submit-button\" \nstyle=\"letter-spacing: 1.2px;font-family: \'Roboto\';border-radius:5px;background-color: #0899ff;padding-left:15px;padding-right: 15px;padding-top: 5px; padding-bottom:5px;font-size: 16px;;text-transform: none !important\">\nDeactivate Account</md-button></div><div layout=\"row\" layout-align=\"center center\" \nstyle=\"margin-bottom: 30px;margin-top: 0px\"><md-button type=\"submit\" ng-click=\"$ctrl.deleteAccountDisclaimer()\" \nclass=\"md-raised md-accent submit-button\" \nstyle=\"color: black;etter-spacing: 0.2px;font-family: \'Roboto\';border-radius:5px;background-color: #ffffff;padding-left:36px;padding-right: 36px;padding-top: 5px; padding-bottom:5px;font-size: 16px;;text-transform: none !important\">\nDelete Account</md-button></div></div></div></div><div layout=\"row\" layout-align=\"space-around\" \nclass=\"whiteframedemoDirectiveInterpolation\" ng-show=\"$ctrl.showDeletePage === 2\"><div class=\"padded\" md-whiteframe \nflex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.go2DeletePage()\"></md-icon></div></div><div layout=\"column\" \nstyle=\"margin-top: 30px;width:100%\"><div layout=\"row\" \nstyle=\"font-size: 26px; font-weight: bold;letter-spacing: 0.4px;font-family: Roboto;margin-top:30px;margin:auto\">\nDelete your account</div><div layout=\"row\" style=\"margin:auto;padding-top: 20px\"><div layout=\"column\"><h1 \nstyle=\"font-size: 17px;font-weight: 500;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:26px\">\nHi, {{$ctrl.userService.getUserDisplayName()}}</h1></div></div><div layout=\"row\" \nstyle=\"margin:auto;padding-bottom: 20px\"><div layout=\"column\" style=\"width: 70%; text-align: center;margin: auto\"><h1 \nstyle=\"font-size: 17px;font-weight: 500;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:26px\">\nOnce the request is received the account will be deleted permanently and you will no longer be able to access your MDT meetings and chats.\n</h1></div></div><div layout=\"row\" style=\"margin:auto;padding-top: 60px\"><div layout=\"column\" \nstyle=\"width: 100%; text-align: center;margin: auto\"><h1 \nstyle=\"font-size: 17px;font-weight: 500;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:26px\">\nWhy are you deleting your account ?</h1></div></div><div layout=\"row\" style=\"margin:auto\"><div layout=\"column\">\n<md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><md-select type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial\" \nng-model=\"$ctrl.reason2Delete\" placeholder=\"Select\"><md-option value=\"Resigned\">Resigned</md-option><md-option \nvalue=\"Other\">Other</md-option></md-select></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;padding-top: 30px\"><div layout=\"column\" style=\"width: 100%; text-align: center;margin: auto\"><h1 \nstyle=\"font-size: 17px;font-weight: 500;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:26px\">\nTo continue, please re-enter your password</h1></div></div><div layout=\"row\" style=\"margin:auto\"><div layout=\"column\">\n<md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"password\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.password2Delete\" placeholder=\"Password\"></md-input-container><div class=\"dontKnowRegistration\" \nstyle=\"margin-right: 44px\"><span ui-sref=\"app.user.forgot-password\" style=\"cursor:pointer;font-weight:normal\">\nForgot Password</span></div></div></div><div layout=\"row\" layout-align=\"center center\" \nstyle=\"margin-bottom: 10px;margin-top: 30px\"><md-button type=\"submit\" ng-click=\"$ctrl.deleteAccount()\" \nclass=\"md-raised md-accent submit-button\" \nstyle=\"letter-spacing: 1.2px;font-family: \'Roboto\';border-radius:5px;background-color: #0899ff;padding-left:15px;padding-right: 15px;padding-top: 5px; padding-bottom:5px;font-size: 16px;;text-transform: none !important\">\nSubmit</md-button></div></div></div></div><div layout=\"row\" layout-align=\"space-around\" \nclass=\"whiteframedemoDirectiveInterpolation\" ng-show=\"$ctrl.showDeletePage === 3\"><div class=\"padded\" md-whiteframe \nflex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.go2DeletePage()\"></md-icon></div></div><div layout=\"column\" \nstyle=\"margin-top: 30px;width:100%\"><div layout=\"row\" \nstyle=\"font-size: 26px; font-weight: bold;letter-spacing: 0.4px;font-family: Roboto;margin-top:30px;margin:auto\">\nTemporarily Deactivate your account</div><div layout=\"row\" style=\"margin:auto;padding-top: 20px\"><div layout=\"column\">\n<h1 \nstyle=\"font-size: 17px;font-weight: 500;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:26px\">\nHi, {{$ctrl.userService.getUserDisplayName()}}</h1></div></div><div layout=\"row\" \nstyle=\"margin:auto;padding-bottom: 20px\"><div layout=\"column\" style=\"width: 70%; text-align: center;margin: auto\"><h1 \nstyle=\"font-size: 17px;font-weight: 500;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:26px\">\nYou can deactivate your account instead of deleting it. This means your account will be hidden until you reactivate it by logging back in.\n</h1></div></div><div layout=\"row\" style=\"margin:auto;padding-top: 60px\"><div layout=\"column\" \nstyle=\"width: 100%; text-align: center;margin: auto\"><h1 \nstyle=\"font-size: 17px;font-weight: 500;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:26px\">\nWhy are you deactivating your account ?</h1></div></div><div layout=\"row\" style=\"margin:auto\"><div layout=\"column\">\n<md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><md-select type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial\" \nng-model=\"$ctrl.reason2Deactivate\" placeholder=\"Select\"><md-option value=\"Resigned\">Long Leave</md-option><md-option \nvalue=\"MDT ceased\">MDT ceased</md-option><md-option value=\"Change roles temporary\">Change roles temporary</md-option>\n<md-option value=\"Other\">Other</md-option></md-select></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;padding-top: 30px\"><div layout=\"column\" style=\"width: 100%; text-align: center;margin: auto\"><h1 \nstyle=\"font-size: 17px;font-weight: 500;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:26px\">\nTo continue, please re-enter your password</h1></div></div><div layout=\"row\" style=\"margin:auto\"><div layout=\"column\">\n<md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"password\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.password2Deactivate\" placeholder=\"Password\"></md-input-container><div class=\"dontKnowRegistration\" \nstyle=\"margin-right: 44px\"><span ui-sref=\"app.user.forgot-password\" style=\"cursor:pointer;font-weight:normal\">\nForgot Password</span></div></div></div><div layout=\"row\" layout-align=\"center center\" \nstyle=\"margin-bottom: 10px;margin-top: 30px\"><md-button type=\"submit\" ng-click=\"$ctrl.deactivateAccount()\" \nclass=\"md-raised md-accent submit-button\" \nstyle=\"letter-spacing: 1.2px;font-family: \'Roboto\';border-radius:5px;background-color: #0899ff;padding-left:15px;padding-right: 15px;padding-top: 5px; padding-bottom:5px;font-size: 16px;;text-transform: none !important\">\nSubmit</md-button></div></div></div></div></div></md-tab><md-tab label=\"Your Availability\" \nga-track-event=\"[\'Button\', \'Click\', \'clicked-to-view-availability\']\" ng-if=\"!$ctrl.userService.checkSuperAdmin()\"><div \nlayout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-calendar-clock\" class=\"icon\" \nstyle=\"color:#92298C\"><md-tooltip>Your Current Profile</md-tooltip></md-icon><span style=\"color: #92298C\"><strong>\nControl when users can message you</strong></span></div><form name=\"availabilityForm\"><md-radio-group \nng-model=\"$ctrl.availabilityMode\"><div layout=\"row\" layout-padding=\"\" layout-wrap=\"\" layout-margin=\"\" \nlayout-align=\"space-around\" class=\"whiteframedemoDirectiveInterpolation\"><div class=\"padded\" md-whiteframe flex=\"100\" \nflex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" style=\"background: #fff\"><md-radio-button \nvalue=\"available\"><strong>Available</strong><br><span>\nContacts can send you cases and messages. &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp</span>\n</md-radio-button></div><div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" \nlayout-align=\"center center\" style=\"background: #fff\"><md-radio-button value=\"unavailableUntil\"><strong>\nUnavailable until</strong><br><span>Contacts cannot send you cases and messages until:</span></md-radio-button>\n<fieldset layout=\"row\" ng-disabled=\"$ctrl.availabilityMode !== \'unavailableUntil\'\" style=\"border:0\"><mdp-time-picker \nname=\"timeFormat\" ng-model=\"$ctrl.unavailableTime\" mdp-format=\"HH:mm A\"></mdp-time-picker></fieldset><fieldset \nlayout=\"row\" style=\"border:0\" ng-disabled=\"$ctrl.availabilityMode !== \'unavailableUntil\'\"><md-datepicker \nng-model=\"$ctrl.unavailableDate\" md-placeholder=\"Enter date\" md-open-on-focus md-min-date=\"$ctrl.minUnavailableDate\" \nmd-max-date=\"$ctrl.maxUnavailableDate\"></md-datepicker></fieldset><span>* max 1 month</span></div><div class=\"padded\" \nmd-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" style=\"background: #fff\">\n<md-radio-button value=\"unavailableDuration\"><strong>Unavailable for duration</strong><br><span>\nContacts cannot send you cases and messages for:</span></md-radio-button><div layout=\"row\"><md-input-container><label>\nDays</label><md-select ng-model=\"$ctrl.day\" ng-disabled=\"$ctrl.availabilityMode !== \'unavailableDuration\'\"><md-option \nng-repeat=\"day in $ctrl.days\" value=\"{{day}}\">{{day}}</md-option></md-select></md-input-container><md-input-container>\n<label>Hours</label><md-select ng-model=\"$ctrl.hour\" ng-disabled=\"$ctrl.availabilityMode !== \'unavailableDuration\'\">\n<md-option ng-repeat=\"hour in $ctrl.hours\" value=\"{{hour}}\">{{hour}}</md-option></md-select></md-input-container>\n<md-input-container><label>Minutes</label><md-select ng-model=\"$ctrl.minute\" \nng-disabled=\"$ctrl.availabilityMode !== \'unavailableDuration\'\"><md-option ng-repeat=\"minute in $ctrl.minutes\" \nvalue=\"{{minute}}\">{{minute}}</md-option></md-select></md-input-container></div></div></div></md-radio-group><div \nlayout=\"column\" layout-align=\"center center\"><md-button class=\"md-raised md-warn\" \nng-click=\"$ctrl.saveAvailabilityChanges()\" style=\"background-color: #92298D;border-radius: 6px\">Save</md-button></div>\n</form></md-tab><md-tab label=\"Manage organisations\" ng-if=\"!$ctrl.userService.checkSuperAdmin()\"><div layout=\"row\" \nlayout-align=\"space-around\" class=\"whiteframedemoDirectiveInterpolation\"><div \nng-include=\"\'app/main/admin/manage-organisation/display-all-organisations.html\'\" \nng-if=\"$ctrl.organizationPage === $ctrl.allOrganisationPage\"></div><div \nng-include=\"\'app/main/admin/manage-organisation/no-organisation.html\'\" \nng-if=\"$ctrl.organizationPage === $ctrl.noOrganisationPage\"></div><div \nng-include=\"\'app/main/admin/manage-organisation/org-info.html\'\" \nng-if=\"$ctrl.organizationPage === $ctrl.organisationInfoPage\"></div><div \nng-include=\"\'app/main/admin/manage-organisation/add-member.html\'\" \nng-if=\"$ctrl.organizationPage ===  $ctrl.addMemberPage\"></div><div \nng-include=\"\'app/main/admin/manage-organisation/invite-member.html\'\" \nng-if=\"$ctrl.organizationPage === $ctrl.inviteMemberPage\"></div><div \nng-include=\"\'app/main/admin/manage-organisation/invite-status.html\'\" \nng-if=\"$ctrl.organizationPage === $ctrl.inviteStatusPage\"></div><div \nng-include=\"\'app/main/admin/manage-organisation/manage-members.html\'\" \nng-if=\"$ctrl.organizationPage === $ctrl.manageMembersPage\"></div><div \nng-include=\"\'app/main/admin/manage-organisation/manage-members-edit.html\'\" \nng-if=\"$ctrl.organizationPage === $ctrl.manageMembersEditPage\"></div><div \nng-include=\"\'app/main/admin/manage-organisation/manage-contacts.html\'\" \nng-if=\"$ctrl.organizationPage === $ctrl.manageContactsPage\"></div><div \nng-include=\"\'app/main/admin/manage-organisation/manage-contacts-edit-contact.html\'\" \nng-if=\"$ctrl.organizationPage === $ctrl.manageContactsEditpage\"></div><div \nng-include=\"\'app/main/admin/manage-organisation/manage-contacts-add-contact.html\'\" \nng-if=\"$ctrl.organizationPage === $ctrl.manageContactsAddPage\"></div><div \nng-include=\"\'app/main/admin/manage-organisation/notifications.html\'\" \nng-if=\"$ctrl.organizationPage === $ctrl.notificationsPage\"></div><div \nng-include=\"\'app/main/admin/manage-organisation/manage-cases.html\'\" \nng-if=\"$ctrl.organizationPage === $ctrl.manageCasesPage\"></div><div \nng-include=\"\'app/main/admin/manage-organisation/activity-status.html\'\" \nng-show=\"$ctrl.organizationPage === $ctrl.activityStatusPage\"></div><div \nng-include=\"\'app/main/admin/manage-organisation/activity-status-details.html\'\" \nng-show=\"$ctrl.organizationPage === $ctrl.activityStatusDetails\"></div></div></md-tab></md-tabs></div></div>");
$templateCache.put("app/user/user.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label \ntranslate=\"QUICKPANEL.TODAY\">TODAY</md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" ms-scroll \nng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label \ntranslate=\"QUICKPANEL.CHAT\">CHAT</md-tab-label><md-tab-body><md-content class=\"chat-tab scrollable\" ms-scroll \nng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" ng-controller=\"ChatTabController as $ctrl\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label translate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</md-tab-label><md-tab-body>\n<md-content class=\"activity-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar\" ui-view=\"toolbar\" \nstyle=\"background-color: #ffffff;height: auto;min-height: auto;max-height: auto\"></md-toolbar><div \nid=\"horizontal-navigation\" class=\"md-whiteframe-1dp\" ui-view=\"navigation\" ng-if=\"$ctrl.auth.isAuth\"></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" \nms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-panel\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"ms-theme-options-panel-button md-primary-bg\" ng-click=\"toggleOptionsPanel()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><div class=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option\"><div \nclass=\"option-title\">Layout Style:</div><md-radio-group layout=\"column\" ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button value=\"verticalNavigation\">Vertical Navigation</md-radio-button>\n<md-radio-button value=\"horizontalNavigation\">Horizontal Navigation</md-radio-button><md-radio-button \nvalue=\"contentOnly\">Content Only</md-radio-button><md-radio-button value=\"contentWithToolbar\">Content with Toolbar\n</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">\nLayout Mode:</div><md-radio-group layout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" \nng-change=\"vm.updateLayoutMode()\"><md-radio-button value=\"boxed\">Boxed</md-radio-button><md-radio-button value=\"wide\">\nWide</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div \nclass=\"option-title\">Color Palette:</div><md-menu-item ng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"theme\">\n<md-button class=\"md-raised theme-button\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"themeName\"><span><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" md-font-icon=\"icon-palette\">\n</md-icon><span>{{themeName}}</span></span></md-button></md-menu-item></div></div></div>");
$templateCache.put("app/main/admin/admin.html","<md-whiteframe class=\"md-whiteframe-7dp m-50 right\" flex-sm=\"45\" flex-gt-sm=\"35\" flex-gt-md=\"25\" layout \nlayout-align=\"center center\"><md-content flex layout-padding><h1>This is the HCI Admin User Interface</h1><h2>TBC</h2>\n</md-content></md-whiteframe>");
$templateCache.put("app/main/clinician/clinician-accept.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page off-white-bg\" layout=\"column\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">Clinicians</span></div><div class=\"title\">Clinician Registration</div></div></div><div \nclass=\"content\" layout=\"column\"><div class=\"md-title\">Accept and Confirm Registration Details</div><div class=\"pb-16\">\nUse this form to accept the invitation from your organisation to register an account. Your account will not be active until you complete this process.\n</div><form name=\"stepper\" ms-stepper ng-submit=\"$ctrl.submitStepper()\" ng-model=\"$ctrl.form.person\" novalidate>\n<ms-stepper-step ng-form=\"nameForm\" step=\"1\" step-title=\"\'Name\'\"><div \nng-include=\"\'app/main/shared/templates/name-form.html\'\"></div></ms-stepper-step><ms-stepper-step \nng-form=\"professionForm\" step=\"2\" step-title=\"\'Profession\'\"><div \nng-include=\"\'app/main/admin/people/profession-form.html\'\"></div></ms-stepper-step><ms-stepper-step ng-form=\"linksForm\" \nstep=\"3\" step-title=\"\'Contact\'\"><div ng-include=\"\'app/main/admin/people/links-form.html\'\"></div></ms-stepper-step>\n<ms-stepper-step ng-form=\"passwordForm\" step=\"4\" step-title=\"\'Login\'\"><div class=\"form-title\">Create your login</div>\n<md-input-container class=\"md-block\"><input type=\"email\" name=\"email\" ng-model=\"$ctrl.form.person.email\" translate \ntranslate-attr-placeholder=\"REGISTER.EMAIL\" aria-label=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" ng-disabled=\"true\" required>\n<div ng-messages=\"passwordForm.email.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.EMAIL_REQUIRED\">Email is required.</span></div><div ng-message=\"pattern\"><span \ntranslate=\"REGISTER.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input\n type=\"password\" name=\"password\" ng-model=\"$ctrl.form.person.password\" aria-label=\"Password\" ng-minlength=\"8\" \nng-maxlength=\"30\" translate translate-attr-placeholder=\"REGISTER.PASSWORD\" ng-disabled=\"$ctrl.form.lock1\" required><div\n ng-messages=\"passwordForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.PASSWORD_REQUIRED\">Password field is required.</span></div><div ng-message=\"maxlength\">\n<span>Too many characters.</span></div><div ng-message=\"minlength\"><span>8 characters minimum.</span></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"password\" name=\"passwordConfirm\" \nng-model=\"$ctrl.form.person.confirmPassword\" aria-label=\"Confirm Password\" translate \ntranslate-attr-placeholder=\"REGISTER.PASSWORD_CONFIRM\" ng-disabled=\"$ctrl.form.lock1\" \nng-pattern=\"($ctrl.form.person.password)\" required><div ng-messages=\"passwordForm.passwordConfirm.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.PASSWORD_CONFIRM_REQUIRED\">\nPassword (Confirm) field is required</span></div><div ng-message=\"pattern\"><span>Passwords do not match</span></div>\n</div></md-input-container></div></ms-stepper-step></form></div></div>");
$templateCache.put("app/main/clinician/clinician.html","<md-whiteframe class=\"md-whiteframe-7dp m-50 right\" flex-sm=\"45\" flex-gt-sm=\"35\" flex-gt-md=\"25\" layout \nlayout-align=\"center center\"><md-content flex layout-padding><h1>This is the Clinician User Interface</h1><h2>TBC</h2>\n</md-content></md-whiteframe>");
$templateCache.put("app/main/clinician/mdt.html","<div class=\"page-layout simple tabbed off-white-bg\" style=\"background-color: #f8f8f8\"><div class=\"content\" flex><div \nflex-gt-xs=\"100\" layout=\"column\" style=\"background-color: #f8f8f8\" layout-align=\"center center\"><md-card \nstyle=\"background-color: #ffffff; padding-bottom: 16px;width:500px\" class=\"ie-contacts\"><div \nclass=\"registerAccountHeader\" layout=\"row\" layout-align=\"center\" style=\"padding-top: 6px;height: 35px\">\nWelcome to Meetings</div><md-divider></md-divider><div class=\"center-mdt\" style=\"margin-top: 100px; height: 40px\">\nInterested in Multidisciplinary Team Meetings?</div><div class=\"center-mdt\">Please contact us at <a \nhref=\"mailto:support@clinivid.com.au\">support@clinivid.com.au</a></div></md-card></div></div></div>");
$templateCache.put("app/main/clinician/people.html","<div id=\"search\" class=\"page-layout simple tabbed\"><div class=\"top-bg md-accent-bg\"></div><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div class=\"header\"><p></p>\n</div><md-content class=\"content\" flex ms-scroll><div class=\"demo-sidenav\"><md-list><md-subheader class=\"md-no-sticky\">\nSearch Results</md-subheader><div ng-repeat=\"org in $ctrl.org.results\" ui-sref=\"app.admin.org.view({id: org.id})\">\n<md-list-item><p><b>{{org.displayName}}</b><br>ABN:{{org.registeredId}}</p></md-list-item><md-divider></md-divider>\n</div></md-list></div></md-content></md-sidenav><div class=\"center\" layout=\"column\" flex><div class=\"header\" \nlayout=\"row\"><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon search-icon\"></md-icon><input class=\"search-input\" ng-model=\"$ctrl.search\" type=\"text\" \nplaceholder=\"Search..\" translate translate-attr-placeholder=\"SEARCH.SEARCH\" flex></div><md-menu \nclass=\"search-settings\" md-position-mode=\"target-right target\"><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Search settings\" translate translate-attr-aria-label=\"SEARCH.SEARCH_SETTINGS\">\n<md-icon md-menu-origin md-menu-align-target md-font-icon=\"icon-cog\" class=\"icon s16\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"$ctrl.dummyFunction()\"><p translate=\"SEARCH.SETTINGS_1\">\nSettings 1</p></md-button></md-menu-item><md-menu-item><md-button ng-click=\"$ctrl.dummyFunction()\"><p \ntranslate=\"SEARCH.SETTINGS_2\">Settings 2</p></md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div>\n<md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"$ctrl.toggleSidenav(\'sidenav\')\" hide-gt-md \naria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><p \nstyle=\"display:inline-block\">Search for a Contact</p></div></div><md-content class=\"content\" flex ms-scroll><div \nclass=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"start start\">\n<div><span class=\"md-title\" translate=\"CLINICIAN.CONTACTS\">Contacts</span> <span class=\"secondary-text\"><span>13</span>\n <span translate=\"CLINICIAN.RESULTS\">Results</span></span></div><div class=\"pager\"><span class=\"secondary-text\"><span \ntranslate=\"CLINICIAN.RESULTS\">Results</span> <span>:</span> </span><span class=\"page-info\"><span>1</span> <span>-\n</span> <span>10</span> <span translate=\"CLINICIAN.OF\">of</span> <span>100</span></span><md-button \nclass=\"md-icon-button\" aria-label=\"previous page\" translate translate-attr-aria-label=\"CLINICIAN.PREVIOUS_PAGE\">\n<md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"md-icon-button\" \naria-label=\"next page\" translate translate-attr-aria-label=\"CLINICIAN.NEXT_PAGE\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div><table class=\"results simple clickable\" \nms-responsive-table><thead><tr><th></th><th translate=\"CLINICIAN.NAME\">Name</th><th translate=\"CLINICIAN.POSITION\">\nPosition</th><th translate=\"CLINICIAN.PHONE\">Phone</th><th translate=\"CLINICIAN.EMAIL\">Email</th></tr></thead><tbody>\n<tr class=\"result-item\" ng-repeat=\"contact in $ctrl.contacts\"><td class=\"text-left avatar-cell\" ng-if=\"contact.avatar\">\n<img class=\"avatar\" alt=\"{{contact.name}}\" ng-src=\"{{contact.avatar}}\"></td><td class=\"text-left avatar-cell\" \nng-if=\"!contact.avatar\"><div class=\"avatar\">{{contact.name[0]}}</div></td><td class=\"name\">{{contact.name}}</td><td \nclass=\"position\">{{contact.position}}</td><td class=\"phone\">{{contact.phone}}</td><td class=\"email\">{{contact.email}}\n</td></tr></tbody></table><div class=\"simple-pagination\"><md-button class=\"pagination-item disabled\" md-no-ink \nng-href=\"#\" aria-label=\"Go to previous page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"pagination-item active\" md-no-ink ng-href=\"#\" \naria-label=\"Go to page 1\"><span>1</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 2\" hide-xs><span>2</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 3\" hide-xs><span>3</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 4\" hide-xs><span>4</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 5\" hide-xs><span>5</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 6\" hide-xs><span>6</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 7\" hide-xs><span>7</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 8\" hide-xs><span>8</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 9\" hide-xs><span>9</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 10\" hide-xs><span>10</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to next page\" translate translate-attr-aria-label=\"CLINICIAN.GO_TO_NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></md-content></div></div></div>");
$templateCache.put("app/main/clinician/settings.html","<md-whiteframe class=\"md-whiteframe-7dp m-50 right\" flex-sm=\"45\" flex-gt-sm=\"35\" flex-gt-md=\"25\" layout \nlayout-align=\"center center\"><md-content flex layout-padding><h1>This is the Clinician settings page</h1><h2>TBC</h2>\n</md-content></md-whiteframe>");
$templateCache.put("app/main/clinician/welcome.html","<md-whiteframe class=\"md-whiteframe-7dp m-50 right\" flex-sm=\"45\" flex-gt-sm=\"35\" flex-gt-md=\"25\" layout \nlayout-align=\"center center\"><md-content flex layout-padding><h1>This is the Clinician welcome page</h1><h2>TBC</h2>\n</md-content></md-whiteframe>");
$templateCache.put("app/main/contacts/contacts.html","<div layout=\"row\" layout-align=\"center center\"><md-input-container md-no-float class=\"md-accent\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input class=\"search-input\" type=\"text\" \nplaceholder=\"Search..\" ng-model=\"$ctrl.searchTerm\" flex></md-input-container><md-button \nclass=\"md-icon-button md-raised md-accent secondary-bg\" ui-sref=\"app.clinician.people.add\" aria-label=\"Add file\" \ntranslate translate-attr-aria-label=\"FM.ADD_FILE\" ga-track-event=\"[\'Button\', \'Click\', \'add-contact-button-clicked\']\" \nng-show=\"$ctrl.showActions\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><md-tooltip><span>Add a contact</span>\n</md-tooltip></md-button></div><div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" \nlayout-xs=\"column\" layout-align-xs=\"start start\"><div><span class=\"md-title\" translate=\"SEARCH.CONTACTS\" \nstyle=\"padding-left: 12px\">Contacts</span> <span class=\"secondary-text\"><span>{{$ctrl.totalItems}}</span> <span \ntranslate=\"SEARCH.RESULTS\">Results</span></span></div><div class=\"pager\"><span class=\"secondary-text\"><span \ntranslate=\"SEARCH.RESULTS\" style=\"padding-left: 12px\">Results</span> <span>:</span> </span><span class=\"page-info\">\n<span>{{$ctrl.skipRows + 1}}</span> <span>-</span> <span>{{$ctrl.lastShownIndex}}</span> <span translate=\"SEARCH.OF\">of\n</span> <span style=\"padding-right: 12px\">{{$ctrl.totalItems}}</span></span><md-button class=\"md-icon-button\" \naria-label=\"previous page\" ng-click=\"$ctrl.gotoPage($ctrl.currentPage - 1)\" translate \ntranslate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\" ng-hide=\"$ctrl.skipRows === 0\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"$ctrl.gotoPage($ctrl.currentPage + 1)\" aria-label=\"next page\" translate \ntranslate-attr-aria-label=\"SEARCH.NEXT_PAGE\" ng-hide=\"$ctrl.lastShownIndex === $ctrl.totalItems\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div><table class=\"results simple clickable\" \nms-responsive-table><thead><tr><th ng-if=\"!$ctrl.showActions\"></th><th></th><th translate=\"SEARCH.LASTNAME\">Lastname\n</th><th translate=\"SEARCH.OTHER_NAMES\">Other names</th><th translate=\"SEARCH.MOBILE\">Mobile</th><th \ntranslate=\"SEARCH.EMAIL\">Email</th><th>Profession</th><th></th><th ng-if=\"$ctrl.showActions\">Actions</th></tr></thead>\n<tbody><tr class=\"result-item\" ng-repeat=\"contact in $ctrl.items | filter: $ctrl.searchTerm\"><td \nng-if=\"!$ctrl.showActions\"><md-checkbox ng-click=\"$ctrl.selectContact({contact: contact})\"></md-checkbox></td><td \nclass=\"text-left avatar-cell\" ng-if=\"contact.avatar\"><img class=\"avatar\" alt=\"{{contact.name}}\" \nng-src=\"{{contact.avatar}}\"></td><td class=\"text-left avatar-cell\" ng-if=\"!contact.avatar\"><img class=\"avatar\" \nalt=\"{{contact.firstname}}\" ng-src=\"assets/images/avatars/profile.jpg\"></td><td class=\"name\">\n{{contact.title}} {{contact.lastname}}</td><td class=\"position\">{{contact.firstname}} {{contact.middleNames}}</td><td \nclass=\"phone\">{{contact.mobile}}</td><td class=\"email\">{{contact.email}}</td><td class=\"profession\">\n{{contact.profession}}</td><td class=\"linked\"><md-icon ng-if=\"contact.isLinked\" md-font-icon=\"icon-link-variant\">\n</md-icon></td><td style=\"white-space:nowrap\" ng-if=\"$ctrl.showActions\"><md-button \nclass=\"md-icon-button md-raised md-accent secondary-bg\" aria-label=\"Previous\" \nng-click=\"$ctrl.createCase({contact: contact})\" style=\"background-color:#92298C\" \nga-track-event=\"[\'Button\', \'Click\', \'create-case-from-contacts\']\"><md-icon md-font-icon=\"icon-folder-plus\"></md-icon>\n<md-tooltip><span>Create Case</span></md-tooltip></md-button><md-button ng-hide=\"contact.isLinked\" \nclass=\"md-icon-button md-raised\" aria-label=\"Previous\" ng-click=\"$ctrl.editContact({contact: contact})\" \nstyle=\"background-color:#92298C\" ga-track-event=\"[\'Button\', \'Click\', \'clicked-to-edit-contact\']\"><md-icon \nmd-font-icon=\"icon-pencil-box-outline\" style=\"color:white;font:bold\"></md-icon><md-tooltip><span>Edit Contact</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button md-raised\" aria-label=\"Previous\" \nng-click=\"$ctrl.deleteContactWithConfirm({contact: contact})\" style=\"background-color:#92298C\" \nga-track-event=\"[\'Button\', \'Click\', \'clicked-to-delete-contact\']\"><md-icon md-font-icon=\"icon-delete\" \nstyle=\"color:white;font:bold\"></md-icon><md-tooltip><span>Delete Contact</span></md-tooltip></md-button></td></tr>\n</tbody></table><div class=\"simple-pagination\"><md-button class=\"pagination-item\" ng-disabled=\"$ctrl.skipRows === 0\" \nmd-no-ink ng-click=\"$ctrl.gotoPage($ctrl.currentPage - 1)\" aria-label=\"Go to previous page\" translate \ntranslate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button>\n<md-button class=\"pagination-item\" ng-repeat=\"page in $ctrl.pageLinks\" ng-class=\"{active: $ctrl.currentPage == page}\" \nmd-no-ink ng-click=\"$ctrl.gotoPage(page)\" aria-label=\"Go to page {{page}}\"><span>{{page}}</span></md-button><md-button \nclass=\"pagination-item\" ng-disabled=\"$ctrl.lastShownIndex === $ctrl.totalItems\" \nng-click=\"$ctrl.gotoPage($ctrl.currentPage + 1)\" aria-label=\"Go to next page\" translate \ntranslate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/content/FAQs.html","<div class=\"page-layout off-white-bg carded fullwidth single-scroll layout-row\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center flex\" flex=\"\"><div class=\"header\"><span class=\"h2 white-fg\">\nFrequently asked questions</span></div><div class=\"content-card\"><div \nclass=\"toolbar layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><span>\nLast update: 13th July 2016</span></div><md-content class=\"content ms-scroll md-default-theme\" ms-scroll=\"\"><div \nclass=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 align-center content_anim27\">\n<div class=\"intro\"><h1>Frequently Asked Questions</h1></div></div></div><div class=\"row align-left content_anim28\"><div\n class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"iconbox content_anim1\"><h3>\nWhy is Clinivid restricted to Australian health providers?</h3><p>\nClinivid is a communication platform specifically designed for clinicians to securely share clinical information, including sensitive health information, with each other to provide better treatment and care to patients. Australian and State based privacy legislation in dealing with this type of information apply fully to registered health practitioners. This is relevant, as Clinivid does not have access to any of the information shared by its users and users are responsible for proper handling of personal and sensitive information.\n</p></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"iconbox content_anim1\"><h3>\nDo I need the patient\'s consent to transmit information about their treatment via Clinivid?</h3><p>\nPatients need to consent to their sensitive health information being shared via Clinivid. It is the responsibility of the clinicians sharing such information to have obtained or be able to rely on sufficient consent from the patient before sharing any personal or sensitive information with other clinicians. This is a requirements for any type of information sharing, whether it is on the phone, in writing or via Clinivid. In general, consent is either obtained at the time when the information is collected from the patient, when they are referred to other clinicians or where the patient requests the health service. For example, if a GP refers a patient for a CT, consent to communicate results back via Clinivid can be obtained from the patient by the GP when referring the patient (download our referral letter template with consent section); or the patient could provide consent when admitted to the radiology practice, as part of the practice\'s admission form. It is always best to have the patient\'s consent in writing, but verbal consent can be sufficient or in some cases, consent may be implied. Health practitioners in Australia are subject to the same consent requirements for any information sharing as part of the treatment and care provided to patients, whether they share information verbally, in writing or via electronic means, including Clinivid. Where a health practitioner is unsure whether they have obtained proper patient consent for the transmission of patient information on Clinivid, they have the option to create and send cases in a de-identified manner, for example referring to a patient as a 24-yers old female with a specific condition, rather than providing the patient\'s name and date of birth.\n</p></div></div></div><div class=\"row align-left content_anim29\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div\n class=\"iconbox content_anim1\"><h3>What type of patient information is transmitted via Clinivid?</h3><p>\nClinivid is designed to allow clinicians to share relevant information to help treat and care for patients. Any patient related information is entered voluntarily by the clinician, which means, a clinician might choose to share de-identified information about a patient case with colleagues, for example to get a second opinion, or they may select to identify the patient through their name and DoB or Case number, with the patient\'s consent. Clinivid does not require any identifiable patient information to be entered, but provides clinicians with the option. Importantly, any personal information that is shared via Clinivid is only accessible to the clinicians involved in that specific case.\n</p></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"iconbox content_anim1\"><h3>\nHow patients can access their information?</h3><p>\nAny patient related information transmitted via Clinivid is entered and controlled by the clinicians involved in the case. That means, that patients who request access to their personal or health information, should direct their request to the relevant clinician involved in their care. Where a patient applies for access directly to Clinivid, the request should be send to privacy@clinivid.com.au. Clinivid will respond to all requests according to its obligations under relevant privacy legislation. Clinivid may refer the patient\'s request to the relevant clinician to facilitate direct access to the information to the patient.\n</p></div></div></div><div class=\"row align-left content_anim29\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div\n class=\"iconbox content_anim1\"><h3>Is Clinivid considered a health record?</h3><p>\nClinicians have the professional obligation to keep proper health records. Information transmitted via the Clinivid platform may be considered to be relevant to be included in a patient\'s health record. It is each clinician\'s own responsibility to ensure that they keep a proper records of relevant information relating to a patient\'s treatment and care. Clinivid stores information about users and cases only as long as it is required for its functions and ensures access to this information for users with an active account. That means for example that where all clinicians involved in a particular case no longer have an active account, the conversations will be deleted from the Clinivid system. Clinicians using Clinivid should ensure appropriate record keeping and if using a non-enterprise version, must not rely on Clinivid to fulfill their record-keeping obligations. On request, Clinivid can be integrated with local patient record systems. Please inquire at info@clinivid.com.au about the options available.\n</p></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"iconbox content_anim1\"><h3>\nCan I link Clinivid cases with local health records using a single unique identifier?</h3><p>\nClinicians who wish to link Clinivid cases to their local health records must obtain explicit patient consent to link the records before doing so.\n</p></div></div></div><div class=\"row align-left content_anim28\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div\n class=\"iconbox content_anim1\"><h3>What type of personal information about patients may be shared via Clinivid?</h3><p>\nIn general, clinicians can decide whether they wish to share clinical information in a de-identified or identified manner. Where they decide to enter and share patient information, it must be relevant, not excessive, accurate and not intrusive. In general, patient information shared may include: the patient\'s name; date of birth, a reference number, results, or imaging. Clinivid does not restrict the type of information clinicians who are involved in the treatment and care of a patient can share. Importantly, any patient information is fully controlled by and only accessible to the clinicians involved in a Clinivid case.\n</p></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"iconbox content_anim1\"><h6></h6><p></p>\n</div></div></div></div><div class=\"ps-scrollbar-x-rail\" style=\"left: 0px; bottom: 3px\"><div class=\"ps-scrollbar-x\" \ntabindex=\"0\" style=\"left: 0px; width: 0px\"></div></div><div class=\"ps-scrollbar-y-rail\" style=\"top: 0px; right: 3px\">\n<div class=\"ps-scrollbar-y\" tabindex=\"0\" style=\"top: 0px; height: 0px\"></div></div></md-content></div></div></div>");
$templateCache.put("app/main/content/about.html","<div id=\"landing\" class=\"page-layout\"><section class=\"hero-fullscreen background_solid\" layout=\"row\" \nlayout-align=\"end end\"><div class=\"container align-center\" id=\"main_content\" layout=\"column\" layout-align=\"end end\">\n<div layout=\"row\" layout-align=\"end center\"><div layout=\"column\" layout-align=\"center end\"><div hide-xs><iframe \nwidth=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/64rpa2uFVAk?rel=0&t=1m14s\" frameborder=\"0\" allowfullscreen>\n</iframe></div><h2 class=\"slogan\">Communicator for Clinicians</h2><h5 class=\"features-title subtitle\">\nShare patient information with other clinicians securely anytime from anywhere.</h5></div></div></div></section>\n<section hide-gt-xs style=\"padding:0px\"><div class=\"videoWrapper\"><iframe width=\"560\" height=\"315\" \nsrc=\"https://www.youtube.com/embed/64rpa2uFVAk?rel=0&t=1m14s\" frameborder=\"0\" allowfullscreen></iframe></div></section>\n<section class=\"subsection white-bg\"><div class=\"container\"><div layout=\"row\" layout-align=\"center center\"><div \nclass=\"\" layout=\"column\"><h3>Available now on iOS.</h3></div><div class=\"\" layout=\"column\"><h3>&nbsp;&nbsp;&nbsp;</h3>\n</div><div layout=\"column\"><a href=\"https://apps.apple.com/us/app/clinivid/id1518793065\" \nstyle=\"display:inline-block;overflow:hidden;background:url(https://linkmaker.itunes.apple.com/images/badges/en-us/badge_appstore-lrg.svg) no-repeat;width:165px;height:40px\">\n</a></div></div></div></section><section id=\"more_info\" class=\"subsection darker_bg align-center off-white-bg\"><div \nclass=\"container\"><div layout=\"column\" layout-gt-sm=\"row\" class=\"feature-row\"><div class=\"\" layout-gt-sm=\"column\" \nflex-gt-sm=\"33\"><div class=\"iconbox content_anim1\"><div data-icon=\"\" class=\"iconbox_icon\"></div><div \nclass=\"iconbox_content\"><md-icon class=\"feature-icon inline\" md-font-icon=\"icon-alarm-check\"></md-icon><h5>\nConvenient and saving time</h5><p>\nIn health, every second counts. Get important information to other clincians instantly and securely with Clinivid.</p>\n<p>\nSend and access cases from any device – mobile, tablet, desktop. It is as simple as messaging, but made for health care. Clinicians love it. Try it yourself for free (link to register)\n</p></div></div></div><div class=\"\" layout-gt-sm=\"column\" flex-gt-sm=\"33\"><div class=\"iconbox content_anim2\"><div \ndata-icon=\"\" class=\"iconbox_icon\"></div><div class=\"iconbox_content\"><md-icon class=\"feature-icon inline\" \nmd-font-icon=\"icon-lock-outline\"></md-icon><h5>Secure and accountable</h5><p>\nClinivid protects sensitive patient information and does not store it on any device. If you loose your phone, the information is safe.\n</p><p>All communication is time stamped and you get notified when someone has read your message or has responded.</p>\n</div></div></div><div class=\"\" layout-gt-sm=\"column\" flex-gt-sm=\"33\"><div class=\"iconbox content_anim3\"><div \ndata-icon=\"\" class=\"iconbox_icon\"></div><div class=\"iconbox_content\"><md-icon class=\"feature-icon inline\" \nmd-font-icon=\"icon-folder-move\"></md-icon><h5>Versatile and seamless</h5><p>\nClinivid is designed for the clinician on the go. Your patient cases go with you whereever you are.</p><p>\nWith our enterprise version, you can share any case conversations with your practice or hospital.</p></div></div></div>\n</div></div></section><section class=\"subsection off-white-bg\"><div class=\"container\"><div layout=\"row\" \nlayout-align=\"center center\"><div class=\"\" layout=\"column\"><h3>Change the way you communicate with other clinicians\n</h3></div></div><div layout=\"row\" layout-align=\"center center\"><div class=\"\" layout=\"column\"><h4>\nTry it now for free&nbsp;</h4></div><div class=\"button\" layout=\"column\"><md-button \nclass=\"md-raised md-accent secondary-bg\" ng-click=\"$ctrl.next(msWizard)\">Sign up</md-button></div><div layout=\"column\">\n<a href=\"https://apps.apple.com/us/app/clinivid/id1518793065\" \nstyle=\"display:inline-block;overflow:hidden;background:url(https://linkmaker.itunes.apple.com/images/badges/en-us/badge_appstore-lrg.svg) no-repeat;width:165px;height:40px\">\n</a></div></div></div></section><section id=\"contact-info\" class=\"section-padding white-bg\"><div \nclass=\"container text-center\"><div layout=\"column\" layout-gt-sm=\"row\"><div class=\"wow fadeIn\" layout-gt-sm=\"column\" \nflex-gt-sm=\"35\" data-wow-delay=\"0.4s\" data-wow-duration=\"2s\"><md-icon class=\"feature-icon\" md-font-icon=\"icon-clock\">\n</md-icon><h5 class=\"features-title\">Office Hours</h5><p>Mon - Fri : 9am to 6pm<br>\nSat : 10am to 2pm (Online support only)</p></div><div class=\"wow fadeIn\" layout-gt-sm=\"column\" flex-gt-sm=\"30\" \ndata-wow-delay=\"0.6s\" data-wow-duration=\"2s\"><md-icon class=\"feature-icon\" md-font-icon=\"icon-headset\"></md-icon><h5 \nclass=\"features-title\">Contact</h5><p class=\"contact-link\"><a href=\"mailto:support@clinivid.com.au\"><md-icon \nclass=\"line-icon\" md-font-icon=\"icon-email\"></md-icon>: support@clinivid.com.au</a><br><a><md-icon class=\"line-icon\" \nmd-font-icon=\"icon-phone\"></md-icon>: +61 (02) 9327 7737</a></p></div><div class=\"wow fadeIn\" layout-gt-sm=\"column\" \nflex-gt-sm=\"35\" data-wow-delay=\"0.2s\" data-wow-duration=\"2s\"><md-icon class=\"feature-icon\" \nmd-font-icon=\"icon-map-marker-radius\"></md-icon><h5 class=\"features-title\">Address</h5><p>608 Harris St,<br>\nUltimo NSW 2007, Australia</p></div></div></div></section><section id=\"map-section\" class=\"white-bg\">\n<ui-gmap-google-map center=\"mapCenter\" zoom=\"mapOptions.zoom\" options=\"mapOptions\" style=\"height:380px\"><ui-gmap-marker\n idkey=\"marker.id\" coords=\"markerLocation\" options=\"marker\"></ui-gmap-marker></ui-gmap-google-map></section><section \nid=\"footer\" class=\"subsection white-bg\"><div class=\"container text-center\"><div class=\"footer-logo mb-25 wow fadeInUp\" \ndata-wow-duration=\"1.5s\"><a class=\"scroll-top\" href=\"#intro\"><img src=\"assets/images/logos/main_logo.png\" \nalt=\"clinivid\"></a></div><p class=\"copyright mb-25\"><a>Health Care Innovate Pty Ltd</a>\n. &copy; 2016 All Rights Reserved.<br><br><a ui-sref=\"app.privacy\">Privacy Policy</a> | <a ui-sref=\"app.terms\">\nTerms of Service</a></p></div></section></div>");
$templateCache.put("app/main/content/pricing.html","<div id=\"landing\" class=\"page-layout\"><section class=\"hero-fullscreen background_solid\" layout=\"row\" \nlayout-align=\"end end\"><div class=\"container align-center\" id=\"main_content\" layout=\"column\" layout-align=\"end end\">\n<div layout=\"row\" layout-align=\"end center\"><div layout=\"column\" layout-align=\"center end\"><div hide-xs><iframe \nwidth=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/64rpa2uFVAk?rel=0&t=1m14s\" frameborder=\"0\" allowfullscreen>\n</iframe></div><h2 class=\"slogan\">Communicator for Clinicians</h2><h5 class=\"features-title subtitle\">\nShare patient information with other clinicians securely anytime from anywhere.</h5></div></div></div></section>\n<section hide-gt-xs style=\"padding:0px\"><div class=\"videoWrapper\"><iframe width=\"560\" height=\"315\" \nsrc=\"https://www.youtube.com/embed/64rpa2uFVAk?rel=0&t=1m14s\" frameborder=\"0\" allowfullscreen></iframe></div></section>\n<section class=\"subsection white-bg\"><div class=\"container\"><div layout=\"row\" layout-align=\"center center\"><div \nclass=\"\" layout=\"column\"><h3>Available now on iOS.</h3></div><div class=\"\" layout=\"column\"><h3>&nbsp;&nbsp;&nbsp;</h3>\n</div><div layout=\"column\"><a href=\"https://apps.apple.com/us/app/clinivid/id1518793065\" \nstyle=\"display:inline-block;overflow:hidden;background:url(https://linkmaker.itunes.apple.com/images/badges/en-us/badge_appstore-lrg.svg) no-repeat;width:165px;height:40px\">\n</a></div></div></div></section><section id=\"more_info\" class=\"subsection darker_bg align-center off-white-bg\"><div \nclass=\"container\"><div layout=\"column\" layout-gt-sm=\"row\" class=\"feature-row\"><div class=\"\" layout-gt-sm=\"column\" \nflex-gt-sm=\"33\"><div class=\"iconbox content_anim1\"><div data-icon=\"\" class=\"iconbox_icon\"></div><div \nclass=\"iconbox_content\"><md-icon class=\"feature-icon inline\" md-font-icon=\"icon-alarm-check\"></md-icon><h5>\nConvenient and saving time</h5><p>\nIn health, every second counts. Get important information to other clincians instantly and securely with Clinivid.</p>\n<p>\nSend and access cases from any device – mobile, tablet, desktop. It is as simple as messaging, but made for health care. Clinicians love it. Try it yourself for free (link to register)\n</p></div></div></div><div class=\"\" layout-gt-sm=\"column\" flex-gt-sm=\"33\"><div class=\"iconbox content_anim2\"><div \ndata-icon=\"\" class=\"iconbox_icon\"></div><div class=\"iconbox_content\"><md-icon class=\"feature-icon inline\" \nmd-font-icon=\"icon-lock-outline\"></md-icon><h5>Secure and accountable</h5><p>\nClinivid protects sensitive patient information and does not store it on any device. If you loose your phone, the information is safe.\n</p><p>All communication is time stamped and you get notified when someone has read your message or has responded.</p>\n</div></div></div><div class=\"\" layout-gt-sm=\"column\" flex-gt-sm=\"33\"><div class=\"iconbox content_anim3\"><div \ndata-icon=\"\" class=\"iconbox_icon\"></div><div class=\"iconbox_content\"><md-icon class=\"feature-icon inline\" \nmd-font-icon=\"icon-folder-move\"></md-icon><h5>Versatile and seamless</h5><p>\nClinivid is designed for the clinician on the go. Your patient cases go with you whereever you are.</p><p>\nWith our enterprise version, you can share any case conversations with your practice or hospital.</p></div></div></div>\n</div></div></section><section class=\"subsection off-white-bg\"><div class=\"container\"><div layout=\"row\" \nlayout-align=\"center center\"><div class=\"\" layout=\"column\"><h3>Change the way you communicate with other clinicians\n</h3></div></div><div layout=\"row\" layout-align=\"center center\"><div class=\"\" layout=\"column\"><h4>\nTry it now for free&nbsp;</h4></div><div class=\"button\" layout=\"column\"><md-button \nclass=\"md-raised md-accent secondary-bg\" ng-click=\"$ctrl.next(msWizard)\">Sign up</md-button></div><div layout=\"column\">\n<a href=\"https://apps.apple.com/us/app/clinivid/id1518793065\" \nstyle=\"display:inline-block;overflow:hidden;background:url(https://linkmaker.itunes.apple.com/images/badges/en-us/badge_appstore-lrg.svg) no-repeat;width:165px;height:40px\">\n</a></div></div></div></section><section id=\"contact-info\" class=\"section-padding white-bg\"><div \nclass=\"container text-center\"><div layout=\"column\" layout-gt-sm=\"row\"><div class=\"wow fadeIn\" layout-gt-sm=\"column\" \nflex-gt-sm=\"35\" data-wow-delay=\"0.4s\" data-wow-duration=\"2s\"><md-icon class=\"feature-icon\" md-font-icon=\"icon-clock\">\n</md-icon><h5 class=\"features-title\">Office Hours</h5><p>Mon - Fri : 9am to 6pm<br>\nSat : 10am to 2pm (Online support only)</p></div><div class=\"wow fadeIn\" layout-gt-sm=\"column\" flex-gt-sm=\"30\" \ndata-wow-delay=\"0.6s\" data-wow-duration=\"2s\"><md-icon class=\"feature-icon\" md-font-icon=\"icon-headset\"></md-icon><h5 \nclass=\"features-title\">Contact</h5><p class=\"contact-link\"><a href=\"mailto:support@clinivid.com.au\"><md-icon \nclass=\"line-icon\" md-font-icon=\"icon-email\"></md-icon>: support@clinivid.com.au</a><br><a><md-icon class=\"line-icon\" \nmd-font-icon=\"icon-phone\"></md-icon>: +61 (02) 9327 7737</a></p></div><div class=\"wow fadeIn\" layout-gt-sm=\"column\" \nflex-gt-sm=\"35\" data-wow-delay=\"0.2s\" data-wow-duration=\"2s\"><md-icon class=\"feature-icon\" \nmd-font-icon=\"icon-map-marker-radius\"></md-icon><h5 class=\"features-title\">Address</h5><p>608 Harris St,<br>\nUltimo NSW 2007, Australia</p></div></div></div></section><section id=\"map-section\" class=\"white-bg\">\n<ui-gmap-google-map center=\"mapCenter\" zoom=\"mapOptions.zoom\" options=\"mapOptions\" style=\"height:380px\"><ui-gmap-marker\n idkey=\"marker.id\" coords=\"markerLocation\" options=\"marker\"></ui-gmap-marker></ui-gmap-google-map></section><section \nid=\"footer\" class=\"subsection white-bg\"><div class=\"container text-center\"><div class=\"footer-logo mb-25 wow fadeInUp\" \ndata-wow-duration=\"1.5s\"><a class=\"scroll-top\" href=\"#intro\"><img src=\"assets/images/logos/main_logo.png\" \nalt=\"clinivid\"></a></div><p class=\"copyright mb-25\"><a>Health Care Innovate Pty Ltd</a>\n. &copy; 2016 All Rights Reserved.<br><br><a ui-sref=\"app.privacy\">Privacy Policy</a> | <a ui-sref=\"app.terms\">\nTerms of Service</a></p></div></section></div>");
$templateCache.put("app/main/enterprise/cases.html","<md-whiteframe class=\"md-whiteframe-7dp m-50 right\" flex-sm=\"45\" flex-gt-sm=\"35\" flex-gt-md=\"25\" layout \nlayout-align=\"center center\"><md-content flex layout-padding><h1>This is the Enterprise Cases page</h1><h2>TBC</h2>\n</md-content></md-whiteframe>");
$templateCache.put("app/main/enterprise/details.html","<md-whiteframe class=\"md-whiteframe-7dp m-50 right\" flex-sm=\"45\" flex-gt-sm=\"35\" flex-gt-md=\"25\" layout \nlayout-align=\"center center\"><md-content flex layout-padding><h1>This is the Enterprise Details page</h1><h2>TBC</h2>\n</md-content></md-whiteframe>");
$templateCache.put("app/main/enterprise/enterprise-accept.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page off-white-bg\" layout=\"column\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">Clinicians</span></div><div class=\"title\">Clinician Registration</div></div></div><div \nclass=\"content\" layout=\"column\"><div class=\"md-title\">Accept and Confirm Registration Details</div><div class=\"pb-16\">\nUse this form to accept the invitation from your organisation to register an account. Your account will not be active until you complete this process.\n</div><form name=\"stepper\" ms-stepper ng-submit=\"$ctrl.submitStepper()\" ng-model=\"$ctrl.form.person\" novalidate>\n<ms-stepper-step ng-form=\"nameForm\" step=\"1\" step-title=\"\'Name\'\"><div \nng-include=\"\'app/main/shared/templates/name-form.html\'\"></div></ms-stepper-step><ms-stepper-step \nng-form=\"professionForm\" step=\"2\" step-title=\"\'Profession\'\"><div \nng-include=\"\'app/main/admin/people/profession-form.html\'\"></div></ms-stepper-step><ms-stepper-step ng-form=\"linksForm\" \nstep=\"3\" step-title=\"\'Contact\'\"><div ng-include=\"\'app/main/admin/people/links-form.html\'\"></div></ms-stepper-step>\n<ms-stepper-step ng-form=\"passwordForm\" step=\"4\" step-title=\"\'Login\'\"><div class=\"form-title\">Create your login</div>\n<md-input-container class=\"md-block\"><input type=\"email\" name=\"email\" ng-model=\"$ctrl.form.person.email\" translate \ntranslate-attr-placeholder=\"REGISTER.EMAIL\" aria-label=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" ng-disabled=\"true\" required>\n<div ng-messages=\"passwordForm.email.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.EMAIL_REQUIRED\">Email is required.</span></div><div ng-message=\"pattern\"><span \ntranslate=\"REGISTER.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input\n type=\"password\" name=\"password\" ng-model=\"$ctrl.form.person.password\" aria-label=\"Password\" ng-minlength=\"8\" \nng-maxlength=\"30\" translate translate-attr-placeholder=\"REGISTER.PASSWORD\" ng-disabled=\"$ctrl.form.lock1\" required><div\n ng-messages=\"passwordForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.PASSWORD_REQUIRED\">Password field is required.</span></div><div ng-message=\"maxlength\">\n<span>Too many characters.</span></div><div ng-message=\"minlength\"><span>8 characters minimum.</span></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"password\" name=\"passwordConfirm\" \nng-model=\"$ctrl.form.person.confirmPassword\" aria-label=\"Confirm Password\" translate \ntranslate-attr-placeholder=\"REGISTER.PASSWORD_CONFIRM\" ng-disabled=\"$ctrl.form.lock1\" \nng-pattern=\"($ctrl.form.person.password)\" required><div ng-messages=\"passwordForm.passwordConfirm.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.PASSWORD_CONFIRM_REQUIRED\">\nPassword (Confirm) field is required</span></div><div ng-message=\"pattern\"><span>Passwords do not match</span></div>\n</div></md-input-container></div></ms-stepper-step></form></div></div>");
$templateCache.put("app/main/enterprise/enterprise.html","<md-whiteframe class=\"md-whiteframe-7dp m-50 right\" flex-sm=\"45\" flex-gt-sm=\"35\" flex-gt-md=\"25\" layout \nlayout-align=\"center center\"><md-content flex layout-padding><h1>This is the Enterprise User Interface</h1><h2>TBC</h2>\n</md-content></md-whiteframe>");
$templateCache.put("app/main/enterprise/people.html","<md-whiteframe class=\"md-whiteframe-7dp m-50 right\" flex-sm=\"45\" flex-gt-sm=\"35\" flex-gt-md=\"25\" layout \nlayout-align=\"center center\"><md-content flex layout-padding><h1>This is the Enterprise People page</h1><h2>TBC</h2>\n</md-content></md-whiteframe>");
$templateCache.put("app/main/viewer/cases.html","<md-whiteframe class=\"md-whiteframe-7dp m-50\" flex-sm=\"45\" flex-gt-sm=\"35\" flex-gt-md=\"25\" layout \nlayout-align=\"center center\"><md-content flex layout-padding><h1>This is the Viewer Case page</h1><h2>TBC</h2>\n</md-content></md-whiteframe>");
$templateCache.put("app/main/viewer/viewer.html","<md-whiteframe class=\"md-whiteframe-7dp m-50 right\" flex-sm=\"45\" flex-gt-sm=\"35\" flex-gt-md=\"25\" layout \nlayout-align=\"center center\"><md-content flex layout-padding><h1>This is the Viewer User Interface</h1><h2>TBC</h2>\n</md-content></md-whiteframe>");
$templateCache.put("app/main/viewer/welcome.html","<header class=\"header\"><nav class=\"navbar\"><div class=\"navbar-brand navbar-brand-center\"><img class=\"brand-logo\" \nsrc=\"./Remark _ Remark Admin Template_files/logo-purple.png\" alt=\"\"></div></nav><section class=\"section section-main\">\n<div class=\"container\"><h2 class=\"section-title\">Stylish Responsive Bootstrap Admin Template</h2><p \nclass=\"section-desc\">It\'s professional comes with terrific UI components, widgets, forms, tables, charts, pages and<br>\napplications. Each one is fully customizable, exceptionally easy to use and carefully.</p></div></section></header>\n<section class=\"section section-layouts\"><div class=\"container\"><h3 class=\"section-title\">Choose one of the demos</h3>\n<p class=\"section-desc\">You can customize it as you want and use it for any kind of App, Startup, Dashboard...</p><ul \nclass=\"blocks-100 blocks-xs-2 blocks-xl-3\"><li><figure class=\"overlay\"><img \nsrc=\"./Remark _ Remark Admin Template_files/center.jpg\" alt=\"Center Layout\"><figcaption class=\"overlay-panel\"><a \nclass=\"btn btn-round btn-dark\" target=\"_blank\" href=\"http://getbootstrapadmin.com/remark/center/index.html\">Classic</a>\n <a class=\"btn btn-round btn-dark\" target=\"_blank\" \nhref=\"http://getbootstrapadmin.com/remark/material/center/index.html\">Material</a></figcaption></figure><div \nclass=\"desc\"><h4>Center Layout <span class=\"new\">New</span></h4><p></p></div></li><li><figure class=\"overlay\"><img \nsrc=\"./Remark _ Remark Admin Template_files/topbar.jpg\" alt=\"Topbar Layout\"><figcaption class=\"overlay-panel\"><a \nclass=\"btn btn-round btn-dark\" target=\"_blank\" href=\"http://getbootstrapadmin.com/remark/topbar/index.html\">Classic</a>\n <a class=\"btn btn-round btn-dark\" target=\"_blank\" \nhref=\"http://getbootstrapadmin.com/remark/material/topbar/index.html\">Material</a></figcaption></figure><div \nclass=\"desc\"><h4>Topbar Layout <span class=\"new\">New</span></h4><p></p></div></li><li><figure class=\"overlay\"><img \nsrc=\"./Remark _ Remark Admin Template_files/iconbar.jpg\" alt=\"Iconbar Layout\"><figcaption class=\"overlay-panel\"><a \nclass=\"btn btn-round btn-dark\" target=\"_blank\" href=\"http://getbootstrapadmin.com/remark/iconbar/index.html\">Classic\n</a> <a class=\"btn btn-round btn-dark\" target=\"_blank\" \nhref=\"http://getbootstrapadmin.com/remark/material/iconbar/index.html\">Material</a></figcaption></figure><div \nclass=\"desc\"><h4>Iconbar Layout <span class=\"new\">New</span></h4><p></p></div></li><li><figure class=\"overlay\"><img \nsrc=\"./Remark _ Remark Admin Template_files/mmenu.jpg\" alt=\"MMenu Layout\"><figcaption class=\"overlay-panel\"><a \nclass=\"btn btn-round btn-dark\" target=\"_blank\" href=\"http://getbootstrapadmin.com/remark/mmenu/index.html\">Classic</a> \n<a class=\"btn btn-round btn-dark\" target=\"_blank\" href=\"http://getbootstrapadmin.com/remark/material/mmenu/index.html\">\nMaterial</a></figcaption></figure><div class=\"desc\"><h4>MMenu Layout <span class=\"new\">New</span></h4><p></p></div>\n</li><li><figure class=\"overlay\"><img src=\"./Remark _ Remark Admin Template_files/topicon.jpg\" alt=\"Topicon Layout\">\n<figcaption class=\"overlay-panel\"><a class=\"btn btn-round btn-dark\" target=\"_blank\" \nhref=\"http://getbootstrapadmin.com/remark/topicon/index.html\">Classic</a> <a class=\"btn btn-round btn-dark\" \ntarget=\"_blank\" href=\"http://getbootstrapadmin.com/remark/material/topicon/index.html\">Material</a></figcaption>\n</figure><div class=\"desc\"><h4>Topicon Layout <span class=\"new\">New</span></h4><p></p></div></li><li><figure \nclass=\"overlay\"><img src=\"./Remark _ Remark Admin Template_files/base.jpg\" alt=\"Basic Layout\"><figcaption \nclass=\"overlay-panel\"><a class=\"btn btn-round btn-dark\" target=\"_blank\" \nhref=\"http://getbootstrapadmin.com/remark/base/index.html\">Classic</a> <a class=\"btn btn-round btn-dark\" \ntarget=\"_blank\" href=\"http://getbootstrapadmin.com/remark/material/base/index.html\">Material</a></figcaption></figure>\n<div class=\"desc\"><h4>Basic Layout</h4><p></p></div></li></ul></div></section><section class=\"section section-feature\">\n<div class=\"container\"><h3 class=\"section-title\">We are the best choice</h3><ul \nclass=\"blocks-100 blocks-xs-2 blocks-xl-3\"><li class=\"iconbox iconbox-left wow fadeInDown\" \nstyle=\"visibility: visible; animation-name: fadeInDown\"><i class=\"icon iconbox-icon wb-mobile\" aria-hidden=\"true\"></i>\n<div class=\"iconbox-content\"><h3 class=\"iconbox-title\">Responsive design</h3><p>\nFully adjust to fit the size of screen, whether its mobile, tablet or desktop.</p></div></li><li \nclass=\"iconbox iconbox-left wow fadeInDown\" data-wow-delay=\"500ms\" \nstyle=\"visibility: visible; animation-delay: 500ms; animation-name: fadeInDown\"><i \nclass=\"icon iconbox-icon wb-extension\" aria-hidden=\"true\"></i><div class=\"iconbox-content\"><h3 class=\"iconbox-title\">\nUI Components</h3><p>It offers a wide choice of elements, full customizable components.</p></div></li><li \nclass=\"iconbox iconbox-left wow fadeInDown\" data-wow-delay=\"600ms\" \nstyle=\"visibility: visible; animation-delay: 600ms; animation-name: fadeInDown\"><i class=\"icon iconbox-icon wb-grid-4\" \naria-hidden=\"true\"></i><div class=\"iconbox-content\"><h3 class=\"iconbox-title\">Application</h3><p>\nThe app is designed to help you save time by developing projects.</p></div></li><li \nclass=\"iconbox iconbox-left wow fadeInDown\" data-wow-delay=\"600ms\" \nstyle=\"visibility: visible; animation-delay: 600ms; animation-name: fadeInDown\"><i class=\"icon iconbox-icon wb-file\" \naria-hidden=\"true\"></i><div class=\"iconbox-content\"><h3 class=\"iconbox-title\">Pre-build pages ready</h3><p>\nWith the choice of pages offered and building websites fast.</p></div></li><li \nclass=\"iconbox iconbox-left wow fadeInDown\" data-wow-delay=\"300ms\" \nstyle=\"visibility: visible; animation-delay: 300ms; animation-name: fadeInDown\"><i class=\"icon iconbox-icon wb-layout\" \naria-hidden=\"true\"></i><div class=\"iconbox-content\"><h3 class=\"iconbox-title\">Dark &amp; Bright Menubar</h3><p>\nLook great against light or dark menu backgrounds.</p></div></li><li class=\"iconbox iconbox-left wow fadeInDown\" \ndata-wow-delay=\"400ms\" style=\"visibility: visible; animation-delay: 400ms; animation-name: fadeInDown\"><i \nclass=\"icon iconbox-icon wb-pencil\" aria-hidden=\"true\"></i><div class=\"iconbox-content\"><h3 class=\"iconbox-title\">\n11 Color Skins</h3><p>Come with 11 color palette and excepttionally easy to switch</p></div></li></ul></div></section>\n<section class=\"section section-cta\"><div class=\"container\"><h3 class=\"section-title\">\nAll of these for the perfect price</h3><span class=\"price\">24$</span><p><a class=\"btn btn-round btn-dark btn-buy\" \nhref=\"http://themeforest.net/item/remark-responsive-bootstrap-admin-template/11989202\" target=\"blank\"><span><i \nclass=\"icon wb-shopping-cart\"></i> PURCHASE NOW</span></a></p></div></section><footer class=\"footer\"><div \nclass=\"container\"><img class=\"footer-logo\" src=\"./Remark _ Remark Admin Template_files/logo-purple.png\" alt=\"\"><p>\nCopyright © 2016 Remark. All Rights Reserved | AmazingSurge Ltd.</p></div></footer>");
$templateCache.put("app/user/auth/SuspendedUser.html","<div class=\"page-layout simple tabbed off-white-bg\" style=\"background-color: #f8f8f8\"><div class=\"content\" flex><div \nflex-gt-xs=\"100\" layout=\"column\" style=\"background-color: #f8f8f8\" layout-align=\"center center\"><md-card \nstyle=\"background-color: #ffffff; padding-bottom: 16px;width:500px;margin: 0; position: absolute;top: 50%;-ms-transform: translateY(-50%);transform: translateY(-50%)\" \nclass=\"ie-contacts\"><div class=\"registerAccountHeader\" layout=\"row\" layout-align=\"center\" \nstyle=\"padding-top: 6px;height: 35px\">Account Suspended</div><md-divider></md-divider><div><div layout=\"row\" \nlayout-align=\"center\" style=\"padding-top: 112px\"><img src=\"assets/images/no-ahpra.png\"></div><div class=\"sorryNoARPHA\" \nstyle=\"padding-top: 10px\">We apologise</div><div class=\"sorryNoARPHAText\">You account has been suspended.</div><div \nlayout=\"row\" layout-align=\"center\"><md-button class=\"md-raised md-accent genericRegistrationPageButton\" \nng-href=\"mailto:support@clinivid.com.au\" aria-label=\"Contact Us\" type=\"submit\" \nstyle=\"margin-top: 20px;padding-top: 2px\">Contact Us</md-button></div><div class=\"iHaveRegistration\"></div></div>\n<md-divider></md-divider><md-card-actions layout=\"row\" layout-align=\"center\"><div class=\"registerAccountFooter\">\nNeed help or have feedback? Contact: <a href=\"mailto:support@clinivid.com.au\">Support&nbsp<md-icon \nmd-font-icon=\"icon-email\" class=\"icon\" style=\"color:#92298C\"></md-icon></a></div></md-card-actions></md-card></div>\n</div></div>");
$templateCache.put("app/user/auth/completeUserProfile.html","<div class=\"page-layout simple tabbed off-white-bg\" style=\"background-color: #f8f8f8\"><div class=\"content\" flex><div \nflex-gt-xs=\"100\" layout=\"column\" style=\"background-color: #f8f8f8\" layout-align=\"center center\"><md-card \nstyle=\"background-color: #ffffff; padding-bottom: 16px;width:500px;margin: 0; position: absolute;top: 50%;-ms-transform: translateY(-50%);transform: translateY(-50%)\" \nclass=\"ie-contacts\"><div class=\"registerAccountHeader\" layout=\"row\" layout-align=\"center\" \nstyle=\"padding-top: 6px;height: 35px\">Complete your profile</div><md-divider></md-divider><div id=\"newUserForm\"><div \nlayout=\"row\" layout-align=\"center center\"><form name=\"details\" id=\"contact-details\" novalidate><div \nstyle=\"padding-left:17px;padding-top:20px\"><md-input-container flex=\"\" class=\"flex md-default-theme\"><label \nfor=\"select_55\" class=\"md-placeholder\">Title</label><md-select ng-model=\"$ctrl.title\" name=\"title\" \nclass=\"ng-pristine ng-valid md-default-theme ng-empty ng-touched\" tabindex=\"0\" aria-disabled=\"false\" role=\"listbox\" \naria-expanded=\"false\" aria-multiselectable=\"false\" id=\"select_55\" aria-owns=\"select_container_56\" aria-invalid=\"false\" \naria-label=\"Title\"><md-option value=\"Dr\">Dr</md-option><md-option value=\"Mr\">Mr</md-option><md-option value=\"Mrs\">Mrs\n</md-option><md-option value=\"Ms\">Ms</md-option><md-option value=\"Miss\">Miss</md-option><md-option value=\"Master\">\nMaster</md-option><md-option value=\"Prof\">Prof</md-option><md-option value=\"A/Prof\">A/Prof</md-option><md-option \nvalue=\"Other\">Other</md-option></md-select></md-input-container></div><div layout=\"column\" \nstyle=\"padding-right:17px;padding-left:17px\"><md-input-container flex=\"\" class=\"flex md-default-theme\"><input \ntype=\"text\" name=\"firstName\" ng-model=\"$ctrl.firstName\" ng-maxlength=\"50\" placeholder=\"First name\" required><div \nclass=\"validation-messages\" ng-messages=\"details.firstname.$error\"><div ng-message=\"required\">First name is required.\n</div></div></md-input-container><md-input-container flex=\"\" class=\"flex md-default-theme\"><input type=\"text\" \nname=\"middleName\" ng-model=\"$ctrl.middleName\" ng-maxlength=\"50\" placeholder=\"Middle name\"><div \nclass=\"validation-messages\" ng-messages=\"details.middleName.$error\"><div ng-message=\"maxlength\">Too many characters.\n</div></div></md-input-container><md-input-container flex=\"\" class=\"flex md-default-theme\"><input type=\"text\" \nname=\"lastName\" ng-model=\"$ctrl.lastName\" ng-maxlength=\"50\" placeholder=\"Last name\" required><div \nclass=\"validation-messages\" ng-messages=\"details.lastname.$error\"><div ng-message=\"required\">Last name is required\n</div></div></md-input-container><md-input-container flex=\"\" class=\"flex md-default-theme\"><input type=\"text\" \nname=\"registerNumber\" ng-model=\"$ctrl.registerNumber\" required ng-pattern=\"$ctrl.registrationRegularExpression\" \nplaceholder=\"Enter Registration Number\"><div class=\"validation-messages\" ng-messages=\"details.registerNumber.$error\">\n<div ng-message=\"required\"><span>AHPRA Registration No is required.</span></div><div ng-message=\"pattern\"><span>\n{{$ctrl.registrationInvalidMessage}}</span></div></div><div class=\"dontKnowRegistration\"><span \nng-click=\"$ctrl.openAHRPAPage()\" style=\"cursor:pointer;font-weight:normal\">Don\'t Remember</span></div>\n</md-input-container><md-input-container flex=\"\" class=\"flex md-default-theme\"><label for=\"professionNewOfContact\" \nclass=\"md-placeholder\">Select your profession</label><md-select name=\"profession\" id=\"professionNewOfContact\" \nng-model=\"$ctrl.profession\" class=\"ng-pristine ng-valid md-default-theme ng-empty ng-touched\"><md-option \nvalue=\"Aboriginal and Torres Strait Islander Health Practitioner\">Aboriginal and Torres Strait Islander<br>\nHealth Practitioner</md-option><md-option value=\"Chinese Medicine Practitioner\">Chinese Medicine Practitioner\n</md-option><md-option value=\"Chiropractor\">Chiropractor</md-option><md-option value=\"Dental Practitioner\">\nDental Practitioner</md-option><md-option value=\"Medical Practitioner\">Medical Practitioner</md-option><md-option \nvalue=\"Medical Radiation Practitioner\">Medical Radiation Practitioner</md-option><md-option value=\"Midwife\">Midwife\n</md-option><md-option value=\"Nurse\">Nurse</md-option><md-option value=\"Occupational Therapist\">Occupational Therapist\n</md-option><md-option value=\"Optometrist\">Optometrist</md-option><md-option value=\"Osteopath\">Osteopath</md-option>\n<md-option value=\"Paramedic\">Paramedic</md-option><md-option value=\"Pathologist\">Pathologist</md-option><md-option \nvalue=\"Pharmacist\">Pharmacist</md-option><md-option value=\"Physiotherapist\">Physiotherapist</md-option><md-option \nvalue=\"Podiatrist\">Podiatrist</md-option><md-option value=\"Psychologist\">Psychologist</md-option><md-option \nvalue=\"Sonographer\">Sonographer</md-option><md-option value=\"Other\">Other</md-option></md-select></md-input-container>\n</div><div layout=\"row\" layout-align=\"center\" style=\"margin-top: 35px\"><md-input-container class=\"person-country-code\">\n<md-select class=\"ng-pristine ng-valid md-default-theme ng-empty ng-touched\" tabindex=\"0\" aria-disabled=\"false\" \nrole=\"listbox\" aria-expanded=\"false\" aria-multiselectable=\"false\" placeholder=\"Country code\" \nng-model=\"$ctrl.countryCode\" id=\"country-code\" name=\"phone\" aria-owns=\"select_container_56\" aria-invalid=\"false\" \naria-label=\"Select country code\"><md-option value=\"AU\" selected=\"true\">+61 AUS</md-option><md-option value=\"NZ\">+64 NZ\n</md-option><md-option value=\"IN\">+91 IND</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\"><input name=\"phone\" \nstyle=\"border: none;width: 178px;border-bottom: 1px solid #d3d3d3;border-radius: 8px;padding: 4px;position: relative\" \nng-model=\"$ctrl.phoneNumber\" placeholder=\" Mobile number\" number-blur required ng-pattern=\"$ctrl.phoneNumberRegex()\">\n<div class=\"validation-messages\" ng-messages=\"details.phone.$error\"><div ng-message=\"required\">\nMobile Number is required.</div><div ng-message=\"pattern\">Not a valid phone number.</div></div></md-input-container>\n</div><div layout=\"row\" layout-align=\"center\"><md-button class=\"md-raised md-accent genericRegistrationPageButton\" \naria-label=\"register\" type=\"submit\" style=\"margin-top: 20px;margin-bottom: 20px\" ng-disabled=\"details.$invalid\" \nname=\"next-submit\" ng-click=\"$ctrl.registerUser()\">Update</md-button></div></form></div></div><md-divider></md-divider>\n<md-card-actions layout=\"row\" layout-align=\"center\"><div class=\"registerAccountFooter\">\nNeed help or have feedback? Contact: <a href=\"mailto:support@clinivid.com.au\">Support&nbsp<md-icon \nmd-font-icon=\"icon-email\" class=\"icon\" style=\"color:#92298C\"></md-icon></a></div></md-card-actions></md-card></div>\n</div></div>");
$templateCache.put("app/user/auth/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\" \nstyle=\"border-radius: 7px\"><div layout=\"row\" layout-align=\"center\"><img src=\"/assets/images/loginlogo.svg\" \nstyle=\"width:30px;height:30px\"></div><div class=\"title\" translate=\"FORGOTPASSWORD.TITLE\" \nstyle=\"font-family: Roboto;font-size: 22px;font-weight: 600;letter-spacing: 0.5px;text-align: center;color: #030303;\">\nRecover your password</div><md-card-actions layout=\"row\" layout-align=\"center\" ng-show=\"$ctrl.backendError\"><div \nclass=\"alert\"><img src=\"/assets/images/error.png\" style=\"width: 16px;height: 19px\"> <span \nstyle=\"color: red;margin-left: 2px;font-size: 12px;margin-top: 0px;font-weight: 500\">\nPlease check your details entered or contact <a href=\"mailto:support@clinivid.com.au\">support@clinivid.com.au</a>\n</span></div></md-card-actions><form name=\"forgotPasswordForm\" ng-submit=\"$ctrl.forgotPassword()\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"$ctrl.emailAddress\" \nplaceholder=\"Email address\" translate translate-attr-placeholder=\"FORGOTPASSWORD.EMAIL_ADRESS\" \nng-pattern=\"/^.+@.+\\..+$/\" required \nstyle=\"border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5); border-radius: 8px;padding: 4px\">\n<div ng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"FORGOTPASSWORD.ERRORS.EMAIL_REQUIRED\" style=\"margin-left:4px\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"FORGOTPASSWORD.ERRORS.EMAIL_MUST_VALID\" style=\"margin-left:4px\">\nEmail must be a valid e-mail address</span></div></div></md-input-container><div layout=\"column\" \nlayout-align=\"center center\"><div vc-recaptcha key=\"\'6LdN51EUAAAAANUbadEqSvfFB52kvU1dueywiLuD\'\"></div></div><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"RESET MY PASSWORD\" \nng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" \nstyle=\"border-radius: 5px;text-transform: none !important\">Send reset link</md-button></form><div class=\"login\" \nlayout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"app.user.login\" translate=\"FORGOTPASSWORD.GO_BACK\">\nGo back to login</a></div></div></div></div><style>\n#content-container{\n    background-image: linear-gradient(to bottom, rgba(202, 234, 255, 0.97), #ffffff 80%);\n  }\n</style>");
$templateCache.put("app/user/auth/login.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex><div id=\"login\" class=\"flex-scrollable\" \nlayout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div \nid=\"login-mfa-form\" class=\"md-whiteframe-8dp\" style=\"border-radius:7px\" ng-show=\"$ctrl.mfaVisible\"><div layout=\"row\" \nlayout-align=\"center\"><img src=\"/assets/images/loginlogo.svg\" style=\"width:30px;height:30px\"></div><div class=\"title\" \nstyle=\"font-family: Roboto;font-size: 22px;font-weight: 600;letter-spacing: 0.5px;text-align: center;color: #030303\">\nVerify your identity</div><div class=\"mfa-screen\"><div class=\"mfa-subtitle\" style=\"margin-top:20px\">\nWe have sent a text message to:</div><div layout=\"row\" layout-align=\"center\" \nstyle=\"margin-bottom: 30px;margin-top:10px\"><input type=\"text\" ng-value=\"$ctrl.maskedMobile\" readonly=\"readonly\" \nstyle=\"border:1px solid #d3d3d3; height: 50px; text-align: center; font-size: 18px; letter-spacing: 2px\"></div><div \nclass=\"mfa-subtitle\" style=\"margin-bottom: 20px\">Enter the 6 digits code</div><div layout=\"row\" layout-align=\"center\" \nclass=\"mfa-inputs\"><input ng-repeat=\"i in [0,1,2,3,4,5] track by $index\" id=\"mfa-digit-{{$index}}\" type=\"text\" \nmaxlength=\"1\" ng-model=\"$ctrl.mfaCode[$index]\" ng-keyup=\"$ctrl.onCodeDigitInput($index, $event)\" \nng-keydown=\"$ctrl.onCodeKeydown($index, $event)\" class=\"mfa-digit-input\" autocomplete=\"off\" inputmode=\"numeric\" \npattern=\"[0-9]*\"></div><div ng-show=\"$ctrl.mfaError\" class=\"mfa-error\" \nstyle=\"color: red; text-align: center; margin-top: 10px\">{{$ctrl.mfaError}}</div><div \nng-show=\"$ctrl.mfaSuccess && !$ctrl.mfaError\" class=\"mfa-success\" \nstyle=\"color: #388e3c; text-align: center; margin-top: 10px\">{{$ctrl.mfaSuccess}}</div><div layout=\"row\" \nlayout-align=\"center\"><md-button class=\"md-raised md-accent submit-button md-button md-default-theme md-ink-ripple\" \nstyle=\"border-radius:5px;width:115px;height:40px;margin-top:50px;text-transform: none !important\" \nng-disabled=\"$ctrl.mfaCode.join(\'\').length < 6\" ng-click=\"$ctrl.verifyMFA()\" id=\"confirm_btn\">Confirm</md-button></div>\n<div layout-align=\"center\" style=\"margin-top: 16px\"><div><span>Didn\'t receive a code?</span> <a \nng-click=\"$ctrl.resendCode()\" style=\"cursor: pointer; color: #92298C; text-decoration: underline\">Resend</a><br><div><a\n ng-click=\"$ctrl.sendCodeByEmail()\" \nstyle=\"cursor: pointer; color: #92298C; text-decoration: underline; font-size: 13px\">\nSend code to {{$ctrl.maskedEmail}} instead</a></div></div><div ng-show=\"$ctrl.emailCodeSent\" style=\"text-align:center\">\n<span style=\"color: #388e3c; font-size: 13px\">A code has been sent to {{$ctrl.maskedEmail}}.</span></div></div><div \nng-show=\"$ctrl.mfaTestMode\" \nstyle=\"background-color: #fff3cd; color: #856404; border: 1px solid #ffc107;\n                              border-radius: 4px; padding: 10px 14px; margin: 20px 0 0;\n                              text-align: center; font-size: 13px\">\nMFA validation is disabled and any related functionalities will not work.</div></div><md-card-actions layout=\"row\" \nlayout-align=\"center\"><div class=\"registerAccountFooter\" style=\"font-size: 12px;letter-spacing: 0.1px\">Need help? <a \nhref=\"mailto:support@clinivid.com.au\">Contact Support</a></div></md-card-actions></div><div id=\"login-form\" \nclass=\"md-whiteframe-8dp\" style=\"border-radius:7px\" ng-hide=\"$ctrl.mfaVisible\"><div layout=\"row\" layout-align=\"center\">\n<img src=\"/assets/images/loginlogo.svg\" style=\"width:30px;height:30px\"></div><div class=\"title\" \ntranslate=\"LOGIN.TITLE\" \nstyle=\"font-family: Roboto;font-size: 22px;font-weight: 600;letter-spacing: 0.5px;text-align: center;color: #030303;\">\nLog in to your account</div><form name=\"loginForm\" ng-submit=\"$ctrl.login()\" novalidate><md-input-container \nclass=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"$ctrl.form.email\" placeholder=\"Email\" \ntranslate translate-attr-placeholder=\"LOGIN.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required \nstyle=\"border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5); border-radius: 8px;padding: 4px\">\n<div ng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_REQUIRED\" style=\"margin-left:4px\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\" style=\"margin-left:4px\">\nEmail must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float><input type=\"password\" name=\"password\" id=\"userpassword\" ng-model=\"$ctrl.form.password\" \nplaceholder=\"Password\" translate translate-attr-placeholder=\"LOGIN.PASSWORD\" required \nstyle=\"border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5); border-radius: 8px;padding: 4px\">\n<div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\" style=\"margin-left:4px\">Password field is required</span></div></div><div \nclass=\"dontKnowRegistration\"><span ui-sref=\"app.user.forgot-password\" style=\"cursor:pointer;font-weight:normal\">\nReset Password</span></div></md-input-container><md-card-actions layout=\"row\" layout-align=\"center\"><label for=\"cbx\" \nclass=\"label-cbx\" style=\"font-family: Roboto;font-size: 14px\"><input id=\"cbx\" type=\"checkbox\" class=\"invisible\" \nng-click=\"$ctrl.togglePassword()\"><div class=\"checkbox\" style=\"margin-top:-2px\"><svg width=\"20px\" height=\"20px\" \nviewBox=\"0 0 20 20\"><path \nd=\"M3,1 L17,1 L17,1 C18.1045695,1 19,1.8954305 19,3 L19,17 L19,17 C19,18.1045695 18.1045695,19 17,19 L3,19 L3,19 C1.8954305,19 1,18.1045695 1,17 L1,3 L1,3 C1,1.8954305 1.8954305,1 3,1 Z\">\n</path><polyline points=\"4 11 8 15 16 6\"></polyline></svg></div><span>Show password</span></label></md-card-actions>\n<div class=\"loadingLoginDiv\" ng-show=\"isLoginInProcess\" \nstyle=\"border-radius:5px;width:115px;height:40px;margin-top:71px\"><div class=\"spinner\"></div></div><md-button \nname=\"loginUser\" ng-show=\"!isLoginInProcess\" type=\"submit\" class=\"md-raised md-accent submit-button\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \nstyle=\"border-radius:5px;width:115px;height:40px;margin-top:50px;text-transform: none !important\">Log in</md-button>\n</form><md-card-actions layout=\"row\" layout-align=\"center\"><div class=\"registerAccountFooter\" \nstyle=\"margin-top: 30px;font-size: 16px\">Not registered with us yet? <span style=\"color: #0899ff;cursor:pointer\" \nui-sref=\"app.user.register\">Sign up</span></div></md-card-actions><md-card-actions layout=\"row\" layout-align=\"center\" \nstyle=\"width:100%;font-weight:600px;margin-top:20px\"><div class=\"registerAccountFooter\" \nstyle=\"font-size: 12px;letter-spacing: 0.1px\">©2016-2026 InfoMedix Pty Ltd under license. All Rights Reserved<br><br>\n<span style=\"margin-left:10px;cursor:pointer\" ng-click=\"$ctrl.showPrivacy()\">Privacy policy</span></div>\n</md-card-actions></div></div></div></md-content><div></div><md-sidenav md-component-id=\"termsAndConditions\" \nclass=\"md-sidenav-right\"><div style=\"display: flex; flex-flow: column; height: 100%\"><div><md-toolbar layout=\"row\"><div\n class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" aria-label=\"Close Side Panel\" \nng-click=\"$ctrl.closeSideNavPanelTermsAndConditions()\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#FFFFFF\"></md-icon></md-button><h2><span style=\"color:#FFFFFF;font-size: 16px;font-weight: 700\" \nclass=\"hide-xs\">Terms of Service</span></h2><div class=\"createpageHeaderButtons\" \nstyle=\"color: #ffffff;margin-left: auto\" class=\"hide-xs\"><md-icon md-font-icon=\"icon-clock\" class=\"icon\" \nstyle=\"color:#FFFFFF\"></md-icon><strong><span style=\"color: #FFFFFF\">Last update: 15<span>th</span> June 2020</span>\n</strong></div></div></md-toolbar></div><div style=\"min-height: 0; flex: 1; overflow: auto\"><div \nclass=\"page-layout off-white-bg carded fullwidth single-scroll layout-row\" layout=\"row\"><div class=\"center flex\">\n<md-content class=\"content ms-scroll md-default-theme\" ms-scroll=\"\"><div class=\"content\" \nstyle=\"text-align: justify;font-family: \'Work Sans\', sans-serif;font-size: 16px;color: #8c8c8c\"><p></p><p></p>\nThese Terms of Service (<b>Terms</b>\n) are between InfoMedix Pty Ltd (ACN 093 160 653), its successors and permitted assigns (referred to as <b>\nHealth Care Innovate</b>) and each individual user subject to these Terms (referred to as <b>you</b> or <b>your</b>\n), collectively referred to as the <b>Parties</b> and each a <b>Party</b>\n. These Terms govern your access to and use of the Clinivid communication platform (<b>Platform</b>\n) and any related services made available to you (together with the Platform referred to as <b>Services</b>\n). The Services are accessible via supported web browsers (<b>Website</b>\n), a third party software where integrated with the Clinivid platform, or via the Clinivid application (<b>App</b>\n) on any mobile, tablet, console or other devices which supports the App and Website. You may be a user with: (i) your own individual Account (\n<b>Individual Account Holder</b>\n); and or (ii) an Account/s created for you by our enterprise customers which have an enterprise subscription with us (\n<b>Authorised User</b>).<p></p><p><b style=\"color: #010101\">\nINFOMEDIX DOES NOT COLLECT OR SOLICIT ANY PERSONAL INFORMATION VIA THE SERVICES WHICH MIGHT BE UNLAWFUL, UNNECESSARY, EXCESSIVE, INTRUSIVE OR UNRELATED TO THE FUNCTIONS OF THE SERVICES. THE SERVICES ARE DEPENDENT ON A NUMBER OF FACTORS AND PROVIDED TO YOU ON AN “AS IS” BASIS. THE SERVICES ARE NOT A SUBSTITUTE FOR ANY SYSTEMS FOR ADMINISTERING MEDICINE OR MEDICAL ADVICE, PATIENT RECORDS OR ANY PRACTICE MANAGEMENT SYSTEMS USED BY YOU AND YOU MUST NOT RELY ON THE SERVICES TO TRANSMIT ANY INFORMATION ON AN URGENT BASIS OR ANY INFORMATION RELATING TO A LIFE THREATENING SITUATION. PLEASE REFER TO CLAUSE 15 FOR HEALTH CARE INNOVATE’S FULL DISCLAIMER.\n</b></p><p>1.<b> ACCEPTANCE </b><b></b></p><p>\n1.1. These Terms form a binding legal agreement between the Parties. By accessing and using the Services, you agree to comply with and be legally bound by these Terms. Please read these Terms carefully. If you have any questions, you should contact InfoMedix using the contact details at the end of these Terms.\n</p><p>\n1.2. You acknowledge and agree to these Terms by: (i) ticking ‘I Agree’; (ii) accessing or using the Services whether via the App, Website or otherwise; or (iii) making part or full payment for the Services. If you do not agree to these Terms, you should cease accessing or using the App, Services and Website.\n</p><p>\n1.3. InfoMedix reserves the right to make changes to these Terms at any time, effective upon the posting of modified Terms. InfoMedix will endeavour to communicate these changes to the Users via email, App or Website. It is your obligation to ensure that you have read, understood and agree to the most recent Terms available on the App or Website.\n</p><p>\n1.4. Using the Services may be prohibited or restricted in certain countries. If you use the Services outside of Australia, you are responsible for complying with the laws and regulations of the territory from which you access or use the Services.\n</p><p>2.<b> PRIVACY AND ADDITIONAL TERMS</b></p><p>\n2.1. These Terms supplement and incorporate the Privacy Policy as set out on the App and Website. You will be taken to have read the terms of the Privacy Policy when you accept these Terms.\n</p><p>\n2.2. InfoMedix agrees to comply with the Privacy Act 1988 (Cth) including the Australian Privacy Principles, the Health Records and Information Privacy Act 2002 (NSW) where applicable and any other applicable legislation or privacy guidelines as amended from time to time. Please refer to Health Care Innovate’s Privacy Policy for details on how we store and use Personal Information.\n</p><p>3.<b> PLATFORM AND SERVICES</b></p><p>\n3.1. You can access and use the Services on any computer, mobile, tablet or other device (<b>Device</b>\n ) which supports the App or Website, or where the Services are integrated, from a 3<sup>rd</sup>\n party software. InfoMedix recommends each User accesses the App and Website using the recommended browsers or Devices as notified to you.\n</p><p>3.2	<b>Applicable to Individual Account Holders</b>\n: To access the App and some Services you must register for an account (<b>Account</b>\n) and complete Health Care Innovate’s registration form as set out on the App or Website (<b>Registration Form</b>\n). The Registration Form may require your first, middle and last name (as applicable), mobile number, email address and other related information which will be used to generate your Account profile (\n<b>User Information</b>).</p><p>\n3.3. If you are an Individual Account Holder and an Authorised User, you may alternate your profile between the Account you hold as an Individual Account Holder and the account/s you hold as an Authorised User.\n</p><p>3.4. <b>Applicable to Individual Account Holders</b>\n: Access to all Services and features on the App and Website will require you to subscribe to the Services (<b>\nSubscription</b>) for a period of time as set out on the App or Website (<b>Subscription Period</b>\n). The fees for each Subscription Period (<b>Subscription Fee</b>\n) will vary subject to the functionalities and Services you request as identified in your Account.</p><p>\n3.5. Any information or content you submit via the Services, including but not limited to photos, videos, audio, User Information or information or content which passes through the Platform whether it contains Personal Information or otherwise (collectively referred to as Data) are stored in servers located in Australia. InfoMedix will take reasonable steps and use industry standard procedures to ensure that Data is kept secure and confidential. Such Data does not include any data you submit through our third party service provider including our third party payment service provider, Braintree.\n</p><p>3.6	You represent and warrant that:<br><ol type=\"a\"><li>\nany and all Data you submit (or a User submits) via the Services are your sole and exclusive property; or</li><li>\nyou have secured any and all authorisation and rights to use the Data as applicable under the relevant laws.</li></ol>\n</p><p>3.7	Subject to your Device, you may be able to activate finger print recognition (<b>Fingerprint Login</b>\n) to access and use the Services via the Application. If you activate Fingerprint Login, you understand the need to protect your Device and if you have other people’s fingerprints registered in your Device, they will also have access to your Account and Services.\n</p><p>\n3.8	You acknowledge and agree that the operation of the Services may rely on third party application or services and your use of the Services may be subject to third party terms, including but not limited to Braintree Terms of Service as notified to you on our App and Website.\n</p><p>4.	<b>SECURITY</b></p><p>\n4.1	InfoMedix has implemented and will maintain security systems for the transmission and storage of Data consisting of encryption and data security technologies that are understood in the industry to provide adequate security for the transmission of such information over the Internet. These measures are intended to prevent unauthorised Data infiltration or security breaches. InfoMedix does not guarantee the security of any Data you store on your servers or Device(s).\n</p><p>5.<b> UPDATES AND AVAILABILITY OF SERVICES</b></p><p>5.1. InfoMedix may issue updates to the Services (<b>\nUpdates</b> ) from time to time.</p><p>\n5.2. Although InfoMedix endeavours to provide access to the Services should be available on a full-time basis, the Services may be unavailable due to maintenance or other development activity from time to time.\n</p><p>\n5.3. Where possible, InfoMedix will provide you with notice of any maintenance or development activity via email, App and Website.\n</p><p>6.<b> OFFERS AND PROMOTIONS</b></p><p>\n6.1. InfoMedix may, from time to time, make offers or promotions which may be applicable to the Services including but not limited to a free trial period to use the Services and create a limited number of cases ( \n<b>Trial Period</b>\n ). If any additional terms and conditions apply to such offers or promotions, these will be set out on the App, Website or otherwise notified to you via the Services.\n</p><p>7.<b> YOUR OBLIGATONS</b></p><p>7.1. You represent and warrant that:<ol type=\"a\"><li>\nby submitting your User Information and creating an Account, you are a health practitioner in Australia with a current registration with the Australian Health Practitioner Regulation Agency ( \n<b>AHPRA</b>);</li><li>all User Information provided to InfoMedix is true, accurate and complete;</li><li>\nany content or Data you post or submit via the Services or the posting, uploading, publication or transmission of the Data:\n</li><ol type=\"i\"><li>will not breach any agreements between you and any third party;</li><li>\nwill be in compliance with all applicable laws, requirements, rules and regulation that may apply to any third party in their state or territory; and\n</li><li>will not conflict with the rights of third parties;</li></ol><li>\nwhere Data contains any third party Personal Information, in order to post, upload, publish, transmit or otherwise use or disclose such Personal Information via the Services, you have:\n<ol type=\"i\"><li>\nprovided a consent form to such third party including but not limited to, where applicable, expressed consent to use any unique identifiers to link Data from the Services to your patients’ records; and\n</li><li>obtained the requisite consent; and</li></ol></li><li>\nonly to the extent necessary will you disclose Data to other registered health practitioner(s) involved in the management of a particular third party case to which that Data relates.\n</li></ol>7.2. You acknowledge and agree that you are responsible for how you use the Services and that:<ol type=\"a\">\n<li>you use the Services, App and Website at your own risk;</li><li>\nshould you use Fingerprint Login to access the Application, you are solely responsible for any access or use of your Account or Services via Fingerprint Login, whether such access or use are by you or anyone else whose fingerprint is saved on your Device.\n</li><li>you consent to InfoMedix checking your User Information against the AHPRA register;</li><li>\nInfoMedix is not responsible for any corruption or loss of any Data if such corruption or loss is due to an act or omission by you, your employee(s), contractor(s), agent(s) or any third party;\n</li><li>\nInfoMedix reserves the right to access and/or delete your Data at any time and for any reason including if InfoMedix reasonably believes your Data violates these Terms or infringe any law or regulation; and\n</li><li>you are solely responsible for:</li><ol type=\"i\"><li>\nany Data you upload or otherwise transmit via the Services; and</li><li>\ncomplying with all laws and regulations regarding the use and disclosure of Personal Information including but not limited to the Privacy Act 1988 (Cth) and the Australian Privacy Principles (including but not limited to APP 8 - Cross-border disclosure of personal information) as amended from time to time, the Spam Act 2003 (Cth) and any other requirements under Australian law.\n</li></ol><li>the Services must only be used for your own lawful purposes and in accordance with these Terms;</li><li>\nthe accessibility and reliability of the Services is dependent on your choice of web-browser, internet connection, Device operating system and your internet connection;\n</li><li>all usernames and passwords required to access the Account and Services are kept secure and confidential;</li>\n<li>\nif there is any unauthorised use of your passwords or any other breach of security, you will immediately notify InfoMedix of such activity; and\n</li><li>\nit is your responsibility to determine that the Services meet your needs and are suitable for the purposes for which the Services are used.\n</li></ol>\n7.3. InfoMedix has no responsibility to any person or entity other than you and nothing in these Terms confer, or purport to confer, a benefit on any person or entity other than you. If you use the Platform on behalf of or for the benefit of anyone other than yourself, you agree that:\n<ol type=\"a\"><li>you are responsible for ensuring that you have the right to do so;</li><li>\nInfoMedix does not warrant the fitness for purpose or suitability of the Platform for any third party’s purpose and third parties may not rely on InfoMedix for any purpose;\n</li><li>\nyou are responsible for authorising any person who is given access to your Data, and you agree that, subject to any requirements by law or regulation including but not limited to the obligation to grant any third party access to any of your Data to which their Personal Information relates, InfoMedix has no obligation to provide any person or entity with access to such Data without authorisation from you and we may refer any requests for access to the Data to you to address; and\n</li><li>\nyou will indemnify Health Care Innovate, on first demand, against any and all claims, expenses, liabilities or losses arising out of in connection with Health Care Innovate’s refusal to provide any persons with access to your Data (including but not limited to any patient data) in accordance with these Terms and InfoMedix making Data available to any person with authorisation from you.\n</li></ol>\n7.4. You remain solely responsible for complying with all applicable laws. It is your responsibility to ensure that the storage of and access to your Data via the Services complies with any laws which are applicable to you, including any laws requiring you to maintain or retain records, maintain confidentiality and accuracy and protect the privacy of your Data. If you would like information in relation to how InfoMedix stores and collects Data, please contact InfoMedix using the details at the bottom of these Terms.\n</p><p>8.<b> PAYMENT (Applicable to Individual Account Holders)</b></p><p>\n8.1. You agree to pay InfoMedix the applicable Subscription Fees upfront as required to enable you to access and use the Services.\n</p><p>\n8.2. You will be required to make payment by way of credit card, PayPal or other payment methods as set out on the App and Website. The initial payment will be processed (a) upon receipt of the request for a Subscription; or (b) subject to any offers and promotions, immediately upon using up any limit prescribed to the Trial Period. You must make further payments prior to the expiry of your Subscription on the relevant periodic basis.\n</p><p>8.3. You acknowledge and agree that:<ol type=\"a\"><li>\nto maintain your subscription and subject to your elected payment method, payment to InfoMedix will be made automatically in advance on a monthly payment date, from your nominated PayPal account; and\n</li><li>\nas you have allowed InfoMedix and its payment service provider to automatically direct debit your nominated credit card or other payment account, if the direct debit service provider is unable to process payment, Health Care Innovate’s payment service provider will attempt to contact you via email as soon as it is aware of the payment failure. Until payment is confirmed, your access to the Services may be suspended until InfoMedix and its payment service provider receives confirmation of payment.\n</li></ol>\n8.4. If you make a payment by way of credit card, you warrant that the information you provide to InfoMedix and its payment service provider is true and complete, that you are authorised to use the credit card to make payment and that your payment will be honoured by your card issuer.\n</p><p>\n8.5. If payment is not made within 30 days of the last payment date, InfoMedix may lock your Account without notice to you, in which case you will not be able to access your Account or use the Services, and any Data on the Account may be deleted and not recoverable.\n</p><p>\n8.6. All amounts are stated in Australian dollars and unless otherwise stated, all amounts are exclusive of goods and services tax (\n<b>GST</b>).</p><p>\n8.7. Health Care Innovate’s pricing structure or payment methods may be amended from time to time in its sole discretion.\n</p><p>9.<b> CANCELLATION AND TERMINATION</b></p><p>9.1	<b>Applicable to Individual Account Holders</b>\n: If you would like to cancel your Subscription, you may do so by notifying Health Care Innovate through your Account using the App or Website (\n<b>Cancellation Request</b>\n). Your access to your Account and any Data will be terminated at the end of the Subscription Period month following your Cancellation Request and you will not be charged any further Subscription Fees to your payment account.\n</p><p>9.2. InfoMedix may terminate these Terms or your Account immediately, in its sole discretion, if:<ol type=\"a\">\n<li>you breach any of these Terms;</li><li>\nInfoMedix reasonably suspects that you are attempting to reverse engineer the Platform that is provided to you;</li>\n<li>Health Care Innovate, at its own discretion, terminates the Services; or</li><li>\nfor any other reason outside Health Care Innovate’s control which has the effect of compromising its ability to provide you with the Services within a required timeframe.\n</li></ol>\n9.3. On termination of the Services and these Terms, InfoMedix may retain your Data and related documents (including copies) as required to facilitate the Services to other users, by law or regulation. Your express or implied agreement to the Terms constitutes your authority for InfoMedix to retain or destroy such documents and records in accordance with the statutory periods, or on termination of these Terms.\n</p><p>10.<b> PROHIBITED USE</b></p><p>10.1. You acknowledge and agree that you will not:<ol type=\"a\"><li>\nuse the Services in any manner that is illegal or violates any applicable rights (e.g. right to privacy), law or regulation;\n</li><li>\ntransmit via the Services any Personal Information including Personal Information relating to your patient which are unlawful, unnecessary, excessive, intrusive or unrelated to the functions of the Services;\n</li><li>\nattempt to circumvent or disable the Services or any technology features or measures in the Platform by any means or in any manner;\n</li><li>\nattempt to modify, copy, adapt or reproduce the Data, Services or App except as necessary for normal operation;</li>\n<li>\nattempt to decompile, disassemble, reverse engineer, or otherwise attempt to derive the source code for the Platform or App;\n</li><li>\nupload any Data including any content that is defamatory, obscene, pornographic, vulgar, offensive, promotes discrimination, bigotry, racism, harassment or harm against any individual or group;\n</li><li>\ndistribute, encumber, sell, rent, lease, sub-license, or otherwise transfer, publish or disclose the Data or Services to any third party (except as permitted under these Terms);\n</li><li>\nremove or alter any trademark, logo, copyright or other proprietary notices, legends, symbols or labels in or on the App, Platform or Website or otherwise used in connection with the Services;\n</li><li>\nuse the Services in any manner to aid in the violation of any third party Intellectual Property Rights, including but not limited to another’s copyrights, trade marks, and patents;\n</li><li>\ntake any action that interferes, in any manner, with Health Care Innovate’s rights with respect to the Services;</li>\n<li>\nattempt to undermine the security or integrity of Health Care Innovate’s computing systems or where the Services are hosted by a third party, that third party’s computing systems and networks; and\n</li><li>\nuse, or misuse, the Services in any way which may impair the functionality of the Services, App, Website or other systems used to deliver the Platform or impair the ability of any other user to use the Services, App or Website.\n</li></ol>\n10.2. You acknowledge that any breaches of this clause or the Terms generally may lead to termination of these Terms and cancellation of your Account.\n</p><p>11.<b> INTELLECTUAL PROPERTY</b></p><p>\n11.1. Heath Care Innovate holds the title to, or otherwise holds the licence to all Intellectual Property Rights in the Platform, Services, and any documentation relating to the Platform and these remain the property of InfoMedix and any other applicable owner. Your right to use such Intellectual Property Rights is subject to these Terms.\n</p><p>\n11.2. Title, ownership rights and Intellectual Property Rights in and to any content displayed on the Services, App or Website, or accessed through the Services, App or Website are the property of the applicable content owner and may be protected by applicable copyright or other law. These Terms give you no rights to such content.\n</p><p>11.3. You grant InfoMedix a non-exclusive, worldwide, royalty free, irrevocable licence to:<ol type=\"a\"><li>\nuse any Intellectual Property Rights which subsists in any materials you provide in connection with your Account or the Services as required for InfoMedix to provide the Services to you; and\n</li><li>\nto any Intellectual Property Rights subsisting in your Data in order to host, store, use, copy, display, transmit, reference, disclose, reproduce, modify, adapt, edit, publish and distribute your Data or otherwise for purposes including:\n</li><ol type=\"i\"><li>to enable you to access and use the Services;</li><li>\nfor Health Care Innovate’s administrative, support and training purposes; and</li><li>\nin accordance with these Terms or as otherwise required for InfoMedix to develop, provide and improve the Services.\n</li></ol></ol>\nWhere such Data contains your Personal Information, InfoMedix will use your Data for purposes consistent with its Privacy Policy.\n</p><p>\n11.4. Title to and all Intellectual Property Rights in any Data you input into the Services remain your property. However, your access to the Data and continued use of the Services is contingent on payment of your Subscription Fee for your Subscription.\n</p><p>\n11.5. As the operation of the Services may rely on third party application or services, you acknowledge that InfoMedix may allow providers of these third party-application to access any inputted Data as required for the interoperation of such third party applications with the Services. InfoMedix is not responsible for any disclosure, modification or deletion of Data resulting from any such access by third-party application providers.\n</p><p>12.<b> FEEDBACK AND DISPUTE RESOLUTION</b></p><p>\n12.1. Your feedback is important to Health Care Innovate. InfoMedix seeks to resolve your concerns quickly and effectively. If you have any feedback or questions about the Services, please contact InfoMedix using the details at the end of these Terms.\n</p><p>\n12.2. If there is a dispute between the Parties in relation to these Terms or the Services, the Parties agree to the following dispute resolution procedure:\n<ol type=\"a\"><li>\nThe complainant must tell the respondent in writing, the nature of the dispute, what outcome the complainant wants and what action the complainant thinks will settle the dispute. The Parties agree to liaise with each other in good faith to seek to resolve the dispute by agreement between them ( \n<b>Initial Discussion</b> ).</li><li>\nIf the Parties cannot agree how to resolve the dispute at the Initial Meeting, any Party may refer the matter to a mediator. If the parties cannot agree on who the mediator should be, the complainant will ask the Law Society of New South Wales to appoint a mediator. The mediator will decide the time and place for mediation. The Parties must attend the mediation in good faith, to seek to resolve the dispute.\n</li></ol>\n12.3. Any attempts made by the Parties to resolve a dispute pursuant to this clause are without prejudice to other rights or entitlements of the Parties under these Terms, by law or in equity.\n</p><p>13.<b> AUSTRALIAN CONSUMER LAW</b></p><p>\n13.1. InfoMedix Services come with guarantees that cannot be excluded under the Australian Consumer Law. For major failures with the Services, Customer is entitled:\n<ol type=\"a\"><li>to cancel this Agreement with Health Care Innovate; and</li><li>\nto a refund for the unused portion, or to compensation for its reduced value</li></ol></p><p>\n13.2. InfoMedix reserves the right to change or remove features of the SaaS Services from time to time. Where there is any material alteration to the SaaS Services in accordance with this clause, InfoMedix will provide the Customer with 20 Business Days’ notice and the Customer agrees that any material alteration is at Health Care Innovate’s discretion, though Customer may terminate this Document if such changes are unfair under the Australian Consumer Law.\n</p><p>14.<b> LIMITATION OF LIABILITY AND DISCLAIMERS</b></p><p>\n14.1. You acknowledge that whilst InfoMedix will take reasonable steps to ensure that the Services will be fit for the advertised purpose, to the fullest extent permitted by law, InfoMedix does not guarantee that:\n<ol type=\"a\"><li>\nthe Services will meet your requirements as the functionality of the Services is dependent upon configuration of your Device and other components;\n</li><li>the Services will work in each of your desired use case scenarios; and</li><li>\nthe Services can be executed on every operating system, as it is impossible to test each variant.</li></ol>\n14.2. The Services use third party hosting services. InfoMedix does not warrant that use of the Services will be uninterrupted or error or defect free. The operation and availability of the Services is dependent on public telephone services, computer networks, the Internet, which can be unpredictable and may from time to time interfere with the use of the Services. InfoMedix is not responsible for any such interference or prevention of your use of the Platform.\n</p><p>\n14.3. All risk arising out of the use or performance of the Services remain with you. You understand and agree that the use of the Services, material or Data obtained or generated through the use of the Services, is at your own discretion and risk and that you will be solely responsible for any infections, contaminations or damage to your Device, system or network. InfoMedix is not responsible or liable for delays, inaccuracies, errors or omissions arising out of your use of the Platform, any third party software or operating system.\n</p><p>\n14.4. InfoMedix does not collect any Data or other Personal Information directly from any patient or clinical stakeholder of a health practitioner and, subject to any obligations under law, does not notify such third parties regarding the collection and use of their information via the Services.\n</p><p>\n14.5. To the maximum extent permitted by applicable law, InfoMedix and its licensors disclaim all warranties, express or implied, including, without limitation, any implied warranties of merchantability, fitness for a particular purpose and non-infringement of third party intellectual property rights or lack of viruses, for the Services. In no event will InfoMedix or its licensors be liable for any consequential, incidental, indirect, special, punitive, or other damages whatsoever arising out of these Terms, the use of or inability to use the Services, even if InfoMedix has been advised of the possibility of such damages.\n</p><p>\n14.6. You acknowledge that InfoMedix may pursue any available equitable or other remedy against you as a result of your breach of any provision of these Terms.\n</p><p>\n14.7. InfoMedix or its licensors’ liability for breach of any of its obligations under these Terms for the Services, or breach of any warranty implied by law, will be limited, to the extent permitted by law, to the total price paid for Subscription to use the App, Services and Website. Health Care Innovate’s total liability to you for all damages in connection with the Services will not exceed the price paid by you under these Terms for the Services. The foregoing limitations, exclusions and disclaimers will apply to the maximum extent permitted by applicable law, even if any remedy fails its essential purpose.\n</p><p>\n14.8. You acknowledge and agree that InfoMedix will not be liable for any non-compensatory damages including punitive, aggravated, multiple, exemplary, liquated or any other non-compensatory damages or the consequences of non-payment.\n</p><p>15.<b>INDEMNITY</b></p><p>\n15.1. You will be liable for and agree to indemnify, defend and hold InfoMedix harmless for and against any and all claims, liabilities, suits, actions and expenses, including costs of litigation and reasonable legal costs, resulting directly or indirectly from any:\n<ol type=\"a\"><li>information that is not accurate, up to date or complete or is misleading or a misrepresentation;</li>\n<li>breach of these Terms;</li><li>\nmisuse of the Services, from or by you, your employees, contractors, agents or any third party you permit to use your Account or otherwise access the Services using your Subscription;\n</li><li>breach of law, regulation or licence by you;</li><li>\nclaims brought by a third party against a Party arising out of the App, Services or Website including but not limited to any claims regarding breach of such third party’s privacy;\n</li><li>claims by any third party that:</li><ol type=\"i\"><li>\nthe grant, or exercise of any licence, of any Intellectual Property Rights under these Terms; or</li><li>\nthe supply or use of the Services, App or Website, infringes the Intellectual Property Rights of any person;</li></ol>\n<li>\nany death or injury to persons and any losses or claims to the real or personal property of InfoMedix or a third party, caused or contributed by your act or omission; or\n</li><li>any breach of clause 7.1 by you or your representatives.</li></ol>\n15.2. You agree to co-operate with InfoMedix (at your own expense) in the handling of disputes, complaints, investigations or litigation that arise as a result of your use of the Services including but not limited to disputes, complaints, investigations or litigation that arises out of or relates to incorrect information you have given Health Care Innovate.\n</p><p>15.3. The obligations under this clause will survive termination of these Terms.</p><p>16.<b> NOTICE</b></p><p>\n16.1. Any notice required or permitted to be given to you under these Terms will be addressed to you, unless you otherwise notify Health Care Innovate, using the contact details you provided to InfoMedix in the Registration Form.\n</p><p>17.<b> RELATIONSHIP OF PARTIES</b></p><p>\n17.1. Neither Party is authorised to bind the other Party in any way without prior written consent of the other Party.\n</p><p>\n17.2. The Parties acknowledge and agree that they will not seek to bind the other Party other than with the prior written consent of the other Party.\n</p><p>18.<b> RIGHTS OF THIRD PARTIES</b></p><p>\n18.1. Any person or entity who is not a party to these Terms has no right to benefit under or to enforce any of these Terms.\n</p><p>19.<b> ASSIGNMENT</b></p><p>\n19.1. These Terms are personal to you. You must not assign or deal with the whole or any part of your rights and/or obligations under these Terms without the prior written consent of Health Care Innovate.\n</p><p>19.2. Any purported dealing in breach of this clause is of no effect.</p><p>20.<b> WAIVER OR VARIATION OF RIGHTS\n</b></p><p>\n20.1. Any failure or delay by a Party in exercising a power or right (either wholly or partially) in relation to these Terms does not operate as a waiver or prevent that Party from exercising that power or right or any other power or right.\n</p><p>\n20.2. A Party is not liable to any other Party for any loss, cost or expense that may have been caused or contributed to by the failure, delay, waiver or exercise of a power or right.\n</p><p>21.<b> POWERS, RIGHTS AND REMEDIES</b></p><p>\n21.1. Except as expressly stated to the contrary in these Terms, the powers, rights and/or remedies of a Party under these Terms are cumulative and are in addition to any other powers, rights and remedies of that Party. Nothing in these Terms merge, extinguish, postpone, lessen or otherwise prejudicially affect any power, right, or remedy that a Party may have at any time against the other Party to these Terms or any other person.\n</p><p>22.<b> Force Majeure</b></p><p>\n22.1. If performance of these Terms or any obligation under these Terms are prevented, restricted, or interfered with by causes beyond either Party’s reasonable control ( \n<b>Force Majeure</b>\n ), and if the Party unable to carry out its obligations gives the other Party prompt written notice of such event, then the obligations of the Party invoking this provision shall be suspended to the extent necessary by such event.&nbsp; The term Force Majeure shall include, without limitation, acts of God, fire, explosion, vandalism, storm or other similar occurrence, orders of acts of military or civil authority, or by national emergencies, insurrections, riots, or wars, or strikes, lock-outs, work stoppages. The excused party shall use reasonable efforts under the circumstances to avoid or remove such causes of non-performance and shall proceed to perform with reasonable dispatch whenever such causes are removed or ceased.&nbsp; An act or omission shall be deemed within the reasonable control of a party if committed, omitted, or caused by such party, or its employees, officers, agents, or affiliates.\n</p><p>23.<b> CONSENTS AND APPROVALS</b></p><p>\n23.1. Where these Terms provides that a Party may conditionally or unconditionally give or withhold any consent or approval in relation to any matter in these Terms, that Party may in its absolute discretion, and without being obliged to give reasons for doing so, withhold any consent or approval or give consent or approval conditionally or unconditionally.\n</p><p>24.<b> FURTHER ASSURANCE</b></p><p>\n24.1. Each Party must from time to time and in a timely manner do all things reasonably required of it by another Party to give effect to these Terms.\n</p><p>25.<b> ENFORCEABILITY</b></p><p>\n25.1. If any provision of these Terms are held by any competent authority to be invalid or unenforceable in whole or in part, the validity of the other provisions of these Terms and the remainder of the provisions in question will not be affected.\n</p><p>26.<b> ENTIRE AGREEMENT AND UNDERSTANDING</b></p><p>\n26.1. The date of these Terms are the date that these Terms are accepted by you.</p><p>\n26.2. In respect of the subject matter of these Terms:<ol type=\"a\"><li>\nthese Terms contain the entire understanding between the Parties; and</li><li>\nall previous oral and written communications, representations, warranties or commitments are superseded by these Terms and do not affect the interpretation or meaning of these Terms.\n</li></ol>27.<b> GOVERNING LAW AND JURISDICTION</b></p><p>\n27.1. These Terms are governed by the laws of New South Wales and the Commonwealth of Australia. Each Party irrevocably and unconditionally submits to the exclusive jurisdiction of the courts operating in New South Wales.\n</p><p>28.<b> DEFINITIONS</b></p><p><b>Insolvency Event</b>\n means the occurrence of any of the following events in which a Party:</p><p><ol type=\"a\"><li>\nis unable to pay its debt as they fall due;</li><li>\nmakes or commences negotiation with a view to making, a general rescheduling of its indebtedness, a general assignment, scheme or arrangement or composition with its creditors;\n</li><li>takes any corporate action or any steps are taken or legal proceedings are started for:</li><ol type=\"i\"><li>\nits winding-up, dissolution, liquidation or re-organisation, other than to reconstruct or amalgamate while solvent on terms approved by the other Party (which approval will not be unreasonably withheld); or\n</li><li>the appointment of a controller, receiver, administrator, office manager, trustee; or</li></ol><li>\nseeks protection or is granted protection from its creditors, under any applicable legislation.</li></ol></p><p><b>\nIntellectual Property Rights</b>\n includes any and all intellectual and industrial property rights throughout the world, whether subsisting now or in the future and includes all copyright and analogous rights, all rights in relation to inventions (including patent rights), registered and unregistered trademarks, designs (whether or not registered or registrable), circuit layout rights, trade names, trade secrets and know-how.\n</p><p><b>Personal Information</b>\n means personal information as defined in the Privacy Act 1988 (Cth) and includes health information.</p><br><hr><p>\n</p><h3 style=\"font-family: \'Cabin\', sans-serif;color: #636363;font-size: 18px\">\nFor any questions or notice, please contact InfoMedix at:</h3>InfoMedix Pty Ltd (ACN 093 160 653)<br>Level 2<br>\n451 Little Bourke Street<br>Melbourne, VIC 3000 Australia<br>Email: info@infomedix.com.au<br><p></p></div></md-content>\n</div></div></div></div></md-sidenav><md-sidenav md-component-id=\"privacy\" class=\"md-sidenav-right\"><div \nstyle=\"display: flex; flex-flow: column; height: 100%\"><div><md-toolbar layout=\"row\"><div class=\"md-toolbar-tools\">\n<md-button class=\"md-icon-button\" aria-label=\"Close Side Panel\" ng-click=\"$ctrl.closeSideNavPanelPrivacy()\"><md-icon \nmd-font-icon=\"icon-close-circle-outline\" class=\"icon\" style=\"color:#FFFFFF\"></md-icon></md-button><h2><span \nstyle=\"color:#FFFFFF;font-size: 16px;font-weight: 700\" class=\"hide-xs\">Clinivid Privacy Policy</span></h2><div \nclass=\"createpageHeaderButtons\" style=\"color: #ffffff;margin-left: auto\" class=\"hide-xs\"><md-icon \nmd-font-icon=\"icon-clock\" class=\"icon\" style=\"color:#FFFFFF\"></md-icon><strong><span style=\"color: #FFFFFF\">\nLast update: 15<span>th</span> June 2020</span></strong></div></div></md-toolbar></div><div \nstyle=\"min-height: 0; flex: 1; overflow: auto\"><div \nclass=\"page-layout off-white-bg carded fullwidth single-scroll layout-row\" layout=\"row\"><div class=\"center flex\">\n<md-content class=\"content ms-scroll md-default-theme\" ms-scroll=\"\"><div class=\"content\" \nstyle=\"text-align: justify;font-family: \'Work Sans\', sans-serif;font-size: 16px;color: #8c8c8c\"><p>\nThis Privacy Policy sets out InfoMedix Pty Ltd (ACN 093 160 653), its successors and assignees (referred to as we, us and our) commitment to protecting the privacy of your personal information that we collect through this website clinivid.com.au, the App (collectively the Site) or directly from you, being the person, organisation or entity that uses our Site (referred to as you or your).\n<br>\nPlease read this Privacy Policy carefully. Please contact us if you have any questions – our contact details are at the end of this Privacy Policy.\n<br>\nYou providing us with personal information indicates that you have had sufficient opportunity to access this Privacy Policy and that you have read and consented to it.\n<br>\nIf you do not wish to provide personal information to us, then you do not have to do so, however it may affect your use of this Site or any products and services offered on it.\n</p><h3 class=\"secondary-text\" \nstyle=\"font-family: \'Cabin\', sans-serif;color: #636363;font-size: 24px;font-weight: 500\">\n1. Collection of personal information</h3><p><b style=\"color:#010101\">Personal information:</b>\n We will collect the minimum amount of personal information possible in order to provide our services effectively. Payment data is not collected or held by us but is held by our payment facilitator, Braintree in the US. The type of information we collect may include:\n<ul><li style=\"list-style-type: initial\">name;</li><li style=\"list-style-type: initial\">images;</li><li \nstyle=\"list-style-type: initial\">contact details including email address, address and telephone number;</li><li \nstyle=\"list-style-type: initial\">date of birth;</li><li style=\"list-style-type: initial\">\ndemographic information such as postcode;</li><li style=\"list-style-type: initial\">preferences and opinions; and</li>\n<li style=\"list-style-type: initial\">\nany other information requested on this Site or otherwise requested by us or provided by you.</li></ul><br><b \nstyle=\"color:#010101\">Your use of our Site:</b>\n As with most online businesses, we may log information about your access and use of our Site, including through the use of Internet cookies, your communications with our Site, the type of browser you are using, the type of operating system you are using and the domain name of your Internet service provider.\n<br><b style=\"color:#010101\">Your opinion and feedback:</b>\n We may contact you to voluntarily respond to questionnaires, surveys or market research to seek your opinion and feedback. Providing this information is optional to you.\n<br>If we receive your personal information from third parties, we will protect it as set out in this Privacy Policy.\n</p><h3 class=\"secondary-text\" \nstyle=\"font-family: \'Cabin\', sans-serif;color: #636363;font-size: 24px;font-weight: 500\">\n2. Purpose of collection and use of personal information</h3><p>\nWe collect and use the information for purposes including:<ul><li style=\"list-style-type: initial\">\nto contact and communicate with you;</li><li style=\"list-style-type: initial\">for internal record keeping;</li><li \nstyle=\"list-style-type: initial\">for market research and business development including website development;</li><li \nstyle=\"list-style-type: initial\">for marketing including direct marketing;</li><li style=\"list-style-type: initial\">\nto improve your user experience; and</li><li style=\"list-style-type: initial\">for data analytics purposes.</li></ul>\n</p><h3 class=\"secondary-text\" \nstyle=\"font-family: \'Cabin\', sans-serif;color: #636363;font-size: 24px;font-weight: 500\">\n3. Disclosure of personal information to third parties</h3><p>We may disclose personal information to:<ul><li \nstyle=\"list-style-type: initial\">\ncredit reporting agencies and courts, tribunals and regulatory authorities where customers fail to pay for goods or services provided by us to them;\n</li><li style=\"list-style-type: initial\">\ncourts, tribunals, regulatory authorities and law enforcement officers as required by law, in connection with any actual or prospective legal proceedings, or in order to establish, exercise or defend our legal rights;\n</li><li style=\"list-style-type: initial\">\nthird parties, including agents or sub-contractors, who assist us in providing information, products, services or direct marketing to you. This may include parties located, or that store data, outside of Australia including BrainTree for payment management; and\n</li><li style=\"list-style-type: initial\">\nthird parties to collect and process data including Google Analytics. This may include parties that store data outside of Australia.\n</li></ul>\nWe may use Google Analytics to collect and process data. To find out how Google uses data when you use third party websites or applications, please see www.google.com/policies/privacy/partners/ or any other URL Google may use from time to time.To find out how Fabric uses data, please go to \n<a href=\"https://fabric.io/terms\">https://fabric.io/terms</a>.<br>\nWhere we disclose your personal information to third parties for these purposes, we will request that the third party follow this Privacy Policy regarding handling of your personal information.\n<br>\nIf there is a change of control of our business or a sale or transfer of business assets, we reserve the right to transfer to the extent permissible by law our user databases, together with any personal information and non-personal information contained in those databases. This information may be disclosed to a potential purchaser. We would seek to only disclose information in good faith.\n</p><h3 class=\"secondary-text\" \nstyle=\"font-family: \'Cabin\', sans-serif;color: #636363;font-size: 24px;font-weight: 500\">\n4. How we treat personal information that is also sensitive information</h3><p>\nSensitive information is a sub-set of personal information that is given a higher level of protection under the Australian Privacy Principles. In referring to ‘sensitive information’ we mean information that relates to your racial or ethnic origin, political opinions, religion, trade union or other professional associations or memberships, philosophical beliefs, sexual orientation or practices and criminal records, health information; or biometric information.\n<br>The type of sensitive information that we may collect includes:<ul><li style=\"list-style-type: initial\">\nHealth information about patients;</li><li style=\"list-style-type: initial\">\nProfessional associations or memberships of users; and</li><li style=\"list-style-type: initial\">\nProfessional registration identifiers of users.</li></ul>\nSensitive information will be used and disclosed for purposes relating to the primary purpose for which the sensitive information was collected, including:\n<ul><li style=\"list-style-type: initial\">Communication between treating clinicians (users) about a patient’s case; and\n</li><li style=\"list-style-type: initial\">Verification of users credentials and qualifications.</li><li \nstyle=\"list-style-type: initial\">Sensitive information may also be used or disclosed if required or authorised by law.\n</li></ul></p><h3 class=\"secondary-text\" \nstyle=\"font-family: \'Cabin\', sans-serif;color: #636363;font-size: 24px;font-weight: 500\">\n5. Your rights and controlling your personal information</h3><p><b style=\"color:#010101\">Choice and consent:</b>\n Providing us with your personal information is optional to you. You can choose not to provide personal information. When you provide us with your personal information, you consent to the terms in this Privacy Policy, and to us disclosing or receiving your personal information for these purposes.\n<br><b style=\"color:#010101\">Patient and Staff information:</b>\n Should you choose to enter, use or otherwise transmit patient’s, employee’s or sub-contractor’s or other stakeholder’s personal information through the Site, you warrant to us that you have obtained the patient’s, employee’s, sub-contractor’s, or stakeholder’s consent as applicable to disclose their personal information to our service for the purpose of us providing services.\n<br>\nYou warrant that where data contains any third party Personal Information, in order to post, upload, publish, transmit, store or otherwise use or disclose such Personal Information via the services, your and or applicable users, as required by applicable law has:\n<ul><li>\nprovided a consent form to such third party including but not limited to, where applicable, expressed consent to use any unique identifiers to link and match data from the services to patients’ records; and\n</li><li>obtained the requisite consent; and</li><li>\nonly to the extent necessary will you and your authorised users disclose data to other registered health practitioner(s) involved in the management of a particular third party case to which that data relates.\n</li></ul>You consent to us matching the data held on your systems with such data held by us<br><b \nstyle=\"color:#010101\">Restrict:</b>\n You may choose to restrict the collection or use of your personal information. If you have previously agreed to us using your personal information for direct marketing purposes, you can unsubscribe at any time by using \n<u>unsubscribe@clinivid.com.au</u><br><b style=\"color:#010101\">Access:</b>\n You may request details of personal information that we hold about you, in certain circumstances set out in the Privacy Act 1988 (Cth). An administrative fee may be payable for the provision of information. We may refuse to provide you with information that we hold about you, in certain circumstances set out in the Privacy Act. If patients request access to their personal information that you may have entered or transmitted through your account we will need to refer their request to you as we do not have access to your account for that purpose.\n<br><b style=\"color:#010101\">Correction:</b>\n If you believe that any information we hold about you is inaccurate, out of date, incomplete, irrelevant or misleading, please contact us by email. We rely in part upon users advising us when their personal information changes. We will respond to any request within a reasonable time. We will endeavour to promptly correct any information found to be inaccurate, incomplete or out of date. If patients request correction to their personal information that you may have entered or transmitted through your account we will need to refer their request to you as we do not have access to your account for that purpose.\n<br><b style=\"color:#010101\">Complaints:</b>\n If you believe that we have breached the Australian Privacy Principles and wish to make a complaint about that breach, please contact us by email setting out details of the breach. We will promptly investigate your complaint and respond to you in writing setting out the outcome of our investigation, what steps we propose to take to remedy the breach and any other action we will take to deal with your complaint.\n<br><b style=\"color:#010101\">Unsubscribe:</b>\n To unsubscribe from the service, please delete your account in your user profile. To unsubscribe from communication, please change your preferences in your profile or alternatively, send your request to \n<u>unsubscribe@clinivid.com.au</u>.</p><h3 class=\"secondary-text\" \nstyle=\"font-family: \'Cabin\', sans-serif;color: #636363;font-size: 24px;font-weight: 500\">6. Storage and Security</h3>\n<p>\nWe are committed to ensuring that the information you provide is secure. In order to prevent unauthorised access or disclosure, we have put in place suitable physical, electronic and managerial procedures to safeguard and secure the information and protect it from misuse, interference, loss and unauthorised access, modification and disclosure.\n<br>\nAlthough every effort is taken to secure your personal information no information transmitted over the Internet can be guaranteed to be absolutely secure. We cannot completely guarantee the security of any information that you transmit to us, or receive from us. Although we take measures to safeguard against unauthorised disclosures of information, we cannot assure you that personal information that we collect will not be disclosed in a manner that is inconsistent with this Privacy Policy.\n</p><h3 class=\"secondary-text\" \nstyle=\"font-family: \'Cabin\', sans-serif;color: #636363;font-size: 24px;font-weight: 500\">7. Cookies & Web Beacons</h3>\n<p>\nWe may use cookies on this Site from time to time. Cookies are text files placed in your computer\'s browser to store your preferences. Cookies, by themselves, do not tell us your e-mail address or other personally identifiable information. However, once you choose to furnish the Site with personally identifiable information, this information may be linked to the data stored in the cookie.\n<br>\nWe may use web beacons on this Site from time to time. Web beacons or clear.gifs are small pieces of code placed on a web page to monitor the visitors’ behaviour and collect data about the visitors viewing a web page. For example, web beacons can be used to count the users who visit a web page or to deliver a cookie to the browser of a visitor viewing that page.\n</p><h3 class=\"secondary-text\" \nstyle=\"font-family: \'Cabin\', sans-serif;color: #636363;font-size: 24px;font-weight: 500\">8. Links to other websites\n</h3><p>\nOur Site may contain links to other websites of interest. We do not have any control over those websites. We are not responsible for or liable for the protection and privacy of any information which you provide whilst visiting such websites, and such websites are not governed by this Privacy Policy.\n</p><h3 class=\"secondary-text\" \nstyle=\"font-family: \'Cabin\', sans-serif;color: #636363;font-size: 24px;font-weight: 500\">9. Amendments</h3><p>\nThis Privacy Policy may be amended, including with changes, additions and deletions, from time to time in our sole discretion. We may send you email notifications informing you of such changes, additions and deletions. Your continued use of our Site following any amendments indicates that you accept the amendments. You should check this Privacy Policy regularly, prior to providing personal information, to ensure you are aware of any changes, and only proceed to provide personal information if you accept the new Privacy Policy.\n</p><hr><p></p><h4 style=\"font-family: \'Cabin\', sans-serif;color: #636363;font-size: 18px\">\nFor any questions or notice, please contact our Privacy Officer at:</h4>InfoMedix Pty Ltd (ACN 093 160 653)<br>\nEmail: privacy@clinivid.com.au<p></p></div></md-content></div></div></div></div></md-sidenav></div><style>\n#content-container{\n    background-image: linear-gradient(to bottom, rgba(202, 234, 255, 0.97), #ffffff 80%);\n  }\n  .label-cbx {\n    user-select: none;\n    cursor: pointer;\n    margin-bottom: 0;\n  }\n  .label-cbx input:checked + .checkbox {\n    border-color: #20C2E0;\n  }\n  .label-cbx input:checked + .checkbox svg path {\n    fill: #20C2E0;\n  }\n  .label-cbx input:checked + .checkbox svg polyline {\n    stroke-dashoffset: 0;\n  }\n  .label-cbx:hover .checkbox svg path {\n    stroke-dashoffset: 0;\n  }\n  .label-cbx .checkbox {\n    position: relative;\n    top: 2px;\n    float: left;\n    margin-right: 8px;\n    width: 20px;\n    height: 20px;\n    border: 2px solid #C8CCD4;\n    border-radius: 3px;\n  }\n  .label-cbx .checkbox svg {\n    position: absolute;\n    top: -2px;\n    left: -2px;\n  }\n  .label-cbx .checkbox svg path {\n    fill: none;\n    stroke: #20C2E0;\n    stroke-width: 2;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    stroke-dasharray: 71px;\n    stroke-dashoffset: 71px;\n    transition: all 0.6s ease;\n  }\n  .label-cbx .checkbox svg polyline {\n    fill: none;\n    stroke: #FFF;\n    stroke-width: 2;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    stroke-dasharray: 18px;\n    stroke-dashoffset: 18px;\n    transition: all 0.3s ease;\n  }\n  .label-cbx > span {\n    pointer-events: none;\n    vertical-align: middle;\n  }\n\n  .cntr {\n    position: absolute;\n    top: 45%;\n    left: 0;\n    width: 100%;\n    text-align: center;\n  }\n\n  .invisible {\n    position: absolute;\n    z-index: -1;\n    width: 0;\n    height: 0;\n    opacity: 0;\n  }\n</style>");
$templateCache.put("app/user/auth/logout-user.html","<div class=\"see\">Logging out</div>");
$templateCache.put("app/user/auth/register.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page off-white-bg\" layout=\"column\"><md-content><div \nclass=\"content\" layout=\"column\"><div layout=\"column\" layout-align=\"center center\"><span style=\"color: #92298C\" \nclass=\"md-title mt-32\"><strong>Clinician Registration </strong></span><span style=\"color: #92298C\" class=\"pb-16\">\n<strong>\nIf you are a registered health practitioner in Australia, please enter your details to start using Clinivid to securely exchange patient information with other clinicians from your phone, tablet or desktop computer.\n</strong></span></div><div layout=\"row\"><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1\n</span> <span class=\"ms-form-wizard-step-number secondary-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">Login Details</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div><div layout=\"column\" \nlayout-align=\"center center\"><span style=\"color: #92298C\" class=\"md-title mt-32\"><strong>\nAre you an AHPRA registered clinician?</strong></span></div><md-radio-group ng-model=\"$ctrl.form.isPractitioner\" \nclass=\"md-primary\" layout=\"row\" layout-align=\"center center\"><md-radio-button ng-value=\"true\" style=\"margin: 0 16px\">\nYes</md-radio-button><md-radio-button ng-value=\"false\" style=\"margin: 0 16px\">No</md-radio-button></md-radio-group><p \nclass=\"text-center\" ng-if=\"$ctrl.form.isPractitioner == false\">\nWe are sorry, Clinivid is currently only available to registered practitioners in Australia.</p></div><div \nng-if=\"$ctrl.form.isPractitioner\"><span style=\"color: #92298C\" class=\"md-title mt-16\"><strong>Create your login\n</strong></span><md-input-container class=\"md-block\"><input type=\"email\" name=\"email\" \nng-model=\"$ctrl.form.person.email\" translate translate-attr-placeholder=\"REGISTER.EMAIL\" aria-label=\"Email\" \nng-pattern=\"/^.+@.+\\..+$/\" ng-disabled=\"$ctrl.form.lock1\" required><div ng-messages=\"wizardStep1.email.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.EMAIL_REQUIRED\">Email is required.</span>\n</div><div ng-message=\"pattern\"><span translate=\"REGISTER.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address\n</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"password\" name=\"password\" ng-model=\"$ctrl.form.person.password\" aria-label=\"Password\" \nng-minlength=\"8\" ng-maxlength=\"30\" translate translate-attr-placeholder=\"REGISTER.PASSWORD\" \nng-disabled=\"$ctrl.form.lock1\" required><div ng-messages=\"wizardStep1.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"REGISTER.ERRORS.PASSWORD_REQUIRED\">Password field is required.</span></div><div \nng-message=\"maxlength\"><span>Too many characters.</span></div><div ng-message=\"minlength\"><span>8 characters minimum.\n</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"password\" \nname=\"passwordConfirm\" ng-model=\"$ctrl.form.person.confirmPassword\" aria-label=\"Confirm Password\" translate \ntranslate-attr-placeholder=\"REGISTER.PASSWORD_CONFIRM\" ng-disabled=\"$ctrl.form.lock1\" match-password=\"password\" \nrequired><div ng-messages=\"wizardStep1.passwordConfirm.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"REGISTER.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required\n</span></div><div ng-message=\"passwordMatch\"><span>Your passwords did not match</span></div></div></md-input-container>\n</div><div class=\"terms\" layout=\"row\" layout-align=\"center center\"><md-checkbox name=\"terms\" \nng-model=\"$ctrl.form.accept\" aria-label=\"I read and accept\" required></md-checkbox><span>I read and accept the&nbsp;\n</span><md-button class=\"md-accent\" ng-click=\"$ctrl.openRightMenu()\">terms of service</md-button></div></div></form>\n</md-tab-body></md-tab><md-tab \nng-disabled=\"wizardStep1.$invalid || ($ctrl.form.isPractitioner == false) || !$ctrl.showRegistrationDetailsStep\">\n<md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number secondary-bg\" ng-if=\"wizardStep2.$valid\">\n<i class=\"icon-check s16\"></i> </span><span class=\"ms-form-wizard-step-text\">Your Details</span></span></md-tab-label>\n<md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form novalidate><span style=\"color: #92298C\" \nclass=\"md-title mt-16\"><strong>Tell us who you are</strong></span><br><span style=\"color: #92298C;font-style:italic\" \nclass=\"pb-16\"><strong>\nPlease enter the same details as used for your Australian Health Practitioner Regulation Agency (AHPRA) registration, so we can verify you.\n</strong></span><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"\" class=\"flex md-default-theme\">\n<label for=\"select_55\" class=\"md-placeholder\">Title</label><md-select ng-model=\"$ctrl.form.person.title\" \nclass=\"ng-pristine ng-valid md-default-theme ng-empty ng-touched\" tabindex=\"0\" aria-disabled=\"false\" role=\"listbox\" \naria-expanded=\"false\" aria-multiselectable=\"false\" id=\"select_55\" aria-owns=\"select_container_56\" aria-invalid=\"false\" \naria-label=\"Title\"><md-option ng-value=\"title\" ng-repeat=\"title in $ctrl.context.titles\">{{ title }}</md-option>\n</md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Lastname</label><input \ntype=\"text\" name=\"lastname\" ng-model=\"$ctrl.form.person.lastname\" ng-maxlength=\"50\" required><div \nng-messages=\"wizardStep2.lastname.$error\" ng-show=\"wizardStep2.lastname.$touched\" role=\"alert\" multiple=\"multiple\"><div\n ng-message=\"required\"><span>Lastname is required.</span></div><div ng-message=\"maxlength\"><span>Too many characters.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>\nFirstname</label><input type=\"text\" name=\"firstname\" ng-model=\"$ctrl.form.person.firstname\" ng-maxlength=\"50\" required>\n<div ng-messages=\"wizardStep2.firstname.$error\" ng-show=\"wizardStep2.firstname.$touched\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Firstname is required.</span></div><div ng-message=\"maxlength\">\n<span>Too many characters.</span></div></div></md-input-container><md-input-container flex><label>Middle Names</label>\n<input type=\"text\" name=\"middlenames\" ng-model=\"$ctrl.form.person.middleName\" ng-maxlength=\"100\"><div \nng-messages=\"wizardStep2.middlenames.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"maxlength\"><span>\nToo many characters.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"30\"><label>Pick country and enter mobile number</label>\n<input style=\"border: 2px solid #92298C; border-radius: 4px\" auto-format=\"false\" type=\"text\" \nname=\"mobile_number_registration\" id=\"mobile_number_registration\" only-countries=\"au, in, nz\" \ninternational-phone-number ng-model=\"$ctrl.form.person.mobile\" preferred-countries=\"au\" required \nauto-placeholder=\"off\" placeholder=\"Enter mobile number\"><div \nng-messages=\"wizardStep2.mobile_number_registration.$error\" ng-show=\"wizardStep2.mobile_number_registration.$touched\" \nrole=\"alert\"><div ng-message=\"pattern\"><span>Invalid characters or number.</span></div><div ng-message=\"maxlength\">\n<span>Too many digits.</span></div><div ng-message=\"minlength\"><span>Not enough digits.</span></div><div \nng-message=\"required\"><span>Mobile no. is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"35\"><label>AHPRA Registration No.</label><input type=\"text\" \nname=\"registrationId\" ng-model=\"$ctrl.form.person.registrationId\" ng-maxlength=\"13\" required \nng-pattern=\"/[A-Z]{3}[0-9]{7,10}/\"><div ng-messages=\"wizardStep2.registrationId.$error\" \nng-show=\"wizardStep2.registrationId.$touched\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nAHPRA Registration No is required.</span></div><div ng-message=\"maxlength\"><span>Too many characters.</span></div><div \nng-message=\"pattern\"><span>\nThat doesn\'t look like a valid AHPRA Registration No. Must be 3 Capital letters followed by 10 digits</span></div>\n</div><div class=\"mt-5\"><a href=\"http://www.ahpra.gov.au/Registration/Registers-of-Practitioners.aspx\" target=\"_blank\">\nHelp me find my AHPRA No.</a></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"35\">\n<label>Profession</label><input type=\"text\" name=\"profession\" ng-model=\"$ctrl.form.person.profession\">\n</md-input-container></div><br><br><br><br><br><br></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" \nflex layout=\"row\" layout-align=\"center center\" ng-if=\"msWizard.selectedIndex == 0\"><div class=\"steps\"><span \nng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div>\n</div><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nng-if=\"msWizard.selectedIndex != 0\" class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" \nng-disabled=\"msWizard.isFirstStep()\">Previous</md-button><div class=\"steps\" ng-if=\"msWizard.selectedIndex != 0\"><span \nng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div>\n<md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.next(msWizard)\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid() || !$ctrl.form.isPractitioner\">Next</md-button><md-button \nclass=\"md-raised md-accent secondary-bg\" ng-click=\"$ctrl.next(msWizard)\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.formsIncomplete()\">Send</md-button></div></ms-form-wizard></div></div></md-content><section \nclass=\"no-padding-bottom\" ng-show=\"$ctrl.showCallToAction\"><div class=\"cta cta-image-bg\"><div class=\"overlay\"></div>\n<div class=\"container\"><h2 class=\"heading\">Start your free trial now</h2><div class=\"cta-wrapper\"><a \nhref=\"https://apps.apple.com/us/app/clinivid/id1518793065\" \nstyle=\"text-align: center; display: inline-block; overflow: hidden; background: url(https://linkmaker.itunes.apple.com/images/badges/en-us/badge_appstore-lrg.svg) no-repeat; width: 135px; height: 40px\">\n</a> <a \nhref=\"https://play.google.com/store/apps/details?id=hci.clinivid.android.x2&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1\" \nstyle=\"line-height: 30px\"><img alt=\"Get it on Google Play\" \nsrc=\"https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png\" \nstyle=\"vertical-align: bottom;\n                    height: 60px\"></a></div></div></div></section><md-sidenav \nmd-component-id=\"right\" class=\"md-sidenav-right\"><div style=\"display: flex; flex-flow: column; height: 100%\"><div>\n<md-toolbar layout=\"row\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" aria-label=\"Close Side Panel\" \nng-click=\"$ctrl.closeSideNavPanel()\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#FFFFFF\"></md-icon></md-button><h2><span style=\"color:#FFFFFF\">Terms of Service</span></h2><div \nclass=\"createpageHeaderButtons\" style=\"color: #ffffff;margin-left: auto\"><md-icon md-font-icon=\"icon-clock\" \nclass=\"icon\" style=\"color:#FFFFFF\"></md-icon><strong><span style=\"color: #FFFFFF\">Last update: 2<span>nd</span>\n March 2018</span></strong></div></div></md-toolbar></div><div style=\"min-height: 0; flex: 1; overflow: auto\"><div \nclass=\"page-layout off-white-bg carded fullwidth single-scroll layout-row\" layout=\"row\"><div class=\"center flex\">\n<md-content class=\"content ms-scroll md-default-theme\" ms-scroll=\"\"><div class=\"content\"><p></p><p></p>\nThese Terms of Service (<b>Terms</b>\n) are between Health Care Innovate Pty Ltd (ABN 60 986 620 449), its successors and permitted assigns (referred to as \n<b>Health Care Innovate</b>) and each individual user subject to these Terms (referred to as <b>you</b> or <b>your</b>\n), collectively referred to as the <b>Parties</b> and each a <b>Party</b>\n. These Terms govern your access to and use of the Clinivid communication platform (<b>Platform</b>\n) and any related services made available to you (together with the Platform referred to as <b>Services</b>\n). The Services are accessible via supported web browsers (<b>Website</b>\n), a third party software where integrated with the Clinivid platform, or via the Clinivid application (<b>App</b>\n) on any mobile, tablet, console or other devices which supports the App and Website. You may be a user with: (i) your own individual Account (\n<b>Individual Account Holder</b>\n); and or (ii) an Account/s created for you by our enterprise customers which have an enterprise subscription with us (\n<b>Authorised User</b>).<p></p><p><b>\nHEALTH CARE INNOVATE DOES NOT COLLECT OR SOLICIT ANY PERSONAL INFORMATION VIA THE SERVICES WHICH MIGHT BE UNLAWFUL, UNNECESSARY, EXCESSIVE, INTRUSIVE OR UNRELATED TO THE FUNCTIONS OF THE SERVICES. THE SERVICES ARE DEPENDENT ON A NUMBER OF FACTORS AND PROVIDED TO YOU ON AN “AS IS” BASIS. THE SERVICES ARE NOT A SUBSTITUTE FOR ANY SYSTEMS FOR ADMINISTERING MEDICINE OR MEDICAL ADVICE, PATIENT RECORDS OR ANY PRACTICE MANAGEMENT SYSTEMS USED BY YOU AND YOU MUST NOT RELY ON THE SERVICES TO TRANSMIT ANY INFORMATION ON AN URGENT BASIS OR ANY INFORMATION RELATING TO A LIFE THREATENING SITUATION. PLEASE REFER TO CLAUSE 15 FOR HEALTH CARE INNOVATE’S FULL DISCLAIMER.\n</b></p><p>1.<b> ACCEPTANCE </b><b></b></p><p>\n1.1. These Terms form a binding legal agreement between the Parties. By accessing and using the Services, you agree to comply with and be legally bound by these Terms. Please read these Terms carefully. If you have any questions, you should contact Health Care Innovate using the contact details at the end of these Terms.\n</p><p>\n1.2. You acknowledge and agree to these Terms by: (i) ticking ‘I Agree’; (ii) accessing or using the Services whether via the App, Website or otherwise; or (iii) making part or full payment for the Services. If you do not agree to these Terms, you should cease accessing or using the App, Services and Website.\n</p><p>\n1.3. Health Care Innovate reserves the right to make changes to these Terms at any time, effective upon the posting of modified Terms. Health Care Innovate will endeavour to communicate these changes to the Users via email, App or Website. It is your obligation to ensure that you have read, understood and agree to the most recent Terms available on the App or Website.\n</p><p>\n1.4. Using the Services may be prohibited or restricted in certain countries. If you use the Services outside of Australia, you are responsible for complying with the laws and regulations of the territory from which you access or use the Services.\n</p><p>2.<b> PRIVACY AND ADDITIONAL TERMS</b></p><p>\n2.1. These Terms supplement and incorporate the Privacy Policy as set out on the App and Website. You will be taken to have read the terms of the Privacy Policy when you accept these Terms.\n</p><p>\n2.2. Health Care Innovate agrees to comply with the Privacy Act 1988 (Cth) including the Australian Privacy Principles, the Health Records and Information Privacy Act 2002 (NSW) where applicable and any other applicable legislation or privacy guidelines as amended from time to time. Please refer to Health Care Innovate’s Privacy Policy for details on how we store and use Personal Information.\n</p><p>3.<b> PLATFORM AND SERVICES</b></p><p>\n3.1. You can access and use the Services on any computer, mobile, tablet or other device (<b>Device</b>\n ) which supports the App or Website, or where the Services are integrated, from a 3<sup>rd</sup>\n party software. Health Care Innovate recommends each User accesses the App and Website using the recommended browsers or Devices as notified to you.\n</p><p>3.2	<b>Applicable to Individual Account Holders</b>\n: To access the App and some Services you must register for an account (<b>Account</b>\n) and complete Health Care Innovate’s registration form as set out on the App or Website (<b>Registration Form</b>\n). The Registration Form may require your first, middle and last name (as applicable), mobile number, email address and other related information which will be used to generate your Account profile (\n<b>User Information</b>).</p><p>\n3.3. If you are an Individual Account Holder and an Authorised User, you may alternate your profile between the Account you hold as an Individual Account Holder and the account/s you hold as an Authorised User.\n</p><p>3.4. <b>Applicable to Individual Account Holders</b>\n: Access to all Services and features on the App and Website will require you to subscribe to the Services (<b>\nSubscription</b>) for a period of time as set out on the App or Website (<b>Subscription Period</b>\n). The fees for each Subscription Period (<b>Subscription Fee</b>\n) will vary subject to the functionalities and Services you request as identified in your Account.</p><p>\n3.5. Any information or content you submit via the Services, including but not limited to photos, videos, audio, User Information or information or content which passes through the Platform whether it contains Personal Information or otherwise (collectively referred to as Data) are stored in servers located in Australia. Health Care Innovate will take reasonable steps and use industry standard procedures to ensure that Data is kept secure and confidential. Such Data does not include any data you submit through our third party service provider including our third party payment service provider, Braintree.\n</p><p>3.6	You represent and warrant that:<br><ol type=\"a\"><li>\nany and all Data you submit (or a User submits) via the Services are your sole and exclusive property; or</li><li>\nyou have secured any and all authorisation and rights to use the Data as applicable under the relevant laws.</li></ol>\n</p><p>3.7	Subject to your Device, you may be able to activate finger print recognition (<b>Fingerprint Login</b>\n) to access and use the Services via the Application. If you activate Fingerprint Login, you understand the need to protect your Device and if you have other people’s fingerprints registered in your Device, they will also have access to your Account and Services.\n</p><p>\n3.8	You acknowledge and agree that the operation of the Services may rely on third party application or services and your use of the Services may be subject to third party terms, including but not limited to Braintree Terms of Service as notified to you on our App and Website.\n</p><p>4.	<b>SECURITY</b></p><p>\n4.1	Health Care Innovate has implemented and will maintain security systems for the transmission and storage of Data consisting of encryption and data security technologies that are understood in the industry to provide adequate security for the transmission of such information over the Internet. These measures are intended to prevent unauthorised Data infiltration or security breaches. Health Care Innovate does not guarantee the security of any Data you store on your servers or Device(s).\n</p><p>5.<b> UPDATES AND AVAILABILITY OF SERVICES</b></p><p>\n5.1. Health Care Innovate may issue updates to the Services (<b>Updates</b> ) from time to time.</p><p>\n5.2. Although Health Care Innovate endeavours to provide access to the Services should be available on a full-time basis, the Services may be unavailable due to maintenance or other development activity from time to time.\n</p><p>\n5.3. Where possible, Health Care Innovate will provide you with notice of any maintenance or development activity via email, App and Website.\n</p><p>6.<b> OFFERS AND PROMOTIONS</b></p><p>\n6.1. Health Care Innovate may, from time to time, make offers or promotions which may be applicable to the Services including but not limited to a free trial period to use the Services and create a limited number of cases ( \n<b>Trial Period</b>\n ). If any additional terms and conditions apply to such offers or promotions, these will be set out on the App, Website or otherwise notified to you via the Services.\n</p><p>7.<b> YOUR OBLIGATONS</b></p><p>7.1. You represent and warrant that:<ol type=\"a\"><li>\nby submitting your User Information and creating an Account, you are a health practitioner in Australia with a current registration with the Australian Health Practitioner Regulation Agency ( \n<b>AHPRA</b>);</li><li>all User Information provided to Health Care Innovate is true, accurate and complete;</li><li>\nany content or Data you post or submit via the Services or the posting, uploading, publication or transmission of the Data:\n</li><ol type=\"i\"><li>will not breach any agreements between you and any third party;</li><li>\nwill be in compliance with all applicable laws, requirements, rules and regulation that may apply to any third party in their state or territory; and\n</li><li>will not conflict with the rights of third parties;</li></ol><li>\nwhere Data contains any third party Personal Information, in order to post, upload, publish, transmit or otherwise use or disclose such Personal Information via the Services, you have:\n<ol type=\"i\"><li>\nprovided a consent form to such third party including but not limited to, where applicable, expressed consent to use any unique identifiers to link Data from the Services to your patients’ records; and\n</li><li>obtained the requisite consent; and</li></ol></li><li>\nonly to the extent necessary will you disclose Data to other registered health practitioner(s) involved in the management of a particular third party case to which that Data relates.\n</li></ol>7.2. You acknowledge and agree that you are responsible for how you use the Services and that:<ol type=\"a\">\n<li>you use the Services, App and Website at your own risk;</li><li>\nshould you use Fingerprint Login to access the Application, you are solely responsible for any access or use of your Account or Services via Fingerprint Login, whether such access or use are by you or anyone else whose fingerprint is saved on your Device.\n</li><li>you consent to Health Care Innovate checking your User Information against the AHPRA register;</li><li>\nHealth Care Innovate is not responsible for any corruption or loss of any Data if such corruption or loss is due to an act or omission by you, your employee(s), contractor(s), agent(s) or any third party;\n</li><li>\nHealth Care Innovate reserves the right to access and/or delete your Data at any time and for any reason including if Health Care Innovate reasonably believes your Data violates these Terms or infringe any law or regulation; and\n</li><li>you are solely responsible for:</li><ol type=\"i\"><li>\nany Data you upload or otherwise transmit via the Services; and</li><li>\ncomplying with all laws and regulations regarding the use and disclosure of Personal Information including but not limited to the Privacy Act 1988 (Cth) and the Australian Privacy Principles (including but not limited to APP 8 - Cross-border disclosure of personal information) as amended from time to time, the Spam Act 2003 (Cth) and any other requirements under Australian law.\n</li></ol><li>the Services must only be used for your own lawful purposes and in accordance with these Terms;</li><li>\nthe accessibility and reliability of the Services is dependent on your choice of web-browser, internet connection, Device operating system and your internet connection;\n</li><li>all usernames and passwords required to access the Account and Services are kept secure and confidential;</li>\n<li>\nif there is any unauthorised use of your passwords or any other breach of security, you will immediately notify Health Care Innovate of such activity; and\n</li><li>\nit is your responsibility to determine that the Services meet your needs and are suitable for the purposes for which the Services are used.\n</li></ol>\n7.3. Health Care Innovate has no responsibility to any person or entity other than you and nothing in these Terms confer, or purport to confer, a benefit on any person or entity other than you. If you use the Platform on behalf of or for the benefit of anyone other than yourself, you agree that:\n<ol type=\"a\"><li>you are responsible for ensuring that you have the right to do so;</li><li>\nHealth Care Innovate does not warrant the fitness for purpose or suitability of the Platform for any third party’s purpose and third parties may not rely on Health Care Innovate for any purpose;\n</li><li>\nyou are responsible for authorising any person who is given access to your Data, and you agree that, subject to any requirements by law or regulation including but not limited to the obligation to grant any third party access to any of your Data to which their Personal Information relates, Health Care Innovate has no obligation to provide any person or entity with access to such Data without authorisation from you and we may refer any requests for access to the Data to you to address; and\n</li><li>\nyou will indemnify Health Care Innovate, on first demand, against any and all claims, expenses, liabilities or losses arising out of in connection with Health Care Innovate’s refusal to provide any persons with access to your Data (including but not limited to any patient data) in accordance with these Terms and Health Care Innovate making Data available to any person with authorisation from you.\n</li></ol>\n7.4. You remain solely responsible for complying with all applicable laws. It is your responsibility to ensure that the storage of and access to your Data via the Services complies with any laws which are applicable to you, including any laws requiring you to maintain or retain records, maintain confidentiality and accuracy and protect the privacy of your Data. If you would like information in relation to how Health Care Innovate stores and collects Data, please contact Health Care Innovate using the details at the bottom of these Terms.\n</p><p>8.<b> PAYMENT (Applicable to Individual Account Holders)</b></p><p>\n8.1. You agree to pay Health Care Innovate the applicable Subscription Fees upfront as required to enable you to access and use the Services.\n</p><p>\n8.2. You will be required to make payment by way of credit card, PayPal or other payment methods as set out on the App and Website. The initial payment will be processed (a) upon receipt of the request for a Subscription; or (b) subject to any offers and promotions, immediately upon using up any limit prescribed to the Trial Period. You must make further payments prior to the expiry of your Subscription on the relevant periodic basis.\n</p><p>8.3. You acknowledge and agree that:<ol type=\"a\"><li>\nto maintain your subscription and subject to your elected payment method, payment to Health Care Innovate will be made automatically in advance on a monthly payment date, from your nominated PayPal account; and\n</li><li>\nas you have allowed Health Care Innovate and its payment service provider to automatically direct debit your nominated credit card or other payment account, if the direct debit service provider is unable to process payment, Health Care Innovate’s payment service provider will attempt to contact you via email as soon as it is aware of the payment failure. Until payment is confirmed, your access to the Services may be suspended until Health Care Innovate and its payment service provider receives confirmation of payment.\n</li></ol>\n8.4. If you make a payment by way of credit card, you warrant that the information you provide to Health Care Innovate and its payment service provider is true and complete, that you are authorised to use the credit card to make payment and that your payment will be honoured by your card issuer.\n</p><p>\n8.5. If payment is not made within 30 days of the last payment date, Health Care Innovate may lock your Account without notice to you, in which case you will not be able to access your Account or use the Services, and any Data on the Account may be deleted and not recoverable.\n</p><p>\n8.6. All amounts are stated in Australian dollars and unless otherwise stated, all amounts are exclusive of goods and services tax (\n<b>GST</b>).</p><p>\n8.7. Health Care Innovate’s pricing structure or payment methods may be amended from time to time in its sole discretion.\n</p><p>9.<b> CANCELLATION AND TERMINATION</b></p><p>9.1	<b>Applicable to Individual Account Holders</b>\n: If you would like to cancel your Subscription, you may do so by notifying Health Care Innovate through your Account using the App or Website (\n<b>Cancellation Request</b>\n). Your access to your Account and any Data will be terminated at the end of the Subscription Period month following your Cancellation Request and you will not be charged any further Subscription Fees to your payment account.\n</p><p>9.2. Health Care Innovate may terminate these Terms or your Account immediately, in its sole discretion, if:<ol \ntype=\"a\"><li>you breach any of these Terms;</li><li>\nHealth Care Innovate reasonably suspects that you are attempting to reverse engineer the Platform that is provided to you;\n</li><li>Health Care Innovate, at its own discretion, terminates the Services; or</li><li>\nfor any other reason outside Health Care Innovate’s control which has the effect of compromising its ability to provide you with the Services within a required timeframe.\n</li></ol>\n9.3. On termination of the Services and these Terms, Health Care Innovate may retain your Data and related documents (including copies) as required to facilitate the Services to other users, by law or regulation. Your express or implied agreement to the Terms constitutes your authority for Health Care Innovate to retain or destroy such documents and records in accordance with the statutory periods, or on termination of these Terms.\n</p><p>10.<b> PROHIBITED USE</b></p><p>10.1. You acknowledge and agree that you will not:<ol type=\"a\"><li>\nuse the Services in any manner that is illegal or violates any applicable rights (e.g. right to privacy), law or regulation;\n</li><li>\ntransmit via the Services any Personal Information including Personal Information relating to your patient which are unlawful, unnecessary, excessive, intrusive or unrelated to the functions of the Services;\n</li><li>\nattempt to circumvent or disable the Services or any technology features or measures in the Platform by any means or in any manner;\n</li><li>\nattempt to modify, copy, adapt or reproduce the Data, Services or App except as necessary for normal operation;</li>\n<li>\nattempt to decompile, disassemble, reverse engineer, or otherwise attempt to derive the source code for the Platform or App;\n</li><li>\nupload any Data including any content that is defamatory, obscene, pornographic, vulgar, offensive, promotes discrimination, bigotry, racism, harassment or harm against any individual or group;\n</li><li>\ndistribute, encumber, sell, rent, lease, sub-license, or otherwise transfer, publish or disclose the Data or Services to any third party (except as permitted under these Terms);\n</li><li>\nremove or alter any trademark, logo, copyright or other proprietary notices, legends, symbols or labels in or on the App, Platform or Website or otherwise used in connection with the Services;\n</li><li>\nuse the Services in any manner to aid in the violation of any third party Intellectual Property Rights, including but not limited to another’s copyrights, trade marks, and patents;\n</li><li>\ntake any action that interferes, in any manner, with Health Care Innovate’s rights with respect to the Services;</li>\n<li>\nattempt to undermine the security or integrity of Health Care Innovate’s computing systems or where the Services are hosted by a third party, that third party’s computing systems and networks; and\n</li><li>\nuse, or misuse, the Services in any way which may impair the functionality of the Services, App, Website or other systems used to deliver the Platform or impair the ability of any other user to use the Services, App or Website.\n</li></ol>\n10.2. You acknowledge that any breaches of this clause or the Terms generally may lead to termination of these Terms and cancellation of your Account.\n</p><p>11.<b> INTELLECTUAL PROPERTY</b></p><p>\n11.1. Heath Care Innovate holds the title to, or otherwise holds the licence to all Intellectual Property Rights in the Platform, Services, and any documentation relating to the Platform and these remain the property of Health Care Innovate and any other applicable owner. Your right to use such Intellectual Property Rights is subject to these Terms.\n</p><p>\n11.2. Title, ownership rights and Intellectual Property Rights in and to any content displayed on the Services, App or Website, or accessed through the Services, App or Website are the property of the applicable content owner and may be protected by applicable copyright or other law. These Terms give you no rights to such content.\n</p><p>11.3. You grant Health Care Innovate a non-exclusive, worldwide, royalty free, irrevocable licence to:<ol \ntype=\"a\"><li>\nuse any Intellectual Property Rights which subsists in any materials you provide in connection with your Account or the Services as required for Health Care Innovate to provide the Services to you; and\n</li><li>\nto any Intellectual Property Rights subsisting in your Data in order to host, store, use, copy, display, transmit, reference, disclose, reproduce, modify, adapt, edit, publish and distribute your Data or otherwise for purposes including:\n</li><ol type=\"i\"><li>to enable you to access and use the Services;</li><li>\nfor Health Care Innovate’s administrative, support and training purposes; and</li><li>\nin accordance with these Terms or as otherwise required for Health Care Innovate to develop, provide and improve the Services.\n</li></ol></ol>\nWhere such Data contains your Personal Information, Health Care Innovate will use your Data for purposes consistent with its Privacy Policy.\n</p><p>\n11.4. Title to and all Intellectual Property Rights in any Data you input into the Services remain your property. However, your access to the Data and continued use of the Services is contingent on payment of your Subscription Fee for your Subscription.\n</p><p>\n11.5. As the operation of the Services may rely on third party application or services, you acknowledge that Health Care Innovate may allow providers of these third party-application to access any inputted Data as required for the interoperation of such third party applications with the Services. Health Care Innovate is not responsible for any disclosure, modification or deletion of Data resulting from any such access by third-party application providers.\n</p><p>12.<b> FEEDBACK AND DISPUTE RESOLUTION</b></p><p>\n12.1. Your feedback is important to Health Care Innovate. Health Care Innovate seeks to resolve your concerns quickly and effectively. If you have any feedback or questions about the Services, please contact Health Care Innovate using the details at the end of these Terms.\n</p><p>\n12.2. If there is a dispute between the Parties in relation to these Terms or the Services, the Parties agree to the following dispute resolution procedure:\n<ol type=\"a\"><li>\nThe complainant must tell the respondent in writing, the nature of the dispute, what outcome the complainant wants and what action the complainant thinks will settle the dispute. The Parties agree to liaise with each other in good faith to seek to resolve the dispute by agreement between them ( \n<b>Initial Discussion</b> ).</li><li>\nIf the Parties cannot agree how to resolve the dispute at the Initial Meeting, any Party may refer the matter to a mediator. If the parties cannot agree on who the mediator should be, the complainant will ask the Law Society of New South Wales to appoint a mediator. The mediator will decide the time and place for mediation. The Parties must attend the mediation in good faith, to seek to resolve the dispute.\n</li></ol>\n12.3. Any attempts made by the Parties to resolve a dispute pursuant to this clause are without prejudice to other rights or entitlements of the Parties under these Terms, by law or in equity.\n</p><p>13.<b> AUSTRALIAN CONSUMER LAW</b></p><p>13.1. Certain legislation including the Australian Consumer Law (<b>ACL\n</b>\n ) in the Competition and Consumer Act 2010 (Cth), and similar consumer protection laws and regulations may confer you with rights, warranties, guarantees and remedies relating to the provision of Services by Health Care Innovate to you which cannot be excluded, restricted or modified ( \n<b>Statutory Rights</b> ).</p><p>\n13.2. If you are a consumer, nothing in these Terms remove your Statutory Rights as a consumer under the ACL. You agree that Health Care Innovate’s liability for Services provided to consumers is governed solely by the ACL and these Terms. Health Care Innovate excludes all conditions and warranties implied by custom, law or statute except for your Statutory Rights.\n</p><p>\n13.3. Except for your Statutory Rights, all material and work is provided to you without warranties of any kind, either express or implied; and Health Care Innovate expressly disclaims all warranties of any kind including but not limited to implied warranties of merchantability and fitness for a particular purpose.\n</p><p>13.4. If you are a consumer as defined in the ACL, the following applies to you:<b>\n We guarantee that the services we supply to you are rendered with due care and skill; fit for the purpose that we advertise, or that you have told us you are acquiring the services for or for a result which you have told us you wish the services achieve, unless we consider and disclose that this purpose is not achievable; and will be supplied within a reasonable time. To the extent we are unable to exclude liability; our total liability for loss or damage you suffer or incur from our services is limited to us re-supplying the services to you, or, at our option, us refunding to you the amount you have paid us for the services to which your claim relates.\n</b></p><p>14.<b> LIMITATION OF LIABILITY AND DISCLAIMERS</b></p><p>\n14.1. You acknowledge that whilst Health Care Innovate will take reasonable steps to ensure that the Services will be fit for the advertised purpose, to the fullest extent permitted by law, Health Care Innovate does not guarantee that:\n<ol type=\"a\"><li>\nthe Services will meet your requirements as the functionality of the Services is dependent upon configuration of your Device and other components;\n</li><li>the Services will work in each of your desired use case scenarios; and</li><li>\nthe Services can be executed on every operating system, as it is impossible to test each variant.</li></ol>\n14.2. The Services use third party hosting services. Health Care Innovate does not warrant that use of the Services will be uninterrupted or error or defect free. The operation and availability of the Services is dependent on public telephone services, computer networks, the Internet, which can be unpredictable and may from time to time interfere with the use of the Services. Health Care Innovate is not responsible for any such interference or prevention of your use of the Platform.\n</p><p>\n14.3. All risk arising out of the use or performance of the Services remain with you. You understand and agree that the use of the Services, material or Data obtained or generated through the use of the Services, is at your own discretion and risk and that you will be solely responsible for any infections, contaminations or damage to your Device, system or network. Health Care Innovate is not responsible or liable for delays, inaccuracies, errors or omissions arising out of your use of the Platform, any third party software or operating system.\n</p><p>\n14.4. Health Care Innovate does not collect any Data or other Personal Information directly from any patient or clinical stakeholder of a health practitioner and, subject to any obligations under law, does not notify such third parties regarding the collection and use of their information via the Services.\n</p><p>\n14.5. To the maximum extent permitted by applicable law, Health Care Innovate and its licensors disclaim all warranties, express or implied, including, without limitation, any implied warranties of merchantability, fitness for a particular purpose and non-infringement of third party intellectual property rights or lack of viruses, for the Services. In no event will Health Care Innovate or its licensors be liable for any consequential, incidental, indirect, special, punitive, or other damages whatsoever arising out of these Terms, the use of or inability to use the Services, even if Health Care Innovate has been advised of the possibility of such damages.\n</p><p>\n14.6. You acknowledge that Health Care Innovate may pursue any available equitable or other remedy against you as a result of your breach of any provision of these Terms.\n</p><p>\n14.7. Health Care Innovate or its licensors’ liability for breach of any of its obligations under these Terms for the Services, or breach of any warranty implied by law, will be limited, to the extent permitted by law, to the total price paid for Subscription to use the App, Services and Website. Health Care Innovate’s total liability to you for all damages in connection with the Services will not exceed the price paid by you under these Terms for the Services. The foregoing limitations, exclusions and disclaimers will apply to the maximum extent permitted by applicable law, even if any remedy fails its essential purpose.\n</p><p>\n14.8. You acknowledge and agree that Health Care Innovate will not be liable for any non-compensatory damages including punitive, aggravated, multiple, exemplary, liquated or any other non-compensatory damages or the consequences of non-payment.\n</p><p>15.<b>INDEMNITY</b></p><p>\n15.1. You will be liable for and agree to indemnify, defend and hold Health Care Innovate harmless for and against any and all claims, liabilities, suits, actions and expenses, including costs of litigation and reasonable legal costs, resulting directly or indirectly from any:\n<ol type=\"a\"><li>information that is not accurate, up to date or complete or is misleading or a misrepresentation;</li>\n<li>breach of these Terms;</li><li>\nmisuse of the Services, from or by you, your employees, contractors, agents or any third party you permit to use your Account or otherwise access the Services using your Subscription;\n</li><li>breach of law, regulation or licence by you;</li><li>\nclaims brought by a third party against a Party arising out of the App, Services or Website including but not limited to any claims regarding breach of such third party’s privacy;\n</li><li>claims by any third party that:</li><ol type=\"i\"><li>\nthe grant, or exercise of any licence, of any Intellectual Property Rights under these Terms; or</li><li>\nthe supply or use of the Services, App or Website, infringes the Intellectual Property Rights of any person;</li></ol>\n<li>\nany death or injury to persons and any losses or claims to the real or personal property of Health Care Innovate or a third party, caused or contributed by your act or omission; or\n</li><li>any breach of clause 7.1 by you or your representatives.</li></ol>\n15.2. You agree to co-operate with Health Care Innovate (at your own expense) in the handling of disputes, complaints, investigations or litigation that arise as a result of your use of the Services including but not limited to disputes, complaints, investigations or litigation that arises out of or relates to incorrect information you have given Health Care Innovate.\n</p><p>15.3. The obligations under this clause will survive termination of these Terms.</p><p>16.<b> NOTICE</b></p><p>\n16.1. Any notice required or permitted to be given to you under these Terms will be addressed to you, unless you otherwise notify Health Care Innovate, using the contact details you provided to Health Care Innovate in the Registration Form.\n</p><p>17.<b> RELATIONSHIP OF PARTIES</b></p><p>\n17.1. Neither Party is authorised to bind the other Party in any way without prior written consent of the other Party.\n</p><p>\n17.2. The Parties acknowledge and agree that they will not seek to bind the other Party other than with the prior written consent of the other Party.\n</p><p>18.<b> RIGHTS OF THIRD PARTIES</b></p><p>\n18.1. Any person or entity who is not a party to these Terms has no right to benefit under or to enforce any of these Terms.\n</p><p>19.<b> ASSIGNMENT</b></p><p>\n19.1. These Terms are personal to you. You must not assign or deal with the whole or any part of your rights and/or obligations under these Terms without the prior written consent of Health Care Innovate.\n</p><p>19.2. Any purported dealing in breach of this clause is of no effect.</p><p>20.<b> WAIVER OR VARIATION OF RIGHTS\n</b></p><p>\n20.1. Any failure or delay by a Party in exercising a power or right (either wholly or partially) in relation to these Terms does not operate as a waiver or prevent that Party from exercising that power or right or any other power or right.\n</p><p>\n20.2. A Party is not liable to any other Party for any loss, cost or expense that may have been caused or contributed to by the failure, delay, waiver or exercise of a power or right.\n</p><p>21.<b> POWERS, RIGHTS AND REMEDIES</b></p><p>\n21.1. Except as expressly stated to the contrary in these Terms, the powers, rights and/or remedies of a Party under these Terms are cumulative and are in addition to any other powers, rights and remedies of that Party. Nothing in these Terms merge, extinguish, postpone, lessen or otherwise prejudicially affect any power, right, or remedy that a Party may have at any time against the other Party to these Terms or any other person.\n</p><p>22.<b> Force Majeure</b></p><p>\n22.1. If performance of these Terms or any obligation under these Terms are prevented, restricted, or interfered with by causes beyond either Party’s reasonable control ( \n<b>Force Majeure</b>\n ), and if the Party unable to carry out its obligations gives the other Party prompt written notice of such event, then the obligations of the Party invoking this provision shall be suspended to the extent necessary by such event.&nbsp; The term Force Majeure shall include, without limitation, acts of God, fire, explosion, vandalism, storm or other similar occurrence, orders of acts of military or civil authority, or by national emergencies, insurrections, riots, or wars, or strikes, lock-outs, work stoppages. The excused party shall use reasonable efforts under the circumstances to avoid or remove such causes of non-performance and shall proceed to perform with reasonable dispatch whenever such causes are removed or ceased.&nbsp; An act or omission shall be deemed within the reasonable control of a party if committed, omitted, or caused by such party, or its employees, officers, agents, or affiliates.\n</p><p>23.<b> CONSENTS AND APPROVALS</b></p><p>\n23.1. Where these Terms provides that a Party may conditionally or unconditionally give or withhold any consent or approval in relation to any matter in these Terms, that Party may in its absolute discretion, and without being obliged to give reasons for doing so, withhold any consent or approval or give consent or approval conditionally or unconditionally.\n</p><p>24.<b> FURTHER ASSURANCE</b></p><p>\n24.1. Each Party must from time to time and in a timely manner do all things reasonably required of it by another Party to give effect to these Terms.\n</p><p>25.<b> ENFORCEABILITY</b></p><p>\n25.1. If any provision of these Terms are held by any competent authority to be invalid or unenforceable in whole or in part, the validity of the other provisions of these Terms and the remainder of the provisions in question will not be affected.\n</p><p>26.<b> ENTIRE AGREEMENT AND UNDERSTANDING</b></p><p>\n26.1. The date of these Terms are the date that these Terms are accepted by you.</p><p>\n26.2. In respect of the subject matter of these Terms:<ol type=\"a\"><li>\nthese Terms contain the entire understanding between the Parties; and</li><li>\nall previous oral and written communications, representations, warranties or commitments are superseded by these Terms and do not affect the interpretation or meaning of these Terms.\n</li></ol>27.<b> GOVERNING LAW AND JURISDICTION</b></p><p>\n27.1. These Terms are governed by the laws of New South Wales and the Commonwealth of Australia. Each Party irrevocably and unconditionally submits to the exclusive jurisdiction of the courts operating in New South Wales.\n</p><p>28.<b> DEFINITIONS</b></p><p><b>Insolvency Event</b>\n means the occurrence of any of the following events in which a Party:</p><p><ol type=\"a\"><li>\nis unable to pay its debt as they fall due;</li><li>\nmakes or commences negotiation with a view to making, a general rescheduling of its indebtedness, a general assignment, scheme or arrangement or composition with its creditors;\n</li><li>takes any corporate action or any steps are taken or legal proceedings are started for:</li><ol type=\"i\"><li>\nits winding-up, dissolution, liquidation or re-organisation, other than to reconstruct or amalgamate while solvent on terms approved by the other Party (which approval will not be unreasonably withheld); or\n</li><li>the appointment of a controller, receiver, administrator, office manager, trustee; or</li></ol><li>\nseeks protection or is granted protection from its creditors, under any applicable legislation.</li></ol></p><p><b>\nIntellectual Property Rights</b>\n includes any and all intellectual and industrial property rights throughout the world, whether subsisting now or in the future and includes all copyright and analogous rights, all rights in relation to inventions (including patent rights), registered and unregistered trademarks, designs (whether or not registered or registrable), circuit layout rights, trade names, trade secrets and know-how.\n</p><p><b>Personal Information</b>\n means personal information as defined in the Privacy Act 1988 (Cth) and includes health information.</p><br><hr><p>\n</p><h3>For any questions or notice, please contact Health Care Innovate at:</h3>\nHealth Care Innovate Pty Ltd (ACN 607 346 029)<br>Michael Crouch Innovation Centre,<br>Hilmer Building (E10)<br>\nUniversity of New South Wales, Kensington NSW 2033<br>Email: info@clinivid.com.au<br><p></p></div></md-content></div>\n</div></div></div></md-sidenav></div>");
$templateCache.put("app/user/auth/register2.html","<div class=\"page-layout simple tabbed off-white-bg\" style=\"background-color: #f8f8f8\"><div class=\"content\" flex><div \nflex-gt-xs=\"100\" layout=\"column\" style=\"background-color: #f8f8f8\" layout-align=\"center center\"><md-card \nstyle=\"background-color: #ffffff; padding-bottom: 16px;width:500px\" class=\"ie-contacts\" ng-hide=\"$ctrl.showMFAScreen\">\n<div class=\"registerAccountHeader\" layout=\"row\" layout-align=\"center\" style=\"padding-top: 6px;height: 35px\">\nCreate an account</div><md-divider></md-divider><div ng-show=\"$ctrl.currentPage === \'CHECK_AHPRA\'\"><div \nclass=\"registerAccountText\">Are you a registered clinician?</div><div layout=\"row\" layout-align=\"center\"><md-button \nname=\"yesRegisteredClinician\" class=\"md-raised md-accent genericRegistrationPageButton\" aria-label=\"YES\" type=\"submit\" \nstyle=\"margin-top: 30px\" ng-click=\"$ctrl.takeToRegistrationPage()\">YES</md-button></div><div layout=\"row\" \nlayout-align=\"center\"><md-button name=\"notRegisteredClinician\" \nclass=\"md-raised md-accent genericRegistrationPageButton\" aria-label=\"NO\" type=\"submit\" style=\"margin-top: 20px\" \nng-click=\"$ctrl.takeToNoAHRPAPage()\">NO</md-button></div><div \nstyle=\"position: relative;background-image: url(/assets/call2action.jpg);background-position: center center;text-align: center;padding: 50px 0;margin-top: 70px\" \nng-show=\"$ctrl.showCallToAction\"><div \nstyle=\"position: absolute;top: 0;left: 0;width: 100%;height: 100%;background-color: rgba(0, 0, 180, 0.2)\"></div><h2 \nstyle=\"font-family: Roboto;font-size: 40px;font-weight: 500;color: #fff;margin-top: 0;margin-bottom: 45px\">\nStart your free trial now</h2><div style=\"display: inline-block\"><a \nhref=\"https://apps.apple.com/us/app/clinivid/id1518793065\" \nstyle=\"text-align: center; display: inline-block; overflow: hidden; background: url(https://linkmaker.itunes.apple.com/images/badges/en-us/badge_appstore-lrg.svg) no-repeat; width: 135px; height: 40px\">\n</a> <a \nhref=\"https://play.google.com/store/apps/details?id=hci.clinivid.android.x2&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1\" \nstyle=\"line-height: 30px\"><img alt=\"Get it on Google Play\" \nsrc=\"https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png\" \nstyle=\"vertical-align: bottom;\n                    height: 60px\"></a></div></div><div style=\"margin-top: 257px\" \nng-show=\"!$ctrl.showCallToAction\"></div></div><div ng-show=\"$ctrl.currentPage === \'NO_AHPRA\'\"><div layout=\"row\" \nlayout-align=\"center\" style=\"padding-top: 112px\"><img src=\"assets/images/no-ahpra.png\"></div><div class=\"sorryNoARPHA\" \nstyle=\"padding-top: 10px\">We apologise</div><div class=\"sorryNoARPHAText\">You have to be a registered health<br>\npractitioner to continue. Get in touch<br>with us with any questions.</div><div layout=\"row\" layout-align=\"center\">\n<md-button class=\"md-raised md-accent genericRegistrationPageButton\" ng-href=\"mailto:support@clinivid.com.au\" \naria-label=\"Contact Us\" type=\"submit\" style=\"margin-top: 20px;padding-top: 2px\">Contact Us</md-button></div><div \nclass=\"iHaveRegistration\" ng-click=\"$ctrl.takeToRegistrationPage()\">I am a registered clinician</div></div><div \nng-show=\"$ctrl.currentPage === \'USER_REGISTRATION\'\"><form name=\"personForm\" class=\"contact-inputs\" novalidate><div \nng-show=\"$ctrl.currentStep >= 1\"><div layout=\"row\" layout-align=\"center\"><md-select name=\"profession\" \nng-model=\"$ctrl.patientRegistrationForm.profession\" class=\"registrationProfession\" \nplaceholder=\"Select Your Profession\" ng-change=\"$ctrl.appendRegistrationPrefix()\" required><md-option \nname=\"profession\" value=\"Aboriginal and Torres Strait Islander Health Practitioner\">\nAboriginal and Torres Strait Islander<br>Health Practitioner</md-option><md-option name=\"profession\" \nvalue=\"Chinese Medicine Practitioner\">Chinese Medicine Practitioner</md-option><md-option name=\"profession\" \nvalue=\"Chiropractor\">Chiropractor</md-option><md-option name=\"profession\" value=\"Dental Practitioner\">\nDental Practitioner</md-option><md-option name=\"profession\" value=\"Medical Practitioner\">Medical Practitioner\n</md-option><md-option name=\"profession\" value=\"Medical Radiation Practitioner\">Medical Radiation Practitioner\n</md-option><md-option name=\"profession\" value=\"Midwife\">Midwife</md-option><md-option name=\"profession\" value=\"Nurse\">\nNurse</md-option><md-option name=\"profession\" value=\"Occupational Therapist\">Occupational Therapist</md-option>\n<md-option name=\"profession\" value=\"Optometrist\">Optometrist</md-option><md-option name=\"profession\" value=\"Osteopath\">\nOsteopath</md-option><md-option name=\"profession\" value=\"Paramedic\">Paramedic</md-option><md-option name=\"profession\" \nvalue=\"Pathologist\">Pathologist</md-option><md-option name=\"profession\" value=\"Pharmacist\">Pharmacist</md-option>\n<md-option name=\"profession\" value=\"Physiotherapist\">Physiotherapist</md-option><md-option name=\"profession\" \nvalue=\"Podiatrist\">Podiatrist</md-option><md-option name=\"profession\" value=\"Psychologist\">Psychologist</md-option>\n<md-option name=\"profession\" value=\"Sonographer\">Sonographer</md-option><md-option name=\"profession\" value=\"Other\">\nOther</md-option></md-select></div></div><div ng-show=\"$ctrl.currentStep >= 2\"><div layout=\"row\" layout-align=\"center\">\n<md-input-container class=\"person-country-code\"><md-select \nclass=\"ng-pristine ng-valid md-default-theme ng-empty ng-touched\" tabindex=\"0\" aria-disabled=\"false\" role=\"listbox\" \naria-expanded=\"false\" aria-multiselectable=\"false\" placeholder=\"Country Code\" \nname=\"$ctrl.patientRegistrationForm.countryCode\" ng-model=\"$ctrl.patientRegistrationForm.countryCode\" \nid=\"country-code\" aria-owns=\"select_container_56\" aria-invalid=\"false\" aria-label=\"Select country code\"><md-option \nname=\"country\" value=\"AU\" selected=\"true\">+61 AUS</md-option><md-option name=\"country\" value=\"NZ\">+64 NZ</md-option>\n<md-option name=\"country\" value=\"IN\">+91 IND</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\"><input name=\"phone\" \nstyle=\"border: none;width: 178px;border-bottom: 1px solid #d3d3d3;border-radius: 8px;padding: 4px;position: relative\" \nng-model=\"$ctrl.patientRegistrationForm.phoneNumber\" placeholder=\" Mobile Number\" number-blur \nng-required=\"$ctrl.currentStep >= 2\" ng-pattern=\"$ctrl.phoneNumberRegex()\"><div class=\"validation-messages\" \nng-messages=\"personForm.phone.$error\"><div ng-message=\"required\">Mobile Number is required.</div><div \nng-message=\"pattern\">Not a valid phone number.</div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"center\"><md-input-container class=\"md-block\"><input name=\"email\" \nstyle=\"border: none;width: 325px;border-bottom: 1px solid #d3d3d3;border-radius: 8px;padding: 4px;position: relative\" \nng-model=\"$ctrl.patientRegistrationForm.email\" placeholder=\"Email(User Name)\" number-blur \nng-required=\"$ctrl.currentStep >= 2\" ng-pattern=\"/^.+@.+\\..+$/\"><div class=\"validation-messages\" \nng-messages=\"personForm.email.$error\"><div ng-message=\"required\">Email is required.</div><div ng-message=\"pattern\">\nEmail must be a valid e-mail address.</div></div></md-input-container></div><div layout=\"row\" layout-align=\"center\">\n<md-input-container class=\"md-block\"><input name=\"password\" type=\"password\" \nstyle=\"border: none;width: 162px;border-bottom: 1px solid #d3d3d3;border-radius: 8px;padding: 4px;position: relative\" \nng-model=\"$ctrl.patientRegistrationForm.password\" placeholder=\"Choose Password\" number-blur \nng-required=\"$ctrl.currentStep >= 2\" ng-minlength=\"8\" ng-maxlength=\"30\"><div class=\"validation-messages\" \nng-messages=\"personForm.password.$error\"><div ng-message=\"required\">Password is required.</div><div \nng-message=\"maxlength\">Too many characters.</div><div ng-message=\"minlength\">8 characters minimum.</div></div>\n</md-input-container><md-input-container class=\"md-block\"><input name=\"confirmPassword\" type=\"password\" \nstyle=\"border: none;width: 163px;border-bottom: 1px solid #d3d3d3;border-radius: 8px;padding: 4px;position: relative\" \nng-model=\"$ctrl.patientRegistrationForm.confirmPassword\" placeholder=\"Confirm Password\" number-blur \nng-required=\"$ctrl.currentStep >= 2\" match-password=\"password\"><div class=\"validation-messages\" \nng-messages=\"personForm.confirmPassword.$error\"><div ng-message=\"required\">Confirm Password is required.</div><div \nng-message=\"passwordMatch\">Your passwords did not match.</div></div></md-input-container></div></div><div \nng-show=\"$ctrl.currentStep >= 3\"><div layout=\"row\" layout-align=\"center\"><md-input-container class=\"person-title\">\n<md-select class=\"ng-pristine ng-valid md-default-theme ng-empty ng-touched\" tabindex=\"0\" aria-disabled=\"false\" \nrole=\"listbox\" aria-expanded=\"false\" aria-multiselectable=\"false\" placeholder=\"Title\" name=\"title\" \nng-model=\"$ctrl.patientRegistrationForm.title\" id=\"title\" aria-owns=\"select_container_56\" aria-invalid=\"false\" \naria-label=\"Select Title\"><md-option value=\"Dr\">Dr</md-option><md-option value=\"Mr\">Mr</md-option><md-option \nvalue=\"Mrs\">Mrs</md-option><md-option value=\"Ms\">Ms</md-option><md-option value=\"Miss\">Miss</md-option><md-option \nvalue=\"Master\">Master</md-option><md-option value=\"Prof\">Prof</md-option><md-option value=\"A/Prof\">A/Prof</md-option>\n<md-option value=\"Other\">Other</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><input \nname=\"lastName\" \nstyle=\"border: none;width: 222px;border-bottom: 1px solid #d3d3d3;border-radius: 8px;padding: 4px;position: relative\" \nng-model=\"$ctrl.patientRegistrationForm.firstName\" placeholder=\"First Name\" number-blur \nng-required=\"$ctrl.currentStep >= 3\" ng-maxlength=\"50\"><div class=\"validation-messages\" \nng-messages=\"personForm.firstName.$error\"><div ng-message=\"required\">First Name is required.</div><div \nng-message=\"maxlength\">Too many characters.</div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"center\"><md-input-container class=\"md-block\"><input name=\"middleName\" \nstyle=\"border: none;width: 162px;border-bottom: 1px solid #d3d3d3;border-radius: 8px;padding: 4px;position: relative\" \nng-model=\"$ctrl.patientRegistrationForm.middleName\" placeholder=\"Middle Name\" number-blur ng-maxlength=\"50\"><div \nclass=\"validation-messages\" ng-messages=\"personForm.middleName.$error\"><div ng-message=\"maxlength\">Too many characters.\n</div></div></md-input-container><md-input-container class=\"md-block\"><input name=\"firstName\" \nstyle=\"border: none;width: 163px;border-bottom: 1px solid #d3d3d3;border-radius: 8px;padding: 4px;position: relative\" \nng-model=\"$ctrl.patientRegistrationForm.lastName\" placeholder=\"Last Name\" number-blur \nng-required=\"$ctrl.currentStep >= 3\" ng-maxlength=\"50\"><div class=\"validation-messages\" \nng-messages=\"personForm.lastName.$error\"><div ng-message=\"required\">Last Name is required.</div><div \nng-message=\"maxlength\">Too many characters.</div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"center\"><md-input-container class=\"md-block\"><input name=\"registerNumber\" \nstyle=\"border: none;width: 325px;border-bottom: 1px solid #d3d3d3;border-radius: 8px;padding: 4px;position: relative\" \nng-model=\"$ctrl.patientRegistrationForm.registerNumber\" placeholder=\"Enter Registration Number\" number-blur \nng-required=\"$ctrl.currentStep >= 3\" ng-pattern=\"$ctrl.registrationRegularExpression\"><div class=\"validation-messages\" \nng-messages=\"personForm.registerNumber.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nAHPRA Registration No is required.</span></div><div ng-message=\"pattern\"><span>{{$ctrl.registrationInvalidMessage}}\n</span></div></div><div class=\"dontKnowRegistration\"><span ng-click=\"$ctrl.openAHRPAPage()\" \nstyle=\"cursor:pointer;font-weight:normal\">Don\'t Remember</span></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"center\"><div class=\"round\"><input type=\"checkbox\" id=\"iAgree\" \nng-model=\"$ctrl.patientRegistrationForm.iAgree\" ng-required=\"$ctrl.currentStep >= 3\"><label for=\"iAgree\"></label></div>\n<div style=\"padding-top: 4px;padding-left: 15px\"><span class=\"iAgree\">I agree with the </span><span \nclass=\"dontKnowRegistration\" ng-click=\"$ctrl.openRightMenu()\" style=\"cursor:pointer\">Terms and Conditions</span> <span \nclass=\"iAgree\">and </span><span class=\"dontKnowRegistration\" ng-click=\"$ctrl.openPrivacyMenu()\" style=\"cursor:pointer\">\nPrivacy Policy</span></div></div></div><div layout=\"row\" layout-align=\"center\"><md-button \nclass=\"md-raised md-accent genericRegistrationPageButton\" aria-label=\"register\" type=\"submit\" \nstyle=\"margin-top: 20px;margin-bottom: 20px\" ng-disabled=\"personForm.$invalid\" name=\"next-submit\" \nng-click=\"$ctrl.currentStep < 3 ? $ctrl.registerUser() : $ctrl.initiateMFA()\" ng-show=\"$ctrl.currentStep > 1\">\n{{$ctrl.getButtonText()}}</md-button></div></form></div><md-divider></md-divider><md-card-actions layout=\"row\" \nlayout-align=\"center\"><div class=\"registerAccountFooter\" ng-show=\"$ctrl.currentPage !== \'USER_REGISTRATION\'\">\nYou need to have a current registration with<br>AHPRA or ASAR to create an account.</div><div \nclass=\"registerAccountFooter\" ng-show=\"$ctrl.currentPage === \'USER_REGISTRATION\'\">Need help or have feedback? Contact: \n<a href=\"mailto:support@clinivid.com.au\">Support&nbsp<md-icon md-font-icon=\"icon-email\" class=\"icon\" \nstyle=\"color:#92298C\"></md-icon></a></div></md-card-actions></md-card><md-card \nstyle=\"background-color: #ffffff; padding-bottom: 16px;width:500px\" class=\"ie-contacts\" ng-show=\"$ctrl.showMFAScreen\">\n<div class=\"registerAccountHeader\" layout=\"row\" layout-align=\"center\" style=\"padding-top: 6px;height: 35px\">\nVerify your identity</div><md-divider></md-divider><div class=\"mfa-screen\"><div class=\"mfa-header\">&nbsp;</div><div \nclass=\"mfa-subtitle\">We have sent a text message to:</div><div layout=\"row\" layout-align=\"center\" \nstyle=\"margin-bottom: 30px\"><input type=\"text\" ng-value=\"$ctrl.maskedMobile\" readonly=\"readonly\" \nstyle=\"border:1px solid #d3d3d3; height: 50px; text-align: center; font-size: 18px; letter-spacing: 2px\"></div><div \nclass=\"mfa-subtitle\" style=\"margin-bottom: 20px\">Enter the 6 digits code</div><div layout=\"row\" layout-align=\"center\" \nclass=\"mfa-inputs\"><input ng-repeat=\"i in [0,1,2,3,4,5] track by $index\" id=\"mfa-digit-{{$index}}\" type=\"text\" \nmaxlength=\"1\" ng-model=\"$ctrl.mfaCode[$index]\" ng-keyup=\"$ctrl.onCodeDigitInput($index, $event)\" \nng-keydown=\"$ctrl.onCodeKeydown($index, $event)\" class=\"mfa-digit-input\" autocomplete=\"off\" inputmode=\"numeric\" \npattern=\"[0-9]*\"></div><div ng-show=\"$ctrl.mfaError\" class=\"mfa-error\" \nstyle=\"color: red; text-align: center; margin-top: 10px\">{{$ctrl.mfaError}}</div><div layout=\"row\" \nlayout-align=\"center\" style=\"margin-top: 24px\"><md-button \nclass=\"md-raised md-accent submit-button md-button md-default-theme md-ink-ripple\" \nstyle=\"border-radius:5px;width:115px;height:40px;margin-top:50px;text-transform: none !important\" \nng-click=\"$ctrl.cancelMFA()\">Go back</md-button><md-button \nclass=\"md-raised md-accent submit-button md-button md-default-theme md-ink-ripple\" \nstyle=\"border-radius:5px;width:115px;height:40px;margin-top:50px;text-transform: none !important\" \nng-disabled=\"$ctrl.mfaCode.join(\'\').length < 6\" ng-click=\"$ctrl.registerUser()\" id=\"signup_btn\">Sign Up</md-button>\n</div><div layout=\"row\" layout-align=\"center\" style=\"margin-top: 16px\"><div ng-show=\"$ctrl.resendCount < 3\"><span>\nDidn\'t receive a code?</span> <a ng-click=\"$ctrl.resendCode()\" \nstyle=\"cursor: pointer; color: #92298C; text-decoration: underline\">Resend</a></div><span \nng-show=\"$ctrl.resendCount >= 3\" style=\"color: #d50000; font-size: 13px; text-align: center\">\nPlease click on the Go back button to verify the mobile number you have entered or contact support using the link below.\n</span></div><div ng-show=\"$ctrl.mfaTestMode\" \nstyle=\"background-color: #fff3cd; color: #856404; border: 1px solid #ffc107;\n                        border-radius: 4px; padding: 10px 14px; margin: 15px 0 0;\n                        text-align: center; font-size: 13px\">\nMFA validation is disabled and any related functionalities will not work.</div></div><md-divider></md-divider>\n<md-card-actions layout=\"row\" layout-align=\"center\"><div class=\"registerAccountFooter\">\nNeed help or have feedback? Contact: <a href=\"mailto:support@clinivid.com.au\">Support&nbsp<md-icon \nmd-font-icon=\"icon-email\" class=\"icon\" style=\"color:#92298C\"></md-icon></a></div></md-card-actions></md-card>\n<md-sidenav md-component-id=\"termsAndConditions\" class=\"md-sidenav-right\"><div \nstyle=\"display: flex; flex-flow: column; height: 100%\"><div><md-toolbar layout=\"row\"><div class=\"md-toolbar-tools\">\n<md-button class=\"md-icon-button\" aria-label=\"Close Side Panel\" ng-click=\"$ctrl.closeSideNavPanelTermsAndConditions()\">\n<md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" style=\"color:#FFFFFF\"></md-icon></md-button><h2><span \nstyle=\"color:#FFFFFF;font-size: 16px;font-weight: 700\" class=\"hide-xs\">Terms of Service</span></h2><div \nclass=\"createpageHeaderButtons\" style=\"color: #ffffff;margin-left: auto\" class=\"hide-xs\"><md-icon \nmd-font-icon=\"icon-clock\" class=\"icon\" style=\"color:#FFFFFF\"></md-icon><strong><span style=\"color: #FFFFFF\">\nLast update: 15<span>th</span> June 2020</span></strong></div></div></md-toolbar></div><div \nstyle=\"min-height: 0; flex: 1; overflow: auto\"><div \nclass=\"page-layout off-white-bg carded fullwidth single-scroll layout-row\" layout=\"row\"><div class=\"center flex\">\n<md-content class=\"content ms-scroll md-default-theme\" ms-scroll=\"\"><div class=\"content\" \nstyle=\"text-align: justify;font-family: \'Work Sans\', sans-serif;font-size: 16px;color: #8c8c8c\"><p></p><p></p>\nThese Terms of Service (<b>Terms</b>\n) are between InfoMedix Pty Ltd (ACN 093 160 653), its successors and permitted assigns (referred to as <b>InfoMedix\n</b>) and each individual user subject to these Terms (referred to as <b>you</b> or <b>your</b>\n), collectively referred to as the <b>Parties</b> and each a <b>Party</b>\n. These Terms govern your access to and use of the Clinivid communication platform (<b>Platform</b>\n) and any related services made available to you (together with the Platform referred to as <b>Services</b>\n). The Services are accessible via supported web browsers (<b>Website</b>\n), a third party software where integrated with the Clinivid platform, or via the Clinivid application (<b>App</b>\n) on any mobile, tablet, console or other devices which supports the App and Website. You may be a user with: (i) your own individual Account (\n<b>Individual Account Holder</b>\n); and or (ii) an Account/s created for you by our enterprise customers which have an enterprise subscription with us (\n<b>Authorised User</b>).<p></p><p><b style=\"color: #010101\">\nINFOMEDIX DOES NOT COLLECT OR SOLICIT ANY PERSONAL INFORMATION VIA THE SERVICES WHICH MIGHT BE UNLAWFUL, UNNECESSARY, EXCESSIVE, INTRUSIVE OR UNRELATED TO THE FUNCTIONS OF THE SERVICES. THE SERVICES ARE DEPENDENT ON A NUMBER OF FACTORS AND PROVIDED TO YOU ON AN “AS IS” BASIS. THE SERVICES ARE NOT A SUBSTITUTE FOR ANY SYSTEMS FOR ADMINISTERING MEDICINE OR MEDICAL ADVICE, PATIENT RECORDS OR ANY PRACTICE MANAGEMENT SYSTEMS USED BY YOU AND YOU MUST NOT RELY ON THE SERVICES TO TRANSMIT ANY INFORMATION ON AN URGENT BASIS OR ANY INFORMATION RELATING TO A LIFE THREATENING SITUATION. PLEASE REFER TO CLAUSE 15 FOR INFOMEDIX’S FULL DISCLAIMER.\n</b></p><p>1.<b> ACCEPTANCE </b><b></b></p><p>\n1.1. These Terms form a binding legal agreement between the Parties. By accessing and using the Services, you agree to comply with and be legally bound by these Terms. Please read these Terms carefully. If you have any questions, you should contact InfoMedix using the contact details at the end of these Terms.\n</p><p>\n1.2. You acknowledge and agree to these Terms by: (i) ticking ‘I Agree’; (ii) accessing or using the Services whether via the App, Website or otherwise; or (iii) making part or full payment for the Services. If you do not agree to these Terms, you should cease accessing or using the App, Services and Website.\n</p><p>\n1.3. InfoMedix reserves the right to make changes to these Terms at any time, effective upon the posting of modified Terms. InfoMedix will endeavour to communicate these changes to the Users via email, App or Website. It is your obligation to ensure that you have read, understood and agree to the most recent Terms available on the App or Website.\n</p><p>\n1.4. Using the Services may be prohibited or restricted in certain countries. If you use the Services outside of Australia, you are responsible for complying with the laws and regulations of the territory from which you access or use the Services.\n</p><p>2.<b> PRIVACY AND ADDITIONAL TERMS</b></p><p>\n2.1. These Terms supplement and incorporate the Privacy Policy as set out on the App and Website. You will be taken to have read the terms of the Privacy Policy when you accept these Terms.\n</p><p>\n2.2. InfoMedix agrees to comply with the Privacy Act 1988 (Cth) including the Australian Privacy Principles, the Health Records and Information Privacy Act 2002 (NSW) where applicable and any other applicable legislation or privacy guidelines as amended from time to time. Please refer to InfoMedix’s Privacy Policy for details on how we store and use Personal Information.\n</p><p>3.<b> PLATFORM AND SERVICES</b></p><p>\n3.1. You can access and use the Services on any computer, mobile, tablet or other device (<b>Device</b>\n ) which supports the App or Website, or where the Services are integrated, from a 3<sup>rd</sup>\n party software. InfoMedix recommends each User accesses the App and Website using the recommended browsers or Devices as notified to you.\n</p><p>3.2	<b>Applicable to Individual Account Holders</b>\n: To access the App and some Services you must register for an account (<b>Account</b>\n) and complete InfoMedix’s registration form as set out on the App or Website (<b>Registration Form</b>\n). The Registration Form may require your first, middle and last name (as applicable), mobile number, email address and other related information which will be used to generate your Account profile (\n<b>User Information</b>).</p><p>\n3.3. If you are an Individual Account Holder and an Authorised User, you may alternate your profile between the Account you hold as an Individual Account Holder and the account/s you hold as an Authorised User.\n</p><p>3.4. <b>Applicable to Individual Account Holders</b>\n: Access to all Services and features on the App and Website will require you to subscribe to the Services (<b>\nSubscription</b>) for a period of time as set out on the App or Website (<b>Subscription Period</b>\n). The fees for each Subscription Period (<b>Subscription Fee</b>\n) will vary subject to the functionalities and Services you request as identified in your Account.</p><p>\n3.5. Any information or content you submit via the Services, including but not limited to photos, videos, audio, User Information or information or content which passes through the Platform whether it contains Personal Information or otherwise (collectively referred to as Data) are stored in servers located in Australia. InfoMedix will take reasonable steps and use industry standard procedures to ensure that Data is kept secure and confidential. Such Data does not include any data you submit through our third party service provider including our third party payment service provider, Braintree.\n</p><p>3.6	You represent and warrant that:<br><ol type=\"a\"><li>\nany and all Data you submit (or a User submits) via the Services are your sole and exclusive property; or</li><li>\nyou have secured any and all authorisation and rights to use the Data as applicable under the relevant laws.</li></ol>\n</p><p>3.7	Subject to your Device, you may be able to activate finger print recognition (<b>Fingerprint Login</b>\n) to access and use the Services via the Application. If you activate Fingerprint Login, you understand the need to protect your Device and if you have other people’s fingerprints registered in your Device, they will also have access to your Account and Services.\n</p><p>\n3.8	You acknowledge and agree that the operation of the Services may rely on third party application or services and your use of the Services may be subject to third party terms, including but not limited to Braintree Terms of Service as notified to you on our App and Website.\n</p><p>4.	<b>SECURITY</b></p><p>\n4.1	InfoMedix has implemented and will maintain security systems for the transmission and storage of Data consisting of encryption and data security technologies that are understood in the industry to provide adequate security for the transmission of such information over the Internet. These measures are intended to prevent unauthorised Data infiltration or security breaches. InfoMedix does not guarantee the security of any Data you store on your servers or Device(s).\n</p><p>5.<b> UPDATES AND AVAILABILITY OF SERVICES</b></p><p>5.1. InfoMedix may issue updates to the Services (<b>\nUpdates</b> ) from time to time.</p><p>\n5.2. Although InfoMedix endeavours to provide access to the Services should be available on a full-time basis, the Services may be unavailable due to maintenance or other development activity from time to time.\n</p><p>\n5.3. Where possible, InfoMedix will provide you with notice of any maintenance or development activity via email, App and Website.\n</p><p>6.<b> OFFERS AND PROMOTIONS</b></p><p>\n6.1. InfoMedix may, from time to time, make offers or promotions which may be applicable to the Services including but not limited to a free trial period to use the Services and create a limited number of cases ( \n<b>Trial Period</b>\n ). If any additional terms and conditions apply to such offers or promotions, these will be set out on the App, Website or otherwise notified to you via the Services.\n</p><p>7.<b> YOUR OBLIGATONS</b></p><p>7.1. You represent and warrant that:<ol type=\"a\"><li>\nby submitting your User Information and creating an Account, you are a health practitioner in Australia with a current registration with the Australian Health Practitioner Regulation Agency ( \n<b>AHPRA</b>);</li><li>all User Information provided to InfoMedix is true, accurate and complete;</li><li>\nany content or Data you post or submit via the Services or the posting, uploading, publication or transmission of the Data:\n</li><ol type=\"i\"><li>will not breach any agreements between you and any third party;</li><li>\nwill be in compliance with all applicable laws, requirements, rules and regulation that may apply to any third party in their state or territory; and\n</li><li>will not conflict with the rights of third parties;</li></ol><li>\nwhere Data contains any third party Personal Information, in order to post, upload, publish, transmit or otherwise use or disclose such Personal Information via the Services, you have:\n<ol type=\"i\"><li>\nprovided a consent form to such third party including but not limited to, where applicable, expressed consent to use any unique identifiers to link Data from the Services to your patients’ records; and\n</li><li>obtained the requisite consent; and</li></ol></li><li>\nonly to the extent necessary will you disclose Data to other registered health practitioner(s) involved in the management of a particular third party case to which that Data relates.\n</li></ol>7.2. You acknowledge and agree that you are responsible for how you use the Services and that:<ol type=\"a\">\n<li>you use the Services, App and Website at your own risk;</li><li>\nshould you use Fingerprint Login to access the Application, you are solely responsible for any access or use of your Account or Services via Fingerprint Login, whether such access or use are by you or anyone else whose fingerprint is saved on your Device.\n</li><li>you consent to InfoMedix checking your User Information against the AHPRA register;</li><li>\nInfoMedix is not responsible for any corruption or loss of any Data if such corruption or loss is due to an act or omission by you, your employee(s), contractor(s), agent(s) or any third party;\n</li><li>\nInfoMedix reserves the right to access and/or delete your Data at any time and for any reason including if InfoMedix reasonably believes your Data violates these Terms or infringe any law or regulation; and\n</li><li>you are solely responsible for:</li><ol type=\"i\"><li>\nany Data you upload or otherwise transmit via the Services; and</li><li>\ncomplying with all laws and regulations regarding the use and disclosure of Personal Information including but not limited to the Privacy Act 1988 (Cth) and the Australian Privacy Principles (including but not limited to APP 8 - Cross-border disclosure of personal information) as amended from time to time, the Spam Act 2003 (Cth) and any other requirements under Australian law.\n</li></ol><li>the Services must only be used for your own lawful purposes and in accordance with these Terms;</li><li>\nthe accessibility and reliability of the Services is dependent on your choice of web-browser, internet connection, Device operating system and your internet connection;\n</li><li>all usernames and passwords required to access the Account and Services are kept secure and confidential;</li>\n<li>\nif there is any unauthorised use of your passwords or any other breach of security, you will immediately notify InfoMedix of such activity; and\n</li><li>\nit is your responsibility to determine that the Services meet your needs and are suitable for the purposes for which the Services are used.\n</li></ol>\n7.3. InfoMedix has no responsibility to any person or entity other than you and nothing in these Terms confer, or purport to confer, a benefit on any person or entity other than you. If you use the Platform on behalf of or for the benefit of anyone other than yourself, you agree that:\n<ol type=\"a\"><li>you are responsible for ensuring that you have the right to do so;</li><li>\nInfoMedix does not warrant the fitness for purpose or suitability of the Platform for any third party’s purpose and third parties may not rely on InfoMedix for any purpose;\n</li><li>\nyou are responsible for authorising any person who is given access to your Data, and you agree that, subject to any requirements by law or regulation including but not limited to the obligation to grant any third party access to any of your Data to which their Personal Information relates, InfoMedix has no obligation to provide any person or entity with access to such Data without authorisation from you and we may refer any requests for access to the Data to you to address; and\n</li><li>\nyou will indemnify InfoMedix, on first demand, against any and all claims, expenses, liabilities or losses arising out of in connection with InfoMedix’s refusal to provide any persons with access to your Data (including but not limited to any patient data) in accordance with these Terms and InfoMedix making Data available to any person with authorisation from you.\n</li></ol>\n7.4. You remain solely responsible for complying with all applicable laws. It is your responsibility to ensure that the storage of and access to your Data via the Services complies with any laws which are applicable to you, including any laws requiring you to maintain or retain records, maintain confidentiality and accuracy and protect the privacy of your Data. If you would like information in relation to how InfoMedix stores and collects Data, please contact InfoMedix using the details at the bottom of these Terms.\n</p><p>8.<b> PAYMENT (Applicable to Individual Account Holders)</b></p><p>\n8.1. You agree to pay InfoMedix the applicable Subscription Fees upfront as required to enable you to access and use the Services.\n</p><p>\n8.2. You will be required to make payment by way of credit card, PayPal or other payment methods as set out on the App and Website. The initial payment will be processed (a) upon receipt of the request for a Subscription; or (b) subject to any offers and promotions, immediately upon using up any limit prescribed to the Trial Period. You must make further payments prior to the expiry of your Subscription on the relevant periodic basis.\n</p><p>8.3. You acknowledge and agree that:<ol type=\"a\"><li>\nto maintain your subscription and subject to your elected payment method, payment to InfoMedix will be made automatically in advance on a monthly payment date, from your nominated PayPal account; and\n</li><li>\nas you have allowed InfoMedix and its payment service provider to automatically direct debit your nominated credit card or other payment account, if the direct debit service provider is unable to process payment, InfoMedix’s payment service provider will attempt to contact you via email as soon as it is aware of the payment failure. Until payment is confirmed, your access to the Services may be suspended until InfoMedix and its payment service provider receives confirmation of payment.\n</li></ol>\n8.4. If you make a payment by way of credit card, you warrant that the information you provide to InfoMedix and its payment service provider is true and complete, that you are authorised to use the credit card to make payment and that your payment will be honoured by your card issuer.\n</p><p>\n8.5. If payment is not made within 30 days of the last payment date, InfoMedix may lock your Account without notice to you, in which case you will not be able to access your Account or use the Services, and any Data on the Account may be deleted and not recoverable.\n</p><p>\n8.6. All amounts are stated in Australian dollars and unless otherwise stated, all amounts are exclusive of goods and services tax (\n<b>GST</b>).</p><p>\n8.7. InfoMedix’s pricing structure or payment methods may be amended from time to time in its sole discretion.</p><p>9.\n<b> CANCELLATION AND TERMINATION</b></p><p>9.1	<b>Applicable to Individual Account Holders</b>\n: If you would like to cancel your Subscription, you may do so by notifying InfoMedix through your Account using the App or Website (\n<b>Cancellation Request</b>\n). Your access to your Account and any Data will be terminated at the end of the Subscription Period month following your Cancellation Request and you will not be charged any further Subscription Fees to your payment account.\n</p><p>9.2. InfoMedix may terminate these Terms or your Account immediately, in its sole discretion, if:<ol type=\"a\">\n<li>you breach any of these Terms;</li><li>\nInfoMedix reasonably suspects that you are attempting to reverse engineer the Platform that is provided to you;</li>\n<li>InfoMedix, at its own discretion, terminates the Services; or</li><li>\nfor any other reason outside InfoMedix’s control which has the effect of compromising its ability to provide you with the Services within a required timeframe.\n</li></ol>\n9.3. On termination of the Services and these Terms, InfoMedix may retain your Data and related documents (including copies) as required to facilitate the Services to other users, by law or regulation. Your express or implied agreement to the Terms constitutes your authority for InfoMedix to retain or destroy such documents and records in accordance with the statutory periods, or on termination of these Terms.\n</p><p>10.<b> PROHIBITED USE</b></p><p>10.1. You acknowledge and agree that you will not:<ol type=\"a\"><li>\nuse the Services in any manner that is illegal or violates any applicable rights (e.g. right to privacy), law or regulation;\n</li><li>\ntransmit via the Services any Personal Information including Personal Information relating to your patient which are unlawful, unnecessary, excessive, intrusive or unrelated to the functions of the Services;\n</li><li>\nattempt to circumvent or disable the Services or any technology features or measures in the Platform by any means or in any manner;\n</li><li>\nattempt to modify, copy, adapt or reproduce the Data, Services or App except as necessary for normal operation;</li>\n<li>\nattempt to decompile, disassemble, reverse engineer, or otherwise attempt to derive the source code for the Platform or App;\n</li><li>\nupload any Data including any content that is defamatory, obscene, pornographic, vulgar, offensive, promotes discrimination, bigotry, racism, harassment or harm against any individual or group;\n</li><li>\ndistribute, encumber, sell, rent, lease, sub-license, or otherwise transfer, publish or disclose the Data or Services to any third party (except as permitted under these Terms);\n</li><li>\nremove or alter any trademark, logo, copyright or other proprietary notices, legends, symbols or labels in or on the App, Platform or Website or otherwise used in connection with the Services;\n</li><li>\nuse the Services in any manner to aid in the violation of any third party Intellectual Property Rights, including but not limited to another’s copyrights, trade marks, and patents;\n</li><li>take any action that interferes, in any manner, with InfoMedix’s rights with respect to the Services;</li><li>\nattempt to undermine the security or integrity of InfoMedix’s computing systems or where the Services are hosted by a third party, that third party’s computing systems and networks; and\n</li><li>\nuse, or misuse, the Services in any way which may impair the functionality of the Services, App, Website or other systems used to deliver the Platform or impair the ability of any other user to use the Services, App or Website.\n</li></ol>\n10.2. You acknowledge that any breaches of this clause or the Terms generally may lead to termination of these Terms and cancellation of your Account.\n</p><p>11.<b> INTELLECTUAL PROPERTY</b></p><p>\n11.1. Heath Care Innovate holds the title to, or otherwise holds the licence to all Intellectual Property Rights in the Platform, Services, and any documentation relating to the Platform and these remain the property of InfoMedix and any other applicable owner. Your right to use such Intellectual Property Rights is subject to these Terms.\n</p><p>\n11.2. Title, ownership rights and Intellectual Property Rights in and to any content displayed on the Services, App or Website, or accessed through the Services, App or Website are the property of the applicable content owner and may be protected by applicable copyright or other law. These Terms give you no rights to such content.\n</p><p>11.3. You grant InfoMedix a non-exclusive, worldwide, royalty free, irrevocable licence to:<ol type=\"a\"><li>\nuse any Intellectual Property Rights which subsists in any materials you provide in connection with your Account or the Services as required for InfoMedix to provide the Services to you; and\n</li><li>\nto any Intellectual Property Rights subsisting in your Data in order to host, store, use, copy, display, transmit, reference, disclose, reproduce, modify, adapt, edit, publish and distribute your Data or otherwise for purposes including:\n</li><ol type=\"i\"><li>to enable you to access and use the Services;</li><li>\nfor InfoMedix’s administrative, support and training purposes; and</li><li>\nin accordance with these Terms or as otherwise required for InfoMedix to develop, provide and improve the Services.\n</li></ol></ol>\nWhere such Data contains your Personal Information, InfoMedix will use your Data for purposes consistent with its Privacy Policy.\n</p><p>\n11.4. Title to and all Intellectual Property Rights in any Data you input into the Services remain your property. However, your access to the Data and continued use of the Services is contingent on payment of your Subscription Fee for your Subscription.\n</p><p>\n11.5. As the operation of the Services may rely on third party application or services, you acknowledge that InfoMedix may allow providers of these third party-application to access any inputted Data as required for the interoperation of such third party applications with the Services. InfoMedix is not responsible for any disclosure, modification or deletion of Data resulting from any such access by third-party application providers.\n</p><p>12.<b> FEEDBACK AND DISPUTE RESOLUTION</b></p><p>\n12.1. Your feedback is important to InfoMedix. InfoMedix seeks to resolve your concerns quickly and effectively. If you have any feedback or questions about the Services, please contact InfoMedix using the details at the end of these Terms.\n</p><p>\n12.2. If there is a dispute between the Parties in relation to these Terms or the Services, the Parties agree to the following dispute resolution procedure:\n<ol type=\"a\"><li>\nThe complainant must tell the respondent in writing, the nature of the dispute, what outcome the complainant wants and what action the complainant thinks will settle the dispute. The Parties agree to liaise with each other in good faith to seek to resolve the dispute by agreement between them ( \n<b>Initial Discussion</b> ).</li><li>\nIf the Parties cannot agree how to resolve the dispute at the Initial Meeting, any Party may refer the matter to a mediator. If the parties cannot agree on who the mediator should be, the complainant will ask the Law Society of New South Wales to appoint a mediator. The mediator will decide the time and place for mediation. The Parties must attend the mediation in good faith, to seek to resolve the dispute.\n</li></ol>\n12.3. Any attempts made by the Parties to resolve a dispute pursuant to this clause are without prejudice to other rights or entitlements of the Parties under these Terms, by law or in equity.\n</p><p>13.<b> AUSTRALIAN CONSUMER LAW</b></p><p>\n13.1 InfoMedix Services come with guarantees that cannot be excluded under the Australian Consumer Law. For major failures with the Services, Customer is entitled:\n<ol type=\"a\"><li>to cancel this Agreement with InfoMedix; and</li><li>\nto a refund for the unused portion, or to compensation for its reduced value.</li></ol></p><p>\nCustomer is also entitled to be compensated for any other reasonably foreseeable loss or damage. If the failure does not amount to a major failure you are entitled to have problems with the Services rectified in a reasonable time and, if this is not done, to cancel this Agreement and obtain a refund for the unused portion of this Agreement.\n</p><p>\n13.2 InfoMedix reserves the right to change or remove features of the SaaS Services from time to time. Where there is any material alteration to the SaaS Services in accordance with this clause, InfoMedix will provide the Customer with 20 Business Days’ notice and the Customer agrees that any material alteration is at InfoMedix’s discretion, though Customer may terminate this Document if such changes are unfair under the Australian Consumer Law.\n</p><p>14.<b> LIMITATION OF LIABILITY AND DISCLAIMERS</b></p><p>\n14.1. You acknowledge that whilst InfoMedix will take reasonable steps to ensure that the Services will be fit for the advertised purpose, to the fullest extent permitted by law, InfoMedix does not guarantee that:\n<ol type=\"a\"><li>\nthe Services will meet your requirements as the functionality of the Services is dependent upon configuration of your Device and other components;\n</li><li>the Services will work in each of your desired use case scenarios; and</li><li>\nthe Services can be executed on every operating system, as it is impossible to test each variant.</li></ol>\n14.2. The Services use third party hosting services. InfoMedix does not warrant that use of the Services will be uninterrupted or error or defect free. The operation and availability of the Services is dependent on public telephone services, computer networks, the Internet, which can be unpredictable and may from time to time interfere with the use of the Services. InfoMedix is not responsible for any such interference or prevention of your use of the Platform.\n</p><p>\n14.3. All risk arising out of the use or performance of the Services remain with you. You understand and agree that the use of the Services, material or Data obtained or generated through the use of the Services, is at your own discretion and risk and that you will be solely responsible for any infections, contaminations or damage to your Device, system or network. InfoMedix is not responsible or liable for delays, inaccuracies, errors or omissions arising out of your use of the Platform, any third party software or operating system.\n</p><p>\n14.4. InfoMedix does not collect any Data or other Personal Information directly from any patient or clinical stakeholder of a health practitioner and, subject to any obligations under law, does not notify such third parties regarding the collection and use of their information via the Services.\n</p><p>\n14.5. To the maximum extent permitted by applicable law, InfoMedix and its licensors disclaim all warranties, express or implied, including, without limitation, any implied warranties of merchantability, fitness for a particular purpose and non-infringement of third party intellectual property rights or lack of viruses, for the Services. In no event will InfoMedix or its licensors be liable for any consequential, incidental, indirect, special, punitive, or other damages whatsoever arising out of these Terms, the use of or inability to use the Services, even if InfoMedix has been advised of the possibility of such damages.\n</p><p>\n14.6. You acknowledge that InfoMedix may pursue any available equitable or other remedy against you as a result of your breach of any provision of these Terms.\n</p><p>\n14.7. InfoMedix or its licensors’ liability for breach of any of its obligations under these Terms for the Services, or breach of any warranty implied by law, will be limited, to the extent permitted by law, to the total price paid for Subscription to use the App, Services and Website. InfoMedix’s total liability to you for all damages in connection with the Services will not exceed the price paid by you under these Terms for the Services. The foregoing limitations, exclusions and disclaimers will apply to the maximum extent permitted by applicable law, even if any remedy fails its essential purpose.\n</p><p>\n14.8. You acknowledge and agree that InfoMedix will not be liable for any non-compensatory damages including punitive, aggravated, multiple, exemplary, liquated or any other non-compensatory damages or the consequences of non-payment.\n</p><p>15.<b>INDEMNITY</b></p><p>\n15.1. You will be liable for and agree to indemnify, defend and hold InfoMedix harmless for and against any and all claims, liabilities, suits, actions and expenses, including costs of litigation and reasonable legal costs, resulting directly or indirectly from any:\n<ol type=\"a\"><li>information that is not accurate, up to date or complete or is misleading or a misrepresentation;</li>\n<li>breach of these Terms;</li><li>\nmisuse of the Services, from or by you, your employees, contractors, agents or any third party you permit to use your Account or otherwise access the Services using your Subscription;\n</li><li>breach of law, regulation or licence by you;</li><li>\nclaims brought by a third party against a Party arising out of the App, Services or Website including but not limited to any claims regarding breach of such third party’s privacy;\n</li><li>claims by any third party that:</li><ol type=\"i\"><li>\nthe grant, or exercise of any licence, of any Intellectual Property Rights under these Terms; or</li><li>\nthe supply or use of the Services, App or Website, infringes the Intellectual Property Rights of any person;</li></ol>\n<li>\nany death or injury to persons and any losses or claims to the real or personal property of InfoMedix or a third party, caused or contributed by your act or omission; or\n</li><li>any breach of clause 7.1 by you or your representatives.</li></ol>\n15.2. You agree to co-operate with InfoMedix (at your own expense) in the handling of disputes, complaints, investigations or litigation that arise as a result of your use of the Services including but not limited to disputes, complaints, investigations or litigation that arises out of or relates to incorrect information you have given InfoMedix.\n</p><p>15.3. The obligations under this clause will survive termination of these Terms.</p><p>16.<b> NOTICE</b></p><p>\n16.1. Any notice required or permitted to be given to you under these Terms will be addressed to you, unless you otherwise notify InfoMedix, using the contact details you provided to InfoMedix in the Registration Form.\n</p><p>17.<b> RELATIONSHIP OF PARTIES</b></p><p>\n17.1. Neither Party is authorised to bind the other Party in any way without prior written consent of the other Party.\n</p><p>\n17.2. The Parties acknowledge and agree that they will not seek to bind the other Party other than with the prior written consent of the other Party.\n</p><p>18.<b> RIGHTS OF THIRD PARTIES</b></p><p>\n18.1. Any person or entity who is not a party to these Terms has no right to benefit under or to enforce any of these Terms.\n</p><p>19.<b> ASSIGNMENT</b></p><p>\n19.1. These Terms are personal to you. You must not assign or deal with the whole or any part of your rights and/or obligations under these Terms without the prior written consent of InfoMedix.\n</p><p>19.2. Any purported dealing in breach of this clause is of no effect.</p><p>20.<b> WAIVER OR VARIATION OF RIGHTS\n</b></p><p>\n20.1. Any failure or delay by a Party in exercising a power or right (either wholly or partially) in relation to these Terms does not operate as a waiver or prevent that Party from exercising that power or right or any other power or right.\n</p><p>\n20.2. A Party is not liable to any other Party for any loss, cost or expense that may have been caused or contributed to by the failure, delay, waiver or exercise of a power or right.\n</p><p>21.<b> POWERS, RIGHTS AND REMEDIES</b></p><p>\n21.1. Except as expressly stated to the contrary in these Terms, the powers, rights and/or remedies of a Party under these Terms are cumulative and are in addition to any other powers, rights and remedies of that Party. Nothing in these Terms merge, extinguish, postpone, lessen or otherwise prejudicially affect any power, right, or remedy that a Party may have at any time against the other Party to these Terms or any other person.\n</p><p>22.<b> Force Majeure</b></p><p>\n22.1. If performance of these Terms or any obligation under these Terms are prevented, restricted, or interfered with by causes beyond either Party’s reasonable control ( \n<b>Force Majeure</b>\n ), and if the Party unable to carry out its obligations gives the other Party prompt written notice of such event, then the obligations of the Party invoking this provision shall be suspended to the extent necessary by such event.&nbsp; The term Force Majeure shall include, without limitation, acts of God, fire, explosion, vandalism, storm or other similar occurrence, orders of acts of military or civil authority, or by national emergencies, insurrections, riots, or wars, or strikes, lock-outs, work stoppages. The excused party shall use reasonable efforts under the circumstances to avoid or remove such causes of non-performance and shall proceed to perform with reasonable dispatch whenever such causes are removed or ceased.&nbsp; An act or omission shall be deemed within the reasonable control of a party if committed, omitted, or caused by such party, or its employees, officers, agents, or affiliates.\n</p><p>23.<b> CONSENTS AND APPROVALS</b></p><p>\n23.1. Where these Terms provides that a Party may conditionally or unconditionally give or withhold any consent or approval in relation to any matter in these Terms, that Party may in its absolute discretion, and without being obliged to give reasons for doing so, withhold any consent or approval or give consent or approval conditionally or unconditionally.\n</p><p>24.<b> FURTHER ASSURANCE</b></p><p>\n24.1. Each Party must from time to time and in a timely manner do all things reasonably required of it by another Party to give effect to these Terms.\n</p><p>25.<b> ENFORCEABILITY</b></p><p>\n25.1. If any provision of these Terms are held by any competent authority to be invalid or unenforceable in whole or in part, the validity of the other provisions of these Terms and the remainder of the provisions in question will not be affected.\n</p><p>26.<b> ENTIRE AGREEMENT AND UNDERSTANDING</b></p><p>\n26.1. The date of these Terms are the date that these Terms are accepted by you.</p><p>\n26.2. In respect of the subject matter of these Terms:<ol type=\"a\"><li>\nthese Terms contain the entire understanding between the Parties; and</li><li>\nall previous oral and written communications, representations, warranties or commitments are superseded by these Terms and do not affect the interpretation or meaning of these Terms.\n</li></ol>27.<b> GOVERNING LAW AND JURISDICTION</b></p><p>\n27.1. These Terms are governed by the laws of New South Wales and the Commonwealth of Australia. Each Party irrevocably and unconditionally submits to the exclusive jurisdiction of the courts operating in New South Wales.\n</p><p>28.<b> DEFINITIONS</b></p><p><b>Insolvency Event</b>\n means the occurrence of any of the following events in which a Party:</p><p><ol type=\"a\"><li>\nis unable to pay its debt as they fall due;</li><li>\nmakes or commences negotiation with a view to making, a general rescheduling of its indebtedness, a general assignment, scheme or arrangement or composition with its creditors;\n</li><li>takes any corporate action or any steps are taken or legal proceedings are started for:</li><ol type=\"i\"><li>\nits winding-up, dissolution, liquidation or re-organisation, other than to reconstruct or amalgamate while solvent on terms approved by the other Party (which approval will not be unreasonably withheld); or\n</li><li>the appointment of a controller, receiver, administrator, office manager, trustee; or</li></ol><li>\nseeks protection or is granted protection from its creditors, under any applicable legislation.</li></ol></p><p><b>\nIntellectual Property Rights</b>\n includes any and all intellectual and industrial property rights throughout the world, whether subsisting now or in the future and includes all copyright and analogous rights, all rights in relation to inventions (including patent rights), registered and unregistered trademarks, designs (whether or not registered or registrable), circuit layout rights, trade names, trade secrets and know-how.\n</p><p><b>Personal Information</b>\n means personal information as defined in the Privacy Act 1988 (Cth) and includes health information.</p><br><hr><p>\n</p><h3 style=\"font-family: \'Cabin\', sans-serif;color: #636363;font-size: 18px\">\nFor any questions or notice, please contact InfoMedix at:</h3>InfoMedix Pty Ltd (ACN 093 160 653)<br>Level 2<br>\n451 Little Bourke Street<br>Melbourne, VIC 3000 Australia<br>Email: info@infomedix.com.au<br><p></p></div></md-content>\n</div></div></div></div></md-sidenav><md-sidenav md-component-id=\"privacy\" class=\"md-sidenav-right\"><div \nstyle=\"display: flex; flex-flow: column; height: 100%\"><div><md-toolbar layout=\"row\"><div class=\"md-toolbar-tools\">\n<md-button class=\"md-icon-button\" aria-label=\"Close Side Panel\" ng-click=\"$ctrl.closeSideNavPanelPrivacy()\"><md-icon \nmd-font-icon=\"icon-close-circle-outline\" class=\"icon\" style=\"color:#FFFFFF\"></md-icon></md-button><h2><span \nstyle=\"color:#FFFFFF;font-size: 16px;font-weight: 700\" class=\"hide-xs\">Clinivid Privacy Policy</span></h2><div \nclass=\"createpageHeaderButtons\" style=\"color: #ffffff;margin-left: auto\" class=\"hide-xs\"><md-icon \nmd-font-icon=\"icon-clock\" class=\"icon\" style=\"color:#FFFFFF\"></md-icon><strong><span style=\"color: #FFFFFF\">\nLast update: 15<span>th</span> June 2020</span></strong></div></div></md-toolbar></div><div \nstyle=\"min-height: 0; flex: 1; overflow: auto\"><div \nclass=\"page-layout off-white-bg carded fullwidth single-scroll layout-row\" layout=\"row\"><div class=\"center flex\">\n<md-content class=\"content ms-scroll md-default-theme\" ms-scroll=\"\"><div class=\"content\" \nstyle=\"text-align: justify;font-family: \'Work Sans\', sans-serif;font-size: 16px;color: #8c8c8c\"><p>\nThis Privacy Policy sets out InfoMedix Pty Ltd (ACN 093 160 653), its successors and assignees (referred to as we, us and our) commitment to protecting the privacy of your personal information that we collect through this website clinivid.com.au, the App (collectively the Site) or directly from you, being the person, organisation or entity that uses our Site (referred to as you or your).\n<br>\nPlease read this Privacy Policy carefully. Please contact us if you have any questions – our contact details are at the end of this Privacy Policy.\n<br>\nYou providing us with personal information indicates that you have had sufficient opportunity to access this Privacy Policy and that you have read and consented to it.\n<br>\nIf you do not wish to provide personal information to us, then you do not have to do so, however it may affect your use of this Site or any products and services offered on it.\n</p><h3 class=\"secondary-text\" \nstyle=\"font-family: \'Cabin\', sans-serif;color: #636363;font-size: 24px;font-weight: 500\">\n1. Collection of personal information</h3><p><b style=\"color:#010101\">Personal information:</b>\n We will collect the minimum amount of personal information possible in order to provide our services effectively. Payment data is not collected or held by us but is held by our payment facilitator, Braintree in the US. The type of information we collect may include:\n<ul><li style=\"list-style-type: initial\">name;</li><li style=\"list-style-type: initial\">images;</li><li \nstyle=\"list-style-type: initial\">contact details including email address, address and telephone number;</li><li \nstyle=\"list-style-type: initial\">date of birth;</li><li style=\"list-style-type: initial\">\ndemographic information such as postcode;</li><li style=\"list-style-type: initial\">preferences and opinions; and</li>\n<li style=\"list-style-type: initial\">\nany other information requested on this Site or otherwise requested by us or provided by you.</li></ul><br><b \nstyle=\"color:#010101\">Your use of our Site:</b>\n As with most online businesses, we may log information about your access and use of our Site, including through the use of Internet cookies, your communications with our Site, the type of browser you are using, the type of operating system you are using and the domain name of your Internet service provider.\n<br><b style=\"color:#010101\">Your opinion and feedback:</b>\n We may contact you to voluntarily respond to questionnaires, surveys or market research to seek your opinion and feedback. Providing this information is optional to you.\n<br>If we receive your personal information from third parties, we will protect it as set out in this Privacy Policy.\n</p><h3 class=\"secondary-text\" \nstyle=\"font-family: \'Cabin\', sans-serif;color: #636363;font-size: 24px;font-weight: 500\">\n2. Purpose of collection and use of personal information</h3><p>\nWe collect and use the information for purposes including:<ul><li style=\"list-style-type: initial\">\nto contact and communicate with you;</li><li style=\"list-style-type: initial\">for internal record keeping;</li><li \nstyle=\"list-style-type: initial\">for market research and business development including website development;</li><li \nstyle=\"list-style-type: initial\">for marketing including direct marketing;</li><li style=\"list-style-type: initial\">\nto improve your user experience; and</li><li style=\"list-style-type: initial\">for data analytics purposes.</li></ul>\n</p><h3 class=\"secondary-text\" \nstyle=\"font-family: \'Cabin\', sans-serif;color: #636363;font-size: 24px;font-weight: 500\">\n3. Disclosure of personal information to third parties</h3><p>We may disclose personal information to:<ul><li \nstyle=\"list-style-type: initial\">\ncredit reporting agencies and courts, tribunals and regulatory authorities where customers fail to pay for goods or services provided by us to them;\n</li><li style=\"list-style-type: initial\">\ncourts, tribunals, regulatory authorities and law enforcement officers as required by law, in connection with any actual or prospective legal proceedings, or in order to establish, exercise or defend our legal rights;\n</li><li style=\"list-style-type: initial\">\nthird parties, including agents or sub-contractors, who assist us in providing information, products, services or direct marketing to you. This may include parties located, or that store data, outside of Australia including BrainTree for payment management; and\n</li><li style=\"list-style-type: initial\">\nthird parties to collect and process data including Google Analytics. This may include parties that store data outside of Australia.\n</li></ul>\nWe may use Google Analytics to collect and process data. To find out how Google uses data when you use third party websites or applications, please see www.google.com/policies/privacy/partners/ or any other URL Google may use from time to time.To find out how Fabric uses data, please go to \n<a href=\"https://fabric.io/terms\">https://fabric.io/terms</a>.<br>\nWhere we disclose your personal information to third parties for these purposes, we will request that the third party follow this Privacy Policy regarding handling of your personal information.\n<br>\nIf there is a change of control of our business or a sale or transfer of business assets, we reserve the right to transfer to the extent permissible by law our user databases, together with any personal information and non-personal information contained in those databases. This information may be disclosed to a potential purchaser. We would seek to only disclose information in good faith.\n</p><h3 class=\"secondary-text\" \nstyle=\"font-family: \'Cabin\', sans-serif;color: #636363;font-size: 24px;font-weight: 500\">\n4. How we treat personal information that is also sensitive information</h3><p>\nSensitive information is a sub-set of personal information that is given a higher level of protection under the Australian Privacy Principles. In referring to ‘sensitive information’ we mean information that relates to your racial or ethnic origin, political opinions, religion, trade union or other professional associations or memberships, philosophical beliefs, sexual orientation or practices and criminal records, health information; or biometric information.\n<br>The type of sensitive information that we may collect includes:<ul><li style=\"list-style-type: initial\">\nHealth information about patients;</li><li style=\"list-style-type: initial\">\nProfessional associations or memberships of users; and</li><li style=\"list-style-type: initial\">\nProfessional registration identifiers of users.</li></ul>\nSensitive information will be used and disclosed for purposes relating to the primary purpose for which the sensitive information was collected, including:\n<ul><li style=\"list-style-type: initial\">Communication between treating clinicians (users) about a patient’s case; and\n</li><li style=\"list-style-type: initial\">Verification of users credentials and qualifications.</li><li \nstyle=\"list-style-type: initial\">Sensitive information may also be used or disclosed if required or authorised by law.\n</li></ul></p><h3 class=\"secondary-text\" \nstyle=\"font-family: \'Cabin\', sans-serif;color: #636363;font-size: 24px;font-weight: 500\">\n5. Your rights and controlling your personal information</h3><p><b style=\"color:#010101\">Choice and consent:</b>\n Providing us with your personal information is optional to you. You can choose not to provide personal information. When you provide us with your personal information, you consent to the terms in this Privacy Policy, and to us disclosing or receiving your personal information for these purposes.\n<br><b style=\"color:#010101\">Patient and Staff information:</b>\n Should you choose to enter, use or otherwise transmit patient’s, employee’s or sub-contractor’s or other stakeholder’s personal information through the Site, you warrant to us that you have obtained the patient’s, employee’s, sub-contractor’s, or stakeholder’s consent as applicable to disclose their personal information to our service for the purpose of us providing services.\n<br>\nYou warrant that where data contains any third party Personal Information, in order to post, upload, publish, transmit, store or otherwise use or disclose such Personal Information via the services, your and or applicable users, as required by applicable law has:\n<ul><li>\nprovided a consent form to such third party including but not limited to, where applicable, expressed consent to use any unique identifiers to link and match data from the services to patients’ records; and\n</li><li>obtained the requisite consent; and</li><li>\nonly to the extent necessary will you and your authorised users disclose data to other registered health practitioner(s) involved in the management of a particular third party case to which that data relates.\n</li></ul>You consent to us matching the data held on your systems with such data held by us<br><b \nstyle=\"color:#010101\">Restrict:</b>\n You may choose to restrict the collection or use of your personal information. If you have previously agreed to us using your personal information for direct marketing purposes, you can unsubscribe at any time by using \n<u>unsubscribe@clinivid.com.au</u><br><b style=\"color:#010101\">Access:</b>\n You may request details of personal information that we hold about you, in certain circumstances set out in the Privacy Act 1988 (Cth). An administrative fee may be payable for the provision of information. We may refuse to provide you with information that we hold about you, in certain circumstances set out in the Privacy Act. If patients request access to their personal information that you may have entered or transmitted through your account we will need to refer their request to you as we do not have access to your account for that purpose.\n<br><b style=\"color:#010101\">Correction:</b>\n If you believe that any information we hold about you is inaccurate, out of date, incomplete, irrelevant or misleading, please contact us by email. We rely in part upon users advising us when their personal information changes. We will respond to any request within a reasonable time. We will endeavour to promptly correct any information found to be inaccurate, incomplete or out of date. If patients request correction to their personal information that you may have entered or transmitted through your account we will need to refer their request to you as we do not have access to your account for that purpose.\n<br><b style=\"color:#010101\">Complaints:</b>\n If you believe that we have breached the Australian Privacy Principles and wish to make a complaint about that breach, please contact us by email setting out details of the breach. We will promptly investigate your complaint and respond to you in writing setting out the outcome of our investigation, what steps we propose to take to remedy the breach and any other action we will take to deal with your complaint.\n<br><b style=\"color:#010101\">Unsubscribe:</b>\n To unsubscribe from the service, please delete your account in your user profile. To unsubscribe from communication, please change your preferences in your profile or alternatively, send your request to \n<u>unsubscribe@clinivid.com.au</u>.</p><h3 class=\"secondary-text\" \nstyle=\"font-family: \'Cabin\', sans-serif;color: #636363;font-size: 24px;font-weight: 500\">6. Storage and Security</h3>\n<p>\nWe are committed to ensuring that the information you provide is secure. In order to prevent unauthorised access or disclosure, we have put in place suitable physical, electronic and managerial procedures to safeguard and secure the information and protect it from misuse, interference, loss and unauthorised access, modification and disclosure.\n<br>\nAlthough every effort is taken to secure your personal information no information transmitted over the Internet can be guaranteed to be absolutely secure. We cannot completely guarantee the security of any information that you transmit to us, or receive from us. Although we take measures to safeguard against unauthorised disclosures of information, we cannot assure you that personal information that we collect will not be disclosed in a manner that is inconsistent with this Privacy Policy.\n</p><h3 class=\"secondary-text\" \nstyle=\"font-family: \'Cabin\', sans-serif;color: #636363;font-size: 24px;font-weight: 500\">7. Cookies & Web Beacons</h3>\n<p>\nWe may use cookies on this Site from time to time. Cookies are text files placed in your computer\'s browser to store your preferences. Cookies, by themselves, do not tell us your e-mail address or other personally identifiable information. However, once you choose to furnish the Site with personally identifiable information, this information may be linked to the data stored in the cookie.\n<br>\nWe may use web beacons on this Site from time to time. Web beacons or clear.gifs are small pieces of code placed on a web page to monitor the visitors’ behaviour and collect data about the visitors viewing a web page. For example, web beacons can be used to count the users who visit a web page or to deliver a cookie to the browser of a visitor viewing that page.\n</p><h3 class=\"secondary-text\" \nstyle=\"font-family: \'Cabin\', sans-serif;color: #636363;font-size: 24px;font-weight: 500\">8. Links to other websites\n</h3><p>\nOur Site may contain links to other websites of interest. We do not have any control over those websites. We are not responsible for or liable for the protection and privacy of any information which you provide whilst visiting such websites, and such websites are not governed by this Privacy Policy.\n</p><h3 class=\"secondary-text\" \nstyle=\"font-family: \'Cabin\', sans-serif;color: #636363;font-size: 24px;font-weight: 500\">9. Amendments</h3><p>\nThis Privacy Policy may be amended, including with changes, additions and deletions, from time to time in our sole discretion. We may send you email notifications informing you of such changes, additions and deletions. Your continued use of our Site following any amendments indicates that you accept the amendments. You should check this Privacy Policy regularly, prior to providing personal information, to ensure you are aware of any changes, and only proceed to provide personal information if you accept the new Privacy Policy.\n</p><hr><p></p><h4 style=\"font-family: \'Cabin\', sans-serif;color: #636363;font-size: 18px\">\nFor any questions or notice, please contact our Privacy Officer at:</h4>InfoMedix Pty Ltd (ACN 093 160 653)<br>\nEmail: privacy@clinivid.com.au<p></p></div></md-content></div></div></div></div></md-sidenav></div></div></div>");
$templateCache.put("app/user/auth/reset-password.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"></div><div class=\"title\" translate=\"RESETPASSWORD.TITLE\">Reset your password</div><form \nname=\"resetPasswordForm\" ng-submit=\"$ctrl.resetPwd()\" novalidate><md-input-container class=\"md-block\" md-no-float>\n<input type=\"password\" name=\"password\" ng-model=\"$ctrl.form.password\" placeholder=\"Password\" ng-minlength=\"8\" \nng-maxlength=\"30\" translate translate-attr-placeholder=\"RESETPASSWORD.PASSWORD\" required><div \nng-messages=\"registerForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div><div ng-message=\"maxlength\">\n<span>Too many characters.</span></div><div ng-message=\"minlength\"><span>8 characters minimum.</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"passwordConfirm\" \nng-model=\"$ctrl.form.passwordConfirm\" placeholder=\"Password (Confirm)\" translate \ntranslate-attr-placeholder=\"RESETPASSWORD.PASSWORD_CONFIRM\" required><div \nng-messages=\"resetPasswordForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"UPDATE MY PASSWORD\" ng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine\" \ntranslate=\"RESETPASSWORD.UPDATE_PASSWORD\" translate-attr-aria-label=\"RESETPASSWORD.UPDATE_PASSWORD\">RESET MY PASSWORD\n</md-button></form></div></div></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Row Color\" md-menu-origin \nng-click=\"$mdOpenMenu($event)\" ng-class=\"selectedColor.class\"><span ng-show=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-show=\"!selectedColor.palette\">Select Color</span>\n</md-button><md-menu-content class=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-if=\"!selectedColor.palette\">Select Color</span>\n<md-button class=\"remove-color-button md-icon-button\" ng-click=\"removeColor()\" aria-label=\"Remove Color\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-if=\"!selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in palettes\" ng-click=\"activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-if=\"selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+selectedPalette+\'-\'+hue+\'-bg\'\" \nng-repeat=\"(hue, values) in selectedHues\" ng-click=\"selectColor(selectedPalette,hue)\" layout=\"row\" \nlayout-align=\"start end\" md-ink-ripple><span class=\"label\">{{hue}} </span><i \nng-if=\"selectedPalette == selectedColor.palette && hue == selectedColor.hue\" class=\"s16 icon-check\"></i></div></div>\n</div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon \nid=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><md-icon \nid=\"ms-search-bar-collapser\" md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></label><input \nid=\"ms-search-bar-input\" type=\"text\" ng-model=\"global.search\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex></div>");
$templateCache.put("app/main/admin/cases/cases.html","<md-whiteframe class=\"md-whiteframe-7dp m-50 right\" flex-sm=\"45\" flex-gt-sm=\"35\" flex-gt-md=\"25\" layout \nlayout-align=\"center center\"><md-content flex layout-padding><h1>This is the Admin Cases page</h1><h2>TBC</h2>\n</md-content></md-whiteframe>");
$templateCache.put("app/main/admin/clinicians/clinician-add.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page off-white-bg\" layout=\"column\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">Clinicians</span></div><div class=\"title\">Add a Clinician</div></div></div><div \nclass=\"content\" layout=\"column\"><div class=\"md-title\">Create and Add a Clinician</div><div class=\"pb-16\">\nUse this form to add a new clinician to your organisation. If you enter a new user, the system will issue an invitation to that user via email to complete their account registration. The clinician\'s user account will not be active until they complete the instructions in the invitation email.\n</div><form name=\"stepper\" ms-stepper ng-submit=\"$ctrl.submitStepper()\" ng-model=\"$ctrl.form.person\" novalidate>\n<ms-stepper-step ng-form=\"nameForm\" step=\"1\" step-title=\"\'Name\'\"><div \nng-include=\"\'app/main/admin/people/name-form.html\'\"></div></ms-stepper-step><ms-stepper-step ng-form=\"professionForm\" \nstep=\"2\" step-title=\"\'Profession\'\"><div ng-include=\"\'app/main/admin/people/profession-form.html\'\"></div>\n</ms-stepper-step><ms-stepper-step ng-form=\"linksForm\" step=\"3\" step-title=\"\'Contact\'\"><div \nng-include=\"\'app/main/admin/people/links-form.html\'\"></div></ms-stepper-step></form></div></div>");
$templateCache.put("app/main/admin/manage-organisation/activity-status-details.html","<div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px;max-width:100%;min-width:600px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.cancelActivityStatusDetailsPage()\"></md-icon></div></div><div \nlayout=\"row\" style=\"position: absolute;top: 0\"><div layout=\"column\" \nstyle=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px\">Case Details</div></div><div layout=\"column\" \nlayout-align=\"center center\" ng-show=\"$ctrl.selectedCaseMessageDetails && $ctrl.selectedCaseMessageDetails.length > 0\">\n<div style=\"margin: 10px;margin-top:90px\"><div class=\"tbl-header\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\">\n<thead><tr><th style=\"text-align: center\">Case Items</th><th style=\"text-align: center\">Sender</th><th \nstyle=\"text-align: center\">Reading Receipts</th></tr></thead></table></div><div class=\"tbl-content\" \nstyle=\"height: 100%\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tbody><tr \nng-repeat=\"selectedCase in $ctrl.selectedCaseMessageDetails\"><td style=\"text-align: center\">\n{{selectedCase.displayCaseItem}}</td><td style=\"text-align: center\">{{selectedCase.displaySender}}</td><td \nstyle=\"text-align: center\">{{selectedCase.displayRecipients}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/admin/manage-organisation/activity-status.html","<div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px;max-width:100%;min-width:600px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.cancelActivityStatusPage()\"></md-icon></div></div><div \nlayout=\"row\" style=\"position: absolute;top: 0\"><div layout=\"column\" \nstyle=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px\">Activity Report</div></div><div layout=\"column\" \nlayout-align=\"center center\" ng-show=\"!$ctrl.allCases || $ctrl.allCases.length === 0\"><div \nstyle=\"margin: 10px;margin-top:30px;font-style: italic\"><div><img src=\"/assets/images/info.png\" \nstyle=\"padding-top: 3px;margin-right: 5px\">There are no chats for this organisation.</div></div></div><div \nlayout=\"column\" layout-align=\"center center\" ng-show=\"$ctrl.allCases && $ctrl.allCases.length > 0\"><div \nstyle=\"margin: 10px;margin-top:90px\"><div class=\"tbl-header\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><thead>\n<tr><th style=\"text-align: center\">Case Id</th><th style=\"text-align: center\">Title</th><th style=\"text-align: center\">\nPriority</th><th style=\"text-align: center\">Patient</th><th style=\"text-align: center\">Creator</th><th \nstyle=\"text-align: center\">Participants</th><th style=\"text-align: center\">Total Items</th></tr></thead></table></div>\n<div class=\"tbl-content\" style=\"height: 100%\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tbody><tr \nng-repeat=\"userCase in $ctrl.allCases\" ng-click=\"$ctrl.openActivityCaseDetails(userCase)\" style=\"cursor:pointer\"><td \nstyle=\"text-align: center\">{{userCase.id}}</td><td style=\"text-align: center\">{{userCase.title}}</td><td \nstyle=\"text-align: center\">{{userCase.casePriority}}</td><td style=\"text-align: center\">{{userCase.patientName}}</td>\n<td style=\"text-align: center\">{{userCase.senderName}}</td><td style=\"text-align: center\">{{userCase.recipientsNames}}\n</td><td style=\"text-align: center\">{{userCase.totalItemCount}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/admin/manage-organisation/add-member.html","<div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px;margin:auto;min-width:600px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.cancelAddMemberPage()\"></md-icon></div></div><div layout=\"column\" \nstyle=\"margin-top: 30px;width:100%\"><div layout=\"row\" \nstyle=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px;margin:auto\">Add member</div><div layout=\"row\" \nstyle=\"height: 30px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto;margin-top: 30px\"><h1 \nstyle=\"font-size: 11px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;width: 160px;margin-top: -7px;margin-left: 43px;padding-left: 10px;background: white\">\nSearch and add Clinivid user</h1></div><div layout=\"row\" style=\"margin:auto\"><div layout=\"column\" \nstyle=\"width:80px;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:10px\">\nCountry code<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><md-select \nclass=\"ng-pristine ng-valid md-default-theme ng-empty ng-touched\" tabindex=\"0\" aria-disabled=\"false\" role=\"listbox\" \naria-expanded=\"false\" aria-multiselectable=\"false\" placeholder=\"Country Code\" ng-model=\"$ctrl.searchUser.region\" \naria-owns=\"select_container_56\" aria-invalid=\"false\" aria-label=\"Select country code\"><md-option value=\"AU\" \nselected=\"true\">+61 AUS</md-option><md-option value=\"NZ\">+64 NZ</md-option><md-option value=\"IN\">+91 IND</md-option>\n</md-select></md-input-container></div><div layout=\"column\" style=\"width:130px;margin-left:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:10px\">\nMobile number<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.searchUser.phone\" placeholder=\"Mobile number\"></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"center center\" style=\"margin-bottom: 30px;margin-top: 30px\"><md-button type=\"submit\" \nng-click=\"$ctrl.searchUsers()\" class=\"md-raised md-accent submit-button\" \nstyle=\"border-radius:5px;width:115px;height:40px;font-size: 16px;;text-transform: none !important\">Search</md-button>\n</div><div ng-show=\"$ctrl.clinividUserFound\"><div layout=\"row\" \nstyle=\"height: 30px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto\"><h1 \nstyle=\"font-size: 11px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;width: 100px;margin-top: -7px;margin-left: 43px;padding-left: 10px;background: white\">\nUser details</h1></div><div layout=\"row\" style=\"margin:auto;width: 90%\"><div layout=\"column\" \nstyle=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nTitle</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.searchUser.title\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nLast name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.searchUser.lastName\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nFirst name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.searchUser.firstName\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nProfession</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.searchUser.profession\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nAHPRA No</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.searchUser.registrationNo\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nStaff ID</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.searchUser.staffID\" placeholder=\"Staff ID\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"height: 30px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto;margin-top: 30px\"><h1 \nstyle=\"font-size: 11px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;width: 80px;margin-top: -7px;margin-left: 43px;padding-left: 10px;background: white\">\nSelect roles</h1></div><div layout=\"row\" style=\"margin:auto;width:90%\"><div layout=\"column\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nChoose roles to assign<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><div \nstyle=\"display: flex;flex: 1\"><aside><div class=\"container\"><div class=\"round\"><input id=\"roleOrgOwner2\" value=\"true\" \ntype=\"checkbox\" ng-model=\"$ctrl.searchUser.assignRoleOwner\"><label for=\"roleOrgOwner2\" \nstyle=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8\"></label></div></div></aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nOrganisation owner</aside></div></div></div><div layout=\"row\" style=\"margin:auto;width:90%\"><div \nstyle=\"display: flex;flex: 1;margin-top: 20px\"><aside><div class=\"container\"><div class=\"round\"><input \nid=\"roleClinician2\" value=\"true\" type=\"checkbox\" ng-model=\"$ctrl.searchUser.assignRoleClinician\"><label \nfor=\"roleClinician2\" style=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8\"></label></div></div>\n</aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nClinician</aside></div></div><div layout=\"row\" style=\"margin:auto;width:90%\"><div \nstyle=\"display: flex;flex: 1;margin-top: 20px;margin-bottom: 30px\"><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px\">\n* To add MDT coordinator or conference roles please contact us at <a target=\"_blank\" \nhref=\"mailto:support@clinivid.com.au\">support@clinivid.com.au</a></aside></div></div><div layout=\"row\" \nlayout-align=\"center center\" style=\"margin-bottom: 30px\"><md-button type=\"submit\" ng-click=\"$ctrl.addUser()\" \nclass=\"md-raised md-accent submit-button\" \nstyle=\"border-radius:5px;width:115px;height:40px;font-size: 16px;;text-transform: none !important\">Add User</md-button>\n</div></div></div></div>");
$templateCache.put("app/main/admin/manage-organisation/display-all-organisations.html","<div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px;margin:auto\"><div layout=\"row\" \nstyle=\"height:50px;margin-top:60px\"><input type=\"text\" placeholder=\"Search organisation\" \nng-model=\"$ctrl.orgSearchTerm\" \nstyle=\"background: #ffffff;padding:10px;border-radius:5px;-moz-border-radius:5px;-webkit-border-radius:5px;-o-border-radius:5px;border: 1px solid #92298D;width:160px;height:30px\">\n <img src=\"/assets/images/purple-close-circle.png\" style=\"width:30px;height:30px;margin-right:13px;cursor:pointer\" \nng-click=\"$ctrl.setSearchModeOff()\" ng-show=\"$ctrl.orgSearchTerm.length > 0\"></div><div style=\"margin: 10px\"><div \nclass=\"tbl-header\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><thead><tr><th>Organisation name</th><th>Role</th>\n</tr></thead></table></div><div class=\"tbl-content\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tbody><tr \nng-repeat=\"org in $ctrl.orgInfo | filter: $ctrl.orgSearchTerm track by $index\" \nng-click=\"$ctrl.showOrganizationalDetails(org.orgId , org.membershipId )\" style=\"cursor: pointer\"><td>{{org.orgName}}\n</td><td>Org-Owner</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/admin/manage-organisation/invite-member.html","<div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px;margin:auto\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.cancelInviteMemberPage()\"></md-icon></div></div><div \nlayout=\"column\" style=\"margin-top: 30px\"><div layout=\"row\" \nstyle=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px;margin:auto\">Invite member</div><div layout=\"row\" \nstyle=\"font-size: 12px;font-family: Roboto;font-style: italic;text-align: center;padding-left: 15px;padding-right: 15px\">\nUse this form to add a non existing Clinivid user to your organisation. If you enter a new user, the system will issue an invitation to that user via email to complete their account registration. The user\'s account will not be active until they complete the instructions in the invitation email.\n</div><div layout=\"row\" style=\"height: 30px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto;margin-top: 30px\"><h1\n \nstyle=\"font-size: 11px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;width: 120px;margin-top: -7px;margin-left: 43px;padding-left: 10px;background: white\">\nNew member details</h1></div><div layout=\"row\" style=\"width:90%;margin:auto\"><div layout=\"column\" \nstyle=\"width:100%;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nTitle</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0;margin-top: 7px\">\n<md-select type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial\" \nng-model=\"$ctrl.newInvite.title\" placeholder=\"Title\"><md-option value=\"Dr\">Dr</md-option><md-option value=\"Mr\">Mr\n</md-option><md-option value=\"Mrs\">Mrs</md-option><md-option value=\"Ms\">Ms</md-option><md-option value=\"Miss\">Miss\n</md-option><md-option value=\"Master\">Master</md-option><md-option value=\"Prof\">Prof</md-option><md-option \nvalue=\"A/Prof\">A/Prof</md-option><md-option value=\"Other\">Other</md-option></md-select></md-input-container></div><div \nlayout=\"column\" style=\"width:100%;margin-left:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nFirst name<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.newInvite.firstName\" placeholder=\"First name\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"width:90%;margin:auto;margin-top: 20px\"><div layout=\"column\" style=\"width:100%;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nMiddle name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0;margin-top: 7px\">\n<input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.newInvite.middleName\" placeholder=\"Middle name\"></md-input-container></div><div layout=\"column\" \nstyle=\"width:100%;margin-left:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nLast name<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.newInvite.lastName\" placeholder=\"Last name\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"height: 30px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto;margin-top: 50px\"><h1 \nstyle=\"font-size: 11px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;width: 100px;margin-top: -7px;margin-left: 43px;padding-left: 10px;background: white\">\nContact details</h1></div><div layout=\"row\" style=\"width:90%;margin:auto\"><div layout=\"column\" \nstyle=\"width:50%;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nEmail<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container class=\"md-block\" \nmd-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.newInvite.email\" placeholder=\"Email address\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"width:90%;margin:auto;margin-top:20px\"><div layout=\"column\" style=\"width:18%;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nCountry code<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><md-select \nclass=\"ng-pristine ng-valid md-default-theme ng-empty ng-touched\" tabindex=\"0\" aria-disabled=\"false\" role=\"listbox\" \naria-expanded=\"false\" aria-multiselectable=\"false\" placeholder=\"Country Code\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial\" \nng-model=\"$ctrl.newInvite.region\" aria-owns=\"select_container_56\" aria-invalid=\"false\" \naria-label=\"Select country code\"><md-option value=\"AU\" selected=\"true\">+61 AUS</md-option><md-option value=\"NZ\">+64 NZ\n</md-option><md-option value=\"IN\">+91 IND</md-option></md-select></md-input-container></div><div layout=\"column\" \nstyle=\"width:28%;margin-left:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nMobile number<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.newInvite.phone\" placeholder=\"Mobile number\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"height: 30px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto;margin-top: 50px\"><h1 \nstyle=\"font-size: 11px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;width: 120px;margin-top: -7px;margin-left: 43px;padding-left: 10px;background: white\">\nProfessional details</h1></div><div layout=\"row\" style=\"width:90%;margin:auto\"><div layout=\"column\" \nstyle=\"width:50%;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nStaff ID</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.newInvite.staffID\" placeholder=\"Staff ID\"></md-input-container></div></div><md-radio-group \nng-model=\"$ctrl.newInvite.isPractitioner\" style=\"margin: auto;width:90%;margin-top:20px\"><span \nstyle=\"font-size: 11px;font-weight: normal;letter-spacing: normal;color: #333333;padding-left: 2px\">\nRegistered practitioner ?</span><div \nstyle=\"display: flex;align-items: center;margin-bottom: 20px;font-size: 14px;margin-top: 10px;width:90%\">\n<md-radio-button ng-value=\"true\" class=\"md-primary\" style=\"margin-bottom: 0;font-size: 12px\">YES</md-radio-button>\n<md-radio-button ng-value=\"false\" class=\"md-primary\" style=\"margin-bottom: 0;margin-left: 30px;font-size: 12px\">NO\n</md-radio-button></div></md-radio-group><div layout=\"row\" style=\"width:90%;margin:auto\" \nng-if=\"$ctrl.isPractitioner()\"><div layout=\"column\" style=\"width:50%;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nProfession</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><md-select \ntype=\"text\" style=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial\" \nng-model=\"$ctrl.newInvite.profession\" placeholder=\"Choose your profession\"><md-option \nvalue=\"Aboriginal and Torres Strait Islander Health Practitioner\">Aboriginal and Torres Strait Islander<br>\nHealth Practitioner</md-option><md-option value=\"Chinese Medicine Practitioner\">Chinese Medicine Practitioner\n</md-option><md-option value=\"Chiropractor\">Chiropractor</md-option><md-option value=\"Dental Practitioner\">\nDental Practitioner</md-option><md-option value=\"Medical Practitioner\">Medical Practitioner</md-option><md-option \nvalue=\"Medical Radiation Practitioner\">Medical Radiation Practitioner</md-option><md-option value=\"Midwife\">Midwife\n</md-option><md-option value=\"Nurse\">Nurse</md-option><md-option value=\"Occupational Therapist\">Occupational Therapist\n</md-option><md-option value=\"Optometrist\">Optometrist</md-option><md-option value=\"Osteopath\">Osteopath</md-option>\n<md-option value=\"Paramedic\">Paramedic</md-option><md-option value=\"Pathologist\">Pathologist</md-option><md-option \nvalue=\"Pharmacist\">Pharmacist</md-option><md-option value=\"Physiotherapist\">Physiotherapist</md-option><md-option \nvalue=\"Podiatrist\">Podiatrist</md-option><md-option value=\"Psychologist\">Psychologist</md-option><md-option \nvalue=\"Sonographer\">Sonographer</md-option><md-option value=\"Other\">Other</md-option></md-select></md-input-container>\n</div></div><div layout=\"row\" style=\"width:90%;margin:auto;margin-top:20px\" ng-if=\"$ctrl.isPractitioner()\"><div \nlayout=\"column\" style=\"width:50%;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nRegistration No.</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.newInvite.registrationNo\" placeholder=\"Registration Number\"></md-input-container></div></div><div \nlayout=\"row\" style=\"height: 30px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto;margin-top: 50px\"><h1 \nstyle=\"font-size: 11px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;width: 50px;margin-top: -7px;margin-left: 43px;padding-left: 10px;background: white\">\nRoles</h1></div><div layout=\"row\" style=\"margin:auto;width:90%\"><div layout=\"column\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nChoose roles to assign<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><div \nstyle=\"display: flex;flex: 1\"><aside><div class=\"container\"><div class=\"round\"><input id=\"roleOrgOwner\" value=\"true\" \ntype=\"checkbox\" ng-model=\"$ctrl.newInvite.assignRoleOwner\" ng-click=\"$ctrl.resetDefaultRole()\"><label \nfor=\"roleOrgOwner\" style=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8\"></label></div></div>\n</aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nOrganisation owner</aside></div></div></div><div layout=\"row\" style=\"margin:auto;width:90%\"><div \nstyle=\"display: flex;flex: 1;margin-top: 20px\"><aside><div class=\"container\"><div class=\"round\"><input \nid=\"roleClinician\" value=\"true\" type=\"checkbox\" ng-model=\"$ctrl.newInvite.assignRoleClinician\" \nng-click=\"$ctrl.resetDefaultRole()\"><label for=\"roleClinician\" \nstyle=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8\"></label></div></div></aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nClinician</aside></div></div><div layout=\"row\" style=\"margin:auto;width:90%\"><div \nstyle=\"display: flex;flex: 1;margin-top: 20px;margin-bottom: 30px\"><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px\">\n* To add MDT coordinator or conference roles please contact us at <a target=\"_blank\" \nhref=\"mailto:support@clinivid.com.au\">support@clinivid.com.au</a></aside></div></div><md-radio-group \nng-model=\"$ctrl.newInvite.defaultRole\" style=\"margin: auto;width:90%\" \nng-show=\"($ctrl.newInvite.assignRoleClinician && $ctrl.newInvite.assignRoleOwner)\"><span \nstyle=\"font-size: 11px;font-weight: normal;letter-spacing: normal;color: #333333;padding-left: 2px\">Select default role\n</span><div style=\"display: flex;align-items: center;font-size: 14px;margin-top: 10px;width:90%;margin-bottom: 0px\">\n<md-radio-button value=\"OrgOwner\" class=\"md-primary\" style=\"margin-bottom: 0;font-size: 12px\">Organisation owner\n</md-radio-button><md-radio-button value=\"Creator\" class=\"md-primary\" \nstyle=\"margin-bottom: 0;margin-left: 30px;font-size: 12px\">Clinician</md-radio-button></div></md-radio-group><div \nlayout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 30px\"><md-button type=\"submit\" \nng-click=\"$ctrl.sendInvite()\" class=\"md-raised md-accent submit-button\" \nstyle=\"border-radius:5px;width:115px;height:40px;font-size: 16px;;text-transform: none !important\">Invite</md-button>\n</div></div></div>");
$templateCache.put("app/main/admin/manage-organisation/invite-status.html","<div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px;max-width:100%;min-width:600px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.cancelInviteStatusPage()\"></md-icon></div></div><div layout=\"row\" \nstyle=\"position: absolute;top: 0\"><div layout=\"column\" style=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px\">\nInvite status</div></div><div layout=\"column\" layout-align=\"center center\" \nng-show=\"!$ctrl.inviteStatus || $ctrl.inviteStatus.length === 0\"><div \nstyle=\"margin: 10px;margin-top:30px;font-style: italic\"><div><img src=\"assets/images/info.png\" \nstyle=\"padding-top: 3px;margin-right: 5px\">There are no invites for this organisation.</div></div></div><div \nlayout=\"row\" style=\"height:50px;margin-top:80px\" ng-show=\"$ctrl.inviteStatus && $ctrl.inviteStatus.length > 0\"><input \ntype=\"text\" placeholder=\"Search invites\" ng-model=\"$ctrl.inviteSearchTerm\" \nstyle=\"background: #ffffff;padding:10px;border-radius:5px;-moz-border-radius:5px;-webkit-border-radius:5px;-o-border-radius:5px;border: 1px solid #92298D;width:160px;height:30px\">\n <img src=\"/assets/images/purple-close-circle.png\" style=\"width:30px;height:30px;margin-right:13px;cursor:pointer\" \nng-click=\"$ctrl.cancelInviteSearch()\" ng-show=\"$ctrl.inviteSearchTerm.length > 0\"></div><div layout=\"column\" \nlayout-align=\"center center\" ng-show=\"$ctrl.inviteStatus && $ctrl.inviteStatus.length > 0\"><div \nstyle=\"margin: 10px;margin-top:30px\"><div class=\"tbl-header\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><thead>\n<tr><th>Name</th><th>Sent on</th><th>Status</th><th>Action</th></tr></thead></table></div><div class=\"tbl-content\" \nstyle=\"height: 100%\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tbody><tr \nng-repeat=\"inviteStatus in $ctrl.inviteStatus | filter: $ctrl.inviteSearchTerm track by $index\"><td>\n{{inviteStatus.userName}}</td><td>{{inviteStatus.createdDate}}</td><td><div \nstyle=\"width: 70px;border-radius: 4px;font-size: 11px;padding: .25em .75em;font-weight: 500;text-align: center;vertical-align: middle;background: #ff902b;color: #ffffff\" \nng-show=\"inviteStatus.statusCode === 55\">{{inviteStatus.statusText}}</div><div \nstyle=\"width: 70px;border-radius: 4px;font-size: 11px;padding: .25em .75em;font-weight: 500;text-align: center;vertical-align: middle;background: #27c24c;color: #ffffff\" \nng-show=\"inviteStatus.statusCode === 70\">{{inviteStatus.statusText}}</div></td><td><div \nstyle=\"width: 70px;border-radius: 4px;font-size: 11px;padding: .25em .75em;font-weight: 500;text-align: center;vertical-align: middle;background: #92298D;color: #ffffff;cursor: pointer\" \nng-show=\"inviteStatus.statusCode === 55\" ng-click=\"$ctrl.resendInvite(inviteStatus.inviteId)\">RESEND</div></td></tr>\n</tbody></table></div></div></div></div>");
$templateCache.put("app/main/admin/manage-organisation/manage-cases.html","<div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px;max-width:100%;min-width: 600px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.cancelOpenCase()\"></md-icon></div></div><div layout=\"row\" \nstyle=\"position: absolute;top: 0\"><div layout=\"column\" style=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px\">\nChats</div></div><div layout=\"column\" layout-align=\"center center\" \nng-show=\"!$ctrl.allCases || $ctrl.allCases.length === 0\"><div style=\"margin: 10px;margin-top:30px;font-style: italic\">\n<div><img src=\"/assets/images/info.png\" style=\"padding-top: 3px;margin-right: 5px\">\nThere are no chats for this organisation.</div></div></div><div layout=\"row\" style=\"height:50px;margin-top:80px\" \nng-show=\"$ctrl.allCases && $ctrl.allCases.length > 0\"><input type=\"text\" placeholder=\"Search chats\" \nng-model=\"$ctrl.caseSearchTerm\" \nstyle=\"background: #ffffff;padding:10px;border-radius:5px;-moz-border-radius:5px;-webkit-border-radius:5px;-o-border-radius:5px;border: 1px solid #92298D;width:160px;height:30px\">\n <img src=\"/assets/images/purple-close-circle.png\" style=\"width:30px;height:30px;margin-right:13px;cursor:pointer\" \nng-click=\"$ctrl.cancelSearchCase()\" ng-show=\"$ctrl.caseSearchTerm.length > 0\"></div><div \nstyle=\"margin:auto;border-radius: 4px;font-size: 14px;padding: .45em .95em;font-weight: 500;text-align: center;vertical-align: middle;background: #92298D;color: #ffffff;cursor: pointer\" \nng-click=\"$ctrl.batchDownload()\" ng-show=\"$ctrl.showDownloadAll()\">DOWNLOAD SELECTED</div><div layout=\"column\" \nlayout-align=\"center center\" ng-show=\"$ctrl.allCases && $ctrl.allCases.length > 0\"><div \nstyle=\"margin: 10px;margin-top:30px\"><div class=\"tbl-header\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><thead>\n<tr><th style=\"text-align: center;width:10px\"><div class=\"container\"><div class=\"round\"><input type=\"checkbox\" \nid=\"selectAllCases\" ng-model=\"$ctrl.allCasesSelected\"><label for=\"selectAllCases\" style=\"border-radius: 5px\" \nng-click=\"$ctrl.selectDeselectAllCases()\"></label></div></div></th><th style=\"text-align: center\">Title</th><th \nstyle=\"text-align: center\">Sender</th><th style=\"text-align: center\">Patient</th><th style=\"text-align: center\">\nRecipients</th><th style=\"text-align: center\">Updated On</th><th style=\"text-align: center\">Action</th></tr></thead>\n</table></div><div class=\"tbl-content\" style=\"height: 100%\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tbody>\n<tr ng-repeat=\"userCase in $ctrl.allCases | filter: $ctrl.caseSearchTerm track by $index\"><td \nstyle=\"text-align: center;width:10px\"><div class=\"container\"><div class=\"round\"><input type=\"checkbox\" id=\"{{$index}}\" \nng-model=\"userCase.selected\"><label for=\"{{$index}}\" style=\"border-radius: 5px\"></label></div></div></td><td \nstyle=\"text-align: center\">{{userCase.title}}</td><td style=\"text-align: center\">{{userCase.senderName}}</td><td \nstyle=\"text-align: center\">{{userCase.patientName}}</td><td style=\"text-align: center\">{{userCase.recipientsNames}}\n</td><td style=\"text-align: center\">{{userCase.lastUpdated}}</td><td><div \nstyle=\"margin:auto;width: 90px;border-radius: 4px;font-size: 11px;padding: .45em .75em;font-weight: 500;text-align: center;vertical-align: middle;background: #92298D;color: #ffffff;cursor: pointer\" \nng-click=\"$ctrl.fetchCase(userCase.id,true)\">DOWNLOAD</div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/admin/manage-organisation/manage-contacts-add-contact.html","<div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px;min-width:600px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.cancelAddContact()\"></md-icon></div></div><div layout=\"column\" \nstyle=\"margin-top: 30px;width:100%\"><div layout=\"row\" \nstyle=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px;margin:auto\">Add contact</div><div layout=\"row\" \nstyle=\"height: 30px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto;margin-top: 30px\"><h1 \nstyle=\"font-size: 11px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;width: 50px;margin-top: -7px;margin-left: 43px;padding-left: 10px;background: white\">\nMode</h1></div><div layout=\"row\" style=\"margin:auto;margin-top:20px\"><md-radio-group ng-model=\"$ctrl.addContactMode\" \nstyle=\"margin: auto\"><div style=\"display: flex;align-items: center;font-size: 14px;margin-bottom: 0px\"><md-radio-button\n value=\"emailMode\" class=\"md-primary\" style=\"margin-bottom: 0;font-size: 12px\">By email</md-radio-button>\n<md-radio-button value=\"phoneMode\" class=\"md-primary\" style=\"margin-bottom: 0;margin-left: 30px;font-size: 12px\">\nBy mobile</md-radio-button></div></md-radio-group></div><div layout=\"row\" style=\"margin:auto;margin-top:30px\" \nng-show=\"$ctrl.addContactMode === \'phoneMode\'\"><div layout=\"column\" style=\"width:80px;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:10px\">\nCountry code<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><md-select \nclass=\"ng-pristine ng-valid md-default-theme ng-empty ng-touched\" tabindex=\"0\" aria-disabled=\"false\" role=\"listbox\" \naria-expanded=\"false\" aria-multiselectable=\"false\" placeholder=\"Country Code\" ng-model=\"$ctrl.addContact.region\" \naria-owns=\"select_container_56\" aria-invalid=\"false\" aria-label=\"Select country code\"><md-option value=\"AU\" \nselected=\"true\">+61 AUS</md-option><md-option value=\"NZ\">+64 NZ</md-option><md-option value=\"IN\">+91 IND</md-option>\n</md-select></md-input-container></div><div layout=\"column\" style=\"width:130px;margin-left:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:10px\">\nMobile number<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.addContact.phone\" placeholder=\"Mobile number\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:30px;width:50%\" ng-show=\"$ctrl.addContactMode === \'emailMode\'\"><div layout=\"column\" \nstyle=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nEmail<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container class=\"md-block\" \nmd-no-float style=\"margin-top:8px;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.addContact.email\" placeholder=\"Email\"></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"center center\" style=\"margin-bottom: 30px;margin-top: 30px\"><md-button type=\"submit\" \nng-click=\"$ctrl.addContactNext()\" class=\"md-raised md-accent submit-button\" \nstyle=\"border-radius:5px;width:115px;height:40px;font-size: 16px;;text-transform: none !important\">Next</md-button>\n</div><div ng-show=\"$ctrl.isContactExistingUser\"><div layout=\"row\" \nstyle=\"height: 30px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto\"><h1 \nstyle=\"font-size: 11px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;width: 120px;margin-top: -7px;margin-left: 43px;padding-left: 10px;background: white\">\nExisting user details</h1></div><div layout=\"row\" style=\"margin:auto;width: 90%\"><div layout=\"column\" \nstyle=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nTitle</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.existingUserPayload.title\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nFirst name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.existingUserPayload.firstname\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nMiddle name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.existingUserPayload.middleNames\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nLast name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.existingUserPayload.lastname\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nProfession</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.existingUserPayload.profession\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"center center\" style=\"margin-bottom: 30px\"><md-button type=\"submit\" \nng-click=\"$ctrl.connectWithContact()\" class=\"md-raised md-accent submit-button\" \nstyle=\"border-radius:5px;width:115px;height:40px;font-size: 16px;;text-transform: none !important\">Connect</md-button>\n</div></div><div ng-show=\"$ctrl.isContactNewUser\"><div layout=\"row\" \nstyle=\"height: 30px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto\"><h1 \nstyle=\"font-size: 11px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;width: 100px;margin-top: -7px;margin-left: 43px;padding-left: 10px;background: white\">\nNew user details</h1></div><div layout=\"row\" style=\"margin:auto;width: 90%\"><div layout=\"column\" \nstyle=\"margin-right:10px;width:30%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nTitle</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><md-select \ntype=\"text\" style=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial\" \nng-model=\"$ctrl.newUserPayload.title\" placeholder=\"Title\"><md-option value=\"Dr\">Dr</md-option><md-option value=\"Mr\">Mr\n</md-option><md-option value=\"Mrs\">Mrs</md-option><md-option value=\"Ms\">Ms</md-option><md-option value=\"Miss\">Miss\n</md-option><md-option value=\"Master\">Master</md-option><md-option value=\"Prof\">Prof</md-option><md-option \nvalue=\"A/Prof\">A/Prof</md-option><md-option value=\"Other\">Other</md-option></md-select></md-input-container></div>\n</div><div layout=\"row\" style=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" \nstyle=\"margin-right:10px;width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nFirst name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.newUserPayload.firstname\" placeholder=\"First name\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nMiddle name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.newUserPayload.middleNames\" placeholder=\"Middle name\"></md-input-container></div></div><div \nlayout=\"row\" style=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:50%\">\n<h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nLast name<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.newUserPayload.lastname\" placeholder=\"Last name\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nProfession</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0;margin-left:-5px\">\n<md-select name=\"profession\" ng-model=\"$ctrl.newUserPayload.profession\" placeholder=\"Profession\"><md-option \nname=\"profession\" value=\"Aboriginal and Torres Strait Islander Health Practitioner\">\nAboriginal and Torres Strait Islander<br>Health Practitioner</md-option><md-option name=\"profession\" \nvalue=\"Chinese Medicine Practitioner\">Chinese Medicine Practitioner</md-option><md-option name=\"profession\" \nvalue=\"Chiropractor\">Chiropractor</md-option><md-option name=\"profession\" value=\"Dental Practitioner\">\nDental Practitioner</md-option><md-option name=\"profession\" value=\"Medical Practitioner\">Medical Practitioner\n</md-option><md-option name=\"profession\" value=\"Medical Radiation Practitioner\">Medical Radiation Practitioner\n</md-option><md-option name=\"profession\" value=\"Midwife\">Midwife</md-option><md-option name=\"profession\" value=\"Nurse\">\nNurse</md-option><md-option name=\"profession\" value=\"Occupational Therapist\">Occupational Therapist</md-option>\n<md-option name=\"profession\" value=\"Optometrist\">Optometrist</md-option><md-option name=\"profession\" value=\"Osteopath\">\nOsteopath</md-option><md-option name=\"profession\" value=\"Paramedic\">Paramedic</md-option><md-option name=\"profession\" \nvalue=\"Pathologist\">Pathologist</md-option><md-option name=\"profession\" value=\"Pharmacist\">Pharmacist</md-option>\n<md-option name=\"profession\" value=\"Physiotherapist\">Physiotherapist</md-option><md-option name=\"profession\" \nvalue=\"Podiatrist\">Podiatrist</md-option><md-option name=\"profession\" value=\"Psychologist\">Psychologist</md-option>\n<md-option name=\"profession\" value=\"Sonographer\">Sonographer</md-option><md-option name=\"profession\" value=\"Other\">\nOther</md-option></md-select></md-input-container></div></div><div layout=\"row\" layout-align=\"center center\" \nstyle=\"margin-bottom: 30px;margin-top: 30px\"><md-button type=\"submit\" ng-click=\"$ctrl.addNewUser()\" \nclass=\"md-raised md-accent submit-button\" \nstyle=\"border-radius:5px;width:115px;height:40px;font-size: 16px;;text-transform: none !important\">Add</md-button>\n</div></div></div></div>");
$templateCache.put("app/main/admin/manage-organisation/manage-contacts-edit-contact.html","<div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px;min-width:600px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.cancelEditContact()\"></md-icon></div></div><div layout=\"column\" \nstyle=\"margin-top: 30px;width:100%\"><div layout=\"row\" \nstyle=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px;margin:auto\">Edit contact</div><div><div layout=\"row\" \nstyle=\"height: 30px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto;margin-top: 30px\"><h1 \nstyle=\"font-size: 11px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;width: 100px;margin-top: -7px;margin-left: 43px;padding-left: 10px;background: white\">\nUser details</h1></div><div layout=\"row\" style=\"margin:auto;width: 90%\"><div layout=\"column\" \nstyle=\"margin-right:10px;width:20%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nTitle</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><md-select \ntype=\"text\" style=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial\" \nng-model=\"$ctrl.contactEdited.title\" placeholder=\"Title\"><md-option value=\"Dr\">Dr</md-option><md-option value=\"Mr\">Mr\n</md-option><md-option value=\"Mrs\">Mrs</md-option><md-option value=\"Ms\">Ms</md-option><md-option value=\"Miss\">Miss\n</md-option><md-option value=\"Master\">Master</md-option><md-option value=\"Prof\">Prof</md-option><md-option \nvalue=\"A/Prof\">A/Prof</md-option><md-option value=\"Other\">Other</md-option></md-select></md-input-container></div>\n</div><div layout=\"row\" style=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" \nstyle=\"margin-right:10px;width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nFirst name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.contactEdited.firstname\" placeholder=\"First name\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nMiddle name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.contactEdited.middleNames\" placeholder=\"Middle name\"></md-input-container></div></div><div \nlayout=\"row\" style=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:50%\">\n<h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nLast name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.contactEdited.lastname\" placeholder=\"Last name\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nProfession</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><md-select \ntype=\"text\" style=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial\" \nng-model=\"$ctrl.contactEdited.profession\" placeholder=\"Profession\"><md-option \nvalue=\"Aboriginal and Torres Strait Islander Health Practitioner\">Aboriginal and Torres Strait Islander<br>\nHealth Practitioner</md-option><md-option value=\"Chinese Medicine Practitioner\">Chinese Medicine Practitioner\n</md-option><md-option value=\"Chiropractor\">Chiropractor</md-option><md-option value=\"Dental Practitioner\">\nDental Practitioner</md-option><md-option value=\"Medical Practitioner\">Medical Practitioner</md-option><md-option \nvalue=\"Medical Radiation Practitioner\">Medical Radiation Practitioner</md-option><md-option value=\"Midwife\">Midwife\n</md-option><md-option value=\"Nurse\">Nurse</md-option><md-option value=\"Occupational Therapist\">Occupational Therapist\n</md-option><md-option value=\"Optometrist\">Optometrist</md-option><md-option value=\"Osteopath\">Osteopath</md-option>\n<md-option value=\"Paramedic\">Paramedic</md-option><md-option value=\"Pathologist\">Pathologist</md-option><md-option \nvalue=\"Pharmacist\">Pharmacist</md-option><md-option value=\"Physiotherapist\">Physiotherapist</md-option><md-option \nvalue=\"Podiatrist\">Podiatrist</md-option><md-option value=\"Psychologist\">Psychologist</md-option><md-option \nvalue=\"Sonographer\">Sonographer</md-option><md-option value=\"Other\">Other</md-option></md-select></md-input-container>\n</div></div><div layout=\"row\" style=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" \nstyle=\"margin-right:10px;width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nAHPRA No</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.contactEdited.registrationId\" placeholder=\"Registration No\"></md-input-container></div></div><div \nlayout=\"row\" style=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:50%\">\n<h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nEmail</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.contactEdited.email\" placeholder=\"Email\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;width:90%;margin-top: 20px\"><div layout=\"column\" style=\"width:15%;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:10px\">\nCountry code</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><md-select \ntype=\"text\" tabindex=\"0\" aria-disabled=\"false\" role=\"listbox\" aria-expanded=\"false\" aria-multiselectable=\"false\" \nplaceholder=\"Country Code\" ng-model=\"$ctrl.contactEdited.region\" aria-owns=\"select_container_56\" aria-invalid=\"false\" \naria-label=\"Select country code\"><md-option value=\"AU\" selected=\"true\">+61 AUS</md-option><md-option value=\"NZ\">+64 NZ\n</md-option><md-option value=\"IN\">+91 IND</md-option></md-select></md-input-container></div><div layout=\"column\" \nstyle=\"width:32%;margin-left:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:10px\">\nMobile number</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.contactEdited.mobile\" placeholder=\"Mobile number\"></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"center center\" style=\"margin-bottom: 30px;margin-top: 30px\"><md-button type=\"submit\" \nng-click=\"$ctrl.updateContact()\" class=\"md-raised md-accent submit-button\" \nstyle=\"border-radius:5px;width:115px;height:40px;font-size: 16px;;text-transform: none !important\">Update</md-button>\n</div></div></div></div>");
$templateCache.put("app/main/admin/manage-organisation/manage-contacts.html","<div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px;max-width: 100%;min-width:600px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.cancelInviteStatusPage()\"></md-icon></div></div><div layout=\"row\" \nstyle=\"position: absolute;top: 0\"><div layout=\"column\" style=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px\">\nMembers and shared contacts</div></div><div layout=\"column\" layout-align=\"center center\" \nng-show=\"!$ctrl.orgContacts || $ctrl.orgContacts.length === 0\"><div \nstyle=\"margin: 10px;margin-top:30px;font-style: italic\"><div><img src=\"assets/images/info.png\" \nstyle=\"padding-top: 3px;margin-right: 5px\">There are no contacts in this organisation.</div></div></div><div \nlayout=\"row\" style=\"height:50px;margin-top:80px\" ng-show=\"$ctrl.orgContacts && $ctrl.orgContacts.length > 0\"><input \ntype=\"text\" placeholder=\"Search contacts\" ng-model=\"$ctrl.orgContactSearchTerm\" \nstyle=\"background: #ffffff;padding:10px;border-radius:5px;-moz-border-radius:5px;-webkit-border-radius:5px;-o-border-radius:5px;border: 1px solid #92298D;width:160px;height:30px\">\n <img src=\"/assets/images/purple-close-circle.png\" style=\"width:30px;height:30px;margin-right:13px;cursor:pointer\" \nng-click=\"$ctrl.cancelContactSearch()\" ng-show=\"$ctrl.orgContactSearchTerm.length > 0\"> <span \nstyle=\"padding-left: 35px\"><span><img src=\"/assets/images/add-contact.png\" \nstyle=\"cursor:pointer;width:30px;height:30px\" ng-click=\"$ctrl.openAddContact()\"><md-tooltip class=\"hide-xs\">\nAdd a new contact</md-tooltip></span></span></div><div layout=\"column\" layout-align=\"center center\" \nng-show=\"$ctrl.orgContacts && $ctrl.orgContacts.length > 0\"><div style=\"margin: 10px;margin-top:30px\"><div \nclass=\"tbl-header\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><thead><tr><th style=\"text-transform: none\">Name\n</th><th style=\"text-transform: none;width: 25%\">Email</th><th style=\"text-transform: none;width: 20%\">Mobile</th><th \nstyle=\"text-transform: none;width: 20%\">Profession</th><th style=\"text-transform: none;width: 5%\">Edit</th><th \nstyle=\"text-transform: none;text-align: end;width: 10%\">Delete</th></tr></thead></table></div><div class=\"tbl-content\" \nstyle=\"height: 100%\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tbody><tr \nng-repeat=\"orgContact in $ctrl.orgContacts | filter: $ctrl.orgContactSearchTerm track by $index\"><td>\n{{orgContact.userName}}</td><td style=\"width: 25%;word-wrap:break-word\">{{orgContact.email}}</td><td \nstyle=\"width: 20%\">{{orgContact.mobile}}</td><td style=\"width: 20%\">{{orgContact.profession}}</td><td \nstyle=\"width: 5%\"><md-icon md-font-icon=\"icon-pencil-box-outline\" style=\"color: #0899ff;cursor: pointer\" \nng-show=\"!orgContact.isLinked\" ng-click=\"$ctrl.editContact(orgContact)\"></md-icon></td><td \nstyle=\"text-align: end;width: 10%\"><md-icon md-font-icon=\"icon-trash\" style=\"color:#FF0000;cursor: pointer\" \nng-click=\"$ctrl.deleteContact(orgContact.id,orgContact.userName)\"></md-icon></td></tr></tbody></table></div></div>\n</div></div>");
$templateCache.put("app/main/admin/manage-organisation/manage-members-edit.html","<div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px;min-width:600px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.cancelEditMemberPage()\"></md-icon></div></div><div \nlayout=\"column\" style=\"margin-top: 30px;width:100%\"><div layout=\"row\" \nstyle=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px;margin:auto\">Edit member</div><div><div layout=\"row\" \nstyle=\"height: 30px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto;margin-top: 30px\"><h1 \nstyle=\"font-size: 11px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;width: 100px;margin-top: -7px;margin-left: 43px;padding-left: 10px;background: white\">\nUser details</h1></div><div layout=\"row\" style=\"margin:auto;width: 90%\"><div layout=\"column\" \nstyle=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nTitle</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.editInvitee.title\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nFirst name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.editInvitee.firstname\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nMiddle name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.editInvitee.middleNames\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nLast name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.editInvitee.lastname\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nEmail</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.editInvitee.email\" placeholder=\"Email\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nMobile</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.editInvitee.mobile\" placeholder=\"Mobile\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"height: 30px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto;margin-top: 30px\"><h1 \nstyle=\"font-size: 11px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;width: 80px;margin-top: -7px;margin-left: 43px;padding-left: 10px;background: white\">\nUser roles</h1></div><div layout=\"row\" style=\"margin:auto;width:90%\"><div layout=\"column\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nEdit roles to assign<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><div \nstyle=\"display: flex;flex: 1\"><aside><div class=\"container\"><div class=\"round\"><input id=\"inviteRoleOrgOwner\" \nvalue=\"true\" type=\"checkbox\" ng-model=\"$ctrl.editInvitee.isOrgOwner\"><label for=\"inviteRoleOrgOwner\" \nstyle=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8\"></label></div></div></aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nOrganisation owner</aside></div></div></div><div layout=\"row\" style=\"margin:auto;width:90%\"><div \nstyle=\"display: flex;flex: 1;margin-top: 20px\"><aside><div class=\"container\"><div class=\"round\"><input \nid=\"inviteeRoleClinician\" value=\"true\" type=\"checkbox\" ng-model=\"$ctrl.editInvitee.isClinician\"><label \nfor=\"inviteeRoleClinician\" style=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8\"></label></div>\n</div></aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nClinician</aside></div></div><div layout=\"row\" style=\"margin:auto;width:90%\"><div \nstyle=\"display: flex;flex: 1;margin-top: 20px;margin-bottom: 30px\"><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px\">\n* To add MDT coordinator or conference roles please contact us at <a target=\"_blank\" \nhref=\"mailto:support@clinivid.com.au\">support@clinivid.com.au</a></aside></div></div><div layout=\"row\" \nlayout-align=\"center center\" style=\"margin-bottom: 30px\"><md-button type=\"submit\" ng-click=\"$ctrl.updateInvitee()\" \nclass=\"md-raised md-accent submit-button\" \nstyle=\"border-radius:5px;width:115px;height:40px;font-size: 16px;;text-transform: none !important\">Update</md-button>\n</div></div></div></div>");
$templateCache.put("app/main/admin/manage-organisation/manage-members.html","<div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px;margin:auto;min-width:600px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.cancelInviteStatusPage()\"></md-icon></div></div><div layout=\"row\" \nstyle=\"position: absolute;top: 0\"><div layout=\"column\" style=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px\">\nMembers</div></div><div layout=\"column\" layout-align=\"center center\" \nng-show=\"!$ctrl.orgUsers || $ctrl.orgUsers.length === 0\"><div style=\"margin: 10px;margin-top:30px;font-style: italic\">\n<div><img src=\"assets/images/info.png\" style=\"padding-top: 3px;margin-right: 5px\">\nThere are no members in this organisation.</div></div></div><div layout=\"row\" style=\"height:50px;margin-top:80px\" \nng-show=\"$ctrl.orgUsers && $ctrl.orgUsers.length > 0\"><input type=\"text\" placeholder=\"Search members\" \nng-model=\"$ctrl.orgUserSearchTerm\" \nstyle=\"background: #ffffff;padding:10px;border-radius:5px;-moz-border-radius:5px;-webkit-border-radius:5px;-o-border-radius:5px;border: 1px solid #92298D;width:160px;height:30px\">\n <img src=\"/assets/images/purple-close-circle.png\" style=\"width:30px;height:30px;margin-right:13px;cursor:pointer\" \nng-click=\"$ctrl.cancelOrgUserSearch()\" ng-show=\"$ctrl.orgUserSearchTerm.length > 0\"></div><div layout=\"column\" \nlayout-align=\"center center\" ng-show=\"$ctrl.orgUsers && $ctrl.orgUsers.length > 0\"><div \nstyle=\"margin: 10px;margin-top:30px\"><div class=\"tbl-header\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><thead>\n<tr><th style=\"text-transform: none\">Name</th><th style=\"text-transform: none;text-align: end;width: 15%\">Edit</th><th \nstyle=\"text-transform: none;text-align: end;width: 15%\">Delete</th></tr></thead></table></div><div class=\"tbl-content\" \nstyle=\"height: 100%\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tbody><tr \nng-repeat=\"orgUser in $ctrl.orgUsers | filter: $ctrl.orgUserSearchTerm track by $index\"><td>{{orgUser.userName}}</td>\n<td style=\"text-align: end;width: 15%\"><md-icon md-font-icon=\"icon-pencil-box-outline\" \nstyle=\"color: #0899ff;cursor: pointer\" ng-click=\"$ctrl.editMember(orgUser)\"></md-icon></td><td \nstyle=\"text-align: end;width: 15%\"><md-icon md-font-icon=\"icon-trash\" style=\"color:#FF0000;cursor: pointer\" \nng-click=\"$ctrl.deleteMember(orgUser)\"></md-icon></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/admin/manage-organisation/no-organisation.html","<div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px;margin:auto;min-width:600px\"><div \nlayout=\"column\" layout-align=\"center center\" style=\"font-size: 2.4rem;font-family: Roboto\">\nYou are not admin of any organisations.<br></div></div>");
$templateCache.put("app/main/admin/manage-organisation/notifications.html","<div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px;min-width:130%\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.cancelAddMemberPage()\"></md-icon></div></div><div \nstyle=\"position: absolute;bottom:0;right:0;padding-bottom: 8px;padding-right: 25px\"><md-button type=\"submit\" \nng-click=\"$ctrl.sendNotification()\" class=\"md-raised md-accent submit-button\" \nstyle=\"border-radius:5px;width:115px;height:40px;font-size: 16px;;text-transform: none !important\" \nng-disabled=\"(\n                                ($ctrl.newNotification.content ==null || $ctrl.newNotification.content.trim().length == 0) ||\n                                ($ctrl.chipContacts == null || ($ctrl.chipContacts != null && $ctrl.chipContacts.length ==0)) ||\n                                ($ctrl.newNotification.subject == null || ($ctrl.newNotification.subject.trim().length ==0))\n                                )\">\nSend</md-button></div><div layout=\"column\" style=\"margin-top: 30px;width:100%\"><div layout=\"row\" \nstyle=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px;margin:auto\">Notification</div><div layout=\"row\" \nstyle=\"margin:auto;margin-top: 10px;width:90%\"><div layout=\"column\" \nstyle=\"margin-right:10px;width:30%;text-align: right\"><h1 \nstyle=\"margin-top: 14px;font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:10px\">\nSending as:</h1></div><div layout=\"column\" style=\"width:100%;margin-left:10px\"><h1 \nstyle=\"font-size: 15px;font-weight: bold;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:10px\" \nng-bind=\"$ctrl.userService.getUserName()\"></h1><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: italic;line-height: normal;letter-spacing: normal;color: #494949;height:10px\" \nng-bind=\"$ctrl.selectedOrgDisplayName\"></h1></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top: 10px;width:90%\"><div layout=\"column\" \nstyle=\"margin-right:10px;width:30%;text-align: right;margin-top: 10px\"><h1 \nstyle=\"margin-top: 14px;font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:10px\">\nSending to:</h1></div><div layout=\"column\" style=\"width:100%;margin-left:10px\"><md-chips ng-model=\"$ctrl.chipContacts\" \nmd-transform-chip=\"$ctrl.transformChip($chip)\" md-require-match=\"true\" style=\"width:450px\"><md-autocomplete \nmd-selected-item=\"$ctrl.selectedItemChip\" md-no-cache=\"true\" md-require-match=\"true\" \nmd-search-text=\"$ctrl.searchTextChip\" md-items=\"item in $ctrl.querySearchChip($ctrl.searchTextChip)\" \nmd-item-text=\"item.fullName\" placeholder=\"Enter name...\" md-menu-class=\"autocomplete-custom-template\" \nmd-menu-container-class=\"custom-container\" md-min-length=\"0\" style=\"width:400px\"><md-item-template><span \nclass=\"item-title\"><span>{{item.fullName}} </span></span><span class=\"profession\"><span>{{item.profession}}</span> \n</span><span class=\"item-metadata\"><span>{{item.formattedOrganizationName}}</span></span></md-item-template>\n<md-not-found>No matches found.</md-not-found></md-autocomplete><md-chip-template><span><strong \nstyle=\"font-size: 15px;font-weight: bold\">{{$chip.fullName}}</strong></span></md-chip-template><button \nmd-chip-remove=\"\" style=\"margin-right: 9px;margin-top: 7px\">&times;</button></md-chips></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top: 10px;width:90%\"><div layout=\"column\" \nstyle=\"margin-right:10px;width:30%;text-align: right;margin-top: 10px\"><h1 \nstyle=\"margin-top: 14px;font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:10px\">\nSubject:</h1></div><div layout=\"column\" style=\"width:100%;margin-left:10px\"><md-input-container md-no-float \nclass=\"md-block\"><input type=\"text\" ng-model=\"$ctrl.newNotification.subject\"></md-input-container></div></div><div \nlayout=\"row\" style=\"margin:auto;margin-top: 10px;width:90%;margin-bottom: 70px\"><div layout=\"column\" \nstyle=\"margin-right:10px;width:30%;text-align: right\"><h1 \nstyle=\"margin-top: 14px;font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:10px\">\nContent:</h1></div><div layout=\"column\" style=\"width:100%;margin-left:10px\"><textarea class=\"caseMessageTextBox\" \ntype=\"text\" style=\"width:100%\" ng-model=\"$ctrl.newNotification.content\">\n        </div>\n      </div>\n\n    </div>\n\n  \n</div>");
$templateCache.put("app/main/admin/manage-organisation/org-info.html","<div class=\"padded\" md-whiteframe flex=\"100\" layout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px;min-width: 600px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.cancelOrganizationDisplay()\"></md-icon></div></div><div \nlayout=\"column\" style=\"position: absolute;top: 0;left:0\"><div layout=\"row\" layout-align=\"center center\"><md-menu-bar>\n<md-menu md-position-mode=\"left bottom\"><md-button aria-label=\"Open phone interactions menu\" class=\"md-icon-button\" \nng-click=\"$ctrl.openOrgMenu($mdMenu, $event)\"><img src=\"/assets/images/menu-24.png\"></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button ng-click=\"$ctrl.openAddMemberPage()\">Add member</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"$ctrl.openInviteMemberPage()\">Invite member</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"$ctrl.openInviteStatusPage()\">Invite status</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"$ctrl.openManageMembersPage()\">Manage members</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"$ctrl.openManageContactsPage()\">Manage contacts</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"$ctrl.openNotificationsPage()\">Notification</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"$ctrl.openCases()\">Chats</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"$ctrl.openActivityStatusPage()\">Activity status</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar></div></div><div layout=\"row\" style=\"margin-top:-10px\"><div layout=\"column\" layout-align=\"center center\" \nstyle=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px\">Organisation info</div></div><div layout=\"column\" \nstyle=\"width: 300px;max-width: 300px;margin-top: 12px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nDisplay name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.selectedOrgDisplayName\" placeholder=\"Display name\"></md-input-container></div><div layout=\"column\" \nstyle=\"width: 300px;max-width: 300px;margin-top: 20px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nFormal name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.selectedOrgFormalName\" placeholder=\"Formal name\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\" style=\"margin-top: 30px\"><md-button type=\"submit\" \nng-click=\"$ctrl.saveOrganizationInfoChanges()\" class=\"md-raised md-accent submit-button\" \nstyle=\"border-radius:5px;width:115px;height:40px;font-size: 16px;;text-transform: none !important\">Save</md-button>\n</div></div>");
$templateCache.put("app/main/admin/organisations/org-add.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page off-white-bg\" layout=\"column\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">Organisation</span></div><div class=\"title\">Add Organisation</div></div></div><div \nclass=\"content\" layout=\"column\"><div class=\"md-title\">Create and Add an Organisation</div><div class=\"pb-16\">\nUse this form to add a new organisation to Clinivid such as an enterprise. You must select or enter a user who will have full ownership of the organisation. If you enter a new user, the system will issue an invitation to that user via email to complete their account registration. The organisation will not be active until the owning user account is fully registered.\n</div><form name=\"stepper\" ms-stepper ng-submit=\"$ctrl.submitStepper()\" ng-model=\"$ctrl.org\" novalidate>\n<ms-stepper-step ng-form=\"nameForm\" step=\"1\" step-title=\"\'Owner\'\"><div \nng-include=\"\'app/main/shared/templates/name-form.html\'\"></div></ms-stepper-step><ms-stepper-step \nng-form=\"professionForm\" step=\"2\" step-title=\"\'Profession\'\"><div \nng-include=\"\'app/main/admin/people/profession-form.html\'\"></div></ms-stepper-step><ms-stepper-step ng-form=\"linksForm\" \nstep=\"3\" step-title=\"\'Contact\'\"><div ng-include=\"\'app/main/admin/people/links-form.html\'\"></div></ms-stepper-step>\n<ms-stepper-step ng-form=\"orgForm\" step=\"4\" step-title=\"\'Organisation\'\"><div \nng-include=\"\'app/main/admin/organisations/org-form.html\'\"></div></ms-stepper-step></form></div></div>");
$templateCache.put("app/main/admin/organisations/org-edit.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page off-white-bg\" layout=\"column\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">Organisation</span></div><div class=\"title\">Edit Organisation</div></div></div><div \nclass=\"content\" layout=\"column\"><div class=\"md-title mt-32\">Edit Organisation Details</div><div class=\"pb-16\">\nYou may edit the details of an organisation with this form. Not all details can be changed. Please contact a System Admin if you have special circumstances.\n</div><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"basicForm\" \nclass=\"md-inline-form\" ng-submit=\"$ctrl.submitEdit()\" novalidate><div class=\"form-title\">Organisation Details</div><br>\n<div ng-include=\"\'app/main/admin/organisations/org-form.html\'\"></div><div layout=\"row\" layout-align=\"center\"><md-button\n class=\"md-raised\" aria-label=\"Cancel\">Cancel</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" \naria-label=\"Submit\" ng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button></div></form></div></div>\n</div></div>");
$templateCache.put("app/main/admin/organisations/org-form.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"displayName\" ng-model=\"$ctrl.form.org.displayName\" placeholder=\"Display Name\" \nrequired><div ng-messages=\"orgForm.displayName.$error\" ng-show=\"orgForm.displayName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Display Name field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"formalName\" ng-model=\"$ctrl.form.org.formalName\" \nplaceholder=\"Formal Name\" required><div ng-messages=\"orgForm.formalName.$error\" ng-show=\"orgForm.formalName.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Formal Name field is required.</span></div></div></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"description\" ng-model=\"$ctrl.form.org.description\" placeholder=\"Description\"></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"registeredId\" \nng-model=\"$ctrl.form.org.registeredId\" placeholder=\"ABN\" ng-pattern=\"/^[0-9 -]+$/\" ng-maxlength=\"14\" ng-minlength=\"11\" \nrequired><div ng-messages=\"orgForm.registeredId.$error\" ng-show=\"orgForm.registeredId.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>ABN field is required.</span></div><div ng-message=\"pattern\"><span>Invalid characters.\n</span></div><div ng-message=\"maxlength\"><span>Too many digits.</span></div><div ng-message=\"minlength\"><span>\nNot enough digits.</span></div></div></md-input-container></div></div>");
$templateCache.put("app/main/admin/organisations/org-view.html","<div class=\"page-layout carded fullwidth single-scroll off-white-bg\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" flex><div class=\"header\"><span class=\"h2 white-fg\">View Organisation</span></div><div \nclass=\"content-card\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span>{{$ctrl.form.formalName}}\n</span><span style=\"width:100%\"></span><md-button ng-click=\"$ctrl.scopeToOrg()\">Scope</md-button><md-button \nui-sref=\"app.admin.org.edit({id: $ctrl.form.org.id})\" style=\"float:right; white-space: nowrap\">Edit</md-button></div>\n<md-content class=\"content\" ms-scroll><div class=\"demo-content\"><h1>{{$ctrl.form.org.displayName}}</h1><h4 \nclass=\"secondary-text\">ABN: {{$ctrl.form.org.registeredId}}</h4><br><p>{{$ctrl.form.org.description}}</p><br><h3>Links\n</h3><br><br><h3>Contacts</h3><br><br><h3>Premises</h3><br><br><h3>Members</h3><br><br><h3>Patients</h3><br><br></div>\n</md-content></div></div></div>");
$templateCache.put("app/main/admin/organisations/org.html","<div class=\"page-layout carded left-sidenav off-white-bg\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><div class=\"header\"><p></p></div><md-content class=\"content\" flex ms-scroll><div \nclass=\"demo-sidenav\"><md-list><md-subheader class=\"md-no-sticky\">Search Results</md-subheader><div \nng-repeat=\"org in $ctrl.results\" ui-sref=\"app.admin.org.view({id: org.id})\"><md-list-item><p><b>{{org.displayName}}</b>\n<br>ABN:{{org.registeredId}}</p></md-list-item><md-divider></md-divider></div></md-list></div></md-content>\n</md-sidenav><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">\nOrganisations</span></div><md-button class=\"add-contact-button md-fab secondary-bg\" ui-sref=\"app.admin.org.add\" \naria-label=\"Add Organisation\" translate translate-attr-aria-label=\"FM.ADD_FILE\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"$ctrl.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle left sidenav\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><p style=\"display:inline-block\">Search for an Organisation\n</p></div></div><md-content class=\"content\" flex ms-scroll><br><br><div layout=\"row\" \nlayout-align=\"space-between center\" layout-gt-xs=\"row\" flex-gt-md=\"40\" flex-md=\"60\" flex-sm=\"80\" flex-xs=\"100\" \nstyle=\"margin: auto\"><div layout=\"column\" layout-align=\"start\" flex><md-input-container style=\"width: 100%\"><input \ntype=\"text\" name=\"nameQuery\" ng-model=\"$ctrl.form.org.nameQuery\" placeholder=\"Search by Name\" required><div \nng-messages=\"orgForm.nameQuery.$error\" ng-show=\"orgForm.nameQuery.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>Display Name field is required.</span></div></div></md-input-container></div><md-button class=\"md-raised mb-30\" \nlayout=\"column\" layout-align=\"start\" style=\"padding: 0 16px 0 16px;min-width: 48px\" ng-click=\"$ctrl.search(\'name\')\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"icon s24 md-font icon-magnify material-icons md-default-theme\"></md-icon>\n<span hide-xs>Search&nbsp;</span></md-button></div><br><br><div layout=\"row\" layout-align=\"space-between center\" \nlayout-gt-xs=\"row\" flex-gt-md=\"40\" flex-md=\"60\" flex-sm=\"80\" flex-xs=\"100\" style=\"margin: auto\"><div layout=\"column\" \nlayout-align=\"start\" flex><md-input-container style=\"width: 100%\"><input type=\"text\" name=\"registeredId\" \nng-model=\"$ctrl.form.org.registeredId\" placeholder=\"Search by ABN\" required><div \nng-messages=\"orgForm.registeredId.$error\" ng-show=\"orgForm.registeredId.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>ABN field is required.</span></div></div></md-input-container></div><md-button \nclass=\"md-raised mb-30\" layout=\"column\" layout-align=\"start\" style=\"padding: 0 16px 0 16px;min-width: 48px\" \nng-click=\"$ctrl.search(\'registeredId\')\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24 md-font icon-magnify material-icons md-default-theme\"></md-icon><span hide-xs>Search&nbsp;</span>\n</md-button></div></md-content></div></div></div>");
$templateCache.put("app/main/admin/people/links-form.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Email</label><input type=\"email\" name=\"email\" ng-model=\"$ctrl.form.person.email\" \nng-disabled=\"$ctrl.form.person.lockEmail\" required><div ng-messages=\"linksForm.email.$error\" \nng-show=\"linksForm.email.$touched\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Email is required.\n</span></div><div ng-message=\"email\"><span>Invalid email address.</span></div></div></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Mobile No.</label><input type=\"text\" name=\"mobile\" \nng-model=\"$ctrl.form.person.mobile\" ng-maxlength=\"16\" ng-minlength=\"10\" \nng-pattern=\"/^\\(?(?:\\+?61|0|#)(?:[4-6])\\)?(?: ?-?[0-9]){8}$/\" required><div ng-messages=\"linksForm.mobile.$error\" \nng-show=\"linksForm.mobile.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Mobile No. is required.</span></div>\n<div ng-message=\"pattern\"><span>Invalid characters.</span></div><div ng-message=\"maxlength\"><span>Too many digits.\n</span></div><div ng-message=\"minlength\"><span>Not enough digits.</span></div></div></md-input-container></div></div>");
$templateCache.put("app/main/admin/people/name-form.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"\" \nclass=\"flex md-default-theme\"><label for=\"select_55\" class=\"md-placeholder\">Title</label><md-select \nng-model=\"$ctrl.form.person.title\" class=\"ng-pristine ng-valid md-default-theme ng-empty ng-touched\" tabindex=\"0\" \naria-disabled=\"false\" role=\"listbox\" aria-expanded=\"false\" aria-multiselectable=\"false\" id=\"select_55\" \naria-owns=\"select_container_56\" aria-invalid=\"false\" aria-label=\"Title\"><md-option ng-value=\"title\" \nng-repeat=\"title in $ctrl.context.titles\">{{ title }}</md-option></md-select></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><label>Lastname</label><input type=\"text\" name=\"lastname\" \nng-model=\"$ctrl.form.person.lastname\" ng-maxlength=\"50\" required><div ng-messages=\"nameForm.lastname.$error\" \nng-show=\"nameForm.lastname.$touched\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nDisplay Name field is required.</span></div><div ng-message=\"maxlength\"><span>Too many characters.</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Firstname</label>\n<input type=\"text\" name=\"firstname\" ng-model=\"$ctrl.form.person.firstname\" ng-maxlength=\"50\" required><div \nng-messages=\"nameForm.firstname.$error\" ng-show=\"nameForm.firstname.$touched\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Firstname is required.</span></div><div ng-message=\"maxlength\"><span>Too many characters.\n</span></div></div></md-input-container><md-input-container flex><label>Middle Names</label><input type=\"text\" \nname=\"middlenames\" ng-model=\"$ctrl.form.person.middleNames\" ng-maxlength=\"100\"><div \nng-messages=\"nameForm.middlenames.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"maxlength\"><span>\nToo many characters.</span></div></div></md-input-container></div></div>");
$templateCache.put("app/main/admin/people/people.html","<div class=\"page-layout carded left-sidenav off-white-bg\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><div class=\"header\"><p></p></div><md-content class=\"content\" flex ms-scroll><div \nclass=\"demo-sidenav\"><md-list><md-subheader class=\"md-no-sticky\">Search Results</md-subheader><div \nng-repeat=\"person in $ctrl.results\" ui-sref=\"app.admin.person.view({id: person.id})\"><md-list-item><p><b>\n{{person.displayName}}</b><br>ID:{{person.staffId}} Reg. No.:{{person.registeredId}}</p></md-list-item><md-divider>\n</md-divider></div></md-list></div></md-content></md-sidenav><div class=\"center\" layout=\"column\" flex><div \nclass=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">People</span></div><md-button \nclass=\"add-contact-button md-fab secondary-bg\" ng-click=\"$ctrl.addClinician()\" aria-label=\"Add Person\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"content-card\" layout=\"column\" flex><md-content>\n<md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" class=\"ng-isolate-scope md-dynamic-height md-pink-theme\"><md-tab \nlabel=\"Clinicians\" class=\"ng-scope ng-isolate-scope content\"><md-content class=\"md-padding ng-scope md-pink-theme\"><h1 \nclass=\"md-display-2\" style=\"display:inline-block\">Clinician Search</h1><br><br><div layout=\"row\" \nlayout-align=\"space-between center\" layout-gt-xs=\"row\" flex-gt-md=\"40\" flex-md=\"60\" flex-sm=\"80\" flex-xs=\"100\" \nstyle=\"margin: auto\"><div layout=\"column\" layout-align=\"start\" flex><md-input-container style=\"width: 100%\"><input \ntype=\"text\" name=\"lastname\" ng-model=\"$ctrl.form.person.lastname\" placeholder=\"Search by Lastname\" required><div \nng-messages=\"clinicianForm.lastname.$error\" ng-show=\"clinicianForm.lastname.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Lastname field is required.</span></div></div></md-input-container><md-input-container \nstyle=\"width: 100%\"><input type=\"text\" name=\"firstname\" ng-model=\"$ctrl.form.person.firstname\" \nplaceholder=\"Firstname (Optional)\"><div ng-messages=\"clinicianForm.firstname.$error\" \nng-show=\"clinicianForm.firstname.$touched\" role=\"alert\"></div></md-input-container></div><md-button \nclass=\"md-raised mb-30\" layout=\"column\" layout-align=\"start\" style=\"padding: 0 16px 0 16px;min-width: 48px\" \nng-click=\"$ctrl.search(\'clinician\',\'name\')\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24 md-font icon-magnify material-icons md-default-theme\"></md-icon><span hide-xs>Search&nbsp;</span>\n</md-button></div><br><br><div layout=\"row\" layout-align=\"space-between center\" layout-gt-xs=\"row\" flex-gt-md=\"40\" \nflex-md=\"60\" flex-sm=\"80\" flex-xs=\"100\" style=\"margin: auto\"><div layout=\"column\" layout-align=\"start\" flex>\n<md-input-container style=\"width: 100%\"><input type=\"text\" name=\"staffId\" ng-model=\"$ctrl.form.person.staffId\" \nplaceholder=\"Search by ID\" required><div ng-messages=\"clinicianForm.staffId.$error\" \nng-show=\"clinicianForm.staffId.$touched\" role=\"alert\"><div ng-message=\"required\"><span>ABN field is required.</span>\n</div></div></md-input-container></div><md-button class=\"md-raised mb-30\" layout=\"column\" layout-align=\"start\" \nstyle=\"padding: 0 16px 0 16px;min-width: 48px\" ng-click=\"$ctrl.search(\'clinician\',\'staffId\')\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s24 md-font icon-magnify material-icons md-default-theme\"></md-icon><span \nhide-xs>Search&nbsp;</span></md-button></div><br><div layout=\"row\" layout-align=\"space-between center\" \nlayout-gt-xs=\"row\" flex-gt-md=\"40\" flex-md=\"60\" flex-sm=\"80\" flex-xs=\"100\" style=\"margin: auto\"><div layout=\"column\" \nlayout-align=\"start\" flex><md-input-container style=\"width: 100%\"><input type=\"text\" name=\"registeredId\" \nng-model=\"$ctrl.form.person.registeredId\" placeholder=\"Search by Registration No.\" required><div \nng-messages=\"clinicianForm.registeredId.$error\" ng-show=\"clinicianForm.registeredId.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Registered No. is required.</span></div></div></md-input-container></div><md-button \nclass=\"md-raised mb-30\" layout=\"column\" layout-align=\"start\" style=\"padding: 0 16px 0 16px;min-width: 48px\" \nng-click=\"$ctrl.search(\'clinician\',\'registeredId\')\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24 md-font icon-magnify material-icons md-default-theme\"></md-icon><span hide-xs>Search&nbsp;</span>\n</md-button></div></md-content></md-tab><md-tab label=\"Support\" class=\"ng-scope ng-isolate-scope\"><md-content \nclass=\"md-padding ng-scope md-pink-theme content\"><h1 class=\"md-display-2\">Enterprise Support Staff</h1><p>\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla venenatis ante augue. Phasellus volutpat neque ac dui mattis vulputate. Etiam consequat aliquam cursus. In sodales pretium ultrices. Maecenas lectus est, sollicitudin consectetur felis nec, feugiat ultricies mi. Aliquam erat volutpat. Nam placerat, tortor in ultrices porttitor, orci enim rutrum enim, vel tempor sapien arcu a tellus. Vivamus convallis sodales ante varius gravida. Curabitur a purus vel augue ultrices ultricies id a nisl. Nullam malesuada consequat diam, a facilisis tortor volutpat et. Sed urna dolor, aliquet vitae posuere vulputate, euismod ac lorem. Sed felis risus, pulvinar at interdum quis, vehicula sed odio. Phasellus in enim venenatis, iaculis tortor eu, bibendum ante. Donec ac tellus dictum neque volutpat blandit. Praesent efficitur faucibus risus, ac auctor purus porttitor vitae. Phasellus ornare dui nec orci posuere, nec luctus mauris semper.\n</p><p>\nMorbi viverra, ante vel aliquet tincidunt, leo dolor pharetra quam, at semper massa orci nec magna. Donec posuere nec sapien sed laoreet. Etiam cursus nunc in condimentum facilisis. Etiam in tempor tortor. Vivamus faucibus egestas enim, at convallis diam pulvinar vel. Cras ac orci eget nisi maximus cursus. Nunc urna libero, viverra sit amet nisl at, hendrerit tempor turpis. Maecenas facilisis convallis mi vel tempor. Nullam vitae nunc leo. Cras sed nisl consectetur, rhoncus sapien sit amet, tempus sapien.\n</p><p>\nInteger turpis erat, porttitor vitae mi faucibus, laoreet interdum tellus. Curabitur posuere molestie dictum. Morbi eget congue risus, quis rhoncus quam. Suspendisse vitae hendrerit erat, at posuere mi. Cras eu fermentum nunc. Sed id ante eu orci commodo volutpat non ac est. Praesent ligula diam, congue eu enim scelerisque, finibus commodo lectus.\n</p></md-content></md-tab><md-tab label=\"Other Recipients\" class=\"ng-scope ng-isolate-scope\"><md-content \nclass=\"md-padding ng-scope md-pink-theme content\"><h1 class=\"md-display-2\">Other Recipients</h1><p>\nInteger turpis erat, porttitor vitae mi faucibus, laoreet interdum tellus. Curabitur posuere molestie dictum. Morbi eget congue risus, quis rhoncus quam. Suspendisse vitae hendrerit erat, at posuere mi. Cras eu fermentum nunc. Sed id ante eu orci commodo volutpat non ac est. Praesent ligula diam, congue eu enim scelerisque, finibus commodo lectus.\n</p></md-content></md-tab><md-tab label=\"HCI Staff\" class=\"ng-scope ng-isolate-scope\"><md-content \nclass=\"md-padding ng-scope md-pink-theme content\"><h1 class=\"md-display-2\">HCI Staff</h1><p>\nInteger turpis erat, porttitor vitae mi faucibus, laoreet interdum tellus. Curabitur posuere molestie dictum. Morbi eget congue risus, quis rhoncus quam. Suspendisse vitae hendrerit erat, at posuere mi. Cras eu fermentum nunc. Sed id ante eu orci commodo volutpat non ac est. Praesent ligula diam, congue eu enim scelerisque, finibus commodo lectus.\n</p></md-content></md-tab></md-tabs><div ng-if=\"$ctrl.context.currentPerson\"><h3>\nScoped to: {{$ctrl.context.currentPerson.title}} {{$ctrl.context.currentPerson.lastname}}, {{$ctrl.context.currentPerson.firstname}}\n</h3></div><div class=\"main\" ms-scroll><md-list class=\"contacts-list\"><md-list-item class=\"contact-item md-white-bg\" \nmd-ink-ripple ng-repeat=\"contact in $ctrl.clinicianResults\" ng-click=\"$ctrl.openContactDialog($event, contact)\" \nng-class=\"{\'selected\': $ctrl.isSelected(contact)}\"><md-checkbox \nng-checked=\"$ctrl.exists(contact, $ctrl.selectedContacts)\" ng-click=\"$ctrl.toggleSelectContact(contact, $event)\" \naria-label=\"{{$ctrl.exists(contact, $ctrl.selectedContacts) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><img \nclass=\"md-avatar\" ng-if=\"contact.avatar\" alt=\"{{contact.name}}\" ng-src=\"{{contact.avatar}}\"><p \nclass=\"text-truncate font-weight-600\">{{contact.title}} {{contact.lastname}}, {{contact.firstname}}</p><p \nclass=\"email text-truncate hide show-gt-sm\">{{contact.email}}</p><p class=\"phone text-truncate hide show-gt-md\">\n{{contact.phone}}</p><p class=\"job-title text-truncate hide show-gt-lg\">{{contact.jobTitle}}</p><p \nclass=\"company text-truncate hide show-gt-lg\">{{contact.company}}</p><div class=\"actions\" layout=\"row\" \nlayout-align=\"start center\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"CONTACTS.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"$ctrl.connectClinician(contact, ev)\">Connect Clinician</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"$ctrl.scopeToClinician(contact, ev)\">Scope To Clinician</md-button></md-menu-item><md-menu-item><md-button \nui-sref=\"app.admin.people.view({id: contact.id})\">View Clinician</md-button></md-menu-item></md-menu-content></md-menu>\n</div></md-list-item></md-list><md-list-item class=\"no-results md-white-bg\" ng-show=\"filteredContacts.length === 0\"><p \ntranslate=\"CONTACTS.NO_RESULTS\">No results..</p></md-list-item></div></md-content></div></div></div>");
$templateCache.put("app/main/admin/people/person-add.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page off-white-bg\" layout=\"column\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">People</span></div><div class=\"title\">Add a Person</div></div></div><div \nclass=\"content\" layout=\"column\"><div class=\"md-title\">Create and Add a People</div><div class=\"pb-16\">\nUse this form to add a new organisation to Clinivid such as an enterprise. You must select or enter a user who will have full ownership of the organisation. If you enter a new user, the system will issue an invitation to that user via email to complete their account registration. The organisation will not be active until the owning user account is fully registered.\n</div><form name=\"stepper\" ms-stepper ng-submit=\"$ctrl.submitStepper()\" ng-model=\"$ctrl.person\" novalidate>\n<ms-stepper-step ng-form=\"orgForm\" step=\"1\" step-title=\"\'Owner\'\"><div \nng-include=\"\'app/main/admin/people/person-form.html\'\"></div></ms-stepper-step><ms-stepper-step ng-form=\"orgForm\" \nstep=\"2\" step-title=\"\'Organisation\'\"><div ng-include=\"\'app/main/admin/people/person-form.html\'\"></div>\n</ms-stepper-step></form></div></div>");
$templateCache.put("app/main/admin/people/person-edit.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page off-white-bg\" layout=\"column\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">Organisation</span></div><div class=\"title\">Edit Organisation</div></div></div><div \nclass=\"content\" layout=\"column\"><div class=\"md-title mt-32\">Edit Person Details</div><div class=\"pb-16\">\nYou may edit the details of a person with this form. Not all details can be changed. Please contact a System Admin if you have special circumstances.\n</div><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\"><form name=\"basicForm\" \nclass=\"md-inline-form\" ng-submit=\"$ctrl.submitEdit()\" novalidate><div class=\"form-title\">Person Details</div><br><div \nng-include=\"\'app/main/admin/people/person-form.html\'\"></div><div layout=\"row\" layout-align=\"center\"><md-button \nclass=\"md-raised\" aria-label=\"Cancel\">Cancel</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" \naria-label=\"Submit\" ng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button></div></form></div></div>\n</div></div>");
$templateCache.put("app/main/admin/people/person-form.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"displayName\" ng-model=\"$ctrl.org.displayName\" placeholder=\"Display Name\" \nrequired><div ng-messages=\"orgForm.displayName.$error\" ng-show=\"orgForm.displayName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Display Name field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"formalName\" ng-model=\"$ctrl.org.formalName\" \nplaceholder=\"Formal Name\" required><div ng-messages=\"orgForm.formalName.$error\" ng-show=\"orgForm.formalName.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Formal Name field is required.</span></div></div></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"description\" ng-model=\"$ctrl.org.description\" placeholder=\"Description\"></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"registeredId\" ng-model=\"$ctrl.org.registeredId\" placeholder=\"ABN\" \nrequired><div ng-messages=\"orgForm.registeredId.$error\" ng-show=\"orgForm.registeredId.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>ABN field is required.</span></div></div></md-input-container></div></div>");
$templateCache.put("app/main/admin/people/person-view.html","<div class=\"page-layout carded fullwidth single-scroll off-white-bg\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" flex><div class=\"header\"><span class=\"h2 white-fg\">View Practitioner</span></div><div \nclass=\"content-card\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span>\n{{$ctrl.form.person.firstname}} {{$ctrl.form.person.lastname}}</span><span style=\"width:100%\"></span><md-button \nui-sref=\"app.admin.people.edit({id: $ctrl.form.person.id})\" style=\"float:right; white-space: nowrap\">Edit</md-button>\n</div><md-content class=\"content\" ms-scroll><div class=\"demo-content\"><h1>\n{{$ctrl.form.person.firstname}} {{$ctrl.form.person.lastname}}</h1><h4 class=\"secondary-text\">\nAHPRA Number: {{$ctrl.form.person.registrationId}}</h4><br><br></div><div class=\"md-inline-form\"><form \nname=\"basicForm\" class=\"md-inline-form\" ng-submit=\"$ctrl.confirmAHPRA()\" novalidate><h2>Confirm AHPRA Number</h2><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"35\"><input type=\"text\" \nname=\"newAHPRANumber\" ng-model=\"$ctrl.form.confirmAHPRA.newAHPRA\" placeholder=\"Change AHPRA Number\">\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"30\"><md-checkbox name=\"isValidAHPRA\" \nng-model=\"$ctrl.form.confirmAHPRA.isValid\" aria-label=\"Is Valid AHPRA\">Is Valid AHPRA</md-checkbox>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"35\"><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\">Confirm AHPRA</md-button></md-input-container></div></form></div>\n</md-content></div></div></div>");
$templateCache.put("app/main/admin/people/practitioner-form.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><div class=\"form-title\">Tell us who you are\n</div><md-input-container class=\"md-block\"><label>Lastname</label><input type=\"text\" name=\"lastname\" \nng-model=\"$ctrl.form.person.lastname\" md-maxlength=\"50\"><div ng-messages=\"wizardStep2.lastname.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Lastname is required.</span></div><div ng-message=\"md-maxlength\">\n<span>Lastname can\'t be longer than 50 characters.</span></div></div></md-input-container><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label>Firstname</label><input type=\"text\" name=\"firstname\" \nng-model=\"$ctrl.form.person.firstname\" md-maxlength=\"50\" required><div ng-messages=\"wizardStep2.firstname.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Firstname is required.</span></div><div \nng-message=\"md-maxlength\"><span>Firstname can\'t be longer than 50 characters.</span></div></div></md-input-container>\n<md-input-container flex><label>Middle Names</label><input type=\"text\" name=\"middlenames\" \nng-model=\"$ctrl.form.person.middlenames\" md-maxlength=\"100\"><div ng-messages=\"wizardStep2.middlenames.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"md-maxlength\"><span>Middle names can\'t be longer than 100 characters.\n</span></div></div></md-input-container></div><md-input-container class=\"md-block\"><label>Mobile Number</label><input \ntype=\"text\" name=\"mobile\" ng-model=\"$ctrl.form.person.mobile\" md-maxlength=\"20\" required><div \nng-messages=\"wizardStep2.mobile.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nAddress field is required.</span></div><div ng-message=\"md-maxlength\"><span>\nMobile number can\'t be longer than 20 characters.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"displayName\" ng-model=\"$ctrl.org.displayName\" \nplaceholder=\"Display Name\" required><div ng-messages=\"orgForm.displayName.$error\" \nng-show=\"orgForm.displayName.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Display Name field is required.\n</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"formalName\" ng-model=\"$ctrl.org.formalName\" placeholder=\"Formal Name\" required><div \nng-messages=\"orgForm.formalName.$error\" ng-show=\"orgForm.formalName.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>Formal Name field is required.</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"description\" \nng-model=\"$ctrl.org.description\" placeholder=\"Description\"></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"registeredId\" ng-model=\"$ctrl.org.registeredId\" placeholder=\"ABN\" required>\n<div ng-messages=\"orgForm.registeredId.$error\" ng-show=\"orgForm.registeredId.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>ABN field is required.</span></div></div></md-input-container></div></div>");
$templateCache.put("app/main/admin/people/profession-form.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><label>Staff ID</label><input type=\"text\" name=\"staffId\" ng-model=\"$ctrl.form.person.staffId\" required>\n<div ng-messages=\"professionForm.staffId.$error\" ng-show=\"professionForm.staffId.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>A unique identifier is required.</span></div></div></md-input-container><md-input-container\n flex=\"100\" flex-gt-xs=\"50\" ng-if=\"$ctrl.form.person.isPractitioner\"><label>Profession</label><input type=\"text\" \nname=\"profession\" ng-model=\"$ctrl.form.person.profession\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container style=\"text-align: center\" flex=\"100\" flex-gt-xs=\"50\"><md-checkbox \nstyle=\"margin-top: 5px\" ng-model=\"$ctrl.form.person.isPractitioner\" \nng-disabled=\"$ctrl.form.person.isPractitionerLocked\" aria-label=\"Is Clinician\">Registered Practitioner</md-checkbox>\n<div ng-messages=\"professionForm.role.$error\" ng-show=\"professionForm.role.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Role is required.</span></div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\" ng-if=\"$ctrl.form.person.isPractitioner\"><label>Registration No.</label><input type=\"text\" \nname=\"registrationId\" ng-model=\"$ctrl.form.person.registrationId\" ng-disabled=\"$ctrl.form.person.isPractitionerLocked\">\n</md-input-container></div></div>");
$templateCache.put("app/main/clinician/cases/cases.html","<div id=\"case\" class=\"page-layout carded left-sidenav off-white-bg\" layout=\"row\"><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"></div></div><div class=\"content-wrapper\" layout=\"row\" flex \nng-show=\"$ctrl.casePollStatus && $ctrl.casePollStatus.hasCases && $ctrl.casePollStatus.firstPoll\"><div layout=\"column\" \nflex=\"100\" flex-gt-sm=\"40\" class=\"content case-list-pane\" ng-class=\"{\'hide-xs\': $ctrl.selectedCase}\" \nng-include=\"\'app/main/clinician/cases/views/list/list-view2.html\'\" ng-click=\"$ctrl.closeAllSidenavs()\"></div><div \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"60\" hide show-gt-sm class=\"content case-read-pane\" \nng-class=\"{show: $ctrl.selectedCase}\" ng-include=\"\'app/main/clinician/cases/views/read/read-view2.html\'\" \nstyle=\"background-color: #ffffff;position: relative\"></div></div><div layout=\"column\" layout-align=\"center center\" \nng-show=\"$ctrl.casePollStatus && !$ctrl.casePollStatus.hasCases && $ctrl.casePollStatus.firstPoll\"><span><h1>\nGreat, let\'s get started!</h1></span><br><span>Start your first chat by selecting the New Chat button<br></span><br>\n<br><br><md-button layout=\"row\" layout-align=\"center center\" class=\"createcasediv\" ui-sref=\"app.user.casecreation\" \nstyle=\"background-color: #f5f5f5; border: 1px solid #eaeaea\"><md-icon md-font-icon=\"icon-folder-plus-center\" \nclass=\"icon-adjust\"></md-icon><md-input-container md-no-float class=\"md-accent\" style=\"padding-bottom: 8px\"><span \nclass=\"newcaselabel\">New Chat</span></md-input-container></md-button><br><br><span><h1>This is your Inbox<br></h1>\n</span><span>It will list your communication with other clinicians </span><br><span>\nCommunication is organized around chats which will be accesible for 30 days after last activity</span><br></div><div \nlayout=\"column\" layout-align=\"center center\" ng-show=\"!$ctrl.casePollStatus.firstPoll\"><div layout=\"row\" \nlayout-align=\"center center\"><div class=\"holder\"><div class=\"preloader\"><div></div><div></div><div></div><div></div>\n<div></div><div></div><div></div><div></div><div></div><div></div></div></div></div><div layout=\"row\" \nlayout-align=\"center center\">One moment please, we are loading your cases</div></div></div><div id=\"overlay\" \nstyle=\"position:fixed;display: none;width: 100%;height: 100%;top: 0;left: 0;right: 0;bottom: 0;background-color: rgba(0, 0, 0, 0.8);z-index: 100\" \nng-click=\"$ctrl.closeCaseGallery()\"></div></div>");
$templateCache.put("app/main/clinician/people/manageOrganisation.html","<div id=\"forms\" class=\"page-layout simple tabbed off-white-bg\"><div class=\"content\" flex><div layout=\"row\" \nlayout-align=\"space-around\" class=\"whiteframedemoDirectiveInterpolation\" style=\"padding:24px\" \nng-show=\"$ctrl.whichPage === 0\"><div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" \nlayout-align=\"center center\" style=\"background: #fff;border-radius: 4px;position:relative;min-height:400px\"><div \nlayout=\"row\" style=\"margin-top:-10px\"><div layout=\"column\" layout-align=\"center center\" \nstyle=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px\">Search for an Organisation</div></div><div \nlayout=\"column\" style=\"width: 300px;max-width: 300px;margin-top: 30px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nSearch by name</h1><div layout=\"row\"><md-input-container class=\"md-block\" md-no-float \nstyle=\"margin-top:0;margin-bottom: 0;width:250px\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.name\" placeholder=\"Organisation Name\"></md-input-container><span \nstyle=\"padding-left: 5px;padding-top: 5px\"><span><img src=\"/assets/images/searchbutton.png\" \nstyle=\"cursor:pointer;width:30px;height:30px\" ng-click=\"$ctrl.searchByName()\"></span></span></div></div><div \nlayout=\"column\" style=\"width: 300px;max-width: 300px;margin-top: 37px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nSearch by ABN</h1><div layout=\"row\"><md-input-container class=\"md-block\" md-no-float \nstyle=\"margin-top:0;margin-bottom: 0;width:250px\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.abn\" placeholder=\"ABN\"></md-input-container><span style=\"padding-left: 5px;padding-top: 5px\"><span><img\n src=\"/assets/images/searchbutton.png\" style=\"cursor:pointer;width:30px;height:30px\" ng-click=\"$ctrl.searchByABN()\">\n</span></span></div></div><div layout=\"row\" style=\"margin-top:25px\" ng-if=\"$ctrl.noresults\"><img \nsrc=\"/assets/images/icons8-info-64.png\" \nstyle=\"width:30px;height:30px;margin-right:13px;cursor:pointer;margin-top:30px\"><div layout=\"column\" \nlayout-align=\"center center\" style=\"font-size: 12px;font-family: Roboto;margin-top:30px\">No results found.</div></div>\n<div layout=\"column\" layout-align=\"center center\" ng-show=\"$ctrl.searchResults && $ctrl.searchResults.length > 0\"><div \nstyle=\"margin: 10px;margin-top:30px\"><div class=\"tbl-header\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><thead>\n<tr><th style=\"text-transform: none;width: 20%\">Display Name</th><th style=\"text-transform: none;width: 20%\">\nFormal Name</th><th style=\"text-transform: none;width: 20%\"></th></tr></thead></table></div><div class=\"tbl-content\">\n<table cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tbody><tr \nng-repeat=\"orgContact in $ctrl.searchResults | filter: $ctrl.orgContactSearchTerm track by $index\"><td \nstyle=\"width: 20%;word-wrap:break-word\">{{orgContact.displayName}}</td><td style=\"width: 20%\">{{orgContact.formalName}}\n</td><td style=\"text-align: end;width: 20%\"><md-button type=\"submit\" ng-click=\"$ctrl.editOrganisation(orgContact.id)\" \nclass=\"md-raised md-accent submit-button\" style=\"border-radius:5px;font-size: 12px;;text-transform: none !important\">\nVIEW</md-button></td></tr></tbody></table></div></div></div></div></div><div layout=\"row\" layout-align=\"space-around\" \nclass=\"whiteframedemoDirectiveInterpolation\" style=\"padding:24px\" ng-show=\"$ctrl.whichPage === 1\"><div class=\"padded\" \nmd-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.cancelOrgDisplay()\"></md-icon></div></div><div layout=\"column\" \nstyle=\"position: absolute;top: 0;left:0\"><div layout=\"row\" layout-align=\"center center\"><md-menu-bar><md-menu \nmd-position-mode=\"left bottom\"><md-button aria-label=\"Open phone interactions menu\" class=\"md-icon-button\" \nng-click=\"$ctrl.openOrgMenu($mdMenu, $event)\"><img src=\"/assets/images/menu-24.png\"></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button ng-click=\"$ctrl.openAddUserPage()\">Add user</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"$ctrl.openInviteUserPage()\">Invite user</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"$ctrl.openInviteStatusPage()\">Invite status</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"$ctrl.openMemberListPage()\">Member list</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"$ctrl.openCasesPage()\">Chats</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"$ctrl.openAddContactPage()\">Add contact</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"$ctrl.openAllContactsPage()\">All contacts</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar></div></div><div layout=\"row\" style=\"margin-top:-10px\"><div layout=\"column\" layout-align=\"center center\" \nstyle=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px\">Organisation info</div></div><div layout=\"column\" \nstyle=\"width: 300px;max-width: 300px;margin-top: 25px\" ng-show=\"$ctrl.orgEditMode\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nDisplay name<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-disabled=\"$ctrl.orgEditMode\" ng-model=\"$ctrl.editOrgDisplayName\" placeholder=\"Display name\"></md-input-container>\n</div><div layout=\"column\" style=\"width: 300px;max-width: 300px;margin-top: 20px\" ng-show=\"$ctrl.orgEditMode\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nFormal name<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-disabled=\"$ctrl.orgEditMode\" ng-model=\"$ctrl.editOrgFormalName\" placeholder=\"Formal name\"></md-input-container>\n</div><div layout=\"column\" style=\"width: 300px;max-width: 300px;margin-top: 25px\" ng-show=\"!$ctrl.orgEditMode\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nDisplay name<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-disabled=\"$ctrl.orgEditMode\" ng-model=\"$ctrl.editOrgDisplayName\" placeholder=\"Display name\"></md-input-container>\n</div><div layout=\"column\" style=\"width: 300px;max-width: 300px;margin-top: 20px\" ng-show=\"!$ctrl.orgEditMode\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nFormal name<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-disabled=\"$ctrl.orgEditMode\" ng-model=\"$ctrl.editOrgFormalName\" placeholder=\"Formal name\"></md-input-container>\n</div><div layout=\"column\" style=\"width: 300px;max-width: 300px;margin-top: 20px\" ng-show=\"!$ctrl.orgEditMode\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nDescription</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.editOrgDescription\" placeholder=\"Formal name\"></md-input-container></div><div layout=\"column\" \nstyle=\"width: 300px;max-width: 300px;margin-top: 20px\" ng-show=\"!$ctrl.orgEditMode\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nABN</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.editOrgABN\" placeholder=\"Formal name\"></md-input-container></div><div layout=\"column\" \nstyle=\"width: 300px;max-width: 300px;margin-top: 20px\" ng-show=\"!$ctrl.orgEditMode\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nState<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container class=\"md-block\" \nmd-no-float style=\"margin-top:0;margin-bottom: 0\"><md-select type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.editOrgState\" placeholder=\"Select State\"><md-option value=\"NSW\">New South Wales (NSW)</md-option>\n<md-option value=\"VIC\">Victoria (VIC)</md-option><md-option value=\"QLD\">Queensland (QLD)</md-option><md-option \nvalue=\"SA\">South Australia (SA)</md-option><md-option value=\"WA\">Western Australia (WA)</md-option><md-option \nvalue=\"TAS\">Tasmania (TAS)</md-option><md-option value=\"NT\">Northern Territory (NT)</md-option><md-option value=\"ACT\">\nAustralian Capital Territory (ACT)</md-option></md-select></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\" style=\"margin-top: 30px;margin-bottom:20px\"><md-button type=\"submit\" \nng-click=\"$ctrl.editOrg()\" class=\"md-raised md-accent submit-button\" \nstyle=\"border-radius:5px;width:115px;height:40px;font-size: 16px;;text-transform: none !important\">\n{{$ctrl.orgEditMode ? \'Edit\' : \'Save\'}}</md-button></div></div></div><div layout=\"row\" layout-align=\"space-around\" \nclass=\"whiteframedemoDirectiveInterpolation\" style=\"padding:24px\" ng-show=\"$ctrl.whichPage === 2\"><div class=\"padded\" \nmd-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.back2OrgInfo()\"></md-icon></div></div><div layout=\"row\" \nstyle=\"margin-top:60px\"><div layout=\"column\" layout-align=\"center center\" \nstyle=\"font-family: Roboto;margin-top: 60px;position: absolute;top: 0;right: 0;left: 0;font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333\">\nSelected Organisation</div></div><div layout=\"row\" style=\"margin-top:-10px\"><div layout=\"column\" \nlayout-align=\"center center\" \nstyle=\"font-family: Roboto;margin-top: 78px;position: absolute;top: 0;right: 0;left: 0;font-size: 12px;font-weight: bold;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #92298C;text-transform: uppercase\">\n{{$ctrl.selectedOrganisation.displayName}}</div></div><div layout=\"row\" style=\"margin-top:25px\"><div layout=\"column\" \nlayout-align=\"center center\" style=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px\">Search Users</div></div><div\n layout=\"column\" style=\"width: 300px;max-width: 300px;margin-top: 30px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nSearch by First Name</h1><div layout=\"row\"><md-input-container class=\"md-block\" md-no-float \nstyle=\"margin-top:0;margin-bottom: 0;width:250px\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.addUser.firstName\" placeholder=\"First Name\"></md-input-container><span \nstyle=\"padding-left: 5px;padding-top: 5px\"><span><img src=\"/assets/images/searchbutton.png\" \nstyle=\"cursor:pointer;width:30px;height:30px\" ng-click=\"$ctrl.searchAddUser()\"></span></span></div></div><div \nlayout=\"column\" style=\"width: 300px;max-width: 300px;margin-top: 37px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nSearch by Last Name</h1><div layout=\"row\"><md-input-container class=\"md-block\" md-no-float \nstyle=\"margin-top:0;margin-bottom: 0;width:250px\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.addUser.lastName\" placeholder=\"Last Name\"></md-input-container><span \nstyle=\"padding-left: 5px;padding-top: 5px\"><span><img src=\"/assets/images/searchbutton.png\" \nstyle=\"cursor:pointer;width:30px;height:30px\" ng-click=\"$ctrl.searchAddUser()\"></span></span></div></div><div \nlayout=\"column\" layout-align=\"center center\" \nng-show=\"$ctrl.addUser.searchResults && $ctrl.addUser.searchResults.length > 0\"><div \nstyle=\"margin: 10px;margin-top:30px\"><div class=\"tbl-header\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><thead>\n<tr><th style=\"text-transform: none\">Title</th><th style=\"text-transform: none;width: 20%\">First Name</th><th \nstyle=\"text-transform: none;width: 20%\">Middle Name</th><th style=\"text-transform: none;width: 20%\">Last Name</th><th \nstyle=\"text-transform: none;width: 20%\"></th></tr></thead></table></div><div class=\"tbl-content\"><table \ncellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tbody><tr ng-repeat=\"orgUser in $ctrl.addUser.searchResults\"><td>\n{{orgUser.title}}</td><td style=\"width: 20%;word-wrap:break-word\">{{orgUser.firstname}}</td><td style=\"width: 20%\">\n{{orgUser.middleNames}}</td><td style=\"width: 20%\">{{orgUser.lastname}}</td><td style=\"text-align: end;width: 20%\">\n<md-button type=\"submit\" ng-click=\"$ctrl.viewUser(orgUser)\" class=\"md-raised md-accent submit-button\" \nstyle=\"border-radius:5px;font-size: 12px;;text-transform: none !important\">VIEW</md-button></td></tr></tbody></table>\n</div></div></div><div layout=\"row\" style=\"margin-top:25px;margin-bottom:30px\" \nng-if=\"$ctrl.addUser.searchResults.length === 0 && $ctrl.isSearchUserOn\"><img src=\"/assets/images/icons8-info-64.png\" \nstyle=\"width:30px;height:30px;margin-right:13px;cursor:pointer;margin-top:30px\"><div layout=\"column\" \nlayout-align=\"center center\" style=\"font-size: 12px;font-family: Roboto;margin-top:30px\">No users found.</div></div>\n</div></div><div layout=\"row\" layout-align=\"space-around\" class=\"whiteframedemoDirectiveInterpolation\" \nstyle=\"padding:24px\" ng-show=\"$ctrl.whichPage === 3\"><div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" \nlayout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.back2OrgInfo()\"></md-icon></div></div><div layout=\"row\" \nstyle=\"margin-top:60px\"><div layout=\"column\" layout-align=\"center center\" \nstyle=\"font-family: Roboto;margin-top: 60px;position: absolute;top: 0;right: 0;left: 0;font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333\">\nSelected Organisation</div></div><div layout=\"row\" style=\"margin-top:-10px\"><div layout=\"column\" \nlayout-align=\"center center\" \nstyle=\"font-family: Roboto;margin-top: 78px;position: absolute;top: 0;right: 0;left: 0;font-size: 12px;font-weight: bold;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #92298C;text-transform: uppercase\">\n{{$ctrl.selectedOrganisation.displayName}}</div></div><div layout=\"column\" style=\"margin-top: 70px\"><div layout=\"row\" \nstyle=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px;margin:auto;text-transform: uppercase\">Invite Member</div>\n<div layout=\"row\" \nstyle=\"font-size: 12px;font-family: Roboto;font-style: italic;text-align: center;padding-left: 15px;padding-right: 15px\">\nUse this form to add a non existing clinivid user to your organisation. If you enter a new user, the system will issue an invitation to that user via email to complete their account registration. The user\'s account will not be active until they complete the instructions in the invitation email\n</div><div layout=\"row\" style=\"height: 30px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto;margin-top: 50px\"><h1\n \nstyle=\"font-size: 11px;font-weight: bold;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;margin-top: -7px;margin-left: 43px;padding-left: 10px;padding-right:10px;background: white\">\nNEW MEMBER DETAILS</h1></div><div layout=\"row\" style=\"width:90%;margin:auto\"><div layout=\"column\" \nstyle=\"width:100%;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nTitle</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0;margin-top: 7px\">\n<md-select type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.inviteNewUser.person.title\" placeholder=\"Title\"><md-option value=\"Dr\">Dr</md-option><md-option \nvalue=\"Mr\">Mr</md-option><md-option value=\"Mrs\">Mrs</md-option><md-option value=\"Ms\">Ms</md-option><md-option \nvalue=\"Miss\">Miss</md-option><md-option value=\"Master\">Master</md-option><md-option value=\"Prof\">Prof</md-option>\n<md-option value=\"A/Prof\">A/Prof</md-option><md-option value=\"Other\">Other</md-option></md-select></md-input-container>\n</div><div layout=\"column\" style=\"width:100%;margin-left:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nFirst name<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.inviteNewUser.person.firstName\" placeholder=\"First name\"></md-input-container></div></div><div \nlayout=\"row\" style=\"width:90%;margin:auto;margin-top: 20px\"><div layout=\"column\" style=\"width:100%;margin-right:10px\">\n<h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nMiddle name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0;margin-top: 7px\">\n<input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.inviteNewUser.person.middleNames\" placeholder=\"Middle name\"></md-input-container></div><div \nlayout=\"column\" style=\"width:100%;margin-left:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nLast name<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0;margin-top: 0px\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.inviteNewUser.person.lastName\" placeholder=\"Last name\"></md-input-container></div></div><div \nlayout=\"row\" style=\"margin:auto;width:90%\"><div layout=\"column\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;padding-bottom: 10px;padding-top:20px\">\nRoles</h1><div style=\"display: flex;flex: 1\"><aside><div class=\"container\"><div class=\"round\"><input \nid=\"roleOrgOwner2\" value=\"true\" type=\"checkbox\" ng-model=\"$ctrl.isOrgOwner\"><label for=\"roleOrgOwner2\" \nstyle=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8\"></label></div></div></aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nOrganisation owner</aside></div></div></div><div layout=\"row\" style=\"margin:auto;width:90%\"><div \nstyle=\"display: flex;flex: 1;margin-top: 20px\"><aside><div class=\"container\"><div class=\"round\"><input \nid=\"roleOfficeAdmin\" value=\"true\" type=\"checkbox\" ng-model=\"$ctrl.isOfficeAdmin\"><label for=\"roleOfficeAdmin\" \nstyle=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8\"></label></div></div></aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nOffice Admin</aside></div></div><div layout=\"row\" style=\"margin:auto;width:90%\"><div \nstyle=\"display: flex;flex: 1;margin-top: 20px\"><aside><div class=\"container\"><div class=\"round\"><input \nid=\"roleClinician\" value=\"true\" type=\"checkbox\" ng-model=\"$ctrl.isCreator\"><label for=\"roleClinician\" \nstyle=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8\"></label></div></div></aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nClinician</aside></div></div><md-radio-group ng-model=\"$ctrl.inviteNewUser.defaultRole\" \nstyle=\"margin: auto;width:90%;margin-top:26px\" ng-show=\"$ctrl.showDefaultRoles()\"><span \nstyle=\"font-size: 11px;font-weight: normal;letter-spacing: normal;color: #333333;padding-left: 2px\">Default role</span>\n<div style=\"display: flex;align-items: center;font-size: 14px;margin-top: 10px;width:90%;margin-bottom: 0px\">\n<md-radio-button value=\"OrgOwner\" class=\"md-primary\" style=\"margin-bottom: 0;font-size: 12px\" \nng-show=\"$ctrl.isOrgOwner\">Organisation Owner</md-radio-button><md-radio-button value=\"OfficeAdmin\" class=\"md-primary\" \nstyle=\"margin-bottom: 0;margin-left: 30px;font-size: 12px\" ng-show=\"$ctrl.isOfficeAdmin\">Office Admin</md-radio-button>\n<md-radio-button value=\"Creator\" class=\"md-primary\" style=\"margin-bottom: 0;margin-left: 30px;font-size: 12px\" \nng-show=\"$ctrl.isCreator\">Clinician</md-radio-button></div></md-radio-group><div layout=\"row\" \nstyle=\"height: 30px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto;margin-top: 46px\"><h1 \nstyle=\"font-size: 11px;font-weight: bold;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;width: 70px;margin-top: -7px;margin-left: 43px;padding-left: 10px;background: white\">\nCONTACT</h1></div><div layout=\"row\" style=\"margin:auto;width:90%\"><div layout=\"column\" \nstyle=\"width:50%;margin-left:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nEmail<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container class=\"md-block\" \nmd-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.inviteNewUser.person.email\" placeholder=\"Email\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"width:90%;margin:auto;margin-top:20px\"><div layout=\"column\" style=\"width:18%;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;margin-left: 10px\">\nCountry code<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><md-select \nclass=\"ng-pristine ng-valid md-default-theme ng-empty ng-touched\" tabindex=\"0\" aria-disabled=\"false\" role=\"listbox\" \naria-expanded=\"false\" aria-multiselectable=\"false\" placeholder=\"Country Code\" \nng-model=\"$ctrl.inviteNewUser.person.region\" aria-owns=\"select_container_56\" aria-invalid=\"false\" \naria-label=\"Select country code\"><md-option value=\"AU\">+61 AUS</md-option><md-option value=\"NZ\">+64 NZ</md-option>\n<md-option value=\"IN\">+91 IND</md-option></md-select></md-input-container></div><div layout=\"column\" \nstyle=\"width:28%;margin-left:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nMobile number<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0;padding-top:4px\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.inviteNewUser.person.mobile\" placeholder=\"Mobile number\"></md-input-container></div></div><div \nlayout=\"row\" style=\"height: 30px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto;margin-top: 50px\"><h1 \nstyle=\"font-size: 11px;font-weight: bold;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;width: 88px;margin-top: -7px;margin-left: 43px;padding-left: 10px;background: white\">\nPROFESSION</h1></div><div layout=\"row\" style=\"width:90%;margin:auto\"><div layout=\"column\" \nstyle=\"width:50%;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nStaff ID</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.inviteNewUser.person.staffId\" placeholder=\"Staff ID\"></md-input-container></div></div><md-radio-group \nng-model=\"$ctrl.inviteNewUser.person.isPractitioner\" style=\"margin: auto;width:90%;margin-top:26px\"><span \nstyle=\"font-size: 11px;font-weight: normal;letter-spacing: normal;color: #333333;padding-left: 2px\">\nRegistered Practitioner</span><div \nstyle=\"display: flex;align-items: center;font-size: 14px;margin-top: 10px;width:90%;margin-bottom: 0px\">\n<md-radio-button ng-value=\"true\" class=\"md-primary\" style=\"margin-bottom: 0;font-size: 12px\">Yes</md-radio-button>\n<md-radio-button ng-value=\"false\" class=\"md-primary\" style=\"margin-bottom: 0;margin-left: 30px;font-size: 12px\">No\n</md-radio-button></div></md-radio-group><div layout=\"row\" style=\"width:90%;margin:auto;margin-top:20px\"><div \nlayout=\"column\" style=\"width:50%;margin-right:10px\" ng-if=\"$ctrl.checkPractitioner()\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nProfession</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><md-select \ntype=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.inviteNewUser.person.profession\" placeholder=\"Profession\"><md-option \nvalue=\"Aboriginal and Torres Strait Islander Health Practitioner\">Aboriginal and Torres Strait Islander<br>\nHealth Practitioner</md-option><md-option value=\"Chinese Medicine Practitioner\">Chinese Medicine Practitioner\n</md-option><md-option value=\"Chiropractor\">Chiropractor</md-option><md-option value=\"Dental Practitioner\">\nDental Practitioner</md-option><md-option value=\"Medical Practitioner\">Medical Practitioner</md-option><md-option \nvalue=\"Medical Radiation Practitioner\">Medical Radiation Practitioner</md-option><md-option value=\"Midwife\">Midwife\n</md-option><md-option value=\"Nurse\">Nurse</md-option><md-option value=\"Occupational Therapist\">Occupational Therapist\n</md-option><md-option value=\"Optometrist\">Optometrist</md-option><md-option value=\"Osteopath\">Osteopath</md-option>\n<md-option value=\"Paramedic\">Paramedic</md-option><md-option value=\"Pathologist\">Pathologist</md-option><md-option \nvalue=\"Pharmacist\">Pharmacist</md-option><md-option value=\"Physiotherapist\">Physiotherapist</md-option><md-option \nvalue=\"Podiatrist\">Podiatrist</md-option><md-option value=\"Psychologist\">Psychologist</md-option><md-option \nvalue=\"Sonographer\">Sonographer</md-option><md-option value=\"Other\">Other</md-option></md-select></md-input-container>\n</div></div><div layout=\"row\" style=\"width:90%;margin:auto;margin-top:20px;padding-bottom: 40px\" \nng-if=\"$ctrl.checkPractitioner()\"><div layout=\"column\" style=\"width:50%;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nRegistration No.</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.inviteNewUser.person.registrationId\" placeholder=\"Registration Number\"></md-input-container></div>\n</div><div layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 30px\"><md-button type=\"submit\" \nng-click=\"$ctrl.inviteNewUserRequest()\" class=\"md-raised md-accent submit-button\" \nstyle=\"border-radius:5px;width:115px;height:40px;font-size: 16px;;text-transform: none !important\">SUBMIT</md-button>\n</div></div></div></div></div><div layout=\"row\" layout-align=\"space-around\" \nclass=\"whiteframedemoDirectiveInterpolation\" style=\"padding:24px\" ng-show=\"$ctrl.whichPage === 4\"><div class=\"padded\" \nmd-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px;max-width:80%\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.back2OrgInfo()\"></md-icon></div></div><div layout=\"row\" \nstyle=\"margin-top:60px\"><div layout=\"column\" layout-align=\"center center\" \nstyle=\"font-family: Roboto;margin-top: 60px;position: absolute;top: 0;right: 0;left: 0;font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333\">\nSelected Organisation</div></div><div layout=\"row\" style=\"margin-top:-10px\"><div layout=\"column\" \nlayout-align=\"center center\" \nstyle=\"font-family: Roboto;margin-top: 78px;position: absolute;top: 0;right: 0;left: 0;font-size: 12px;font-weight: bold;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #92298C;text-transform: uppercase\">\n{{$ctrl.selectedOrganisation.displayName}}</div></div><div layout=\"row\"><div layout=\"column\" \nlayout-align=\"center center\" \nstyle=\"font-family: Roboto;margin-top: 98px;position: absolute;top: 0;right: 0;left: 0;font-size: 2.4rem\">INVITE STATUS\n</div></div><div layout=\"row\" style=\"margin-top:25px\" ng-if=\"$ctrl.noInvites\"><img \nsrc=\"/assets/images/icons8-info-64.png\" \nstyle=\"width:30px;height:30px;margin-right:13px;cursor:pointer;margin-top:30px\"><div layout=\"column\" \nlayout-align=\"center center\" style=\"font-size: 12px;font-family: Roboto;margin-top:30px\">No invites found.</div></div>\n<div layout=\"row\" style=\"margin-top:55px\" ng-if=\"!$ctrl.noInvites\"><div layout=\"column\" layout-align=\"center center\" \nng-show=\"$ctrl.allInvites && $ctrl.allInvites.length > 0\"><div style=\"margin: 10px;margin-top:60px\"><div \nclass=\"tbl-header\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><thead><tr><th style=\"text-align: center\">Name\n</th><th style=\"text-align: center\">Date sent</th><th style=\"text-align: center\">Status</th><th \nstyle=\"text-align: center\">Action</th></tr></thead></table></div><div class=\"tbl-content\"><table cellpadding=\"0\" \ncellspacing=\"0\" border=\"0\"><tbody><tr ng-repeat=\"invite in $ctrl.allInvites \"><td style=\"text-align: center\">\n{{$ctrl.getDisplayName(invite.user)}}</td><td style=\"text-align: center\">{{$ctrl.getCreatedDate(invite.created)}}</td>\n<td style=\"text-align: center\"><div \nstyle=\"margin: 0 auto;;width: 70px;border-radius: 4px;font-size: 11px;padding: .25em .75em;font-weight: 500;text-align: center;vertical-align: middle;background: #ff902b;color: #ffffff\" \nng-show=\"invite.statusCode === 55\">{{invite.status}}</div><div \nstyle=\"margin: 0 auto;;width: 70px;border-radius: 4px;font-size: 11px;padding: .25em .75em;font-weight: 500;text-align: center;vertical-align: middle;background: #27c24c;color: #ffffff\" \nng-show=\"invite.statusCode === 70\">{{invite.status}}</div></td><td style=\"text-align: center\"><md-button \nng-show=\"invite.statusCode === 55\" type=\"submit\" ng-click=\"$ctrl.resendInvite(invite.inviteId)\" \nclass=\"md-raised md-accent submit-button\" style=\"border-radius:5px;font-size: 12px;;text-transform: none !important\">\nRESEND</md-button></td></tr></tbody></table></div></div></div></div></div></div><div layout=\"row\" \nlayout-align=\"space-around\" class=\"whiteframedemoDirectiveInterpolation\" style=\"padding:24px\" \nng-show=\"$ctrl.whichPage === 5\"><div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" \nlayout-align=\"center center\" style=\"background: #fff;border-radius: 4px;position:relative;min-height:400px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.back2OrgInfo()\"></md-icon></div></div><div layout=\"row\" \nstyle=\"margin-top:60px\"><div layout=\"column\" layout-align=\"center center\" \nstyle=\"font-family: Roboto;margin-top: 60px;position: absolute;top: 0;right: 0;left: 0;font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333\">\nSelected Organisation</div></div><div layout=\"row\" style=\"margin-top:-10px\"><div layout=\"column\" \nlayout-align=\"center center\" \nstyle=\"font-family: Roboto;margin-top: 78px;position: absolute;top: 0;right: 0;left: 0;font-size: 12px;font-weight: bold;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #92298C;text-transform: uppercase\">\n{{$ctrl.selectedOrganisation.displayName}}</div></div><div layout=\"row\"><div layout=\"column\" \nlayout-align=\"center center\" \nstyle=\"font-family: Roboto;margin-top: 98px;position: absolute;top: 0;right: 0;left: 0;font-size: 2.4rem\">ALL MEMBERS\n</div></div><div layout=\"row\" style=\"margin-top:25px\" ng-if=\"$ctrl.noMembers\"><img \nsrc=\"/assets/images/icons8-info-64.png\" \nstyle=\"width:30px;height:30px;margin-right:13px;cursor:pointer;margin-top:30px\"><div layout=\"column\" \nlayout-align=\"center center\" style=\"font-size: 12px;font-family: Roboto;margin-top:30px\">No members found.</div></div>\n<div layout=\"column\" layout-align=\"center center\" ng-show=\"$ctrl.allMembers && $ctrl.allMembers.length > 0\" \nstyle=\"margin-top:100px\"><div style=\"margin: 10px;margin-top:30px\"><div class=\"tbl-header\"><table cellpadding=\"0\" \ncellspacing=\"0\" border=\"0\"><thead><tr><th style=\"text-align: center\">Title</th><th style=\"text-align: center\">\nFirst Name</th><th style=\"text-align: center\">Middle Name</th><th style=\"text-align: center\">Last Name</th><th \nstyle=\"text-align: center\"></th></tr></thead></table></div><div class=\"tbl-content\"><table cellpadding=\"0\" \ncellspacing=\"0\" border=\"0\"><tbody><tr ng-repeat=\"member in $ctrl.allMembers\"><td>{{member.user.title}}</td><td \nstyle=\"text-align: center\">{{member.user.firstname}}</td><td style=\"text-align: center\">{{member.user.middleNames}}\n</td><td style=\"text-align: center\">{{member.user.lastname}}</td><td style=\"text-align: center\"><md-button \ntype=\"submit\" ng-click=\"$ctrl.viewMember(member)\" class=\"md-raised md-accent submit-button\" \nstyle=\"border-radius:5px;font-size: 12px;;text-transform: none !important\">VIEW</md-button></td></tr></tbody></table>\n</div></div></div></div></div><div layout=\"row\" layout-align=\"space-around\" \nclass=\"whiteframedemoDirectiveInterpolation\" style=\"padding:24px\" ng-show=\"$ctrl.whichPage === 6\"><div class=\"padded\" \nmd-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.back2OrgInfo()\"></md-icon></div></div><div layout=\"row\" \nstyle=\"margin-top:60px\"><div layout=\"column\" layout-align=\"center center\" \nstyle=\"font-family: Roboto;margin-top: 60px;position: absolute;top: 0;right: 0;left: 0;font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333\">\nSelected Organisation</div></div><div layout=\"row\" style=\"margin-top:-10px\"><div layout=\"column\" \nlayout-align=\"center center\" \nstyle=\"font-family: Roboto;margin-top: 78px;position: absolute;top: 0;right: 0;left: 0;font-size: 12px;font-weight: bold;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #92298C;text-transform: uppercase\">\n{{$ctrl.selectedOrganisation.displayName}}</div></div><div layout=\"row\"><div layout=\"column\" \nlayout-align=\"center center\" \nstyle=\"font-family: Roboto;margin-top: 98px;position: absolute;top: 0;right: 0;left: 0;font-size: 2.4rem\">ALL CHATS\n</div></div><div layout=\"row\" style=\"margin-top:25px\" ng-if=\"$ctrl.noCases\"><img \nsrc=\"/assets/images/icons8-info-64.png\" \nstyle=\"width:30px;height:30px;margin-right:13px;cursor:pointer;margin-top:30px\"><div layout=\"column\" \nlayout-align=\"center center\" style=\"font-size: 12px;font-family: Roboto;margin-top:30px\">No chats found.</div></div>\n<div layout=\"column\" layout-align=\"center center\" ng-show=\"$ctrl.allCases && $ctrl.allCases.length > 0\" \nstyle=\"margin-top:100px\"><div style=\"margin: 10px;margin-top:30px\"><div class=\"tbl-header\"><table cellpadding=\"0\" \ncellspacing=\"0\" border=\"0\"><thead><tr><th style=\"text-align: center\">Title</th><th style=\"text-align: center\">Sender\n</th><th style=\"text-align: center\">Recipients</th><th style=\"text-align: center\">Created</th></tr></thead></table>\n</div><div class=\"tbl-content\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tbody><tr \nng-repeat=\"userCase in $ctrl.allCases\"><td style=\"text-align: center\">{{userCase.title}}</td><td \nstyle=\"text-align: center\">{{$ctrl.getCaseCreatorName(userCase.creator)}}</td><td style=\"text-align: center\">\n{{$ctrl.getRecipientNames(userCase.recipients)}}</td><td style=\"text-align: center\">\n{{$ctrl.getCreatedDate(userCase.created)}}</td></tr></tbody></table></div></div></div></div></div><div layout=\"row\" \nlayout-align=\"space-around\" class=\"whiteframedemoDirectiveInterpolation\" style=\"padding:24px\" \nng-show=\"$ctrl.whichPage === 7\"><div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" \nlayout-align=\"center center\" style=\"background: #fff;border-radius: 4px;position:relative;min-height:400px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.back2OrgInfo()\"></md-icon></div></div><div layout=\"row\" \nstyle=\"margin-top:60px\"><div layout=\"column\" layout-align=\"center center\" \nstyle=\"font-family: Roboto;margin-top: 60px;position: absolute;top: 0;right: 0;left: 0;font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333\">\nSelected Organisation</div></div><div layout=\"row\" style=\"margin-top:-10px\"><div layout=\"column\" \nlayout-align=\"center center\" \nstyle=\"font-family: Roboto;margin-top: 78px;position: absolute;top: 0;right: 0;left: 0;font-size: 12px;font-weight: bold;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #92298C;text-transform: uppercase\">\n{{$ctrl.selectedOrganisation.displayName}}</div></div><div layout=\"row\"><div layout=\"column\" \nlayout-align=\"center center\" \nstyle=\"font-family: Roboto;margin-top: 98px;position: absolute;top: 0;right: 0;left: 0;font-size: 2.4rem\">ADD CONTACTS\n</div></div><div layout=\"row\" style=\"margin-top:25px\" ng-if=\"$ctrl.noAddContacts\"><img \nsrc=\"/assets/images/icons8-info-64.png\" \nstyle=\"width:30px;height:30px;margin-right:13px;cursor:pointer;margin-top:30px\"><div layout=\"column\" \nlayout-align=\"center center\" style=\"font-size: 12px;font-family: Roboto;margin-top:30px\">No users found.</div></div>\n<div layout=\"column\" layout-align=\"center center\" ng-show=\"$ctrl.allAddContacts && $ctrl.allAddContacts.length > 0\" \nstyle=\"margin-top:100px\"><div style=\"margin: 10px;margin-top:30px\"><div class=\"tbl-header\"><table cellpadding=\"0\" \ncellspacing=\"0\" border=\"0\"><thead><tr><th style=\"text-align: center\">Title</th><th style=\"text-align: center\">\nFirst Name</th><th style=\"text-align: center\">Middle Name</th><th style=\"text-align: center\">Last Name</th><th \nstyle=\"text-align: center\"></th><th style=\"text-align: center\"></th></tr></thead></table></div><div \nclass=\"tbl-content\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tbody><tr \nng-repeat=\"contact in $ctrl.allAddContacts\"><td style=\"text-align: center\">{{contact.user.title}}</td><td \nstyle=\"text-align: center\">{{contact.user.firstname}}</td><td style=\"text-align: center\">{{contact.user.middleNames}}\n</td><td style=\"text-align: center\">{{contact.user.lastname}}</td><td style=\"text-align: center\"><md-button \ntype=\"submit\" ng-click=\"$ctrl.connectToExistingUser(contact)\" class=\"md-raised md-accent submit-button\" \nstyle=\"border-radius:5px;font-size: 12px;;text-transform: none !important;width:100px;white-space: normal\">\nCONNECT TO EXISTING USER</md-button></td><td style=\"text-align: center\"><md-button type=\"submit\" \nng-click=\"$ctrl.connectToNonUser(contact)\" class=\"md-raised md-accent submit-button\" \nstyle=\"border-radius:5px;font-size: 12px;;text-transform: none !important;width:100px;white-space: normal\">\nCONNECT TO NON USER</md-button></td></tr></tbody></table></div></div></div></div></div><div layout=\"row\" \nlayout-align=\"space-around\" class=\"whiteframedemoDirectiveInterpolation\" style=\"padding:24px\" \nng-show=\"$ctrl.whichPage === 8\"><div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" \nlayout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px;max-width:80%\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.back2OrgInfo()\"></md-icon></div></div><div layout=\"row\" \nstyle=\"margin-top:60px\"><div layout=\"column\" layout-align=\"center center\" \nstyle=\"font-family: Roboto;margin-top: 60px;position: absolute;top: 0;right: 0;left: 0;font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333\">\nSelected Organisation</div></div><div layout=\"row\" style=\"margin-top:-10px\"><div layout=\"column\" \nlayout-align=\"center center\" \nstyle=\"font-family: Roboto;margin-top: 78px;position: absolute;top: 0;right: 0;left: 0;font-size: 12px;font-weight: bold;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #92298C;text-transform: uppercase\">\n{{$ctrl.selectedOrganisation.displayName}}</div></div><div layout=\"row\"><div layout=\"column\" \nlayout-align=\"center center\" \nstyle=\"font-family: Roboto;margin-top: 98px;position: absolute;top: 0;right: 0;left: 0;font-size: 2.4rem\">\nMEMBERS AND SHARED CONTACTS</div></div><div layout=\"row\" style=\"margin-top:25px\" ng-if=\"$ctrl.noContacts\"><img \nsrc=\"/assets/images/icons8-info-64.png\" \nstyle=\"width:30px;height:30px;margin-right:13px;cursor:pointer;margin-top:30px\"><div layout=\"column\" \nlayout-align=\"center center\" style=\"font-size: 12px;font-family: Roboto;margin-top:30px\">There are no contacts.</div>\n</div><div layout=\"row\" style=\"margin-top:55px\" ng-if=\"!$ctrl.noContacts\"><div layout=\"column\" \nlayout-align=\"center center\" ng-show=\"$ctrl.allContacts && $ctrl.allContacts.length > 0\"><div \nstyle=\"margin: 10px;margin-top:60px\"><div class=\"tbl-header\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><thead>\n<tr><th style=\"text-align: center\">Name</th><th style=\"text-align: center\">Mobile</th><th style=\"text-align: center\">\nEmail</th><th style=\"text-align: center\">Profession</th><th style=\"text-align: center\">Linked</th><th \nstyle=\"text-align: center\">Action</th></tr></thead></table></div><div class=\"tbl-content\"><table cellpadding=\"0\" \ncellspacing=\"0\" border=\"0\"><tbody><tr ng-repeat=\"contact in $ctrl.allContacts \"><td style=\"text-align: center\">\n{{$ctrl.getDisplayName(contact)}}</td><td style=\"text-align: center\">{{contact.profession}}</td><td \nstyle=\"text-align: center\">{{contact.mobile}}</td><td style=\"text-align: center\">{{contact.email}}</td><td \nstyle=\"text-align: center\"><span ng-show=\"contact.isLinked\"><img src=\"/assets/images/icons8-chain-48.png\" \nstyle=\"cursor:pointer;width:18px;height:18px\" ng-click=\"$ctrl.searchByName()\"></span></td><td \nstyle=\"text-align: center\"><md-button type=\"submit\" ng-click=\"$ctrl.viewContactDetails(contact)\" \nclass=\"md-raised md-accent submit-button\" style=\"border-radius:5px;font-size: 12px;;text-transform: none !important\">\nVIEW</md-button></td></tr></tbody></table></div></div></div></div></div></div><div layout=\"row\" \nlayout-align=\"space-around\" class=\"whiteframedemoDirectiveInterpolation\" style=\"padding:24px\" \nng-show=\"$ctrl.whichPage === 9\"><div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" \nlayout-align=\"center center\" style=\"background: #fff;border-radius: 4px;position:relative;min-height:400px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.back2AllContacts()\"></md-icon></div></div><div layout=\"column\" \nstyle=\"margin-top: 30px;width:100%\"><div layout=\"row\" style=\"margin-top:40px\"><div layout=\"column\" \nlayout-align=\"center center\" \nstyle=\"font-family: Roboto;margin-top: 60px;position: absolute;top: 0;right: 0;left: 0;font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333\">\nSelected Organisation</div></div><div layout=\"row\"><div layout=\"column\" layout-align=\"center center\" \nstyle=\"font-family: Roboto;margin-top: 78px;position: absolute;top: 0;right: 0;left: 0;font-size: 12px;font-weight: bold;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #92298C;text-transform: uppercase\">\n{{$ctrl.selectedOrganisation.displayName}}</div></div><div><div layout=\"row\" \nstyle=\"height: 30px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto;margin-top: 60px\"><h1 \nstyle=\"font-size: 11px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;width: 100px;margin-top: -7px;margin-left: 43px;padding-left: 10px;background: white\">\nContact information</h1></div><div layout=\"row\" style=\"margin:auto;width: 90%\" ng-show=\"$ctrl.selectedContact.title\">\n<div layout=\"column\" style=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nTitle</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedContact.title\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nLast name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedContact.lastname\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\" ng-show=\"$ctrl.selectedContact.middleNames\"><div layout=\"column\" \nstyle=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nMiddle name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedContact.middleNames\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nFirst name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedContact.firstname\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nProfession</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedContact.profession\" placeholder=\"Profession\"></md-input-container></div></div><div \nlayout=\"row\" style=\"margin:auto;margin-top:20px;width: 90%\" ng-show=\"$ctrl.selectedContact.registrationId\"><div \nlayout=\"column\" style=\"margin-right:10px;width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nAHPRA No</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedContact.registrationId\" placeholder=\"AHPRA\"></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"center center\" style=\"margin-bottom: 30px\"></div></div></div></div></div><div layout=\"row\" \nlayout-align=\"space-around\" class=\"whiteframedemoDirectiveInterpolation\" style=\"padding:24px\" \nng-show=\"$ctrl.whichPage === 10\"><div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" \nlayout-align=\"center center\" style=\"background: #fff;border-radius: 4px;position:relative;min-height:400px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.closeAddSelectedUser()\"></md-icon></div></div><div \nlayout=\"column\" style=\"margin-top: 30px;width:100%\"><div layout=\"row\" \nstyle=\"font-family: Roboto;margin:auto;font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333\">\nSelected Organisation</div><div layout=\"row\" \nstyle=\"font-family: Roboto;margin-top:30px;margin:auto;font-size: 12px;font-weight: bold;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #92298C;text-transform: uppercase\">\n{{$ctrl.selectedOrganisation.displayName}}</div><div layout=\"row\" \nstyle=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px;margin:auto;padding-top:20px\">User details</div><div><div \nlayout=\"row\" style=\"height: 30px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto;margin-top: 30px\"><h1 \nstyle=\"font-size: 11px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;width: 100px;margin-top: -7px;margin-left: 43px;padding-left: 10px;background: white\">\nPersonal details</h1></div><div layout=\"row\" style=\"margin:auto;width: 90%\" ng-show=\"$ctrl.selectedAddUser.title\"><div \nlayout=\"column\" style=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nTitle</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedAddUser.title\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nLast name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedAddUser.lastname\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\" ng-show=\"$ctrl.selectedAddUser.middleNames\"><div layout=\"column\" \nstyle=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nMiddle name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedAddUser.middleNames\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nFirst name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedAddUser.firstname\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nProfession</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedAddUser.profession\" placeholder=\"Profession\"></md-input-container></div></div><div \nlayout=\"row\" style=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:50%\">\n<h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nEmail</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedAddUser.email\" placeholder=\"Email\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:10%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nCountry Code</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedAddUser.region\" placeholder=\"\"></md-input-container></div><div layout=\"column\" \nstyle=\"margin-right:10px;width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nMobile</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedAddUser.mobile\" placeholder=\"Mobile\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\" ng-show=\"$ctrl.selectedAddUser.registrationId\"><div layout=\"column\" \nstyle=\"margin-right:10px;width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nAHPRA No</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedAddUser.registrationId\" placeholder=\"AHPRA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;width: 90%\" ng-show=\"$ctrl.selectedAddUser.registrationId\"><div layout=\"column\" \nstyle=\"margin-right:10px;width:50%\"><div style=\"display: flex;flex: 1\"><aside><div class=\"container\"><div \nclass=\"round\"><input id=\"roleOrgOwner\" value=\"true\" type=\"checkbox\" checked=\"true\" ng-disabled=\"true\"><label \nfor=\"roleOrgOwner\" style=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8;background-color: grey\">\n</label></div></div></aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nValid AHPRA</aside></div></div></div><div layout=\"row\" \nstyle=\"height: 10px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto;margin-top: 45px\" \nng-show=\"$ctrl.showOrganisation\"><h1 \nstyle=\"font-size: 11px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;margin-top: -7px;margin-left: 43px;padding-left: 10px;padding-right:10px;background: white\">\nAll Organisation details</h1></div><div layout=\"row\" style=\"margin:auto;width:90%\" \nng-repeat=\"(key, value) in $ctrl.selectedUserOrgMap\"><div layout=\"column\"><h1 \nstyle=\"font-size: 12px;font-weight: bold;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #92298C;margin-top:25px\">\n{{value.orgName}}</h1><div style=\"display: flex;flex: 1;margin-top: 8px\" ng-repeat=\"orgRole in value.allRoles\"><aside>\n<div class=\"container\"><div class=\"round\"><input id=\"inviteRoleOrgOwner\" value=\"true\" type=\"checkbox\" \nng-model=\"$ctrl.editInvitee.isOrgOwner\" ng-checked=\"true\" ng-disabled=\"true\"><label for=\"inviteRoleOrgOwner\" \nstyle=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8;background-color: grey\"></label></div></div>\n</aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\n{{orgRole===\'Creator\'? \'Clinician\' : orgRole === \'OrgOwner\' ? \'Organisation Owner\' : orgRole===\'OfficeAdmin\' ? \'Office Admin\' : orgRole}}\n</aside></div></div></div><div layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 30px\"><md-button \ntype=\"submit\" ng-click=\"$ctrl.addUserNext()\" class=\"md-raised md-accent submit-button\" \nstyle=\"border-radius:5px;font-size: 12px;;text-transform: none !important\">Next</md-button></div></div></div></div>\n</div><div layout=\"row\" layout-align=\"space-around\" class=\"whiteframedemoDirectiveInterpolation\" style=\"padding:24px\" \nng-show=\"$ctrl.whichPage === 11\"><div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" \nlayout-align=\"center center\" style=\"background: #fff;border-radius: 4px;position:relative;min-height:400px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.closeAddSelectedUser()\"></md-icon></div></div><div \nlayout=\"column\" style=\"margin-top: 30px;width:100%\"><div layout=\"row\" \nstyle=\"font-family: Roboto;margin:auto;font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333\">\nSelected Organisation</div><div layout=\"row\" \nstyle=\"font-family: Roboto;margin-top:30px;margin:auto;font-size: 12px;font-weight: bold;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #92298C;text-transform: uppercase\">\n{{$ctrl.selectedOrganisation.displayName}}</div><div layout=\"row\" \nstyle=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px;margin:auto;padding-top:20px\">SELECT ROLES</div><div><div \nlayout=\"row\" style=\"width:90%;margin:auto;margin-top:20px\"><div layout=\"column\" style=\"width:50%;margin-right:10px\"><h1\n \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nStaff ID</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.addUserPayload.member.staffId\" placeholder=\"Staff ID\"></md-input-container></div></div><div \nlayout=\"row\" style=\"margin:auto;width:90%\"><div layout=\"column\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;padding-bottom: 10px;padding-top:20px\">\nRoles</h1><div style=\"display: flex;flex: 1\"><aside><div class=\"container\"><div class=\"round\"><input \nid=\"roleOrgOwnerAddUser\" value=\"true\" type=\"checkbox\" ng-model=\"$ctrl.isOrgOwnerAddUser\"><label \nfor=\"roleOrgOwnerAddUser\" style=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8\"></label></div>\n</div></aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nOrganisation owner</aside></div></div></div><div layout=\"row\" style=\"margin:auto;width:90%\"><div \nstyle=\"display: flex;flex: 1;margin-top: 20px\"><aside><div class=\"container\"><div class=\"round\"><input \nid=\"roleOfficeAdminAddUser\" value=\"true\" type=\"checkbox\" ng-model=\"$ctrl.isOfficeAdminAddUser\"><label \nfor=\"roleOfficeAdminAddUser\" style=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8\"></label></div>\n</div></aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nOffice Admin</aside></div></div><div layout=\"row\" style=\"margin:auto;width:90%\"><div \nstyle=\"display: flex;flex: 1;margin-top: 20px\"><aside><div class=\"container\"><div class=\"round\"><input \nid=\"roleClinicianAddUser\" value=\"true\" type=\"checkbox\" ng-model=\"$ctrl.isClinicianAddUser\"><label \nfor=\"roleClinicianAddUser\" style=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8\"></label></div>\n</div></aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nClinician</aside></div></div><div layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 30px\"><md-button \ntype=\"submit\" ng-click=\"$ctrl.addUserAction()\" class=\"md-raised md-accent submit-button\" \nstyle=\"border-radius:5px;font-size: 12px;;text-transform: none !important\">Add User</md-button></div></div></div></div>\n</div><div layout=\"row\" layout-align=\"space-around\" class=\"whiteframedemoDirectiveInterpolation\" style=\"padding:24px\" \nng-show=\"$ctrl.whichPage === 12\"><div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" \nlayout-align=\"center center\" style=\"background: #fff;border-radius: 4px;position:relative;min-height:400px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.closeViewSelectedMember()\"></md-icon></div></div><div \nlayout=\"column\" style=\"margin-top: 30px;width:100%\"><div layout=\"row\" \nstyle=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px;margin:auto\">User Details</div><div><div layout=\"row\" \nstyle=\"height: 30px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto;margin-top: 30px\"><h1 \nstyle=\"font-size: 11px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;width: 100px;margin-top: -7px;margin-left: 43px;padding-left: 10px;background: white\">\nPersonal details</h1></div><div style=\"position: absolute;right:0;padding-top: 8px;padding-right: 23px\"><div \nlayout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-pencil-box-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.editPersonalDetails()\"></md-icon></div></div><div layout=\"row\" \nstyle=\"margin:auto;width: 90%\" ng-show=\"$ctrl.selectedMember.user.title\"><div layout=\"column\" \nstyle=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nTitle</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedMember.user.title\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nLast name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedMember.user.lastname\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\" ng-show=\"$ctrl.selectedMember.user.middleNames\"><div layout=\"column\" \nstyle=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nMiddle name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedMember.user.middleNames\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nFirst name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedMember.user.firstname\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\" ng-show=\"$ctrl.selectedMember.user.profession\"><div layout=\"column\" \nstyle=\"margin-right:10px;width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nProfession</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedMember.user.profession\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nEmail</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedMember.user.email\" placeholder=\"Email\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:10%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nCountry Code</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedMember.user.region\" placeholder=\"NA\"></md-input-container></div><div layout=\"column\" \nstyle=\"margin-right:10px;width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nMobile</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedMember.user.mobile\" placeholder=\"Mobile\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\" ng-show=\"$ctrl.selectedMember.user.registrationId\"><div layout=\"column\" \nstyle=\"margin-right:10px;width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nAHPRA No</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedMember.user.registrationId\" placeholder=\"AHPRA\"></md-input-container></div></div><div \nlayout=\"row\" style=\"height: 30px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto;margin-top: 45px\" \nng-show=\"$ctrl.selectedMember.roles\"><h1 \nstyle=\"font-size: 11px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;margin-top: -7px;margin-left: 43px;padding-left: 10px;padding-right:10px;background: white\">\nRoles</h1></div><div style=\"position: absolute;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-pencil-box-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.editPersonalRoles()\"></md-icon></div></div><div layout=\"row\" \nstyle=\"margin:auto;width:90%\"><div style=\"display: flex;flex: 1;margin-top: 20px\"><aside><div class=\"container\"><div \nclass=\"round\"><input id=\"personalRoleOrgOwner\" value=\"true\" type=\"checkbox\" ng-model=\"$ctrl.selectedMember.isOrgOwner\" \nng-disabled=\"true\"><label for=\"personalRoleOrgOwner\" \nstyle=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8;background-color: grey\"></label></div></div>\n</aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nOrganisation Owner</aside></div></div><div layout=\"row\" style=\"margin:auto;width:90%\"><div \nstyle=\"display: flex;flex: 1;margin-top: 20px\"><aside><div class=\"container\"><div class=\"round\"><input \nid=\"personalRoleOfficeAdmin\" value=\"true\" type=\"checkbox\" ng-model=\"$ctrl.selectedMember.isOfficeAdmin\" \nng-disabled=\"true\"><label for=\"personalRoleOfficeAdmin\" \nstyle=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8;background-color: grey\"></label></div></div>\n</aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nOffice Admin</aside></div></div><div layout=\"row\" style=\"margin:auto;width:90%\"><div \nstyle=\"display: flex;flex: 1;margin-top: 20px\"><aside><div class=\"container\"><div class=\"round\"><input \nid=\"personalRoleClinician\" value=\"true\" type=\"checkbox\" ng-model=\"$ctrl.selectedMember.isCreator\" ng-disabled=\"true\">\n<label for=\"personalRoleClinician\" \nstyle=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8;background-color: grey\"></label></div></div>\n</aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nClinician</aside></div></div><div layout=\"row\" style=\"margin:auto;width:90%\"><div \nstyle=\"display: flex;flex: 1;margin-top: 20px\"><aside><div class=\"container\"><div class=\"round\"><input \nid=\"personalRoleMDTCoOrdinator\" value=\"true\" type=\"checkbox\" ng-model=\"$ctrl.selectedMember.isMDTCoOrdinator\" \nng-disabled=\"true\"><label for=\"personalRoleMDTCoOrdinator\" \nstyle=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8;background-color: grey\"></label></div></div>\n</aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nMDT-CoOrdinator</aside></div></div><div layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 30px\"></div>\n</div></div></div></div><div layout=\"row\" layout-align=\"space-around\" class=\"whiteframedemoDirectiveInterpolation\" \nstyle=\"padding:24px\" ng-show=\"$ctrl.whichPage === 13\"><div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" \nlayout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.cancelPersonalEdit()\"></md-icon></div></div><div layout=\"column\" \nstyle=\"margin-top: 30px;width:100%\"><div layout=\"row\" \nstyle=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px;margin:auto\">Edit Personal Details</div><div><div \nlayout=\"row\" style=\"margin:auto;width: 90%\"><div layout=\"column\" style=\"width:15%;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nTitle</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0;margin-top: 7px\">\n<md-select type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.selectedMember.editTitle\" placeholder=\"Title\"><md-option value=\"Dr\">Dr</md-option><md-option \nvalue=\"Mr\">Mr</md-option><md-option value=\"Mrs\">Mrs</md-option><md-option value=\"Ms\">Ms</md-option><md-option \nvalue=\"Miss\">Miss</md-option><md-option value=\"Master\">Master</md-option><md-option value=\"Prof\">Prof</md-option>\n<md-option value=\"A/Prof\">A/Prof</md-option><md-option value=\"Other\">Other</md-option></md-select></md-input-container>\n</div></div><div layout=\"row\" style=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"width:50%\"><h1\n \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nFirst name<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.selectedMember.editFirstName\" placeholder=\"First name\"></md-input-container></div></div></div><div \nlayout=\"row\" style=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:50%\">\n<h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nMiddle name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0;margin-top: 7px\">\n<input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.selectedMember.editMiddleNames\" placeholder=\"Middle name\"></md-input-container></div></div><div \nlayout=\"row\" style=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nLast name<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0;margin-top: 7px\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.selectedMember.editLastName\" placeholder=\"Last name\"></md-input-container></div></div><div \nlayout=\"row\" style=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"width:50%;margin-right:10px\">\n<h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nProfession</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><md-select \ntype=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.selectedMember.editProfession\" placeholder=\"Profession\"><md-option \nvalue=\"Aboriginal and Torres Strait Islander Health Practitioner\">Aboriginal and Torres Strait Islander<br>\nHealth Practitioner</md-option><md-option value=\"Chinese Medicine Practitioner\">Chinese Medicine Practitioner\n</md-option><md-option value=\"Chiropractor\">Chiropractor</md-option><md-option value=\"Dental Practitioner\">\nDental Practitioner</md-option><md-option value=\"Medical Practitioner\">Medical Practitioner</md-option><md-option \nvalue=\"Medical Radiation Practitioner\">Medical Radiation Practitioner</md-option><md-option value=\"Midwife\">Midwife\n</md-option><md-option value=\"Nurse\">Nurse</md-option><md-option value=\"Occupational Therapist\">Occupational Therapist\n</md-option><md-option value=\"Optometrist\">Optometrist</md-option><md-option value=\"Osteopath\">Osteopath</md-option>\n<md-option value=\"Paramedic\">Paramedic</md-option><md-option value=\"Pathologist\">Pathologist</md-option><md-option \nvalue=\"Pharmacist\">Pharmacist</md-option><md-option value=\"Physiotherapist\">Physiotherapist</md-option><md-option \nvalue=\"Podiatrist\">Podiatrist</md-option><md-option value=\"Psychologist\">Psychologist</md-option><md-option \nvalue=\"Sonographer\">Sonographer</md-option><md-option value=\"Other\">Other</md-option></md-select></md-input-container>\n</div></div><div layout=\"row\" style=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"width:50%\"><h1\n \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nEmail<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container class=\"md-block\" \nmd-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.selectedMember.editEmail\" placeholder=\"Email\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"width:18%;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nCountry code<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><md-select type=\"text\" \nstyle=\"border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.selectedMember.editCountryCode\" placeholder=\" \"><md-option value=\"AU\">+61</md-option><md-option \nvalue=\"IN\">+91</md-option></md-select></md-input-container></div><div layout=\"column\" \nstyle=\"width:28%;margin-left:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nMobile number<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0;padding-top:4px\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.selectedMember.editPhone\" placeholder=\"Mobile number\"></md-input-container></div></div><div \nlayout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 30px;margin-top:20px\"><md-button type=\"submit\" \nng-click=\"$ctrl.savePersonalDetails()\" class=\"md-raised md-accent submit-button\" \nstyle=\"border-radius:5px;font-size: 12px;;text-transform: none !important\">SAVE</md-button></div></div></div></div><div\n layout=\"row\" layout-align=\"space-around\" class=\"whiteframedemoDirectiveInterpolation\" style=\"padding:24px\" \nng-show=\"$ctrl.whichPage === 14\"><div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" \nlayout-align=\"center center\" style=\"background: #fff;border-radius: 4px;position:relative;min-height:400px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.cancelPersonalEdit()\"></md-icon></div></div><div layout=\"column\" \nstyle=\"margin-top: 30px;width:100%\"><div layout=\"row\" \nstyle=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px;margin:auto\">Edit Roles</div><div><div layout=\"column\" \nstyle=\"margin:auto;width: 90%\"><div style=\"display: flex;flex: 1;margin-top: 8px\"><aside><div class=\"container\"><div \nclass=\"round\"><input id=\"editOrgOwner\" value=\"true\" type=\"checkbox\" ng-checked=\"$ctrl.selectedMember.isOrgOwnerEdit\" \nng-model=\"$ctrl.selectedMember.isOrgOwnerEdit\"><label for=\"editOrgOwner\" \nstyle=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8\"></label></div></div></aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nOrganisation Owner</aside></div><div style=\"display: flex;flex: 1;margin-top: 8px\"><aside><div class=\"container\"><div \nclass=\"round\"><input id=\"editOfficeAdmin\" value=\"true\" type=\"checkbox\" \nng-checked=\"$ctrl.selectedMember.isOfficeAdminEdit\" ng-model=\"$ctrl.selectedMember.isOfficeAdminEdit\"><label \nfor=\"editOfficeAdmin\" style=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8\"></label></div></div>\n</aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nOffice Admin</aside></div><div style=\"display: flex;flex: 1;margin-top: 8px\"><aside><div class=\"container\"><div \nclass=\"round\"><input id=\"editCreator\" value=\"true\" type=\"checkbox\" ng-checked=\"$ctrl.selectedMember.isCreatorEdit\" \nng-model=\"$ctrl.selectedMember.isCreatorEdit\"><label for=\"editCreator\" \nstyle=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8\"></label></div></div></aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nClinician</aside></div><div style=\"display: flex;flex: 1;margin-top: 8px\"><aside><div class=\"container\"><div \nclass=\"round\"><input id=\"editMDTCoOrdinator\" value=\"true\" type=\"checkbox\" \nng-checked=\"$ctrl.selectedMember.isMDTCoOrdinatorEdit\" ng-model=\"$ctrl.selectedMember.isMDTCoOrdinatorEdit\"><label \nfor=\"editMDTCoOrdinator\" style=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8\"></label></div>\n</div></aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nMDT Co-Ordinator</aside></div></div><div layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 30px\">\n<md-button type=\"submit\" ng-click=\"$ctrl.saveRoleChanges()\" class=\"md-raised md-accent submit-button\" \nstyle=\"border-radius:5px;font-size: 12px;;text-transform: none !important\">SAVE</md-button></div></div></div></div>\n</div><div layout=\"row\" layout-align=\"space-around\" class=\"whiteframedemoDirectiveInterpolation\" style=\"padding:24px\" \nng-show=\"$ctrl.whichPage === 15\"><div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" \nlayout-align=\"center center\" style=\"background: #fff;border-radius: 4px;position:relative;min-height:400px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.cancelExternalContact()\"></md-icon></div></div><div \nlayout=\"column\" style=\"margin-top: 30px;width:100%\"><div layout=\"row\" \nstyle=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px;margin:auto\">Enter Contact Details</div><div><div \nlayout=\"row\" style=\"margin:auto;width: 90%\"><div layout=\"column\" style=\"width:15%;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nTitle</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0;margin-top: 7px\">\n<md-select type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.externalContactTitle\" placeholder=\"Title\"><md-option value=\"Dr\">Dr</md-option><md-option value=\"Mr\">Mr\n</md-option><md-option value=\"Mrs\">Mrs</md-option><md-option value=\"Ms\">Ms</md-option><md-option value=\"Miss\">Miss\n</md-option><md-option value=\"Master\">Master</md-option><md-option value=\"Prof\">Prof</md-option><md-option \nvalue=\"A/Prof\">A/Prof</md-option><md-option value=\"Other\">Other</md-option></md-select></md-input-container></div>\n</div><div layout=\"row\" style=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nFirst name<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.externalContactFirstName\" placeholder=\"First name\"></md-input-container></div></div></div><div \nlayout=\"row\" style=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:50%\">\n<h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nMiddle name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0;margin-top: 7px\">\n<input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.externalContactMiddleName\" placeholder=\"Middle name\"></md-input-container></div></div><div \nlayout=\"row\" style=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nLast name<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0;margin-top: 7px\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.externalContactLastName\" placeholder=\"Last name\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"width:50%;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nProfession</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><md-select \ntype=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.externalContactProfession\" placeholder=\"Profession\"><md-option \nvalue=\"Aboriginal and Torres Strait Islander Health Practitioner\">Aboriginal and Torres Strait Islander<br>\nHealth Practitioner</md-option><md-option value=\"Chinese Medicine Practitioner\">Chinese Medicine Practitioner\n</md-option><md-option value=\"Chiropractor\">Chiropractor</md-option><md-option value=\"Dental Practitioner\">\nDental Practitioner</md-option><md-option value=\"Medical Practitioner\">Medical Practitioner</md-option><md-option \nvalue=\"Medical Radiation Practitioner\">Medical Radiation Practitioner</md-option><md-option value=\"Midwife\">Midwife\n</md-option><md-option value=\"Nurse\">Nurse</md-option><md-option value=\"Occupational Therapist\">Occupational Therapist\n</md-option><md-option value=\"Optometrist\">Optometrist</md-option><md-option value=\"Osteopath\">Osteopath</md-option>\n<md-option value=\"Paramedic\">Paramedic</md-option><md-option value=\"Pathologist\">Pathologist</md-option><md-option \nvalue=\"Pharmacist\">Pharmacist</md-option><md-option value=\"Physiotherapist\">Physiotherapist</md-option><md-option \nvalue=\"Podiatrist\">Podiatrist</md-option><md-option value=\"Psychologist\">Psychologist</md-option><md-option \nvalue=\"Sonographer\">Sonographer</md-option><md-option value=\"Other\">Other</md-option></md-select></md-input-container>\n</div></div><md-radio-group ng-model=\"$ctrl.externalContactIsSpellingCorrect\" \nstyle=\"margin: auto;width:90%;margin-top:40px\"><span \nstyle=\"font-size: 11px;font-weight: normal;letter-spacing: normal;color: #333333;padding-left: 2px\">\nConfirm last name is correct ?</span><div \nstyle=\"display: flex;align-items: center;font-size: 14px;margin-top: 10px;width:90%;margin-bottom: 0px\">\n<md-radio-button ng-value=\"true\" class=\"md-primary\" style=\"margin-bottom: 0;font-size: 12px\">Yes</md-radio-button>\n<md-radio-button ng-value=\"false\" class=\"md-primary\" style=\"margin-bottom: 0;margin-left: 30px;font-size: 12px\">No\n</md-radio-button></div></md-radio-group><div layout=\"row\" layout-align=\"center center\" \nstyle=\"margin-bottom: 30px;margin-top:20px\"><md-button ng-disabled=\"!$ctrl.externalContactIsSpellingCorrect\" \ntype=\"submit\" ng-click=\"$ctrl.addExternalContact()\" class=\"md-raised md-accent submit-button\" \nstyle=\"border-radius:5px;font-size: 12px;;text-transform: none !important\">SUBMIT</md-button></div></div></div></div>\n<div layout=\"row\" layout-align=\"space-around\" class=\"whiteframedemoDirectiveInterpolation\" style=\"padding:24px\" \nng-show=\"$ctrl.whichPage === 16\"><div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" \nlayout-align=\"center center\" style=\"background: #fff;border-radius: 4px;position:relative;min-height:400px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.cancelExistingContactSearchPage()\"></md-icon></div></div><div \nlayout=\"row\" style=\"margin-top:-10px\"><div layout=\"column\" layout-align=\"center center\" \nstyle=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px\">Search Users</div></div><div layout=\"column\" \nstyle=\"width: 300px;max-width: 300px;margin-top: 30px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nSearch by First Name</h1><div layout=\"row\"><md-input-container class=\"md-block\" md-no-float \nstyle=\"margin-top:0;margin-bottom: 0;width:250px\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.connectUserFirstName\" placeholder=\"First Name\"></md-input-container><span \nstyle=\"padding-left: 5px;padding-top: 5px\"><span><img src=\"/assets/images/searchbutton.png\" \nstyle=\"cursor:pointer;width:30px;height:30px\" ng-click=\"$ctrl.search()\"></span></span></div></div><div layout=\"column\" \nstyle=\"width: 300px;max-width: 300px;margin-top: 37px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nSearch by Last Name</h1><div layout=\"row\"><md-input-container class=\"md-block\" md-no-float \nstyle=\"margin-top:0;margin-bottom: 0;width:250px\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.connectUserLastName\" placeholder=\"Last Name\"></md-input-container><span \nstyle=\"padding-left: 5px;padding-top: 5px\"><span><img src=\"/assets/images/searchbutton.png\" \nstyle=\"cursor:pointer;width:30px;height:30px\" ng-click=\"$ctrl.search()\"></span></span></div></div><div layout=\"row\" \nstyle=\"margin-top:25px\" ng-if=\"$ctrl.noConnectUserSearchResults\"><img src=\"/assets/images/icons8-info-64.png\" \nstyle=\"width:30px;height:30px;margin-right:13px;cursor:pointer;margin-top:30px\"><div layout=\"column\" \nlayout-align=\"center center\" style=\"font-size: 12px;font-family: Roboto;margin-top:30px\">No results found.</div></div>\n<div layout=\"column\" layout-align=\"center center\" \nng-show=\"$ctrl.connectUserSearchResults && $ctrl.connectUserSearchResults.length > 0\"><div \nstyle=\"margin: 10px;margin-top:30px\"><div class=\"tbl-header\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><thead>\n<tr><th style=\"text-transform: none\">Title</th><th style=\"text-transform: none;width: 20%\">First Name</th><th \nstyle=\"text-transform: none;width: 20%\">Middle Name</th><th style=\"text-transform: none;width: 20%\">Last Name</th><th \nstyle=\"text-transform: none;width: 20%\"></th></tr></thead></table></div><div class=\"tbl-content\"><table \ncellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tbody><tr ng-repeat=\"orgUser in $ctrl.connectUserSearchResults\"><td>\n{{orgUser.title}}</td><td style=\"width: 20%;word-wrap:break-word\">{{orgUser.firstname}}</td><td style=\"width: 20%\">\n{{orgUser.middleNames}}</td><td style=\"width: 20%\">{{orgUser.lastname}}</td><td style=\"text-align: end;width: 20%\">\n<md-button type=\"submit\" ng-click=\"$ctrl.viewUserConnect(orgUser)\" class=\"md-raised md-accent submit-button\" \nstyle=\"border-radius:5px;font-size: 12px;;text-transform: none !important\">VIEW</md-button></td></tr></tbody></table>\n</div></div></div></div></div><div layout=\"row\" layout-align=\"space-around\" \nclass=\"whiteframedemoDirectiveInterpolation\" style=\"padding:24px\" ng-show=\"$ctrl.whichPage === 17\"><div class=\"padded\" \nmd-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.cancelViewExistingMember()\"></md-icon></div></div><div \nlayout=\"column\" style=\"margin-top: 30px;width:100%\"><div layout=\"row\" \nstyle=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px;margin:auto\">User details</div><div><div layout=\"row\" \nstyle=\"height: 30px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto;margin-top: 30px\"><h1 \nstyle=\"font-size: 11px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;width: 100px;margin-top: -7px;margin-left: 43px;padding-left: 10px;background: white\">\nPersonal details</h1></div><div layout=\"row\" style=\"margin:auto;width: 90%\" \nng-show=\"$ctrl.selectedExistingContact.title\"><div layout=\"column\" style=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nTitle</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedExistingContact.title\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nLast name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedExistingContact.lastname\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\" ng-show=\"$ctrl.selectedExistingContact.middleNames\"><div \nlayout=\"column\" style=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nMiddle name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedExistingContact.middleNames\" placeholder=\"NA\"></md-input-container></div></div><div \nlayout=\"row\" style=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:100%\">\n<h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nFirst name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedExistingContact.firstname\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nProfession</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedExistingContact.profession\" placeholder=\"Profession\"></md-input-container></div></div><div \nlayout=\"row\" style=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:50%\">\n<h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nEmail</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedExistingContact.email\" placeholder=\"Email\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:10%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nCountry Code</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedExistingContact.region\" placeholder=\"\"></md-input-container></div><div layout=\"column\" \nstyle=\"margin-right:10px;width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nMobile</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedExistingContact.mobile\" placeholder=\"Mobile\"></md-input-container></div></div><div \nlayout=\"row\" style=\"margin:auto;margin-top:20px;width: 90%\" ng-show=\"$ctrl.selectedExistingContact.registrationId\"><div\n layout=\"column\" style=\"margin-right:10px;width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nAHPRA No</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedExistingContact.registrationId\" placeholder=\"AHPRA\"></md-input-container></div></div><div \nlayout=\"row\" style=\"margin:auto;width: 90%\" ng-show=\"$ctrl.selectedExistingContact.registrationId\"><div \nlayout=\"column\" style=\"margin-right:10px;width:50%\"><div style=\"display: flex;flex: 1\"><aside><div class=\"container\">\n<div class=\"round\"><input id=\"roleOrgOwner\" value=\"true\" type=\"checkbox\" checked=\"true\" ng-disabled=\"true\"><label \nfor=\"roleOrgOwner\" style=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8;background-color: grey\">\n</label></div></div></aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nValid AHPRA</aside></div></div></div><div layout=\"row\" \nstyle=\"height: 30px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto;margin-top: 45px\" \nng-show=\"$ctrl.showOrganisation\"><h1 \nstyle=\"font-size: 11px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;margin-top: -7px;margin-left: 43px;padding-left: 10px;padding-right:10px;background: white\">\nAll Organisation details</h1></div><div layout=\"row\" style=\"margin:auto;width:90%\" \nng-repeat=\"(key, value) in $ctrl.selectedUserOrgMap\"><div layout=\"column\"><h1 \nstyle=\"font-size: 12px;font-weight: bold;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #92298C;margin-top:25px\">\n{{value.orgName}}</h1><div style=\"display: flex;flex: 1;margin-top: 8px\" ng-repeat=\"orgRole in value.allRoles\"><aside>\n<div class=\"container\"><div class=\"round\"><input id=\"inviteRoleOrgOwner7\" value=\"true\" type=\"checkbox\" \nng-model=\"$ctrl.editInvitee.isOrgOwner\" ng-checked=\"true\" ng-disabled=\"true\"><label for=\"inviteRoleOrgOwner7\" \nstyle=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8;background-color: grey\"></label></div></div>\n</aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\n{{orgRole===\'Creator\'? \'Clinician\' : orgRole === \'OrgOwner\' ? \'Organisation Owner\' : orgRole===\'OfficeAdmin\' ? \'Office Admin\' : orgRole}}\n</aside></div></div></div><div layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 30px\"><md-button \ntype=\"submit\" ng-click=\"$ctrl.connectExistingUser()\" class=\"md-raised md-accent submit-button\" \nstyle=\"border-radius:5px;width:115px;height:40px;font-size: 16px;;text-transform: none !important\">CONNECT</md-button>\n</div></div></div></div></div></div><style>\ntable{\n    width:100%;\n    table-layout: fixed;\n\n  }\n  table tr:hover {\n    background: #f4f4f4;\n  }\n  table tr:hover td {\n    color: #555;\n  }\n  .tbl-header{\n    background-color: rgba(255,255,255,0.3);\n  }\n  .tbl-content{\n\n    overflow-x:auto;\n    margin-top: 0px;\n    border: 1px solid rgba(255,255,255,0.3);\n  }\n  th{\n    padding: 20px 15px;\n    text-align: left;\n    font-weight: 500;\n    font-size: 12px;\n    color: #ffffff;\n    text-transform: uppercase;\n    background: #92298D;\n  }\n  td{\n    padding: 15px;\n    text-align: left;\n    vertical-align:middle;\n    font-weight: 300;\n    font-size: 12px;\n    color: #000;\n    border-bottom: solid 1px rgba(255,255,255,0.1);\n  }\n</style>");
$templateCache.put("app/main/clinician/people/manageUsers.html","<div id=\"forms\" class=\"page-layout simple tabbed off-white-bg\"><div class=\"content\" flex><div layout=\"row\" \nlayout-align=\"space-around\" class=\"whiteframedemoDirectiveInterpolation\" style=\"padding:24px\" \nng-show=\"$ctrl.whichPage === 0\"><div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" \nlayout-align=\"center center\" style=\"background: #fff;border-radius: 4px;position:relative;min-height:400px\"><div \nlayout=\"row\" style=\"margin-top:-10px\"><div layout=\"column\" layout-align=\"center center\" \nstyle=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px\">Search Users</div></div><div layout=\"column\" \nstyle=\"width: 300px;max-width: 300px;margin-top: 30px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nSearch by First Name</h1><div layout=\"row\"><md-input-container class=\"md-block\" md-no-float \nstyle=\"margin-top:0;margin-bottom: 0;width:250px\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.firstName\" placeholder=\"First Name\"></md-input-container><span \nstyle=\"padding-left: 5px;padding-top: 5px\"><span><img src=\"/assets/images/searchbutton.png\" \nstyle=\"cursor:pointer;width:30px;height:30px\" ng-click=\"$ctrl.searchByFirstName()\"></span></span></div></div><div \nlayout=\"column\" style=\"width: 300px;max-width: 300px;margin-top: 37px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nSearch by Last Name</h1><div layout=\"row\"><md-input-container class=\"md-block\" md-no-float \nstyle=\"margin-top:0;margin-bottom: 0;width:250px\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.lastName\" placeholder=\"Last Name\"></md-input-container><span \nstyle=\"padding-left: 5px;padding-top: 5px\"><span><img src=\"/assets/images/searchbutton.png\" \nstyle=\"cursor:pointer;width:30px;height:30px\" ng-click=\"$ctrl.searchByLastName()\"></span></span></div></div><div \nlayout=\"column\" layout-align=\"center center\" ng-show=\"$ctrl.searchResults && $ctrl.searchResults.length > 0\"><div \nstyle=\"margin: 10px;margin-top:30px\"><div class=\"tbl-header\"><table cellpadding=\"0\" cellspacing=\"0\" border=\"0\"><thead>\n<tr><th style=\"text-transform: none\">Title</th><th style=\"text-transform: none;width: 20%\">First Name</th><th \nstyle=\"text-transform: none;width: 20%\">Middle Name</th><th style=\"text-transform: none;width: 20%\">Last Name</th><th \nstyle=\"text-transform: none;width: 20%\"></th></tr></thead></table></div><div class=\"tbl-content\"><table \ncellpadding=\"0\" cellspacing=\"0\" border=\"0\"><tbody><tr \nng-repeat=\"orgUser in $ctrl.searchResults | filter: $ctrl.searchTerm track by $index\"><td>{{orgUser.title}}</td><td \nstyle=\"width: 20%;word-wrap:break-word\">{{orgUser.firstname}}</td><td style=\"width: 20%\">{{orgUser.middleNames}}</td>\n<td style=\"width: 20%\">{{orgUser.lastname}}</td><td style=\"text-align: end;width: 20%\"><md-button type=\"submit\" \nng-click=\"$ctrl.viewUser(orgUser)\" class=\"md-raised md-accent submit-button\" \nstyle=\"border-radius:5px;font-size: 12px;;text-transform: none !important\">VIEW</md-button></td></tr></tbody></table>\n</div></div></div></div></div><div layout=\"row\" layout-align=\"space-around\" \nclass=\"whiteframedemoDirectiveInterpolation\" style=\"padding:24px\" ng-show=\"$ctrl.whichPage === 1\"><div class=\"padded\" \nmd-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.cancel()\"></md-icon></div></div><div layout=\"column\" \nstyle=\"margin-top: 30px;width:100%\"><div layout=\"row\" \nstyle=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px;margin:auto\">User details</div><div><div layout=\"row\" \nstyle=\"height: 30px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto;margin-top: 30px\"><h1 \nstyle=\"font-size: 11px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;width: 100px;margin-top: -7px;margin-left: 43px;padding-left: 10px;background: white\">\nPersonal details</h1></div><div style=\"position: absolute;right:0;padding-top: 8px;padding-right: 23px\"><div \nlayout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-pencil-box-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.editPersonalDetails()\"></md-icon></div></div><div layout=\"row\" \nstyle=\"margin:auto;width: 90%\" ng-show=\"$ctrl.selectedUser.title\"><div layout=\"column\" \nstyle=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nTitle</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedUser.title\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nLast name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedUser.lastname\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\" ng-show=\"$ctrl.selectedUser.middleNames\"><div layout=\"column\" \nstyle=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nMiddle name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedUser.middleNames\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:100%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nFirst name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedUser.firstname\" placeholder=\"NA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nProfession</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedUser.profession\" placeholder=\"Profession\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nEmail</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedUser.email\" placeholder=\"Email\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:10%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nCountry Code</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" ng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedUser.region\" placeholder=\"\"></md-input-container></div><div layout=\"column\" \nstyle=\"margin-right:10px;width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nMobile</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedUser.mobile\" placeholder=\"Mobile\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\" ng-show=\"$ctrl.selectedUser.registrationId\"><div layout=\"column\" \nstyle=\"margin-right:10px;width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nAHPRA No</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nng-disabled=\"true\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 0px solid\" \nng-model=\"$ctrl.selectedUser.registrationId\" placeholder=\"AHPRA\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;width: 90%\" ng-show=\"$ctrl.selectedUser.registrationId\"><div layout=\"column\" \nstyle=\"margin-right:10px;width:50%\"><div style=\"display: flex;flex: 1\"><aside><div class=\"container\"><div \nclass=\"round\"><input id=\"roleOrgOwner\" value=\"true\" type=\"checkbox\" checked=\"true\" ng-disabled=\"true\"><label \nfor=\"roleOrgOwner\" style=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8;background-color: grey\">\n</label></div></div></aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nValid AHPRA</aside></div></div></div><div layout=\"row\" \nstyle=\"height: 30px;width: 90%;border-top: 1px solid #b8b8b8;margin: auto;margin-top: 45px\" \nng-show=\"$ctrl.showOrganisation\"><h1 \nstyle=\"font-size: 11px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #333333;margin-top: -7px;margin-left: 43px;padding-left: 10px;padding-right:10px;background: white\">\nAll Organisation details</h1></div><div layout=\"row\" style=\"margin:auto;width:90%\" \nng-repeat=\"(key, value) in $ctrl.selectedUserOrgMap\"><div layout=\"column\"><h1 \nstyle=\"font-size: 12px;font-weight: bold;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #92298C;margin-top:25px\">\n{{value.orgName}}</h1><div style=\"display: flex;flex: 1;margin-top: 8px\" ng-repeat=\"orgRole in value.allRoles\"><aside>\n<div class=\"container\"><div class=\"round\"><input id=\"inviteRoleOrgOwner\" value=\"true\" type=\"checkbox\" \nng-model=\"$ctrl.editInvitee.isOrgOwner\" ng-checked=\"true\" ng-disabled=\"true\"><label for=\"inviteRoleOrgOwner\" \nstyle=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8;background-color: grey\"></label></div></div>\n</aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\n{{orgRole===\'Creator\'? \'Clinician\' : orgRole === \'OrgOwner\' ? \'Organisation Owner\' : orgRole===\'OfficeAdmin\' ? \'Office Admin\' : orgRole}}\n</aside><div style=\"position: absolute;right:0;padding-top: 0px;padding-right: 23px\" ng-show=\"$index == 0\"><div \nlayout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-pencil-box-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.editRoles(key)\"></md-icon></div></div></div></div></div><div \nlayout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 30px\"></div></div></div></div></div><div layout=\"row\" \nlayout-align=\"space-around\" class=\"whiteframedemoDirectiveInterpolation\" style=\"padding:24px\" \nng-show=\"$ctrl.whichPage === 2\"><div class=\"padded\" md-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" \nlayout-align=\"center center\" style=\"background: #fff;border-radius: 4px;position:relative;min-height:400px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.cancelPersonalDetails()\"></md-icon></div></div><div \nlayout=\"column\" style=\"margin-top: 30px;width:100%\"><div layout=\"row\" \nstyle=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px;margin:auto\">Edit personal details</div><div><div \nlayout=\"row\" style=\"margin:auto;width: 90%\"><div layout=\"column\" style=\"width:15%;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nTitle</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0;margin-top: 7px\">\n<md-select type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.editTitle\" placeholder=\"Title\"><md-option value=\"Dr\">Dr</md-option><md-option value=\"Mr\">Mr</md-option>\n<md-option value=\"Mrs\">Mrs</md-option><md-option value=\"Ms\">Ms</md-option><md-option value=\"Miss\">Miss</md-option>\n<md-option value=\"Master\">Master</md-option><md-option value=\"Prof\">Prof</md-option><md-option value=\"A/Prof\">A/Prof\n</md-option><md-option value=\"Other\">Other</md-option></md-select></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nFirst name<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.editFirstName\" placeholder=\"First name\"></md-input-container></div></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"margin-right:10px;width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949;height:0px\">\nMiddle name</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0;margin-top: 7px\">\n<input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.editMiddleNames\" placeholder=\"Middle name\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"width:50%\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nLast name<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0;margin-top: 7px\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.editLastName\" placeholder=\"Last name\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"width:50%;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nProfession</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><md-select \ntype=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.editProfession\" placeholder=\"Profession\"><md-option \nvalue=\"Aboriginal and Torres Strait Islander Health Practitioner\">Aboriginal and Torres Strait Islander<br>\nHealth Practitioner</md-option><md-option value=\"Chinese Medicine Practitioner\">Chinese Medicine Practitioner\n</md-option><md-option value=\"Chiropractor\">Chiropractor</md-option><md-option value=\"Dental Practitioner\">\nDental Practitioner</md-option><md-option value=\"Medical Practitioner\">Medical Practitioner</md-option><md-option \nvalue=\"Medical Radiation Practitioner\">Medical Radiation Practitioner</md-option><md-option value=\"Midwife\">Midwife\n</md-option><md-option value=\"Nurse\">Nurse</md-option><md-option value=\"Occupational Therapist\">Occupational Therapist\n</md-option><md-option value=\"Optometrist\">Optometrist</md-option><md-option value=\"Osteopath\">Osteopath</md-option>\n<md-option value=\"Paramedic\">Paramedic</md-option><md-option value=\"Pathologist\">Pathologist</md-option><md-option \nvalue=\"Pharmacist\">Pharmacist</md-option><md-option value=\"Physiotherapist\">Physiotherapist</md-option><md-option \nvalue=\"Podiatrist\">Podiatrist</md-option><md-option value=\"Psychologist\">Psychologist</md-option><md-option \nvalue=\"Sonographer\">Sonographer</md-option><md-option value=\"Other\">Other</md-option></md-select></md-input-container>\n</div></div><div layout=\"row\" style=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"width:50%\"><h1\n \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nEmail<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container class=\"md-block\" \nmd-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.editEmail\" placeholder=\"Email\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" style=\"width:18%;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nCountry code<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><md-select \nclass=\"ng-pristine ng-valid md-default-theme ng-empty ng-touched\" tabindex=\"0\" aria-disabled=\"false\" role=\"listbox\" \naria-expanded=\"false\" aria-multiselectable=\"false\" placeholder=\"Country Code\" ng-model=\"$ctrl.editCountryCode\" \naria-owns=\"select_container_56\" aria-invalid=\"false\" aria-label=\"Select country code\"><md-option value=\"AU\">+61 AUS\n</md-option><md-option value=\"NZ\">+64 NZ</md-option><md-option value=\"IN\">+91 IND</md-option></md-select>\n</md-input-container></div><div layout=\"column\" style=\"width:28%;margin-left:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nMobile number<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0;padding-top:4px\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.editPhone\" placeholder=\"Mobile number\" ng-pattern=\"$ctrl.phoneNumberRegex()\"></md-input-container>\n</div></div><div layout=\"row\" style=\"margin:auto;margin-top:20px;width: 90%\"><div layout=\"column\" \nstyle=\"width:50%;margin-right:10px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nAHPRA Number.</h1><md-input-container class=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input \ntype=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.editAHPRA\" placeholder=\"AHPRA Number\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin:auto;width: 90%;margin-top:10px\"><div layout=\"column\" style=\"margin-right:10px;width:50%\"><div \nstyle=\"display: flex;flex: 1\"><aside><div class=\"container\"><div class=\"round\"><input id=\"validAHPRAEdit\" value=\"true\" \ntype=\"checkbox\" ng-model=\"$ctrl.editIsValidAHPRA\"><label for=\"validAHPRAEdit\" \nstyle=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8\"></label></div></div></aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nValid AHPRA</aside></div></div></div><div layout=\"row\" layout-align=\"center center\" \nstyle=\"margin-bottom: 30px;margin-top:20px\"><md-button type=\"submit\" ng-click=\"$ctrl.savePersonalDetails()\" \nclass=\"md-raised md-accent submit-button\" style=\"border-radius:5px;font-size: 12px;;text-transform: none !important\">\nSAVE</md-button></div></div></div></div></div><div layout=\"row\" layout-align=\"space-around\" \nclass=\"whiteframedemoDirectiveInterpolation\" style=\"padding:24px\" ng-show=\"$ctrl.whichPage === 3\"><div class=\"padded\" \nmd-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px\"><div \nstyle=\"position: absolute;top:0;right:0;padding-top: 8px;padding-right: 23px\"><div layout=\"column\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff;cursor:pointer\" ng-click=\"$ctrl.cancelEditRole()\"></md-icon></div></div><div layout=\"column\" \nstyle=\"margin-top: 30px;width:100%\"><div layout=\"row\" \nstyle=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px;margin:auto\">Edit roles</div><div><div layout=\"column\" \nstyle=\"margin:auto;width: 90%\"><h1 \nstyle=\"font-size: 12px;font-weight: bold;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #92298C;margin-top:25px\">\n{{$ctrl.selectedOrgName}}</h1><div style=\"display: flex;flex: 1;margin-top: 8px\"><aside><div class=\"container\"><div \nclass=\"round\"><input id=\"editOrgOwner\" value=\"true\" type=\"checkbox\" ng-checked=\"$ctrl.isOrgOwner\" \nng-model=\"$ctrl.isOrgOwner\"><label for=\"editOrgOwner\" \nstyle=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8\"></label></div></div></aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nOrganisation Owner</aside></div><div style=\"display: flex;flex: 1;margin-top: 8px\"><aside><div class=\"container\"><div \nclass=\"round\"><input id=\"editOfficeAdmin\" value=\"true\" type=\"checkbox\" ng-checked=\"$ctrl.isOfficeAdmin\" \nng-model=\"$ctrl.isOfficeAdmin\"><label for=\"editOfficeAdmin\" \nstyle=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8\"></label></div></div></aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nOffice Admin</aside></div><div style=\"display: flex;flex: 1;margin-top: 8px\"><aside><div class=\"container\"><div \nclass=\"round\"><input id=\"editCreator\" value=\"true\" type=\"checkbox\" ng-checked=\"$ctrl.isCreator\" \nng-model=\"$ctrl.isCreator\"><label for=\"editCreator\" \nstyle=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8\"></label></div></div></aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nClinician</aside></div><div style=\"display: flex;flex: 1;margin-top: 8px\"><aside><div class=\"container\"><div \nclass=\"round\"><input id=\"editMDTCoOrdinator\" value=\"true\" type=\"checkbox\" ng-checked=\"$ctrl.isMDTCoOrdinator\" \nng-model=\"$ctrl.isMDTCoOrdinator\"><label for=\"editMDTCoOrdinator\" \nstyle=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8\"></label></div></div></aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nMDT Co-Ordinator</aside></div><div style=\"display: flex;flex: 1;margin-top: 8px\"><aside><div class=\"container\"><div \nclass=\"round\"><input id=\"editMDTConference\" value=\"true\" type=\"checkbox\" ng-checked=\"$ctrl.isMDTConference\" \nng-model=\"$ctrl.isMDTConference\"><label for=\"editMDTConference\" \nstyle=\"border-radius: 4px;width:25px;height:25px;border: solid 1px #b8b8b8\"></label></div></div></aside><aside \nstyle=\"font-size: 12px;font-weight: normal;font-stretch: normal;font-style: normal;letter-spacing: 0.23px;color: #494949;padding-top: 6px;padding-left: 23px\">\nMDT Conference</aside></div></div><div layout=\"row\" layout-align=\"center center\" style=\"margin-bottom: 30px\"><md-button\n type=\"submit\" ng-click=\"$ctrl.saveRoleChanges()\" class=\"md-raised md-accent submit-button\" \nstyle=\"border-radius:5px;font-size: 12px;;text-transform: none !important\">SAVE</md-button></div></div></div></div>\n</div></div><style>\ntable{\n    width:100%;\n    table-layout: fixed;\n\n  }\n  table tr:hover {\n    background: #f4f4f4;\n  }\n  table tr:hover td {\n    color: #555;\n  }\n  .tbl-header{\n    background-color: rgba(255,255,255,0.3);\n  }\n  .tbl-content{\n    height:300px;\n    overflow-x:auto;\n    margin-top: 0px;\n    border: 1px solid rgba(255,255,255,0.3);\n  }\n  th{\n    padding: 20px 15px;\n    text-align: left;\n    font-weight: 500;\n    font-size: 12px;\n    color: #ffffff;\n    text-transform: uppercase;\n    background: #92298D;\n  }\n  td{\n    padding: 15px;\n    text-align: left;\n    vertical-align:middle;\n    font-weight: 300;\n    font-size: 12px;\n    color: #000;\n    border-bottom: solid 1px rgba(255,255,255,0.1);\n  }\n</style>");
$templateCache.put("app/main/clinician/people/people-add.html","<h2>Create a new contact</h2><div class=\"contact-form\"><div class=\"form-title\"><span>Enter phone number</span></div>\n<form name=\"numberForm\" class=\"contact-inputs\" layout-gt-sm=\"row\" novalidate><md-input-container class=\"country-code\">\n<md-select class=\"ng-pristine ng-valid md-default-theme ng-empty ng-touched\" tabindex=\"0\" aria-disabled=\"false\" \nrole=\"listbox\" aria-expanded=\"false\" aria-multiselectable=\"false\" placeholder=\"+61\" name=\"country\" \nng-model=\"countryCode\" id=\"country-code\" ng-model-options=\"{trackBy: \'$value\'}\" aria-owns=\"select_container_56\" \naria-invalid=\"false\" aria-label=\"select country code\"><md-option ng-value=\"+61\">+61</md-option><md-option \nng-value=\"+63\">+63</md-option><md-option ng-value=\"+64\">+64</md-option><md-option ng-value=\"+91\">+91</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\"><input name=\"phone\" id=\"phone-number\" \nng-model=\"phoneNumber\" placeholder=\"phone number\" number-blur required><div class=\"validation-messages\" \nng-messages=\"numberForm.phone.$error\"><div ng-message=\"required\">Phone number is required!</div><div \nng-message=\"number\">Phone number should be a number.</div><div ng-message=\"australia\">Not a valid number in Australia.\n</div><div ng-message=\"code\">Please select country code.</div><div ng-message=\"australiaLength\">The number is too long.\n</div></div></md-input-container></form></div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" aria-label=\"save contact\" type=\"submit\" \nstyle=\"text-transform: none !important;font-family: SFUIDisplay;font-size: 16px;font-weight: 500;font-style: normal;font-stretch: normal;letter-spacing: 0.3px\" \nng-disabled=\"numberForm.$invalid\" ng-click=\"next()\" ng-show=\"page==\'BEGIN\'\">Next</md-button></div><div \nclass=\"contact-exists\" ng-show=\"page==\'EXISTING_OUT_OF_CONTACTS\'\"><div class=\"exists-ribbon\"><span>\nThis contact already exists on Clinivid</span></div><clinician-people-detail></clinician-people-detail><div \nclass=\"case-button\" layout=\"row\" layout-align=\"center\" ng-click=\"connectWithUser(selectedContact)\"><md-button \nclass=\"md-accent md-raised md-hue-1\" ng-if=\"addContext==\'CONTEXT_CASE\'\">Select for case</md-button><md-button \nclass=\"md-accent md-raised md-hue-1\" ng-if=\"addContext==\'CONTEXT_CONTACTS\'\">Connect</md-button></div></div><div \nclass=\"contact-exists\" ng-show=\"page==\'EXISTING_IN_CONTACTS\'\"><div class=\"exists-ribbon\"><span>\nThis number is already in your contacts.</span></div><clinician-people-detail></clinician-people-detail><div \nclass=\"case-button\" layout=\"row\" layout-align=\"center\" ng-if=\"addContext==\'CONTEXT_CONTACTS\'\" \nng-click=\"createCase(selectedContact)\"><md-button class=\"md-accent md-raised md-hue-1\">Create a case</md-button></div>\n<div class=\"case-button\" layout=\"row\" layout-align=\"center\" ng-if=\"addContext==\'CONTEXT_CASE\'\" \nng-click=\"selectForCase(selectedContact)\"><md-button class=\"md-accent md-raised md-hue-1\">Select for case</md-button>\n</div></div><md-divider></md-divider><form name=\"contactForm\" id=\"contact-details\" novalidate \nng-show=\"page==\'NEW_CONTACT\'\"><div style=\"padding-left:17px\"><md-input-container flex=\"\" class=\"flex md-default-theme\">\n<label for=\"select_55\" class=\"md-placeholder\">Title</label><md-select ng-model=\"title\" name=\"title\" \nclass=\"ng-pristine ng-valid md-default-theme ng-empty ng-touched\" tabindex=\"0\" aria-disabled=\"false\" role=\"listbox\" \naria-expanded=\"false\" aria-multiselectable=\"false\" id=\"select_55\" aria-owns=\"select_container_56\" aria-invalid=\"false\" \naria-label=\"Title\"><md-option ng-value=\"title\" ng-repeat=\"title in $ctrl.context.titles\">{{ title }}</md-option>\n</md-select></md-input-container></div><div layout=\"column\" style=\"padding-right:17px;padding-left:17px\">\n<md-input-container flex=\"\" class=\"flex md-default-theme\"><input type=\"text\" name=\"firstname\" ng-model=\"firstname\" \nng-maxlength=\"50\" placeholder=\"First Name\" required><div class=\"validation-messages\" \nng-messages=\"contactForm.firstname\"><div ng-message=\"required\">First name is required!</div></div></md-input-container>\n<md-input-container flex=\"\" class=\"flex md-default-theme\"><input type=\"text\" name=\"lastname\" ng-model=\"lastname\" \nng-maxlength=\"50\" placeholder=\"Last Name\" required><div class=\"validation-messages\" ng-messages=\"contactForm.lastname\">\n<div ng-message=\"required\">Last name is required!</div></div></md-input-container><md-input-container flex=\"\" \nclass=\"flex md-default-theme\"><input type=\"text\" name=\"profession\" ng-model=\"profession\" placeholder=\"Profession\" \nng-maxlength=\"100\"><div ng-messages=\"contactForm.referenceNo.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"maxlength\"><span>Too many characters.</span></div></div></md-input-container><md-switch md-invert \nng-model=\"isLastNameChecked\" aria-label=\"last name switch\">Confirm spellings of last-name</md-switch></div><div \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" aria-label=\"save contact\" \ntype=\"submit\" \nstyle=\"text-transform: none !important;font-family: SFUIDisplay;font-size: 16px;font-weight: 500;font-style: normal;font-stretch: normal;letter-spacing: 0.3px\" \nng-disabled=\"contactForm.$invalid || !isLastNameChecked\" ng-click=\"saveNewContact()\">Save</md-button></div></form>");
$templateCache.put("app/main/clinician/people/people-detail.html","<div class=\"contact-container\"><aside class=\"caseCreatorLabel adjust\">\n{{selectedContact.title}} {{selectedContact.lastname}}, {{selectedContact.firstname}}<br><span \nclass=\"clinicianJobTitle\" style=\"font-style: normal\" ng-if=\"selectedContact.profession\">{{selectedContact.profession}}\n</span><br ng-if=\"selectedContact.profession\"><span class=\"clinicianOrganization\">\n{{$ctrl.getOrganization(selectedContact)}}</span></aside><md-divider \nng-if=\"selectedContact.firstname || selectedContact.lastname\"></md-divider><aside class=\"contact-details\"><div \nclass=\"contact-email\" ng-if=\"selectedContact.email\"><div class=\"label\">Email</div><div class=\"info\">\n{{ selectedContact.email }}</div></div><div class=\"contact-number\" ng-if=\"selectedContact.mobile\"><div class=\"label\">\nMobile No.</div><div class=\"info\">{{ selectedContact.mobile }}</div></div></aside><md-divider \nng-if=\"selectedContact.email || selectedContact.mobile\"></md-divider><aside class=\"contact-description\" \nng-if=\"selectedContact.availability\"><div class=\"title\"><span>Working at</span></div><p>\n{{$ctrl.getOrganization(selectedContact)}}</p></aside></div>");
$templateCache.put("app/main/clinician/people/people-edit.html","<form name=\"contactEditForm\" id=\"contact-edit-details\" novalidate><div style=\"padding-left:17px\"><md-input-container \nflex=\"\" class=\"flex md-default-theme\"><label for=\"select_55\" class=\"md-placeholder\">Title</label><md-select \nng-model=\"title\" name=\"title\" ng-model-options=\"{trackBy: \'$value\'}\" \nclass=\"ng-pristine ng-valid md-default-theme ng-empty ng-touched\" tabindex=\"0\" aria-disabled=\"false\" role=\"listbox\" \naria-expanded=\"false\" aria-multiselectable=\"false\" id=\"select_55\" aria-owns=\"select_container_56\" aria-invalid=\"false\" \naria-label=\"Title\"><md-option ng-value=\"title\" ng-repeat=\"title in $ctrl.context.titles\">{{ title }}</md-option>\n</md-select></md-input-container></div><div layout=\"column\" style=\"padding-right:17px;padding-left:17px\">\n<md-input-container flex=\"\" class=\"flex md-default-theme\"><input type=\"text\" name=\"firstname\" ng-model=\"firstname\" \nng-maxlength=\"50\" placeholder=\"First Name\" required><div class=\"validation-messages\" \nng-messages=\"ContactEditForm.firstname\"><div ng-message=\"required\">First name is required!</div></div>\n</md-input-container><md-input-container flex=\"\" class=\"flex md-default-theme\"><input type=\"text\" name=\"lastname\" \nng-model=\"lastname\" ng-maxlength=\"50\" placeholder=\"Last Name\" required><div class=\"validation-messages\" \nng-messages=\"ContactEditForm.lastname\"><div ng-message=\"required\">Last name is required!</div></div>\n</md-input-container><md-input-container flex=\"\" class=\"flex md-default-theme\"><input type=\"text\" name=\"profession\" \nng-model=\"profession\" placeholder=\"Profession\" ng-maxlength=\"100\"><div \nng-messages=\"ContactEditForm.referenceNo.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"maxlength\"><span>\nToo many characters.</span></div></div></md-input-container><md-input-container flex=\"\" class=\"flex md-default-theme\">\n<input type=\"text\" name=\"mobile\" ng-model=\"mobile\" ng-maxlength=\"50\" placeholder=\"Mobile\" disabled=\"disabled\">\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \naria-label=\"save contact\" type=\"submit\" \nstyle=\"text-transform: none !important;font-family: SFUIDisplay;font-size: 16px;font-weight: 500;font-style: normal;font-stretch: normal;letter-spacing: 0.3px\" \nng-disabled=\"ContactEditForm.$invalid\" ng-click=\"updateEditContact()\">Save</md-button></div></form>");
$templateCache.put("app/main/clinician/people/people.html","<div id=\"forms\" class=\"page-layout simple tabbed off-white-bg\" style=\"background-color: #f8f8f8\"><div class=\"content\" \nflex><div flex-xs=\"\" flex-gt-xs=\"100\" layout=\"column\" style=\"background-color: #f8f8f8\" layout-align=\"center center\">\n<md-card style=\"background-color: #ffffff; padding-bottom: 16px;width:510px\" class=\"ie-contacts\" \nng-show=\"$ctrl.currentPage==\'CONTACT_LIST\'\"><div class=\"registerAccountHeader\" layout=\"row\" layout-align=\"center\" \nstyle=\"padding-top: 6px;height: 35px\">All Contacts</div><md-divider></md-divider><div \nng-show=\"isLoadContactsAndGroupsComplete && !noContacts\" class=\"tabsdemoDynamicHeight\"><md-content><md-tabs \nmd-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"$ctrl.selectedContactsTabIndex\" md-swipe-content><md-tab \nng-repeat=\"role in $ctrl.howManytabsToShow()\" id=\"{{role.membershipId}}\" label=\"{{role.formattedOrganizationName}}\" \nmd-on-select=\"$ctrl.individualProfileTabClicked(role.membershipId)\"><md-content class=\"md-padding\" \nstyle=\"overflow-x: hidden\"><md-card-actions layout=\"row\" layout-align=\"end end\"><span \nng-show=\"$ctrl.elligibleToAddContact(role) && contactMap[role.membershipId].length > 0\"><span><img \nsrc=\"/assets/images/add-contact.png\" style=\"cursor:pointer\" ng-click=\"$ctrl.openAddContact()\"><md-tooltip \nclass=\"hide-xs\">Add a new contact</md-tooltip></span><span><img src=\"/assets/images/add-group.png\" \nstyle=\"margin-left: 24px;padding-bottom: 2px;cursor:pointer\" ng-click=\"$ctrl.openCreateGroupTab()\"><md-tooltip \nclass=\"hide-xs\">Create a group</md-tooltip></span></span></md-card-actions><md-card-actions layout=\"row\" \nlayout-align=\"start center\" style=\"margin-top: 10px;margin!bottom:30px\"><md-card-icon-actions><span \nclass=\"createpageHeaderButtons\"><input size=\"40\" type=\"text\" placeholder=\"Search a contact or group\" \nng-model=\"contactMap[role.membershipId].searchTerm\" ng-show=\"contactMap[role.membershipId].length > 0\" \nstyle=\"margin-left: 13px;background: #ffffff;padding:10px;border-radius:5px;-moz-border-radius:5px;-webkit-border-radius:5px;-o-border-radius:5px;border: 2px solid #92298D;width:208px\">\n</span></md-card-icon-actions></md-card-actions><div \nng-repeat=\"contact in contactMap[role.membershipId] | filter: contactMap[role.membershipId].searchTerm track by $index\" \nng-click=\"$ctrl.openViewContact(contact)\" class=\"contact-item\" name=\"contact-div\"><md-card-title \nclass=\"adjust-card-title\"><div style=\"display: flex;flex: 1\"><aside class=\"caseCreatorLabel adjust\"><span \nng-show=\"$ctrl.isContactAvailable(contact)\"><span id=\"availability_status\" ng-show=\"$ctrl.isContactAvailable(contact)\" \nstyle=\"height: 7px; width: 7px;background-color: #01d099;border-radius: 50%;display: inline-block;box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1)\">\n</span> <span ng-if=\"!$ctrl.isThisMe(contact)\">{{contact.title}} {{contact.lastname}}, {{contact.firstname}} <sup \nng-show=\"!contact.isInternalContact && !$ctrl.isThisMyPersonalAccount(contact)\" \nstyle=\"border-style: solid;border-width: 1px;font-weight: bold;font-size: 10px;color: #92298D;padding: 1px 5px;border-radius: 4px;border-color: #979797\">\nEXT </sup></span><span ng-if=\"$ctrl.isThisMe(contact)\">My Contact</span> </span><span \nng-show=\"!$ctrl.isContactAvailable(contact)\" style=\"padding-left:12px\">\n{{contact.title}} {{contact.lastname}}, {{contact.firstname}} <sup \nng-show=\"!contact.isInternalContact && !$ctrl.isThisMyPersonalAccount(contact)\" \nstyle=\"border-style: solid;border-width: 1px;font-weight: bold;font-size: 10px;color: #92298D;padding: 1px 5px;border-radius: 4px;border-color: #979797\">\nEXT</sup></span><br ng-show=\"contact.profession\"><span class=\"clinicianJobTitle\" style=\"padding-left:12px\">\n{{contact.profession}}</span><br><br></aside></div></md-card-title><md-divider ng-if=\"!$last\"></md-divider></div><div \nng-repeat=\"contact in $ctrl.getGroupsOfThisProfile(role.membershipId) | filter: contactMap[role.membershipId].searchTerm track by $index\" \nng-click=\"$ctrl.openViewGroup(contact)\" class=\"contact-item\" contact-menu \nng-show=\"contactMap[role.membershipId].length > 0\"><md-divider></md-divider><md-card-title class=\"adjust-card-title\">\n<div style=\"display: flex;flex: 1\"><aside class=\"caseCreatorLabel adjust\" style=\"padding-left:16px\">\n{{contact.aliasName}} <img src=\"/assets/images/group.png\" style=\"width: 20px;height:20px;padding-bottom: 2px\"><br><br>\n</aside></div></md-card-title></div><div ng-show=\"contactMap[role.membershipId].length <= 0\" layout=\"column\" \nclass=\"no-contacts\" layout-align=\"center center\"><span><h1>Lets add a Contact !</h1></span><br><span>\nAdd a contact with this button<br></span><span><img src=\"/assets/images/addcontact@3x.png\" \nstyle=\"width: 20px;cursor:pointer\" ng-click=\"$ctrl.openAddContact()\"></span><br><br><span><h1>This is your contact list\n<br></h1></span><span>It will list the contacts you add and those that send your chats </span><br><span>\nUsers receive notifications when you send a chat or message.</span><br><span>\nContacts who are not Clinivid users, receive and can view the chat via SMS link. They can respond after a free registration.\n</span><br></div></md-content></md-tab></md-tabs></md-content></div><div ng-show=\"!isLoadContactsAndGroupsComplete\">\n<div layout=\"row\" layout-align=\"center\" style=\"padding-top: 112px\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div class=\"sorryNoARPHA\" style=\"padding-top: 40px;font-size:20px;padding-bottom:180px\">\nPlease wait while we load your contacts</div></div><div ng-show=\"noContacts\"><div class=\"sorryNoARPHA\" \nstyle=\"padding-top: 40px;font-size:20px;padding-bottom:180px;padding-top: 180px\">\nYou do not have the permission to view contacts.Please contact your administrator or support@clinivid.com.au</div>\n</div><md-divider></md-divider><md-card-actions layout=\"row\" layout-align=\"center\"><div class=\"registerAccountFooter\">\nNeed help or have feedback? Contact: <a href=\"mailto:support@clinivid.com.au\">Support&nbsp<md-icon \nmd-font-icon=\"icon-email\" class=\"icon\" style=\"color:#92298C;margin-bottom: 2px\"></md-icon></a></div></md-card-actions>\n</md-card></div></div></div><md-sidenav class=\"md-sidenav-right ie-width-fix\" md-component-id=\"viewContact\" \nstyle=\"background-color: #ffffff\"><div style=\"display: flex; flex-flow: column; height: 100%;width: 483px\"><div>\n<md-toolbar layout=\"row\"><div class=\"md-toolbar-tools\" style=\"background-color:#92298C\"><md-button \nclass=\"md-icon-button\" aria-label=\"Close Side Panel\" ng-click=\"$ctrl.closeViewContact()\"><md-icon \nmd-font-icon=\"icon-close-circle-outline\" class=\"icon\" style=\"color:#FFFFFF\"></md-icon></md-button></div></md-toolbar>\n</div><div style=\"min-height: 0; flex: 1; overflow: auto\"><md-card-actions layout=\"row\" layout-align=\"center center\" \nstyle=\"margin-top:50px\"><md-card-icon-actions style=\"margin-right: 22px\" \nng-show=\"($ctrl.isMemberOwnerOfGroup() && !selectedContact.isLinked) || (selectedContact.isMyContact)\" \nid=\"editInLinkedContact\"><div layout=\"column\" layout-align=\"center center\" \nng-click=\"$ctrl.editYourNewClinividContact(selectedContact)\" style=\"cursor:pointer\"><div \nclass=\"action-icon-circular-div\" id=\"editUnlinkedContactEnclosingDiv\"><md-icon md-font-icon=\"icon-folder-plus\" \nclass=\"icon\" style=\"color: #92298D;padding-left: 6px;padding-top: 4px\" id=\"editUnlinkedContactIcon\"></md-icon></div>\n<strong class=\"action-icon-text\" style=\"margin-top: 4px\">Edit Contact</strong></div></md-card-icon-actions>\n<md-card-icon-actions style=\"margin-right: 22px\"><div layout=\"column\" layout-align=\"center center\" \nng-click=\"$ctrl.createCaseForSingleRecipient(selectedContact)\" style=\"cursor:pointer\"><div \nclass=\"action-icon-circular-div\"><md-icon md-font-icon=\"icon-folder-plus\" class=\"icon\" \nstyle=\"color: #92298D;padding-left: 6px;padding-top: 4px\"></md-icon></div><strong class=\"action-icon-text\" \nstyle=\"margin-top: 4px\">Create Chat</strong></div></md-card-icon-actions><div layout=\"column\" \nlayout-align=\"center center\" name=\"delete-button\" ng-click=\"$ctrl.deleteIndividualContact(selectedContact)\" \nstyle=\"cursor:pointer;margin-right: 22px\" ng-show=\"$ctrl.isMemberOwnerOfGroup() && !selectedContact.isMyContact\"><div \nclass=\"action-icon-circular-div\"><md-icon md-font-icon=\"icon-trash\" class=\"icon\" \nstyle=\"color: #92298D;padding-left: 6px;padding-top: 4px\"></md-icon></div><strong class=\"action-icon-text\" \nstyle=\"margin-top: 4px\">Delete Contact</strong></div></md-card-actions><div class=\"contact-container\" \nstyle=\"margin-left: 24px;margin-right: 24px;margin-top:100px\" ng-show=\"!$ctrl.showEditUnlinkedContactSection\"><aside \nclass=\"caseCreatorLabel adjust\">{{selectedContact.title}} {{selectedContact.lastname}}, {{selectedContact.firstname}}\n<br><span class=\"clinicianJobTitle\" style=\"font-style: normal\" ng-if=\"selectedContact.profession\">\n{{selectedContact.profession}}</span><br ng-if=\"selectedContact.profession\"><span class=\"clinicianOrganization\">\n{{$ctrl.getOrganization(selectedContact)}}</span></aside><md-divider \nng-if=\"selectedContact.firstname || selectedContact.lastname\"></md-divider><aside class=\"contact-details\"><div \nclass=\"contact-email\" ng-if=\"selectedContact.email\"><div class=\"label\">Email</div><div class=\"info\">\n{{ selectedContact.email }}</div></div><div class=\"contact-number\" ng-if=\"selectedContact.mobile\"><div class=\"label\">\nMobile No.</div><div class=\"info\">{{ selectedContact.mobile }}</div></div></aside><md-divider \nng-if=\"selectedContact.email || selectedContact.mobile\"></md-divider><aside class=\"contact-description\" \nng-if=\"selectedContact.availability\"><div class=\"label\" style=\"margin-top: 10px\"><span \nstyle=\"color: gray;font-size: 0.9em\">Working at</span></div><div class=\"info\" ng-show=\"selectedContact.isLinked\">\n{{$ctrl.getOrganization(selectedContact)}}</div><div class=\"info\" ng-show=\"!selectedContact.isLinked\">n/a</div></aside>\n</div><div layout=\"row\" layout-align=\"center center\" \nng-show=\"$ctrl.showEditUnlinkedContactSection && !selectedContact.isLinked\" style=\"margin-top: 36px\"><form \nname=\"editUnLinkedContactForm\" id=\"editUnLinkedContactFormId\" novalidate><div style=\"padding-left:17px\">\n<md-input-container flex=\"\" class=\"flex md-default-theme\"><label for=\"editContactTitle\" class=\"md-placeholder\">Title\n</label><md-select ng-model=\"$ctrl.editUnlinkedContact.title\" name=\"title\" \nclass=\"ng-pristine ng-valid md-default-theme ng-empty ng-touched\" tabindex=\"0\" aria-disabled=\"false\" role=\"listbox\" \naria-expanded=\"false\" aria-multiselectable=\"false\" id=\"editContactTitle\" aria-owns=\"select_container_56\" \naria-invalid=\"false\" aria-label=\"Title\"><md-option value=\"Dr\">Dr</md-option><md-option value=\"Mr\">Mr</md-option>\n<md-option value=\"Mrs\">Mrs</md-option><md-option value=\"Ms\">Ms</md-option><md-option value=\"Miss\">Miss</md-option>\n<md-option value=\"Master\">Master</md-option><md-option value=\"Prof\">Prof</md-option><md-option value=\"A/Prof\">A/Prof\n</md-option><md-option value=\"Other\">Other</md-option></md-select></md-input-container></div><div layout=\"column\" \nstyle=\"padding-right:17px;padding-left:17px\"><md-input-container flex=\"\" class=\"flex md-default-theme\"><input \ntype=\"text\" name=\"firstname\" ng-model=\"$ctrl.editUnlinkedContact.firstname\" ng-maxlength=\"50\" placeholder=\"First name\" \nrequired><div class=\"validation-messages\" ng-messages=\"editUnLinkedContactForm.firstname\"><div ng-message=\"required\">\nFirst name is required.</div></div></md-input-container><md-input-container flex=\"\" class=\"flex md-default-theme\">\n<input type=\"text\" name=\"lastname\" ng-model=\"$ctrl.editUnlinkedContact.lastname\" ng-maxlength=\"50\" \nplaceholder=\"Last name\" required><div class=\"validation-messages\" ng-messages=\"editUnLinkedContactForm.lastname\"><div \nng-message=\"required\">Last name is required</div></div></md-input-container><md-input-container flex=\"\" \nclass=\"flex md-default-theme\"><label for=\"editContactProfession\" class=\"md-placeholder\">Select their profession</label>\n<md-select name=\"profession\" id=\"editContactProfession\" ng-model=\"$ctrl.editUnlinkedContact.profession\" \nclass=\"ng-pristine ng-valid md-default-theme ng-empty ng-touched\" ng-change=\"$ctrl.appendRegistrationPrefix()\">\n<md-option value=\"Aboriginal and Torres Strait Islander Health Practitioner\">Aboriginal and Torres Strait Islander<br>\nHealth Practitioner</md-option><md-option value=\"Chinese Medicine Practitioner\">Chinese Medicine Practitioner\n</md-option><md-option value=\"Chiropractor\">Chiropractor</md-option><md-option value=\"Dental Practitioner\">\nDental Practitioner</md-option><md-option value=\"Medical Practitioner\">Medical Practitioner</md-option><md-option \nvalue=\"Medical Radiation Practitioner\">Medical Radiation Practitioner</md-option><md-option value=\"Midwife\">Midwife\n</md-option><md-option value=\"Nurse\">Nurse</md-option><md-option value=\"Occupational Therapist\">Occupational Therapist\n</md-option><md-option value=\"Optometrist\">Optometrist</md-option><md-option value=\"Osteopath\">Osteopath</md-option>\n<md-option value=\"Paramedic\">Paramedic</md-option><md-option value=\"Pathologist\">Pathologist</md-option><md-option \nvalue=\"Pharmacist\">Pharmacist</md-option><md-option value=\"Physiotherapist\">Physiotherapist</md-option><md-option \nvalue=\"Podiatrist\">Podiatrist</md-option><md-option value=\"Psychologist\">Psychologist</md-option><md-option \nvalue=\"Sonographer\">Sonographer</md-option><md-option value=\"Other\">Other</md-option></md-select></md-input-container>\n</div><div layout=\"row\" layout-align=\"center center\" style=\"margin-top: 17px\"><md-input-container \nclass=\"person-country-code\"><label for=\"editUnlinkedContactCountryCode\" class=\"md-placeholder\">Country code</label>\n<md-select class=\"ng-pristine ng-valid md-default-theme ng-empty ng-touched\" id=\"editUnlinkedContactCountryCode\" \ntabindex=\"0\" aria-disabled=\"false\" role=\"listbox\" aria-expanded=\"false\" aria-multiselectable=\"false\" \nng-model=\"$ctrl.editUnlinkedContact.region\" ng-disabled=\"$ctrl.editUnlinkedContact.profession.isLinked\"><md-option \nvalue=\"AU\">+61 AUS</md-option><md-option value=\"NZ\">+64 NZ</md-option><md-option value=\"IN\">+91 IND</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\"><input name=\"phone\" \nstyle=\"border: none;width: 178px;border-bottom: 1px solid #d3d3d3;border-radius: 8px;padding: 4px;position: relative\" \nng-model=\"$ctrl.editUnlinkedContact.mobile\" placeholder=\" Mobile number\" \nng-disabled=\"$ctrl.editUnlinkedContact.profession.isLinked\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\" style=\"margin-top: 36px\"><md-button class=\"md-raised md-accent\" aria-label=\"save contact\" \ntype=\"submit\" \nstyle=\"text-transform: none !important;font-family: Roboto;font-size: 16px;font-weight: 500;font-style: normal;font-stretch: normal;letter-spacing: 0.3px;border-radius: 6px\" \nng-disabled=\"editUnLinkedContactForm.$invalid || editUnLinkedContactForm.$pristine\" \nng-click=\"$ctrl.saveChangesInUnlinkedClinividContact()\">Save</md-button></div></form></div></div></div></md-sidenav>\n<md-sidenav class=\"md-sidenav-right ie-width-fix\" md-component-id=\"viewGroup\" style=\"background-color: #ffffff\"><div \nstyle=\"display: flex; flex-flow: column; height: 100%\"><div><md-toolbar layout=\"row\"><div class=\"md-toolbar-tools\" \nstyle=\"background-color:#92298C\"><md-button class=\"md-icon-button\" aria-label=\"Close Side Panel\" \nng-click=\"$ctrl.closeViewGroup()\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" style=\"color:#FFFFFF\">\n</md-icon></md-button></div></md-toolbar></div><div style=\"min-height: 0; flex: 1; overflow: auto\"><md-card-actions \nlayout=\"row\" layout-align=\"center center\" style=\"margin-top:25px;margin-left:10px\" \nng-show=\"!$ctrl.$scope.editingGroupNameInProgress\"><md-card-icon-actions style=\"margin-right: 22px\"><div \nlayout=\"column\" layout-align=\"center center\" ng-click=\"$ctrl.addContact()\" style=\"cursor:pointer\" \nng-show=\"$ctrl.isMemberOwnerOfGroup()\"><div class=\"action-icon-circular-div\" id=\"addGroupEnclosingDiv\"><md-icon \nmd-font-icon=\"icon-account-plus\" class=\"icon\" style=\"color: #92298D;padding-left: 6px;padding-top: 4px\" \nid=\"addGroupIcon\"></md-icon></div><strong class=\"action-icon-text\" style=\"margin-top: 4px\">Add Contacts</strong></div>\n</md-card-icon-actions><md-card-icon-actions style=\"margin-right: 22px\" \nng-show=\"selectedGroup && selectedGroup[\'groupMembers\'] && selectedGroup[\'groupMembers\'].length >0\"><div \nlayout=\"column\" layout-align=\"center center\" ng-click=\"$ctrl.createCaseForEntireGroup(selectedGroup)\" \nstyle=\"cursor:pointer\"><div class=\"action-icon-circular-div\"><md-icon md-font-icon=\"icon-folder-plus\" class=\"icon\" \nstyle=\"color: #92298D;padding-left: 6px;padding-top: 4px\"></md-icon></div><strong class=\"action-icon-text\" \nstyle=\"margin-top: 4px\">Create Chat</strong></div></md-card-icon-actions><div layout=\"column\" \nlayout-align=\"center center\" ng-click=\"$ctrl.deleteGroup(selectedGroup)\" style=\"cursor:pointer;margin-right: 22px\" \nng-show=\"$ctrl.isMemberOwnerOfGroup()\"><div class=\"action-icon-circular-div\"><md-icon md-font-icon=\"icon-trash\" \nclass=\"icon\" style=\"color: #92298D;padding-left: 6px;padding-top: 4px\"></md-icon></div><strong \nclass=\"action-icon-text\" style=\"margin-top: 4px\">Delete Group</strong></div></md-card-actions><div \nclass=\"contact-container\" style=\"margin-left: 24px;margin-right: 24px;margin-top:50px\"><div class=\"label\" \nstyle=\"margin-bottom: 5px\">Group Name <img src=\"/assets/images/edit-group.png\" \nstyle=\"height: 16px;cursor:pointer;margin-left: 10px\" ng-click=\"$ctrl.editGroupName()\" \nng-show=\"!$ctrl.$scope.editingGroupNameInProgress && $ctrl.isMemberOwnerOfGroup()\"> <span \nstyle=\"color: #0899ff;font-family: Roboto;font-style: normal;font-stretch: normal;line-height: normal;letter-spacing: 0.1px;font-size: 13px;font-weight: 500;cursor:pointer\" \nng-click=\"$ctrl.editGroupName()\" ng-show=\"!$ctrl.$scope.editingGroupNameInProgress && $ctrl.isMemberOwnerOfGroup()\">\nEdit</span></div><aside class=\"caseCreatorLabel adjust\" style=\"color:#030303;min-width: 400px\" \nng-show=\"!$ctrl.$scope.editingGroupNameInProgress\">{{selectedGroup.aliasName}}<br></aside><aside \nstyle=\"min-width: 400px\" ng-show=\"$ctrl.$scope.editingGroupNameInProgress\"><div layout=\"row\" \nlayout-align=\"center center\" style=\"height:50px\"><input type=\"text\" placeholder=\"Enter new group name\" \nng-model=\"newGroupName\" \nstyle=\"margin-left: 40px;background: rgb(255, 255, 255);padding: 10px;border-radius: 5px;border: 2px solid rgb(146, 41, 141);width: 300px\">\n <img src=\"/assets/images/purple-close-circle.png\" style=\"width:33px;margin-right:13px;cursor:pointer\" \nng-click=\"$ctrl.clearGroupName()\"></div></aside><div layout-align=\"center center\" layout=\"row\" \nstyle=\"margin-bottom: 40px;margin-top: 40px\" ng-show=\"$ctrl.$scope.editingGroupNameInProgress\"><md-button \nclass=\"md-raised md-accent\" aria-label=\"save contact\" type=\"submit\" name=\"next-button\" \nstyle=\"text-transform: none !important;font-family: Roboto;font-size: 16px;font-weight: 500;font-style: normal;font-stretch: normal;letter-spacing: 0.3px;border-radius: 6px\" \nng-disabled=\"!newGroupName\" ng-click=\"$ctrl.changeGroupName(selectedGroup)\">Save</md-button><md-button \nclass=\"md-raised md-accent\" name=\"next-button\" \nstyle=\"text-transform: none !important;font-family: Roboto;font-size: 16px;font-weight: 500;font-style: normal;font-stretch: normal;letter-spacing: 0.3px;border-radius: 6px\" \nng-click=\"$ctrl.cancelGroupNameChange()\">Cancel</md-button></div><md-divider></md-divider><div id=\"addContactSection\" \nstyle=\"margin-top: 36px\" ng-show=\"$ctrl.showAddContactSectionForGroup && !$ctrl.$scope.editingGroupNameInProgress\">\n<md-chips ng-model=\"$ctrl.chipEditGroup\" md-autocomplete-snap=\"\" md-transform-chip=\"$ctrl.transformChip($chip)\" \nmd-require-match=\"true\"><md-autocomplete md-selected-item=\"$ctrl.selectedItemChipEdit\" md-no-cache=\"true\" \nmd-search-text=\"$ctrl.searchTextChip\" md-items=\"item in $ctrl.queryContactSearchGroupAdd($ctrl.searchTextChip)\" \nmd-item-text=\"item.fullName\" placeholder=\"Add contact\" md-menu-class=\"autocomplete-custom-template\" \nmd-menu-container-class=\"custom-container\" md-min-length=\"0\"><md-item-template><span class=\"item-title\"><span>\n{{item.fullName}} </span></span><span class=\"profession\"><span>{{item.profession}}</span> </span><span \nclass=\"item-metadata\"><span>{{item.formattedOrganizationName}}</span></span></md-item-template><md-not-found>\nNo contacts to add.</md-not-found></md-autocomplete><md-chip-template><span><strong \nstyle=\"font-size: 15px;font-weight: bold\">{{$chip.fullName}}</strong></span></md-chip-template><button \nmd-chip-remove=\"\" style=\"margin-right: 9px;margin-top: 7px\">&times;</button></md-chips><div layout=\"row\" \nlayout-align=\"center center\" ng-show=\"$ctrl.chipEditGroup.length > 0\"><md-button class=\"md-raised md-accent\" \naria-label=\"Add Contact\" \nstyle=\"text-transform: none !important;font-family: Roboto;font-size: 16px;font-weight: 500;font-style: normal;font-stretch: normal;letter-spacing: 0.3px;border-radius: 6px;margin-top: 32px\" \nng-click=\"$ctrl.addGroupMember()\">&#43; Add</md-button></div></div><div \nng-show=\"!$ctrl.showNoContactsInGroup && !$ctrl.$scope.editingGroupNameInProgress\" id=\"groupDetails\"><div class=\"row\" \nstyle=\"margin-top: 40px\"><md-card-actions layout=\"row\" layout-align=\"center center\" \nng-show=\"!$ctrl.showSpinnerOnGroupDetailsPage\"><md-card-icon-actions><span class=\"createpageHeaderButtons\"><input \nsize=\"40\" type=\"text\" placeholder=\"Search\" ng-model=\"searchWord\" \nstyle=\"background: #ffffff;padding:10px;border-radius:5px;-moz-border-radius:5px;-webkit-border-radius:5px;-o-border-radius:5px;border: 2px solid #92298D;width:208px;margin-bottom: 13px\">\n<md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" style=\"color:#92298D;cursor:pointer\" ng-if=\"searchWord\" \nng-click=\"$ctrl.clearGroupSearch()\"></md-icon></span></md-card-icon-actions></md-card-actions><div \nclass=\"col-sm-6 mt-3 mr-auto ml-auto\"><div class=\"chips chips-initial input-field\" \nng-repeat=\"member in $ctrl.getSortedGroupMembers(selectedGroup) | filter:{displayName:searchWord}\"><div class=\"chip\">\n{{member.displayName}} <span class=\"closebtn\" ng-click=\"$ctrl.removeGroupMember(member)\" style=\"margin-left: 5px\" \nng-show=\"$ctrl.isMemberOwnerOfGroup()\">&times;</span></div><input type=\"text\" class=\"chip-input\" id=\"chip-input\" \nreadonly=\"readonly\"></div></div></div></div><div \nng-show=\"$ctrl.showNoContactsInGroup && $ctrl.isMemberOwnerOfGroup() && !$ctrl.$scope.editingGroupNameInProgress\" \nid=\"defaultNoContactSection\"><div layout=\"column\" class=\"no-contacts\" layout-align=\"center center\"><span><h1>\nLet\'s add a contact!</h1></span><br><span>Add a contact with this button</span><div layout=\"column\" \nlayout-align=\"center center\" ng-click=\"$ctrl.addContact()\" style=\"cursor:pointer\"><div \nclass=\"action-icon-circular-div\"><md-icon md-font-icon=\"icon-account-plus\" class=\"icon\" \nstyle=\"color: #92298D;padding-left: 6px;padding-top: 4px\"></md-icon></div><strong class=\"action-icon-text\" \nstyle=\"margin-top: 4px\">Add Contacts</strong></div></div></div><md-card-title \nng-show=\"$ctrl.showNoContactsInGroup && !$ctrl.isMemberOwnerOfGroup() && !$ctrl.$scope.editingGroupNameInProgress\">\n<md-card-title-text><div class=\"clinividTags\" tabindex=\"-1\" id=\"scripted\" style=\"margin-top:30px\"><div><img \nsrc=\"assets/images/info.png\" style=\"padding-top: 8px;margin-right: 5px\"> This group has no members</div></div>\n</md-card-title-text></md-card-title><div layout=\"row\" layout-align=\"center\" \nng-show=\"$ctrl.showSpinnerOnGroupDetailsPage\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div></div></div></div></md-sidenav><md-sidenav class=\"md-sidenav-right\" md-component-id=\"addContact\" \nstyle=\"background-color: #ffffff\"><div style=\"display: flex; flex-flow: column; height: 100%\"><div><md-toolbar \nlayout=\"row\"><div class=\"md-toolbar-tools\"></div></md-toolbar></div><md-card-actions layout=\"row\" \nlayout-align=\"start start\"><span><md-button class=\"md-icon-button\" aria-label=\"Close Side Panel\" \nng-click=\"$ctrl.closeAddContact()\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#0899ff\"></md-icon></md-button></span></md-card-actions><div \nstyle=\"min-height: 0; flex: 1; overflow: auto;width: 483px\"><div style=\"margin-left:24px;margin-right:24px\"><div \nclass=\"registerAccountHeader\" style=\"margin-top:20px;font-size: 18px\" name=\"newContactPanelHeader\">Add new contact\n</div></div><div style=\"display: flex;flex: 1;margin-left:40px;margin-top: 30px\"><aside><div class=\"container\"><div \nclass=\"round\"><input type=\"checkbox\" id=\"addByMobileNumber\" ng-click=\"$ctrl.toggleAddContact(\'PHONE\')\" \nng-disabled=\"$ctrl.isAddContactinProgress\"><label for=\"addByMobileNumber\"></label></div></div></aside><aside \nclass=\"caseCreatorLabel\" style=\"padding-top:4px;padding-left:23px;font-size: 14px\">Add a contact by mobile number\n</aside></div><div style=\"display: flex;flex: 1;margin-left:40px;margin-top: 20px\"><aside><div class=\"container\"><div \nclass=\"round\"><input type=\"checkbox\" id=\"addByEmail\" ng-click=\"$ctrl.toggleAddContact(\'EMAIL\')\" \nng-disabled=\"$ctrl.isAddContactinProgress\"><label for=\"addByEmail\" name=\"add-by-email\"></label></div></div></aside>\n<aside class=\"caseCreatorLabel\" style=\"padding-top:4px;padding-left:23px;font-size: 14px\">Add a contact by email\n</aside></div><form name=\"personForm\" class=\"contact-inputs\" novalidate><div layout=\"row\" layout-align=\"center\" \nstyle=\"margin-top: 35px\" ng-show=\"addContactMode ==\'PHONE\'\"><md-input-container class=\"person-country-code\"><md-select \nclass=\"ng-pristine ng-valid md-default-theme ng-empty ng-touched\" tabindex=\"0\" aria-disabled=\"false\" role=\"listbox\" \naria-expanded=\"false\" aria-multiselectable=\"false\" placeholder=\"Country code\" \nng-model=\"$ctrl.newContactForm.countryCode\" id=\"country-code\" aria-owns=\"select_container_56\" aria-invalid=\"false\" \naria-label=\"Select country code\" ng-disabled=\"$ctrl.isAddContactinProgress\"><md-option value=\"AU\" selected=\"true\">\n+61 AUS</md-option><md-option value=\"NZ\">+64 NZ</md-option><md-option value=\"IN\">+91 IND</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\"><input name=\"add-phone-contact\" \nstyle=\"border: none;width: 178px;border-bottom: 1px solid #d3d3d3;border-radius: 8px;padding: 4px;position: relative\" \nng-model=\"$ctrl.newContactForm.phoneNumber\" placeholder=\" Mobile number\" number-blur \nng-required=\"addContactMode ==\'PHONE\'\" ng-pattern=\"$ctrl.phoneNumberRegex()\" \nng-disabled=\"$ctrl.isAddContactinProgress\"><div class=\"validation-messages\" ng-messages=\"personForm.phone.$error\"><div \nng-message=\"required\">Mobile Number is required.</div><div ng-message=\"pattern\">Not a valid phone number.</div></div>\n</md-input-container></div><div layout=\"row\" layout-align=\"center\" style=\"margin-top: 35px\" \nng-show=\"addContactMode ==\'EMAIL\'\"><md-input-container class=\"md-block\"><input name=\"email\" \nstyle=\"border: none;width: 325px;border-bottom: 1px solid #d3d3d3;border-radius: 8px;padding: 4px;position: relative\" \nng-model=\"$ctrl.newContactForm.email\" ng-required=\"addContactMode ==\'EMAIL\'\" placeholder=\"Email\" \nng-pattern=\"/^.+@.+\\..+$/\" ng-disabled=\"$ctrl.isAddContactinProgress\"><div class=\"validation-messages\" \nng-messages=\"personForm.email.$error\"><div ng-message=\"required\">Email is required.</div><div ng-message=\"pattern\">\nEmail must be a valid e-mail address.</div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\" id=\"nextButtonCheckPhoneNumber\"><md-button class=\"md-raised md-accent\" \naria-label=\"save contact\" type=\"submit\" name=\"next-button\" \nstyle=\"text-transform: none !important;font-family: Roboto;font-size: 16px;font-weight: 500;font-style: normal;font-stretch: normal;letter-spacing: 0.3px;border-radius: 6px\" \nng-disabled=\"personForm.$invalid\" ng-show=\"nextButtonCheckPhoneNumberShow\" ng-click=\"$ctrl.checkPhoneNumber()\">Next\n</md-button></div><div layout=\"row\" layout-align=\"center\" style=\"padding-top: 112px\" \nng-show=\"$ctrl.checkinPhoneNumberInProgres\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div>\n</form><div id=\"contactExists\" ng-show=\"$ctrl.newContactForm.systemCheckForPhoneNumber\"><div class=\"contact-exists\" \nstyle=\"margin-top:40px\" layout=\"row\" layout-align=\"center center\"><div class=\"exists-ribbon\"><span>\nThis contact already exists on Clinivid</span></div></div><div class=\"contact-container\" \nstyle=\"margin-left: 24px;margin-right: 24px;margin-top:60px\"><aside class=\"caseCreatorLabel adjust\">\n{{$ctrl.newContactForm.systemCheckForPhoneNumber.title}} {{$ctrl.newContactForm.systemCheckForPhoneNumber.lastname}} {{$ctrl.newContactForm.systemCheckForPhoneNumber.firstname}}\n<br><span class=\"clinicianJobTitle\" style=\"font-style: normal\" \nng-if=\"$ctrl.newContactForm.systemCheckForPhoneNumber.profession\">\n{{$ctrl.newContactForm.systemCheckForPhoneNumber.profession}}</span><br \nng-if=\"$ctrl.newContactForm.systemCheckForPhoneNumber.profession\"><span class=\"clinicianOrganization\">\n{{$ctrl.getOrganization($ctrl.newContactForm.systemCheckForPhoneNumber)}}</span></aside><md-divider \nng-if=\"$ctrl.newContactForm.systemCheckForPhoneNumber.firstname || $ctrl.newContactForm.systemCheckForPhoneNumber.lastname\">\n</md-divider><aside class=\"contact-details\"><div class=\"contact-email\" \nng-if=\"$ctrl.newContactForm.systemCheckForPhoneNumber.email\"><div class=\"label\">Email</div><div class=\"info\">\n{{ $ctrl.newContactForm.systemCheckForPhoneNumber.email }}</div></div><div class=\"contact-number\" \nng-if=\"$ctrl.newContactForm.systemCheckForPhoneNumber.mobile\"><div class=\"label\">Mobile No.</div><div class=\"info\">\n{{ $ctrl.newContactForm.systemCheckForPhoneNumber.mobile }}</div></div></aside><md-divider \nng-if=\"$ctrl.newContactForm.systemCheckForPhoneNumber.email || $ctrl.newContactForm.systemCheckForPhoneNumber.mobile\">\n</md-divider><aside class=\"contact-description\" ng-if=\"$ctrl.newContactForm.systemCheckForPhoneNumber.availability\">\n<div class=\"title\"><span>Working at</span></div><p>\n{{$ctrl.getOrganization($ctrl.newContactForm.systemCheckForPhoneNumber)}}</p></aside></div><div class=\"case-button\" \nlayout=\"row\" layout-align=\"center\"><md-button class=\"md-accent md-raised md-hue-1\" style=\"border-radius: 6px\" \nng-click=\"$ctrl.cancelContactAdd()\">Cancel</md-button><md-button class=\"md-accent md-raised md-hue-1\" \nng-click=\"$ctrl.connectWithClinividUser($ctrl.newContactForm.systemCheckForPhoneNumber)\" style=\"border-radius: 6px\">\nConnect</md-button></div></div><div id=\"contactExistsSection\" ng-show=\"$ctrl.doesContactAlreadyexist\"><div \nclass=\"contact-exists\" style=\"margin-top:40px\" layout=\"row\" layout-align=\"center center\"><div class=\"exists-ribbon\">\n<span>This number is already in your contacts.</span></div></div><div class=\"case-button\" layout=\"row\" \nlayout-align=\"center\"><md-button class=\"md-accent md-raised md-hue-1\" style=\"border-radius: 6px\" \nng-click=\"$ctrl.resetAddContactForm()\">Reset</md-button></div></div><div id=\"newUserForm\" \nng-show=\"$ctrl.isContactNewUser\"><div layout=\"row\" layout-align=\"center center\"><form name=\"contactForm\" \nid=\"contact-details\" novalidate><div style=\"padding-left:17px\"><md-input-container flex=\"\" \nclass=\"flex md-default-theme\"><label for=\"select_55\" class=\"md-placeholder\">Title</label><md-select \nng-model=\"$ctrl.newContactForm.title\" name=\"title\" class=\"ng-pristine ng-valid md-default-theme ng-empty ng-touched\" \ntabindex=\"0\" aria-disabled=\"false\" role=\"listbox\" aria-expanded=\"false\" aria-multiselectable=\"false\" id=\"select_55\" \naria-owns=\"select_container_56\" aria-invalid=\"false\" aria-label=\"Title\"><md-option value=\"Dr\">Dr</md-option><md-option \nvalue=\"Mr\">Mr</md-option><md-option value=\"Mrs\">Mrs</md-option><md-option value=\"Ms\">Ms</md-option><md-option \nvalue=\"Miss\">Miss</md-option><md-option value=\"Master\">Master</md-option><md-option value=\"Prof\">Prof</md-option>\n<md-option value=\"A/Prof\">A/Prof</md-option><md-option value=\"Other\">Other</md-option></md-select></md-input-container>\n</div><div layout=\"column\" style=\"padding-right:17px;padding-left:17px\"><md-input-container flex=\"\" \nclass=\"flex md-default-theme\"><input type=\"text\" name=\"contact-firstName\" ng-model=\"$ctrl.newContactForm.firstname\" \nng-maxlength=\"50\" placeholder=\"First name\" required><div class=\"validation-messages\" \nng-messages=\"contactForm.firstname\"><div ng-message=\"required\">First name is required.</div></div></md-input-container>\n<md-input-container flex=\"\" class=\"flex md-default-theme\"><input type=\"text\" name=\"contact-lastName\" \nng-model=\"$ctrl.newContactForm.lastname\" ng-maxlength=\"50\" placeholder=\"Last name\" required><div \nclass=\"validation-messages\" ng-messages=\"contactForm.lastname\"><div ng-message=\"required\">Last name is required</div>\n</div></md-input-container><md-input-container flex=\"\" class=\"flex md-default-theme\"><label \nfor=\"professionNewOfContact\" class=\"md-placeholder\">Select their profession</label><md-select name=\"profession\" \nid=\"professionNewOfContact\" ng-model=\"$ctrl.newContactForm.profession\" \nclass=\"ng-pristine ng-valid md-default-theme ng-empty ng-touched\" ng-change=\"$ctrl.appendRegistrationPrefix()\">\n<md-option value=\"Aboriginal and Torres Strait Islander Health Practitioner\">Aboriginal and Torres Strait Islander<br>\nHealth Practitioner</md-option><md-option value=\"Chinese Medicine Practitioner\">Chinese Medicine Practitioner\n</md-option><md-option value=\"Chiropractor\">Chiropractor</md-option><md-option value=\"Dental Practitioner\">\nDental Practitioner</md-option><md-option value=\"Medical Practitioner\">Medical Practitioner</md-option><md-option \nvalue=\"Medical Radiation Practitioner\">Medical Radiation Practitioner</md-option><md-option value=\"Midwife\">Midwife\n</md-option><md-option value=\"Nurse\">Nurse</md-option><md-option value=\"Occupational Therapist\">Occupational Therapist\n</md-option><md-option value=\"Optometrist\">Optometrist</md-option><md-option value=\"Osteopath\">Osteopath</md-option>\n<md-option value=\"Paramedic\">Paramedic</md-option><md-option value=\"Pathologist\">Pathologist</md-option><md-option \nvalue=\"Pharmacist\">Pharmacist</md-option><md-option value=\"Physiotherapist\">Physiotherapist</md-option><md-option \nvalue=\"Podiatrist\">Podiatrist</md-option><md-option value=\"Psychologist\">Psychologist</md-option><md-option \nvalue=\"Sonographer\">Sonographer</md-option><md-option value=\"Other\">Other</md-option></md-select></md-input-container>\n<md-switch md-invert name=\"last-name-switch\" ng-model=\"$ctrl.newContactForm.isLastNameChecked\" \naria-label=\"last name switch\">Confirm spellings of last-name</md-switch></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised md-hue-1\" style=\"border-radius: 6px\" \nng-click=\"$ctrl.resetAddContactForm()\">Reset</md-button><md-button class=\"md-raised md-accent\" \naria-label=\"save contact\" type=\"submit\" name=\"save-contact\" \nstyle=\"text-transform: none !important;font-family: Roboto;font-size: 16px;font-weight: 500;font-style: normal;font-stretch: normal;letter-spacing: 0.3px;border-radius: 6px\" \nng-disabled=\"contactForm.$invalid || !$ctrl.newContactForm.isLastNameChecked\" \nng-click=\"$ctrl.saveYourNewClinividContact()\">Save</md-button></div></form></div></div></div></div></md-sidenav>\n<md-sidenav class=\"md-sidenav-right ie-width-fix\" md-component-id=\"addGroup\" style=\"background-color: #ffffff\"><div \nstyle=\"display: flex; flex-flow: column; height: 100%\"><div><md-toolbar layout=\"row\"><div class=\"md-toolbar-tools\">\n</div></md-toolbar></div><md-card-actions layout=\"row\" layout-align=\"start start\"><span><md-button \nclass=\"md-icon-button\" aria-label=\"Close Side Panel\" ng-click=\"$ctrl.closeAddGroup()\"><md-icon \nmd-font-icon=\"icon-close-circle-outline\" class=\"icon\" style=\"color:#0899ff\"></md-icon></md-button></span>\n</md-card-actions><div style=\"min-height: 0; flex: 1; overflow: auto\"><div style=\"margin-left:24px;margin-right:24px\">\n<div class=\"registerAccountHeader\" style=\"margin-top:50px\">Create a Group</div><form name=\"createGroupForm\" \nclass=\"contact-inputs\" novalidate><div><md-input-container class=\"md-block\" style=\"margin-top: 30px\"><input \nname=\"groupName\" \nstyle=\"border: none;width: 325px;border-bottom: 1px solid #d3d3d3;border-radius: 8px;padding: 4px;position: relative\" \nng-model=\"$ctrl.newGroupForm.groupName\" placeholder=\"Enter Group Name\" number-blur required><div \nclass=\"validation-messages\" ng-messages=\"createGroupForm.groupName.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Group Name is required.</span></div></div></md-input-container></div><div style=\"margin-top:50px\"><md-chips \nng-model=\"$ctrl.chipContacts\" md-autocomplete-snap=\"\" md-transform-chip=\"$ctrl.transformChip($chip)\" \nmd-require-match=\"true\"><md-autocomplete md-selected-item=\"$ctrl.selectedItemChip\" md-no-cache=\"true\" \nmd-search-text=\"$ctrl.searchTextChip\" md-items=\"item in $ctrl.querySearchChip($ctrl.searchTextChip)\" \nmd-item-text=\"item.fullName\" placeholder=\"Search your contact\" md-menu-class=\"autocomplete-custom-template\" \nmd-menu-container-class=\"custom-container\" md-min-length=\"0\"><md-item-template><span class=\"item-title\"><span>\n{{item.fullName}} </span></span><span class=\"profession\"><span>{{item.profession}}</span> </span><span \nclass=\"item-metadata\"><span>{{item.formattedOrganizationName}}</span></span></md-item-template><md-not-found>\nNo matches found.</md-not-found></md-autocomplete><md-chip-template><span><strong \nstyle=\"font-size: 15px;font-weight: bold\">{{$chip.fullName}}</strong></span></md-chip-template><button \nmd-chip-remove=\"\" style=\"margin-right: 9px;margin-top: 7px\">&times;</button></md-chips></div><div class=\"case-button\" \nlayout=\"row\" layout-align=\"center\" style=\"margin-top:50px\"><md-button \nclass=\"md-accent md-raised md-hue-1 createCaseButton\" ng-disabled=\"createGroupForm.$invalid\" \nng-click=\"$ctrl.createGroup()\">Save</md-button></div></form></div></div></div></md-sidenav><style>\n.md-tab {\n    line-height: 17px;\n  }\n  md-tabs.md-default-theme .md-tab, md-tabs .md-tab {\n    text-transform: none;\n    font-family: Roboto;\n    font-size: 14px;\n    font-weight: bold;\n    font-style: normal;\n    font-stretch: normal;\n    letter-spacing: 0.3px\n  }\n\n  md-tabs.md-default-theme .md-tab.md-active, md-tabs .md-tab.md-active, md-tabs.md-default-theme .md-tab.md-active md-icon, md-tabs .md-tab.md-active md-icon, md-tabs.md-default-theme .md-tab.md-focused, md-tabs .md-tab.md-focused, md-tabs.md-default-theme .md-tab.md-focused md-icon, md-tabs .md-tab.md-focused md-icon {\n    text-transform: none;\n    font-family: Roboto;\n    font-size: 14px;\n    font-weight: bold;\n    font-style: normal;\n    font-stretch: normal;\n    letter-spacing: 0.3px;\n    color: white;\n    background-color: #92298D;\n  }\n  md-tab-content > div {\n    padding-top: 40px;\n  }\n\n  md-sidenav,\n  md-sidenav.md-locked-open,\n  md-sidenav.md-closed.md-locked-open-add-active custom-sidenav {\n    min-width: 0px !important;\n    width: auto !important;\n\n  }\n  @-moz-document url-prefix() {\n    #conversation {\n      max-height: 332px;\n    }\n  }\n  md-select {\n    margin:  0px 0 0px 0;\n  }\n\n  .chips.chips-initial {\n    border-bottom: 1px solid #ddd;\n  }\n  .chip {\n    font-size: 15px;\n    font-weight: bold;\n    line-height: 30px;\n    padding: 0px 13px;\n    border-radius: 16px;\n    background-color: #eef2f3;\n    margin: 5px 5px;\n    display: inline-block;\n    outline: none;\n  }\n  .chip:focus {\n    background-color: #51c5c2;\n    color: #fff;\n  }\n  .closebtn {\n    cursor: pointer;\n  }\n  .chips.chips-initial input.chip-input {\n    display: inline-block ;\n    float: none;\n    width: 120px;\n    min-width: 30px;\n    border:none;\n    outline: none;\n  }\n\n  md-autocomplete#custom-template {\n    width: 200px;\n  }\n  .autocomplete-custom-template li {\n    border-bottom: 1px solid #ccc;\n    height: auto;\n    padding-top: 8px;\n    padding-bottom: 8px;\n    white-space: normal;\n  }\n  .autocomplete-custom-template li:last-child {\n    border-bottom-width: 0;\n  }\n  .autocomplete-custom-template .item-title {\n    font-family: Roboto;\n    font-size: 16px;\n    font-weight: bold;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: 0.3px;\n    text-align: left;\n    color: #494949;\n    display: block;\n  }\n  .autocomplete-custom-template .item-metadata {\n    color: #0899ff;\n    font-size: 13px;\n    font-weight: 500;\n    display: block;\n    line-height: 2;\n  }\n  .autocomplete-custom-template .profession {\n    font-family: Roboto;\n    font-size: 12px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: 2;\n    letter-spacing: 0.1px;\n    text-align: left;\n    color: #494949;\n    display: block;\n  }\n  .custom-container {\n    min-width: 300px !important;\n  }\n\n  md-sidenav { position:fixed; }\n  md-backdrop.md-opaque { position:fixed; }\n\n  md-backdrop.md-opaque { position:fixed; }\n</style>");
$templateCache.put("app/main/clinician/people/person-add.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page off-white-bg\" layout=\"column\"><md-content><div \nclass=\"content\" layout=\"column\"><div layout=\"column\" layout-align=\"center center\"><span style=\"color: #92298C\" \nclass=\"md-title mt-32\"><strong>Create and Add a Contact </strong></span><span style=\"color: #92298C\" class=\"pb-16\">\n<strong>\nUse this form to add a new contact who can be selected as recipients to your messages. The recipients that you send messages to will be able to view the messages without having to create or register an account.\n</strong></span></div><div layout=\"row\"><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1\n</span> <span class=\"ms-form-wizard-step-number secondary-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">Contact Details</span></span></md-tab-label><md-tab-body><div \nlayout=\"column\" layout-align=\"center center\"><span style=\"color: #92298C\" class=\"md-title mt-32\"><strong>\nAdd a Contact with a mobile number</strong></span><br><span style=\"color: #92298C\" class=\"pb-8\"><strong>\nClick on flag to change country code</strong></span><br><br><br></div><form name=\"wizardStep1\" class=\"md-inline-form\" \nms-form-wizard-form novalidate><div layout=\"column\" layout-align=\"center center\"><md-input-container flex-gt-xs=\"100\">\n<label>Required</label><input style=\"border: 2px solid #92298C; border-radius: 4px\" only-countries=\"au, in, nz\" \ntype=\"text\" name=\"mobile\" id=\"mobile\" international-phone-number ng-model=\"$ctrl.form.person.mobile\" \npreferred-countries=\"au\" auto-placeholder=\"off\" placeholder=\"Enter mobile number\" required auto-format=\"false\"><div \nng-messages=\"wizardStep1.mobile.$error\" ng-show=\"wizardStep1.mobile.$touched\" role=\"alert\"><div ng-message=\"pattern\">\n<span>Invalid characters or number.</span></div><div ng-message=\"maxlength\"><span>Too many digits.</span></div><div \nng-message=\"minlength\"><span>Not enough digits.</span></div><div ng-message=\"required\"><span>Mobile number is required.\n</span></div></div></md-input-container></div><br><br><br><br><br><br></form></md-tab-body></md-tab><md-tab \nng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"msWizard.formsIncomplete()\">2</span> <span \nclass=\"ms-form-wizard-step-number secondary-bg\" ng-if=\"!msWizard.formsIncomplete()\"><i class=\"icon-check s16\"></i> \n</span><span class=\"ms-form-wizard-step-text\">Person Details</span></span></md-tab-label><md-tab-body><div \nng-if=\"$ctrl.foundUser\"><div layout=\"column\" layout-align=\"center center\"><span style=\"color: #92298C\" \nclass=\"md-title mt-32\"><strong>Connect to Existing User</strong></span><br><span style=\"color: #92298C\" class=\"pb-8\">\n<strong>This person already uses Clinivid. Lets connect you.</strong></span><br></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex=\"\" class=\"flex md-default-theme\" ng-if=\"$ctrl.foundUser.title\"><label>\nTitle</label><input type=\"text\" name=\"lastname\" ng-model=\"$ctrl.foundUser.title\" disabled=\"disabled\">\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\" ng-if=\"$ctrl.foundUser.lastname\"><label>Lastname\n</label><input type=\"text\" name=\"lastname\" ng-model=\"$ctrl.foundUser.lastname\" disabled=\"disabled\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex \nng-if=\"$ctrl.foundUser.firstname\"><label>Firstname</label><input type=\"text\" name=\"firstname\" \nng-model=\"$ctrl.foundUser.firstname\" disabled=\"disabled\"></md-input-container><md-input-container flex \nng-if=\"$ctrl.foundUser.middleNames\"><label>Middle Names</label><input type=\"text\" name=\"middlenames\" \nng-model=\"$ctrl.foundUser.middleNames\" disabled=\"disabled\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex ng-if=\"$ctrl.foundUser.profession\"><label>Profession</label><input \ntype=\"text\" name=\"firstname\" ng-model=\"$ctrl.foundUser.profession\" disabled=\"disabled\"></md-input-container>\n<md-input-container flex ng-if=\"$ctrl.foundUser.registrationId\"><label>Registration</label><input type=\"text\" \nname=\"middlenames\" ng-model=\"$ctrl.foundUser.registrationId\" disabled=\"disabled\"></md-input-container></div></div><div \nlayout=\"column\" layout-align=\"center center\" ng-if=\"!$ctrl.foundUser\"><span style=\"color: #92298C\" \nclass=\"md-title mt-32\"><strong>Enter Contact\'s Details</strong></span><br><span style=\"color: #92298C\" class=\"pb-8\">\n<strong>Please ensure the last name is correct as the recipient will need to recieve your messages.</strong></span>\n</div><form ng-if=\"!$ctrl.foundUser\" name=\"wizardStep2\" ms-form-wizard-form novalidate><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex=\"\" class=\"flex md-default-theme\"><label for=\"select_55\" \nclass=\"md-placeholder\">Title</label><md-select ng-model=\"$ctrl.form.person.title\" \nclass=\"ng-pristine ng-valid md-default-theme ng-empty ng-touched\" tabindex=\"0\" aria-disabled=\"false\" role=\"listbox\" \naria-expanded=\"false\" aria-multiselectable=\"false\" id=\"select_55\" aria-owns=\"select_container_56\" aria-invalid=\"false\" \naria-label=\"Title\"><md-option ng-value=\"title\" ng-repeat=\"title in $ctrl.context.titles\">{{ title }}</md-option>\n</md-select></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>Lastname</label><input \ntype=\"text\" name=\"lastname\" ng-model=\"$ctrl.form.person.lastname\" ng-maxlength=\"50\" required><div \nng-messages=\"wizardStep2.lastname.$error\" ng-show=\"wizardStep2.lastname.$touched\" role=\"alert\" multiple=\"multiple\"><div\n ng-message=\"required\"><span>Lastname is required.</span></div><div ng-message=\"maxlength\"><span>Too many characters.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>\nFirstname</label><input type=\"text\" name=\"firstname\" ng-model=\"$ctrl.form.person.firstname\" ng-maxlength=\"50\"><div \nng-messages=\"wizardStep2.firstname.$error\" ng-show=\"wizardStep2.firstname.$touched\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"maxlength\"><span>Too many characters.</span></div></div></md-input-container><md-input-container flex>\n<label>Profession</label><input type=\"text\" name=\"profession\" ng-model=\"$ctrl.form.person.profession\" \nng-maxlength=\"50\"><div ng-messages=\"wizardStep2.profession.$error\" ng-show=\"wizardStep2.profession.$touched\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"maxlength\"><span>Too many characters.</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-align=\"center center\"><md-switch md-invert \naria-label=\"Switch 7\" ng-model=\"confirmLastName\" ng-disabled=\"!$ctrl.form.person.lastname\" required><span \nstyle=\"color: #92298C\" class=\"pb-8\"><strong>Confirm the Lastname spelling is correct?</strong></span></md-switch></div>\n</form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\" \nng-if=\"msWizard.selectedIndex == 0\"><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div></div><div class=\"navigation\" flex \nlayout=\"row\" layout-align=\"center center\"><md-button ng-if=\"msWizard.selectedIndex != 0\" class=\"md-raised md-accent\" \nng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Previous</md-button><div class=\"steps\" \nng-if=\"msWizard.selectedIndex != 0\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"$ctrl.next(msWizard)\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"$ctrl.currentStepInvalid(msWizard)\">Next</md-button><md-button class=\"md-raised md-accent secondary-bg\" \nng-click=\"$ctrl.next(msWizard)\" ng-show=\"msWizard.isLastStep() && !$ctrl.foundUser\" \nng-disabled=\"msWizard.formsIncomplete()\">Save</md-button><md-button class=\"md-raised md-accent secondary-bg\" \nng-click=\"$ctrl.next(msWizard)\" ng-show=\"msWizard.isLastStep() && $ctrl.foundUser\" \nng-disabled=\"msWizard.formsIncomplete()\">Connect</md-button></div></ms-form-wizard></div></div></md-content></div>");
$templateCache.put("app/main/clinician/people/profile.html","<div id=\"profile\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><img \nclass=\"profile-image avatar huge\" src=\"assets/images/avatars/katherine.jpg\"><div class=\"name\">Katherine Wilson</div>\n</div><div class=\"actions\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-accent\" \naria-label=\"Follow\" translate=\"PROFILE.FOLLOW\" translate-attr-aria-label=\"PROFILE.FOLLOW\">Follow</md-button><md-button \nclass=\"md-raised md-primary\" translate=\"PROFILE.SEND_MESSAGE\" translate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">\nSend Message</md-button></div></div><div class=\"content\" flex><md-tabs md-dynamic-height><md-tab><md-tab-label><span \ntranslate=\"PROFILE.TIMELINE\">Timeline</span></md-tab-label><md-tab-body><md-content class=\"timeline-tab\" \nng-include=\"\'app/main/pages/profile/tabs/timeline/timeline.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"PROFILE.ABOUT\">About</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/pages/profile/tabs/about/about.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label>\n<span translate=\"PROFILE.PHOTOS_VIDEOS\">Photos & Videos</span></md-tab-label><md-tab-body><md-content \nclass=\"photos-videos-tab\" ng-include=\"\'app/main/pages/profile/tabs/photos-videos/photos-videos.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/clinician/people/resendCase.html","<div id=\"forms\" class=\"page-layout simple tabbed off-white-bg\"><div class=\"content\" flex><div layout=\"row\" \nlayout-align=\"space-around\" class=\"whiteframedemoDirectiveInterpolation\" style=\"padding:24px\"><div class=\"padded\" \nmd-whiteframe flex=\"100\" flex-gt-sm=\"50\" layout=\"column\" layout-align=\"center center\" \nstyle=\"background: #fff;border-radius: 4px;position:relative;min-height:400px\"><div layout=\"row\" \nstyle=\"margin-top:-10px\"><div layout=\"column\" layout-align=\"center center\" \nstyle=\"font-size: 2.4rem;font-family: Roboto;margin-top:30px\">Resend Chat</div></div><div layout=\"column\" \nstyle=\"width: 300px;max-width: 300px;margin-top: 12px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nChat<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container class=\"md-block\" \nmd-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.caseId\" placeholder=\"Chat Id\"></md-input-container></div><div layout=\"column\" \nstyle=\"width: 300px;max-width: 300px;margin-top: 20px\"><h1 \nstyle=\"font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: normal;letter-spacing: normal;color: #494949\">\nRecipient<sup style=\"color: #FF0000;font-size: 13px;padding-left: 5px\">*</sup></h1><md-input-container \nclass=\"md-block\" md-no-float style=\"margin-top:0;margin-bottom: 0\"><input type=\"text\" \nstyle=\"margin-left: -4px;border-top: none; border-right: none; border-left: none; border-image: initial;border-bottom: 2px solid rgba(8, 153, 255, 0.5)\" \nng-model=\"$ctrl.recipientId\" placeholder=\"Recipient Id\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\" style=\"margin-top: 30px\"><md-button type=\"submit\" ng-click=\"$ctrl.submit()\" \nclass=\"md-raised md-accent submit-button\" \nstyle=\"border-radius:5px;width:115px;height:40px;font-size: 16px;;text-transform: none !important\">Submit</md-button>\n</div></div></div></div></div>");
$templateCache.put("app/main/shared/templates/name-form.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"\" \nclass=\"flex md-default-theme\"><label for=\"select_55\" class=\"md-placeholder\">Title</label><md-select \nng-model=\"$ctrl.form.person.title\" class=\"ng-pristine ng-valid md-default-theme ng-empty ng-touched\" tabindex=\"0\" \naria-disabled=\"false\" role=\"listbox\" aria-expanded=\"false\" aria-multiselectable=\"false\" id=\"select_55\" \naria-owns=\"select_container_56\" aria-invalid=\"false\" aria-label=\"Title\"><md-option ng-value=\"title\" \nng-repeat=\"title in $ctrl.context.titles\">{{ title }}</md-option></md-select></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><label>Lastname</label><input type=\"text\" name=\"lastname\" \nng-model=\"$ctrl.form.person.lastname\" ng-maxlength=\"50\" required><div ng-messages=\"nameForm.lastname.$error\" \nng-show=\"nameForm.lastname.$touched\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nDisplay Name field is required.</span></div><div ng-message=\"maxlength\"><span>Too many characters.</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>Firstname</label>\n<input type=\"text\" name=\"firstname\" ng-model=\"$ctrl.form.person.firstname\" ng-maxlength=\"50\" required><div \nng-messages=\"nameForm.firstname.$error\" ng-show=\"nameForm.firstname.$touched\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Firstname is required.</span></div><div ng-message=\"maxlength\"><span>Too many characters.\n</span></div></div></md-input-container><md-input-container flex><label>Middle Names</label><input type=\"text\" \nname=\"middlenames\" ng-model=\"$ctrl.form.person.middleNames\" ng-maxlength=\"100\"><div \nng-messages=\"nameForm.middlenames.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"maxlength\"><span>\nToo many characters.</span></div></div></md-input-container></div></div>");
$templateCache.put("app/main/viewer/direct/read-view.html","<md-content ng-if=\"$ctrl.selectedCase\"><div class=\"videogular-container\" layout-align=\"center center\"><videogular \nvg-theme=\"$ctrl.vidConfig.theme\" flex=\"none\" vg-player-ready=\"$ctrl.onPlayerReady($API)\"><vg-media \nvg-src=\"$ctrl.vidConfig.sources\"></vg-media><vg-controls vg-autohide=\"$ctrl.vidConfig.autohide\" \nvg-autohide-time=\"$ctrl.vidConfig.autohideTime\"><vg-play-pause-button></vg-play-pause-button><vg-time-display>\n{{ currentTime | date:\'mm:ss\' }}</vg-time-display><vg-scrub-bar><vg-scrub-bar-current-time></vg-scrub-bar-current-time>\n</vg-scrub-bar><vg-time-display>{{ timeLeft | date:\'mm:ss\' }}</vg-time-display><vg-volume><vg-mute-button>\n</vg-mute-button><vg-volume-bar></vg-volume-bar></vg-volume><vg-fullscreen-button></vg-fullscreen-button></vg-controls>\n<vg-overlay-play></vg-overlay-play></videogular></div><div class=\"case-content\"><div class=\"info\" flex=\"none\" \nlayout-gt-sm=\"row\" layout=\"column\" layout-align=\"space-between start\"><div layout-gt-sm=\"column\" \nlayout-align=\"start start\"><div class=\"details\" layout=\"row\" layout-align=\"start start\"><div layout=\"column\"><span \nclass=\"title\">Clinician:</span> <span class=\"title\">Patient:</span></div><div layout=\"column\"><span class=\"detail\">\n{{$ctrl.selectedCase.recipients[1].displayName}}</span> <span class=\"detail\">\n{{$ctrl.userService.getLongName($ctrl.selectedCase.patient)}} {{$ctrl.selectedCase.patient.ref}}</span></div></div>\n</div><div layout-gt-sm=\"column\" layout-align=\"start start\"><div class=\"details\" layout=\"row\" \nlayout-align=\"start start\"><div layout=\"column\"><span class=\"title\">Updated:</span> <span class=\"title\">\n{{$ctrl.selectedCase.patient.dob? \"D.O.B.:\" : \" \"}}</span></div><div layout=\"column\"><span class=\"detail\">\n{{$ctrl.app.getTimeString($ctrl.selectedCase.updated)}}</span> <span class=\"detail\">\n{{$ctrl.selectedCase.patient.dob? $ctrl.selectedCase.patient.dob : \" \"}}</span></div></div></div></div></div><div \nclass=\"case-chat-title\">{{$ctrl.app.genCaseTitle($ctrl.selectedCase)}}</div><md-content class=\"case-chat-content\" \nauto-scroll-bottom=\"$ctrl.displayChats\"><div ng-if=\"$ctrl.displayChats.length\" \nng-repeat=\"chat in $ctrl.displayChats track by $index\" class=\"chat-content-item\" ng-class=\"chat.class\"><div \nclass=\"chat-content-bubble\" layout=\"column\">{{chat.data}}</div></div><span ng-if=\"!$ctrl.displayChats.length\" \nstyle=\"color:gray;font-style:italic\">No additional messages at this point in time.</span></md-content><div \nclass=\"case-chat-bar\" flex=\"none\" layout=\"column\" layout-align=\"center center\"><h3>\nRegister now to access cases anytime and have the ability to message the clinician.</h3><div class=\"case-chat-bar\" \nflex=\"none\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nui-sref=\"app.user.register({inviteKey: $ctrl.valKey})\"><md-icon md-font-icon=\"icon-clipboard-account\"></md-icon>\n&nbsp;Register for free&nbsp;</md-button></div></div></md-content>");
$templateCache.put("app/main/viewer/direct/singleView.html","<md-whiteframe id=\"single-view\" class=\"md-whiteframe-7dp\" style=\"margin: 5%\" layout layout-align=\"center center\">\n<md-content flex layout-padding><div class=\"content case-read-pane\" \nng-include=\"\'app/main/viewer/direct/read-view.html\'\" ms-scroll></div></md-content></md-whiteframe>");
$templateCache.put("app/navigation/hci-navigation/templates/horizontal.html","<div ng-if=\"$ctrl.userContext.currentRole.orgDisplayName\" class=\"current-org\" layout=\"row\" layout-align=\"start center\" \nui-sref=\"app.user.profile\"><span class=\"org-logo\"><i class=\"icon s18 icon-hospital-building\"></i></span> <span \nclass=\"org-name\">{{$ctrl.userContext.currentRole.orgDisplayName}}</span></div><div class=\"navigation-toggle\" \nhide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"$ctrl.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\" style=\"position: absolute; right: 0px\"><li ng-repeat=\"node in $ctrl.navigation\" \nms-navigation-horizontal-node=\"node\" ng-class=\"{\'has-children\': $ctrl.hasChildren}\" \nng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script type=\"text/ng-template\" \nid=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" layout-align=\"space-between center\">\n\n            <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n                 ng-class=\"{\'active md-accent-bg\': $ctrl.isActive}\">\n                <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n                <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n                <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n                <i class=\"icon-chevron-right s18 arrow\" ng-if=\"$ctrl.hasChildren\"></i>\n            </div>\n            <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n               ng-class=\"{\'active md-accent-bg\': $ctrl.isActive}\"\n               ng-if=\"node.uisref && node.title\">\n                <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n                <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n                <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n                <i class=\"icon-chevron-right s18 arrow\" ng-if=\"$ctrl.hasChildren\"></i>\n            </a>\n        </div>\n\n        <ul ng-if=\"$ctrl.hasChildren && !$ctrl.isHidden()\" >\n            <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n                ng-class=\"{\'has-children\': $ctrl.hasChildren}\"\n                ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n        </ul>\n</script>");
$templateCache.put("app/navigation/hci-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in $ctrl.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': $ctrl.collapsed, \'has-children\': $ctrl.hasChildren}\" ng-include=\"\'navigation-nested.html\'\">\n</li></ul><script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!$ctrl.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"$ctrl.collapsable && $ctrl.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"$ctrl.collapsable && $ctrl.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"$ctrl.hasChildren && !$ctrl.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': $ctrl.collapsed, \'has-children\': $ctrl.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"end center\"><hci-navigation-horizontal></hci-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\" ui-sref=\"app.welcome\"><span class=\"logo-image\"></span> <span \nclass=\"logo-text\">Clinivid</span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm \nng-click=\"$ctrl.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" \nfolded=\"$ctrl.folded\" ms-scroll=\"$ctrl.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\" ui-sref=\"app.welcome\"><span class=\"logo-image\"></span> <span \nclass=\"logo-text\">Clinivid</span></div><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress || $root.apiLoadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\">\n</md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"$ctrl.userStatus.icon\" \nng-style=\"{\'color\': $ctrl.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>\nChange Password</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon \nmd-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Change Pin</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\"><md-icon md-font-icon ng-class=\"$ctrl.userStatus.icon\" ng-style=\"{\'color\': $ctrl.userStatus.color }\" \nclass=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" \nng-class=\"$ctrl.userStatus.class\">{{$ctrl.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item \nclass=\"status md-indent\" ng-class=\"{\'selected\': status === $ctrl.userStatus}\" \nng-repeat=\"status in $ctrl.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" \nng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button ng-click=\"$ctrl.setUserStatus(status)\">\n{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-divider>\n</md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button\n ng-click=\"$ctrl.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{$ctrl.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{$ctrl.selectedLanguage.code}}\n</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in $ctrl.languages\"><md-button ng-click=\"$ctrl.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"$ctrl.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"navigation-toggle\" hide-gt-sm ng-if=\"$ctrl.auth.isAuth && !$ctrl.userService.checkSuperAdmin()\" \nstyle=\"height: 35px\"><md-menu-bar><md-menu md-position-mode=\"left bottom\"><md-icon md-font-icon=\"icon-menu\" \nng-click=\"$mdMenu.open($event)\" style=\"color: #92298C\"></md-icon><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"goToPage(\'app.clinician.cases\')\">Chats</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"goToPage(\'app.clinician.people\')\">Contacts</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"goToPage(\'app.clinician.mdt\')\">Meetings</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar>\n</div><div class=\"navigation-toggle\" hide-gt-sm ng-if=\"$ctrl.auth.isAuth && $ctrl.userService.checkSuperAdmin()\" \nstyle=\"height: 35px\"><md-menu-bar><md-menu md-position-mode=\"left bottom\"><md-icon md-font-icon=\"icon-menu\" \nng-click=\"$mdMenu.open($event)\" style=\"color: #92298C\"></md-icon><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"goToPage(\'app.clinician.manageOrganisation\')\">Manage Organisations</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"goToPage(\'app.clinician.manageUsers\')\">Manage Users</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"goToPage(\'app.clinician.resendCase\')\">Resend Chat</md-button></md-menu-item></md-menu-content>\n</md-menu></md-menu-bar></div><div ng-if=\"!$ctrl.auth.isAuth\" style=\"width:15px\"></div><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><a href=\"https://clinivid.com.au\" ga-track-event=\"[\'Link\', \'Click\', \'clicked-to-go-home\']\" \nng-show=\"!($ctrl.context && $ctrl.context.user)\"><span class=\"logo-image\"></span> </a><a href=\"#\" \nng-click=\"goToPage(\'app.clinician.cases\')\" \nng-show=\"($ctrl.context && $ctrl.context.user && !$ctrl.userService.checkSuperAdmin())\"><span class=\"logo-image\">\n</span> </a><a href=\"#\" ng-click=\"goToPage(\'app.clinician.manageOrganisation\')\" \nng-if=\"($ctrl.context && $ctrl.context.user && $ctrl.userService.checkSuperAdmin())\"><span class=\"logo-image\"></span> \n</a><a href=\"https://clinivid.com.au\" style=\"text-decoration: none\" \nga-track-event=\"[\'Link\', \'Click\', \'clicked-to-go-home\']\" ng-show=\"!($ctrl.context && $ctrl.context.user)\"><span \nclass=\"logo-text text-case hide-xs\" style=\"color: rgb(146, 41, 140)\">Clinivid</span> </a><a href=\"#\" \nng-click=\"goToPage(\'app.clinician.cases\')\" style=\"text-decoration: none\" \nng-show=\"($ctrl.context && $ctrl.context.user && !$ctrl.userService.checkSuperAdmin())\"><span \nclass=\"logo-text text-case hide-xs\" style=\"color: rgb(146, 41, 140)\">Clinivid</span> </a><a href=\"#\" \nng-click=\"goToPage(\'app.clinician.manageOrganisation\')\" style=\"text-decoration: none\" \nng-if=\"($ctrl.context && $ctrl.context.user  && $ctrl.userService.checkSuperAdmin())\"><span \nclass=\"logo-text text-case hide-xs\" style=\"color: rgb(146, 41, 140)\">Clinivid</span></a></div><md-nav-bar \nmd-selected-nav-item=\"$ctrl.highlightPropertNavMenu()\" class=\"text-case\" \nng-show=\"($ctrl.context && $ctrl.context.user)\" nav-bar-aria-label=\"navigation links\" \nng-if=\"$ctrl.auth.isAuth && !$ctrl.userService.checkSuperAdmin()\"><md-nav-item name=\"cases\" \nmd-nav-click=\"goToPage(\'app.clinician.cases\')\" class=\"text-case\">Chats</md-nav-item><span \nclass=\"badge white-fg ng-binding ng-scope hide-sm hide-xs\" ng-show=\"$ctrl.getUnreadMessageCount() > 0\" \nstyle=\"font-weight: bold;margin-left: 87px\" ng-bind=\"$ctrl.getUnreadMessageCount()\"></span><md-nav-item \nname=\"contacts\" md-nav-click=\"goToPage(\'app.clinician.people\')\" class=\"text-case\">Contacts</md-nav-item><md-nav-item \nname=\"mdt\" md-nav-click=\"goToPage(\'app.clinician.mdt\')\" class=\"text-case\">Meetings</md-nav-item></md-nav-bar>\n<md-nav-bar md-selected-nav-item=\"$ctrl.highlightPropertNavMenu()\" class=\"text-case\" \nng-show=\"($ctrl.context && $ctrl.context.user)\" nav-bar-aria-label=\"navigation links\" \nng-if=\"$ctrl.auth.isAuth && $ctrl.userService.checkSuperAdmin()\"><md-nav-item name=\"manageOrganisation\" \nmd-nav-click=\"goToPage(\'app.clinician.manageOrganisation\')\" class=\"text-case\">Manage Organisations</md-nav-item><span \nclass=\"badge white-fg ng-binding ng-scope hide-sm hide-xs\" ng-show=\"$ctrl.getUnreadMessageCount() > 0\" \nstyle=\"font-weight: bold;margin-left: 87px\" ng-bind=\"$ctrl.getUnreadMessageCount()\"></span><md-nav-item \nname=\"manageUsers\" md-nav-click=\"goToPage(\'app.clinician.manageUsers\')\" class=\"text-case\">Manage Users</md-nav-item>\n<md-nav-item name=\"resendCase\" md-nav-click=\"goToPage(\'app.clinician.resendCase\')\" class=\"text-case\">Resend Chat\n</md-nav-item></md-nav-bar></div><div layout=\"row\" layout-align=\"start center\"><md-button layout=\"row\" \nlayout-align=\"center center\" ng-show=\"($ctrl.context && $ctrl.context.user && $ctrl.checkMenu())\" \nclass=\"createcasediv\" style=\"width:auto\" ui-sref=\"app.user.casecreation\" ng-click=\"openNewCase()\" \nng-if=\"$ctrl.auth.isAuth && !$ctrl.userService.checkSuperAdmin()\"><md-icon md-font-icon=\"icon-folder-plus-center\" \nclass=\"icon-adjust\"></md-icon><md-input-container md-no-float class=\"md-accent hide-xs\" style=\"padding-bottom: 8px\">\n<span class=\"newcaselabel\">New Chat</span></md-input-container></md-button><md-button layout=\"row\" \nlayout-align=\"center center\" ng-show=\"($ctrl.context && $ctrl.context.user && $ctrl.checkMenu())\" \nclass=\"createcasediv\" style=\"width:auto\" ui-sref=\"app.user.createorganisation\" ng-click=\"openCreateNewOrganization()\" \nng-if=\"$ctrl.auth.isAuth && $ctrl.userService.checkSuperAdmin()\"><md-icon md-font-icon=\"icon-folder-plus-center\" \nclass=\"icon-adjust\"></md-icon><md-input-container md-no-float class=\"md-accent hide-xs\" style=\"padding-bottom: 8px\">\n<span class=\"newcaselabel\">Create New Organization</span></md-input-container></md-button><div \nclass=\"createcasediv hide-xs\" style=\"width:auto;border-right: solid 0px #eaeaea\" ui-sref=\"app.user.profile\" \nng-show=\"($ctrl.context && $ctrl.context.user)\" ng-click=\"profileClick()\" ng-if=\"$ctrl.auth.isAuth\"><md-list-item \nclass=\"md-2-line\"><div class=\"md-list-item-text\"><h3 class=\"username\" style=\"font-size: 14px\" \nng-bind=\"$ctrl.userService.getUserName()\"></h3><p class=\"organizationName\" \nng-bind=\"$ctrl.userService.getUserProfile()\"></p></div></md-list-item></div><md-button ui-sref=\"app.user.login\" \nng-if=\"!$ctrl.auth.isAuth && !$ctrl.isAndroidDevice && !$ctrl.showLoginButton()\" \nonclick=\"window.location=\'https://apps.apple.com/us/app/clinivid/id1518793065\'\" \nga-track-event=\"[\'Button\', \'Click\', \'user-clicked-to-download-appstore\']\" class=\"apple\" \nstyle=\"border: none;outline: none;box-shadow: none;background-color: transparent;width: 138px;height: 40px;font-size: 14px;border-radius: 22px;border: solid 1px #b8b8b8;margin-right: 4px;margin-left: 4px;background-repeat: no-repeat;background-position: center;text-transform: none !important\">\n</md-button><md-button ui-sref=\"app.user.login\" \nng-if=\"!$ctrl.auth.isAuth && !$ctrl.isIOSDevice &&  !$ctrl.showLoginButton()\" \nonclick=\"window.location=\'https://play.google.com/store/apps/details?id=au.com.clinivid\'\" \nga-track-event=\"[\'Button\', \'Click\', \'user-clicked-to-download-playstore\']\" class=\"google\" \nstyle=\"border: none;outline: none;box-shadow: none;background-color: transparent;width: 138px;height: 40px;font-size: 14px;border-radius: 22px;border: solid 1px #b8b8b8;margin-right: 4px;margin-left: 4px;background-repeat: no-repeat;background-position: center;text-transform: none !important\">\n</md-button><md-button ui-sref=\"app.user.login\" \nng-if=\"(!$ctrl.auth.isAuth &&  $ctrl.showLoginButton()) || $ctrl.isIncompleteProfile()\" \nga-track-event=\"[\'Button\', \'Click\', \'user-clicked-to-login\']\"><md-icon md-font-icon=\"icon-login\" class=\"icon\">\n</md-icon>Log in</md-button><md-menu-bar id=\"user-menu\" ng-if=\"$ctrl.auth.isAuth\"><md-menu \nmd-position-mode=\"right bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\" name=\"moreMenu\"><img \nsrc=\"/assets/images/chevron-down.svg\" style=\"width: 25px;padding-top: 4px;margin-right: 3px\"></md-button>\n<md-menu-content><md-menu-item class=\"md-indent\" ui-sref=\"app.user.profile\" ng-click=\"profileClick()\" \nng-if=\"!$ctrl.userService.checkSuperAdmin()\"><md-icon md-svg-src=\"/assets/images/icons8-settings.svg\"></md-icon>\n<md-button name=\"myProfile\">Settings</md-button></md-menu-item><md-menu-divider ng-click=\"profileClick()\" \nng-show=\"!$ctrl.userService.checkSuperAdmin()\"></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"$ctrl.logout()\" analytics-on \nanalytics-category=\"Button\" analytics-label=\"user-clicked-to-logout\">Logout</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\"><md-icon md-font-icon=\"icon-headset\" class=\"icon\" style=\"color: red\"></md-icon><md-button \nng-href=\"mailto:support@clinivid.com.au\">Get Help / Feedback</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><a href=\"mailto:support@clinivid.com.au\"><img src=\"/assets/images/question@3x.png\" \nstyle=\"width: 20px;height: 20px;margin-bottom: 4px;margin-right: 6px;cursor:pointer\"></a></div></div><style>\n.apple {\n    background-image: url(data:image/svg+xml;base64,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);\n  }\n\n  .google {\n    background-image: url(data:image/svg+xml;base64,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);\n  }\n</style>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"$ctrl.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"toolbar-separator\"></div><md-progress-circular \nid=\"toolbar-progress\" ng-if=\"$root.loadingProgress || $root.apiLoadingProgress\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\">\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"$ctrl.userStatus.icon\" \nng-style=\"{\'color\': $ctrl.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"$ctrl.userStatus.icon\" \nng-style=\"{\'color\': $ctrl.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"$ctrl.userStatus.class\">{{$ctrl.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === $ctrl.userStatus}\" \nng-repeat=\"status in $ctrl.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" \nng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button ng-click=\"$ctrl.setUserStatus(status)\">\n{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-divider>\n</md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button\n ng-click=\"$ctrl.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{$ctrl.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{$ctrl.selectedLanguage.code}}\n</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in $ctrl.languages\"><md-button ng-click=\"$ctrl.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"$ctrl.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/user/auth/lock/lock.html","<div id=\"lock\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"lock-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"lock-form\" class=\"md-whiteframe-8dp\"><div layout=\"row\" \nlayout-align=\"start center\" layout-sm=\"column\" layout-align-sm=\"center center\"><div class=\"avatar-container\"><img \nclass=\"avatar big\" src=\"assets/images/avatars/katherine.jpg\"><md-icon md-font-icon=\"icon-lock\" \nclass=\"md-warn-fg s36 md-hue-2\"></md-icon></div><div flex layout=\"column\" layout-align=\"start\" \nlayout-align-sm=\"center center\"><div class=\"title\" translate=\"LOCK.TITLE\">Your session is locked</div><div \nclass=\"subtitle\" translate=\"LOCK.SUBTITLE\">Due to inactivity, your session is locked. Enter your password to continue.\n</div></div></div><form name=\"lockForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input \nng-model=\"$ctrl.form.username\" placeholder=\"Username\" translate translate-attr-placeholder=\"LOCK.USERNAME\" \ndisabled=\"disabled\"></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"password\" ng-model=\"$ctrl.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"LOCK.PASSWORD\" required><div ng-messages=\"lockForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"LOCK.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"UNLOCK\" \nng-disabled=\"lockForm.$invalid || lockForm.$pristine\" translate=\"LOCK.UNLOCK\" translate-attr-aria-label=\"LOCK.UNLOCK\">\nUNLOCK</md-button></form><div class=\"message\"><a ui-sref=\"app.pages_auth_login\" class=\"md-accent-color\"><span \ntranslate=\"LOCK.ARE_YOU_NOT\">Are you not</span><span> Jane Doe?</span></a></div></div></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/shared/dialogs/simple-dialog/simple-dialog.html","<md-dialog class=\"simple-dialog\" aria-label=\"Notification\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><span \nclass=\"title\">{{title}}</span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><md-input-container class=\"md-block\"><label translate=\"TODO.TITLE\">{{title}}</label><input name=\"title\" \nng-model=\"$ctrl.task.title\" required><div ng-messages=\"taskForm.title.$error\" ng-show=\"taskForm.title.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"TODO.ERRORS.TITLE_REQUIRED\">Title field is required</span>\n</div></div></md-input-container><div class=\"notes\"><label translate=\"TODO.NOTES\">Notes</label><text-angular \nng-model=\"message\"></text-angular></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-if=\"!$ctrl.newTask\" ng-click=\"$ctrl.saveTask()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"SAVE\" translate=\"TODO.SAVE\" \ntranslate-attr-aria-label=\"TODO.SAVE\">SAVE</md-button><md-button type=\"submit\" ng-if=\"$ctrl.newTask\" \nng-click=\"$ctrl.addNewTask()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"Add Task\" translate=\"TODO.ADD_TASK\" \ntranslate-attr-aria-label=\"TODO.ADD_TASK\">ADD TASK</md-button><md-button class=\"md-icon-button\" \naria-label=\"Attach file\" translate translate-attr-aria-label=\"TODO.ATTACH_FILE\"><md-icon md-font-icon=\"icon-paperclip\">\n</md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Insert picture\" translate \ntranslate-attr-aria-label=\"TODO.INSERT_PICTURE\"><md-icon md-font-icon=\"icon-file-image-box\"></md-icon></md-button>\n</div><div layout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"$ctrl.deleteTask($event)\" aria-label=\"Delete\" \ntranslate translate-attr-aria-label=\"TODO.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"TODO.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps\" layout=\"row\" layout-align=\"start center\"><div class=\"step md-accent-bg\" \nlayout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{step.stepNumber}} \n</span><span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\">\n</span></div><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/main/clinician/cases/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-message-video\" class=\"icon\"></md-icon>\n</span><span class=\"logo-text\" translate=\"CASE.CASES\">Cases</span></div></div><md-content ms-scroll class=\"content\" \nflex><div class=\"compose-button\"><md-button id=\"create-case-btn\" class=\"md-accent md-raised secondary-bg\" \naria-label=\"compose\" ng-click=\"$ctrl.composeDialog($event)\" translate=\"CASE.CREATE\">CREATE</md-button></div><div \nclass=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\" \nng-click=\"$ctrl.composeDialog($event)\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-inbox\" class=\"s16\"></md-icon><span class=\"title\" translate=\"CASE.INBOX\">Inbox</span></div>\n</md-button><md-button class=\"item\" aria-label=\"drafts\" ng-click=\"$ctrl.composeDialog($event)\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-email-open\" class=\"s16\"></md-icon><span class=\"title\">Unread\n</span></div></md-button><md-button class=\"item\" aria-label=\"all mail\" ng-click=\"$ctrl.composeDialog($event)\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder\" class=\"s16\"></md-icon><span class=\"title\">\nBy Creation Date</span></div></md-button><md-divider></md-divider><md-button class=\"item\" aria-label=\"settings\" \nng-click=\"$ctrl.composeDialog($event)\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"s16\"></md-icon><span class=\"title\" translate=\"CASE.SETTINGS\">Settings</span></div></md-button><md-button \nclass=\"item\" aria-label=\"help\" ng-click=\"$ctrl.composeDialog($event)\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-help\" class=\"s16\"></md-icon><span class=\"title\" translate=\"CASE.HELP\">Help</span></div>\n</md-button></div></md-content>");
$templateCache.put("app/main/clinician/cases/views/list/list-view.html","<div class=\"case-list-item\"><input type=\"text\" ng-model=\"$ctrl.caseSearchKeyword\" name=\"searchCase\" \nplaceholder=\"Search cases\" \nstyle=\"height: 40px;width: 385px;box-sizing: border-box;border: 1px solid #eaeaea;border-radius: 9px;font-family: SFUIDisplay;font-size: 16px;font-weight: normal;font-style: normal;font-stretch: normal;line-height: normal;letter-spacing: 0.3px;background-color: white;background-image: url(\'assets/images/search.png\');background-position: right;background-repeat: no-repeat;padding: 12px 20px 12px 40px;background-position: 20px 12px\">\n</div><md-content><div class=\"case-list-item urgent {{case.status}}\" \nng-repeat=\"case in filteredCases =($ctrl.app.clinician.cases.currentPage.items | filter: $ctrl.caseSearchKeyword )\" \nmd-ink-ripple ng-click=\"case.status == 50 ? $ctrl.handleDraftCase(case): $ctrl.selectCase(case, $event)\" \nng-class=\"[case.owner, {\'starred\': case.starred, \'selected\': $ctrl.selectedCase.id === case.id, \'checked\': $ctrl.isChecked(case)}]\">\n<div layout=\"row\" layout-align=\"start start\"><md-icon layout-align=\"center start\" \nmd-font-icon=\"icon-checkbox-blank-circle\" ng-if=\"case.countOfNewItems > 0 && case.status !== 50\"></md-icon><md-icon \nlayout-align=\"center start\" md-font-icon=\"icon-checkbox-blank-circle-outline\" \nng-if=\"case.countOfNewItems <= 0 && case.status !== 50\"></md-icon><md-icon layout-align=\"center start\" \nmd-font-icon=\"icon-pencil-box-outline\" ng-if=\"case.status == 50\"></md-icon><div class=\"info\" flex layout=\"column\"><div \nclass=\"name\" layout=\"row\" layout-align=\"start center\"><img class=\"avatar\" ng-if=\"case.patient.avatar\" \nalt=\"{{case.patient.name}}\" ng-src=\"{{case.patient.avatar}}\"> <span class=\"text-truncate\" ng-if=\"case.status !== 50\">\n{{$ctrl.app.genCaseTitle(case)}}</span> <span class=\"text-truncate\" style=\"color: #A9A9A9\" ng-if=\"case.status == 50\">\n{{$ctrl.app.genCaseTitle(case)}}</span></div><div class=\"subject text-truncate\" ng-cloak \nng-if=\"$ctrl.getRecipientsFromCase(case)\">{{$ctrl.getRecipientsFromCase(case)}}</div><div \nclass=\"subject text-truncate\" ng-cloak ng-if=\"!$ctrl.getRecipientsFromCase(case)\">&nbsp;</div><div class=\"message\" \nng-if=\"$ctrl.userService.getLongName(case.patient)\">Patient: {{$ctrl.userService.getLongName(case.patient)}}</div><div \nclass=\"message\" ng-if=\"!$ctrl.userService.getLongName(case.patient)\">Patient not identified</div></div><div \nlayout=\"column\" layout-align=\"space-between end\"><div class=\"priority\" aria-label=\"Priority\" \nng-if=\"case.priority == 50\">URGENT<md-icon md-font-icon=\"icon-alert\" style=\"color:red\"></md-icon><md-tooltip><span>\nURGENT Priority</span></md-tooltip></div><div class=\"priority\" aria-label=\"Priority\" ng-if=\"case.priority == 40\">HIGH\n<md-icon md-font-icon=\"icon-alert\" style=\"color:orange\"></md-icon><md-tooltip><span>HIGH Priority</span></md-tooltip>\n</div><div class=\"unread\" ng-if=\"case.recipientsUnread > 0 && case.status !== 50\">Unread</div><div class=\"read\" \nng-if=\"case.recipientsUnread == 0 && case.status !== 50\">Read</div><div class=\"read\" ng-if=\"case.status == 50\">Draft\n</div><div class=\"time\">{{$ctrl.app.getTimeString(case.updated)}}</div></div></div></div><div layout=\"row\" \nlayout-align=\"center center\" ng-show=\"!filteredCases.length\" style=\"background-color: rgb(245, 245, 245)\"><span \nstyle=\"text-align: center\"><br><img src=\"assets/images/no-results_1x.png\"></span></div><div layout=\"row\" \nlayout-align=\"center center\" ng-show=\"!filteredCases.length\" style=\"background-color: rgb(245, 245, 245)\"><span \nstyle=\"text-align: center\" class=\"nomatchfound\"><br>Try Another search</span></div><div layout=\"row\" \nlayout-align=\"center center\" ng-show=\"!filteredCases.length\" style=\"background-color: rgb(245, 245, 245)\"><span \nstyle=\"text-align: center\" class=\"nomatchfound\"><br>No cases were found that match your search</span></div>\n</md-content>");
$templateCache.put("app/main/clinician/cases/views/list/list-view2.html","<div style=\"margin-top:15px;margin-bottom:15px\"><div layout=\"row\" layout-align=\"center center\" style=\"height:50px\" \nng-if=\"!searchModeOn\"><span ng-click=\"$ctrl.setSearchModeOn()\"><img src=\"/assets/images/searchChat24.png\" \nstyle=\"cursor:pointer\"> <span \nstyle=\"color:#92298D;cursor:pointer;font-weight: 500;letter-spacing: 0.010em;margin-left: 8px\">Search Chat</span>\n</span></div><div layout=\"row\" layout-align=\"center center\" style=\"height:50px\" ng-if=\"searchModeOn\"><input \ntype=\"text\" placeholder=\"Search Chat\" ng-model=\"$ctrl.caseSearchKeyword2\" \nstyle=\"background: #ffffff;padding:10px;border-radius:5px;-moz-border-radius:5px;-webkit-border-radius:5px;-o-border-radius:5px;border: 1px solid #92298D;width:160px;height:30px\">\n <img src=\"/assets/images/purple-close-circle.png\" style=\"width:33px;margin-right:13px;cursor:pointer\" \nng-click=\"$ctrl.setSearchModeOff()\"></div></div><md-content style=\"background-color: #f5f5f5; margin-bottom: 40px\"><div\n layout=\"column\" layout-align=\"center center\" style=\"padding-top:50px\" ng-if=\"$ctrl.shouldShowSearchCaseBanner()\"><div \nlayout=\"row\" layout-align=\"center center\"><img src=\"/assets/images/searchGraphic.png\"></div><div layout=\"row\" \nlayout-align=\"center center\"><div style=\"padding-top: 15px;font-weight: 500;letter-spacing: 0.010em\">\nSearch for chats by their</div></div><div layout=\"row\" layout-align=\"center center\"><div \nstyle=\"font-weight: 500;letter-spacing: 0.010em\">title, doctors involved or</div></div><div layout=\"row\" \nlayout-align=\"center center\"><div style=\"font-weight: 500;letter-spacing: 0.010em\">patient name</div></div></div><div \nclass=\"case-list-item urgent {{case.status}}\" \nng-repeat=\"case in filteredCases = ( caseList  | filter: $ctrl.caseSearchKeyword2 )\" md-ink-ripple \nng-click=\"case.status == 50 ? $ctrl.handleDraftCase(case): $ctrl.selectCase(case, $event)\" style=\"height: auto\" \nng-class=\"[case.owner, {\'selected\': $ctrl.selectedCase.id === case.id}]\" ng-if=\"$ctrl.shouldShowCaseListing()\"><div \nlayout=\"row\" style=\"margin-bottom: 10px\"><div flex=\"90\"><div ng-show=\"case.priority == 50\"><div \nstyle=\"width: 17%;float: left;max-width: 57px\"><div \nstyle=\"font-family: Roboto;font-size: 14px;font-weight: normal;font-style: normal;font-stretch: normal;letter-spacing: 0.3px;color: #fe3824\">\nURGENT</div></div><div style=\"width: 83%;float: left\"><div \nstyle=\"display: -webkit-box;font-size: 14px;-webkit-line-clamp: 1;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;font-weight: bold\">\n&nbsp;&nbsp;&nbsp;&nbsp;{{case.displayableRecipients}}</div></div></div><div ng-show=\"case.priority == 40\"><div \nstyle=\"width: 13%;float: left;max-width: 40px\"><div \nstyle=\"font-family: Roboto;font-size: 14px;font-weight: normal;font-style: normal;font-stretch: normal;letter-spacing: 0.3px;color: #FFA500\">\nHIGH</div></div><div style=\"width: 87%;float: left\"><div \nstyle=\"display: -webkit-box;font-size: 14px;-webkit-line-clamp: 1;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;font-weight: bold\">\n{{case.displayableRecipients}}</div></div></div><div ng-show=\"case.priority != 40 && case.priority != 50\"><div \nstyle=\"width: 100%;float: left\"><div \nstyle=\"display: -webkit-box;font-size: 14px;-webkit-line-clamp: 1;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;font-weight: bold\">\n{{case.displayableRecipients}}</div></div></div><br><span class=\"casePatientInList\" \nng-if=\"$ctrl.userService.getLongNamePatient(case.patient)\" style=\"font-size: 14px;font-weight: normal\">\nPatient: {{$ctrl.userService.getLongNamePatient(case.patient)}} </span><span class=\"casePatientInList\" \nng-if=\"!$ctrl.userService.getLongNamePatient(case.patient)\" style=\"font-size: 14px;font-weight: normal\">\nPatient: Undisclosed</span><br><span class=\"casePatientName\" ng-if=\"case.status === 50\" \nstyle=\"font-size: 14px;font-weight: normal\">{{$ctrl.app.genCaseTitle(case)}} </span><span class=\"casePatientName\" \nng-if=\"case.status !== 50\" style=\"font-size: 14px;font-weight: normal\">{{$ctrl.app.genCaseTitle(case)}} </span><span \nng-show=\"case.organization\"><br><span class=\"casesReadBy\" style=\"font-style:normal\">Organisation: <span \nstyle=\"color: #0899ff\">{{case.organization}}</span></span></span><br \nng-show=\"case.hasTags && $ctrl.$scope.searchModeOn\"><span class=\"casesReadBy\" \nng-show=\"case.hasTags && $ctrl.$scope.searchModeOn\">Tags: <span style=\"color: #0899ff\">{{case.allCurrentCaseTags}}\n</span></span><br><span class=\"casesReadBy\"><span style=\"color: #0899ff;font-style:normal\" ng-show=\"case.tagCount > 1\">\n{{case.tagCount}} tags</span> <span style=\"color: #0899ff;font-style:normal\" ng-show=\"  case.tagCount === 1 \">1 tag\n</span> <span style=\"font-style:italic\">Read by {{$ctrl.getFractionRead(case)}}</span></span></div><div flex \nstyle=\"position: relative\"><span style=\"float:right\" ng-show=\" case.totalUnreadMessages > 0 && case.status !== 50\"><div\n class=\"numberCircle\">{{case.totalUnreadMessages}}</div></span><span style=\"float:right\" ng-show=\"case.status === 50\">\n<img src=\"/assets/images/draft.png\" style=\"width:25px\"></span><br><span class=\"showTimePastCaseRightBottom\" \nstyle=\"font-size: 12px;white-space: nowrap\">{{$ctrl.calculateTimeSinceLastRead(case)}}</span></div></div></div>\n</md-content><div class=\"cases-pagination\" ng-if=\"!searchModeOn\"><div class=\"left-button\"><button type=\"button\" \nname=\"button\" class=\"previous-page-slide\" ng-click=\"scrollPaginationLeft()\" \nng-show=\"isPaginationScrollable && isLeftScrollPossible\"><span>&#8249;</span></button></div><div class=\"page-buttons\">\n<div class=\"button-container pagination-scroll\" ng-show=\"showCasePagination\"><button \nng-repeat=\"page in allPages() track by $index\" class=\"page\" ng-click=\"$ctrl.goToCasePage($index + 1)\" \nng-class=\"{\'active\': $ctrl.currentCasesPagination==$index + 1}\">{{$index + 1}}</button></div></div><div \nclass=\"right-button\"><button type=\"button\" name=\"button\" class=\"next-page-slide\" ng-click=\"scrollPaginationRight()\" \nng-show=\"isPaginationScrollable && isRightScrollPossible\"><span>&#8250;</span></button></div></div>");
$templateCache.put("app/main/clinician/cases/views/read/read-view.html","<md-content ng-if=\"$ctrl.selectedCase\" scroll-glue><div class=\"case-content\"><div class=\"info\" flex=\"none\" \nlayout=\"row\" layout-align=\"space-between start\"></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"details\" layout=\"row\" layout-align=\"start start\"><div layout=\"column\"><md-icon md-font-icon=\"icon-clock\" \nstyle=\"color: rgb(146,41,140)\"></md-icon></div><div layout=\"column\"><span class=\"detail\" style=\"padding-top:3px\">\nUpdated: <span class=\"caseCreatorLabel\" style=\"padding-top:0px\">{{$ctrl.app.getTimeString($ctrl.selectedCase.updated)}}\n</span></span></div></div></div><div layout=\"column\" layout-align=\"start start\"><div class=\"details\" layout=\"row\" \nlayout-align=\"start start\"><div layout=\"column\"><span class=\"caseCreateLabels\" style=\"padding-top: 0px\">\n&nbsp&nbsp&nbspClinician:&nbsp</span></div><div layout=\"column\"><span class=\"caseCreatorLabel\" style=\"padding-top:0px\">\n{{$ctrl.getRecipients()}}</span></div></div></div><div layout=\"column\" layout-align=\"start start\" \nng-show=\"$ctrl.selectedCase.patient\"><div class=\"details\" layout=\"row\" layout-align=\"start start\"><div layout=\"column\">\n<span class=\"caseCreateLabels\" style=\"padding-top: 0px\">&nbsp&nbsp&nbsp&nbsp&nbsp&nbspPatient:&nbsp</span></div><div \nlayout=\"column\"><span class=\"caseCreatorLabel\" style=\"padding-top:0px\">\n{{$ctrl.userService.getLongName($ctrl.selectedCase.patient)}} {{$ctrl.selectedCase.patient.ref}}</span></div></div>\n</div><div layout=\"column\" layout-align=\"start start\"><div class=\"details\" layout=\"row\" layout-align=\"start start\"><div\n layout=\"column\"><span class=\"caseCreatorLabels\" style=\"padding-top:0px\">\n{{$ctrl.selectedCase.patient.dob? \"&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbspD.O.B.:&nbsp&nbsp&nbsp\" : \" \"}}\n</span></div><div layout=\"column\"><span class=\"caseCreatorLabel\" style=\"padding-top:0px\">\n{{$ctrl.selectedCase.patient.dob? $ctrl.selectedCase.patient.dob : \" \"}}</span></div></div></div></div><div \nclass=\"case-chat-title\">Messages</div><md-content class=\"case-chat-content\" auto-scroll-bottom=\"$ctrl.displayChats\">\n<span ng-if=\"!$ctrl.displayChats.length\" style=\"color:gray;font-style:italic\">\nNo additional messages at this point in time.</span><div class=\"case-chat-content-empty\" \nng-if=\"!$ctrl.displayChats.length\">Send your first message now...</div><div ng-if=\"$ctrl.displayChats.length\" \nng-repeat=\"chat in $ctrl.displayChats track by $index\" class=\"chat-content-item\" ng-class=\"chat.class\"><div \nlayout=\"column\"><div class=\"chat-time\"><span style=\"color: black\"><b>\n{{$ctrl.app.getNameOfMessageOwner($ctrl.selectedCase,chat,$ctrl.getCurrentUserID())}}</b><span>\n {{$ctrl.app.getTimeAndDateOfChat(chat.timestamp)}}</span></span></div><div class=\"chat-content-bubble\" \nng-if=\"chat.type === 30 || chat.type === 32\"><a href=\"{{$ctrl.getFileSource(chat.data)}}\" data-lightbox=\"{{chat.id}}\">\n<thumbnail file-type=\"image\" source=\"{{$ctrl.getFileSource(chat.data)}}\" max-height=\"300\" max-width=\"300\"></thumbnail>\n</a></div><div class=\"chat-content-bubble\" \nng-if=\"chat.type !== 30 && chat.type !== 10 && chat.type !== 32 && chat.type !== 62 && chat.type !== 60\" \nng-bind-html=\"$ctrl.removeNewLines(chat.data)\"></div><div class=\"chat-content-bubble\" ng-if=\"chat.type === 10\"><a \nhref=\"#\" ng-click=\"$ctrl.openVideoInPopup(chat.data)\"><thumbnail file-type=\"video\" \nsource=\"{{$ctrl.setVidConfig(chat.data)}}\" max-height=\"225\" max-width=\"207\"></thumbnail></a></div><div \nclass=\"chat-content-bubble\" ng-if=\"chat.type === 62 || chat.type === 60\"><a href=\"#\" \nng-click=\"$ctrl.openPDFInPopup(chat.data)\"><thumbnail file-type=\"pdf\" source=\"{{$ctrl.getFileSource(chat.data)}}\" \nmax-height=\"225\" max-width=\"207\"></thumbnail></a></div></div></div></md-content><form ng-submit=\"$ctrl.sendMessage()\">\n<div class=\"info\" flex layout=\"column\"><md-input-container flex md-no-float><textarea flex class=\"md-input\" \ntype=\"text\" ng-model=\"$ctrl.newMessage\" placeholder=\"Enter message...\">\n                </textarea>\n</md-input-container></div><div class=\"info\" flex layout=\"row\" layout-align=\"end end\"><md-button \nclass=\"md-fab md-mini\" aria-label=\"Upload\" type=\"submit\" ngf-select=\"$ctrl.genericFileUpload($file, $invalidFiles)\" \naccept=\"application/pdf,image/*,video/*\" ga-track-event=\"[\'Button\', \'Click\', \'upload-file-clicked\']\"><md-icon \nmd-font-icon=\"icon-paperclip\"></md-icon></md-button><md-button class=\"md-raised md-accent\" aria-label=\"Send\" \ntype=\"submit\" ga-track-event=\"[\'Button\', \'Click\', \'add-message-clicked\']\">Send&nbsp;&nbsp;<md-icon \nmd-font-icon=\"icon-telegram\"></md-icon></md-button></div></form></md-content>");
$templateCache.put("app/main/clinician/cases/views/read/read-view2.html","<div \nstyle=\"left: 0;top: 0;width: 100%;background-color: #ffffff;height:auto;border-bottom: 1px solid rgba(0,0,0,0.12)\" \nng-show=\"$ctrl.selectedCase\"><md-toolbar layout=\"row\" style=\"background-color: #FFFFFF\" class=\"only-mobile\" \nng-show=\"isCaseLoaded\"><div class=\"md-toolbar-tools\"><div style=\"color: #0899ff;font-size:16px;cursor:pointer\" \nng-click=\"$ctrl.showCaseList()\">&#x2190; Back</div><div class=\"createpageHeaderButtons\" \nstyle=\"color: #0899ff;margin-left: auto\"><img src=\"/assets/images/more50.png\" style=\"width:25px;cursor:pointer\" \nng-click=\"$ctrl.openMoreActionsMobile()\"></div></div></md-toolbar><div class=\"hide-sm hide-xs\"><md-card-actions \nlayout=\"row\" style=\"margin-top: 15px;margin-left:9px\"><md-card-icon-actions layout-align=\"start center\"><span \nclass=\"caseTitle\" style=\"padding-left: 6px\">{{$ctrl.selectedCase.title ? $ctrl.selectedCase.title : \'Untitled Chat\'}} \n<span class=\"inboxCasePriorityUrgent\" \nng-show=\"$ctrl.selectedCase.priority == 50 && $ctrl.selectedCase.creator.personId !== $ctrl.context.user.personId\" \nng-show=\"\">URGENT</span> <span class=\"inboxCasePriorityHigh\" \nng-show=\"$ctrl.selectedCase.priority == 40 && $ctrl.selectedCase.creator.personId !== $ctrl.context.user.personId\">HIGH\n</span></span></md-card-icon-actions><span flex></span><md-card-icon-actions layout-align=\"start right\" \nstyle=\"display: flex\" ng-show=\"isCaseLoaded\"><md-menu-bar><md-menu md-position-mode=\"right bottom\"><md-button \naria-label=\"Open phone interactions menu\" class=\"md-icon-button\" ng-click=\"$ctrl.openCaseMenu($mdMenu, $event)\">\n<md-icon md-menu-origin md-svg-src=\"/assets/images/more_vert_dark.svg\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item ng-show=\"$ctrl.selectedCase.creator.personId === $ctrl.context.user.personId\"><md-button \nng-click=\"$ctrl.toggleRight()\">Add/Remove Recipients</md-button></md-menu-item><md-menu-item \nng-show=\"$ctrl.selectedCase.creator.personId === $ctrl.context.user.personId\"><md-button \nng-click=\"$ctrl.archiveThisCase()\">Archive</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"$ctrl.downloadCaseInPDF()\">Download</md-button></md-menu-item><md-menu-item \nng-show=\"$ctrl.selectedCase.creator.personId !== $ctrl.context.user.personId\"><md-button \nng-click=\"$ctrl.requestCaseOwnership()\">Request chat ownership</md-button></md-menu-item><md-menu-item \nng-show=\"$ctrl.selectedCase.creator.personId !== $ctrl.context.user.personId\"><md-button ng-click=\"$ctrl.exitCase()\">\nExit chat</md-button></md-menu-item><md-menu-item \nng-show=\"$ctrl.selectedCase.creator.personId === $ctrl.context.user.personId\"><md-button \nng-click=\"$ctrl.transferCase()\">Transfer chat ownership</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar></md-card-icon-actions></md-card-actions><div style=\"display: flex;flex: 1;margin-top: 12px\" \nng-show=\"$ctrl.selectedCase.creator.personId === $ctrl.context.user.personId\"><br><aside \nstyle=\"min-width:140px;margin-top: 10px\"><span class=\"casePatientLabel\">Priority</span></aside><aside><md-select \nname=\"priority\" ng-model=\"$ctrl.priority\" class=\"casePriorityCombo\" ng-change=\"$ctrl.updateCasePriority()\" \naria-label=\"Priority\"><md-option value=\"20\" ng-selected=\"$ctrl.priority === 20\"><span class=\"casePriorityNormal\" \nstyle=\"margin-left: 32px\"></span>&nbsp;None</md-option><md-option value=\"40\" ng-selected=\"$ctrl.priority === 40\"><span \nclass=\"casePriorityHigh\" style=\"margin-left: 32px\"></span>&nbsp;High</md-option><md-option value=\"50\" \nng-selected=\"$ctrl.priority === 50\"><span class=\"casePriorityUrgent\" style=\"margin-left: 32px\"></span>&nbsp;Urgent\n</md-option></md-select></aside></div><div style=\"display: flex;flex: 1;margin-top: 12px\"><aside \nstyle=\"min-width:140px\"><span class=\"casePatientLabel\">Patient</span></aside><aside><span class=\"casePatientName\" \nng-show=\"$ctrl.userService.getLongNamePatient($ctrl.selectedCase.patient)\">\n{{$ctrl.userService.getLongNamePatient($ctrl.selectedCase.patient)}} </span><span class=\"casePatientName\" \nng-show=\"!$ctrl.userService.getLongNamePatient($ctrl.selectedCase.patient)\">Undisclosed</span><md-icon \nmd-font-icon=\"icon-pencil-box-outline\" class=\"icon\" \nstyle=\"color:#92298D;font-size: 25px;cursor: pointer;margin-bottom: 5px\" \nng-show=\"$ctrl.selectedCase.creator.personId === $ctrl.context.user.personId\" ng-click=\"$ctrl.openEditPatient()\">\n<md-tooltip class=\"hide-xs\">Click to Edit patient</md-tooltip></md-icon><br><span class=\"casePatientDetails\" \nng-show=\"$ctrl.showMRN\">MRN: {{$ctrl.selectedCase.patient.ref}}&nbsp;&nbsp;&nbsp;</span> <span \nclass=\"casePatientDetails\" ng-show=\"$ctrl.patientHasDOB()\">D.O.B: {{$ctrl.selectedCase.patient.dob}}</span> <img \nsrc=\"assets/images/info.png\" style=\"padding-top: 2px\" ng-show=\"$ctrl.patientHasRefNo()\" \nng-click=\"$ctrl.showReferenceNumber()\"></aside></div><div ng-show=\"showRecipients\" class=\"recipientsDiv\"><aside \nstyle=\"min-width:140px\"><span class=\"casePatientLabel\">{{$ctrl.getNumberofRecipients()}}</span></aside><aside><table>\n<tr ng-show=\"$ctrl.getReadRecipientsName($ctrl.selectedCase)\"><td style=\"vertical-align:top\"><span \nclass=\"caseReadUnreadStatus\">Read by</span></td><td><span class=\"caseRecipients\">\n{{$ctrl.getReadRecipientsName($ctrl.selectedCase)}} </span></td></tr><tr \nng-show=\"$ctrl.getUnReadRecipientsName($ctrl.selectedCase)\"><td style=\"vertical-align:top\"><span \nclass=\"caseReadUnreadStatus\">Unread &nbsp</span></td><td><span class=\"caseRecipients\" style=\"color: #A9A9A9\">\n{{$ctrl.getUnReadRecipientsName($ctrl.selectedCase)}} </span></td></tr></table></aside></div><md-button \nclass=\"md-primary toggle-recipients\" ng-click=\"toggleRecipients()\">Show <span>{{toggleInstruction}}</span>&nbsp;\n<md-icon md-font-icon=\"icon-blue-down\" ng-show=\"!showRecipients\" class=\"icon s16 icon-down-adjust\"></md-icon><md-icon \nmd-font-icon=\"icon-blue-up\" ng-show=\"showRecipients\" class=\"icon s16 icon-down-adjust\"></md-icon></md-button>\n<md-card-actions layout=\"row\" layout-align=\"end end\" style=\"margin-bottom: 5px\"><div class=\"fileImage\" \nstyle=\"cursor:pointer;padding-left: 13px;padding-bottom: 4px\" ng-click=\"$ctrl.showTags()\"><img \nsrc=\"assets/images/tags.png\" style=\"height:30px;width:30px\"></div><div class=\"fileImage\" \nstyle=\"cursor:pointer;padding-left: 13px;padding-bottom: 6px\" ng-click=\"$ctrl.toggleGallery()\" \nng-show=\"$ctrl.getTotalAttachements() >0\"><img src=\"assets/images/files.png\" style=\"height:26px;width:26px\"><div \nclass=\"fileCountCentered caseAttachementCount\" style=\"padding-top:6px;padding-bottom: 6px;padding-left: 6px\">\n{{$ctrl.getTotalAttachements()}}</div></div></md-card-actions></div></div><div id=\"conversation\" scroll-glue \nng-show=\"$ctrl.selectedCase\" style=\"margin-bottom:40px;max-height: 76vh\"><div \nng-repeat=\"chat in $ctrl.displayChats track by $index\"><div class=\"md-list-item-text disable-context-menu\" \nlayout=\"column\" layout-align=\"end end\" \nng-if=\"$ctrl.validMessage(chat) && (chat.doesMessageBelongToMe && chat.type !== 90 && chat.currentLoadMore <= moreMessageCounter)\" \nstyle=\"padding-top:28px;padding-bottom:28px\"><span class=\"inboxMessageDate\" \nstyle=\"padding-bottom: 8px;padding-right:40px\">{{$ctrl.getTimeAndDateOfChat(chat.timestamp)}} </span><span \nclass=\"inboxTextChat\" ng-if=\"chat.type === 40\" \nstyle=\"background-color: #f3f7fd;word-wrap:break-word;margin-right: 36px\" ng-bind-html=\"chat.data\"></span> <span \nclass=\"thumbnailInageCase linear-background\" ng-if=\"chat.type === 60 && chat.currentLoadMore <= moreMessageCounter\" \nid=\"{{chat.id}}\" tabindex=\"{{chat.id}}\" ng-click=\"$ctrl.openPDFInPopup(chat.data)\" \nstyle=\"background-color: #f3f7fd;cursor: pointer;margin-right: 36px;overflow:hidden\"><thumbnail file-type=\"pdf\" \nsource=\"{{$ctrl.getFileSource(chat.data)}}\" max-height=\"224\" max-width=\"206\" style=\"display:none\"></thumbnail><img \nng-src=\"{{chat.previewData}}\" max-height=\"224\" max-width=\"206\" \nonerror=\"angular.element(this).scope().pdfThumbNailError(this)\"> </span><span \nclass=\"thumbnailInageCase linear-background\" ng-if=\"chat.type === 10 && chat.currentLoadMore <= moreMessageCounter\" \nid=\"{{chat.id}}\" tabindex=\"{{chat.id}}\" \nstyle=\"background-color: #f3f7fd;cursor: pointer;position: relative;margin-right: 36px\" \nng-click=\"$ctrl.openVideoInPopup(chat.data)\"><thumbnail file-type=\"video\" source=\"{{$ctrl.setVidConfig(chat.data)}}\" \nmax-height=\"224\" max-width=\"206\" style=\"display:none\"></thumbnail><img ng-src=\"{{chat.previewData}}\" max-height=\"224\" \nmax-width=\"206\" onerror=\"angular.element(this).scope().imgError(this)\"><md-icon md-font-icon=\"icon-play-video\" \nstyle=\"position: absolute;top: 46%;left: 42%;transform: translate(-50%, -50%);font-size: 40px\"></md-icon></span><span \nclass=\"thumbnailInageCase linear-background\" ng-if=\"chat.type === 30 && chat.currentLoadMore <= moreMessageCounter\" \nid=\"{{chat.id}}\" tabindex=\"{{chat.id}}\" style=\"background-color: #f3f7fd;margin-right: 36px\"><a \nhref=\"{{$ctrl.getFileSource(chat.data)}}\" data-lightbox=\"{{chat.id}}\"><img ng-src=\"{{chat.previewData}}\" height=\"224\" \nwidth=\"206\" onerror=\"angular.element(this).scope().imageThumbnailError(this,chat.id)\"></a></span></div><div \nclass=\"md-list-item-text disable-context-menu\" layout=\"column\" layout-align=\"start start\" \nng-if=\"$ctrl.validMessage(chat) && (!chat.doesMessageBelongToMe && chat.type !== 90 && chat.currentLoadMore <= moreMessageCounter)\" \nstyle=\"padding-top:28px;padding-bottom:28px\"><div layout=\"row\" layout-align=\"start center\"><div \nstyle=\"padding-left:40px;padding-bottom: 6px\"><span class=\"inboxMessageOwner\" style=\"padding-bottom:7px\">\n{{$ctrl.app.getNameOfMessageOwner($ctrl.selectedCase,chat,$ctrl.getCurrentUserID())}}</span> &nbsp&nbsp <span \nclass=\"inboxMessageDate\" style=\"padding-bottom:8px\">{{$ctrl.getTimeAndDateOfChat(chat.timestamp)}}</span></div></div>\n<span class=\"inboxTextChat\" ng-if=\"chat.type === 40 && chat.currentLoadMore <= moreMessageCounter\" \nstyle=\"word-wrap:break-word;margin-left: 36px\" ng-bind-html=\"chat.data\"></span> <span \nclass=\"thumbnailInageCase linear-background\" ng-if=\"chat.type === 60 && chat.currentLoadMore <= moreMessageCounter\" \nid=\"{{chat.id}}\" tabindex=\"{{chat.id}}\" ng-click=\"$ctrl.openPDFInPopup(chat.data)\" \nstyle=\"cursor: pointer;margin-left: 36px;overflow:hidden\"><thumbnail file-type=\"pdf\" \nsource=\"{{$ctrl.getFileSource(chat.data)}}\" max-height=\"224\" max-width=\"206\" style=\"display:none\"></thumbnail><img \nng-src=\"{{chat.previewData}}\" max-height=\"224\" max-width=\"206\" \nonerror=\"angular.element(this).scope().pdfThumbNailError(this)\"> </span><span \nclass=\"thumbnailInageCase linear-background\" ng-if=\"chat.type === 10 && chat.currentLoadMore <= moreMessageCounter\" \nid=\"{{chat.id}}\" tabindex=\"{{chat.id}}\" ng-click=\"$ctrl.openVideoInPopup(chat.data)\" \nstyle=\"cursor: pointer;position: relative;margin-left: 36px\"><thumbnail file-type=\"video\" \nsource=\"{{$ctrl.setVidConfig(chat.data)}}\" max-height=\"224\" max-width=\"206\" style=\"display:none\"></thumbnail><img \nng-src=\"{{chat.previewData}}\" max-height=\"224\" max-width=\"206\" onerror=\"angular.element(this).scope().imgError(this)\">\n<md-icon md-font-icon=\"icon-play-video\" \nstyle=\"position: absolute;top: 46%;left: 42%;transform: translate(-50%, -50%);font-size: 40px\"></md-icon></span><span \nclass=\"thumbnailInageCase linear-background\" ng-if=\"chat.type === 30 && chat.currentLoadMore <= moreMessageCounter\" \nid=\"{{chat.id}}\" tabindex=\"{{chat.id}}\" style=\"margin-left: 36px\"><a href=\"{{$ctrl.getFileSource(chat.data)}}\" \ndata-lightbox=\"{{chat.id}}\"><img ng-src=\"{{chat.previewData}}\" height=\"224\" width=\"206\" \nonerror=\"angular.element(this).scope().imageThumbnailError(this,chat.id)\"></a></span></div><div \nng-if=\"chat.type === 4 && chat.currentLoadMore === moreMessageCounter\" layout=\"row\" layout-align=\"center center\" \nstyle=\"width:100%;margin-bottom: 40px; margin-top: 16px;cursor:pointer\" ng-click=\"$ctrl.showMoreMessages()\"><span \nclass=\"emptySpace\">&nbsp;</span><div layout=\"column\" layout-align=\"center center\" style=\"margin-bottom: 20px\"><span \nclass=\"recipientNotificationText\" style=\"background-color: #0899ff;border: solid 1px #0899ff\">{{chat.loadMoreMessage}}\n</span></div><span class=\"emptySpace\">&nbsp;</span></div><div \nng-if=\"chat.type === 90 && chat.currentLoadMore <= moreMessageCounter\" layout=\"row\" layout-align=\"center center\" \nclass=\"recipientDivider\" style=\"width:100%;margin-bottom: 40px; margin-top: 72px\"><span class=\"emptySpace\">&nbsp;\n</span><div layout=\"column\" layout-align=\"center center\" style=\"margin-bottom: 20px\"><span class=\"inboxMessageDate\" \nstyle=\"padding-bottom: 7px\">{{$ctrl.getTimeAndDateOfChat(chat.timestamp)}}</span><span \nclass=\"recipientNotificationText\"><md-icon md-font-icon=\"icon-bell\" \nstyle=\"color:#ffffff;padding-right: 30px;font-size: 20px\"></md-icon>{{$ctrl.getRecipientNotification(chat.data)}}\n</span></div><span class=\"emptySpace\">&nbsp;</span></div></div><div id=\"uploadindMediaSpinner\" layout=\"column\" \nlayout-align=\"center center\" style=\"text-align: center;display:none\"><svg width=\"70\" height=\"20\"><rect width=\"20\" \nheight=\"20\" x=\"0\" y=\"0\" rx=\"3\" ry=\"3\" style=\"fill: #92298C\"><animate attributeName=\"width\" values=\"0;20;20;20;0\" \ndur=\"1000ms\" repeatCount=\"indefinite\"/><animate attributeName=\"height\" values=\"0;20;20;20;0\" dur=\"1000ms\" \nrepeatCount=\"indefinite\"/><animate attributeName=\"x\" values=\"10;0;0;0;10\" dur=\"1000ms\" repeatCount=\"indefinite\"/>\n<animate attributeName=\"y\" values=\"10;0;0;0;10\" dur=\"1000ms\" repeatCount=\"indefinite\"/></rect><rect width=\"20\" \nheight=\"20\" x=\"25\" y=\"0\" rx=\"3\" ry=\"3\" style=\"fill: #92298C\"><animate attributeName=\"width\" values=\"0;20;20;20;0\" \nbegin=\"200ms\" dur=\"1000ms\" repeatCount=\"indefinite\"/><animate attributeName=\"height\" values=\"0;20;20;20;0\" \nbegin=\"200ms\" dur=\"1000ms\" repeatCount=\"indefinite\"/><animate attributeName=\"x\" values=\"35;25;25;25;35\" begin=\"200ms\" \ndur=\"1000ms\" repeatCount=\"indefinite\"/><animate attributeName=\"y\" values=\"10;0;0;0;10\" begin=\"200ms\" dur=\"1000ms\" \nrepeatCount=\"indefinite\"/></rect><rect width=\"20\" height=\"20\" x=\"50\" y=\"0\" rx=\"3\" ry=\"3\" style=\"fill: #92298C\"><animate\n attributeName=\"width\" values=\"0;20;20;20;0\" begin=\"400ms\" dur=\"1000ms\" repeatCount=\"indefinite\"/><animate \nattributeName=\"height\" values=\"0;20;20;20;0\" begin=\"400ms\" dur=\"1000ms\" repeatCount=\"indefinite\"/><animate \nattributeName=\"x\" values=\"60;50;50;50;60\" begin=\"400ms\" dur=\"1000ms\" repeatCount=\"indefinite\"/><animate \nattributeName=\"y\" values=\"10;0;0;0;10\" begin=\"400ms\" dur=\"1000ms\" repeatCount=\"indefinite\"/></rect></svg></div></div>\n<md-sidenav class=\"md-sidenav-right ie-width-fix\" md-component-id=\"right\" style=\"background-color: #ffffff\"><div \nstyle=\"display: flex; flex-flow: column; height: 100%\"><div><md-toolbar layout=\"row\"><div class=\"md-toolbar-tools\" \nstyle=\"background-color:#92298C\"><md-button class=\"md-icon-button\" aria-label=\"Close Side Panel\" \nng-click=\"$ctrl.closeSideNavPanel()\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#FFFFFF\"></md-icon></md-button><div class=\"createpageHeaderButtons\" \nstyle=\"cursor:pointer;color: #ffffff;margin-left: auto\" ng-click=\"$ctrl.addAndRemoveRecipients()\">Save</div></div>\n</md-toolbar></div><div style=\"min-height: 0; flex: 1; overflow: auto\"><md-content style=\"background-color: #ffffff\">\n<md-card style=\"background-color: #ffffff;box-shadow: 0px 0px\"><md-card-title><md-card-title-text><span \nclass=\"selectRecipientsHeader\">Add or remove recipients</span><br><span class=\"selectRecipientsBody\">\nSelect to Add a recipient. Un-select to remove a recipient.</span></md-card-title-text></md-card-title><md-card-title>\n<md-card-title-text><input type=\"text\" ng-model=\"$ctrl.searchRecipient\" name=\"search\" placeholder=\"Search contact\" \nstyle=\"height: 40px;width: 250px;box-sizing: border-box;border: 1px solid #eaeaea;border-radius: 14px;font-family: Roboto;font-size: 16px;font-weight: normal;font-style: normal;font-stretch: normal;line-height: normal;letter-spacing: 0.3px;background-color: white;background-image: url(\'assets/images/search.png\');background-position: right;background-repeat: no-repeat;padding: 12px 20px 12px 16px;background-position: 350px 12px\">\n</md-card-title-text></md-card-title><div layout=\"row\" layout-align=\"center\" ng-show=\"$ctrl.recipientsLoaded\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-repeat=\"contact in $ctrl.profileSpecificContacts | filter: $ctrl.searchRecipient track by $index\"><md-card-title>\n<div style=\"display: flex;flex: 1\"><aside><div class=\"container\"><div class=\"round\"><input type=\"checkbox\" \nid=\"{{$index}}\" ng-model=\"contact.selected\"><label for=\"{{$index}}\"></label></div></div></aside><aside \nclass=\"caseCreatorLabel\" style=\"padding-top:0px;padding-left:23px\" ng-show=\"!contact.isGroup\">\n{{contact.title}} {{contact.lastname}}, {{contact.firstname}}<br ng-show=\"contact.profession\"><span \nclass=\"clinicianJobTitle\" style=\"font-style: normal\">{{contact.profession}}</span><br><span \nstyle=\"color: #0899ff;font-size: 13px !important;font-weight: 500;letter-spacing: 0.010em;line-height: 1.6em;font-family: Roboto\">\n{{$ctrl.getOrganization(contact)}}</span></aside><aside class=\"caseCreatorLabel\" \nstyle=\"padding-top:0px;padding-left:23px\" ng-show=\"contact.isGroup\">{{contact.name}}<br><span \nstyle=\"color: #0899ff;font-size: 13px !important;font-weight: 500;letter-spacing: 0.010em;line-height: 1.6em;font-family: Roboto\">\n{{$ctrl.context.currentRole.formattedOrganizationName}}</span> <span class=\"clinicianJobTitle\" \nstyle=\"font-style: normal;cursor:pointer;color: #0899ff;display: block;line-height: 7px\" \nid=\"{{contact.aliasKey}}-show\" ng-click=\"$ctrl.showGroupMembers(contact.aliasKey)\" \nng-show=\"contact.members && contact.members.length >0\"><br>Show all members <span style=\"font-size:16px\">&#8702;</span>\n</span><div id=\"{{contact.aliasKey}}-member-details\" style=\"display: none;margin-top: -18px\" \nng-show=\"contact.members && contact.members.length >0\"><span class=\"clinicianJobTitle\" style=\"font-style: normal\" \nng-repeat=\"memberDetail in contact.members\"><br>{{memberDetail}}</span></div><span class=\"clinicianJobTitle\" \nstyle=\"font-style: normal\" ng-show=\"!(contact.members && contact.members.length >0)\"><br>This group has no members\n</span> <span class=\"clinicianJobTitle\" \nstyle=\"font-style: normal;cursor:pointer;color: #0899ff;display: none;line-height: 7px\" id=\"{{contact.aliasKey}}-hide\" \nng-click=\"$ctrl.hideGroupMembers(contact.aliasKey)\" ng-show=\"contact.members && contact.members.length >0\"><br><span \nstyle=\"font-size:16px\">&#8701;</span> Hide all members</span></aside></div></md-card-title><md-divider ng-hide=\"$last\">\n</md-divider></div></md-card></md-content></div></div></md-sidenav><md-sidenav class=\"md-sidenav-right ie-width-fix\" \nmd-component-id=\"transferOwnership\" style=\"background-color: #ffffff\"><div \nstyle=\"display: flex; flex-flow: column; height: 100%\"><div><md-toolbar layout=\"row\"><div class=\"md-toolbar-tools\" \nstyle=\"background-color:#92298C\"><md-button class=\"md-icon-button\" aria-label=\"Close Side Panel\" \nng-click=\"$ctrl.closeCaseTransferSideNav()\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#FFFFFF\"></md-icon></md-button></div></md-toolbar></div><div \nstyle=\"min-height: 0; flex: 1; overflow: auto\"><md-content style=\"background-color: #ffffff\"><md-card \nstyle=\"background-color: #ffffff;box-shadow: 0px 0px\"><md-card-title><md-card-title-text><span \nclass=\"selectRecipientsHeader\">All requests</span><br></md-card-title-text></md-card-title><md-card-title>\n<md-card-title-text><input type=\"text\" ng-model=\"$ctrl.$scope.changeOwnerRequestSearch\" name=\"search\" \nplaceholder=\"Search\" \nstyle=\"height: 40px;width: 250px;box-sizing: border-box;border: 1px solid #eaeaea;border-radius: 14px;font-family: Roboto;font-size: 16px;font-weight: normal;font-style: normal;font-stretch: normal;line-height: normal;letter-spacing: 0.3px;background-color: white;background-image: url(\'assets/images/search.png\');background-position: right;background-repeat: no-repeat;padding: 12px 20px 12px 16px;background-position: 350px 12px\">\n</md-card-title-text></md-card-title><div \nng-repeat=\"transferRequest in $ctrl.$scope.pendingCaseTransfers | filter: $ctrl.$scope.changeOwnerRequestSearch track by $index\">\n<md-card-title><div style=\"display: flex;flex: 1\"><aside><div class=\"container\"><div class=\"round\" \nng-click=\"$ctrl.changeOwnership(transferRequest)\"><input type=\"checkbox\" id=\"{{$index}}\" ng-model=\"contact.selected\">\n<label for=\"{{$index}}\"></label></div></div></aside><aside class=\"caseCreatorLabel\" \nstyle=\"padding-top:0px;padding-left:23px\">\n{{transferRequest.title}} {{transferRequest.lastName}}, {{transferRequest.firstName}}<br \nng-show=\"transferRequest.profession\"><span class=\"clinicianJobTitle\" style=\"font-style: normal\">\n{{transferRequest.profession}}</span><br><span \nstyle=\"color: #0899ff;font-size: 13px !important;font-weight: 500;letter-spacing: 0.010em;line-height: 1.6em;font-family: Roboto\">\n{{$ctrl.getRequestorOrganization(transferRequest.orgId)}}</span></aside></div></md-card-title><md-divider \nng-hide=\"$last\"></md-divider></div></md-card></md-content></div></div></md-sidenav><md-sidenav \nclass=\"md-sidenav-right ie-width-fix\" md-component-id=\"moreActionsMobile\" style=\"background-color: #ffffff\"><div \nstyle=\"display: flex; flex-flow: column; height: 100%\"><div><md-toolbar layout=\"row\"><div class=\"md-toolbar-tools\" \nstyle=\"background-color:#FFFFFF\"><md-button class=\"md-icon-button\" aria-label=\"Close Side Panel\" \nng-click=\"$ctrl.closeMoreActions()\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" \nstyle=\"color:#000000\"></md-icon></md-button></div></md-toolbar></div><div \nstyle=\"min-height: 0; flex: 1; overflow: auto\"><div style=\"margin-left: 20px\"><span \nstyle=\"font-family: Roboto;font-size: 10px;line-height: normal;letter-spacing: 0.12px;color: #494949\">Case Title</span>\n<br><span style=\"font-family: Roboto;font-size: 17px;font-weight: 600;line-height: normal;color: #030303\">\n{{$ctrl.selectedCase.title ? $ctrl.selectedCase.title : \'Untitled Chat\'}}</span></div><div \nstyle=\"margin-left: 20px;margin-top: 20px\"><span \nstyle=\"font-family: Roboto;font-size: 10px;line-height: normal;letter-spacing: 0.12px;color: #494949\">Patient</span>\n<br><span style=\"font-family: Roboto;font-size: 14px;font-weight: 600;line-height: normal;color: #030303\" \nng-show=\"$ctrl.userService.getLongNamePatient($ctrl.selectedCase.patient)\">\n{{$ctrl.userService.getLongNamePatient($ctrl.selectedCase.patient)}} </span><span \nstyle=\"font-family: Roboto;font-size: 14px;font-weight: 600;line-height: normal;color: #030303\" \nng-show=\"!$ctrl.userService.getLongNamePatient($ctrl.selectedCase.patient)\">Undisclosed </span><img \nsrc=\"assets/images/edit.png\" style=\"cursor:pointer;margin-left: 10px;padding-top: 2px\" \nng-show=\"$ctrl.selectedCase.creator.personId === $ctrl.context.user.personId\" ng-click=\"$ctrl.openEditPatient()\"> <span\n ng-show=\"$ctrl.selectedCase.creator.personId === $ctrl.context.user.personId\" ng-click=\"$ctrl.openEditPatient()\" \nstyle=\"cursor:pointer;font-weight: 500;letter-spacing: 0.010em;line-height: 1.6em;font-size: 13px;color: #0899ff;margin-left: 7px\">\nEdit patient</span><br><span class=\"casePatientDetails\" ng-show=\"$ctrl.showMRN\">\nMRN: {{$ctrl.selectedCase.patient.ref}}&nbsp;&nbsp;&nbsp;</span> <span class=\"casePatientDetails\" \nng-show=\"$ctrl.patientHasDOB()\">D.O.B: {{$ctrl.selectedCase.patient.dob}}</span> <img src=\"assets/images/info.png\" \nstyle=\"padding-top: 2px\" ng-show=\"$ctrl.patientHasRefNo()\" ng-click=\"$ctrl.showReferenceNumber()\"></div><div \nstyle=\"margin-left: 20px;margin-top: 20px\"><span \nstyle=\"font-family: Roboto;font-size: 10px;line-height: normal;letter-spacing: 0.12px;color: #494949;font-style: italic\">\nRead by</span><br><span class=\"organizationName\" style=\"font-style: italic\">\n{{$ctrl.getReadRecipientsName($ctrl.selectedCase)}}</span></div><div style=\"margin-left: 20px\" \nng-show=\"$ctrl.getUnReadRecipientsName($ctrl.selectedCase).length > 0\"><span \nstyle=\"font-family: Roboto;font-size: 10px;line-height: normal;letter-spacing: 0.12px;color: #494949;font-style: italic\">\nUnread by</span><br><span class=\"organizationName\" style=\"font-style: italic\">\n{{$ctrl.getUnReadRecipientsName($ctrl.selectedCase)}}</span></div><div style=\"margin-left: 20px;margin-top: 20px\" \nng-show=\"$ctrl.selectedCase.creator.personId === $ctrl.context.user.personId\"><span \nstyle=\"font-family: Roboto;font-size: 10px;line-height: normal;letter-spacing: 0.12px;color: #494949\">Priority\n<md-select name=\"priority\" ng-model=\"$ctrl.priority\" class=\"casePriorityCombo\" ng-change=\"$ctrl.updateCasePriority()\" \nstyle=\"width: 117px;height: 32px\"><md-option value=\"20\" ng-selected=\"$ctrl.priority === 20\"><span \nclass=\"casePriorityNormal\" style=\"margin-left: 32px\"></span>&nbsp;None</md-option><md-option value=\"40\" \nng-selected=\"$ctrl.priority === 40\"><span class=\"casePriorityHigh\" style=\"margin-left: 32px\"></span>&nbsp;High\n</md-option><md-option value=\"50\" ng-selected=\"$ctrl.priority === 50\"><span class=\"casePriorityUrgent\" \nstyle=\"margin-left: 32px\"></span>&nbsp;Urgent</md-option></md-select></span></div><md-card \nstyle=\"background-color: #ffffff;box-shadow: 0px 0px\"><div><md-card-title><md-card-title-text><span \nclass=\"selectRecipientsHeader\" style=\"width:385px\">More actions</span><br></md-card-title-text></md-card-title><div>\n<md-card-title><md-card-title-text><div layout=\"row\"><img src=\"/assets/images/case-download-outline.png\" \nstyle=\"cursor:pointer;width:25px;height:25px\" ng-click=\"$ctrl.downloadCaseInPDF()\"> <span \nstyle=\"margin-left: 10px;font-family: Roboto;font-size: 16px;font-weight: 600;line-height: normal;letter-spacing: -0.5px;color: #92298D; cursor: pointer;letter-spacing: 0.010em\" \nng-click=\"$ctrl.downloadCaseInPDF()\">Download Chat</span></div><div layout=\"row\" style=\"margin-top:20px\" \nng-show=\"$ctrl.selectedCase.creator.personId === $ctrl.context.user.personId\"><img \nsrc=\"/assets/images/archive-outline.png\" style=\"cursor:pointer;width:25px;height:25px\" \nng-click=\"$ctrl.openMobileArchive()\"> <span \nstyle=\"margin-left: 10px;font-family: Roboto;font-size: 16px;font-weight: 600;line-height: normal;letter-spacing: -0.5px;color: #92298D; cursor: pointer;letter-spacing: 0.010em\" \nng-click=\"$ctrl.openMobileArchive()\">Archive Chat</span></div><div layout=\"row\" style=\"margin-top:20px\" \nng-show=\"$ctrl.selectedCase.creator.personId === $ctrl.context.user.personId\"><img \nsrc=\"/assets/images/add-remove-outline.png\" style=\"cursor:pointer;width:25px;height:25px\" \nng-click=\"$ctrl.toggleRightMobile()\"> <span \nstyle=\"margin-left: 10px;font-family: Roboto;font-size: 16px;font-weight: 600;line-height: normal;letter-spacing: -0.5px;color: #92298D; cursor: pointer;letter-spacing: 0.010em\" \nng-click=\"$ctrl.toggleRightMobile()\">Manage Recipients</span></div><div layout=\"row\" style=\"margin-top:20px\"><img \nsrc=\"/assets/images/tag-outline.png\" style=\"cursor:pointer;width:25px;height:25px\" ng-click=\"$ctrl.openTagMobile()\"> \n<span \nstyle=\"margin-left: 10px;font-family: Roboto;font-size: 16px;font-weight: 600;line-height: normal;letter-spacing: -0.5px;color: #92298D;cursor: pointer;letter-spacing: 0.010em\" \nng-click=\"$ctrl.openTagMobile()\">Manage Tags</span></div><div layout=\"row\" style=\"margin-top:20px\" \nng-show=\"$ctrl.selectedCase.creator.personId !== $ctrl.context.user.personId\"><img \nsrc=\"/assets/images/case-transfer.png\" style=\"cursor:pointer;width:25px;height:25px\" \nng-click=\"$ctrl.requestCaseOwnership()\"> <span \nstyle=\"margin-left: 10px;font-family: Roboto;font-size: 16px;font-weight: 600;line-height: normal;letter-spacing: -0.5px;color: #92298D;cursor: pointer;letter-spacing: 0.010em\" \nng-click=\"$ctrl.requestCaseOwnership()\">Request chat ownership</span></div><div layout=\"row\" style=\"margin-top:20px\" \nng-show=\"$ctrl.selectedCase.creator.personId === $ctrl.context.user.personId\"><img \nsrc=\"/assets/images/case-transfer.png\" style=\"cursor:pointer;width:25px;height:25px\" ng-click=\"$ctrl.transferCase()\"> \n<span \nstyle=\"margin-left: 10px;font-family: Roboto;font-size: 16px;font-weight: 600;line-height: normal;letter-spacing: -0.5px;color: #92298D;cursor: pointer;letter-spacing: 0.010em\" \nng-click=\"$ctrl.transferCase()\">Transfer chat ownership</span></div></md-card-title-text></md-card-title></div></div>\n</md-card></div></div></md-sidenav><md-sidenav class=\"md-sidenav-right ie-width-fix\" md-component-id=\"patient\" \nstyle=\"background-color: #ffffff\"><div style=\"display: flex; flex-flow: column; height: 100%\"><div><md-toolbar \nlayout=\"row\"><div class=\"md-toolbar-tools\" style=\"background-color:#92298C\"><md-button class=\"md-icon-button\" \naria-label=\"Close Side Panel\" ng-click=\"$ctrl.closePatientPanel()\"><md-icon md-font-icon=\"icon-close-circle-outline\" \nclass=\"icon\" style=\"color:#FFFFFF\"></md-icon></md-button><div class=\"createpageHeaderButtons\" \nstyle=\"cursor:pointer;color: #ffffff;margin-left: auto;letter-spacing: 1.3px;font-size:16px\" \nng-click=\"$ctrl.togglePatientEdit()\" ng-bind=\"$ctrl.editPatientButtonText\"></div></div></md-toolbar></div><div \nstyle=\"min-height: 0; flex: 1; overflow: auto\"><md-card style=\"background-color: #ffffff;box-shadow: 0px 0px\"><div \nng-show=\"$ctrl.editPatientMode === \'searchExisting\'\"><md-card-title><md-card-title-text><span \nclass=\"selectRecipientsHeader\">Select patient</span><br><span class=\"selectRecipientsBody\">\nYour patients access is limited to the following organisations based on your chosen profile.</span>\n</md-card-title-text></md-card-title><md-card-title><md-card-title-text><input type=\"text\" \nng-model=\"$ctrl.searchPatientKeyWord\" name=\"searchPatient\" placeholder=\"Patient name\" class=\"patientSearchBox\" \nstyle=\"border: 1px solid #eaeaea;border-radius: 14px;padding: 12px 20px 12px 16px\"><div layout=\"column\" \nlayout-align=\"center center\"><br><md-button class=\"md-raised md-accent patientSearchButton\" aria-label=\"searchPatient\" \ntype=\"submit\" ng-click=\"$ctrl.getPatients()\" style=\"border-radius: 6px\">Search</md-button></div><form \nname=\"patientForm\" novalidate ng-show=\"$ctrl.patients.length > 0\"><md-input-container flex=\"\" \nclass=\"flex md-default-theme\" style=\"margin-top: 28px;margin-left: 6px;font-family: Roboto\"><label>Filter by D.O.B\n</label><md-datepicker md-hide-icons=\"calendar\" ng-model=\"$ctrl.patientDOBsearch\" name=\"patientDOB\" md-open-on-focus \nmd-max-date=\"$ctrl.maxPatientDOB\" md-min-date=\"$ctrl.minPatientDOB\"></md-datepicker><div class=\"validation-messages\" \nng-messages=\"patientForm.patientDOB.$error\"><div ng-message=\"valid\">The entered Date of Birth is not a date!</div><div \nng-message=\"mindate\">Date of Birth should be within 120 years of current year</div><div ng-message=\"maxdate\">\nDate of Birth cannot exceed current year</div></div></md-input-container></form><div \nng-repeat=\"patent in $ctrl.patients | filter:  $ctrl.getPatientFilterCondition() track by $index\"><md-card-actions \nlayout=\"row\" layout-align=\"start center\"><md-card-icon-actions><aside class=\"caseCreatorLabel\" \nstyle=\"padding-top:0px;padding-left:10px\">{{patent.title}} {{patent.firstname}} {{patent.lastname}}<br><span \nclass=\"clinicianJobTitle\" style=\"font-style: normal\">D.O.B: {{patent.dob | date:\'MM/dd/yyyy\'}} | MRN: {{patent.ref}}\n</span><br></aside></md-card-icon-actions><md-button class=\"selectPatientButton\" \nng-click=\"$ctrl.changePatientThroughSearch(patent)\">Select</md-button></md-card-actions><md-divider ng-hide=\"$last\">\n</md-divider></div><div layout=\"column\" layout-align=\"center center\" ng-if=\"$ctrl.showNoPatienFoundText\"><br><span \nclass=\"caseFileUploadMessage\">No matching patients found</span><br><br><br></div><div id=\"makeCenter\" \nclass=\"centerLoader\" ng-show=\"$ctrl.patientSearchOn\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div></md-card-title-text></md-card-title></div><div \nng-show=\"$ctrl.editPatientMode === \'createNew\'\"><md-card-title><md-card-title-text><span \nclass=\"selectRecipientsHeader\">Create a new patient profile</span><br><span class=\"selectRecipientsBody\" \nstyle=\"width:385px\">\nEnter details to help identify the patient. Make sure you have the patient’s consent to share these details.</span>\n</md-card-title-text></md-card-title><md-card-title><md-card-title-text><form name=\"patientForm\" novalidate><div \nstyle=\"padding-left:17px\"><md-input-container flex=\"\" class=\"flex md-default-theme\"><label for=\"select_55\" \nclass=\"md-placeholder\">Title</label><md-select ng-model=\"$ctrl.patient.title\" \nclass=\"ng-pristine ng-valid md-default-theme ng-empty ng-touched\" tabindex=\"0\" aria-disabled=\"false\" role=\"listbox\" \naria-expanded=\"false\" aria-multiselectable=\"false\" id=\"select_55\" aria-owns=\"select_container_56\" aria-invalid=\"false\" \naria-label=\"Title\"><md-option value=\"Dr\">Dr</md-option><md-option value=\"Mr\">Mr</md-option><md-option value=\"Mrs\">Mrs\n</md-option><md-option value=\"Ms\">Ms</md-option><md-option value=\"Miss\">Miss</md-option><md-option value=\"Master\">\nMaster</md-option><md-option value=\"Prof\">Prof</md-option><md-option value=\"A/Prof\">A/Prof</md-option><md-option \nvalue=\"Other\">Other</md-option></md-select></md-input-container></div><div layout=\"column\" \nstyle=\"padding-right:17px;padding-left:17px\"><md-input-container flex=\"\" class=\"flex md-default-theme\"><input \ntype=\"text\" name=\"firstname\" ng-model=\"$ctrl.patient.firstName\" ng-maxlength=\"50\" placeholder=\"First Name\" required>\n<div class=\"validation-messages\" ng-messages=\"patientForm.firstname\"><div ng-message=\"required\">First name is required!\n</div></div></md-input-container><md-input-container flex=\"\" class=\"flex md-default-theme\"><input type=\"text\" \nname=\"lastname\" ng-model=\"$ctrl.patient.lastName\" ng-maxlength=\"50\" placeholder=\"Last Name\" required><div \nclass=\"validation-messages\" ng-messages=\"patientForm.lastname\"><div ng-message=\"required\">Last name is required!</div>\n</div></md-input-container><md-input-container class=\"flex md-default-theme\"><input type=\"text\" name=\"patientDOB\" \nng-model=\"$ctrl.patient.dob\" placeholder=\"Patient D.O.B.\" style=\"width: 325px\" maxlength=\"10\" \nng-change=\"$ctrl.validatePatientDOB(patientForm)\"><div ng-messages=\"patientForm.patientDOB.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"errorPatientDOBInvalidFormat\">Please enter DOB in DD-MM-YYYY format.</div><div \nng-message=\"invalidDateRange\">\nDate of Birth should be within 120 years of current year and must not exceed current date.</div></div>\n</md-input-container><md-input-container flex=\"\" class=\"flex md-default-theme\"><input type=\"text\" name=\"referenceNo\" \nng-model=\"$ctrl.patient.ref\" placeholder=\"My Ref. No.\" ng-maxlength=\"100\"><div \nng-messages=\"patientForm.referenceNo.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"maxlength\"><span>\nToo many characters.</span></div></div></md-input-container></div><div layout=\"row\" layout-align=\"center center\">\n<md-button class=\"md-raised md-accent\" aria-label=\"createpatient\" type=\"submit\" \nstyle=\"text-transform: none !important;font-family: Roboto;font-size: 16px;font-weight: 500;font-style: normal;font-stretch: normal;letter-spacing: 0.3px\" \nng-disabled=\"patientForm.$invalid\" ng-click=\"$ctrl.addNewPatientProfile()\">Create patient</md-button></div></form>\n</md-card-title-text></md-card-title></div></md-card></div></div></md-sidenav><md-sidenav \nclass=\"md-sidenav-right ie-width-fix\" md-component-id=\"allCaseTags\" style=\"background-color: #ffffff\"><div \nstyle=\"display: flex; flex-flow: column; height: 100%\"><div><md-toolbar layout=\"row\"><div class=\"md-toolbar-tools\" \nstyle=\"background-color:#92298C\"><md-button class=\"md-icon-button\" aria-label=\"Close Side Panel\" \nng-click=\"$ctrl.closeCaseTags()\"><md-icon md-font-icon=\"icon-close-circle-outline\" class=\"icon\" style=\"color:#FFFFFF\">\n</md-icon></md-button></div></md-toolbar></div><div style=\"min-height: 0; flex: 1; overflow: auto\"><md-card \nstyle=\"background-color: #ffffff;box-shadow: 0px 0px\"><div><md-card-title><md-card-title-text><span \nclass=\"selectRecipientsHeader\" style=\"width:385px\">Tags</span><br></md-card-title-text></md-card-title>\n<md-card-title-text ng-show=\"loadingTagsInProgress\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"centerLoader\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></md-card-title-text>\n<div ng-show=\"!loadingTagsInProgress\"><md-card-title style=\"margin-top:29px\"><md-card-title-text><div layout=\"row\" \nlayout-align=\"center center\"><md-autocomplete id=\"autoCompleteTag\" ng-keypress=\"$ctrl.addTagOnEnter($event)\" \nmd-selected-item=\"$ctrl.selectedTagItem\" md-no-cache=\"true\" md-search-text=\"$ctrl.$scope.tagSearchText\" \nmd-items=\"item in $ctrl.queryTagSearch($ctrl.$scope.tagSearchText)\" md-item-text=\"item\" \nplaceholder=\"Type a tag and press enter\" md-menu-class=\"autocomplete-custom-template\" \nmd-menu-container-class=\"custom-container\" md-min-length=\"0\" style=\"width: 15em\"><md-item-template><span \nclass=\"item-title\"><span>{{item}}</span></span></md-item-template><md-not-found>No matches found.</md-not-found>\n</md-autocomplete><img src=\"assets/images/addTags.png\" style=\"height:25px;width:25px;cursor:pointer;margin-left: 18px\" \nng-show=\"$ctrl.$scope.tagSearchText && $ctrl.$scope.tagSearchText.length > 0\" ng-click=\"$ctrl.addTagToCase()\"></div>\n</md-card-title-text></md-card-title><md-card-title><md-card-title-text><div layout=\"row\" layout-align=\"center center\" \nng-show=\"$ctrl.isTagDuplicate()\" style=\"margin-top:29px\"><img src=\"assets/images/error.png\" \nstyle=\"margin-right: 5px;padding-bottom: 6px\"><span style=\"color:#FF0000;font-weight: 500\">\nA tag with this name already exists</span></div></md-card-title-text></md-card-title><md-card-title>\n<md-card-title-text><div class=\"clinividTags\" tabindex=\"-1\" id=\"scripted\"><div \nng-show=\"selectedCaseTags && selectedCaseTags.length <= 0\"><img src=\"assets/images/info.png\" \nstyle=\"padding-top: 6px;margin-right: 5px\">No Tags for this chat yet</div><div ng-repeat=\"tag in selectedCaseTags\" \nclass=\"clinividTag\" style=\"background: #0899ff;color: #ffffff\">{{tag.tag}} <span \nstyle=\"margin-left:6px;cursor:pointer;font-size:16px\" ng-click=\"$ctrl.deleteTag(tag)\">×</span></div></div>\n</md-card-title-text></md-card-title></div></div></md-card></div></div></md-sidenav><div \nstyle=\"left: 0;bottom: 0;width: 100%;text-align: center;position:absolute;height:auto;background-color: #F0F0F1\" \nng-show=\"$ctrl.selectedCase\"><div layout=\"row\" layout-align=\"center center\" \nstyle=\"padding-bottom: 10px;padding-top: 10px\"><div accept=\"application/pdf,image/*,video/mp4,video/quicktime\" \nngf-select=\"$ctrl.genericFileUpload($file, $invalidFiles)\" \nstyle=\"height: 32px;width: 32px;border-radius: 50%;cursor: pointer;margin-right: 20px;align-self: flex-end\"><md-icon \nmd-font-icon=\"icon-paperclip\" style=\"color:#92298D;margin-top:4px\"></md-icon></div><textarea type=\"text\" \nclass=\"sendTextbox\" id=\"textBox4TextMessage\" ng-model=\"$ctrl.newMessage\" style=\"height:60px\">\n    </textarea><div \nng-click=\"$ctrl.sendMessage()\" style=\"cursor: pointer;margin-left: 20px;align-self: flex-end\"><md-icon \nmd-font-icon=\"icon-send\" style=\"color:#92298D;margin-bottom:7px\"></md-icon></div></div></div><div \nclass=\"case-view-overlay\"><div id=\"makeCenter\" class=\"centerLoader\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div></div><script>\n(function() {\n    $(\'#lightbox\').contextmenu(function(e) {\n      console.log(\"CONTEXT MENU\", e);\n      e.preventDefault();\n    });\n\n  })();\n</script><style>\nmd-sidenav,\n  md-sidenav.md-locked-open,\n  md-sidenav.md-closed.md-locked-open-add-active custom-sidenav {\n    min-width: 0px !important;\n    width: auto !important;\n  }\n  @-moz-document url-prefix() {\n    #conversation {\n      max-height: 332px;\n    }\n  }\n  md-select {\n    margin:  0px 0 0px 0;\n  }\n  .zoom-effect-container {\n  }\n\n  .image-card {\n  }\n\n  .image-card img {\n    -webkit-transition: 0.4s ease;\n    transition: 0.4s ease;\n  }\n\n  .zoom-effect-container:hover .image-card img {\n    -webkit-transform: scale(1.5);\n    transform: scale(1.5);\n  }\n  .md-icon-button + .md-datepicker-input-container {\n    margin-left: 0px;\n  }\n\n\n  md-backdrop.md-opaque { position:fixed; }\n</style>");
$templateCache.put("app/main/clinician/people/tabs/about/about.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"65\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" \ntranslate=\"PROFILE.GENERAL_INFORMATION\">General Information</div></header><div class=\"content\"><div class=\"info-line\">\n<div class=\"title\" translate=\"PROFILE.GENDER\">Gender</div><div class=\"info\">{{$ctrl.about.general.gender}}</div></div>\n<div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.BIRTHDAY\">Birthday</div><div class=\"info\">\n{{$ctrl.about.general.birthday}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.LOCATIONS\">\nLocations</div><div class=\"info location\" ng-repeat=\"location in $ctrl.about.general.locations\"><span>{{location}}\n</span><md-icon md-font-icon=\"icon-map-marker\" class=\"s16\"></md-icon></div></div><div class=\"info-line\"><div \nclass=\"title\" translate=\"PROFILE.ABOUT_ME\">About Me</div><div class=\"info\">{{$ctrl.about.general.about}}</div></div>\n</div></div><div class=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div \nclass=\"title\" translate=\"PROFILE.WORK\">Work</div></header><div class=\"content\"><div class=\"info-line\"><div \nclass=\"title\" translate=\"PROFILE.OCCUPATION\">Occupation</div><div class=\"info\">{{$ctrl.about.work.occupation}}</div>\n</div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.SKILLS\">Skills</div><div class=\"info\">\n{{$ctrl.about.work.skills}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.JOBS\">Jobs</div>\n<table class=\"info jobs\"><tr class=\"job\" ng-repeat=\"job in $ctrl.about.work.jobs\"><td class=\"company\">{{job.company}}\n</td><td class=\"date\">{{job.date}}</td></tr></table></div></div></div><div \nclass=\"profile-box info-box contact md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" \ntranslate=\"PROFILE.CONTACT\">Contact</div></header><div class=\"content\"><div class=\"info-line\"><div class=\"title\" \ntranslate=\"PROFILE.ADDRESS\">Address</div><div class=\"info\">{{$ctrl.about.contact.address}}</div></div><div \nclass=\"info-line\"><div class=\"title\" translate=\"PROFILE.TEL\">Tel.</div><div class=\"info\" \nng-repeat=\"tel in $ctrl.about.contact.tel\"><span>{{tel}}</span></div></div><div class=\"info-line\"><div class=\"title\" \ntranslate=\"PROFILE.WEBSITE\">Website</div><div class=\"info\" ng-repeat=\"website in $ctrl.about.contact.websites\"><span>\n{{website}}</span></div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.EMAILS\">Emails</div><div \nclass=\"info\" ng-repeat=\"email in $ctrl.about.contact.emails\"><span>{{email}}</span></div></div></div></div></div><div \nclass=\"about-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"35\"><div \nclass=\"profile-box friends md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.FRIENDS\">Friends</div><div \nclass=\"more secondary-text\"><span translate=\"PROFILE.SEE\">See</span> <span>454</span> <span translate=\"PROFILE.MORE\">\nMore</span></div></header><div class=\"content\" layout=\"row\" layout-wrap><div class=\"friend\" flex=\"20\" \nng-repeat=\"friend in $ctrl.about.friends\"><img ng-src=\"{{friend.avatar}}\"></div></div></div><div \nclass=\"profile-box groups md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.JOINED_GROUPS\">Joined Groups</div><div \nclass=\"more secondary-text\"><span translate=\"PROFILE.SEE\">See</span> <span>6</span> <span translate=\"PROFILE.MORE\">More\n</span></div></header><div class=\"content\"><div class=\"group\" ng-repeat=\"group in $ctrl.about.groups\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><img ng-src=\"{{group.logo}}\" \nclass=\"logo\" alt=\"{{group.name}}\"><div><div class=\"name\">{{group.name}}</div><div class=\"category\">{{group.category}}\n</div><div class=\"members\">{{group.members}} people</div></div></div><md-button class=\"md-icon-button\" \naria-label=\"more\" translate translate-attr-aria-label=\"PROFILE.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button></div></div></div></div></div>");
$templateCache.put("app/main/clinician/people/tabs/photos-videos/photos-videos.html","<div class=\"photos-videos\"><div class=\"period\" data-ng-repeat=\"period in $ctrl.photosVideos\"><div class=\"period-title\">\n<span class=\"name\">{{period.name}}</span> <span class=\"info\">{{period.info}}</span></div><div class=\"period-media\" \nlayout=\"row\" layout-wrap><div class=\"media\" ng-repeat=\"media in period.media\"><img class=\"preview\" \nng-src=\"{{media.preview}}\" title=\"{{media.title}}\"><div class=\"title\">{{media.title}}</div></div></div></div></div>");
$templateCache.put("app/main/clinician/people/tabs/timeline/timeline.html","<div layout=\"row\" layout-wrap><div class=\"timeline\" layout=\"column\" flex=\"100\" flex-gt-sm=\"55\" flex-gt-md=\"65\" \nflex-order=\"2\" flex-order-gt-sm=\"1\"><div class=\"profile-box add-post md-whiteframe-1dp\"><div class=\"form\" flex>\n<textarea placeholder=\"Write something..\" translate translate-attr-placeholder=\"PROFILE.WRITE_SOMETHING\"></textarea>\n<footer layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button\" aria-label=\"insert photo\" translate translate-attr-aria-label=\"PROFILE.INSERT_PHOTO\"><md-icon \nmd-font-icon=\"icon-file-image-box\"></md-icon><md-tooltip><span translate=\"PROFILE.INSERT_PHOTO\">insert photo</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"add person\" translate \ntranslate-attr-aria-label=\"PROFILE.ADD_PERSON\"><md-icon md-font-icon=\"icon-person-plus\"></md-icon><md-tooltip><span \ntranslate=\"PROFILE.ADD_PERSON\">add person</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \naria-label=\"add location\" translate translate-attr-aria-label=\"PROFILE.LOCATION\"><md-icon \nmd-font-icon=\"icon-map-marker\"></md-icon><md-tooltip><span translate=\"PROFILE.LOCATION\">add location</span>\n</md-tooltip></md-button></div><md-button ng-click=\"\" class=\"post-button md-accent md-raised\" aria-label=\"POST\" \ntranslate=\"PROFILE.POST\" translate-attr-aria-label=\"PROFILE.POST\">POST</md-button></footer></div></div><md-divider>\n</md-divider><div class=\"timeline-item md-whiteframe-1dp\" ng-repeat=\"post in $ctrl.posts\"><header layout=\"row\" \nlayout-align=\"space-between start\"><div class=\"user\" layout=\"row\" layout-align=\"start center\"><img class=\"avatar\" \nng-src=\"{{post.user.avatar}}\"><div layout=\"column\"><div class=\"title\"><span class=\"username md-accent-color\">\n{{post.user.name}}</span> <span ng-if=\"post.type == \'post\'\" translate=\"PROFILE.TYPE_POST\">posted on your timeline\n</span> <span ng-if=\"post.type == \'something\'\" translate=\"PROFILE.TYPE_SOMETHING\">shared something with you</span> \n<span ng-if=\"post.type == \'video\'\" translate=\"PROFILE.TYPE_VIDEO\">shared a video with you</span> <span \nng-if=\"post.type == \'article\'\" translate=\"PROFILE.TYPE_ARTICLE\">shared an article with you</span></div><div \nclass=\"time\">{{post.time}}</div></div></div><md-button class=\"md-icon-button\" aria-label=\"more\" translate \ntranslate-attr-aria-label=\"PROFILE.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></header><div\n class=\"content\"><div ng-if=\"post.message\" class=\"message\">{{post.message}}</div><div ng-if=\"post.media\" class=\"media\">\n<img ng-if=\"post.media.type === \'image\'\" ng-src=\"{{post.media.preview}}\"><div ng-if=\"post.media.type === \'video\'\" \nng-bind-html=\"post.media.embed | toTrusted\"></div></div><div ng-if=\"post.article\" layout=\"column\" class=\"article\"><div \nclass=\"media\"><img ng-src=\"{{post.article.media.preview}}\"></div><div class=\"title\">{{post.article.title}}</div><div \nclass=\"subtitle\">{{post.article.subtitle}}</div><div class=\"excerpt\">{{post.article.excerpt}}</div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"like-button\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-heart-outline\" class=\"s16\"></md-icon><span translate=\"PROFILE.LIKE\">Like</span>&nbsp;<span>\n({{post.like}})</span></div></md-button><md-button class=\"share-button\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-share\" class=\"s16\"></md-icon><span translate=\"PROFILE.SHARE\">Share</span>&nbsp;<span>\n({{post.share}})</span></div></md-button></div></div><footer class=\"\" layout=\"column\" layout-align=\"start start\"><div \nng-if=\"post.comments\" class=\"comment-count\">{{post.comments.length}} comments<md-icon \nmd-font-icon=\"icon-keyboard_arrow_down\"></md-icon></div><div class=\"comment\" layout=\"row\" layout-fill \nng-repeat=\"comment in post.comments\"><img ng-src=\"{{comment.user.avatar}}\" class=\"avatar\"><div flex layout=\"column\">\n<div layout=\"row\" layout-align=\"start center\"><span class=\"username\">{{comment.user.name}}</span> <span class=\"time\">\n{{comment.time}}</span></div><div class=\"message\">{{comment.message}}</div><div class=\"actions\" layout=\"row\" \nlayout-align=\"space-between center\"><a href=\"#\" class=\"reply-button md-accent-color\" translate=\"PROFILE.REPLY\">Reply\n</a><md-icon flex md-font-icon=\"icon-flag\" class=\"report-button s16\"></md-icon></div></div></div><div class=\"reply\" \nlayout=\"row\" layout-fill><img src=\"assets/images/avatars/profile.jpg\" class=\"avatar\"><form flex><textarea \nplaceholder=\"Add a comment...\" translate translate-attr-placeholder=\"PROFILE.ADD_COMMENT\"></textarea><md-button \nng-click=\"\" class=\"post-comment-button md-accent md-raised\" aria-label=\"Post Comment\" translate=\"PROFILE.POST_COMMENT\" \ntranslate-aria-label=\"PROFILE.POST_COMMENT\">Post Comment</md-button></form></div></footer></div></div><div \nclass=\"timeline-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"45\" flex-gt-md=\"35\" flex-order=\"1\" \nflex-order-gt-sm=\"2\"><div class=\"profile-box latest-activity md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\" \ntranslate=\"PROFILE.LATEST_ACTIVITY\">Latest Activity</div><div class=\"more secondary-text\" translate=\"PROFILE.SEE_ALL\">\nSee All</div></header><div class=\"content\" layout=\"row\" layout-wrap><div class=\"activities\"><div class=\"activity\" \nlayout=\"row\" layout-align=\"start start\" ng-repeat=\"activity in $ctrl.activities\"><img \nng-src=\"{{activity.user.avatar}}\" class=\"avatar\" alt=\"{{activity.user.name}}\"><div layout=\"column\"><div><span \nclass=\"username md-accent-color\">{{activity.user.name}}</span> <span class=\"message\">{{activity.message}}</span></div>\n<span class=\"time secondary-text\">{{activity.time}}</span></div></div></div></div></div></div></div>");}]);